<template>
  <div v-dirkeydown="onkeydownCode" v-resize="onResize"
       v-bind:style="{ 'background-color': '#dd4b39', 'position': 'absolute', 'border': '2px solid #F44336', 'width': '100%', 'height': this.windowSize.height - 5 + 'px' }">
    {{ GetEjecucion }}
    <v-row>
      <!-- columna general 1 -->
      <v-col cols="12" md="6" sm="6">
        <v-container
          v-bind:style="{ 'height': this.windowSize.height - 30 + 'px', 'max-height': this.windowSize.height - 30 + 'px', 'border': '1px solid #000000', 'background-color': '#FFFFFF' }">
          <!--------------------- Informacion cliente & vendedor height:75px;   ------------------------------->
          <v-row style="margin-top:-11px; background-color:#3d6687; min-height:20px">

            <v-tooltip v-if="clienteFactura != null" dense top>
              <template v-slot:activator="{ on }">
                <v-chip class="ma-0" close color="#FFFFFF" outlined small
                        v-on="on"
                        @click:close="NotifMessage('quitarCliente')">
                  <v-icon left>mdi-account-outline</v-icon>
                  <span>CLIENTE: </span> <span> {{ clienteFactura.nombre }}</span>
                </v-chip>
              </template>
              <span>Cliente</span>
            </v-tooltip>

            <v-tooltip v-if="SelectMedicoFactura != null" dense top>
              <template v-slot:activator="{ on }">
                <v-chip class="ma-0" close color="#FFFFFF" outlined small v-on="on" @click:close="NewNewMedico()">
                  <v-icon left>mdi-account-outline</v-icon>
                  MÉDICOS: <span> {{ SelectMedicoFactura.nombre }}</span>
                </v-chip>
              </template>
              <span>Médicos</span>
            </v-tooltip>

            <v-tooltip v-if="Facturasventa.vendedor != null" dense top>
              <template v-slot:activator="{ on }">

                <v-chip class="ma-0" close color="#FFFFFF" outlined small v-on="on" @click:close="NewNewVendedores">
                  <v-icon left>mdi-account-outline</v-icon>
                  VENDEDOR: <span> {{ Facturasventa.vendedor.nombre }}</span>
                </v-chip>
              </template>
              <span>vendedor</span>
            </v-tooltip>

          </v-row>

          <!--------------------- Accion & Totales ------------------------------->
          <v-container style="margin-top:-10px;">
            <v-row v-bind:style="{ 'border': '1px solid #000000', 'background-color': '#FFFFFF' }">
              <v-col cols="12" md="2" sm="3" style="border: 1px solid #000000;">
                <!-- Btn-Guaardar temporal -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">

                    <v-btn color="indigo" dark height="60px" outlined v-on="on"
                           @click.prevent="OpenDialogGuardartemporal">
                      <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                      <v-avatar color="transparent" size="50" tile>
                        <img alt="guardar " src="@/assets/icons_pv/extras/guardar.png">
                      </v-avatar>
                      <span style="margin-top:5px; margin-left: 5px;">
                          <b
                            v-bind:style="{ 'font-size': '10px', 'color': '#000000', 'border':`1px solid #000000 `}">F3</b>
                        </span>
                    </v-btn>

                  </template>
                  <span>Guardar temporal</span>
                </v-tooltip>
                <!-- fn Btn-Guardar temporal  -->
                <!-- Btn-limpiar Pantalla -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">

                    <v-btn color="#90A4AE" dark height="60px" outlined v-on="on"
                           @click.prevent="permisolimpiarPuntoVentaCompleto">
                      <v-avatar color="transparent" size="50" tile>
                        <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                      </v-avatar>
                      <span style="margin-top:5px; margin-left: 5px;">
                          <b
                            v-bind:style="{ 'font-size': '10px', 'color':'#FFFFFF', 'border':`1px solid #FFFFFF`}">00</b>
                        </span>
                    </v-btn>

                  </template>
                  <span>limpiar Pantalla</span>
                </v-tooltip>
                <!-- fn Btn-Guaardar temporal -->
              </v-col>

              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="10" sm="9" style="border: 1px solid #000000;">
                <v-row no-gutters>
                  <v-col cols="6" md="6" sm="6" style="margin-top:-8px">
                    <h1 id="miniTotal"><b class="d-flex justify-start">Sub-Total:</b></h1>
                  </v-col>

                  <v-col cols="6" md="6" sm="6" style="margin-top:-8px  ">
                    <h1 id="miniTotal"><b class="d-flex justify-end blue--text">
                      {{ currencyFormatter2(getTasaMonedaSelect(Totales.totalGeneral.subtotal)) }} </b></h1>
                  </v-col>

                  <v-col v-if="Totales.totalGeneral.descuento > 0" cols="6" md="6" sm="6" style="margin-top:-18px">
                    <h2 id="miniTotal"><b class="d-flex justify-start">Descuento:</b></h2>
                  </v-col>

                  <v-col v-if="Totales.totalGeneral.descuento > 0" cols="6" md="6" sm="6" style="margin-top:-18px">
                    <!-- <h2 id="miniTotal" class="blue--text" > <b class="d-flex justify-end"> {{currencyFormatter2(Descuentofactura.descuento)}} </b> </h2> -->
                    <h2 id="miniTotal" class="blue--text"><b class="d-flex justify-end">
                      {{ currencyFormatter2(getTasaMonedaSelect(Totales.totalGeneral.descuento)) }} </b></h2>
                  </v-col>

                  <v-col cols="6" md="6" sm="6" style="margin-top:-18px">
                    <h1 id="miniTotal"><b class="d-flex justify-start">Itbis:</b></h1>
                  </v-col>

                  <v-col cols="6" md="6" sm="6" style="margin-top:-18px">
                    <h1 id="miniTotal" class="blue--text"><b class="d-flex justify-end">
                      {{ currencyFormatter2(getTasaMonedaSelect(Totales.totalGeneral.itbis)) }} </b></h1>
                  </v-col>


                  <v-col v-if="Totales.totalGeneral.Retencion > 0" cols="6" md="6" sm="6" style="margin-top:-18px">
                    <h2 id="miniTotal"><b class="d-flex justify-start">Ret.Gub:</b></h2>
                  </v-col>

                  <v-col v-if="Totales.totalGeneral.Retencion > 0" cols="6" md="6" sm="6" style="margin-top:-18px">
                    <!-- <h2 id="miniTotal" class="blue--text" > <b class="d-flex justify-end"> {{currencyFormatter2(Retencionfactura.Retencion)}} </b> </h2> -->
                    <h2 id="miniTotal" class="blue--text"><b class="d-flex justify-end">
                      {{ currencyFormatter2(getTasaMonedaSelect(Totales.totalGeneral.Retencion)) }} </b></h2>
                  </v-col>

                  <v-col v-if="Totales.totalGeneral.recargo > 0" cols="6" md="6" sm="6" style="margin-top:-18px">
                    <h2 id="miniTotal"><b class="d-flex justify-start">Recargo:</b></h2>
                  </v-col>

                  <v-col v-if="Totales.totalGeneral.recargo > 0" cols="6" md="6" sm="6" style="margin-top:-18px">
                    <!-- <h2 id="miniTotal" class="blue--text" > <b class="d-flex justify-end"> {{currencyFormatter2(Recargofactura.recargo)}} </b> </h2> -->
                    <h2 id="miniTotal" class="blue--text"><b class="d-flex justify-end">
                      {{ currencyFormatter2(getTasaMonedaSelect(Totales.totalGeneral.recargo)) }} </b></h2>
                  </v-col>

                  <v-col v-if="Totales.totalGeneral.cobertura > 0" cols="6" md="6" sm="6" style="margin-top:-18px">
                    <h2 id="miniTotal"><b class="d-flex justify-start">Cobertura:
                      <b class="pa-0 ma-0 py-0 my-0  blue--text">
                        (%{{currencyFormatter2(((Totales.totalGeneral.cobertura/(Totales.totalGeneral.subtotal+Totales.totalGeneral.itbis))*100))}}) 
                      </b>
                      </b>
                    </h2>
                  </v-col>

                  <v-col v-if="Totales.totalGeneral.cobertura > 0" cols="6" md="6" sm="6" style="margin-top:-18px">
                    <!-- <h2 id="miniTotal" class="blue--text" > <b class="d-flex justify-end"> {{currencyFormatter2(CoberturaSeguro.cobertura)}} </b> </h2> -->
                    <h2 id="miniTotal" class="blue--text"><b class="d-flex justify-end">
                      {{ currencyFormatter2(getTasaMonedaSelect(Totales.totalGeneral.cobertura)) }} </b></h2>
                  </v-col>
                  <!-- v-if="Totales.totalGeneral.valorLey>0" -->
                  <v-col v-if="Totales.totalGeneral.valorLey>0" cols="6" md="6" sm="6" style="margin-top:-15px">
                    <h3 id="miniTotal"><b class="d-flex justify-start">%Ley:</b></h3>
                  </v-col>

                  <v-col v-if="Totales.totalGeneral.valorLey>0" cols="6" md="6" sm="6" style="margin-top:-15px">
                    <h3 id="miniTotal" class="blue--text"><b class="d-flex justify-end">
                      {{ currencyFormatter2(getTasaMonedaSelect(Totales.totalGeneral.valorLey)) }} </b></h3>
                  </v-col>


                  <v-col cols="12" md="12" sm="12" style="margin-top:-05px">
                    <hr style="border:1px solid #000000;">
                  </v-col>

                  <v-col cols="6" md="6" sm="6" style="margin-top:-10px">
                    <h1 id="miniTotal"><b class="d-flex justify-start">TOTAL:</b></h1>
                  </v-col>

                  <v-col cols="6" md="6" sm="6" style="margin-top:-10px">
                    <h1 id="miniTotal" class="blue--text"><b class="d-flex justify-end">
                      {{ currencyFormatter2(getTasaMonedaSelect(Totales.totalGeneral.total)) }} </b></h1>
                  </v-col>

                </v-row>

              </v-col>
            </v-row>
          </v-container>
          <!--------------------- Seleccion de producto & Tabla ------------------------------->
          <div v-show="PanelSelectProducto" style="margin-top:-10px;">
            <center>
              <!-------------------------------------------------- input-Buscar Productos -->
              <div v-show="activoF7==false">

                <v-tooltip top>
                  <template v-slot:activator="{ on }">


                    <!-- hide-no-data
                  hide-selected
                  v-combobox
                  -->

                    <div class="pt-0">
                      <v-combobox v-if="$store.getters.GetConfiguracionGeneral.configPv.busquedaFluido==false"
                                  ref="RefTextFieldProducto" v-model="searchProducto"
                                  :disabled="disabledTextFieldProducto" :items="[]" autocomplete="off"
                                  color="green" dense
                                  hide-details label="Buscar:" outlined
                                  @focus="CargarRproducto" @keyup="SelectMarcaProductoKeyNofluido"
                                  @keyup.enter="SeachFilkeyEnterProd"
                      >
                        <!-- color="green" -->
                        <template v-slot:prepend-inner>
                          <i class="fa fa-search" style="font-size: 25px;" @click="SeachProductoBtnMovilNofluido"></i>
                        </template>

                        <template v-slot:append>
                          <i class="fa fa-search" style="font-size: 0px;"></i>
                        </template>


                      </v-combobox>
                    </div>
                    <!-- <v-text-field v-if="$store.getters.GetConfiguracionGeneral.configPv.busquedaFluido==false"  id="formdisabledInput" ref="RefTextFieldProducto" background-color="white" color="grey darken-4"
                    autocomplete="off" v-on="on" v-model="searchProducto" @keyup.enter="SeachFilkeyEnterProd"
                    @focus="CargarRproducto"  label="Buscar" single-line hide-details outlined dense
                    @keydown="SelectMarcaProductoKeyNofluido"
                    :disabled="disabledTextFieldProducto" >
                    <template v-slot:prepend-inner>
                      <i @click="SeachProducto" style="font-size: 25px;" class="fa fa-search"></i>
                    </template>
                  </v-text-field> -->

                    <v-text-field v-if="$store.getters.GetConfiguracionGeneral.configPv.busquedaFluido==true"
                                  id="formdisabledInput" ref="RefTextFieldProducto" v-model="searchProducto"
                                  :disabled="disabledTextFieldProducto"
                                  autocomplete="off" background-color="white" color="grey darken-4" dense
                                  hide-details label="Buscar" outlined single-line @focus="CargarRproducto"
                                  @keydown="SelectMarcaProducto"
                                  @keyup="SeachFilProducto"
                                  v-on="on">
                      <template v-slot:prepend-inner>
                        <i class="fa fa-search" style="font-size: 25px;" @click="SeachProducto"></i>
                      </template>
                    </v-text-field>

                  </template>
                  <span>Busqueda</span>
                </v-tooltip>
              </div>
              <!-------------------------------------------------- fn input-Buscar Productos-->
              <!-------------------------------------------------- input-Buscar Vendedor  single-line-->
              <div v-show="activoF7==true">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-text-field ref="RefTextFieldBuscaVendedorCodigo" v-model="searchVendedorCodigo"
                                  autocomplete="off"
                                  background-color="white" color="grey darken-4" dense
                                  hide-details label="Buscar vendedor por código" outlined
                                  @blur="blurTextFilVendedorCodigo"
                                  v-on="on"
                                  @keyup.enter="SeachTextFilVendedorCodigo"
                    >
                      <template v-slot:prepend-inner>
                        <i class="fa fa-universal-access" style="font-size: 25px;"></i>
                      </template>
                    </v-text-field>
                  </template>
                  <span>Busqueda por el código del vendedor</span>
                </v-tooltip>
              </div>
              <!-------------------------------------------------- input-Buscar Vendedor -->

              <!-- #757575 @click:row="addClikProd" item-key="codigo"    -->

              <!-- @item-selected="obtenerDatoSelect" -->
              <!--------------------------------------------------  Header select producto -->
              <v-col v-show="ProdCompOrSelecProd == false" class="py-0 my-0" cols="12" md="12"
                     sm="12" style="background-color:#3d6687;">
                <v-row style="border: 1px solid #000000;">
                  <!-- <v-col class="pa-0 ma-0"  cols="2" md="2"> <b :class="`d-flex justify-start white--text`" > Cantidad</b></v-col> -->
                  <v-col class="pa-0 ma-0" cols="6" md="6"><b :class="`d-flex justify-start white--text`">
                    Producto</b>
                  </v-col>
                  <!-- <v-col class="pa-0 ma-0"  cols="2" md="2"><b :class="`d-flex justify-center white--text`" > Unidad </b></v-col> -->
                  <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-center white--text`"> Precio </b>
                  </v-col>
                  <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-center white--text`"> Exit. </b>
                  </v-col>
                  <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-center white--text`"> Acción </b>
                  </v-col>
                </v-row>
              </v-col>
              <!-------------------------------------------------- fn Header select producto  -->
              <!-------------------------------------------------- tabla-Seleccion de producto -->
              <!-- 285 id="divSelecProd"   v-bind:style="{  'max-height':this.windowSize.height-400+'px','border': '2px solid #000000' }" class="overflow-x-auto"  -->

              <div
                v-show="ProdCompOrSelecProd == false"
                ref="RefScroll" class="overflow-x-auto"
                v-bind:style="{ 'height': this.windowSizeCaja.height + 'px', 'max-height': this.windowSizeCaja.height + 'px', 'border': '2px solid #000000' }">
                <v-data-table :headers="[
                    { text: 'CODIGO', value: 'productos.codigo', sortable: false, class: ['no-gutters'] },
                    { text: 'PRODUCTO', value: 'productos.descripcion', sortable: false, class: ['no-gutters'] },
                    { text: 'COSTO', value: 'costo', sortable: false, class: ['no-gutters'] },
                    { text: 'PRECIO', value: 'precio', sortable: false, class: ['no-gutters'] },
                    { text: 'EXISTENCIA', value: 'existencias', sortable: false, align: 'center', class: ['no-gutters'] },
                  ]" :items="RallProducto" :items-per-page="-1" :show-select="true" :single-select="true"
                              class="elevation-1" dense hide-default-footer hide-default-header item-key="indx">

                  <!-- PRODUCTO, COSTO, PRECIO, EXISTENCIA :active="selected == props.item"-->

                  <template v-slot:item="props">
                    <span style="display:none;">{{ props.item.indx = RallProducto.indexOf(props.item) }}</span>
                    <tr v-bind:class="classObjProdSelect(props.item)">
                      <!-- @click.prevent="EditarProductoSelect(props.item, false)" -->
                      <td v-ripple="{ class: `indigo--text` }">
                        <span v-if="!props.item.hasOwnProperty('cantidad')" style="display:none;">{{
                            props.item.cantidad
                              = 1
                          }}</span>
                        <v-row>
                          <v-col class="pa-0 ma-0" cols="6" md="6"><span><b>{{ props.item.productos.descripcion }} {{
                              props.item.unidades.descripcion
                            }}</b></span></v-col>
                          <!-- <v-col class="pa-0 ma-0"     cols="2" md="2"><span> <b>X</b> {{ currencyFormatter(props.item.cantidad)}}</span></v-col> -->
                          <!-- <v-col class="pa-0 ma-0"  cols="2" md="2"><span :class="`d-flex justify-center`" >{{props.item.unidades.descripcion}}</span></v-col> -->
                          <v-col class="pa-0 ma-0" cols="2" md="2"><span :class="`d-flex justify-center`"> {{ currencyFormatter2(props.item.precio) }}</span></v-col>
                          <v-col class="pa-0 ma-0" cols="2" md="2">
                            <!--  v-tooltip - EXISTENCIA  top-->
                            <v-tooltip right>
                              <template v-slot:activator="{ on }">
                                <span :class="`d-flex justify-center`"
                                      v-on="on"> {{ currencyFormatter2(props.item.existencias) }}</span>
                              </template>

                              <!-- Existencia de productos almacen  -->
                              <v-col class="pa-0 ma-0 py-0 my-0 pt-1" cols="12" md="12" sm="12">
                                <!-- <div style="max-height:250px;" class="overflow-x-auto"> </div> -->
                                <!-- v-if="UsarLote == false" -->
                                <v-card style="border: 1px solid  #616161;">
                                  <!-- Lista existencia almacen BalanceInventario -->
                                  <v-data-table v-if="UsarLote == false" :footer-props="arrayPropiedases" :headers="[
                    { text: 'ALMACEN', value: 'almacen', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'EXISTENCIA', value: 'existencion', sortable: false, class: ['no-gutters black--text'] },
                  ]" :items="props.item.listExistenciaAlmacen" :items-per-page="-1"
                                                dense hide-default-footer>

                                    <template v-slot:item.almacen="props">
                                      <span style="font-size:13px;">{{ props.item.almacen }}</span>
                                    </template>

                                    <template v-slot:item.existencion="props">
                                      <span style="font-size:13px;">{{ props.item.existencion }}</span>
                                    </template>
                                  </v-data-table>
                                  <!-- FIN Lista existencia almacen BalanceInventario  -->

                                  <!-- Lista existencia almacen BalanceLote -->
                                  <v-data-table v-if="UsarLote == true" :footer-props="arrayPropiedases" :headers="[
                    { text: 'LOTE', value: 'codigoLote', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'ALMACEN', value: 'almacen', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'EXISTENCIA', value: 'existencion', sortable: false, class: ['no-gutters black--text'] },
                  ]" :items="props.item.listExistenciaAlmacen" :items-per-page="-1"
                                                dense hide-default-footer>

                                    <template v-slot:item.codigoLote="props">
                                      <span style="font-size:13px;">{{ props.item.codigoLote }}</span>
                                    </template>

                                    <template v-slot:item.almacen="props">
                                      <span style="font-size:13px;">{{ props.item.almacen }}</span>
                                    </template>

                                    <template v-slot:item.existencion="props">
                                      <span style="font-size:13px;">{{ props.item.existencion }}</span>
                                    </template>
                                  </v-data-table>
                                  <!-- Lista existencia almacen BalanceLote -->

                                </v-card>

                              </v-col>
                              <!-- bn Existencia de productos almacen  -->

                            </v-tooltip>
                            <!--  v-tooltip - EXISTENCIA -->

                          </v-col>
                          <v-col class="pa-0 ma-0" cols="2" md="2">
                            <v-row :class="`d-flex justify-center`">

                              <v-btn
                                :disabled="validarBusProductoBarraReferencia($refs.RefTextFieldProducto.value)==true || validarBusProductoExisteLote(props.item)==true"
                                color="light-blue darken-4" small
                                @click.prevent="BuscPropiedadProductoSelct(props.item, 'add')"><i class="fa fa-plus"
                                                                                                  style="font-size: 20px;"></i>
                              </v-btn>
                              <v-btn color="grey" small @click.prevent="BuscPropiedadProductoSelct(props.item, 'ver')">
                                <i class="fa fa-eye" style="font-size: 20px;"></i>
                              </v-btn>
                            </v-row>
                          </v-col>
                          <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12">
                                <span style=" font-size:12px; border: 1px dashed  #616161;"
                                      v-bind:class="`px-1 `+classObjProdSelectFabricanteProveedor(props.item)">
                                    <b>{{ FabricanteOrProveedor() }}</b>
                                    {{ mostrarFabricanteProveedor(props.item) }}</span>
                                  
                                    <span v-if="validarBusProductoBarraReferencia($refs.RefTextFieldProducto.value)==true" style=" font-size:12px; border: 1px dashed  #616161;"
                                      v-bind:class="`px-1 `+classObjProdSelectReferencia(props.item)">
                                    <b>REF:</b>  {{ mostrarReferencia(props.item) }}</span>

                            <span v-if="$store.getters.GetConfiguracionGeneral.configInv.existenciaAdicionalPv==true"
                                  style=" font-size:12px; border: 1px dashed  #616161;"
                                  v-bind:class="`px-1 `+classObjProdSelectAlmacenAdicional(props.item)">
                                    <b> {{ mostrarExistenciaAdicional(props.item) }}</b>
                                  </span>

                            <span  v-if="props.item.productos.hasOwnProperty('descontinuado') && props.item.productos.descontinuado==true"
                              style=" font-size:12px; border: 1px dashed  #616161;"
                              v-bind:class="`px-1 `+classObjProdSelectDescontinuado(props.item)">
                                    <b>DESCONTINUADO</b> </span>


                          </v-col>
                        </v-row>
                        <!-- <v-list-item-content style="border: 2px solid #000000;"  >  </v-list-item-content> -->
                      </td>
                    </tr>
                  </template>
                  <!--
     <template v-slot:item.productos.descripcion="props">
      <span style="font-size:13px;" > {{props.item.productos.descripcion}}</span>
     </template>-->
                </v-data-table>
              </div>
              <!-------------------------------------------------- fn Seleccion de producto -->

              <!--------------------------------------------------  Header tb compra producto -->
              <v-col v-show="ProdCompOrSelecProd == true" class="py-0 my-0" cols="12" md="12"
                     sm="12" style="background-color:#3d6687;">
                <v-row style="border: 1px solid #000000;">
                  <v-col class="pa-0 ma-0" cols="6" md="6"><b :class="`d-flex justify-start white--text`">
                    {{`${UsarLote==true?'Lote-Producto':'Producto'}`  }}</b>
                  </v-col>
                  <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-start white--text`"> Cantidad</b>
                  </v-col>
                  <!-- <v-col class="pa-0 ma-0"  cols="2" md="2"><b :class="`d-flex justify-center white--text`" > Unidad </b></v-col> -->
                  <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-center white--text`"> Precio </b>
                  </v-col>
                  <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-center white--text`"> Valor </b>
                  </v-col>
                </v-row>
              </v-col>
              <!-------------------------------------------------- fn Header tb compra producto  -->
              <!-------------------------------------------------- Tb productos compra -->
              <div
                v-show="ProdCompOrSelecProd == true"
                ref="RefScrollProductoCompra" class="overflow-x-auto"
                v-bind:style="{ 'height': this.windowSizeCaja.height + 'px', 'max-height': this.windowSizeCaja.height + 'px', 'border': '2px solid #000000' }">
                <v-data-table
                  :headers="[
                    { text: 'CODIGO', value: 'productos.codigo', sortable: false, class: ['no-gutters'] },
                    { text: 'PRODUCTO', value: 'productos.descripcion', sortable: false, class: ['no-gutters'] },
                    { text: 'COSTO', value: 'costo', sortable: false, class: ['no-gutters'] },
                    { text: 'PRECIO', value: 'precio', sortable: false, class: ['no-gutters'] },
                    { text: 'EXISTENCIA', value: 'existencias', sortable: false, align: 'center', class: ['no-gutters'] },
                  ]
                  "
                  :items="RProductoCompra" :items-per-page="-1" :loading="loaderTabla" :show-select="true"
                  :single-select="true"
                  class="elevation-1" dense hide-default-footer hide-default-header item-key="indx">

                  <!-- <template v-slot:prepend-item>
                      <v-row>

                      <v-col cols="9" md="9" > <b style="font-size: 16px;">Descripción: </b> </v-col>
                      <v-col cols="3" md="3" > <b style="font-size: 16px;">Modulo:</b> </v-col>
                     </v-row>
      </template> -->
                  <!-- PRODUCTO, COSTO, PRECIO, EXISTENCIA :active="selected == props.item"-->

                  <template v-slot:item="props">
                    <span style="display:none;">{{ props.item.indx = RProductoCompra.indexOf(props.item) }}</span>
                    <tr v-bind:class="classObjProdSelect(props.item)">
                      <td v-ripple="{ class: `indigo--text` }" @click.prevent="EditarProductoSelect(props.item, true)">
                        <span v-if="!props.item.hasOwnProperty('cantidad')"
                              style="display:none;">{{ props.item.cantidad = 1 }}</span>
                        <span v-if="!props.item.hasOwnProperty('valor')"
                              style="display:none;">{{ props.item.valor = 0 }}</span>
                        <v-row>
                          <v-col class="pa-0 ma-0" cols="6" md="6"><span><b>{{ `${UsarLote==true? props.item.lote+'-'+props.item.descripcion :props.item.descripcion}`}}</b></span>
                          </v-col>
                          <v-col class="pa-0 ma-0" cols="2" md="2"><span> <b>X</b> {{
                              currencyFormatter(props.item.cantidad)
                            }}</span></v-col>
                          <!-- <v-col class="pa-0 ma-0"  cols="2" md="2"><span :class="`d-flex justify-center`" >{{props.item.unidades.descripcion}}</span></v-col> -->
                          <v-col class="pa-0 ma-0" cols="2" md="2"><span :class="`d-flex justify-center`"> {{
                              currencyFormatter2(getTasaMonedaSelect(props.item.precio))
                            }}</span></v-col>
                          <v-col class="pa-0 ma-0" cols="2" md="2"><span :class="`d-flex justify-center`">
                              {{ currencyFormatter2(CalcularValorProductoRPCompra(props.item)) }}
                            <!-- {{currencyFormatter2(((props.item.valor + props.item.RecarValor) -props.item.DescValor) - props.item.cobertura)}}-->
                            </span></v-col>
                          <v-col class="pa-0 ma-0" cols="12" md="12">
                            <span v-if="props.item.DescValor > 0" class="px-1"
                                  style=" font-size:12px; border: 1px dashed  #616161;"><b> **DESCUENTO:</b>
                              ($ {{ currencyFormatter2(getTasaMonedaSelect(props.item.DescValor)) }})
                              (% {{ currencyFormatter2(getTasaMonedaSelect(props.item.descuento)) }})
                            </span>
                            <!--props.item.recargo  -->
                            <span v-if="props.item.RecarValor > 0" class="px-1"
                                  style=" font-size:12px; border: 1px dashed  #616161;"><b> **RECARGO:</b>
                              ${{ currencyFormatter2(getTasaMonedaSelect(props.item.RecarValor)) }} </span>
                            <span v-if="props.item.cobertura > 0" class="px-1"
                                  style=" font-size:12px; border: 1px dashed  #616161;"><b> **COBERTURA:</b>
                              ${{ currencyFormatter2(getTasaMonedaSelect(props.item.cobertura)) }} </span>

                            <span style="display:none;">
                              <!-- {{ props.item.valordescuento = currencyFormatter2(props.item.DescValor),
                                      props.item.valorRecargo = currencyFormatter2(props.item.RecarValor)
                                    }}-->
                              {{
                                props.item.valordescuento = props.item.DescValor,
                                  props.item.valorRecargo = props.item.RecarValor
                              }}
                            </span>


                            <span v-if="props.item.hasOwnProperty('paramOfert') && props.item.paramOfert == true"
                                  class="px-1 blue--text"
                                  style=" font-size:12px; border: 1px dashed  #616161;"><b> **OFERTA**</b></span>
                          </v-col>
                          <v-col v-if="props.item.hasOwnProperty('vendedor') && props.item.vendedor != null"
                                 class="pa-0 ma-0 " cols="12"
                                 md="12">
                            <span class="px-1" style=" font-size:12px; border: 1px dashed  #616161;"><b>Vendedor: </b>{{
                                props.item.vendedor.nombre
                              }}</span>
                          </v-col>
                        </v-row>
                        <!-- <v-list-item-content style="border: 2px solid #000000;"  >  </v-list-item-content> -->
                      </td>
                    </tr>
                  </template>
                  <!--
     <template v-slot:item.productos.descripcion="props">
      <span style="font-size:13px;" > {{props.item.productos.descripcion}}</span>
     </template>-->
                </v-data-table>
              </div>
              <!-------------------------------------------------- fn Tb productos compra-->


            </center>
          </div>
          <!--------------------- fn Seleccion de producto & Tabla ------------------------------->

          <!--------------------- Informacion de producto ------------------------------->
          <!-- class="pa-0 ma-0 py-0 my-0" -->
          <div v-show="PanelInfProduct" style="background-color:#FFFFFF;">
            <div class="overflow-x-auto" style="max-height:535px; border: 1px solid #000000;">
              <v-col class="py-0 my-0 " cols="12" md="12" sm="12">
                <v-row>
                  <!-- columna 1 informacion producto -->
                  <v-col cols="12" md="3" sm="4" style="border: 1px solid #000000;">
                    <center>
                      <v-avatar color="transparent" size="120" tile>
                        <img v-if="(productoSeleccionado != null && productoSeleccionado.productos != null)"
                             :src="verFotodeProducto(productoSeleccionado.productos)" alt="ImagenProducto"
                             style="border: 2px solid #757575;">
                      </v-avatar>
                    </center>
                  </v-col>

                  <v-col cols="12" md="9" sm="8">
                    <span v-if="productoSeleccionado != null">
                      <v-row>

                        <v-col class="pa-0 ma-0 pl-1" cols="12" md="12" style="border: 1px dashed  #616161;">
                          <span
                            v-if="productoSeleccionado.hasOwnProperty('productos') && productoSeleccionado.productos != null && productoSeleccionado.productos.hasOwnProperty('descripcion')">
                            <!--  <b>{{ productoSeleccionado.productos.descripcion }}</b>-->
                            <b>{{ productoSeleccionado.descripcion }}</b>
                          </span>
                        </v-col>

                        <v-col
                          v-if="productoSeleccionado.hasOwnProperty('productos') && productoSeleccionado.productos != null"
                          class="pa-0 ma-0" cols="6"
                          md="6">
                          <p class="pa-0 ma-0 py-0 my-0 pl-1" style="border: 1px dashed  #616161;"><b>Codigo: </b> 
                          {{ productoSeleccionado.productos.codigo  }}<br>
                         </p>
                          <p class="pa-0 ma-0 py-0 my-0 pl-1" style="border: 1px dashed  #616161;"><b>Referencia: </b> 
                          {{ productoSeleccionado.productos.referencia  }}<br>
                         </p>
                          <p class="pa-0 ma-0 py-0 my-0 pl-1" style="border: 1px dashed  #616161;"><b>Ultima Entrada: </b> 
                          {{ productoSeleccionado.productos.existenciamaxima }}<br></p>
                        </v-col>


                        <v-col class="pa-0 ma-0" cols="6" md="6">
                          <p v-if="productoSeleccionado.hasOwnProperty('precio')" class="pa-0 ma-0 py-0 my-0 pl-1" style="border: 1px dashed  #616161;"><b>Precio: </b> 
                             {{ currencyFormatter2(productoSeleccionado.precio) }}<br>
                          </p>
                          <p v-if="productoSeleccionado.hasOwnProperty('existencias')" class="pa-0 ma-0 py-0 my-0 pl-1"
                             style="border: 1px dashed  #616161;"><b>Existencia: </b> 
                             {{ mostrarExistenciaHeaderProducto(productoSeleccionado) }}<br>
                          </p>
                            <p v-if="productoSeleccionado.hasOwnProperty('productos') && productoSeleccionado.productos != null" class="pa-0 ma-0 py-0 my-0 pl-1"
                            style="border: 1px dashed  #616161;">
                            <!-- <span v-if="productoSeleccionado.productos.hasOwnProperty('fabricante') && productoSeleccionado.productos.fabricante != null">
                              <b>Fabricante: </b> {{ productoSeleccionado.productos.fabricante.nombre }}
                              <br>
                            </span>-->
                            <b>Ubicacion: </b> {{ productoSeleccionado.productos.ubicacion }} <br></p>

                        </v-col>

                       <v-col v-if="productoSeleccionado.hasOwnProperty('productos') && productoSeleccionado.productos != null && productoSeleccionado.productos.hasOwnProperty('descontinuado') && productoSeleccionado.productos.descontinuado==true"
                          :class="`pa-0 ma-0 pl-1`" cols="12" md="12" style="border: 1px dashed  #616161; font-size: 13px;">
                       <center><b class="red--text" style="border: 1px dashed  #F44336;">DESCONTINUADO</b><br> </center> 
                      </v-col>
                

                       <v-col class="pa-0 ma-0" cols="6" md="6" v-if="productoSeleccionado.hasOwnProperty('productos') && productoSeleccionado.productos != null"  >
                        <p class="pa-0 ma-0 py-0 my-0 pl-1" style="border: 1px dashed  #616161;">
                          <b>Fabricante: </b> {{ productoSeleccionado.productos.fabricante.nombre.trim()}}<br>
                        </p>
                          <!-- <span><b>{{FabricanteOrProveedor()}} </b> {{mostrarFabricanteProveedor(productoSeleccionado)}}<br></span> -->
                      </v-col>
                  
                       <v-col style="border: 1px dashed  #616161;" class="pa-0 ma-0" cols="6" md="6" v-if="productoSeleccionado.hasOwnProperty('productos') && productoSeleccionado.productos != null">
                        <p class="pa-0 ma-0 py-0 my-0 pl-1" v-if="productoSeleccionado.hasOwnProperty('costo') && $store.getters.GetConfiguracionGeneral.configPv.hasOwnProperty('mostrarCostoProductoPv') && $store.getters.GetConfiguracionGeneral.configPv.mostrarCostoProductoPv==true" >
                          <b>Costo: </b>  {{ currencyFormatter2(productoSeleccionado.costo) }}<br>
                        </p>
                      </v-col>

                       <v-col
                         v-if="productoSeleccionado.hasOwnProperty('productos') && productoSeleccionado.productos != null"
                         class="pa-0 ma-0 pl-1" cols="12" md="12"
                         style="border: 1px dashed  #616161;">
                        <span><b>Proveedor: </b> {{ mostrarProveedor(productoSeleccionado) }}<br></span>
                       </v-col>
                       <v-col
                         v-if="productoSeleccionado.hasOwnProperty('productos') && productoSeleccionado.productos != null &&
                         productoSeleccionado.productos.hasOwnProperty('impuesto') && productoSeleccionado.productos.impuesto!=null && productoSeleccionado.productos.impuesto!=null && productoSeleccionado.productos.impuesto.hasOwnProperty('codigo')"
                         class="pa-0 ma-0 pl-1" cols="12" md="12"
                         style="border: 1px dashed  #616161;">
                        <span><b>Impuesto: </b> {{ mostrarimpuesto(productoSeleccionado) }}<br></span>
                       </v-col>

                          <v-col class="pa-0 ma-0 pl-1" cols="6" md="6">
                          <span
                            v-if="productoSeleccionado.hasOwnProperty('productos')&& productoSeleccionado.productos != null && productoSeleccionado.productos.hasOwnProperty('sustancia') && productoSeleccionado.productos.sustancia!=null && productoSeleccionado.productos.sustancia.length>0">
                            <b>Sustancia: </b> {{ productoSeleccionado.productos.sustancia }}
                            <br>
                          </span>

                        </v-col>

                      </v-row>
                    </span>
                  </v-col>


                  <!-- <v-col cols="12" md="6" sm="6">
           <v-row>

           </v-row>
          </v-col>  -->

                  <!-- Preci,cantida aquii -->

                </v-row>
              </v-col>
            </div>
            <!-- Existencia de productos almacen  -->
            <v-col class="pa-0 ma-0 py-0 my-0 pt-1" cols="12" md="12" sm="12">
              <div class="overflow-x-auto" style="max-height:250px;">

                <v-card v-if="UsarLote == false" style="border: 1px solid  #616161;">
                  <v-data-table :footer-props="arrayPropiedases" :headers="[
                    { text: 'ALMACEN', value: 'almacen', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'EXISTENCIA', value: 'existencion', sortable: false, class: ['no-gutters black--text'] },
                  ]" :items="ListaProdxAlmacen" :items-per-page="15" dense>

                    <template v-slot:item.almacen="props">
                      <span style="font-size:13px;">{{ props.item.almacen }}</span>
                    </template>

                    <template v-slot:item.existencion="props">
                      <span style="font-size:13px;">{{ props.item.existencion }}</span>
                    </template>

                  </v-data-table>
                </v-card>
                <v-card v-if="UsarLote == true" style="border: 1px solid  #616161;">
                  <v-data-table v-model="selectedListProdxLote" :footer-props="arrayPropiedases" :headers="getHeadersExisteLote()"
                                :items="ListaProdxLote"
                                :items-per-page="15" :show-select="true" :single-select="true" dense item-key="indx"
                                @item-selected="obtenerDatoSelectProdxLote"
                                @click:row="obtenerDatoSelectProdxLoteClickRow">
                    <template v-slot:item.balance="props">
                      <span style="font-size:13px;">{{ props.item.balance }}</span>
                    </template>

                    <template v-slot:item.fechaVencimiento="props">
                      <span style="display:none;">{{ props.item.indx = ListaProdxLote.indexOf(props.item) }}</span>

                      <span v-if="props.item.fechaVencimiento != null" style="font-size:13px;">{{
                          FormatoFecha(props.item.fechaVencimiento.fechaInicial)
                        }}</span>

                    </template>

                    <template v-slot:item.loteFabricante="props">
                      <span style="font-size:13px;">{{ props.item.loteFabricante!=null?props.item.loteFabricante.trim():"" }}</span>
                    </template>

                  </v-data-table>
                </v-card>


              </div>
            </v-col>
            <!-- bn Existencia de productos almacen  -->

          </div>

          <!--------------------- fn Informacion de producto ------------------------------->

        </v-container>
      </v-col>
      <!-- fn columna general 1 ------------->


      <!-- columna general 2 ---------------->
      <v-col cols="12" md="6" sm="6">
        <div class="overflow-y-auto"
             v-bind:style="{ 'height': this.windowSize.height - 30 + 'px', 'max-height': this.windowSize.height - 30 + 'px', 'border': '1px solid #000000', 'background-color': '#FFFFFF' }">
          <!-- style="border: 2px solid #757575; overflow: auto;  max-height:350px; min-width:100%;"   class="overflow-x-auto" -->

          <!--------------------- Panel 2 Completo Menu opcion , forma de pago y otros  ------------------------------->
          <div v-show="PanelMenuOpcionCompleto">

            <!---------------------  Panel Menu Opcion Botones ------------------------------->
            <div v-show="PanelMenuOpcionBotones" class="overflow-x-auto" style="max-height:300px;">
              <!-- columna  ---------------------->
              <PvMenuOpcionBotones ref="RefPvMenuOpcionBotones" :cajaSelect="caja"
                                   @DataRetornAccion="DataRetornMenuOpcBotonesPermisosPv"
                                   @DataRetornAccionPadre="DataRetornPadrePermisoPv" />
            </div>
            <!--------------------- fn Panel Menu Opcion Botones ------------------------------->

            <!--------------------- Panel Panel-Factura Domicilio  ------------------------------->
            <div v-show="PanelMenuOpcionFacturaDomicilio" class="overflow-x-auto"
                 style="max-height:300px; min-height:300px ">

              <v-toolbar color="#dd4b39" dark dense>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">

                    <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Factura
                      Domicilio
                    </v-toolbar-title>

                  </template>
                  <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Factura Domicilio : </span>
                    Factura Domicilio </i>

                </v-tooltip>

                <v-spacer></v-spacer>

                <v-card-actions>
                  <v-btn-toggle>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="orange" dark small @click="cancelarFacturaDomicilio()" v-on="on">
                          <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                          CANCELAR
                        </v-btn>
                      </template>
                      <span>CANCELAR: No Agregar y retornar atrás</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="light-blue darken-4" dark small
                               @click="AceptarFacturaDomicilio()" v-on="on">
                          <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                          SALVAR
                        </v-btn>
                      </template>
                      <span>SALVAR: Aceptar Domicilio </span>
                    </v-tooltip>

                  </v-btn-toggle>

                </v-card-actions>

              </v-toolbar>

              <v-col v-if="domiciliofactura != null" cols="12" md="12" sm="12">
                <v-form ref="form" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <v-row no-gutters>
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                      <v-text-field id="formdisabledInput" v-model="domiciliofactura.nombre" autocomplete="off" dense
                                    disabled label="Cliente:"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6">
                      <v-text-field v-model="domiciliofactura.telefonoPrincipal" v-mask="'(###)###-####'"
                                    :rules="[$rules.RulesTel]" autocomplete="off" dense
                                    label="Télefono:" maxlength="13"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-phone" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>
                    </v-col>


                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6">
                      <v-combobox v-model="domiciliofactura.selctDireccion" :items="RDireccionDomicilio"
                                  :rules="[$rules.required]" autocomplete="off" dense
                                  item-text="descripcion" label="Dirección:"
                                  outlined
                                  @blur="SelctCbDireccionDomicilio" @change="ChangeDireccionDomicilio">
                        <template v-slot:prepend>
                          <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>
                    </v-col>


                    <v-col v-if="this.domiciliofactura.selctDireccion != null" class="pa-0 ma-0 py-0 my-0" cols="12"
                           md="12" sm="12">
                      <v-textarea v-model="domiciliofactura.direccion" :rules="[$rules.required]" autocomplete="off"
                                  dense label="Dirección:"
                                  outlined rows="3">
                        <template v-slot:prepend>
                          <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                        </template>
                      </v-textarea>
                    </v-col>


                  </v-row>
                </v-form>
              </v-col>
            </div>
            <!--------------------- fn Panel Factura Domicilio ------------------------------->


            <!--------------------- Panel Panel-Comentario Factura  ------------------------------->
            <div v-show="PanelMenuOpcionComentarioFactura" class="overflow-x-auto"
                 style="max-height:300px; min-height:300px ">

              <v-toolbar color="#dd4b39" dark dense>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">

                    <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Comentario
                      Factura
                    </v-toolbar-title>

                  </template>
                  <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Comentario Factura : </span>
                    Comentario Factura </i>

                </v-tooltip>

                <v-spacer></v-spacer>

                <v-card-actions>
                  <v-btn-toggle>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="orange" dark small @click="cancelarComentarioFactura()" v-on="on">
                          <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                          CANCELAR
                        </v-btn>
                      </template>
                      <span>CANCELAR: No Agregar y retornar atrás</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="grey" dark small @click="NewNewComentarioFactura()" v-on="on">

                          <v-avatar color="transparent" size="28" tile>
                            <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                          </v-avatar>

                          <i style="font-size: 20px;"> </i>
                          NUEVO
                        </v-btn>
                      </template>
                      <span>NUEVO: Limpia los campo para un nuevo registro</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="light-blue darken-4" dark small
                               @click="SalvarComentarioFactura()" v-on="on">
                          <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                          SALVAR
                        </v-btn>
                      </template>
                      <span>SALVAR: Aceptar la retención y retornar atrás</span>
                    </v-tooltip>


                  </v-btn-toggle>

                </v-card-actions>

              </v-toolbar>

              <v-col cols="12" md="12" sm="12">

                <v-row no-gutters>
                  <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6">
                    <v-textarea v-model="Facturasventa.comentario" autocomplete="off" dense label="comentario:"
                                outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-commenting" style="font-size: 20px;"></i>
                      </template>
                    </v-textarea>

                    <v-text-field v-model="Facturasventa.numeroOrden" autocomplete="off" dense label="No.orden:"
                                  outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-hashtag" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>


                  </v-col>


                  <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6">
                    <v-textarea v-model="Facturasventa.ShipTo" autocomplete="off" dense label="Ship To:" outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-ship" style="font-size: 20px;"></i>
                      </template>
                    </v-textarea>

                    <v-text-field v-model="Facturasventa.incoterms" autocomplete="off" dense label="Incoterms:"
                                  outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-font" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col v-if="combExtranjero(clienteFactura)" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                    <v-textarea v-model="Facturasventa.infAdicionales" autocomplete="off" dense label="Informaciones Adicionales:"
                                outlined auto-grow>
                      <template v-slot:prepend>
                        <i class="fa fa-commenting" style="font-size: 20px;"></i>
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>

              </v-col>
            </div>
            <!--------------------- fn Panel Comentario Factura  ------------------------------->


            <!--------------------- Panel Panel-Moneda factura   ------------------------------->
            <div v-show="PanelMenuOpcionMonedaFactura" class="overflow-x-auto"
                 style="max-height:300px; min-height:300px ">

              <v-toolbar color="#dd4b39" dark dense>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">

                    <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Moneda
                      Factura
                    </v-toolbar-title>

                  </template>
                  <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Moneda Factura : </span>
                    Moneda Factura </i>

                </v-tooltip>

                <v-spacer></v-spacer>

                <v-card-actions>
                  <v-btn-toggle>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="orange" dark small v-on="on"
                               @click.prevent="cancelarMonedaFactura()">
                          <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                          CANCELAR
                        </v-btn>
                      </template>
                      <span>CANCELAR: No Agregar la Moneda a la factura y retornar atrás</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="grey" dark small v-on="on" @click.prevent="NewNewMonedaFactura()">

                          <v-avatar color="transparent" size="28" tile>
                            <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                          </v-avatar>

                          <i style="font-size: 20px;"> </i>
                          NUEVO
                        </v-btn>
                      </template>
                      <span>NUEVO: Limpia los campo para un nuevo registro</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="light-blue darken-4" dark
                               small v-on="on" @click.prevent="SalvarMonedaFactura()">
                          <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                          SALVAR
                        </v-btn>
                      </template>
                      <span>SALVAR: Aceptar la Moneda y retornar atrás</span>
                    </v-tooltip>


                  </v-btn-toggle>

                </v-card-actions>

              </v-toolbar>

              <v-col cols="12" md="12" sm="12">

                <!-- -----------------------------------------Moneda   @blur="SelctCbMoneda"  -->
                <!-- <v-col   cols="12" md="12" sm="12" class="py-0 my-0"></v-col> -->

                <v-combobox v-model="Monedafactura" :items="Rmoneda" :rules="[$rules.required]" autocomplete="off" dense
                            item-text="descripcion"
                            label="Monedas" outlined style="font-size:13px;"
                            @focus="cargarMoneda"
                >
                  <template v-slot:prepend>
                    <i class="fa fa-money" style="font-size: 20px;"></i>
                  </template>

                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <span id="ImputColorDisable">
                      {{ item.descripcion }} ({{ item.nombrecorto }})
                    </span>

                  </template>


                  <template slot="item" slot-scope="item">
                    <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="font-size: 13px;">
                      <p class="pa-0 ma-0 py-0 my-0"><b>{{ item.item.descripcion }} ({{ item.item.nombrecorto }})</b>
                      </p>
                    </v-col>
                  </template>
                </v-combobox>


                <!-- -----------------------------  Tasa Compra -->
                <!-- <v-col   cols="12" md="6" sm="6" class="py-0 my-0"  v-if="Monedafactura!=null" ></v-col> -->
                <v-text-field v-if="Monedafactura != null" id="formdisabledInput" v-model.number="Monedafactura.tasa"
                              dense label="Tasa Compra:"
                              outlined>
                  <template v-slot:prepend>
                    <i class="fa fa-usd" style="font-size: 20px;"></i>
                  </template>
                </v-text-field>


              </v-col>
            </div>
            <!--------------------- fn Panel Moneda factura  ------------------------------->


            <!--------------------- Panel Panel-Retencion factura   ------------------------------->
            <div v-show="PanelMenuOpcionRetencionFactura" class="overflow-x-auto"
                 style="max-height:300px; min-height:300px ">

              <v-toolbar color="#dd4b39" dark dense>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">

                    <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Retención
                      Factura
                    </v-toolbar-title>

                  </template>
                  <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Retención Factura : </span>
                    Retención Factura </i>

                </v-tooltip>

                <v-spacer></v-spacer>

                <v-card-actions>
                  <v-btn-toggle>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="orange" dark small @click="cancelarRetencionFactura()" v-on="on">
                          <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                          CANCELAR
                        </v-btn>
                      </template>
                      <span>CANCELAR: No Agregar la retención a la factura y retornar atrás</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="grey" dark small @click="NewNewRetencionFactura()" v-on="on">

                          <v-avatar color="transparent" size="28" tile>
                            <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                          </v-avatar>

                          <i style="font-size: 20px;"> </i>
                          NUEVO
                        </v-btn>
                      </template>
                      <span>NUEVO: Limpia los campo para un nuevo registro</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="light-blue darken-4" dark small
                               @click="SalvarRetencionFactura()" v-on="on">
                          <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                          SALVAR
                        </v-btn>
                      </template>
                      <span>SALVAR: Aceptar la retención y retornar atrás</span>
                    </v-tooltip>


                  </v-btn-toggle>

                </v-card-actions>

              </v-toolbar>

              <v-col cols="12" md="12" sm="12">
                <VueAutonumeric ref="RefTextFieldRetencionFactura" v-model.number="Retencionfactura.Retencion"
                                :rules="[$rules.Numericc]" autocomplete="off"
                                dense label="Retención" outlined
                                style="font-size:13px;" @keydown.enter="SalvarRetencionFactura()">
                  <template v-slot:prepend>
                    <i v-if="Retencionfactura.ValorPorc == true" class="fa fa-usd" style="font-size: 20px;"></i>
                    <i v-if="Retencionfactura.ValorPorc == false" class="fa fa-percent" style="font-size: 20px;"></i>
                  </template>

                  <template v-slot:append-outer>

                    <v-radio-group v-model="Retencionfactura.ValorPorc" column dense style="margin-top: -18%;"
                                   @change="">
                      <v-radio :value="true" color="teal lighten-2" label="Valor"></v-radio>
                      <v-radio :value="false" color="teal lighten-2" label="Porciento"></v-radio>
                    </v-radio-group>
                  </template>
                </VueAutonumeric>

              </v-col>
            </div>
            <!--------------------- fn Panel Retencion factura  ------------------------------->

            <!--------------------- Panel Panel-recargo factura   ------------------------------->
            <div v-show="PanelMenuOpcionRecargoFactura" class="overflow-x-auto"
                 style="max-height:300px; min-height:300px ">

              <v-toolbar color="#dd4b39" dark dense>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">

                    <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Recargo
                      Factura
                    </v-toolbar-title>

                  </template>
                  <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Recargo Factura : </span>
                    Recargo Factura </i>

                </v-tooltip>

                <v-spacer></v-spacer>

                <v-card-actions>
                  <v-btn-toggle>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="orange" dark small v-on="on"
                               @click.prevent="cancelarRecargoFactura()">
                          <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                          CANCELAR
                        </v-btn>
                      </template>
                      <span>CANCELAR: No Agregar el recargo a la factura y retornar atrás</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="grey" dark small v-on="on"
                               @click.prevent="NewNewRecargoFactura()">

                          <v-avatar color="transparent" size="28" tile>
                            <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                          </v-avatar>


                          <i style="font-size: 20px;"> </i>
                          NUEVO
                        </v-btn>
                      </template>
                      <span>NUEVO: Limpia los campo para un nuevo registro</span>
                    </v-tooltip>


                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="light-blue darken-4" dark
                               small v-on="on" @click.prevent="SalvarRecargoFactura()">
                          <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                          SALVAR
                        </v-btn>
                      </template>
                      <span>SALVAR: Aceptar el recargo a la factura y retorna atrás </span>
                    </v-tooltip>

                  </v-btn-toggle>

                </v-card-actions>

              </v-toolbar>

              <v-col cols="12" md="12" sm="12">
                <VueAutonumeric ref="RefTextFieldRecargoFactura" v-model.number="Recargofactura.recargo"
                                :rules="[$rules.Numericc]" autocomplete="off"
                                dense label="recargo" outlined
                                style="font-size:13px;" @keydown.enter="SalvarRecargoFactura()">
                  <template v-slot:prepend>
                    <i v-if="Recargofactura.ValorPorc == true" class="fa fa-usd" style="font-size: 20px;"></i>
                    <i v-if="Recargofactura.ValorPorc == false" class="fa fa-percent" style="font-size: 20px;"></i>
                  </template>

                  <template v-slot:append-outer>

                    <v-radio-group v-model="Recargofactura.ValorPorc" column dense style="margin-top: -18%;" @change="">
                      <v-radio :value="true" color="teal lighten-2" label="Valor"></v-radio>
                      <v-radio :value="false" color="teal lighten-2" label="Porciento"></v-radio>
                    </v-radio-group>
                  </template>
                </VueAutonumeric>
              </v-col>
            </div>
            <!--------------------- fn Panel recargo factura  ------------------------------->


            <!--------------------- Panel Panel Descuento Factura   ------------------------------->
            <div v-show="PanelMenuOpcionDescuentoFactura" class="overflow-x-auto"
                 style="max-height:300px; min-height:300px ">

              <v-toolbar color="#dd4b39" dark dense>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">

                    <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Descuento
                      Factura
                    </v-toolbar-title>

                  </template>
                  <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Descuento Factura : </span>
                    Descuento Factura </i>

                </v-tooltip>

                <v-spacer></v-spacer>

                <v-card-actions>
                  <v-btn-toggle>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="orange" dark small
                               v-on="on"
                               @click.prevent="cancelarDescuentoFactura()">
                          <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                          CANCELAR
                        </v-btn>
                      </template>
                      <span>CANCELAR: No Agregar el descuento a la factura y retornar atrás</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="grey" dark small v-on="on"
                               @click.prevent="NewNewDescuentoFactura()">

                          <v-avatar color="transparent" size="28" tile>
                            <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                          </v-avatar>


                          <i style="font-size: 20px;"> </i>
                          NUEVO
                        </v-btn>
                      </template>
                      <span>NUEVO: Limpia los campo para un nuevo registro</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="light-blue darken-4" dark
                               small v-on="on" @click.prevent="SalvarDescuentoFactura()">
                          <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                          SALVAR
                        </v-btn>
                      </template>
                      <span>SALVAR: Aceptar el descuento a la factura y retorna atrás </span>
                    </v-tooltip>

                  </v-btn-toggle>

                </v-card-actions>

              </v-toolbar>
              <!--:rules="[$rules.Numericc]" -->
              <v-col cols="12" md="12" sm="12">
                <v-form ref="formDescuentoFactura" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
                  <VueAutonumeric ref="RefTextFieldDescuentoFactura" v-model.number="Descuentofactura.descuento"
                                  :rules="[$rules.Numericc]" autocomplete="off"
                                  dense label="Descuento"
                                  outlined style="font-size:13px;"
                                  @keydown.enter="SalvarDescuentoFactura()">
                    <template v-slot:prepend>
                      <i v-if="Descuentofactura.ValorPorc == true" class="fa fa-usd" style="font-size: 20px;"></i>
                      <i v-if="Descuentofactura.ValorPorc == false" class="fa fa-percent" style="font-size: 20px;"></i>
                    </template>

                    <template v-slot:append-outer>

                      <v-radio-group v-model="Descuentofactura.ValorPorc" column dense style="margin-top: -18%;"
                                     @change="">
                        <v-radio :value="true" color="teal lighten-2" label="Valor"></v-radio>
                        <v-radio :value="false" color="teal lighten-2" label="Porciento"></v-radio>
                      </v-radio-group>
                    </template>
                  </VueAutonumeric>
                </v-form>
              </v-col>
            </div>
            <!--------------------- fn Panel Descuento factura  ------------------------------->


            <!--------------------- Panel selecion vendedor  ------------------------------->
            <div v-show="PanelMenuOpcionVendedor" class="overflow-x-auto" style="max-height:300px; min-height:300px ">

              <v-toolbar color="#dd4b39" dark dense>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">

                    <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Selección de
                      Vendedor
                    </v-toolbar-title>

                  </template>
                  <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Selección de Vendedor :
                    </span> Se selecciona el vendedor a la factura actual</i>

                </v-tooltip>

                <v-spacer></v-spacer>

                <v-card-actions>
                  <v-btn-toggle>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="orange" dark small v-on="on"
                               @click.prevent="cancelarVendedores()">
                          <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                          CANCELAR
                        </v-btn>
                      </template>
                      <span>CANCELAR: No Agregar el vendedor a la factura y retornar atrás</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="grey" dark small v-on="on" @click.prevent="NewNewVendedores()">

                          <v-avatar color="transparent" size="28" tile>
                            <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                          </v-avatar>


                          <i style="font-size: 20px;"> </i>
                          NUEVO
                        </v-btn>
                      </template>
                      <span>NUEVO: Limpia los campo para un nuevo registro</span>
                    </v-tooltip>


                  </v-btn-toggle>

                </v-card-actions>

              </v-toolbar>

              <v-col cols="12" md="12" sm="12">

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <!--@change="getChangeClienteBusqueda"  @keyup="CbFilVendedorFactura" -->
                    <v-combobox ref="RefTextFieldBuscaVendedor" v-model="Facturasventa.vendedor" :items="RVendedor"
                                :rules="[$rules.required]"
                                autocomplete="off" background-color="white" color="grey darken-4" dense hide-details
                                item-text="codVenDesc"
                                label="buscar Vendedor:" outlined style="font-size: 13px;"
                                @blur="SelctCbVendedorFactura" @focus="cargarVendedorFactura" v-on="on"
                                @keyup.enter="SalvarVendedores">
                      <template v-slot:prepend-inner>
                        <i class="fa fa-search" style="font-size: 25px;"></i>
                      </template>
                      <!-- margin-top="50px"style="font-size: 14px;" -->
                      <template slot="item" slot-scope="item">
                        <span style="display:none;">{{ item.item.codVenDesc = `${item.item.codigo} - ${item.item.nombre.trim()} ` }}</span>
                        <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12"
                               md="12"
                               sm="12" style="border: 1px solid #000000; font-size: 13px; ">
                          <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>NOMBRE:
                            {{ item.item.nombre }}</b></p>

                          <span class="pa-0 ma-0 py-0 my-0">
                            <span style="border: 1px dashed  #616161;"><b>TEL.: </b>{{ item.item.telefono }} </span>
                            <span style="border: 1px dashed  #616161;"><b>CED/RNC: </b> {{ item.item.cedrnc }}</span>
                          </span>
                          <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>DIRECCIÓN: </b>
                            {{ item.item.direccion }} </p>
                          <span v-if="item.item.hasOwnProperty('ars') && item.item.ars != null"
                                style="border: 1px dashed  #616161;"><b> ARS
                              :{{ item.item.ars.nombre }}</b></span>
                          <span v-if="item.item.diascredito > 0" style="border: 1px dashed  #616161;"><b> TIPO: Cliente
                              Credito</b></span>
                          <span v-if="item.item.diascredito == 0" style="border: 1px dashed  #616161;"><b>TIPO: Cliente
                              Contado</b></span>
                        </v-col>


                      </template>


                      <template v-slot:append-outer>

                        <v-tooltip top>
                          <template v-slot:activator="{ on }">

                            <v-btn color="indigo lighten-2" dark outlined small v-on="on"
                                   @click.prevent="SalvarVendedores">
                              <!-- <i style="font-size: 20px;" class="fa fa-plus-square"></i> -->

                              <v-avatar color="transparent" size="28" tile>
                                <img alt="Asignar Vendedor" src="@/assets/icons_pv/extras/seleccionar48.png">
                              </v-avatar>


                            </v-btn>

                          </template>
                          <span>Asignar Vendedor buscado a la factura</span>
                        </v-tooltip>

                      </template>


                    </v-combobox>
                  </template>
                  <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                    <span> Se selecciona el Vendedor que desea Asignar a la factura.</span>
                  </i>
                </v-tooltip>


              </v-col>
            </div>
            <!--------------------- fn Panel selecion vendedor  ------------------------------->


            <!--------------------- Panel-selecion médico  ------------------------------->
            <div v-show="PanelMenuOpcionMedico" class="overflow-x-auto" style="max-height:300px; min-height:300px ">

              <v-toolbar color="#dd4b39" dark dense>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">

                    <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Selección de
                      médico
                    </v-toolbar-title>

                  </template>
                  <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Selección de médico : </span>
                    Se selecciona el médico a la factura actual</i>

                </v-tooltip>

                <v-spacer></v-spacer>

                <v-card-actions>
                  <v-btn-toggle>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="orange" dark small @click="cancelarMedico()" v-on="on">
                          <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                          CANCELAR
                        </v-btn>
                      </template>
                      <span>CANCELAR: No Agregar el médico a la factura y retornar atrás</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn id="boton-mini" color="grey" dark small @click="NewNewMedico()" v-on="on">

                          <v-avatar color="transparent" size="28" tile>
                            <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                          </v-avatar>


                          <i style="font-size: 20px;"> </i>
                          NUEVO
                        </v-btn>
                      </template>
                      <span>NUEVO: Limpia los campo para un nuevo registro</span>
                    </v-tooltip>


                  </v-btn-toggle>

                </v-card-actions>

              </v-toolbar>

              <v-col cols="12" md="12" sm="12">

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <!--@change="getChangeClienteBusqueda"  @keyup="CbFilVendedorFactura" -->
                    <v-combobox ref="RefTextFieldBuscaMedico" v-model="SelectMedicoFactura" :items="RMedico"
                                :rules="[$rules.required]"
                                autocomplete="off" background-color="white" color="grey darken-4" dense hide-details
                                item-text="nombre"
                                label="buscar Medico:" outlined style="font-size: 13px;"
                                @blur="SelctCbMedicoFactura" @focus="cargarMedico" v-on="on"
                                @keyup.enter="SalvarMedico">
                      <template v-slot:prepend-inner>
                        <i class="fa fa-search" style="font-size: 25px;"></i>
                      </template>
                      <!-- margin-top="50px"style="font-size: 14px;" -->
                      <template slot="item" slot-scope="item">
                        <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12"
                               md="12"
                               sm="12" style="border: 1px solid #000000; font-size: 13px; ">
                          <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>NOMBRE:
                            {{ item.item.nombre }}</b></p>

                          <span class="pa-0 ma-0 py-0 my-0">
                            <span style="border: 1px dashed  #616161;"><b>TEL.: </b> (809)342-6240</span>
                            <span style="border: 1px dashed  #616161;"><b>CED/RNC: </b> {{ item.item.cedrnc }}</span>
                          </span>
                          <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>DIRECCIÓN: </b>
                            {{ item.item.direccion }} </p>
                          <span v-if="item.item.hasOwnProperty('ars') && item.item.ars != null"
                                style="border: 1px dashed  #616161;"><b> ARS
                              :{{ item.item.ars.nombre }}</b></span>
                          <span v-if="item.item.diascredito > 0" style="border: 1px dashed  #616161;"><b> TIPO: Cliente
                              Credito</b></span>
                          <span v-if="item.item.diascredito == 0" style="border: 1px dashed  #616161;"><b>TIPO: Cliente
                              Contado</b></span>
                        </v-col>


                      </template>


                      <template v-slot:append-outer>

                        <v-tooltip top>
                          <template v-slot:activator="{ on }">

                            <v-btn color="indigo lighten-2" dark outlined small v-on="on" @click.prevent="SalvarMedico">
                              <!-- <i style="font-size: 20px;" class="fa fa-plus-square"></i> -->

                              <v-avatar color="transparent" size="28" tile>
                                <img alt="Asignar Vendedor" src="@/assets/icons_pv/extras/seleccionar48.png">
                              </v-avatar>


                            </v-btn>

                          </template>
                          <span>Asignar médico buscado a la factura</span>
                        </v-tooltip>

                      </template>


                    </v-combobox>
                  </template>
                  <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                    <span> Se selecciona el médico que desea Asignar a la factura.</span>
                  </i>
                </v-tooltip>


              </v-col>
            </div>
            <!--------------------- fn Panel-selecion médico------------------------------->

            <!--------------------- Panel Forma pago nota de credito  ------------------------------->
            <div v-show="PanelFormaPagoNotaCredito" class="overflow-x-auto" style="max-height:300px; min-height:300px ">

              <v-toolbar color="#dd4b39" dark dense>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">

                    <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Forma de
                      Pago Nota crédito
                    </v-toolbar-title>

                  </template>
                  <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Forma de Pago Nota crédito:
                    </span> Forma de Pago Nota crédito</i>

                </v-tooltip>

                <v-spacer></v-spacer>

                <v-card-actions>
                  <v-btn color="grey darken-4" fab x-small
                         @click="PanelFormaPagoNotaCredito = false, PanelMenuOpcionBotones = true">
                    <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
                  </v-btn>
                </v-card-actions>

              </v-toolbar>

              <v-col cols="12" md="12" sm="12">

                <v-text-field id="formdisabledInput" v-model="BuscarClienteFormaPagoNC" :rules="[$rules.required]"
                              autocomplete="off"
                              dense hide-details label="Escriba el nombre del cliente:" outlined
                              @keyup="CbFilNotacreditocontado">
                  <template v-slot:prepend>
                    <i class="fa fa-font" style="font-size: 20px;"></i>
                  </template>
                </v-text-field>


                <v-data-table v-model="selectedListFPagoNC" :headers="[
                  { text: 'CLIENTE', value: 'cliente', sortable: false, class: ['no-gutters black--text'] },
                  { text: 'CEDULA', value: 'cedula', sortable: false, class: ['no-gutters black--text'] },
                  { text: 'VALOR PENDIENTE', value: 'pendiente', sortable: false, align: 'center', class: ['no-gutters black--text '] },
                ]
                " :items="ListFormaPagoNC" :items-per-page="5" :show-select="true" :single-select="true"
                              class="elevation-1"
                              dense item-key="indx"
                              @item-selected="obtenerDatoSelectFormaPagoNC"
                              @click:row="obtenerDatoSelectFormaPagoNCClickRow">
                  <!-- hide-default-footer -->
                  <template v-slot:item.pendiente="props">
                    <span style="display:none;">{{ props.item.indx = ListFormaPagoNC.indexOf(props.item) }}</span>
                    <span style="font-size:13px;">{{ currencyFormatter(props.item.pendiente) }}</span>
                  </template>


                </v-data-table>


              </v-col>
            </div>
            <!--------------------- fn Panel Forma pago nota de credito  ------------------------------->


            <hr style="border:1px solid #000000;">
            <v-col cols="12" md="12" sm="12" style="margin-top:-10px">
              <center>
                <!--------------------- Panel-forma de pago pv ------------------------------->
                <v-card v-if="actualizarDecimal" color="grey lighten-3">
                  <v-row>
                    <!--  columna 1  @blur="ActualizarProductPago"-->
                    <!-- VueAutonumeric  -->
                    <v-col v-show="PanelFormaPagoColmna1" cols="12" md="6" sm="6">
                      <AutoNumericNuevoWithOptions id="formdisabledInput"
                                                   ref="RefTextFieldForPagoEfectivo"
                                                   v-model.number="Facturasventa.efectivo"
                                                   :disabled="activaConduceCredito == true || this.SoloCxc==true"
                                                   :rules="[$rules.Numericc]" autocomplete="off"
                                                   dense
                                                   hide-details
                                                   label="Efectivo:" outlined
                                                   style="font-size: 13px;"
                                                   v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                   @blur="BlurEfectivoPago" @input="calculostotales"
                                                   @keydown.enter="enterEfectivo"
                      >
                        <template v-slot:prepend>
                          <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->

                          <!-- <span ></span> -->
                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Efectivo" src="@/assets/icons_pv/formapago/efectivo35.png">
                          </v-avatar>

                        </template>
                      </AutoNumericNuevoWithOptions>
                      <!--@blur="ActualizarProductPago"  -->
                      <AutoNumericNuevoWithOptions id="formdisabledInput"
                                                   v-model.number="Facturasventa.tarjeta"
                                                   :disabled="activaConduceCredito == true || this.SoloCxc==true"
                                                   :rules="[$rules.Numericc]" autocomplete="off" class="mt-1" dense
                                                   hide-details
                                                   label="Tarjeta:" outlined
                                                   style="font-size: 13px;"
                                                   v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                   @blur="BlurTarjetaPago"
                                                   @focus="OpenPanelFormaPagoTarjeta" @input="calculostotales"
                                                   @keydown.enter="enterTarjeta">
                        <template v-slot:prepend>
                          <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->
                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Tarjeta" src="@/assets/icons_pv/formapago/tarjeta35.png">
                          </v-avatar>
                        </template>
                      </AutoNumericNuevoWithOptions>
                      <AutoNumericNuevoWithOptions id="formdisabledInput"
                                                   v-model.number="Facturasventa.cheques"
                                                   :disabled="activaConduceCredito == true || this.SoloCxc==true"
                                                   :rules="[$rules.Numericc]" autocomplete="off" class="mt-1" dense
                                                   hide-details
                                                   label="Cheque:" outlined
                                                   style="font-size: 13px;"
                                                   v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                   @blur="BlurChequesPago"
                                                   @focus="OpenPanelFormaPagoCheque('Cheque')"
                                                   @input="calculostotales"
                                                   @keydown.enter="enterCheque">
                        <template v-slot:prepend>
                          <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->
                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Cheque" src="@/assets/icons_pv/formapago/cheques35.png">
                          </v-avatar>


                        </template>
                      </AutoNumericNuevoWithOptions>


                      <AutoNumericNuevoWithOptions id="formdisabledInput"
                                                   v-model.number="Facturasventa.transferencia"
                                                   :disabled="activaConduceCredito == true || this.SoloCxc==true"
                                                   :rules="[$rules.Numericc]" autocomplete="off" class="mt-1" dense
                                                   hide-details label="Transferencia:"
                                                   outlined style="font-size: 13px;"
                                                   v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                   @blur="BlurTransferenciaPago"
                                                   @focus="OpenPanelFormaPagoCheque('Transferencia')"
                                                   @input="calculostotales"
                                                   @keydown.enter="enterTransferencia">
                        <template v-slot:prepend>
                          <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->

                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Transferencia" src="@/assets/icons_pv/formapago/transferencia35.png">
                          </v-avatar>
                        </template>
                      </AutoNumericNuevoWithOptions>

                      <div
                      v-show="boolModoEstacion()==true">

                     <AutoNumericNuevoWithOptions id="formdisabledInput"
                                                     v-model.number="Facturasventa.valorbonogas"
                                                     :disabled="activaConduceCredito == true || this.SoloCxc==true"
                                                     :label="`Bono Gas:`" :rules="[$rules.Numericc]"
                                                     autocomplete="off"
                                                     class="mt-1"
                                                     dense hide-details
                                                     outlined style="font-size: 13px;"
                                                     v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                     @blur="BlurPuntos" @input="calculostotales"
                                                     @keydown.enter="enterBonogas">
                          <template v-slot:prepend>
                            <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->

                            <v-avatar color="transparent" size="30" tile>
                              <img alt="puntos" src="@/assets/icons_pv/formapago/BonoGas35.png">
                            </v-avatar>
                          </template>
                        </AutoNumericNuevoWithOptions>


<AutoNumericNuevoWithOptions id="formdisabledInput"
                                                     v-model.number="Facturasventa.valorTraspaso"
                                                     :disabled="activaConduceCredito == true || this.SoloCxc==true"
                                                     :label="`Traspaso:`" :rules="[$rules.Numericc]"
                                                     autocomplete="off"
                                                     class="mt-1"
                                                     dense hide-details
                                                     outlined style="font-size: 13px;"
                                                     v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                     @blur="BlurPuntos" @input="calculostotales"
                                                     @keydown.enter="enterTraspaso">
                          <template v-slot:prepend>
                            <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->

                            <v-avatar color="transparent" size="30" tile>
                              <img alt="puntos" src="@/assets/icons_pv/formapago/traspaso35.png">
                            </v-avatar>
                          </template>
                        </AutoNumericNuevoWithOptions>


                      </div>

                    </v-col>

                    <!-- fn columna 1 -->

                    <!--  columna 2  -->
                    <v-col v-show="PanelFormaPagoColmna2" cols="12" md="6" sm="6">

                      <!-- @blur="ActualizarProductPago" -->
                      <AutoNumericNuevoWithOptions id="formdisabledInput" ref="RefTextFieldForPagoCxc"
                                                   v-model.number="Facturasventa.cxc"
                                                   :disabled="activaConduceCredito == true" :rules="[$rules.Numericc]"
                                                   autocomplete="off" class="mt-1" dense
                                                   hide-details label="Crédito (cxc):"
                                                   outlined
                                                   style="font-size: 13px;"
                                                   v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                   @blur="BlurCxcPago" @focus="condicionByPago"
                                                   @input="calculostotales"
                                                   @keydown.enter="enterCxc">
                        <template v-slot:prepend>
                          <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->
                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Crédito" src="@/assets/icons_pv/formapago/credito35.png">
                          </v-avatar>
                        </template>
                      </AutoNumericNuevoWithOptions>
                      <AutoNumericNuevoWithOptions v-show="false" v-model.number="Facturasventa.cupones"
                                                   :rules="[$rules.Numericc]" autocomplete="off" class="mt-1"
                                                   dense
                                                   hide-details label="Cupones:"
                                                   outlined
                                                   style="font-size: 13px;"
                                                   v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                   @blur="BlurCuponesPago"
                                                   @input="calculostotales"
                                                   @keydown.enter="enterCupones">
                        <template v-slot:prepend>
                          <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->
                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Cupones" src="@/assets/icons_pv/formapago/cupones35.png">
                          </v-avatar>
                        </template>
                      </AutoNumericNuevoWithOptions>
                      <AutoNumericNuevoWithOptions id="formdisabledInput" v-model.number="Facturasventa.valorConduce"
                                                   :disabled="this.SoloCxc==true" :rules="[$rules.Numericc]"
                                                   autocomplete="off"
                                                   class="mt-1" dense
                                                   hide-details
                                                   label="Conduce:" outlined style="font-size: 13px;"
                                                   v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                   @blur="BlurConducePago" @input="calculostotales"
                                                   @keydown.enter="enterConduce">
                        <template v-slot:prepend>
                          <!-- <i style="font-size: 20px;" class="fa fa-money"></i>  color="transparent"-->
                          <v-avatar size="30" tile @click="btnActivaInactivaConduceCredito">
                            <img v-if="activaConduceCredito == true"
                                 alt="conduce" src="@/assets/icons_pv/formapago/conduce35activo2.png">
                            <img v-if="activaConduceCredito == false" alt="conduce"
                                 src="@/assets/icons_pv/formapago/conduce.png">

                          </v-avatar>

                        </template>
                      </AutoNumericNuevoWithOptions>

                      <AutoNumericNuevoWithOptions id="formdisabledInput"
                                                   v-model.number="Facturasventa.valorNc"
                                                   :disabled="activaConduceCredito == true || this.SoloCxc==true"
                                                   :rules="[$rules.Numericc]" autocomplete="off" class="mt-1" dense
                                                   hide-details
                                                   label="Nota de crédito:" outlined
                                                   style="font-size: 13px;"
                                                   v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                   @blur="BlurNotaCreditoPago"
                                                   @focus="OpenPanelFormaPagoNotacredito"
                                                   @input="calculostotales" v-on:blur="BlurValorNcPago"
                                                   @keydown.enter="enterNC">
                        <template v-slot:prepend>
                          <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->
                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Nota de crédito" src="@/assets/icons_pv/formapago/notacredito35.png">
                          </v-avatar>
                        </template>
                      </AutoNumericNuevoWithOptions>

                      <div
                        v-show=" $store.getters.GetConfiguracionGeneral.configPv.modalidadClientePreferencial==true && clienteFactura!= null && clienteFactura.hasOwnProperty('codigo') && clienteFactura.balancePuntos>0">
                        <AutoNumericNuevoWithOptions id="formdisabledInput"
                                                     v-model.number="Facturasventa.puntos"
                                                     :disabled="activaConduceCredito == true || this.SoloCxc==true"
                                                     :label="`Puntos:`" :rules="[$rules.Numericc]"
                                                     :suffix="`${getNombreClienteSelectGlobal(clienteFactura)}`"
                                                     autocomplete="off"
                                                     class="mt-1"
                                                     dense hide-details
                                                     outlined style="font-size: 13px;"
                                                     v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                     @blur="BlurPuntos" @input="calculostotales"
                                                     @keydown.enter="enterPunto">
                          <template v-slot:prepend>
                            <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->

                            <v-avatar color="transparent" size="30" tile>
                              <img alt="puntos" src="@/assets/icons_pv/formapago/puntos2-35.png">
                            </v-avatar>
                          </template>
                        </AutoNumericNuevoWithOptions>
                      </div>
                      <div v-show="boolModoEstacion()==true">

                      <AutoNumericNuevoWithOptions id="formdisabledInput"
                                                     v-model.number="Facturasventa.valorasignacion"
                                                     :disabled="activaConduceCredito == true || this.SoloCxc==true"
                                                     :label="`Asignaciones:`" :rules="[$rules.Numericc]"
                                                     autocomplete="off"
                                                     class="mt-1"
                                                     dense hide-details
                                                     outlined style="font-size: 13px;"
                                                     v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                     @blur="BlurPuntos" @input="calculostotales"
                                                     @keydown.enter="enterAsignaciones">
                          <template v-slot:prepend>
                            <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->

                            <v-avatar color="transparent" size="30" tile>
                              <img alt="puntos" src="@/assets/icons_pv/formapago/asignacion35.png">
                            </v-avatar>
                          </template>
                        </AutoNumericNuevoWithOptions>

                              <AutoNumericNuevoWithOptions id="formdisabledInput"
                                                     v-model.number="Facturasventa.valorPruebaMetro"
                                                     :disabled="activaConduceCredito == true || this.SoloCxc==true"
                                                     :label="`Prueba Metros:`" :rules="[$rules.Numericc]"
                                                     autocomplete="off"
                                                     class="mt-1"
                                                     dense hide-details
                                                     outlined style="font-size: 13px;"
                                                     v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                     @blur="BlurPuntos" @input="calculostotales"
                                                     @keydown.enter="enterPruebaMetro">
                          <template v-slot:prepend>
                            <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->

                            <v-avatar color="transparent" size="30" tile>
                              <img alt="puntos" src="@/assets/icons_pv/formapago/BonoGas35.png">
                            </v-avatar>
                          </template>
                        </AutoNumericNuevoWithOptions>


                        <AutoNumericNuevoWithOptions id="formdisabledInput"
                                                     v-model.number="Facturasventa.valordonacion"
                                                     :disabled="activaConduceCredito == true || this.SoloCxc==true"
                                                     :label="`Donaciones:`" :rules="[$rules.Numericc]"
                                                     autocomplete="off"
                                                     class="mt-1"
                                                     dense hide-details
                                                     outlined style="font-size: 13px;"
                                                     v-bind:options="{ 'decimalPlaces': getDecimalPlaces()}"
                                                     @blur="BlurPuntos" @input="calculostotales"
                                                     @keydown.enter="enterDonacion">
                          <template v-slot:prepend>
                            <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->

                            <v-avatar color="transparent" size="30" tile>
                              <img alt="puntos" src="@/assets/icons_pv/formapago/donacion2-35.png">
                            </v-avatar>
                          </template>
                        </AutoNumericNuevoWithOptions>


                      </div>

                    </v-col>

                    <!-- columna 2- Opcion 2 Tarjeta -->
                    <v-col v-show="PanelFormaPagoTarjeta" cols="12" md="6" sm="6" style="border: 1px dashed  #616161;">

                      <v-form ref="formTarjetaFormPago" v-model="valid" lazy-validation translate="no" class="notranslate">

                        <v-row>
                          <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6" style="background-color:#dd4b39;">
                            <span :class="`d-flex justify-center white--text`"><b>Tarjeta</b></span>
                          </v-col>
                          <v-col class="pa-0 ma-0 py-0 my-0 d-flex justify-end" cols="6"
                                 md="6"
                                 sm="6" style="background-color:#dd4b39;">
                            <v-btn color="grey darken-4" fab x-small
                                   @click="PanelFormaPagoTarjeta = false, PanelFormaPagoColmna2 = true">
                              <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
                            </v-btn>
                          </v-col>
                        </v-row>

                        <v-text-field v-model="Facturasventa.numtar" :rules="[$rules.required]" autocomplete="off"
                                      class="mt-2" dense hide-details label="Número Tarjeta:" outlined required
                                      style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-credit-card" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>

                        <v-combobox v-model="tipoTarjeta" :items="RTipoTarjeta" :rules="[$rules.required]"
                                    autocomplete="off" class="mt-2"
                                    dense hide-details item-text="nombre"
                                    label="Tipo de Tarjeta"
                                    outlined @blur="SelctCbTipoTarjeta(false)" @focus="cargarTipoTarjeta">

                          <template v-slot:prepend>
                            <i class="fa fa-credit-card" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                      </v-form>

                    </v-col>
                    <!-- fn columna 2- Opcion 2 Tarjeta  -->

                    <!-- columna 2- Opcion 2 cheque -->
                    <v-col v-show="PanelFormaPagoCheque" cols="12" md="6" sm="6" style="border: 1px dashed  #616161;">
                      <v-row>
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6" style="background-color:#dd4b39;">
                          <span :class="`d-flex justify-center white--text`"><b>{{ NombreFormaPagoCheqTras }}</b></span>
                        </v-col>
                        <v-col class="pa-0 ma-0 py-0 my-0 d-flex justify-end" cols="6" md="6"
                               sm="6" style="background-color:#dd4b39;">
                          <v-btn color="grey darken-4" fab x-small
                                 @click="PanelFormaPagoCheque = false, PanelFormaPagoColmna2 = true">
                            <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
                          </v-btn>
                        </v-col>
                      </v-row>

                      <v-text-field v-model="Facturasventa.numeroCheque" :label="'Número ' + NombreFormaPagoCheqTras"
                                    :rules="[$rules.required]" autocomplete="off"
                                    class="mt-2"
                                    dense hide-details outlined required style="font-size:13px;">
                        <template v-slot:prepend>
                          <i class="fa fa-wpforms" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-combobox v-model="bancoCheque" :items="RBanco" :rules="[$rules.required]" autocomplete="off"
                                  class="mt-2" dense
                                  hide-details item-text="nombre" label="Banco"
                                  outlined
                                  @blur="SelctCbBanco" @focus="cargarBanco">
                        <template v-slot:prepend>
                          <i class="fa fa-wpforms" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>


                    </v-col>
                    <!-- fn columna 2- Opcion 2 Cheque  -->


                    <!-- fn columna 2  -->

                  </v-row>
                </v-card>
                <!--  fn Panel-forma de pago pv-->
              </center>
            </v-col>
            <!-- fn columna  -->
            <center>

              <v-tooltip dense top>
                <template v-slot:activator="{ on }">
                  <h1 block style="border: 2px solid #757575;" v-on="on">
                    <span v-if="devuelta < 0"
                          class="red--text">Devuelta: $ ({{ currencyFormatter2(getTasaMonedaSelect(devuelta) * (-1)) }}
                      )</span>
                    <span v-if="devuelta == 0">Devuelta: $ 0.00</span>
                    <span v-if="devuelta > 0"
                          class="green--text">Devuelta: $ {{ currencyFormatter2(getTasaMonedaSelect(devuelta)) }}</span>
                  </h1>
                </template>
                <b><span> <strong style="  background-color:black; font-size:14px;">Letra Negro:</strong> no contiene
                    devuelta ni faltante,
                    <strong style="  background-color:red; font-size:14px;">Letra Rojo:</strong> contiene faltante,
                    <strong style="  background-color:green; font-size:14px;">Letra Verde:</strong> contiene
                    devuelta.</span></b>

              </v-tooltip>
              <!-- Btn-Cobrar -->
              <v-hover v-slot:default="{ hover }" close-delay="200">

                <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'green darken-3' : 'green'"
                       :disabled="!ejecucion || pvGuardandoFactura || PanelMenuOpcionMonedaFactura" :elevation="hover ? 24 : 2"
                       :loading="!ejecucion || pvGuardandoFactura" :outlined="hover ? false : true"
                       block dark
                       @click.prevent="realizarCobro">

                  <h2>Cobrar</h2>
                  <template v-slot:loader>
                          <span class="custom-loader">
                            <i class="fa fa-refresh" light style="font-size: 28px; color:#424242;"> </i>

                            <!-- <v-icon light>cached</v-icon> -->
                          </span>
                  </template>
                </v-btn>
              </v-hover>
              <br></br>
              <!-- fn Btn-Cobrar -->
            </center>
          </div>
          <!--------------------- fn Panel 2 Completo Menu opcion , forma de pago y otros  ------------------------------->

          <!--------------------- panel-Informacion y edicion de producto ------------------------------->
          <div v-show="PanelInfProduct">
            <div v-if="PanelInfProduct" v-dirkeydown="finalizarPanelInformaciónProductoEsc"></div>
            <!-- <div style="max-height:345px;" class="overflow-x-auto"></div> -->
            <v-toolbar color="#dd4b39" dark dense>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Información de
                    producto
                  </v-toolbar-title>
                </template>
                <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Información de producto:
                  </span> Modificar Cantidad, Precio, Descuento, Recargo</i>

              </v-tooltip>

              <v-spacer></v-spacer>

              <v-card-actions>
                <v-btn-toggle>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn id="boton-mini" color="orange" dark small @click="cancelarInfProducto()" v-on="on">
                        <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                        CANCELAR
                      </v-btn>
                    </template>
                    <span>CANCELAR: No Agregar producto a la lista y retornar atrás</span>
                  </v-tooltip>

                  <v-tooltip v-if="this.EditProdCompa == true" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn id="boton-mini"
                             :disabled="validarBusProductoBarraReferencia($refs.RefTextFieldProducto.value)==true"
                             color="red lighten-2" dark small @click="eliminarInfProductoCompra()"
                             v-on="on">
                        <i class="fa fa-trash-o" style="font-size: 20px;"> </i>
                        ELIMINAR
                      </v-btn>
                    </template>
                    <span>ELIMINAR: Remueve producto de la lista de compra y retornar atrás</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <!-- ValidarProductoOpcionVer(productoSeleccionado) -->
                      <v-btn id="boton-mini"
                             :disabled="validarBusProductoBarraReferencia($refs.RefTextFieldProducto.value)==true"
                             color="light-blue darken-4"
                             dark
                             small v-on="on" @click.prevent="EjecutarPermisoPv=false,SalvarProductoCompraEnter()">
                        <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                        SALVAR
                      </v-btn>
                    </template>
                    <span>SALVAR: Agregar producto a la lista</span>
                  </v-tooltip>

                </v-btn-toggle>

              </v-card-actions>

              <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
            </v-toolbar>


            <!-- columna informacion producto -->
            <v-col cols="12" md="12" sm="12">
              <v-container>
                <v-card color="grey lighten-3">
                  <b :class="`d-flex justify-center`"> EDITAR PRODUCTO</b>
                  <v-form ref="formCampProdc" v-model="valid" lazy-validation translate="no" class="notranslate">
                    <!-- Row 1 edicion producto      ------------------------------------------->

                    <v-row>
                      <v-col cols="12" md="4" sm="4">
                        <AutoNumericNuevoWithOptions id="formdisabledInput" ref="RefTextFieldProductoCantidad"
                                        v-model.number="productoSeleccionado.cantidad"
                                        :disabled="validarBusProductoBarraReferencia(searchProducto)==true"
                                        :rules="[$rules.NumNocero]"
                                        autocomplete="off" dense
                                        label="Cantidad" outlined
                                        style="font-size:13px;"
                                        v-bind:options="{ 'decimalPlaces': getDecimalPlacesCantProd()}"
                                        @blur="ValidaRecetaProduControlado" @focus="FocusProductoCantidad"
                                        v-on:blur="verficardatos"
                                        @keydown.enter="SalvarProductoCompraEnter">
                          <template v-slot:prepend>
                            <i class="fa fa-usd" style="font-size: 20px;"></i>
                          </template>
                        </AutoNumericNuevoWithOptions>
                      </v-col>
                      <!--  -->
                      <v-col cols="12" md="4" sm="4">
                        <div style="display:none;">{{ getRulesProductoPrecio() }}</div>
                        <VueAutonumeric id="formdisabledInput" ref="RefTextFieldProductoPrecio"
                                        v-model.number="productoSeleccionado.precio"
                                        :disabled="validarBusProductoBarraReferencia(searchProducto)==true"
                                        :rules="boolRuleprodprecio===false?[$rules.required]:[$rules.Numericc]"
                                        autocomplete="off" dense
                                        label="Precio"
                                        outlined style="font-size:13px;"
                                        @blur="blurPrecioProductoSelecc"
                                        @focus="FocusProductoPrecio" v-on:blur="verficardatos"
                                        @keydown.enter.prevent="enterPrecioProdSelect">
                          <template v-slot:prepend>
                            <i class="fa fa-usd" style="font-size: 20px;"></i>
                          </template>
                        </VueAutonumeric>
                      </v-col>


                      <v-col
                        v-show="$store.getters.GetConfiguracionGeneral.configPv.pedirCobertura == true && clienteFactura != null"
                        cols="12" md="4" sm="4">
                        <VueAutonumeric id="formdisabledInput" v-model.number="productoSeleccionado.cobertura"
                                        :rules="[$rules.Numericc]" autocomplete="off"
                                        dense
                                        label="Cobertura" outlined
                                        style="font-size:13px;"
                                        @keydown.enter="SalvarProductoCompraEnter">
                                      <template v-slot:prepend>
                                      <i v-if="productoSeleccionado.cobValorPorc == true" class="fa fa-usd"
                                      style="font-size: 20px;"></i>
                                      <i v-if="productoSeleccionado.cobValorPorc == false" class="fa fa-percent" style="font-size: 20px;"></i>
                                      </template>
                                      <template v-slot:append-outer>
                                      <v-radio-group v-model="productoSeleccionado.cobValorPorc" column dense style="margin-top: -18%;">
                                          <v-radio class="pa-0 ma-0 py-0 my-0" :value="true" color="teal lighten-2" label="Valor">
                                            <template v-slot:label>
                                              <strong style="color: #000000; font-size: 10px">VALOR</strong>
                                             </template>
                                          </v-radio>
                                          <v-radio class="pa-0 ma-0 py-0 my-0"  :value="false" color="teal lighten-2" label="Porciento">
                                             <template v-slot:label>
                                              <strong style="color: #000000; font-size: 10px">PORCIENTO</strong>
                                             </template>
                                          </v-radio>
                                    
                                        </v-radio-group>
                                      </template>
                                  </VueAutonumeric>


                      </v-col>
                    </v-row>
                    <!-- Row 2 edicion producto ------------------------------------------->

                    <v-row style="margin-top:-28px;">
                      <!--:suffix="clientTel"-->
                      <v-col cols="12" md="12" sm="12">
                        <v-text-field id="formdisabledInput" v-model="productoSeleccionado.descripcion"
                                      :disabled="!pedirNombre" autocomplete="off"
                                      dense label="* Descripción producto:"
                                      outlined
                                      style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-font" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>


                        <v-combobox ref="RefTextFieldProductoVendedor" v-model="productoSeleccionado.vendedor"
                                    :items="RVendedor" autocomplete="off" dense
                                    item-text="nombre" label="Vendedor:" outlined
                                    style="font-size: 13px;" @blur="SelctCbVendedorProducto"
                                    @focus="cargarVendedorProducto"
                                    @keyup="CbFilVendedorProducto" @keydown.enter="SalvarProductoCompraEnter">
                          <template v-slot:prepend>
                            <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                      </v-col>


                    </v-row>
                    <!-- Row 3 edicion producto ------------------------------------------->
                    <v-row style="margin-top:-28px;">

                      <v-col cols="12" md="6" sm="6">
                        <VueAutonumeric id="formdisabledInput" ref="RefTextFieldProductoDescuento"
                                        v-model.number="productoSeleccionado.descuentoKeys"
                                        :disabled="validarBusProductoBarraReferencia(searchProducto)==true"
                                        :rules="[$rules.Numericc]" autocomplete="off"
                                        dense
                                        label="Descuento" outlined
                                        style="font-size:13px;" @blur="verficardatos"
                                        @focus="FocusProductoDescuento"
                                        @keydown.enter="SalvarProductoCompraEnter">
                          <template v-slot:prepend>
                            <i v-if="productoSeleccionado.ValorPorc == true" class="fa fa-usd"
                               style="font-size: 20px;"></i>
                            <i v-if="productoSeleccionado.ValorPorc == false" class="fa fa-percent"
                               style="font-size: 20px;"></i>
                          </template>

                          <template v-slot:append-outer>

                            <v-radio-group v-model="productoSeleccionado.ValorPorc" column dense
                                           style="margin-top: -18%;" @change="ChangeProductoselectValorPorcc" v-on:change="verficardatos">
                              <v-radio  class="pa-0 ma-0 py-0 my-0" :value="true" color="teal lighten-2" label="Valor">
                                        <template v-slot:label>
                                              <strong style="color: #000000; font-size: 10px">VALOR</strong>
                                             </template>
                              </v-radio>
                              <v-radio  class="pa-0 ma-0 py-0 my-0" :value="false" color="teal lighten-2" label="Porciento">
                                  <template v-slot:label>
                                     <strong style="color: #000000; font-size: 10px">PORCIENTO</strong>
                                  </template>
                              </v-radio>
                            </v-radio-group>

                          </template>
                        </VueAutonumeric>
                      </v-col>


                      <v-col cols="12" md="6" sm="6">
                        <VueAutonumeric id="formdisabledInput" ref="RefTextFieldProductoRecargo"
                                        v-model.number="productoSeleccionado.recargo"
                                        :disabled="validarBusProductoBarraReferencia(searchProducto)==true"
                                        :rules="[$rules.Numericc]" autocomplete="off"
                                        dense
                                        label="Recargo" outlined
                                        style="font-size:13px;"
                                        @focus="FocusProductoRecargo"
                                        v-on:blur="verficardatos"
                                        @keydown.enter="SalvarProductoCompraEnter">
                          <template v-slot:prepend>
                            <i v-if="productoSeleccionado.ValorPorcRecarg == true" class="fa fa-usd"
                               style="font-size: 20px;"></i>
                            <i v-if="productoSeleccionado.ValorPorcRecarg == false" class="fa fa-percent"
                               style="font-size: 20px;"></i>
                          </template>

                          <template v-slot:append-outer>
                            <v-radio-group v-model="productoSeleccionado.ValorPorcRecarg" column dense
                                           style="margin-top: -18%;" @change="ChangeProductoselectValorPorcc"
                                           v-on:change="verficardatos">
                              <v-radio class="pa-0 ma-0 py-0 my-0" :value="true" color="teal lighten-2" label="Valor">
                                  <template v-slot:label>
                                    <strong style="color: #000000; font-size: 10px">VALOR</strong>
                                   </template>
                              </v-radio>
                              <v-radio class="pa-0 ma-0 py-0 my-0" :value="false" color="teal lighten-2" label="Porciento">
                                  <template v-slot:label>
                                    <strong style="color: #000000; font-size: 10px">PORCIENTO</strong>
                                  </template>
                              </v-radio>
                            </v-radio-group>
                          </template>
                        </VueAutonumeric>


                      </v-col>
                    </v-row>

                    <!-- Row 4 edicion producto ------------------------------------------->
                    <v-row style="margin-top:-28px;">

                      <v-col cols="12" md="12" sm="12">
                        <div class="overflow-x-auto" style="max-height:385px;">
                          <!------------------------------------------ Descripcion adicional -->
                          <v-textarea v-if="productoSeleccionado.productos!=null" id="formdisabledInput"
                                      v-model="productoSeleccionado.productos.descripcionAdicional" auto-grow
                                      autocomplete="off"
                                      dense
                                      disabled label="Descripción Adicional:" outlined rows="1">
                            <template v-slot:prepend>
                              <i class="fa fa-commenting" style="font-size: 20px;"></i>
                            </template>
                          </v-textarea>
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card>

                <!-- Productos sustitutos -->
                <v-card v-if="ListProductoSustitutos.length > 0" style="border: 1px solid  #616161;">
                  <v-data-table :footer-props="arrayPropiedases" :headers="[
                    { text: 'PRODUCTO SUSTITUTO', value: 'prosust', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'EXISTENCIA', value: 'existencias', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'ACCIONES', value: 'agregar', sortable: false, class: ['no-gutters black--text'] },
                  ]" :items="ListProductoSustitutos" :items-per-page="15" dense item-key="indx">
                    <template v-slot:item.agregar="props">
                      <v-btn color="light-blue darken-4" small
                             @click.prevent="BuscPropiedadProductoSelct(props.item, 'add')"><i class="fa fa-plus"
                                                                                               style="font-size: 20px;"></i>
                      </v-btn>
                      <v-btn color="grey" small @click.prevent="BuscPropiedadProductoSelct(props.item, 'ver')">
                        <i class="fa fa-eye" style="font-size: 20px;"></i>
                      </v-btn>
                    </template>

                    <template v-slot:item.prosust="props">
                      <span style="display:none;">{{
                          props.item.indx = ListProductoSustitutos.indexOf(props.item)
                        }}</span>
                      <span style="font-size:13px;">{{ props.item.productos.descripcion }}</span>
                    </template>

                  </v-data-table>
                </v-card>
                <!-- fn Producto sustitutos-->
              </v-container>
            </v-col>
            <!-- columna informacion producto -->
          </div>
          <!--------------------- fn Informacion y edicion de producto ------------------------------->


        </div>
      </v-col>
      <!-- fn  columna general 2 -->
    </v-row>


    <!-- modales ---------------------------->

    <v-snackbar v-model="aalert.estado" :color="aalert.color" :right="aalert.right" :timeout="aalert.timeout"
                :top="aalert.top" :vertical="true" style="margin-top: 20%;">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>


    <!-- ------------------------------------------------------Modal Modal-Crear Producto -->
    <v-dialog v-model="dialogCrearProduct" label="Modal Crear producto" max-height="85%" max-width="95%"
              persistent transition="fab-transition">

      <!--------------------- Creacion de producto ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Crear Producto
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Crear Producto: </span> Creación de
              productos</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="cancelarCrearProducto()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar y no Crear el producto</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="SalvarCrearProducto()"
                         v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Aceptar y crear el producto </span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
        <v-card>
          <!-- columna informacion producto -->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> CREAR PRODUCTO</b>
                <v-form ref="formCrearProduct" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <!-- Row 1 edicion producto      ------------------------------------------->

                  <v-row>

                    <v-col cols="12" md="12" sm="12">

                      <v-text-field v-model="unidadesProductos.productos.descripcion" :rules="[$rules.required]"
                                    autocomplete="off" dense label="Nombre:" outlined required>
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <VueAutonumeric v-model.number="unidadesProductos.precio" :rules="[$rules.required]"
                                      autocomplete="off" dense label="Precio"
                                      outlined style="font-size:13px;">
                        <template v-slot:prepend>
                          <i class="fa fa-usd" style="font-size: 20px;"></i>
                        </template>
                      </VueAutonumeric>

                      <VueAutonumeric v-model.number="unidadesProductos.costo" :rules="[$rules.required]"
                                      autocomplete="off" dense label="Costo"
                                      outlined style="font-size:13px;">
                        <template v-slot:prepend>
                          <i class="fa fa-usd" style="font-size: 20px;"></i>
                        </template>
                      </VueAutonumeric>


                      <v-combobox v-model="unidadesProductos.productos.impuesto" :items="RImpuesto" autocomplete="off"
                                  dense item-text="descripcion"
                                  label="Impuesto:" outlined
                                  style="font-size: 13px;"
                                  @blur="SelctCbImpuestoProducto" @focus="cargarImpuestoProducto">
                        <template v-slot:prepend>
                          <i class="fa fa-percent" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>
                    </v-col>

                  </v-row>
                  <!-- Row 2 edicion producto ------------------------------------------->


                </v-form>
              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion producto -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Crear producto-->

    <!-------------------------------------------------------- Modal- Modal-Ver y Asignar mensajero -->
    <v-dialog v-model="dialogMensajero" fullscreen hide-overlay label="Modal Crear ver y asignar" persistent
              transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Seleccionar y Ver
                Mensajero
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Seleccionar y Ver Mensajero:
              </span> muestra y asigna las facturas a domicilio al mensajero</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="CancelarVerAsignarMensajero" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Cancela y retornar atrás</span>
              </v-tooltip>


              <!-- <v-tooltip bottom>
    <template v-slot:activator="{ on }">
       <v-btn id="boton-mini" v-on="on" @click="NewMensagero" color="grey"  small dark>

        <v-avatar tile  size="28" color="transparent"  >
          <img
            src="@/assets/icons_pv/extras/limpiarPantalla.png"
            alt="Limpiar"
          >
        </v-avatar>


        <i style="font-size: 20px;" > </i>
        NUEVO </v-btn>
     </template>
              <span>NUEVO: Limpia los campo para un nuevo registro</span>
      </v-tooltip> -->


              <!-- <v-tooltip bottom v-if="VerFacturaDomicilioMensajero==true" >
    <template v-slot:activator="{ on }">
    <v-btn id="boton-mini"  v-on="on" @click="SalvarAsignarMensagero" color="light-blue darken-4" small   dark
    :disabled="FacturaDomicilioMensajero.ComentarioLeido==false"

    >
    <i style="font-size: 20px;" class="fa fa-plus"></i>
    SALVAR</v-btn>
     </template>
              <span>SALVAR: Guarda las facturas recibida y retornar atrás </span>
      </v-tooltip> -->
              <!-- fab x-small dark  -->


              <v-tooltip v-if="dialogAsignarMensajeros == true" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="SalvarAsignarMensagero"
                         v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Guarda las facturas asignadas y retornar atrás </span>
              </v-tooltip>


              <v-tooltip
                v-if="this.$store.getters.GetConfiguracionGeneral.configPv.imprimirlistamensajeros && dialogFacturasRutasMensajeros == true && buscarMensajero!=null && buscarMensajero.hasOwnProperty('nombre')  "
                bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="blue" dark small @click="imprmirFacturaRutaMensagero" v-on="on">
                    <i class="fa fa-print" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    IMPRIMIR
                  </v-btn>
                </template>
                <span>IMPRIMIR: Imprimir facturas en ruta </span>
              </v-tooltip>


              <v-tooltip
                v-if="dialogCambiarMensajeros == true  && selectedCambiarMensajeros.length>0 && buscarMensajero!=null && buscarMensajero.hasOwnProperty('nombre') "
                bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small
                         @click="cambiarMensajeroSelecionado" v-on="on">
                    <i class="fa fa-retweet" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    CAMBIAR
                  </v-btn>
                </template>
                <span>CAMBIAR: cambia el mensajero seleccionado a la factura seleccionada </span>
              </v-tooltip>


              <!-- <v-tooltip bottom v-if="VerFacturaDomicilioMensajero==true" >
    <template v-slot:activator="{ on }">
    <v-btn id="boton-mini"  v-on="on" @click="SalvarAsignarMensagero" color="light-blue darken-4" small   dark
    :disabled="FacturaDomicilioMensajero.ComentarioLeido==false"

    >
    <i style="font-size: 20px;" class="fa fa-plus"></i>
    SALVAR</v-btn>
     </template>
              <span>SALVAR: Guarda las facturas recibida y retornar atrás </span>
      </v-tooltip> -->


              <!-- FacturaDomicilioMensajero.ComentarioLeido,VerFacturaDomicilioMensajero==true -->


              <div v-if="VerFacturaDomicilioMensajero == true">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn id="boton-mini" :disabled="!FacturaDomicilioMensajero.ComentarioLeido"
                           color="purple accent-4" dark small @click="salvarNoEntregado"
                           v-on="on">
                      <i class="fa fa-ban" style="font-size: 20px;"></i>
                      NO ENTREGADA
                    </v-btn>
                  </template>
                  <span>NO ENTREGADA: No se entrego las factura al cliente </span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn id="boton-mini" :disabled="!FacturaDomicilioMensajero.ComentarioLeido"
                           color="light-blue darken-4" dark small @click="slvarEntregado"
                           v-on="on">
                      <i class="fa fa-check-circle-o" style="font-size: 20px;"></i>
                      ENTREGADA
                    </v-btn>
                  </template>
                  <span>ENTREGADA: Se entrego las factura al cliente </span>
                </v-tooltip>
              </div>


            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>

        <v-col cols="12" md="12" sm="12">
          <v-row>
            <!--------- columna 1 Crear/editar ---------->
            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="4" sm="4" style="border: 1px solid #000000;">
              <!-- 285 id="divSelecProd"   v-bind:style="{  'max-height':this.windowSize.height-400+'px','border': '2px solid #000000' }" class="overflow-x-auto"  -->
              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                <span :class="`d-flex justify-center white--text`"><b>Ver y Seleccionar mensajero</b></span>
              </v-col>

              <v-col cols="12" md="12" sm="12">

                <v-tooltip top>
                  <template v-slot:activator="{ on }">

                    <v-combobox ref="RefTextFieldBuscaCliente" v-model="buscarMensajero" :items="Rmensajero"
                                :rules="[$rules.required]"
                                autocomplete="off" background-color="white" color="grey darken-4" dense hide-details
                                item-text="nombre" label="Buscar Mensajero:" outlined
                                style="font-size: 13px;"
                                @blur="SelctCbBuscarMensajero" @change="getChangeBuscarMensajero"
                                @focus="cargarBuscarMensajero" v-on="on" @keyup.enter="SeleccionarClienteFactura">
                      <template v-slot:prepend-inner>
                        <i class="fa fa-search" style="font-size: 25px;"></i>
                      </template>
                      <!-- margin-top="50px"style="font-size: 14px;" -->
                      <template slot="item" slot-scope="item">
                        <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12"
                               md="12"
                               sm="12" style="border: 1px solid #000000; font-size: 13px; ">
                          <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>NOMBRE:
                            {{ item.item.nombre }}</b></p>

                          <span class="pa-0 ma-0 py-0 my-0">
                            <span style="border: 1px dashed  #616161;"><b>TEL.: </b>{{ item.item.telefono }} </span>
                            <span style="border: 1px dashed  #616161;"><b>CED: </b> {{ item.item.cedula }}</span>
                          </span>
                          <p v-if="item.item.sucursal!=null && item.item.sucursal.hasOwnProperty('codigo')" class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>SUCURSAL: </b>
                            {{ item.item.sucursal.descripcion }} 
                            </p>
                            <p v-if="item.item.sucursal==null || item.item.sucursal!=null && !item.item.sucursal.hasOwnProperty('codigo')" class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>SUCURSAL: </b>
                            N/A
                            </p>
                          <!-- <span style="border: 1px dashed  #616161;" v-if="item.item.hasOwnProperty('ars')&&item.item.ars!=null"  ><b> ARS :{{item.item.ars.nombre}}</b></span> -->

                        </v-col>


                      </template>


                    </v-combobox>
                  </template>
                  <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                    <span> Se selecciona el mensajero.</span>
                  </i>
                </v-tooltip>

              </v-col>

              <v-form ref="formAsignarMensagero" v-model="valid" lazy-validation translate="no" class="notranslate">
                <v-row>
                  <!-- -----------------------------  Codigo -->
                  <v-col class="py-0 my-0" cols="12" md="12" sm="12">
                    <v-text-field id="formdisabledInput" v-model="MensageroSeleccionado.codigo" :disabled="true" dense
                                  hide-details label="Codigo:" outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-list-ol" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>
                  </v-col>

                  <!-- -----------------------------  Nombre -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field id="formdisabledInput" v-model="MensageroSeleccionado.nombre"
                                  :rules="[$rules.required]" autocomplete="off" dense
                                  disabled label="Nombre:" outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-font" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>

                  </v-col>
                  <!--  :rules="[$rules.required, $rules.RulesCel]"-->
                  <v-col class="py-0 my-0 " cols="12" md="12" sm="12">
                    <v-text-field v-model="MensageroSeleccionado.cedula" v-mask="'###-#######-#'" autocomplete="off"
                                  dense label="* Cédula:"
                                  maxlength="13" outlined>

                      <template v-slot:prepend>
                        <i class="fa fa-id-card-o" style="font-size: 20px;"></i>
                      </template>

                    </v-text-field>
                  </v-col>


                  <!-- ----------------------------- Télefono -->
                  <v-col class="py-0 my-0 " cols="12" md="12" sm="12">
                    <v-text-field id="formdisabledInput" v-model="MensageroSeleccionado.telefono"
                                  v-mask="'(###)###-####'" autocomplete="off" dense
                                  disabled label="Teléfono:" maxlength="13"
                                  outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-phone" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>
                  </v-col>

                  <!-- ----------------------------- Meta de Envios -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field id="formdisabledInput" v-model.number="MensageroSeleccionado.metadeenvios" dense
                                  disabled
                                  label="Meta de Envios:" outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-flag-checkered" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>

                  </v-col>

                </v-row>
              </v-form>


            </v-col>
            <!--------- fn columna 1 Ver  y Asignar---------->

            <!--------- columna 2 Ver  y Asignar ---------->
            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="8" sm="8" style="border: 1px solid #000000; ">

              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                <span v-if="dialogAsignarMensajeros == true" :class="`d-flex justify-center white--text`"><b>Facturas a
                    domicilio</b></span>
                <span v-if="dialogRecibirMensajeros == true" :class="`d-flex justify-center white--text`"><b>Facturas
                    Mensajero</b></span>
                <span v-if="dialogFacturasRutasMensajeros == true" :class="`d-flex justify-center white--text`"><b>Facturas en rutas</b></span>
                <span v-if="this.dialogCambiarMensajeros== true" :class="`d-flex justify-center white--text`"><b>Cambiar mensajero</b></span>
              </v-col>

              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">

                <div
                  class="overflow-x-auto"
                  v-bind:style="{ 'height': this.windowSize.height - 0 + 'px', 'max-height': this.windowSize.height - 0 + 'px' }">

                  <!-- tabla Facturas a domicilio  asignar mensajero -->
                  <div v-if="dialogAsignarMensajeros == true">

                    <v-row>
                      <v-col cols="12" md="5" sm="5">
                        <v-combobox v-model="filtroAsigMensajero.caja" :items="RCaja" autocomplete="off" dense
                                    hide-details
                                    item-text="descripcion"
                                    label="caja" outlined required
                                    style="font-size: 13px;"
                                    @blur="SelctCbCajaFiltAsigMensajero"
                                    @change="filterDataTableAsigMensajeroCaja(RFacturasDomicilio)" @focus="cargarCaja">
                          <template v-slot:prepend>
                            <i class="fa fa-cube" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col cols="12" md="3" sm="3">
                        <v-text-field 
                        ref="RefFilAsigMenFactTextField"
                        v-model="filtroAsigMensajero.fact" autocomplete="off" dense hide-details
                                      label="No.Fact:" outlined placeholder=" "
                                      style="font-size: 12px;"
                                     @keyup.enter="keyupEnterAsigMensajFact"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-slack" style="font-size: 18px;"></i>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="4" sm="4">
                        <v-text-field v-model="filtroAsigMensajero.sector" autocomplete="off" dense
                                      hide-details
                                      label="sector:"
                                      outlined
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                             v-bind:style="{ 'font-size': '15px;'}">
                        <span class="px-4"> <strong style="color:#000000;">Cantidad de registro seleccionado:</strong> {{
                            selectedAsignarMensajero.length
                          }}  </span>
                      </v-col>


                    </v-row>

                    <!-- Cliente, Dirección,Sector, Telefono, Devuelta, Valor factura -->
                    <v-data-table v-model="selectedAsignarMensajero" :footer-props="arrayPropiedases" :headers="[
                    { text: '#FACT.', value: 'numeroFactura', sortable: false,filter: filterDataTableAsigMensajeroFact , align: 'center', class: ['no-gutters'] },
                    { text: 'FECHA', value: 'nuevaFecha', sortable: false, align: 'center', class: ['no-gutters'] },
                    { text: 'CLIENTE', value: 'cliente', sortable: false, class: ['no-gutters'] },
                    { text: 'DIRECCIÓN', value: 'direccion', sortable: false, class: ['no-gutters'] },
                    { text: 'SECTOR', value: 'cliente.sector', sortable: false,filter: filterDataTableAsigMensajeroSecto, class: ['no-gutters'] },
                    { text: 'TELÉFONO', value: 'telefono', sortable: false, class: ['no-gutters'] },
                    { text: 'CAJA', value: 'caja', sortable: false, class: ['no-gutters'] },
                    { text: 'VALOR FACTURA', value: 'valor', sortable: false, align: 'center', class: ['no-gutters'] },
                    { text: 'DEVUELTA', value: 'devuelta', sortable: false, align: 'center', class: ['no-gutters'] },
                  ]
                  " :items="RFacturasDomicilio" :items-per-page="15" :show-select="true" :single-select="false"
                                  class="elevation-1" dense item-key="indx"
                                  @click:row="obtenerDatoSelectFactDomicilioClickRow"
                    >
                      <!-- :items="filterDataTableAsigMensajeroCaja(RFacturasDomicilio)"  -->
                      <template v-slot:item.numeroFactura="props">
                        <span style="font-size:13px;">{{ props.item.numeroFactura }}.</span>
                      </template>

                      <template v-slot:item.nuevaFecha="props">
                        <span style="font-size:13px;">{{ FormatoFecha(props.item.nuevaFecha) }}.</span>
                      </template>


                      <template v-slot:item.valor="props">
                        <span style="display:none;">{{
                            props.item.indx = RFacturasDomicilio.indexOf(props.item)
                          }}</span>
                        <span style="font-size:13px;">{{ currencyFormatter(props.item.valor) }}</span>
                      </template>

                      <template v-slot:item.cliente="props">
                      <span v-if="props.item.cliente != null" style="font-size:13px;">{{
                          props.item.cliente.nombre
                        }}</span>
                      </template>

                      <template v-slot:item.telefono="props">

                      <span v-if="props.item.cliente != null" style="font-size:13px;">{{
                          selectTelefonoCliente(props.item.cliente)
                        }}</span>
                      </template>

                      <template v-slot:item.devuelta="props">
                        <span style="font-size:13px;">{{ currencyFormatter(props.item.devuelta) }}</span>
                      </template>

                      <template v-slot:item.direccion="props">
                        <span style="font-size:13px;">{{ props.item.direccion }}</span>
                      </template>
                    </v-data-table>
                    <!-- fn tabla Facturas a domicilio  asignar mensajero -->
                  </div>
                  <!-- informacion de fatura domicilio selecionada -->
                  <v-col v-if="FacturaDomicilioMensajero != null && VerFacturaDomicilioMensajero == true"
                         class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="border: 1px solid #000000;">
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> FACTURA #: </b>
                      {{ FacturaDomicilioMensajero.facturasventaPK.secuencia }}</p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> FECHA : </b>
                      {{ FormatoFecha(FacturaDomicilioMensajero.fecha) }}</p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> NCF : </b>
                      {{ FacturaDomicilioMensajero.ncf }}</p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> CLIENTE : </b>
                      {{ FacturaDomicilioMensajero.cliente.nombre }}</p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> VALOR : </b>
                      {{ currencyFormatter(FacturaDomicilioMensajero.valor) }}</p>
                    <p v-if="FacturaDomicilioMensajero.devuelta>0" class="pa-0 ma-0 py-0 my-0"
                       style="border: 1px dashed  #616161;"><b> DEVUELTA : </b>
                      {{ currencyFormatter(FacturaDomicilioMensajero.devuelta) }}</p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> COMENTARIO : </b>
                      {{ FacturaDomicilioMensajero.comentario }}</p>

                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> FORMA DE PAGO : </b>
                      {{ TipoFacturaDomicilio(FacturaDomicilioMensajero) }}</p>

                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;">
                      <v-checkbox v-model="FacturaDomicilioMensajero.ComentarioLeido" class="mt-0" color="teal"
                                  hide-details
                                  label=""
                                  width="50">
                        <template v-slot:label>
                          <strong v-if="FacturaDomicilioMensajero.ComentarioLeido == true"
                                  style="color:#000000; font-size:13px;">Comentario Leido: Si</strong>
                          <strong v-if="FacturaDomicilioMensajero.ComentarioLeido == false"
                                  style="color:#000000; font-size:13px;">Comentario Leido: No</strong>
                        </template>
                      </v-checkbox>
                      <div class="pb-2"  v-if="verificarCambioPagoDomicilio(FacturaDomicilioMensajero)"
                           style="border: 1px dashed  #616161;">
                        <v-combobox v-model="cambioPagoDomicilio"
                          :items="RCambioPagoDomicilio" autocomplete="off"
                          class="pt-2" dense hide-details
                          item-text="descripcion"
                          label=" Cambiar forma de pago:" outlined 
                          @blur="SelctCbCambioPagoDomicilio">
                          <template v-slot:prepend>
                            <i class="fa fa-money" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                        <v-combobox v-if="cambioPagoDomicilio!=null && cambioPagoDomicilio.hasOwnProperty('codigo') && cambioPagoDomicilio.codigo==2 " v-model="cambioTipoTarjetaDomicilio" :items="RTipoTarjeta"
                                              :rules="[$rules.required]" autocomplete="off"
                                              class="mt-2"
                                              dense hide-details
                                              item-text="nombre"
                                              label="Tipo de Tarjeta" outlined
                                              @blur="SelctCbCambioTipoTarjetaDomicilio"
                                              @focus="cargarTipoTarjeta">

                                    <template v-slot:prepend>
                                      <i class="fa fa-credit-card" style="font-size: 20px;"></i>
                                    </template>
                                  </v-combobox>


                      </div>

                      <v-data-table :footer-props="arrayPropiedases" :headers="[
                        { text: 'PRODUCTO', value: 'productos.descripcion', sortable: false, class: ['no-gutters black--text'] },
                        { text: 'CANTIDAD', value: 'cantidad', sortable: false, class: ['no-gutters black--text'] },
                        { text: 'PRECIO', value: 'precio', sortable: false, class: ['no-gutters black--text'] },
                        { text: 'DESCUENTO', value: 'valordescuento', sortable: false, class: ['no-gutters black--text'] },
                        { text: 'VALOR', value: 'valor', sortable: false, class: ['no-gutters black--text'] },
                      ]" :items="FacturaDomicilioMensajero.facturasventaDetalleList" :items-per-page="15"
                                    dense>

                        <template v-slot:item.valor="props">
                          <!-- <span style="display:none;">{{ props.item.valor=(props.item.cantidad *props.item.precio) + props.item.valorimpuesto }}</span> -->
                          <!-- <span style="display:none;">{{ props.item.valor=(RedondeoBasico((props.item.cantidad *props.item.precio)-(props.item.valordescuento)))}}</span> -->

                          <span
                            style="font-size:13px;">{{
                              currencyFormatter(props.item.valor = (RedondeoBasico(DevolucionValor(props.item))))
                            }}

                          </span>
                        </template>

                        <template v-slot:item.productos.descripcion="props">
                          <span style="font-size:13px;">{{ props.item.productos.descripcion }}</span>
                        </template>

                        <template v-slot:item.cantidad="props">
                          <span style="font-size:13px;">{{ props.item.cantidad }}</span>
                        </template>

                        <template v-slot:item.precio="props">
                          <span style="font-size:13px;">{{ currencyFormatter(props.item.precio) }}</span>
                        </template>


                      </v-data-table>


                    </p>

                  </v-col>
                  <!--  fn informacion de fatura domicilio selecionada -->


                  <!--  tabla Facturas Mensajero  -->
                  <v-data-table v-if="dialogRecibirMensajeros == true && VerFacturaDomicilioMensajero == false"
                                v-model="selectedRecibirMensajeros" :headers="[
                      { text: '#FACT.', value: 'numeroFactura', sortable: false, align: 'center', class: ['no-gutters'] },
                      { text: 'FECHA', value: 'nuevaFecha', sortable: false, align: 'center', class: ['no-gutters'] },
                      { text: 'CLIENTE', value: 'cliente.nombre', sortable: false, class: ['no-gutters'] },
                      { text: 'MENSAJERO', value: 'mensajero.nombre', sortable: false, class: ['no-gutters'] },
                      { text: 'FORMA DE PAGO', value: 'formaPago', sortable: false, class: ['no-gutters'] },
                      { text: 'HORA', value: 'horaPedido', sortable: false, class: ['no-gutters'] },
                      { text: 'VALOR A ENTREGAR', value: 'valor', sortable: false, align: 'center', class: ['no-gutters'] },
                    ]
                    " :items="RRecibirMensajeros" :items-per-page="15" :show-select="true" :single-select="true"
                                class="elevation-1"
                                dense item-key="indx"
                                @item-selected="obtenerDatoSelectRecibirMensajeros"
                                @click:row="obtenerDatoSelectRecibirMensajerosClickRow">

                      <template v-slot:item.numeroFactura="props">
                        <span style="font-size:13px;">{{ props.item.numeroFactura }}</span>
                      </template>

                      <template v-slot:item.nuevaFecha="props">
                        <span style="font-size:13px;">{{ FormatoFecha(props.item.nuevaFecha) }}</span>
                      </template>
                    <template v-slot:item.valor="props">
                      <span style="display:none;">{{ props.item.indx = RRecibirMensajeros.indexOf(props.item) }}</span>
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.valor + props.item.devuelta) }}</span>
                    </template>

                    <template v-slot:item.cliente.nombre="props">
                      <span style="font-size:13px;">{{ props.item.cliente.nombre }}</span>
                    </template>

                    <template v-slot:item.formaPago="props">
                      <span style="font-size:13px;">{{ props.item.formaPago }}</span>
                    </template>

                    <template v-slot:item.mensajero.nombre="props">
                      <span style="font-size:13px;">{{ props.item.mensajero.nombre }}</span>
                    </template>

                    <template v-slot:item.devuelta="props">
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.devuelta) }}</span>
                    </template>

                    <template v-slot:item.horaPedido="props">
                      <span style="font-size:13px;">{{ HoraFormatter(props.item.horaPedido) }}</span>
                    </template>


                    <template v-if="windowSize.width > 600" v-slot:body.append>
                      <tr>
                        <td class="border-top-bottom"><strong></strong></td>
                        <td class="border-top-bottom"><strong></strong></td>
                        <td class="border-top-bottom"><strong></strong></td>
                        <td class="border-top-bottom"><strong></strong></td>
                        <td class="border-top-bottom"><strong></strong></td>
                        <td class="border-top-bottom"><strong class="d-flex justify-end"
                                                              style="font-size:15px; color: #00838F;">Total:</strong>
                        </td>
                        <td class="border-top-bottom"><strong></strong></td>
                        <td class="border-total"><strong class="d-flex justify-center"
                                                         style="font-size:15px; color: #00838F;">
                          {{ currencyFormatter(totalDomicilio.valor) }} </strong>
                        </td>
                      </tr>
                    </template>
                    <template v-if="windowSize.width <= 600" v-slot:footer>
                      <v-list-item class="white--text" style="font-size: 70%;">
                        <v-list-item-content>
                          <span>TOTAL A ENTEGAR:{{ currencyFormatter(totalDomicilio.valor) }}</span>
                        </v-list-item-content>
                      </v-list-item>

                    </template>

                  </v-data-table>
                  <!-- fn tabla Facturas Mensajero -->
                  <div v-if="dialogFacturasRutasMensajeros == true ">

                    <v-col cols="12" md="8" sm="8">
                      <v-text-field v-model="filtroFacturaRutaCliente" autocomplete="off" dense hide-details
                                    label="Nombre:" outlined placeholder=" "
                                    style="font-size: 12px;"
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-user-circle" style="font-size: 18px;"></i>
                        </template>
                      </v-text-field>

                    </v-col>
                    <!--  tabla Facturas en ruta  -->
                    <v-data-table
                      :headers="[
                      { text: 'FECHA', value: 'fecha', sortable: false, class: ['no-gutters'] },
                      { text: 'HORA', value: 'horaPedido', sortable: false, class: ['no-gutters'] },
                      { text: 'CLIENTE', value: 'cliente.nombre', sortable: false,filter: filterDataTableFacturaRutaCliente, class: ['no-gutters'] },
                      { text: 'DIRECCIÓN', value: 'direccion', sortable: false,width:450 ,class: ['no-gutters'] },
                      { text: 'MENSAJERO', value: 'mensajero.nombre', sortable: false,filter: filterDataTableFacturaRutaMensajero, class: ['no-gutters'] },
                    ]
                    " :items="RFacturasRutasMensajeros" :items-per-page="15" :single-select="true" class="elevation-1"
                      dense

                      item-key="indx">


                      <template v-slot:item.fecha="props">
                        <span style="font-size:13px;">{{ FormatoFecha(props.item.fecha) }}</span>
                      </template>

                      <template v-slot:item.horaPedido="props">
                        <!-- <span style="font-size:13px;">{{ HoraFormatter(props.item.horaPedido) }}</span> -->
                    <input id="formdisabledInput" :value="HoraFormatter2(props.item.nuevaHoraPedido)" disabled
                             style="font-size:13px;"
                             type="time" />
                      </template>

                      <template v-slot:item.cliente.nombre="props">
                        <span style="display:none;">{{
                            props.item.indx = RFacturasRutasMensajeros.indexOf(props.item)
                          }}</span>
                        <span style="font-size:13px;">{{ props.item.cliente.nombre }}</span>
                      </template>

                      <template v-slot:item.mensajero.nombre="props">
                        <span style="font-size:13px;">{{ props.item.mensajero.nombre }}</span>
                      </template>

                    </v-data-table>
                    <!-- fn tabla Facturas en ruta  -->
                  </div>


                  <!-- tabla cambiar mensajero -->

                  <div v-if="dialogCambiarMensajeros == true">

                    <v-row>
                      <v-col cols="12" md="7" sm="7">
                        <v-combobox v-model="nuevoMensajeroSelect" :items="Rmensajero" autocomplete="off"
                                    dense hide-details item-text="nombre"
                                    label="Seleccione el nuevo Mensajero" outlined required
                                    style="font-size: 13px;"
                                    @blur="SelctCbNuevoMensajero" @focus="cargarBuscarMensajero">
                          <template v-slot:prepend>
                            <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col cols="12" md="3" sm="3">
                        <v-text-field v-model="filtroAsigMensajero.fact" autocomplete="off" dense hide-details
                                      label="No.Fact:" outlined placeholder=" "
                                      style="font-size: 12px;"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-slack" style="font-size: 18px;"></i>
                          </template>
                        </v-text-field>
                      </v-col>

                    </v-row>

                    <v-data-table v-model="selectedCambiarMensajeros" :footer-props="arrayPropiedases" :headers="[
      { text: '#FACT.', value: 'numeroFactura', sortable: false,filter: filterDataTableAsigMensajeroFact , align: 'center', class: ['no-gutters'] },
      { text: 'CLIENTE', value: 'cliente', sortable: false, class: ['no-gutters'] },
      { text: 'DIRECCIÓN', value: 'direccion',width:250, sortable: false, class: ['no-gutters'] },
      { text: 'SECTOR', value: 'cliente.sector', sortable: false, class: ['no-gutters'] },
      { text: 'TELÉFONO', value: 'telefono', sortable: false, class: ['no-gutters'] },
      { text: 'VALOR FACTURA', value: 'valor', sortable: false, align: 'center', class: ['no-gutters'] },
      { text: 'DEVUELTA', value: 'devuelta', sortable: false, align: 'center', class: ['no-gutters'] },
    ]
    " :items="RRecibirMensajeros" :items-per-page="15" :show-select="true" :single-select="false"
                                  class="elevation-1" dense item-key="indx"
                                  @click:row="obtenerDatoSelectCambioMensajeroClickRow"
                    >

                      <template v-slot:item.numeroFactura="props">
                        <span style="font-size:13px;">{{ props.item.numeroFactura }}</span>
                      </template>

                      <template v-slot:item.valor="props">
                        <span style="display:none;">{{
                            props.item.indx = RRecibirMensajeros.indexOf(props.item)
                          }}</span>
                        <span style="font-size:13px;">{{ currencyFormatter(props.item.valor) }}</span>
                      </template>

                      <template v-slot:item.cliente="props">
        <span v-if="props.item.cliente != null" style="font-size:13px;">{{
            props.item.cliente.nombre
          }}</span>
                      </template>

                      <template v-slot:item.telefono="props">

        <span v-if="props.item.cliente != null" style="font-size:13px;">{{
            selectTelefonoCliente(props.item.cliente)
          }}</span>
                      </template>

                      <template v-slot:item.devuelta="props">
                        <span style="font-size:13px;">{{ currencyFormatter(props.item.devuelta) }}</span>
                      </template>

                      <template v-slot:item.direccion="props">
                        <span style="font-size:13px;">{{ props.item.direccion }}</span>
                      </template>

                    </v-data-table>
                  </div>
                  <!-- fn tabla cambiar mensajero -->


                  <!-- <v-data-table
     dense
     hide-default-footer
     hide-default-header
     :items-per-page="-1"

          item-key="indx"

     :headers="[
     {text: 'CODIGO', value: 'productos.codigo' ,sortable: false, class: ['no-gutters']},
     {text: 'PRODUCTO', value: 'productos.descripcion' ,sortable: false, class: ['no-gutters']},
     {text: 'COSTO', value: 'costo' ,sortable: false, class: ['no-gutters']},
     {text: 'PRECIO', value: 'precio' ,sortable: false, class: ['no-gutters']},
     {text: 'EXISTENCIA', value: 'existencias' ,sortable: false, align:'center', class: ['no-gutters']},
    ]
    " :items="RHistorialCompracliente" class="elevation-1">

    <template v-slot:item="props">
    <span style="display:none;">{{props.item.indx = RHistorialCompracliente.indexOf(props.item)}}</span>
     <tr >
              <td  @click.prevent="EditarProductoSelect(props.item)"  v-ripple="{ class: `indigo--text` }" >
           <span style="display:none;" v-if="!props.item.hasOwnProperty('cantidad')">{{props.item.cantidad=1}}</span>
              <v-row>
              <v-col class="pa-0 ma-0"  cols="12" md="12"><span><b>PRODUCTO: {{props.item.productos.descripcion}} </b></span></v-col>
              <v-col class="pa-0 ma-0"  cols="2" md="2"><span> {{ FormatoFecha(props.item.productos.fechaCreacion)}}</span></v-col>
              <v-col class="pa-0 ma-0"  cols="2" md="2"><span :class="`d-flex justify-center`" > {{ currencyFormatter(props.item.cantidad)}}</span></v-col>
              <v-col class="pa-0 ma-0"  cols="4" md="4"><span :class="`d-flex justify-center`" > {{ currencyFormatter(props.item.precio)}}</span></v-col>
              <v-col class="pa-0 ma-0"  cols="4" md="4"><span :class="`d-flex justify-center`" > {{ props.item.codigobarra}}</span></v-col>
             </v-row>
              </td>
    </tr>

     </template>
    </v-data-table> -->


                </div>
                <!-------------------------------------------------- fn tb Facturas domicilio-->


              </v-col>


            </v-col>
            <!--------- fn columna 2 Ver  y Asignar---------->

          </v-row>
        </v-col>
      </v-card>
    </v-dialog>
    <!--------------------------------------------------------  fn Modal- Ver  y Asignar mensajero -->


    <!-------------------------------------------------------- Modal- Modal-Crear editar cliente -->
    <v-dialog v-model="dialogCrearEditarCliente" fullscreen hide-overlay label="Modal Crear editar cliente  " persistent
              transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Crear / Editar
                Cliente
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>Crear / Editar Cliente: </span> Crea
              , Modificar cliente y muestra el historial de compra</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="CancelarCrearEditarCliente()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Cancela y retornar atrás</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="grey" dark small @click="NewclienteSeleccionado" v-on="on">

                    <v-avatar color="transparent" size="28" tile>
                      <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                    </v-avatar>


                    <i style="font-size: 20px;"> </i>
                    NUEVO
                  </v-btn>
                </template>
                <span>NUEVO: Limpia los campo para un nuevo registro</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="SalvarCrearEditarCliente"
                         v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Crea o edita cliente y retornar atrás </span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>

        <v-col cols="12" md="12" sm="12">
          <v-row>
            <!--------- columna 1 Crear/editar ---------->
            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6" style="border: 1px solid #000000;">
              <!-- 285 id="divSelecProd"   v-bind:style="{  'max-height':this.windowSize.height-400+'px','border': '2px solid #000000' }" class="overflow-x-auto"  -->
              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                <span :class="`d-flex justify-center white--text`"><b>Crear y modificar</b></span>
              </v-col>

              <v-col cols="12" md="12" sm="12">
                <v-form ref="formBuscarCliente" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-combobox ref="RefTextFieldBuscaCliente" v-model="busquedaCliente" :items="RCliente"
                                  :rules="[$rules.required]"
                                  autocomplete="off" background-color="white" color="grey darken-4" dense hide-details
                                  item-text="codnom"
                                  label="Buscar cliente:" no-filter outlined
                                  style="font-size: 13px;"
                                  @blur="SelctCbClienteBuscar"
                                  @change="getChangeClienteBusqueda(busquedaCliente)" @focus="cargarClienteBusqueda"
                                  @keyup="CbFilcliente"
                                  v-on="on"
                                  v-on:change="changeCbTipoComprobante(clienteSeleccionado.tipocomprobante,'RefTextFieldcedrnc')"
                                  @keyup.enter="SeleccionarClienteFactura">
                        <template v-slot:prepend-inner>
                          <i class="fa fa-search" style="font-size: 25px;"></i>
                        </template>
                        <!-- margin-top="50px"style="font-size: 14px;" -->
                        <template slot="item" slot-scope="item">
                          <span style="display:none;">{{
                              item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `
                            }}</span>
                          <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>
                            style="border: 1px dashed  #616161;"
                              -->
                          <v-col class="pa-0 ma-0 py-0 my-0" cols="12"
                                 md="12" sm="12" style="border: 1px solid #000000; font-size: 13px; ">
                            <p class="pa-0 ma-0 py-0 my-0"><b>NOMBRE:
                              {{ item.item.nombre }}</b></p>

                            <span class="pa-0 ma-0 py-0 my-0">
                              <span><b>TEL.: </b>{{ selectTelefonoCliente(item.item) }}.</span>
                              <span><b>CED/RNC: </b> {{ item.item.cedrnc }}</span>
                            </span>
                            <p
                              v-if="item.item.hasOwnProperty('pasaporte') && item.item.pasaporte != null && item.item.pasaporte.length>0"
                              class="pa-0 ma-0 py-0 my-0"><b>PASAPORTE: </b>{{ item.item.pasaporte }} </p>
                            <p class="pa-0 ma-0 py-0 my-0"><b>DIRECCIÓN: </b>
                              {{ item.item.direccion }} </p>
                            <span v-if="item.item.hasOwnProperty('ars') && item.item.ars != null"><b> ARS :{{
                                item.item.ars.nombre
                              }}</b></span>
                            <span v-if="item.item.diascredito > 0"><b> TIPO:</b> Cliente Credito </span>
                            <span v-if="item.item.diascredito == 0"><b>TIPO:</b> Cliente Contado </span>
                            <p class="pa-0 ma-0 py-0 my-0" v-if="$store.getters.GetConfiguracionGeneral.configPv.hasOwnProperty('mostrarBalanceCliente') && $store.getters.GetConfiguracionGeneral.configPv.mostrarBalanceCliente!=null && $store.getters.GetConfiguracionGeneral.configPv.mostrarBalanceCliente==true ">
                              <b>BALANCE: </b>{{ currencyFormatter2(selectBalanceCliente(item.item)) }}.
                              <b>LIM. CRÉDITO: </b>{{ currencyFormatter2(selectLimiteCredito(item.item)) }}.
                              <b>BALANCE DISP.: </b>{{currencyFormatter2(selectLimiteCredito(item.item) - selectBalanceCliente(item.item)) }}.
                            </p>
                          </v-col>


                        </template>


                        <template v-slot:append-outer>

                          <v-tooltip top>
                            <template v-slot:activator="{ on }">

                              <v-btn color="indigo lighten-2" dark outlined
                                     small v-on="on" @click.prevent="SeleccionarClienteFactura">
                                <!-- <i style="font-size: 20px;" class="fa fa-plus-square"></i> -->

                                <v-avatar color="transparent" size="28" tile>
                                  <img alt="Asignar cliente" src="@/assets/icons_pv/extras/seleccionar48.png">
                                </v-avatar>


                              </v-btn>

                            </template>
                            <span>Asignar cliente buscado a la factura</span>
                          </v-tooltip>

                        </template>


                      </v-combobox>
                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Se selecciona el cliente que desea editar.</span>
                    </i>
                  </v-tooltip>

                </v-form>
              </v-col>

              <v-form ref="formCrearEditarCliente" v-model="valid" lazy-validation translate="no" class="notranslate">
                <v-row>
                  <!-- -----------------------------  Codigo -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                    <v-text-field id="formdisabledInput" v-model="clienteSeleccionado.codigo" :disabled="true" dense
                                  hide-details label="Codigo:" outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-list-ol" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>
                  </v-col>

                  <!-- -----------------------------  comentario -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                    <v-textarea v-model="clienteSeleccionado.comentario" autocomplete="off" dense label="comentario:"
                                outlined
                                rows="1">
                      <template v-slot:prepend>
                        <i class="fa fa-commenting" style="font-size: 20px"></i>
                      </template>
                    </v-textarea>
                  </v-col>

                  <!-- -----------------------------  Nombre -->
                  <v-col cols="12" md="6" sm="6">
                    <v-text-field id="formdisabledInput" v-model="clienteSeleccionado.nombre"
                                  :disabled="validarDisabledClienteCredito(busquedaCliente)" :rules="[$rules.required]"
                                  autocomplete="off"
                                  dense
                                  label="* Nombre:"
                                  outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-font" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>


                  </v-col>

                  <!-- ----------------------------- cedula/rnc -->
                  <v-col cols="12" md="6" sm="6">

                    <v-text-field v-if="cedularequired==false" v-model="clienteSeleccionado.cedrnc" v-mask="MakCelRnc"
                                  :rules="[$rules.RulesCelRncValidar]"
                                  autocomplete="off" dense label="Cedula/RNC:"
                                  maxlength="13" outlined
                                  @blur="MakaraCel"
                                  @focus="MakCelRnc = '#############'"
                                  v-on:blur="validandoCedRnc(clienteSeleccionado.cedrnc)">
                      <template v-slot:prepend>
                        <i class="fa fa-id-card-o" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>

                    <v-text-field v-if="cedularequired==true" ref="RefTextFieldcedrnc"
                                  v-model="clienteSeleccionado.cedrnc"
                                  v-mask="MakCelRnc" :rules="[$rules.required,$rules.RulesCelRncValidar]"
                                  autocomplete="off" dense label="Cedula/RNC:"
                                  maxlength="13"
                                  outlined @blur="MakaraCel"
                                  @focus="MakCelRnc = '#############'"
                                  v-on:blur="validandoCedRnc(clienteSeleccionado.cedrnc)">
                      <template v-slot:prepend>
                        <i class="fa fa-id-card-o" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>

                  </v-col>
                  <!-- -----------------------------  Pasaporte -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                    <v-text-field v-model="clienteSeleccionado.pasaporte" autocomplete="off" dense label="Pasaporte:"
                                  maxlength="19"
                                  outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-address-card" style="font-size: 20px"></i>
                      </template>
                    </v-text-field>

                  </v-col>


                  <!-- -----------------------------  Direccion -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                    <v-textarea id="formdisabledInput" v-model="clienteSeleccionado.direccion"
                                :disabled="validarDisabledClienteCredito(busquedaCliente)" :rules="[$rules.required]"
                                autocomplete="off"
                                dense label="* Dirección:"
                                outlined
                                rows="1">
                      <template v-slot:prepend>
                        <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                      </template>
                    </v-textarea>
                  </v-col>


                  <!-- ----------------------------- Télefono -->
                  <v-col class="py-0 my-0 " cols="12" md="6" sm="6">
                    <v-text-field v-model="clienteSeleccionado.telefono" v-mask="'(###)###-####'"
                                  :rules="[$rules.required,$rules.RulesTel]" autocomplete="off" dense
                                  label="Télefono:" maxlength="13"
                                  outlined
                    >
                      <template v-slot:prepend>
                        <i class="fa fa-phone" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>

                  </v-col>

                  <!-- -----------------------------  Direccion 2 -->
                  <!-- :disabled="validarDisabledClienteCredito(busquedaCliente)"  -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                    <v-textarea id="formdisabledInput" v-model="clienteSeleccionado.direccion2" autocomplete="off" dense
                                label=" Dirección2:"
                                outlined
                                rows="1"
                    >
                      <template v-slot:prepend>
                        <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                      </template>
                    </v-textarea>
                  </v-col>

                  <!-- -----------------------------  email -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                    <v-text-field v-model="clienteSeleccionado.email" dense label="E-mail:" outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-envelope-o" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>

                  </v-col>

                  <!-- ----------------------------- fecha de nacimiento   -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                    <v-text-field v-model="clienteSeleccionado.fechanacimiento" dense label="Fecha de Nacimiento:"
                                  outlined
                                  type="date">

                      <template v-slot:prepend>
                        <i class="fa fa-calendar" style="font-size: 20px;"></i>
                      </template>

                    </v-text-field>

                  </v-col>


                  <!-- ----------------------------- Ciudad-->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                    <v-text-field v-model="clienteSeleccionado.ciudad" :rules="[$rules.required]" autocomplete="off"
                                  dense
                                  label="* Ciudad:"
                                  outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-map" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>
                  </v-col>


                  <!-- -----------------------------sector -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                    <v-text-field v-model="clienteSeleccionado.sector" :rules="[$rules.required]" autocomplete="off"
                                  dense label="sector:"
                                  outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>

                  </v-col>


                  <!-- ----------------------------- Dia de credito -->
                  <v-col v-if="false" class="py-0 my-0" cols="12" md="6" sm="6">

                    <v-text-field v-model="clienteSeleccionado.diascredito" dense label="Días de Crédito" outlined
                                  @keyup="KeyUpCantidad">
                      <template v-slot:prepend>
                        <i class="fa fa-credit-card" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>
                  </v-col>


                  <!-- ----------------------------- tipocomprobante -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                    <v-combobox id="formdisabledInput" v-model="clienteSeleccionado.tipocomprobante"
                                :disabled="validarDisabledClienteCredito(busquedaCliente)"
                                :items="filterTipoComprobantePvItbis(RtipoComprobante)"
                                :rules="[$rules.required]" autocomplete="off"
                                dense
                                item-text="descripcion" label="* Tipos de Comprobante:"
                                outlined
                                @blur="SelctCbTipoComprobante"
                                @change="changeCbTipoComprobante(clienteSeleccionado.tipocomprobante,'RefTextFieldcedrnc')"
                                @focus="cargarTipoComprobante">
                      <template v-slot:prepend>
                        <i class="fa fa-tag" style="font-size: 20px;"></i>
                      </template>
                    </v-combobox>

                  </v-col>

                  <v-col v-if="clienteSeleccionado.ordenCompraPv!=null && clienteSeleccionado.ordenCompraPv==true"
                         class="py-0 my-0" cols="12" md="6" sm="6">
                    <!-- numeroOrden No --------------------------------------------------->
                    <v-text-field ref="RefTextFieldNoOrden" v-model="busquedaCliente.numeroOrden"
                                  :rules="[$rules.required]" autocomplete="off" dense
                                  label="No.orden:"
                                  outlined placeholder=" " style="font-size: 12px;">
                      <template v-slot:prepend>
                        <i class="fa fa-slack" style="font-size: 18px;"></i>
                      </template>
                    </v-text-field>
                  </v-col>


                  <!-- -----------------------------sexo -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                    <!-- <v-text-field label="Sexo:" dense outlined
                      autocomplete="off"
                        v-model="clienteSeleccionado.sexo"
                        :rules="[$rules.required]"
                        >
                      <template v-slot:prepend>
                              <i style="font-size: 20px;" class="fa fa-venus-mars"></i>
                      </template>
                        </v-text-field> -->

                  </v-col>
                  <v-col v-if="$store.getters.GetdatosInfUsu.usuario.micromarket == false" class="py-0 my-0" cols="12"
                         md="12"
                         sm="12">
                    <hr style="border: 1px solid #000000;">
                    <br>
                    <v-row>
                      <!-- ----------------------------- Número de Afiliado  -->
                      <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                        <v-text-field v-if="clienteSeleccionado.ars==null" v-model="clienteSeleccionado.carnet"
                                      autocomplete="off" dense label="Número de Afiliado:"
                                      outlined>
                          <template v-slot:prepend>
                            <i class="fa fa-slack" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>

                        <v-text-field v-if="clienteSeleccionado.ars!=null" v-model="clienteSeleccionado.carnet"
                                      :rules="[$rules.required]" autocomplete="off" dense
                                      label="Número de Afiliado:" outlined>
                          <template v-slot:prepend>
                            <i class="fa fa-slack" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>

                      </v-col>
                      <!-- ----------------------------- ARS -->
                      <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                        <v-combobox v-model="clienteSeleccionado.ars" :items="RArs" autocomplete="off" dense
                                    item-text="nombre" label="ARS:"
                                    outlined @blur="SelctCbArsClient" @focus="cargarArs">
                          <template v-slot:prepend>
                            <i class="fa fa-shield" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                      <!-- -----------------------------Donde Trabaja  -->
                      <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                        <v-text-field v-model="clienteSeleccionado.dondetrabaja" autocomplete="off" dense
                                      label="Donde Trabaja:"
                                      outlined>
                          <template v-slot:prepend>
                            <i class="fa fa-building-o" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>


                      </v-col>
                      <!-- ----------------------------- Número de Contrato -->
                      <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                        <v-text-field v-model="clienteSeleccionado.contrato" autocomplete="off" dense
                                      label="Número de Contrato:"
                                      outlined>
                          <template v-slot:prepend>
                            <i class="fa fa-slack" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>
                      </v-col>

                      <!-- ----------------------------- Número de NSS -->
                      <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                        <v-text-field v-model="clienteSeleccionado.nss" autocomplete="off" dense label="Número de NSS:"
                                      outlined>
                          <template v-slot:prepend>
                            <i class="fa fa-slack" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>

                      </v-col>

                      <!-- ----------------------------- Plan  lan -->
                      <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                        <v-text-field v-model="clienteSeleccionado.planlan" autocomplete="off" dense label="Plan  lan:"
                                      outlined>
                          <template v-slot:prepend>
                            <i class="fa fa-sign-language" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>

                      </v-col>


                    </v-row>
                  </v-col>


                </v-row>

              </v-form>


            </v-col>
            <!--------- fn columna 1 Crear/editar ---------->


            <!--------- columna 2 Crear/editar ---------->
            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6" style="border: 1px solid #000000; ">

              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                <span :class="`d-flex justify-center white--text`"><b>Historial de compras del cliente</b></span>
              </v-col>

              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">

                <!--------------------------------------------------  Header tb Historial compra cliente -->
                <!-- <v-col style="background-color:#3d6687;" class="py-0 my-0" cols="12" md="12" sm="12">
                      <v-row style="border: 1px solid #000000;">
                        <v-col class="pa-0 ma-0" cols="2" md="2"> <b :class="`d-flex justify-start white--text`">Fecha</b>
                        </v-col>
                        <v-col class="pa-0 ma-0" cols="2" md="2"> <b :class="`d-flex justify-start white--text`">
                            Cantidad</b></v-col>
                        <v-col class="pa-0 ma-0" cols="4" md="4"><b :class="`d-flex justify-center white--text`"> Precio
                          </b></v-col>
                        <v-col class="pa-0 ma-0" cols="4" md="4"><b :class="`d-flex justify-center white--text`"> No.Factura
                          </b></v-col>
                      </v-row>
                    </v-col> -->
                <!-------------------------------------------------- fn Header tb Historial compra cliente  -->
                <!-------------------------------------------------- tb Historial compra cliente
    :single-select="true" :show-select="true"
    -->
                <!--  hide-default-header  -->
                <div
                  class="overflow-x-auto"
                  v-bind:style="{ 'height': this.windowSize.height - 30 + 'px', 'max-height': this.windowSize.height - 30 + 'px' }">
                  <v-data-table :footer-props="arrayPropiedases" :headers="[
                    { text: 'FECHA', value: 'fecha', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'PRODUCTO', value: 'producto', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'CANTIDAD', value: 'cantidad', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'PRECIO', value: 'precio', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'No.FACTURA', value: 'factura', sortable: false, class: ['no-gutters black--text'] },
                  ]
                  " :items="RHistorialCompracliente" :items-per-page="TbPaginatorHisCli.itemsPerPage"
                                :page="TbPaginatorHisCli.page" :pageCount="TbPaginatorHisCli.pageCount"
                                :server-items-length="TbTotalItemHisCli" class="elevation-1 TbSize13"
                                dense item-key="indx"
                                @pagination="cargarPaginacionAllHisCli">

                    <template v-slot:item.fecha="props">
                      <span style="font-size:13px;">{{ FormatoFecha(props.item.fecha) }}</span>
                    </template>

                    <template v-slot:item.precio="props">
                      <span style="font-size:13px;">{{ currencyFormatter2(props.item.precio) }}</span>
                    </template>


                    <!-- EditarProductoSelect(props.item,false) -->
                    <!-- <template v-slot:item="props">
                          <span style="display:none;">{{ props.item.indx =
                          RHistorialCompracliente.indexOf(props.item)
                          }}</span>
                          <tr>

                            <td @click.prevent="" v-ripple="{ class: `indigo--text` }">
                              <span style="display:none;" v-if="!props.item.hasOwnProperty('cantidad')">{{
                              props.item.cantidad = 1
                              }}</span>
                              <v-row>
                                <v-col class="pa-0 ma-0" cols="12" md="12"><span><b>PRODUCTO:
                                      {{ props.item.productos.descripcion }} </b></span></v-col>
                                <v-col class="pa-0 ma-0" cols="2" md="2"><span> {{
                                FormatoFecha(props.item.productos.fechaCreacion)
                                }}</span></v-col>
                                <v-col class="pa-0 ma-0" cols="2" md="2"><span :class="`d-flex justify-center`"> {{
                                currencyFormatter(props.item.cantidad)
                                }}</span></v-col>
                                <v-col class="pa-0 ma-0" cols="4" md="4"><span :class="`d-flex justify-center`"> {{
                                currencyFormatter(props.item.precio)
                                }}</span></v-col>
                                <v-col class="pa-0 ma-0" cols="4" md="4"><span :class="`d-flex justify-center`"> #{{
                                props.item.facturasventaDetallePK.secuencia
                                }}</span></v-col>
                              </v-row>
                            </td>
                          </tr>
                        </template> -->
                  </v-data-table>
                </div>
                <!-------------------------------------------------- fn tb Historial compra cliente-->


              </v-col>


            </v-col>
            <!--------- fn columna 2 Crear/editar ---------->

          </v-row>
        </v-col>
      </v-card>
    </v-dialog>
    <!--------------------------------------------------------  fn Modal- Crear editar cliente -->

    <!-------------------------------------------------------- Modal-Reimprecion punto de venta-->
    <v-dialog v-model="dialogReimprecion" fullscreen hide-overlay label="Modal Reimprecion " persistent
              transition="dialog-bottom-transition">

      <v-card class="mx-auto">
        <div v-if="dialogReimprecion" v-dirkeydown="finalizarReimprimirKeyEsc">
          <v-toolbar color="#dd4b39" dark dense>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">

                <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Reimpresión
                </v-toolbar-title>

              </template>
              <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>Reimpresión: </span> Recibo, Otros
                ingresos, Factura, Devolución, Vale de caja, Cotización</i>

            </v-tooltip>

            <v-spacer></v-spacer>

            <v-card-actions v-if="windowSize.width > 600">
              <v-btn-toggle>
                <!-- Reimprimir btn Canselar max-height: 130px; ------>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover v-slot:default="{ hover }" close-delay="200">

                      <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                             :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                             dark
                             height="45px" min-width="105px" v-on="on"
                             @click.prevent="ReimpresionBusqueda.opcion=0,ListReimprecion = [], NewReimprecionFacturaSeleccionada(), BtnReimprecionvalue = 0, dialogReimprecion = false">
                        <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                        <span>


                        <v-avatar color="transparent" size="30" tile>
                          <i class="fa fa-reply-all"
                             v-bind:style="{ 'font-size': '30px', 'color': hover ? 'blcak' : 'white' }"></i>
                        </v-avatar>

                          <!-- CANCELAR: Cancela y retornar atrás, class="fa fa-reply-all"
        <br>
    <b v-bind:style="{  'font-size':'10px', 'color': hover ? 'white':'#000000'  }">Recibo</b> -->
                      </span>
                      </v-btn>
                    </v-hover>
                  </template>
                  <span><b> Cancela y retornar atrás</b> </span>
                </v-tooltip>


                <!-- Reimprimir btn recibo ------>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover v-slot:default="{ hover }" close-delay="200">
                      <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                             :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                             dark height="45px" min-width="105px"
                             v-on="on" @click.prevent="ReimpresionOpciones('AccReimpresionOpcRecibo')">
                        <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                        <span>

                        <v-badge color="teal" overlap>
                          <template v-slot:badge>
                            <i v-if="BtnReimprecionvalue == 1" class="fa fa-check" style="font-size: 10px;"></i>
                          </template>

                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Recibo" src="@/assets/icons_pv/menu/recibo64.png">
                          </v-avatar>
                        </v-badge>

                        <br>
                        <b v-if="BtnReimprecionvalue != 1"
                           v-bind:style="{ 'font-size': '10px', 'color': hover ? 'white' : '#BDBDBD' }">Recibo</b>
                        <b v-if="BtnReimprecionvalue == 1" class='white--text'>Recibo</b>
                      </span>
                      </v-btn>
                    </v-hover>
                  </template>
                  <span><b> Recibo de ingresos </b> </span>
                </v-tooltip>

                <!-- Reimprimir btn Otros ingresos ------>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover v-slot:default="{ hover }" close-delay="200">
                      <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                             :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                             dark height="45px"
                             min-width="105px"
                             v-on="on" @click.prevent="ReimpresionOpciones('AccReimpresionOpcOtrosingresos')">
                        <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                        <span>

                        <v-badge color="teal" overlap>
                          <template v-slot:badge>
                            <i v-if="BtnReimprecionvalue == 2" class="fa fa-check" style="font-size: 10px;"></i>
                          </template>

                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Otros ingresos" src="@/assets/icons_pv/menu/otrosIngresos64.png">
                          </v-avatar>
                        </v-badge>
                        <br>
                        <b v-if="BtnReimprecionvalue != 2"
                           v-bind:style="{ 'font-size': '10px', 'color': hover ? 'white' : '#BDBDBD' }">Otros
                          ingresos</b>
                        <b v-if="BtnReimprecionvalue == 2" class='white--text'>Otros ingresos</b>
                      </span>
                      </v-btn>
                    </v-hover>
                  </template>
                  <span><b> Otros ingresos </b> </span>
                </v-tooltip>

                <!-- Reimprimir btn Factura ------>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover v-slot:default="{ hover }" close-delay="200">
                      <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                             :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                             dark height="45px" min-width="105px"
                             v-on="on" @click.prevent="ReimpresionOpciones('AccReimpresionOpcFactura')">
                        <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                        <span>

                        <v-badge color="teal" overlap>
                          <template v-slot:badge>
                            <i v-if="BtnReimprecionvalue == 3" class="fa fa-check" style="font-size: 10px;"></i>
                          </template>

                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Factura" src="@/assets/icons_pv/menu/factura64.png">
                          </v-avatar>
                        </v-badge>
                        <br>
                        <b v-if="BtnReimprecionvalue != 3"
                           v-bind:style="{ 'font-size': '10px', 'color': hover ? 'white' : '#BDBDBD' }">Factura</b>
                        <b v-if="BtnReimprecionvalue == 3" class='white--text'>Factura</b>
                      </span>
                      </v-btn>
                    </v-hover>
                  </template>
                  <span><b> Factura</b></span>
                </v-tooltip>


                <!-- Reimprimir btn Devolución ------>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover v-slot:default="{ hover }" close-delay="200">
                      <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                             :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                             dark height="45px" min-width="105px"
                             v-on="on" @click.prevent="ReimpresionOpciones('AccReimpresionOpcDevolución')">
                        <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                        <span>

                        <v-badge color="teal" overlap>
                          <template v-slot:badge>
                            <i v-if="BtnReimprecionvalue == 4" class="fa fa-check" style="font-size: 10px;"></i>
                          </template>

                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Devolución" src="@/assets/icons_pv/menu/devolucion64.png">
                          </v-avatar>
                        </v-badge>
                        <br>
                        <b v-if="BtnReimprecionvalue != 4"
                           v-bind:style="{ 'font-size': '10px', 'color': hover ? 'white' : '#BDBDBD' }">Devolución</b>
                        <b v-if="BtnReimprecionvalue == 4" class='white--text'>Devolución</b>
                      </span>
                      </v-btn>
                    </v-hover>
                  </template>
                  <span><b> Devolución</b> </span>
                </v-tooltip>


                <!-- Reimprimir btn Vale de caja ------>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover v-slot:default="{ hover }" close-delay="200">
                      <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                             :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                             dark height="45px" min-width="105px"
                             v-on="on" @click.prevent="ReimpresionOpciones('AccReimpresionOpcValeCaja')">
                        <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                        <span>

                        <v-badge color="teal" overlap>
                          <template v-slot:badge>
                            <i v-if="BtnReimprecionvalue == 5" class="fa fa-check" style="font-size: 10px;"></i>
                          </template>

                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Vale de caja" src="@/assets/icons_pv/menu/valeCaja64.png">
                          </v-avatar>
                        </v-badge>

                        <br>
                        <b v-if="BtnReimprecionvalue != 5"
                           v-bind:style="{ 'font-size': '10px', 'color': hover ? 'white' : '#BDBDBD' }">Vale de caja</b>
                        <b v-if="BtnReimprecionvalue == 5" class='white--text'>Vale de caja</b>
                      </span>
                      </v-btn>
                    </v-hover>
                  </template>
                  <span><b> Vale de caja </b> </span>
                </v-tooltip>


                <!-- Reimprimir btn Cotización ------>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover v-slot:default="{ hover }" close-delay="200">
                      <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                             :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                             dark height="45px" min-width="105px"
                             v-on="on" @click.prevent="ReimpresionOpciones('AccReimpresionOpcCotizacion')">
                        <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                        <span>

                        <v-badge color="teal" overlap>
                          <template v-slot:badge>
                            <i v-if="BtnReimprecionvalue == 6" class="fa fa-check" style="font-size: 10px;"></i>
                          </template>

                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Cotización" src="@/assets/icons_pv/menu/cotizacion64.png">
                          </v-avatar>
                        </v-badge>

                        <br>
                        <b v-if="BtnReimprecionvalue != 6"
                           v-bind:style="{ 'font-size': '10px', 'color': hover ? 'white' : '#BDBDBD' }">Cotización</b>
                        <b v-if="BtnReimprecionvalue == 6" class='white--text'>Cotización</b>
                      </span>
                      </v-btn>
                    </v-hover>
                  </template>
                  <span><b> Cotización </b> </span>
                </v-tooltip>


                <!-- Reimprimir btn Conduce ------>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover v-slot:default="{ hover }" close-delay="200">
                      <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                             :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                             dark height="45px" min-width="105px"
                             v-on="on" @click.prevent="ReimpresionOpciones('AccReimpresionOpcConduce')">
                        <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                        <span>

                        <v-badge color="teal" overlap>
                          <template v-slot:badge>
                            <i v-if="BtnReimprecionvalue == 7" class="fa fa-check" style="font-size: 10px;"></i>
                          </template>

                          <v-avatar color="transparent" size="30" tile>
                            <img alt="Conduce" src="@/assets/icons_pv/menu/Conduce2.png">
                          </v-avatar>
                        </v-badge>

                        <br>
                        <b v-if="BtnReimprecionvalue != 7"
                           v-bind:style="{ 'font-size': '10px', 'color': hover ? 'white' : '#BDBDBD' }">Conduce</b>
                        <b v-if="BtnReimprecionvalue == 7" class='white--text'>Conduce</b>
                      </span>
                      </v-btn>
                    </v-hover>
                  </template>
                  <span><b> Conduce </b> </span>
                </v-tooltip>


              </v-btn-toggle>
            </v-card-actions>


            <v-card-actions v-if="windowSize.width <= 600">

              <v-btn color="transparent" dark
                     outlined v-bind="attrs" @click.prevent="BtnReimprecionvalue = 1, dialogReimprecion = false">
                <i class="fa fa-reply-all"
                   v-bind:style="{ 'font-size': '30px', 'color': hover ? 'white' : '#BDBDBD' }"></i>
              </v-btn>

              <!-- Reimprimir btnes Movil; ------>
              <v-bottom-sheet v-model="ReimprecionSheet">
                <template v-slot:activator="{ on, attrs }">

                  <v-btn color="teal darken-2" dark fab outlined v-bind="attrs" x-small v-on="on">
                    <i class="fa fa-list-ul" style="font-size: 20px;"></i>
                  </v-btn>
                </template>
                <v-list>

                  <v-subheader class="d-flex justify-center"><b> Funciones de Reimpreción </b>


                  </v-subheader>

                  <!-- 32px -->
                  <v-list-item @click.prevent="ReimpresionOpciones('AccReimpresionOpcRecibo')">
                    <v-list-item-avatar size="32" tile>
                      <img alt="Recibo" src="@/assets/icons_pv/menu/recibo64.png">
                      <!-- <i style="font-size: 32px; color:#00796B; " class="fa fa-plus-square"></i> -->
                    </v-list-item-avatar>
                    <v-list-item-title>Recibo</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click.prevent="ReimpresionOpciones('AccReimpresionOpcOtrosingresos')">
                    <v-list-item-avatar size="32" tile>
                      <img alt="Otros ingresos" src="@/assets/icons_pv/menu/otrosIngresos64.png">

                    </v-list-item-avatar>
                    <v-list-item-title>Otros ingresos</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click.prevent="ReimpresionOpciones('AccReimpresionOpcFactura')">
                    <v-list-item-avatar size="32" tile>
                      <img alt="Factura" src="@/assets/icons_pv/menu/factura64.png">
                    </v-list-item-avatar>
                    <v-list-item-title>Factura</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click.prevent="ReimpresionOpciones('AccReimpresionOpcDevolución')">
                    <v-list-item-avatar size="32" tile>
                      <img alt="Devolución" src="@/assets/icons_pv/menu/devolucion64.png">
                    </v-list-item-avatar>
                    <v-list-item-title>Devolución</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click.prevent="ReimpresionOpciones('AccReimpresionOpcValeCaja')">
                    <v-list-item-avatar size="32" tile>
                      <img alt="Vale de caja" src="@/assets/icons_pv/menu/valeCaja64.png">
                    </v-list-item-avatar>
                    <v-list-item-title>Vale de caja</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click.prevent="ReimpresionOpciones('AccReimpresionOpcCotizacion')">
                    <v-list-item-avatar size="32" tile>
                      <img alt="Cotización" src="@/assets/icons_pv/menu/cotizacion64.png">
                    </v-list-item-avatar>
                    <v-list-item-title>Cotización</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click.prevent="ReimpresionOpciones('AccReimpresionOpcConduce')">
                    <v-list-item-avatar size="32" tile>
                      <img alt="Conduce" src="@/assets/icons_pv/menu/Conduce2.png">
                    </v-list-item-avatar>
                    <v-list-item-title>Conduce</v-list-item-title>
                  </v-list-item>


                </v-list>
              </v-bottom-sheet>
            </v-card-actions>

          </v-toolbar>

          <v-col cols="12" md="12" sm="12">
            <v-card color="grey lighten-3">
              <b :class="`d-flex justify-center`"> {{ LabelReimprecion }}</b>
              <br>

              <v-form v-show="BtnReimprecionvalue != 0" ref="formReimprecion" v-model="valid" lazy-validation
                      @submit.prevent="" translate="no" class="notranslate">
                <v-row>

                  <!--  reimprecion busqueda secuencia  @blur="getCierreCaja" v-on:input="resertPaginacion" -------------->
                  <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">

                        <v-col class="py-0 my-0" cols="12" md="12" sm="12">
                        <v-text-field v-show="ReimpresionBusqueda.opcion==0" v-model.number="ReimpresionBusqueda.secuencia" autocomplete="off" dense
                                      label="# Secuencia:" outlined style="font-size: 12px;"
                                      type="number" v-on="on" @keyup.enter="getReimprecionlistFactCliente()"
                                      hide-details>
                          <template v-slot:prepend>
                            <i class="fa fa-hashtag" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field> 

                        <v-text-field label="Referencia:" dense outlined v-model="ReimpresionBusqueda.referencia" style="font-size: 12px;"
                                  v-show="ReimpresionBusqueda.opcion==1" @keyup.enter="getReimprecionlistFactCliente()"
                                      hide-details >
                                      <template v-slot:prepend>
                                        <i style="font-size: 20px;" class="fa fa-map-signs"></i>
                                      </template>
                        </v-text-field>
                        </v-col> 
                      </template>
                      <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                        <span> Aquí se registra el número de secuencia que deseamos búscar.</span>
                      </i>
                    </v-tooltip>
                  </v-col>

                  <!--  reimprecion busqueda Fecha Inicial @input="getCierreCaja"  v-on:input="resertPaginacion" -------------->
                  <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">

                        <v-text-field v-model="ReimpresionBusqueda.fechaInicial" :rules="[$rules.required]" dense
                                      label="Fecha Inicial" outlined
                                      placeholder=" " style="font-size: 12px;"
                                      type="date"
                                      v-on="on">
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 18px;"></i>
                          </template>
                        </v-text-field>

                      </template>
                      <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                        <span> Aquí se registra la fecha a partir de la cual queremos la búsqueda.</span>
                      </i>
                    </v-tooltip>
                  </v-col>

                  <!--  reimprecion busqueda Fecha Final @input="getCierreCaja"  v-on:input="resertPaginacion" -------------->
                  <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">

                        <v-text-field v-model="ReimpresionBusqueda.fechaFinal" :rules="[$rules.required]" dense
                                      label="Fecha Final" outlined
                                      placeholder=" " style="font-size: 12px;"
                                      type="date"
                                      v-on="on">
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 18px;"></i>
                          </template>
                        </v-text-field>

                      </template>
                      <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                        <span> Aquí se registra la fecha hasta donde queremos la búsqueda.</span>
                      </i>
                    </v-tooltip>
                  </v-col>
                  <!--  reimprecion cliente @change="getFacVenta" @blur="SelctCbClienteBuscar" -------------->
                  <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-combobox ref="RefCombClienteReImprimir" v-model="ReimpresionBusqueda.cliente"
                                    :items="RCliente" autocomplete="off" dense
                                    item-text="codnom" label="cliente:" no-filter outlined
                                    style="font-size: 13px;" @focus="cargarClienteBusqueda"
                                    @keyup="CbFilcliente" v-on="on">

                          <template slot="item" slot-scope="item">
                            <span style="display:none;">{{
                                item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `
                              }}</span>
                            <span
                              class="fontSize13"><b>{{ item.item.codigo }}</b> - {{ item.item.nombre.trim() }}</span>
                          </template>

                          <template v-slot:selection="{ attrs, item, parent, selected }">
                            <span v-if="item.hasOwnProperty('codigo')"
                                  class="fontSize13 colorNombre"><b>{{ item.codigo }}</b> - {{ item.nombre }}</span>
                            <span v-if="item!=null && !item.hasOwnProperty('codigo')"
                                  class="fontSize13 colorNombre">{{ item }}</span>
                          </template>


                          <template v-slot:prepend>
                            <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>
                      </template>
                      <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                        <span> Se selecciona el cliente que desea buscar.</span>
                      </i>
                    </v-tooltip>


                  </v-col>
                  <v-col class="py-0 my-0" cols="12" md="1" sm="1">
                    <v-btn color="teal" small @click.prevent="getReimprecionlistFactCliente"><i class="fa fa-search"
                                                                                                style="font-size: 20px;"></i>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>

              <v-col v-show="BtnReimprecionvalue != 0" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                <div style="border: 1px solid #000000;">

                  <!-- ReimprecionCargarPaginacion
    ReimprecionSelected,ReimprecionObtenerDatoSelect,ReimprecionlistFactCliente,ReimprecionCargarPaginacion,
    ReimprecionDatostabla,ReimprecionTotalRegistros
    ReimprecionPaginator -->
                  <!-- @click:row="datostabla" -->

                  <div v-if="ReimprecionFacturaSeleccionada.secuencia == 0">

                    <!-- Tabla Reimprecion Factura  @pagination="ReimprecionCargarPaginacion"
    :items-per-page="ReimprecionPaginator.itemsPerPage" :server-items-length="TotalRegistros"    -->
                    <v-data-table v-model="ReimprecionSelected" :footer-props="arrayPropiedases" :headers="[{ text: 'Fecha', sortable: false, value: 'fecha', width: 120 },
                    { text: '# Secuencia', sortable: false, value: 'secdoc', width: 129 },
                    { text: 'Cliente', sortable: false, value: 'nombre', width: 129 },
                    { text: 'Valor', sortable: false, value: 'valor', width: 'auto', width: 105 }]"
                                  :items="ListReimprecion"
                                  :items-per-page="ReimprecionPaginator.itemsPerPage"
                                  :server-items-length="TotalRegistros"
                                  :show-select="true" :single-select="true" class="RowSelectColor"
                                  dense item-key="indx"
                                  @pagination="ReimprecionCargarPaginacion"
                                  @item-selected="ReimprecionObtenerDatoSelect"
                                  @click:row="ReimprecionDatostabla">
                      <template v-slot:item.action="{ item }">
                        <!-- <v-btn fab @click.prevent="VerReporte(item)" x-small color="yellow accent-4"><i style="font-size: 20px;" class="fa fa-eye"></i></v-btn>  -->
                        <v-btn color="red darken-3" fab x-small @click.prevent="deleFact(item)"><i
                          class="fa fa-trash-o"
                          style="font-size: 20px;"></i></v-btn>

                      </template>

                      <template v-slot:item.fecha="props">
                      <span style="font-size:13px; display:none;">{{
                          props.item.indx =
                            ListReimprecion.indexOf(props.item)
                        }}</span>
                        <span style="font-size:13px;">{{ FormatoFecha(props.item.fecha) }}</span>
                      </template>

                      <template v-slot:item.documentoFactura.descripcion="props">
                        <span style="font-size:13px;">{{ props.item.documentoFactura.descripcion }} </span>
                      </template>


                      <template v-slot:item.secdoc="props">
                        <span style="font-size:13px;">{{ props.item.secdoc }} </span>
                      </template>
                      <template v-slot:item.ncf="props">
                        <span style="font-size:13px;">{{ props.item.ncf }} </span>
                      </template>

                      <template v-slot:item.nombre="props">
                        <span v-if="props.item.nombre != null" style="font-size:13px;">{{ props.item.nombre }} </span>
                      </template>

                      <template v-slot:item.sucursal.descripcion="props">
                      <span v-if="props.item.sucursal != null" style="font-size:13px;">{{
                          props.item.sucursal.descripcion
                        }}
                      </span>
                      </template>


                      <template v-slot:item.valor="props">
                        <!-- <span style="font-size:13px;">{{ currencyFormatter(props.item.valor) }}</span>-->
                        <span style="font-size:13px;">{{
                            currencyFormatter2TasaInf(getTasaInfo(props.item.valor, props.item.tasa), props.item.tasa)
                          }}</span>
                      </template>
                    </v-data-table>
                    <!-- fn Tabla Reimprecion Factura -->

                  </div>


                  <!-- informacion de fatura  selecionada reimprecion -->
                  <v-col v-if="ReimprecionFacturaSeleccionada.secuencia > 0" class="pa-0 ma-0 py-0 my-0"
                         cols="12" md="12" sm="12" style="border: 1px solid #000000;">
                    <v-row>
                      <v-col cols="12" md="8" sm="8">
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> {{LabelReimprecion.replace("REIMPRIMIR", "")}} #: </b>
                          {{ ReimprecionFacturaSeleccionada.secdoc }}</p>
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> FECHA : </b>
                          {{ FormatoFecha(ReimprecionFacturaSeleccionada.fecha) }}</p>
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> NCF : </b>
                          {{ ReimprecionFacturaSeleccionada.ncf }}</p>
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> CLIENTE : </b>
                          {{ ReimprecionFacturaSeleccionada.cliente }}</p>
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> VALOR : </b>
                          {{
                            currencyFormatter2TasaInf(getTasaInfo(ReimprecionFacturaSeleccionada.valor, ReimprecionFacturaSeleccionada.tasa), ReimprecionFacturaSeleccionada.tasa)
                          }}
                        </p>
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> COMENTARIO : </b>
                          {{ ReimprecionFacturaSeleccionada.comentario }}</p>
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> TURNO : </b>
                          {{ ReimprecionFacturaSeleccionada.turno!=null && ReimprecionFacturaSeleccionada.turno.hasOwnProperty('descripcion')? ReimprecionFacturaSeleccionada.turno.descripcion:''   }}</p>
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> FORMA DE PAGO : </b>
                          {{ ReimprecionFacturaSeleccionada.formapago }}</p>
                        <p v-if="ReimprecionFacturaSeleccionada.moneda!=null" class="pa-0 ma-0 py-0 my-0"
                           style="border: 1px dashed  #616161;"><b> MONEDA : </b>
                          ${{ ReimprecionFacturaSeleccionada.moneda.nombrecorto.trim() }}</p>
                      </v-col>
                      <v-col cols="12" md="4" sm="4" >

                        <div class="d-flex justify-center" style="border: 1px dashed  #616161;">
                          <p class="pa-0 ma-0 py-0 my-0" style="font-size:20px;"><b> ¿DESEA {{ LabelReimprecion }}?</b>
                          </p>
                        </div>
                         
                        <v-hover v-slot:default="{ hover }" close-delay="200">

                          <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red darken-3' : 'red'"
                                 :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                 block dark
                                 @click.prevent="NewReimprecionFacturaSeleccionada">

                            <h2>CANCELAR</h2>

                          </v-btn>
                        </v-hover>

                        <v-hover v-slot:default="{ hover }" close-delay="200">

                          <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'blue darken-3' : 'blue'"
                                 :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                 block dark
                                 @click.prevent="ImpriReimprimirFactura">

                            <h2>IMPRIMIR</h2>

                          </v-btn>
                        </v-hover>

                    <!-- -->
                      <v-col v-if=" BtnReimprecionvalue==3 || BtnReimprecionvalue==4 && getInfFactEletronica(ReimprecionFacturaSeleccionada)"  class="pa-0 ma-0 py-0 my-0 mt-2" cols="12" md="12" sm="12" style="border: 1px dashed  #616161;" >
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#BDBDBD;">
                          <span><b>Facturación Electrónica</b></span>
                        </v-col>
                        <v-row class="pt-1" no-gutters style="border: 1px dashed  #616161;">

                         <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                          <v-text-field id="formdisabledInput" :value="ReimprecionFacturaSeleccionada.signatureValue"
                                        autocomplete="off" dense
                                        disabled
                                        hide-details label=" signatureValue:" outlined style="font-size:13px;">
                            <template v-slot:prepend>
                              <i class="fa fa-shield" style="font-size: 13px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                          <v-text-field id="formdisabledInput" :value="ReimprecionFacturaSeleccionada.fechafirmadgii"
                                        autocomplete="off"
                                        dense disabled
                                        hide-details label="fechafirmadgii" outlined style="font-size:13px;">
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 13px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" md="12" sm="12">
                          <v-textarea id="formdisabledInput" :value="ReimprecionFacturaSeleccionada.qrdgii" auto-grow
                                      autocomplete="off" dense
                                      disabled hide-details label="QR:" outlined
                                      rows="1">
                            <template v-slot:prepend>
                              <i class="fa fa-commenting" style="font-size: 13px;"></i>
                            </template>
                          </v-textarea>
                        </v-col>
                        <v-col cols="12" md="12" sm="12">
                                                  <v-textarea id="formdisabledInput" :value="ReimprecionFacturaSeleccionada.trackId" auto-grow
                                                              autocomplete="off" dense
                                                              hide-details label="trackId:" outlined rows="1">
                                                    <template v-slot:prepend>
                                                      <i class="fa fa-commenting" style="font-size: 13px;"></i>
                                                    </template>
                                                  </v-textarea>
                                                </v-col>
                        </v-row>
                     
                      </v-col>
                    <!-- -->
                        
                      </v-col>
                    </v-row>
                    <p style="border: 1px dashed  #616161;">

                      <!-- Tabla ReimprecionFacturaSeleccionada de factura -->
                      <v-data-table v-if="BtnReimprecionvalue == 1" :headers="[
                      { text: 'FECHA', value: 'fecha', sortable: false, class: ['no-gutters black--text'] },
                      { text: 'FACTURA', value: 'factura', sortable: false, class: ['no-gutters black--text'] },
                      { text: 'VALOR ORIGINAL', value: 'valororiginal', sortable: false, class: ['no-gutters black--text'] },
                      { text: 'ABONO', value: 'abono', sortable: false, class: ['no-gutters black--text'] },
                      { text: 'PENDIENTE', value: 'pendientedespues', sortable: false, class: ['no-gutters black--text'] },
                    ]" :items="ReimprecionFacturaSeleccionada.DetalleList" :items-per-page="15" dense>

                        <template v-slot:item.fecha="props">
                          <span style="font-size:13px;">{{ FormatoFecha(props.item.nuevaFechaFactura) }}</span>
                        </template>

                        <template v-slot:item.factura="props">
                        <span v-if="props.item.hasOwnProperty('facturasventa') && props.item.facturasventa != null"
                              style="font-size:13px;">
                          {{ props.item.facturasventa.facturasventaPK.secuencia }}
                        </span>

                          <span
                            v-if="props.item.hasOwnProperty('notadebitoclientes') && props.item.notadebitoclientes != null"
                            style="font-size:13px;">
                          {{ props.item.notadebitoclientes.notadebitoclientesPK.secuencia }}
                        </span>
                        </template>

                        <template v-slot:item.valororiginal="props">

                        <span v-if="props.item.hasOwnProperty('facturasventa') && props.item.facturasventa != null"
                              style="font-size:13px;">
                          {{ currencyFormatter(props.item.facturasventa.valor) }}
                          <!-- <span style="display:none;">{{props.item.pendiente=props.item.facturasventa.valor-props.item.abono}}</span> -->
                        </span>
                          <span
                            v-if="props.item.hasOwnProperty('notadebitoclientes') && props.item.notadebitoclientes != null"
                            style="font-size:13px;">
                          {{ props.item.notadebitoclientes.valor }}
                            <!-- <span style="display:none;">{{props.item.pendiente=props.item.notadebitoclientes.valor-props.item.abono}}</span> -->
                        </span>
                        </template>

                        <template v-slot:item.abono="props">
                          <span style="font-size:13px;">{{ currencyFormatter(props.item.abono) }}</span>
                        </template>

                        <template v-slot:item.pendiente="props">
                          <!-- <span style="font-size:13px;">{{ currencyFormatter( props.item.pendiente) }}</span> -->
                          <span style="font-size:13px;">{{ currencyFormatter(props.item.pendiente) }}</span>
                        </template>

                        <template v-slot:item.pendientedespues="props">
                          <!-- <span style="font-size:13px;">{{ currencyFormatter( props.item.pendiente) }}</span> -->
                          <span style="font-size:13px;">{{
                              currencyFormatter(calcularReciboIngPendienteDespues(props.item))
                            }}</span>
                        </template>


                      </v-data-table>
                      <!-- Tabla ReimprecionFacturaSeleccionada de factura   -->

                      <!-- Tabla ReimprecionFacturaSeleccionada de varias-->
                      <v-data-table
                        v-if="BtnReimprecionvalue == 3"
                        :headers="[
                        { text: 'PRODUCTO', value: 'descripcion', sortable: false, class: ['no-gutters black--text'] },
                        { text: 'CANTIDAD', value: 'cantidad', sortable: false, class: ['no-gutters black--text'] },
                        { text: 'ITBIS', value: 'itbis', sortable: false, class: ['no-gutters black--text'] },
                        { text: 'VALOR', value: 'valor', sortable: false, class: ['no-gutters black--text'] },
                        { text: 'DESCUENTO', value: 'descu', sortable: false, class: ['no-gutters black--text'] },
                        { text: 'IMPORTE', value: 'importe', sortable: false, class: ['no-gutters black--text'] },
                      ]" :items="ReimprecionFacturaSeleccionada.DetalleList" :items-per-page="15" dense>


                        <template v-slot:item.valor="props">
                          <!-- <span style="font-size:13px;" >{{currencyFormatter( (props.item.cantidad * props.item.precio)+props.item.valorimpuesto)}}</span> -->
                          <!-- <span style="font-size:13px;">{{ currencyFormatter(props.item.precio) }}</span> -->
                          <span style="font-size:13px;">
                          {{ currencyFormatter2TasaInf(getTasaInfo(props.item.precio, ReimprecionFacturaSeleccionada.tasa), ReimprecionFacturaSeleccionada.tasa)}}
                        </span>
                        </template>

                        <template v-slot:item.itbis="props">
                          <span style="font-size:13px;">
                          {{ currencyFormatter2TasaInf(getTasaInfo(props.item.valorimpuesto, ReimprecionFacturaSeleccionada.tasa), ReimprecionFacturaSeleccionada.tasa)}}
                        </span>
                        </template>

                        <template v-slot:item.descu="props">

                          <span style="font-size:13px;">
                          ($.{{ currencyFormatter2TasaInf(getTasaInfo(props.item.valordescuento, ReimprecionFacturaSeleccionada.tasa), ReimprecionFacturaSeleccionada.tasa)}})  
                          (%.{{ currencyFormatter2TasaInf(getTasaInfo(props.item.descuento, ReimprecionFacturaSeleccionada.tasa), ReimprecionFacturaSeleccionada.tasa)}})
                        </span>
                        </template>


                        <template v-slot:item.descripcion="props">
                          <span style="font-size:13px;">{{ props.item.descripcion }}</span>
                        </template>

                        <template v-slot:item.cantidad="props">
                          <span style="font-size:13px;">{{ props.item.cantidad }}</span>
                        </template>

                        <template v-slot:item.importe="props">
                          <span v-if="IncluirItbisGeneral == true" style="font-size:13px;">
                          {{currencyFormatter2TasaInf(getTasaInfo((props.item.cantidad * props.item.precio), ReimprecionFacturaSeleccionada.tasa), ReimprecionFacturaSeleccionada.tasa)
                            }}
                        </span>
                          <span v-if="IncluirItbisGeneral == false" style="font-size:13px;">
                          {{currencyFormatter2TasaInf(getTasaInfo(((props.item.cantidad * props.item.precio) + (props.item.valorimpuesto * props.item.cantidad)), ReimprecionFacturaSeleccionada.tasa), ReimprecionFacturaSeleccionada.tasa)
                            }}
                        </span>
                        </template>
                      </v-data-table>
                      <!-- Tabla ReimprecionFacturaSeleccionada de factura   -->


                      <!-- Tabla ReimprecionFacturaSeleccionada de varias-->
                      <v-data-table
                        v-if="BtnReimprecionvalue == 6 || BtnReimprecionvalue == 7"
                        :headers="[
                        { text: 'PRODUCTO', value: 'descripcion', sortable: false, class: ['no-gutters black--text'] },
                        { text: 'CANTIDAD', value: 'cantidad', sortable: false, class: ['no-gutters black--text'] },
                        { text: 'VALOR', value: 'valor', sortable: false, class: ['no-gutters black--text'] },
                        { text: 'IMPORTE', value: 'importe', sortable: false, class: ['no-gutters black--text'] },
                      ]" :items="ReimprecionFacturaSeleccionada.DetalleList" :items-per-page="15" dense>

                        <template v-slot:item.valor="props">
                          <!-- <span style="font-size:13px;" >{{currencyFormatter( (props.item.cantidad * props.item.precio)+props.item.valorimpuesto)}}</span> -->
                          <!-- <span style="font-size:13px;">{{ currencyFormatter(props.item.precio) }}</span> -->
                          <span style="font-size:13px;">
  {{
                              currencyFormatter2TasaInf(getTasaInfo(props.item.precio, ReimprecionFacturaSeleccionada.tasa), ReimprecionFacturaSeleccionada.tasa)
                            }}
</span>


                        </template>

                        <template v-slot:item.descripcion="props">
                          <span style="font-size:13px;">{{ props.item.descripcion }}</span>
                        </template>

                        <template v-slot:item.cantidad="props">
                          <span style="font-size:13px;">{{ props.item.cantidad }}</span>
                        </template>

                        <template v-slot:item.importe="props">
                          <!-- <span style="font-size:13px;">{{ currencyFormatter( props.item.importe) }}</span> -->
                          <!-- <span style="font-size:13px;" >{{currencyFormatter( (props.item.cantidad * props.item.precio))}}</span> -->

                          <!--  <span style="font-size:13px;" v-if="IncluirItbisGeneral == true">
                          {{ currencyFormatter((props.item.cantidad * props.item.precio)) }}
                        </span>
                        <span style="font-size:13px;" v-if="IncluirItbisGeneral == false">
                          {{ currencyFormatter((props.item.cantidad * props.item.precio) + (props.item.valorimpuesto *
                            props.item.cantidad))
                          }}
                        </span>-->

                          <span v-if="IncluirItbisGeneral == true" style="font-size:13px;">
                          {{
                              currencyFormatter2TasaInf(getTasaInfo((props.item.cantidad * props.item.precio), ReimprecionFacturaSeleccionada.tasa), ReimprecionFacturaSeleccionada.tasa)
                            }}
                        </span>
                          <span v-if="IncluirItbisGeneral == false" style="font-size:13px;">
                          {{
                              currencyFormatter2TasaInf(getTasaInfo(((props.item.cantidad * props.item.precio) + (props.item.valorimpuesto * props.item.cantidad)), ReimprecionFacturaSeleccionada.tasa), ReimprecionFacturaSeleccionada.tasa)
                            }}
                        </span>


                        </template>
                      </v-data-table>
                      <!-- Tabla ReimprecionFacturaSeleccionada de factura   -->


                      <!-- Tabla ReimprecionFacturaSeleccionada de factura -->
                      <v-data-table v-if="BtnReimprecionvalue == 4" :headers="[
                      { text: 'PRODUCTO', value: 'producto.descripcion', sortable: false, class: ['no-gutters black--text'] },
                      { text: 'CANTIDAD', value: 'cantidad', sortable: false, class: ['no-gutters black--text'] },
                      // { text: 'COSTO', value: 'costo', sortable: false, class: ['no-gutters black--text'] },
                      { text: 'PRECIO', value: 'precio', sortable: false, class: ['no-gutters black--text'] },
                      // { text: 'VALOR', value: 'valor', sortable: false, class: ['no-gutters black--text'] },

                    ]" :items="ReimprecionFacturaSeleccionada.DetalleList" :items-per-page="15" dense>

                        <template v-slot:item.valor="props">
                          <!-- <span style="font-size:13px;" >{{currencyFormatter( (props.item.cantidad * props.item.precio)+props.item.valorimpuesto)}}</span> -->
                          <span style="font-size:13px;">
                        <!-- {{ currencyFormatter(ReimprecionItemSelectValor(props.item))}} -->
                        {{
                              currencyFormatter2TasaInf(getTasaInfo(ReimprecionItemSelectValor(props.item), ReimprecionFacturaSeleccionada.tasa), ReimprecionFacturaSeleccionada.tasa)
                            }}
                        </span>
                        </template>

                        <template v-slot:item.producto.descripcion="props">
                          <span style="font-size:13px;">{{ props.item.producto.descripcion }}</span>
                        </template>

                        <template v-slot:item.cantidad="props">
                          <span style="font-size:13px;">{{ props.item.cantidad }}</span>
                        </template>

                        <template v-slot:item.costo="props">
                        <span style="font-size:13px;">
                          <!-- {{ currencyFormatter(props.item.costo) }} -->
                          {{
                            currencyFormatter2TasaInf(getTasaInfo(props.item.costo, ReimprecionFacturaSeleccionada.tasa), ReimprecionFacturaSeleccionada.tasa)
                          }}
                        </span>
                        </template>

                      </v-data-table>
                      <!-- Tabla ReimprecionFacturaSeleccionada de factura   -->


                    </p>

                  </v-col>
                  <!-- fn  informacion de fatura  selecionada reimprecion -->


                </div>
              </v-col>


            </v-card>
          </v-col>

        </div>
      </v-card>

    </v-dialog>
    <!-------------------------------------------------------- fn Modal- Reimprecion-->


    <!-- ------------------------------------------------------ Modal- Aceptar Devolucion-->
    <v-dialog v-model="dialogAceptarDevolucion" label="Modal Aceptar Devolucion" max-height="85%" max-width="95%"
              persistent transition="fab-transition">

      <!--------------------- Aceptar Devolucion ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Información
                devolución
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Información devolución: </span>
              cliente y cedula </i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="cancelarAceptarDevolucion()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar </span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="grey" dark small @click="newnewAceptarDevolucion()" v-on="on">

                    <v-avatar color="transparent" size="28" tile>
                      <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                    </v-avatar>


                    <i style="font-size: 20px;"> </i>
                    NUEVO
                  </v-btn>
                </template>
                <span>NUEVO: Limpia los campo para un nuevo registro</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="SalvarAceptarDevolucion()"
                         v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Aceptar y finalizar devolución </span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
        <v-card>
          <!-- columna informacion  -->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> FINALIZAR DEVOLUCIÓN </b>
                <v-form ref="formAceptarDevolucion" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <!-- Row 1      ------------------------------------------->

                  <v-row>

                    <v-col cols="12" md="12" sm="12">


                      <!-- ----------------------------- nombre -->

                      <v-text-field v-model="AceptarDevolucion.nombre" :rules="[$rules.required]" autocomplete="off"
                                    dense label="* Cliente:"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                      <v-text-field v-model="AceptarDevolucion.cedula" v-mask="MakCelRnc"
                                    :rules="[$rules.RulesCelRncValidar]" autocomplete="off" dense
                                    label=" Cedula/RNC:" maxlength="13"
                                    outlined
                                    @blur="MakaraCelAceptarDevolucion"
                                    @focus="MakCelRnc = '#############'"
                                    v-on:blur="validandoCedRnc(AceptarDevolucion.cedula)">
                        <template v-slot:prepend>
                          <i class="fa fa-id-card-o" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                    </v-col>

                  </v-row>
                  <!-- Row 2 ------------------------------------------->

                </v-form>
              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal-Aceptar Devolucion -->


    <!-------------------------------------------------------- Modal-hacer devolucion -->
    <v-dialog v-model="dialogDevolucion" fullscreen hide-overlay label="Modal Devolucion  " persistent
              transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Devolución
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>Devolución: </span></i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark
                         small @click="NewDevolucionFacturaSeleccionada(), dialogDevolucion = false, codUsuAutorDev=$store.getters.GetdatosInfUsu.usuario.codigo" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Cancela y retornar atrás</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>


        </v-toolbar>

        <v-col cols="12" md="12" sm="12">
          <v-card color="grey lighten-3">

            <v-form ref="formReimprecion" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
              <v-row>

                <v-col class="py-0 my-0" cols="12" md="4" sm="4">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model.number="DevolucionBusqueda.secuencia" autocomplete="off" dense
                                    label="# Digite Número Factura:" outlined
                                    style="font-size: 12px;" type="number"
                                    v-on="on" @keydown.enter="buscarFacturaDevolucion">
                        <template v-slot:prepend>
                          <i class="fa fa-hashtag" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra el número de factura que deseamos búscar.</span>
                    </i>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-form>

            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
              <div style="border: 1px solid #000000;">

                <!-- fn Tabla Busqueda Devolucion -->
                <div v-if="DevolucionFacturaSeleccionada.secuencia == 0">
                  <v-data-table v-model="DevolucionSelected" :headers="[
                      { text: 'Fecha', sortable: false, value: 'fecha', width: 120 },
                      { text: '# Secuencia', sortable: false, value: 'sec', width: 129 },
                      { text: 'Cliente', sortable: false, value: 'clinica.nombre', width: 129 },
                      { text: 'Valor', sortable: false, value: 'valor', width: 'auto', width: 105 },
                    ]" :items="filterFacturaDevolucion(DevolucionlistFactCliente)" :show-select="true"
                                :single-select="true" class="RowSelectColor"
                                dense item-key="indx" @item-selected="DevolucionObtenerDatoSelect"
                                @click:row="DevolucionDatostabla">

                    <template v-slot:item.fecha="props">
                      <span style="font-size:13px; display:none;">{{
                          props.item.indx =
                            DevolucionlistFactCliente.indexOf(props.item)
                        }}</span>
                      <span style="font-size:13px;">{{ FormatoFecha(props.item.fecha) }}</span>
                    </template>

                    <template v-slot:item.facturasventaPK.secuencia="props">
                      <span style="font-size:13px;">{{ props.item.facturasventaPK.secuencia }} </span>
                    </template>

                    <template v-slot:item.sec="props">
                      <span style="font-size:13px;">{{ props.item.documentoFactura.nombrecorto.trim() }}-{{
                          props.item.facturasventaPK.secuencia
                        }} </span>
                    </template>

                    <template v-slot:item.clinica.nombre="props">
                      <span v-if="props.item.cliente != null" style="font-size:13px;">{{ props.item.cliente.nombre }}
                      </span>
                    </template>

                    <template v-slot:item.valor="props">
                      <!-- <span style="font-size:13px;">{{ currencyFormatter(props.item.valor) }}</span> -->
                      <span style="font-size:13px;">{{
                          currencyFormatter2TasaInf(getTasaInfo(props.item.valor, props.item.tasa), props.item.tasa)
                        }}</span>
                    </template>
                  </v-data-table>
                </div>
                <!-- fn Tabla Busqueda Devolucion -->

                <!-- Devolucion Selecionada -->
                <v-col v-if="DevolucionFacturaSeleccionada.secuencia > 0" class="pa-0 ma-0 py-0 my-0"
                       cols="12" md="12" sm="12" style="border: 1px solid #000000;">
                  <v-row>
                    <v-col cols="12" md="8" sm="8">
                      <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> FACTURA #: </b>
                        {{ DevolucionFacturaSeleccionada.secuencia }}</p>
                      <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> FECHA : </b>
                        {{ FormatoFecha(DevolucionFacturaSeleccionada.fecha) }}</p>
                      <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> NCF : </b>
                        {{ DevolucionFacturaSeleccionada.ncf }}</p>
                      <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> CLIENTE : </b>
                        {{ DevolucionFacturaSeleccionada.cliente }}</p>
                      <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> VALOR : </b>
                        <!-- {{ currencyFormatter(DevolucionFacturaSeleccionada.valortotal) }} -->
                        {{
                          currencyFormatter2TasaInf(getTasaInfo(DevolucionFacturaSeleccionada.valortotal, DevolucionFacturaSeleccionada.tasa), DevolucionFacturaSeleccionada.tasa)
                        }}
                      </p>
                      <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> FORMA DE PAGO : </b>
                        {{ DevolucionFacturaSeleccionada.formapago }}</p>
                      <p v-if="DevolucionFacturaSeleccionada.moneda!=null" class="pa-0 ma-0 py-0 my-0"
                         style="border: 1px dashed  #616161;"><b> MONEDA : </b>
                        ${{ DevolucionFacturaSeleccionada.moneda.nombrecorto.trim() }}</p>
                      <v-textarea v-model="DevolucionFacturaSeleccionada.comentario" autocomplete="off" dense
                                  hide-details label="comentario:"
                                  outlined rows="2">
                        <template v-slot:prepend>
                          <i class="fa fa-commenting" style="font-size: 20px;"></i>
                        </template>
                      </v-textarea>
                      <v-row>
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6">

                          <v-checkbox
                            v-if="DevolucionFacturaSeleccionada.tarjeta > 0 && DevolucionFacturaSeleccionada.valortotal==DevolucionFacturaSeleccionada.tarjeta"
                            v-model="DevolucionFacturaSeleccionada.devtarjeta"
                            class="mt-0 ma-3" color="teal " hide-details label=""
                            @change="changeDevolucionTarjeta">
                            <template v-slot:label>
                              <strong v-if="DevolucionFacturaSeleccionada.devtarjeta == true"
                                      style="color:#000000; font-size:13px;">Devolucion en Tarjeta: Si</strong>
                              <strong v-if="DevolucionFacturaSeleccionada.devtarjeta == false"
                                      style="color:#000000; font-size:13px;">Devolucion en Tarjeta: No</strong>
                            </template>
                          </v-checkbox>

                          <v-checkbox
                            v-if="DevolucionFacturaSeleccionada.Pagoefec > 0 && DevolucionFacturaSeleccionada.cheques == 0 &&
                              DevolucionFacturaSeleccionada.cupones == 0 && DevolucionFacturaSeleccionada.cxc == 0 &&
                              DevolucionFacturaSeleccionada.puntos == 0 && DevolucionFacturaSeleccionada.tarjeta == 0 &&
                              DevolucionFacturaSeleccionada.valorNc == 0 && DevolucionFacturaSeleccionada.transferencia == 0"
                            v-model="DevolucionFacturaSeleccionada.efectivo"
                            class="mt-0 ma-3" color="teal " hide-details label=""
                            @change="changeDevolucionEfectivo">
                            <template v-slot:label>
                              <strong v-if="DevolucionFacturaSeleccionada.efectivo == true"
                                      style="color:#000000; font-size:13px;">Devolucion en Efectivo: Si</strong>
                              <strong v-if="DevolucionFacturaSeleccionada.efectivo == false"
                                      style="color:#000000; font-size:13px;">Devolucion en Efectivo: No</strong>
                            </template>
                          </v-checkbox>
                        </v-col>


                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6">
                          <v-checkbox v-model="DevolucionFacturaSeleccionada.quitaritbis" class="mt-0 ma-3"
                                      color="teal "
                                      hide-details label="" @change="DevolucionValorTotal()"
                                      v-on:change="verificarVenFacDev()">
                            <template v-slot:label>
                              <strong v-if="DevolucionFacturaSeleccionada.quitaritbis == true"
                                      style="color:#000000; font-size:13px;">Quitar itbis: Si</strong>
                              <strong v-if="DevolucionFacturaSeleccionada.quitaritbis == false"
                                      style="color:#000000; font-size:13px;">Quitar itbis: No</strong>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>

                    </v-col>
                    <v-col cols="12" md="4" sm="4">

                      <br>
                      <v-hover v-slot:default="{ hover }" close-delay="200">

                        <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red darken-3' : 'red'"
                               :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                               block dark
                               @click.prevent="NewDevolucionFacturaSeleccionada">

                          <h2>CANCELAR</h2>

                        </v-btn>
                      </v-hover>

                      <v-hover v-slot:default="{ hover }" close-delay="200">

                        <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'blue darken-3' : 'blue'"
                               :disabled="!ejecucion" :elevation="hover ? 24 : 2"
                               :loading="!ejecucion" :outlined="hover ? false : true"
                               block dark @click.prevent="openAceptarDevolucion">

                          <h2>FINALIZAR</h2>
                          <template v-slot:loader>
                          <span class="custom-loader">
                            <i class="fa fa-refresh" light style="font-size: 28px; color:#424242;"> </i>

                            <!-- <v-icon light>cached</v-icon> -->
                          </span>
                          </template>

                        </v-btn>
                      </v-hover>

                    </v-col>
                  </v-row>
                  <!-- Tabla ReimprecionFacturaSeleccionada de factura -->
                  <p style="border: 1px dashed  #616161;">
                    <strong style="color:#000000; font-size:13px;">El valor de la devolucion sera RD$:
                      {{ currencyFormatter2(DevolucionFacturaSeleccionada.valordevolucion) }}</strong>
                    <v-data-table v-model="DevolucionFacturaSeleccionada.SeletDetalleList" :headers="[
                        { text: 'DESCRIPCIÓN', value: 'descripcion', sortable: false, width: 'auto', class: ['no-gutters black--text'] },
                        { text: 'CANTIDAD', value: 'cantidad', sortable: false, width: 200, class: ['no-gutters black--text'] },
                        { text: 'PRECIO', value: 'precio', sortable: false, width: 200, class: ['no-gutters black--text'] },
                        { text: 'ITBIS', value: 'valorimpuesto', sortable: false, width: 200, class: ['no-gutters black--text'] },
                        { text: 'VALOR', value: 'valor', sortable: false, width: 200, class: ['no-gutters black--text'] },
                      ]"
                                  :items="DevolucionFacturaSeleccionada.DetalleList" :items-per-page="15"
                                  :show-select="true" dense item-key="indx"
                                  @item-selected="SelcDevObtenerDatoSelect"
                                  @toggle-select-all="AllSelcDevObtenerDatoSelect">
                      <template v-slot:item.descripcion="props">
                        <span style="font-size:13px; display:none;">{{
                            props.item.indx =
                              DevolucionFacturaSeleccionada.DetalleList.indexOf(props.item)
                          }}</span>
                        <span style="font-size:13px;">{{ props.item.descripcion }}</span>
                      </template>

                      <template v-slot:item.cantidad="props">

                        <!-- <span style="font-size:13px; display:none;">{{props.item.cantidad = props.item.cantidadPendiente}}</span> -->

                        <VueAutonumeric v-model.number="props.item.cantidad" autocomplete="off" dense hide-details
                                        label="" outlined
                                        style="font-size:13px;" @blur="DevolucionVerificaCantidad(props.item)"
                                        v-on:blur="DevolucionValorTotal()"
                                        v-on:input="DevoItemCant()">
                        </VueAutonumeric>
                      </template>

                      <template v-slot:item.precio="props">
                        <span style="font-size:13px;">
                          <!-- {{ currencyFormatter(props.item.precio) }} -->
                          {{
                            currencyFormatter2TasaInf(getTasaInfo(props.item.precio, DevolucionFacturaSeleccionada.tasa), DevolucionFacturaSeleccionada.tasa)
                          }}
                        </span>
                      </template>
                      <template v-slot:item.valorimpuesto="props">
                        <span style="font-size:13px;">
                          <!-- {{ currencyFormatter(props.item.precio) }} -->
                          {{
                            currencyFormatter2TasaInf(getTasaInfo(props.item.valorimpuesto, DevolucionFacturaSeleccionada.tasa), DevolucionFacturaSeleccionada.tasa)
                          }}
                        </span>
                      </template>

                      <template v-slot:item.valor="props">

                        <span style="font-size:13px;">
                          <!-- {{ currencyFormatter(DevolucionValor(props.item)) }} -->
                          {{
                            currencyFormatter2TasaInf(getTasaInfo(DevolucionValor(props.item), DevolucionFacturaSeleccionada.tasa), DevolucionFacturaSeleccionada.tasa)
                          }}
                        </span>


                      </template>

                    </v-data-table>
                    <!-- Tabla ReimprecionFacturaSeleccionada de factura   -->
                  </p>


                </v-col>
                <!-- fn devolucion Selecionada -->

              </div>
            </v-col>
          </v-card>
        </v-col>

      </v-card>

    </v-dialog>
    <!-------------------------------------------------------- fn Modal-hacer devolucion -->

    <!-------------------------------------------------------- Modal-Anulacion de factura -->
    <v-dialog v-model="dialogAnulacion" fullscreen hide-overlay label="Modal Anulacion " persistent
              transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Anulación de
                factura
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>Anulación de factura: </span></i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="NewAnulacionFacturaSeleccionada()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Cancela y retornar atrás</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>


        </v-toolbar>

        <v-col cols="12" md="12" sm="12">
          <v-card color="grey lighten-3">

            <v-form ref="formAnulacion" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
              <v-row>

                <v-col class="py-0 my-0" cols="12" md="4" sm="4">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model.number="AnulacionBusqueda.secuencia" autocomplete="off" dense
                                    label="# Digite Número Factura:" outlined
                                    style="font-size: 12px;" type="number"
                                    v-on="on"
                                    @keydown.enter="buscarFacturaAnulada">
                        <template v-slot:prepend>
                          <i class="fa fa-hashtag" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra el número de factura que deseamos búscar.</span>
                    </i>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-form>

            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
              <div style="border: 1px solid #000000;">

                <!-- fn Tabla Busqueda anulacion -->
                <!-- && !AnulacionFacturaSeleccionada.hasOwnProperty('secuencia') ||  AnulacionFacturaSeleccionada.secuencia==0 -->
                <div v-if="AnulacionFacturaSeleccionada == null">
                  <v-data-table v-model="AnulacionSelected" :headers="[
                      { text: 'Fecha', sortable: false, value: 'fecha', width: 120 },
                      { text: '# Secuencia', sortable: false, value: 'sec', width: 129 },
                      { text: 'Cliente', sortable: false, value: 'clinica.nombre', width: 129 },
                      { text: 'Valor', sortable: false, value: 'valor', width: 'auto', width: 105 },
                    ]" :items="AnulacionlistFactCliente"
                                :show-select="true" :single-select="true" class="RowSelectColor elevation-1 TbSize13"
                                dense item-key="indx" @item-selected="AnularObtenerDatoSelect"
                                @click:row="AnularDatostabla">

                    <template v-slot:item.fecha="props">
                      <span style="font-size:13px; display:none;">{{
                          props.item.indx =
                            AnulacionlistFactCliente.indexOf(props.item)
                        }}</span>
                      <span style="font-size:13px;">{{ FormatoFecha(props.item.fecha) }}</span>
                    </template>

                    <template v-slot:item.sec="props">
                      <span style="font-size:13px;">{{ props.item.documentoFactura.nombrecorto.trim() }}-{{
                          props.item.facturasventaPK.secuencia
                        }} </span>
                    </template>


                    <template v-slot:item.clinica.nombre="props">
                      <span v-if="props.item.cliente != null" style="font-size:13px;">{{ props.item.cliente.nombre }}
                      </span>
                    </template>

                    <template v-slot:item.valor="props">
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.valor) }}</span>
                    </template>
                  </v-data-table>
                </div>
                <!-- fn Tabla Busqueda anulacion -->

                <!-- anulacion Selecionada -->
                <v-col v-if="AnulacionFacturaSeleccionada != null" class="pa-0 ma-0 py-0 my-0"
                       cols="12" md="12" sm="12" style="border: 1px solid #000000;">
                  <v-row no-gutters>
                    <v-col cols="12" md="5" sm="5" style="font-size: 13px;">
                      <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> FACTURA #: </b>
                        {{ AnulacionFacturaSeleccionada.facturasventaPK.secuencia }}</p>
                      <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> FECHA : </b>
                        {{ FormatoFecha(new Date(AnulacionFacturaSeleccionada.fecha).toISOString().substr(0, 10)) }}</p>
                      <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> NCF : </b>
                        {{ AnulacionFacturaSeleccionada.ncf }}</p>
                      <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> CLIENTE : </b>
                        {{
                          (AnulacionFacturaSeleccionada.cliente == null ? ""
                            : AnulacionFacturaSeleccionada.cliente.nombre)
                        }}</p>
                      <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> VALOR : </b>
                        {{ currencyFormatter(AnulacionFacturaSeleccionada.valor) }}</p>

                    </v-col>

                    <v-col cols="12" md="3" sm="3" style="font-size: 13px;">
                      <p v-if="AnulacionFacturaSeleccionada.efectivo > 0" class="pa-0 ma-0 py-0 my-0"
                         style="border: 1px dashed  #616161;"><b> EFECTIVO : </b>
                        {{ currencyFormatter(AnulacionFacturaSeleccionada.efectivo) }}</p>
                      <p v-if="AnulacionFacturaSeleccionada.tarjeta > 0" class="pa-0 ma-0 py-0 my-0"
                         style="border: 1px dashed  #616161;"><b> TIPO TARJETA : </b>
                        {{ AnulacionFacturaSeleccionada.tipoTarjeta.nombre }}</p>
                      <p v-if="AnulacionFacturaSeleccionada.tarjeta > 0" class="pa-0 ma-0 py-0 my-0"
                         style="border: 1px dashed  #616161;"><b> #TARJETA : </b>
                        {{ AnulacionFacturaSeleccionada.numtar }}</p>
                      <p v-if="AnulacionFacturaSeleccionada.tarjeta > 0" class="pa-0 ma-0 py-0 my-0"
                         style="border: 1px dashed  #616161;"><b> VALOR TARJETA : </b>
                        {{ currencyFormatter(AnulacionFacturaSeleccionada.tarjeta) }}</p>
                      <p v-if="AnulacionFacturaSeleccionada.cheques > 0" class="pa-0 ma-0 py-0 my-0"
                         style="border: 1px dashed  #616161;"><b> CHEQUE : </b>
                        {{ currencyFormatter(AnulacionFacturaSeleccionada.cheques) }}</p>
                      <p v-if="AnulacionFacturaSeleccionada.cupones > 0" class="pa-0 ma-0 py-0 my-0"
                         style="border: 1px dashed  #616161;"><b> CUPONES : </b>
                        {{ currencyFormatter(AnulacionFacturaSeleccionada.cupones) }}</p>
                      <p v-if="AnulacionFacturaSeleccionada.valorNc > 0" class="pa-0 ma-0 py-0 my-0"
                         style="border: 1px dashed  #616161;"><b> NOTA CREDITO : </b>
                        {{ currencyFormatter(AnulacionFacturaSeleccionada.valorNc) }}</p>
                      <p v-if="AnulacionFacturaSeleccionada.cxc > 0" class="pa-0 ma-0 py-0 my-0"
                         style="border: 1px dashed  #616161;"><b> CREDITO(CXC): </b>
                        {{ currencyFormatter(AnulacionFacturaSeleccionada.cxc) }}</p>
                      <p v-if="AnulacionFacturaSeleccionada.transferencia > 0" class="pa-0 ma-0 py-0 my-0"
                         style="border: 1px dashed  #616161;"><b> TRANSFERENCIA: </b>
                        {{ currencyFormatter(AnulacionFacturaSeleccionada.transferencia) }}</p>
                      <p v-if="AnulacionFacturaSeleccionada.puntos > 0" class="pa-0 ma-0 py-0 my-0"
                         style="border: 1px dashed  #616161;"><b> PUNTO: </b>
                        {{ currencyFormatter(AnulacionFacturaSeleccionada.puntos) }}</p>
                    </v-col>

                    <v-col class="px-2" cols="12" md="4" sm="4">

                      <br>

                      <v-hover v-slot:default="{ hover }" close-delay="200">

                        <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'grey darken-3' : 'grey'"
                               :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                               block dark
                               @click.prevent="CancelarAnulacionFacturaSeleccionada">

                          <h2>CANCELAR</h2>

                        </v-btn>
                      </v-hover>

                      <v-hover v-slot:default="{ hover }" close-delay="200">

                        <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red darken-3' : 'red'"
                               :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                               block dark
                               @click.prevent="AnulacionFacturaAnular">

                          <h2>ANULAR</h2>

                        </v-btn>
                      </v-hover>


                    </v-col>

                    <!-- <v-textarea
                      autocomplete="off"
                        label="comentario:"
                        rows="3"
                        dense
                        outlined
                        v-model="AnulacionFacturaSeleccionada.comentario"

                      >
                        <template v-slot:prepend>
                          <i style="font-size: 20px;" class="fa fa-commenting"></i>
                        </template>
                      </v-textarea>
    cheques,Pagoefec,cupones,puntos,valorNc,cxc,tarjeta,transferencia,efectivo -->

                  </v-row>
                  <!-- :class="`d-flex justify-center`"  -->
                  <center class="pa-0 ma-0 py-0 my-0">
                    <v-form ref="formAnulacion" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
                      <v-col class="pb-0 mb-0" cols="12" md="8" sm="8">

                        <v-combobox v-model="TipoAnulacion" :items="RTipoAnulacion" :rules="[$rules.required]"
                                    autocomplete="off"
                                    dense
                                    item-text="descripcion" label="Motivo de anulación:" outlined
                                    @blur="SelctCbMotivoAnulacion">
                          <template v-slot:prepend>
                            <i class=" fa fa-ban" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                      </v-col>
                    </v-form>
                  </center>
                  <!-- Tabla ReimprecionFacturaSeleccionada de factura -->
                  <!-- :show-select="true"
            v-model="AnulacionFacturaSeleccionada.SeletDetalleList" -->
                  <p style="border: 1px dashed  #616161;">
                    <v-data-table :headers="[
                      { text: 'DESCRIPCIÓN', value: 'descripcion', sortable: false, width: 'auto', class: ['no-gutters black--text'] },
                      { text: 'CANTIDAD', value: 'cantidad', sortable: false, width: 200, class: ['no-gutters black--text'] },
                      { text: 'PRECIO', value: 'precio', sortable: false, width: 200, class: ['no-gutters black--text'] },
                    ]" :items="AnulacionFacturaSeleccionada.facturasventaDetalleList" :items-per-page="15"
                                  class="elevation-1 TbSize13" dense item-key="indx">
                      <template v-slot:item.descripcion="props">
                        <span style="font-size:13px; display:none;">{{
                            props.item.indx =
                              AnulacionFacturaSeleccionada.facturasventaDetalleList.indexOf(props.item)
                          }}</span>
                        <span style="font-size:13px;">{{ props.item.descripcion }}</span>
                      </template>

                      <template v-slot:item.cantidad="props">
                        <!-- <span style="font-size:13px; display:none;">{{props.item.cantidad = props.item.cantidadPendiente}}</span> -->
                        <span style="font-size:13px;">{{ props.item.cantidad }}</span>
                      </template>

                      <template v-slot:item.precio="props">
                        <span style="font-size:13px;">{{ currencyFormatter(props.item.precio) }}</span>
                      </template>
                    </v-data-table>
                    <!-- Tabla ReimprecionFacturaSeleccionada de factura   -->
                  </p>


                </v-col>
                <!-- fn anulacion Selecionada -->

              </div>
            </v-col>
          </v-card>
        </v-col>

      </v-card>

    </v-dialog>
    <!-------------------------------------------------------- fn Modal- Anulacion de factura-->


    <!--------------------------------------------------------   Modal-Recibo de ingreso -->
    <!---   Modal-Recibo de ingreso classico -->
    <div v-if="$store.getters.GetConfiguracionGeneral.configPv.reciboIngresoAvanzadopv==false">
      <v-dialog v-model="dialogReciboIngreso" fullscreen hide-overlay label="Modal Recibo de ingreso" persistent
                transition="dialog-bottom-transition">
        <div v-if="dialogReciboIngreso" v-dirkeydown="reciboIngresoKeyCtrl">
          <v-card>
            <v-toolbar color="#dd4b39" dark dense>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">

                  <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Recibo de
                    ingreso
                  </v-toolbar-title>

                </template>
                <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>Recibo de ingreso: </span> Crea
                  ,
                  Modificar cliente y muestra el historial de compra</i>

              </v-tooltip>

              <v-spacer></v-spacer>

              <v-card-actions>
                <v-btn-toggle>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn id="boton-mini" color="orange" dark
                             small @click="dialogReciboIngreso = false, NewclienteSeleccionado()" v-on="on">
                        <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                        CANCELAR
                      </v-btn>
                    </template>
                    <span>CANCELAR: Cancela y retornar atrás</span>
                  </v-tooltip>

                  <v-tooltip v-if="ReciboIngresoFactPendHist == true" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn id="boton-mini" color="light-green lighten-1" dark
                             small @click="ReciboIngresoFactPendHist = false, historialClieList()" v-on="on">

                        <v-avatar color="transparent" size="28" tile>
                          <img alt="HISTORIAL" src="@/assets/icons_pv/extras/historial.png">
                        </v-avatar>


                        <i style="font-size: 20px;"> </i>
                        HISTORIAL
                      </v-btn>
                    </template>
                    <span>HISTORIAL: historial factura</span>
                  </v-tooltip>


                  <v-tooltip v-if="ReciboIngresoFactPendHist == false" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn id="boton-mini" color="light-green lighten-1" dark
                             small
                             @click="ReciboIngresoFactPendHist = true" v-on="on">

                        <v-avatar color="transparent" size="28" tile>
                          <img alt="FACTURA PENDIENTE" src="@/assets/icons_pv/menu/recibo64.png">
                        </v-avatar>


                        <i style="font-size: 20px;"> </i>
                        FACTURA PENDIENTE
                      </v-btn>
                    </template>
                    <span>FACTURA PENDIENTE: Muestra las facturas pendiente el cliente</span>
                  </v-tooltip>


                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn id="boton-mini" color="light-blue darken-4" dark small
                             @click="SalvarReciboIngresoFacPen"
                             v-on="on">
                        <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                        SALVAR
                      </v-btn>
                    </template>
                    <span>SALVAR: Guarda Recibo de ingreso y retornar atrás, Al presionar la tecla (CTRL), ejecuta este boton </span>
                  </v-tooltip>


                </v-btn-toggle>

              </v-card-actions>
            </v-toolbar>

            <v-col cols="12" md="12" sm="12">
              <v-row>
                <!--------- columna 1 Recibo de ingreso ---------->
                <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6" style="border: 1px solid #000000;">
                  <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                    <span :class="`d-flex justify-center white--text`"><b>Datos e Información</b></span>
                  </v-col>

                  <!-- columna Recibo de ingreso-->
                  <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="border: 1px solid #000000;">
                    <v-card color="grey lighten-3">
                      <b :class="`d-flex justify-center`"> CLIENTE</b>
                      <span>
    <b>Nota:</b><span style="color: #C62828;"> Salvar al presionar tecla (CTRL).</span>
 </span>
                      <v-col v-if="clienteFactura != null" class="pa-0 ma-0 py-0 my-0"
                             cols="12"
                             md="12" sm="12" style="border: 1px solid #000000;">
                        <!-- style="border: 1px dashed  #616161;" -->
                        <span><b> CLIENTE: </b> {{ clienteFactura.nombre }} </span>
                        <span><b> TELEFONO: </b>{{ selectTelefonoCliente(clienteFactura) }} </span>
                        <span v-if="false"><b> BALANCE: </b> {{ currencyFormatter(0) }} </span>
                        <!-- {{clienteFactura.telefonoPrincipal}} -->
                        <p><b> DIRECCIÓN: </b> {{ clienteFactura.direccion }} </p>

                      </v-col>


                      <b :class="`d-flex justify-center`"> EDITAR RECIBO DE INGRESO</b>
                      <v-form ref="formReciboIngreso" v-model="valid" lazy-validation translate="no" class="notranslate">
                        <!-- Row 1  Recibo Ingreso   @keydown.enter="SalvarProductoCompraEnter"   ------------------------------------------->
                        <v-row class="pa-0 ma-0 py-0 my-0">

                          <v-col cols="12" md="6" sm="12">

                            <!-- CalcularReciboIngreso1() -->
                            <VueAutonumeric v-model.number="ReciboIngreso.abono" :rules="[$rules.Numericc]"
                                            autocomplete="off" dense
                                            label="Abono"
                                            outlined style="font-size:13px;"
                                            @blur="CalcularReciboIngreso1()"
                                            v-on:input="calcularToTalRecIng">
                              <template v-slot:prepend>
                                <i class="fa fa-usd" style="font-size: 20px;"></i>
                              </template>
                            </VueAutonumeric>

                            <VueAutonumeric v-model.number="ReciboIngreso.descuento" :rules="[$rules.Numericc]"
                                            autocomplete="off" dense
                                            hide-details label="Descuento"
                                            outlined
                                            style="font-size:13px;" @blur="CalcularReciboIngreso1()">
                              <template v-slot:prepend>
                                <i v-if="ReciboIngreso.DescValorPorc == true" class="fa fa-usd"
                                   style="font-size: 20px;"></i>
                                <i v-if="ReciboIngreso.DescValorPorc == false" class="fa fa-percent"
                                   style="font-size: 20px;"></i>
                              </template>

                              <template v-slot:append-outer>
                                <!-- ChangeReciboIngresoValorPorcc -->
                                <v-radio-group v-model="ReciboIngreso.DescValorPorc" column dense
                                               hide-details
                                               style="margin-top: -18%; border: 1px dashed  #616161;"
                                               @change="CalcularReciboIngreso1">
                                  <v-radio :value="true" class="ma-0 pa-0 " color="teal lighten-2"
                                           label="Valor"></v-radio>
                                  <v-radio :value="false" class="ma-0 pa-0 " color="teal lighten-2" label="Porciento">
                                  </v-radio>
                                </v-radio-group>

                              </template>
                            </VueAutonumeric>

                            <VueAutonumeric v-if="false" v-model.number="ReciboIngreso.retencion"
                                            :rules="[$rules.Numericc]" autocomplete="off"
                                            dense
                                            hide-details label="Retencion"
                                            outlined
                                            style="font-size:13px;" @blur="CalcularReciboIngreso()">
                              <template v-slot:prepend>
                                <i v-if="ReciboIngreso.retenValorPorc == true" class="fa fa-usd"
                                   style="font-size: 20px;"></i>
                                <i v-if="ReciboIngreso.retenValorPorc == false" class="fa fa-percent"
                                   style="font-size: 20px;"></i>
                              </template>

                              <template v-slot:append-outer>

                                <v-radio-group v-model="ReciboIngreso.retenValorPorc" column dense
                                               hide-details
                                               style="margin-top: -15%; border: 1px dashed  #616161;"
                                               @change="ChangeReciboIngresoValorPorcc">
                                  <v-radio :value="true" class="ma-0 pa-0 " color="teal lighten-2" dense label="Valor">
                                  </v-radio>
                                  <v-radio :value="false" class="ma-0 pa-0 " color="teal lighten-2" dense
                                           label="Porciento">
                                  </v-radio>
                                </v-radio-group>

                              </template>
                            </VueAutonumeric>
                            <VueAutonumeric v-if="false" v-model.number="ReciboIngreso.isr" :rules="[$rules.Numericc]"
                                            autocomplete="off"
                                            dense
                                            hide-details label="Retencion ISR"
                                            outlined
                                            style="font-size:13px;" @blur="CalcularReciboIngreso()">
                              <template v-slot:prepend>
                                <i v-if="ReciboIngreso.isrValorPorc == true" class="fa fa-usd"
                                   style="font-size: 20px;"></i>
                                <i v-if="ReciboIngreso.isrValorPorc == false" class="fa fa-percent"
                                   style="font-size: 20px;"></i>
                              </template>

                              <template v-slot:append-outer>

                                <v-radio-group v-model="ReciboIngreso.isrValorPorc" column dense
                                               hide-details
                                               style="margin-top: -15%; border: 1px dashed  #616161;"
                                               @change="ChangeReciboIngresoValorPorcc">
                                  <v-radio :value="true" class="ma-0 pa-0 " color="teal lighten-2"
                                           label="Valor"></v-radio>
                                  <v-radio :value="false" class="ma-0 pa-0 " color="teal lighten-2" label="Porciento">
                                  </v-radio>
                                </v-radio-group>

                              </template>
                            </VueAutonumeric>


                          </v-col>

                          <v-col cols="12" md="6" sm="12" style="border: 1px solid #000000;">
                            <!-- <p style="border: 1px solid #000000;" ><b>PENDIENTE:</b>  <b :class="`d-flex justify-end red--text`" >0.00</b></p> -->
                            <v-row class="pa-0 ma-0 py-0 my-0" no-gutters>
                              <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
                                <p class="pa-0 ma-0 py-0 my-0"><b>PENDIENTE:</b></p>
                              </v-col>
                              <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
                                <p class="pa-0 ma-0 py-0 my-0"><b :class="`d-flex justify-end red--text`">{{
                                    currencyFormatter(Totales.ReciboIngreso.pendiente)
                                  }}</b>
                                </p>
                              </v-col>
                              <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
                                <p class="pa-0 ma-0 py-0 my-0"><b>ABONADO:</b></p>
                              </v-col>
                              <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
                                <p class="pa-0 ma-0 py-0 my-0"><b :class="`d-flex justify-end`">{{
                                    currencyFormatter(Totales.ReciboIngreso.abono)
                                  }}</b></p>
                              </v-col>
                              <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
                                <p class="pa-0 ma-0 py-0 my-0"><b>DESCUENTO:</b></p>
                              </v-col>
                              <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
                                <p class="pa-0 ma-0 py-0 my-0"><b :class="`d-flex justify-end`">{{
                                    currencyFormatter(Totales.ReciboIngreso.descuento)
                                  }}</b>
                                </p>
                              </v-col>
                              <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
                                <p class="pa-0 ma-0 py-0 my-0"><b>RETENCIÓN:</b></p>
                              </v-col>
                              <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
                                <p class="pa-0 ma-0 py-0 my-0"><b :class="`d-flex justify-end`">{{
                                    currencyFormatter(Totales.ReciboIngreso.retencion)
                                  }}</b>
                                </p>
                              </v-col>
                              <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
                                <p class="pa-0 ma-0 py-0 my-0"><b>RETENCIÓN ISR:</b></p>
                              </v-col>
                              <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
                                <p class="pa-0 ma-0 py-0 my-0"><b :class="`d-flex justify-end`">{{
                                    currencyFormatter(Totales.ReciboIngreso.isr)
                                  }}</b></p>
                              </v-col>

                            </v-row>

                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card>

                  </v-col>
                  <!-- Forma de pago recibo de ingreso -->
                  <v-col v-if="FactPendienteSeleccionado == null" class="pa-0 ma-0 py-0 my-0"
                         cols="12" md="12" sm="12" style="border: 1px solid #000000;">
                    <center>
                      <v-card color="grey lighten-3">
                        <v-row>
                          <!--  columna 1  -->
                          <v-col cols="12" md="6" sm="6">


                            <VueAutonumeric v-model.number="ReciboIngresoFactura.efectivo" :rules="[$rules.Numericc]"
                                            autocomplete="off" dense
                                            hide-details label="Efectivo:"
                                            outlined style="font-size: 13px;" @focus="PanelReciboFormaPago = false"
                                            @input="calcularToTalRecIng" @keydown.enter="ReciboEnterEfectivo"
                                            v-on:keydown.enter="calcularToTalRecIng"
                            >
                              <template v-slot:prepend>
                                <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->

                                <!-- <span ></span> -->
                                <v-avatar color="transparent" size="30" tile>
                                  <img alt="Efectivo" src="@/assets/icons_pv/formapago/efectivo35.png">
                                </v-avatar>

                              </template>
                            </VueAutonumeric>

                            <VueAutonumeric v-model.number="ReciboIngresoFactura.tarjeta" :rules="[$rules.Numericc]"
                                            autocomplete="off" class="mt-1" dense
                                            hide-details label="Tarjeta:"
                                            outlined style="font-size: 13px;"
                                            @focus="OpenPanelReciboFormaPago('Tarjeta')"
                                            @input="calcularToTalRecIng" @keydown.enter="ReciboEnterTarjeta"
                                            v-on:keydown.enter="calcularToTalRecIng"
                            >
                              <template v-slot:prepend>
                                <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->
                                <v-avatar color="transparent" size="30" tile>
                                  <img alt="Tarjeta" src="@/assets/icons_pv/formapago/tarjeta35.png">
                                </v-avatar>
                              </template>
                            </VueAutonumeric>

                            <VueAutonumeric v-model.number="ReciboIngresoFactura.cheque" :rules="[$rules.Numericc]"
                                            autocomplete="off" class="mt-1" dense
                                            hide-details label="Cheque:"
                                            outlined style="font-size: 13px;"
                                            @focus="OpenPanelReciboFormaPago('Cheque')" @input="calcularToTalRecIng"
                                            @keydown.enter="enterCheque"
                                            v-on:keydown.enter="ReciboEnterCheques"
                            >
                              <template v-slot:prepend>
                                <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->
                                <v-avatar color="transparent" size="30" tile>
                                  <img alt="Cheque" src="@/assets/icons_pv/formapago/cheques35.png">
                                </v-avatar>

                              </template>
                            </VueAutonumeric>

                            <VueAutonumeric v-model.number="ReciboIngresoFactura.transferencia"
                                            :rules="[$rules.Numericc]" autocomplete="off" class="mt-1" dense
                                            hide-details
                                            label="Transferencia:"
                                            outlined style="font-size: 13px;"
                                            @focus="OpenPanelReciboFormaPago('Transferencia')"
                                            @input="calcularToTalRecIng" @keydown.enter="enterTransferencia"
                                            v-on:keydown.enter="ReciboEnterTransferencia">
                              <template v-slot:prepend>
                                <!-- <i style="font-size: 20px;" class="fa fa-money"></i> -->

                                <v-avatar color="transparent" size="30" tile>
                                  <img alt="Transferencia" src="@/assets/icons_pv/formapago/transferencia35.png">
                                </v-avatar>
                              </template>
                            </VueAutonumeric>
                            <center>
                              <v-tooltip dense top>
                                <template v-slot:activator="{ on }">
                                  <h3 block style="border: 2px solid #757575;" v-on="on">
                                <span v-if="devueltaRecIngreso < 0" class="red--text">Devuelta: $ ({{
                                    currencyFormatter2(devueltaRecIngreso * (-1))
                                  }}
                                  )</span>
                                    <span v-if="devueltaRecIngreso == 0">Devuelta: $ 0.00</span>
                                    <span v-if="devueltaRecIngreso > 0" class="green--text">Devuelta: $ {{
                                        currencyFormatter2(devueltaRecIngreso)
                                      }}</span>
                                  </h3>
                                </template>
                                <b><span> <strong
                                  style="  background-color:black; font-size:14px;">Letra Negro:</strong> no
                                contiene
                                devuelta ni faltante,
                                <strong style="  background-color:red; font-size:14px;">Letra Rojo:</strong> contiene
                                faltante,
                                <strong style="  background-color:green; font-size:14px;">Letra Verde:</strong> contiene
                                devuelta.</span></b>

                              </v-tooltip>

                            </center>

                          </v-col>
                          <!--  fn columna 1  -->

                          <!--  columna 2 -->

                          <!-- columna 2- Opcion 2 cheque -->
                          <v-col v-show="PanelReciboFormaPago" cols="12" md="6" sm="6">
                            <v-row class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;">
                              <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6"
                                     style="background-color:#dd4b39;">
                            <span :class="`d-flex justify-center white--text`"><b>{{
                                NombrePanelReciboFormaPago
                              }}</b></span>
                              </v-col>
                              <v-col class=" pa-0 ma-0 py-0 my-0 d-flex justify-end" cols="6"
                                     md="6" sm="6" style="background-color:#dd4b39;">
                                <v-btn color="grey darken-4" fab x-small @click="PanelReciboFormaPago = false">
                                  <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
                                </v-btn>
                              </v-col>

                              <div
                                v-if="NombrePanelReciboFormaPago == 'Cheque' || NombrePanelReciboFormaPago == 'Transferencia'">
                                <v-text-field v-model="ReciboIngresoFactura.numeroCheque"
                                              :label="'Número ' + NombrePanelReciboFormaPago"
                                              :rules="[$rules.required]" autocomplete="off"
                                              class="mt-2" dense hide-details outlined
                                              required
                                              style="font-size:13px;">
                                  <template v-slot:prepend>
                                    <i class="fa fa-wpforms" style="font-size: 20px;"></i>
                                  </template>
                                </v-text-field>

                                <v-combobox v-model="ReciboIngresoFactura.bancoCheque" :items="RBanco"
                                            :rules="[$rules.required]" autocomplete="off" class="mt-2"
                                            dense
                                            hide-details item-text="nombre"
                                            label="Banco" outlined @blur="SelctCbBancoReciboFacturaFormPag"
                                            @focus="cargarBanco">
                                  <template v-slot:prepend>
                                    <i class="fa fa-wpforms" style="font-size: 20px;"></i>
                                  </template>
                                </v-combobox>

                              </div>

                              <div v-show="NombrePanelReciboFormaPago == 'Tarjeta'">
                                <v-form ref="formRecibTarjetaFormPago" v-model="valid" lazy-validation translate="no" class="notranslate">
                                  <v-text-field v-model="ReciboIngresoFactura.numtar" :rules="[$rules.required]"
                                                autocomplete="off" class="mt-2" dense
                                                hide-details label="Número Tarjeta:"
                                                outlined required style="font-size:13px;">
                                    <template v-slot:prepend>
                                      <i class="fa fa-credit-card" style="font-size: 20px;"></i>
                                    </template>
                                  </v-text-field>
                                  <v-combobox v-model="ReciboIngresoFactura.tipoTarjeta" :items="RTipoTarjeta"
                                              :rules="[$rules.required]" autocomplete="off"
                                              class="mt-2"
                                              dense hide-details
                                              item-text="nombre"
                                              label="Tipo de Tarjeta" outlined
                                              @blur="SelctCbTipoTarjetaReciboFacturaFormPag"
                                              @focus="cargarTipoTarjeta">

                                    <template v-slot:prepend>
                                      <i class="fa fa-credit-card" style="font-size: 20px;"></i>
                                    </template>
                                  </v-combobox>
                                </v-form>
                              </div>
                            </v-row>

                          </v-col>

                          <!-- fn columna 2- Opcion 2 Cheque  -->

                          <!--  fn columna 2  -->

                        </v-row>
                      </v-card>
                    </center>
                  </v-col>
                  <!-- fn Forma de pago recibo de ingreso -->
                  <!-- columna recibo de ingreso  ReciboIngreso.abono==0 &&-->
                  <v-col v-if="FactPendienteSeleccionado != null" class="pa-0 ma-0 py-0 my-0"
                         cols="12" md="12" sm="12" style="border: 1px solid #000000;">
                    <b :class="`d-flex justify-center`"> FACTURA PENDIENTE SELECCIONADA </b>
                    <v-row no-gutters>
                      <v-col cols="12" md="6" sm="12" style="border: 1px solid #000000; ">
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161; font-size: 14px;"><b>
                          FECHA: </b>
                          {{ FormatoFecha(HeadInfFactPendienteSelecc.fecha) }} </p>
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161; font-size: 14px;"><b>
                          #FACTURA:
                        </b> {{ HeadInfFactPendienteSelecc.factura }} </p>
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161; font-size: 14px;"><b> VALOR
                          FACTURA: </b> {{ currencyFormatter(HeadInfFactPendienteSelecc.valorf) }}</p>
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161; font-size: 14px;"><b>
                          PENDIENTE:
                        </b> {{ currencyFormatter(HeadInfFactPendienteSelecc.pendiente) }} </p>

                        <VueAutonumeric v-model.number="FactPendienteSeleccionado.abono" :rules="[$rules.Numericc]"
                                        autocomplete="off" class="ma-1" dense
                                        hide-details label="Abono"
                                        outlined
                                        style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-usd" style="font-size: 20px;"></i>
                          </template>
                        </VueAutonumeric>

                        <VueAutonumeric v-model.number="FactPendienteSeleccionado.descuento" :rules="[$rules.Numericc]"
                                        autocomplete="off" class="ma-1" dense
                                        hide-details label="Descuento"
                                        outlined style="font-size:13px;">
                          <template v-slot:prepend>
                            <i v-if="FactPendienteSeleccionado.DescValorPorc == true" class="fa fa-usd"
                               style="font-size: 20px;"></i>
                            <i v-if="FactPendienteSeleccionado.DescValorPorc == false" class="fa fa-percent"
                               style="font-size: 20px;"></i>
                          </template>
                          <template v-slot:append-outer>
                            <!-- ChangeReciboIngresoValorPorcc -->
                            <v-radio-group v-model="FactPendienteSeleccionado.DescValorPorc" column
                                           dense hide-details
                                           style="margin-top: -18%;">
                              <v-radio :value="true" class="ma-0 pa-0 " color="teal lighten-2" label="Valor"></v-radio>
                              <v-radio :value="false" class="ma-0 pa-0 " color="teal lighten-2" label="Porciento">
                              </v-radio>
                            </v-radio-group>

                          </template>
                        </VueAutonumeric>
                        <VueAutonumeric v-model.number="FactPendienteSeleccionado.retencion" :rules="[$rules.Numericc]"
                                        autocomplete="off" class="ma-1" dense
                                        hide-details label="retencion"
                                        outlined style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-usd" style="font-size: 20px;"></i>
                          </template>
                        </VueAutonumeric>


                      </v-col>

                      <v-col cols="12" md="6" sm="12" style="border: 1px solid #000000;">
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161; font-size: 14px;"><b>
                          NCF: </b>
                          {{ FactPendienteSeleccionado.ncf }} </p>
                        <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161; font-size: 14px;"><b>
                          REFERENCIA:
                        </b> {{ FactPendienteSeleccionado.referencia }} </p>
                        <br>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn id="boton-mini" block color="orange" dark
                                   small
                                   @click="FactPendienteSeleccionado = null" v-on="on">
                              <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                              CANCELAR
                            </v-btn>
                          </template>
                          <span>CANCELAR: Cancela operacion de factura seleccionada</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn id="boton-mini" block color="light-blue darken-4" dark
                                   small @click="SalvarReciboIngresoSelctAbono1" v-on="on">
                              <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                              SALVAR
                            </v-btn>
                          </template>
                          <span>SALVAR: Guardar la operacion realizada en la factura seleccionada </span>
                        </v-tooltip>


                      </v-col>
                    </v-row>
                  </v-col>

                </v-col>
                <!--------- fn columna 1 recibo de ingreso ---------->


                <!--------- columna 2 recibo de ingreso ---------->
                <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6" style="border: 1px solid #000000; ">


                  <div v-if="ReciboIngresoFactPendHist == true">
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                      <span :class="`d-flex justify-center white--text`"><b>Facturas Pendientes</b></span>
                    </v-col>

                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">

                      <!--------------------------------------------------  Header tb Facturas Pendientes -->
                      <v-col class="py-0 my-0" cols="12" md="12" sm="12" style="background-color:#3d6687;">
                        <v-row style="border: 1px solid #000000;">
                          <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-start white--text`">Fecha</b></v-col>
                          <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-center white--text`">Factura</b></v-col>
                          <v-col class="pa-0 ma-0" cols="3" md="3"><b :class="`d-flex justify-center white--text`">Valor Factura </b></v-col>
                          <v-col class="pa-0 ma-0" cols="3" md="3"><b :class="`d-flex justify-center white--text`">Pendiente </b></v-col>
                          <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-center white--text`">D.Transcurridos</b></v-col>
                        </v-row>
                      </v-col>
                      <!-------------------------------------------------- fn Header tb Facturas Pendientes -->
                      <!-------------------------------------------------- tb Facturas Pendientes
    :single-select="true" :show-select="true"
    -->
                      <div
                        class="overflow-x-auto"
                        v-bind:style="{ 'height': this.windowSize.height - 30 + 'px', 'max-height': this.windowSize.height - 30 + 'px' }">

                        <v-data-table :headers="[
                        { text: 'FECHA', value: 'props.item', sortable: false, class: ['no-gutters'] },
                        { text: 'CODIGO', value: 'props.item', sortable: false, class: ['no-gutters'] },
                        { text: 'VALOR FACTURA', value: 'props.item', sortable: false, class: ['no-gutters'] },
                        { text: 'PENDIENTE', value: 'props.item', sortable: false, class: ['no-gutters'] },
                        { text: 'Dias', value: 'props.item', sortable: false, class: ['no-gutters'] },
                      ]
                      " :items="RListFactpendiente" :items-per-page="-1" :show-select="true"
                                      :single-select="true"
                                      class="elevation-1" dense hide-default-footer hide-default-header item-key="indx">

                          <template v-slot:item="props">
                        <span v-if="!props.item.hasOwnProperty('abono')" style="display:none;">{{ props.item.abono= 0 }}</span>
                        <span v-if="!props.item.hasOwnProperty('descuento')" style="display:none;">{{ props.item.descuento = 0 }}</span>
                        <span v-if="!props.item.hasOwnProperty('retencion')" style="display:none;">{{ props.item.retencion = 0 }}</span>
                        <span v-if="!props.item.hasOwnProperty('isr')" style="display:none;">{{ props.item.isr= 0 }}</span>
                        <span style="display:none;">{{ props.item.indx = RListFactpendiente.indexOf(props.item) }}</span>
                        
                        <tr v-bind:class="classObjFactPenSelect(props.item)">
                              <td v-ripple="{ class: `indigo--text` }"
                                  @click.prevent="datostablaFactPendiente(props.item)">
                                <!-- <span style="display:none;" v-if="!props.item.hasOwnProperty('cantidad')">{{props.item.cantidad=1}}</span>
           @item-selected="obtenerDatoSelectFactPendiente" v-model="SelectedFactPendiente"-->
                                <v-row>
                                  <!-- <v-col class="pa-0 ma-0"  cols="12" md="12"><span><b>PRODUCTO: {{props.item.productos.descripcion}} </b></span></v-col> -->
                                  <v-col class="pa-0 ma-0" cols="2" md="2"> 
                                    <span> {{ FormatoFecha(props.item.nuevaFechaFactura) }}</span>
                                    <!-- <span> {{ FormatoFecha(props.item.fecha)}}</span> -->
                                  </v-col>

                                  <v-col v-if="props.item.facturasventa != null" class="pa-0 ma-0" cols="2" md="2">
                                    <span :class="`d-flex justify-center`"> {{ props.item.facturasventa.documentoFactura.nombrecorto + "-" + props.item.facturasventa.facturasventaPK.secuencia}}</span>
                                  </v-col>

                                  <v-col v-if="props.item.facturasventa != null" class="pa-0 ma-0" cols="3" md="3">
                                    <span :class="`d-flex justify-center`"> {{ currencyFormatter(props.item.facturasventa.valor) }}</span>
                                  </v-col>

                                  <v-col v-if="props.item.notadebitoclientes != null" class="pa-0 ma-0" cols="2" md="2">
                                   <span :class="`d-flex justify-center`"> {{ props.item.notadebitoclientes.documentocxc.nombrecorto + "-" +  props.item.notadebitoclientes.notadebitoclientesPK.secuencia }}</span>
                                  </v-col>

                                  <v-col v-if="props.item.notadebitoclientes != null" class="pa-0 ma-0" cols="3" md="3">
                                   <span :class="`d-flex justify-center`"> {{ currencyFormatter(props.item.notadebitoclientes.valor) }}</span>
                                  </v-col>

                                  <v-col class="pa-0 ma-0" cols="3" md="3">
                                    <span :class="`d-flex justify-center`"> {{ currencyFormatter(props.item.pendientedespues) }}</span>
                                  </v-col>
                                  <v-col class="pa-0 ma-0" cols="2" md="2">
                                    <span :class="`d-flex justify-center`"> {{ diasTranscurridos(props.item.nuevaFechaFactura) }} DIAS</span>
                                  </v-col>

                                  <v-col class="pa-0 ma-0" cols="12" md="12">
                                <span v-if="props.item.abono > 0" class="px-1"
                                      style=" font-size:12px; border: 1px dashed  #616161;"><b> **ABONO:</b>
                                  {{ currencyFormatter(props.item.abono) }} </span>
                                    <span v-if="props.item.descuento > 0"
                                          style=" font-size:12px; border: 1px dashed  #616161;"><b> **DESCUENTO:</b>
                                  {{ props.item.descuento }} </span>
                                    <span v-if="props.item.retencion > 0"
                                          style=" font-size:12px; border: 1px dashed  #616161;"><b> **RETENCIÓN:</b>
                                  {{ props.item.retencion }} </span>
                                    <span v-if="props.item.isr > 0"
                                          style=" font-size:12px; border: 1px dashed  #616161;"><b>
                                    **RETENCIÓN ISR:</b> {{ props.item.isr }} </span>
                                  </v-col>


                                </v-row>
                              </td>
                            </tr>

                          </template>
                        </v-data-table>


                      </div>
                      <!-------------------------------------------------- fn tb Facturas Pendientes-->
                    </v-col>
                  </div>


                  <div v-if="ReciboIngresoFactPendHist == false">
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                      <span :class="`d-flex justify-center white--text`"><b>Historial</b></span>
                    </v-col>

                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">

                      <!--------------------------------------------------  Header tb Historial -->
                      <!-- <v-col style="background-color:#3d6687;" class="py-0 my-0" cols="12" md="12" sm="12">

                        <v-row style="border: 1px solid #000000;">
                          <v-col class="pa-0 ma-0" cols="2" md="2"> <b :class="`d-flex justify-start white--text`">Fecha</b>
                          </v-col>
                          <v-col class="pa-0 ma-0" cols="2" md="2"> <b :class="`d-flex justify-start white--text`">
                              #Factura</b></v-col>
                          <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-center white--text`">
                              Referencia </b></v-col>
                          <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-center white--text`"> Débito
                            </b></v-col>
                          <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-center white--text`">
                              Crédito</b></v-col>
                          <v-col class="pa-0 ma-0" cols="2" md="2"><b :class="`d-flex justify-center white--text`">
                              Balance</b></v-col>
                        </v-row>
                      </v-col> -->
                      <!-------------------------------------------------- fn Header tb Facturas Pendientes -->
                      <!-------------------------------------------------- tb Historial-->
                      <div
                        class="overflow-x-auto"
                        v-bind:style="{ 'height': this.windowSize.height - 30 + 'px', 'max-height': this.windowSize.height - 30 + 'px' }">

                        <v-data-table :footer-props="arrayPropiedases" :headers="[
                      { text: 'Fecha', sortable: false, value: 'fecha', width: 'auto', class: ['no-gutters black--text'] },
                      { text: 'No.Documento', sortable: false, value: 'ref', width: 'auto', class: ['no-gutters black--text'] },
                      { text: 'Descripción', sortable: false, value: 'descripcion', width: 'auto', class: ['no-gutters black--text'] },
                      { text: '$ Factura(Débito)', sortable: false, value: 'debito', width: 'auto', class: ['no-gutters black--text'] },
                      { text: '$ (Pagos)Crédito', sortable: false, value: 'credito', width: 'auto', width: 'auto', class: ['no-gutters black--text'] },
                      { text: '$ Balance', sortable: false, value: 'balance', width: 'auto', class: ['no-gutters black--text'] }
                    ]" :items="listHiscliente" :items-per-page="15" class="elevation-1 RowSelectColor TbSize13" dense>

                          <template v-slot:item.fecha="{ item }">
                            <span>{{ FormatoFecha(item.fecha) }}</span>
                          </template>

                          <template v-slot:item.balance="{ item }">
                            <span>{{ currencyFormatter(item.balance) }}</span>
                          </template>

                          <template v-slot:item.debito="{ item }">
                            <span>{{ currencyFormatter(item.debito) }}</span>
                          </template>

                          <template v-slot:item.credito="{ item }">
                            <span>{{ currencyFormatter(item.credito) }}</span>
                          </template>

                          <template v-if="windowSize.width > 600" v-slot:body.append>
                            <tr>
                              <td class="border-top-bottom"><strong></strong></td>
                              <td class="border-top-bottom"><strong class="d-flex justify-end"
                                                                    style="font-size:15px; color: #00838F;">Total:</strong>
                              </td>
                              <td class="border-top-bottom"><strong></strong></td>
                              <td class="border-total"><strong class="d-flex justify-start"
                                                               style="font-size:15px; color: #00838F;">
                                {{ currencyFormatter(totales.debito) }} </strong>
                              </td>
                              <td class="border-total"><strong class="d-flex justify-start"
                                                               style="font-size:15px; color: #00838F;">
                                {{ currencyFormatter(totales.credito) }} </strong>
                              </td>
                              <td class="border-total"><strong class="d-flex justify-start"
                                                               style="font-size:15px; color: #00838F;">
                                {{ currencyFormatter(totales.BalanceTotal) }}
                              </strong></td>
                            </tr>
                          </template>
                          <template v-if="windowSize.width <= 600" v-slot:footer>
                            <v-list-item class="white--text" style="font-size: 70%;">
                              <v-list-item-content>
                                <span>Débito:{{ currencyFormatter(totales.debito) }}</span>
                                <span>Crédito:{{ currencyFormatter(totales.credito) }}</span>
                                <span>Balance:{{ currencyFormatter(totales.BalanceTotal) }}</span>
                              </v-list-item-content>
                            </v-list-item>

                          </template>


                        </v-data-table>
                      </div>
                      <!-------------------------------------------------- fn tb Historial-->
                    </v-col>
                  </div>

                </v-col>
                <!--------- fn columna 2 recibo de ingreso ---------->

              </v-row>
            </v-col>
          </v-card>
        </div>


      </v-dialog>
    </div>

    <!-----  Modal-Recibo de ingreso avanzado -->
    <div v-if="$store.getters.GetConfiguracionGeneral.configPv.reciboIngresoAvanzadopv==true">
      <v-dialog v-model="dialogReciboIngreso" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
        <v-card class="mx-auto">
          <v-col class="pa-0 ma-0 py-0 my-0 d-flex justify-end" cols="12" md="12" sm="12"
                 style="background-color: #dd4b39">
            <v-btn color="grey darken-4" fab x-small @click="closeComponentsRecibosIngresos()">
              <i class="fa fa-close" style="font-size: 20px; color: white"></i>
            </v-btn>
          </v-col>

          <v-list subheader three-line>
            <ComponentsRecibosIngresos ref="RefComptsRecibosIngresos"
                                       @DataRetornComptsRecibosIngresos="DataRetornComptsRecibosIngresos" />
          </v-list>
        </v-card>

        <!----- fn Modal-Recibo de ingreso avanzado -->
      </v-dialog>
    </div>
    <!--------------------------------------------------------  fn Modal- recibo de ingreso -->

    <!-------------------------------------------------------- Modal Modal-Lista Receta -->
    <v-dialog v-model="dialogRecetas" fullscreen hide-overlay label="Modal Receta  " persistent
              transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Recetas
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>Recetas: </span></i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="dialogRecetas = false" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Cancela y retornar atrás</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>


        </v-toolbar>

        <v-col cols="12" md="12" sm="12">
          <v-card color="grey lighten-3">

            <v-form ref="formReimprecion" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
              <v-row>

                <!--  recibo busqueda receta  @blur="getCierreCaja" v-on:input="resertPaginacion" -------------->
                <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="RecetaBusqueda.receta" autocomplete="off" dense label="Receta:" outlined
                                    @blur="CargarBusquedaRecetas" v-on="on">
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra la receta que deseamos búscar.</span>
                    </i>
                  </v-tooltip>
                </v-col>

                <!--  receta paciente @change="getFacVenta"  -------------->
                <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="RecetaBusqueda.paciente" autocomplete="off" dense label="Paciente:"
                                    outlined
                                    @blur="CargarBusquedaRecetas" v-on="on">
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra el paciente que deseamos búscar.</span>
                    </i>
                  </v-tooltip>

                </v-col>
                <!--  reimprecion busqueda Fecha Inicial @input="getCierreCaja"  v-on:input="resertPaginacion" -------------->
                <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model="RecetaBusqueda.fechaInicial" dense label="Fecha Inicial" outlined
                                    placeholder=" "
                                    style="font-size: 12px;" type="date" @input="CargarBusquedaRecetas"
                                    v-on="on">
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 18px;"></i>
                        </template>
                      </v-text-field>

                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra la fecha a partir de la cual queremos la búsqueda.</span>
                    </i>
                  </v-tooltip>
                </v-col>

                <!--  reimprecion busqueda Fecha Final @input="getCierreCaja"  v-on:input="resertPaginacion" -------------->
                <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model="ReimpresionBusqueda.fechaFinal" dense label="Fecha Final" outlined
                                    placeholder=" "
                                    style="font-size: 12px;" type="date" @input="CargarBusquedaRecetas"
                                    v-on="on">
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 18px;"></i>
                        </template>
                      </v-text-field>

                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra la fecha hasta donde queremos la búsqueda.</span>
                    </i>
                  </v-tooltip>
                </v-col>


              </v-row>
            </v-form>

            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
              <div style="border: 1px solid #000000;">
                <v-data-table v-if="resertPagi == true" v-model="RecetaSelected" :headers="[{ text: 'Código', sortable: false, value: 'codigo', width: 120 },
                  { text: 'Fecha', sortable: false, value: 'fecha', width: 120 },
                  { text: '# Receta', sortable: false, value: 'numero', width: 129 },
                  { text: 'Paciente', sortable: false, value: 'cliente.nombre', width: 129 },
                  { text: 'Doctor', sortable: false, value: 'medico', width: 'auto', width: 105 },


                  ]" :items="Recetaslist"
                              :items-per-page="RecetaPaginator.itemsPerPage" :server-items-length="TotalRegistros"
                              :show-select="true" :single-select="true" class="RowSelectColor" dense item-key="indx"
                              @pagination="RecetaCargarPaginacion" @item-selected="RecetaObtenerDatoSelect"
                              @click:row="RecetaDatostabla">
                  <template v-slot:item.action="{ item }">

                    <!-- <v-btn fab @click.prevent="VerReporte(item)" x-small color="yellow accent-4"><i style="font-size: 20px;" class="fa fa-eye"></i></v-btn>  -->
                    <v-btn color="red darken-3" fab x-small @click.prevent=""><i class="fa fa-trash-o"
                                                                                 style="font-size: 20px;"></i></v-btn>

                  </template>
                  <template v-slot:item.fecha="props">
                    <span style="font-size:13px; display:none;">{{
                        props.item.indx =
                          Recetaslist.indexOf(props.item)
                      }}</span>
                    <span style="font-size:13px;">{{ FormatoFecha(props.item.fecha) }}</span>
                  </template>

                  <template v-slot:item.codigo="props">
                    <span style="font-size:13px;">{{ props.item.codigo }} </span>
                  </template>

                  <template v-slot:item.numero="props">
                    <span style="font-size:13px;">{{ props.item.numero }} </span>
                  </template>

                  <template v-slot:item.cliente.nombre="props">
                    <span v-if="props.item.cliente != null" style="font-size:13px;">{{ props.item.cliente.nombre }}
                    </span>
                  </template>

                  <template v-slot:item.medico="props">
                    <span style="font-size:13px;">{{ props.item.medico }} </span>
                  </template>

                </v-data-table>
              </div>
            </v-col>
          </v-card>
        </v-col>

      </v-card>

    </v-dialog>
    <!-------------------------------------------------------- fn Modal- Recibo-->

    <!-- ------------------------------------------------------ Modal-Receta completa -->
    <v-dialog v-model="dialogVerRecetaCompleta" label="Modal Receta completa " max-height="85%" max-width="95%"
              persistent transition="fab-transition">

      <!--------------------- receta ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Ver Receta
                completa
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Receta: </span> Ver Receta completa
            </i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">

                  <v-btn color="grey darken-4" fab small v-on="on" @click.prevent="CerrarVerRecetaCompleta()">
                    <i class="fa fa-close" style="font-size: 20px; color:white;"></i>
                  </v-btn>

                </template>
                <span>Cerrar: cierra la pestaña actual</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
        <v-card>
          <!-- columna informacion Receta -->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">

                <!-- Row 1 Receta  ------------------------------------------->
                <v-row v-if="RecetaSeleccionado != null" no-gutters>
                  <v-col cols="12" md="6" sm="6">
                    <p style="border: 1px dashed  #616161;"><b> # RECETA: </b> {{ RecetaSeleccionado.numero }} </p>
                  </v-col>
                  <v-col cols="12" md="6" sm="6">
                    <p style="border: 1px dashed  #616161;"><b> FECHA: </b> {{ FormatoFecha(RecetaSeleccionado.fecha) }}
                    </p>
                  </v-col>
                  <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                    <p v-if="RecetaSeleccionado.hasOwnProperty('faturas') && RecetaSeleccionado.faturas.length >0 "
                       class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> FACTURA: </b>
                      {{ RecetaSeleccionado.faturas }}. </p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> PACIENTE: </b>
                      {{ RecetaSeleccionado.cliente.nombre }} </p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> TELEFONO: </b>
                      {{ RecetaSeleccionado.telefono }} </p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> DIRECCIÓN: </b>
                      {{ RecetaSeleccionado.direccion }} </p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> MEDICO: </b>
                      {{ RecetaSeleccionado.medico }} </p>

                  </v-col>
                  <!-- <v-col cols="12" md="12" sm="12"></v-col> -->


                  <v-col
                    v-if="RecetaSeleccionado.hasOwnProperty('recetaDetalleList') && RecetaSeleccionado.recetaDetalleList.length > 0"
                    cols="12" md="12"
                    sm="12">

                    <v-data-table :headers="[{ text: 'PRODUCTO', value: 'producto.descripcion', sortable: false },
                    { text: 'CANTIDAD RECETA', value: 'cantidadRecetada', sortable: false },
                    { text: 'CANTIDAD DESPACHADA', value: 'cantidadDespachada', sortable: false },
                    ]" :items="RecetaSeleccionado.recetaDetalleList" :items-per-page="-1" class="elevation-1" dense
                                  hide-default-footer @click:row="RecetaProdctoDatostabla">
                      <template v-slot:item.action="{ item }">
                        <v-btn color="grey " fab x-small @click.prevent="editTel(item)"><i class="fa fa-pencil"
                                                                                           style="font-size: 20px;"></i>
                        </v-btn>
                        <v-btn color="red darken-3" fab x-small @click.prevent="deleTel(item)"><i
                          class="fa fa-trash-o"
                          style="font-size: 20px;"></i></v-btn>
                      </template>

                      <template v-slot:item.producto.descripcion="props">
                        <span style="font-size:13px;">{{ props.item.producto.descripcion }} </span>
                      </template>

                      <template v-slot:item.cantidadRecetada="props">
                        <span style="font-size:13px;">{{ props.item.cantidadRecetada }} </span>
                      </template>

                      <template v-slot:item.cantidadDespachada="props">
                        <span style="font-size:13px;">{{ props.item.cantidadDespachada }}</span>
                      </template>

                    </v-data-table>

                  </v-col>


                  <v-col v-if="recetaFacturaList.length > 0" cols="12" md="12" sm="12">
                    <hr style="border: 1px solid  #616161;">
                    <v-data-table :headers="[{ text: 'FECHA', value: 'fecha', sortable: false },
                    { text: 'FACTURA', value: 'secuencia', sortable: false },
                    { text: 'CANTIDAD VENDIDA', value: 'cantidad', sortable: false },
                    ]" :items="recetaFacturaList" :items-per-page="-1" class="elevation-1" dense hide-default-footer>
                      <template v-slot:item.action="{ item }">
                        <v-btn color="grey " fab x-small @click.prevent="editTel(item)"><i class="fa fa-pencil"
                                                                                           style="font-size: 20px;"></i>
                        </v-btn>
                        <v-btn color="red darken-3" fab x-small @click.prevent="deleTel(item)"><i
                          class="fa fa-trash-o"
                          style="font-size: 20px;"></i></v-btn>
                      </template>

                      <template v-slot:item.fecha="props">
                        <span style="font-size:13px;">{{ FormatoFecha(props.item.fecha) }}</span>
                      </template>


                      <template v-slot:item.secuencia="props">
                        <span style="font-size:13px;">{{ props.item.nombrecorto }}-{{ props.item.secuencia }} </span>
                      </template>

                      <template v-slot:item.cantidad="props">
                        <span style="font-size:13px;">{{ props.item.cantidad }}</span>
                      </template>

                    </v-data-table>

                  </v-col>


                </v-row>
                <!-- Row 2 Receta ------------------------------------------->

              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion Receta -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal-Receta completa -->


    <!-- ------------------------------------------------------ Modal-Restaurar Factura-->
    <v-dialog v-model="dialogRestaurarFactura" fullscreen hide-overlay label="Modal Restaurar Factura  " persistent
              transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Restaurar Factura
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>Restaurar Factura: </span></i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark
                         small @click="canselarBuscarRestaurarFacturasFrecuencia()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Cancela y retornar atrás</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>


        </v-toolbar>

        <v-col cols="12" md="12" sm="12">
          <v-card color="grey lighten-3">

            <v-form ref="formReimprecion" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
              <v-row>

                <v-col class="py-0 my-0" cols="12" md="4" sm="4">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field ref="RefTextFieldBuscarResFact" v-model="RestaurarFacturaBusqueda.buscar"
                                    autocomplete="off" dense
                                    label="buscar por nombre:" outlined
                                    style="font-size: 12px;" @keydown="SelectMarcaFactTemp"
                                    @keyup="BuscarRestaurarFacturas"
                                    v-on="on">
                        <template v-slot:prepend>
                          <i class="fa fa-hashtag" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra el Nombre del cliente que deseamos búscar.</span>
                    </i>
                  </v-tooltip>
                </v-col>
                <v-col class="py-0 my-0" cols="12" md="4" sm="4">

                  <v-combobox v-if="cambiarDestinoSucursal == true" v-model="RestaurarFacturaBusqueda.sucursal"
                              :items="RSucursal" :rules="[$rules.required]" autocomplete="off"
                              dense item-text="descripcion" label="Sucursal:"
                              outlined @blur="SelctCbSucursalFactTempSeach"
                              @change="BuscarRestaurarFacturas" @focus="CargarRSucursal">
                    <template v-slot:prepend>
                      <i class="fa fa-sitemap" style="font-size: 20px;"></i>
                    </template>
                  </v-combobox>
                </v-col>

              </v-row>
            </v-form>

            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
              <div style="border: 1px solid #000000;">

                <v-data-table id="TbBord" :footer-props="arrayPropiedases" :headers="[
                  
                { text: '#SECUENCIA', sortable: true, value: 'secuencia', width: '110', class: ['no-gutters black--text'] },
                { text: 'NOMBRE', sortable: true, value: 'descripcion', width: 'auto', class: ['no-gutters black--text'] },
                { text: 'VENDEDOR', sortable: true, value: 'vendedor', width: 'auto', class: ['no-gutters black--text'] },
                { text: 'TELEFONO', sortable: true, value: 'telefono', width: 'auto', class: ['no-gutters black--text'] },
                { text: 'FECHA', sortable: false, value: 'nuevaFecha', width: '110', class: ['no-gutters black--text'] },
                { text: 'VALOR FACTURA', sortable: false, value: 'valor', width: 'auto', class: ['no-gutters black--text'] },
                { text: 'HORA', sortable: false, value: 'hora', width: '110', class: ['no-gutters black--text'] },
                { text: 'Tipo factura', sortable: false, value: 'tipo', width: 'auto', class: ['no-gutters black--text'] },
                { text: 'ACCIÓN', value: 'action', width: '110', sortable: true}]"
                              :items="RestaurarFactlistFact" :items-per-page="TbPaginatorFactTem.itemsPerPage"
                              :page.sync="TbPaginatorFactTem.page" :pageCount="TbPaginatorFactTem.pageCount"
                              :search="RestaurarFacturaBusqueda.buscar"
                              dense item-key="indx"
                              @pagination="cargarPaginacionAllFactTem" @click:row="RestaurarFacturaDatostabla">
                  
                   <template v-slot:item.secuencia="props">
                    <v-col
                      class="pa-0 ma-0 py-0 my-0"
                      cols="12" md="12" sm="12"
                      v-bind:style="{ 'font-size': '13px;', 'background': GetColorRestaurarFact(props.item), 'border-top':getBorderColorSelectFactTem(props.item) ,'border-bottom':getBorderColorSelectFactTem(props.item) }">
                      <span class="px-2"> {{ props.item.secuencia }} </span>
                    </v-col>
                  </template>
                   <template v-slot:item.descripcion="props">
                    <v-col
                      class="pa-0 ma-0 py-0 my-0"
                      cols="12" md="12" sm="12"
                      v-bind:style="{ 'font-size': '13px;', 'background': GetColorRestaurarFact(props.item), 'border-top':getBorderColorSelectFactTem(props.item) ,'border-bottom':getBorderColorSelectFactTem(props.item) }">
                      <span class="px-2"> {{ props.item.descripcion.trim() }} </span>
                    </v-col>
                  </template>

                  <template v-slot:item.vendedor="props">
                    <v-col
                      class="pa-0 ma-0 py-0 my-0"
                      cols="12" md="12" sm="12"
                      v-bind:style="{ 'font-size': '13px;', 'background': GetColorRestaurarFact(props.item), 'border-top':getBorderColorSelectFactTem(props.item) ,'border-bottom':getBorderColorSelectFactTem(props.item) }">
                      <span class="px-2"> <span
                        v-if="props.item.vendedor!=null"> {{ props.item.vendedor.nombre.trim() }} </span> </span>
                    </v-col>
                  </template>

                  <template v-slot:item.telefono="props">
                    <v-col
                      class="pa-0 ma-0 py-0 my-0"
                      cols="12" md="12" sm="12"
                      v-bind:style="{ 'font-size': '13px;', 'background': GetColorRestaurarFact(props.item), 'border-top':getBorderColorSelectFactTem(props.item) ,'border-bottom':getBorderColorSelectFactTem(props.item) }">
                      <span class="px-2"> {{ RestaurarFacturaTelefono(props.item) }} </span>
                    </v-col>
                  </template>


                  <template v-slot:item.nuevaFecha="props">
                    <span style="display:none;">{{ props.item.indx = RestaurarFactlistFact.indexOf(props.item) }}</span>
                    <span v-if="!props.item.hasOwnProperty('valor')" style="display:none;">{{
                        props.item.valor = 0
                      }}</span>
                    <v-col
                      class="pa-0 ma-0 py-0 my-0"
                      cols="12" md="12" sm="12"
                      v-bind:style="{ 'font-size': '13px;', 'background': GetColorRestaurarFact(props.item), 'border-top':getBorderColorSelectFactTem(props.item) ,'border-bottom':getBorderColorSelectFactTem(props.item) }">
                      <span class="px-2"> {{ FormatoFecha(props.item.nuevaFecha) }} </span>
                    </v-col>
                  </template>

                  <template v-slot:item.valor="props">
                    <v-col
                      class="pa-0 ma-0 py-0 my-0"
                      cols="12" md="12" sm="12"
                      v-bind:style="{ 'font-size': '13px;', 'background': GetColorRestaurarFact(props.item), 'border-top':getBorderColorSelectFactTem(props.item) ,'border-bottom':getBorderColorSelectFactTem(props.item) }">
                      <span class="px-2"> {{ currencyFormatter(props.item.valor) }} </span>
                    </v-col>
                  </template>


                  <template v-slot:item.hora="props">
                    <v-col
                      class="pa-0 ma-0 py-0 my-0"
                      cols="12" md="12" sm="12"
                      v-bind:style="{ 'font-size': '12px;', 'background': GetColorRestaurarFact(props.item), 'border-top':getBorderColorSelectFactTem(props.item) ,'border-bottom':getBorderColorSelectFactTem(props.item) }">
                      <input id="formdisabledInput" :value="HoraFormatter2(props.item.hora)" disabled
                             style="font-size:12px;"
                             type="time" />
                    </v-col>
                  </template>
                  <!-- 'border': '1px solid #000000'
style="border: 1px solid #000000;" -->

                  <template v-slot:item.tipo="props">
                    <v-col
                      class="pa-0 ma-0 py-0 my-0"
                      cols="12" md="12" sm="12"
                      v-bind:style="{ 'font-size': '13px;', 'background': GetColorRestaurarFact(props.item), 'border-top':getBorderColorSelectFactTem(props.item) ,'border-bottom':getBorderColorSelectFactTem(props.item) }">
                      <span class="px-2"> {{ TipoRestaurarFactura(props.item) }} </span>
                    </v-col>
                  </template>


                  <template v-slot:item.action="{ item }">

                    <v-btn :disabled="!ejecutarAplRestFact" :loading="!ejecutarAplRestFact" color="green" fab
                           x-small @click.prevent="verificarusofacturatemporalAplicar(item)">
                      <i class="fa fa-check" style="font-size: 20px;"></i>
                      <template v-slot:loader>
                          <span class="custom-loader">
                            <i class="fa fa-refresh" light style="font-size: 28px; color:#424242;"> </i>

                            <!-- <v-icon light>cached</v-icon> -->
                          </span>
                      </template>
                    </v-btn>
                    <v-btn color="blue" fab x-small @click.prevent="ImprimirRestaurarFact(item)"><i
                      class="fa fa-print" style="font-size: 20px;"></i></v-btn>
                    <v-btn color="red darken-3" fab x-small @click.prevent="LlamadeleRestaurarFact(item)"><i
                      class="fa fa-trash-o" style="font-size: 20px;"></i></v-btn>

                  </template>


                </v-data-table>
                <!------- Por Aquii -->


              </div>
            </v-col>
          </v-card>
        </v-col>

      </v-card>

    </v-dialog>
    <!-------------------------------------------------------- fn Modal- Restaurar Factura-->

    <!-- ------------------------------------------------------ Modal-Crear Cotizacion -->
    <v-dialog v-model="dialogCotizacion" label="Modal Cotizacion" max-height="85%" max-width="95%" persistent
              transition="fab-transition">

      <!--------------------- Creacion Cotizacion ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Cotización
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>Cotización: </span> Creación de
              Cotización</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="cancelarCotizacion()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar y no Crear Cotización</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="SalvarCotizacion()" v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Aceptar y crear Cotización</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
        <v-card>
          <!-- columna informacion Cotizacion -->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> COTIZACIÓN</b>
                <v-form ref="formCrearProduct" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <!-- Row 1 edicion Cotizacion     ------------------------------------------->

                  <v-row no-gutters>


                    <v-col cols="12" md="12" sm="12">
                      <v-text-field v-model="CotizacionFact.nombrecliente" :rules="[$rules.required]" autocomplete="off"
                                    dense label="Nombre:"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" sm="4">
                      <v-text-field v-model="CotizacionFact.telefono" v-mask="'(###)###-####'"
                                    :rules="[$rules.required, $rules.RulesTel]" autocomplete="off" dense
                                    label="Teléfono:" maxlength="13"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-phone" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="8" sm="8">
                      <v-text-field v-model="CotizacionFact.correo" dense label="Correo electrónico" outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-envelope-o" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                    </v-col>


                    <v-col cols="12" md="12" sm="12">
                      <v-textarea v-model="CotizacionFact.direccion" :rules="[$rules.required]" autocomplete="off" dense
                                  label="Dirección:"
                                  outlined rows="2">
                        <template v-slot:prepend>
                          <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                        </template>
                      </v-textarea>

                      <v-text-field v-model="CotizacionFact.valido" autocomplete="off" dense label="Válido Hasta:"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-clock-o" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field v-model="CotizacionFact.conceptoPago" autocomplete="off" dense
                                    label="Condición de Pago:"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-money" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-textarea v-model="CotizacionFact.concepto" :rules="[$rules.required]" autocomplete="off" dense
                                  label="Comentario:"
                                  outlined rows="2">
                        <template v-slot:prepend>
                          <i class="fa fa-commenting-o" style="font-size: 20px;"></i>
                        </template>
                      </v-textarea>

                    </v-col>


                    <v-col cols="12" md="5" sm="5">
                      <v-checkbox v-model="CotizacionImp.CotImg" class="mt-0" color="teal" label="" width="50">
                        <template v-slot:label>
                          <strong v-if="CotizacionImp.CotImg == true" style="color:#000000; font-size:13px;">Imprimir
                            Cotización con Imagen: Si</strong>
                          <strong v-if="CotizacionImp.CotImg == false" style="color:#000000; font-size:13px;">Imprimir
                            Cotización con Imagen: No</strong>
                        </template>
                      </v-checkbox>

                    </v-col>
                    <v-col cols="12" md="2" sm="2">
                      <v-checkbox v-model="CotizacionImp.ProForma" class="mt-0" color="teal" label="" width="50">
                        <template v-slot:label>
                          <strong v-if="CotizacionImp.ProForma == true" style="color:#000000; font-size:13px;">Pro-forma:
                            Si</strong>
                          <strong v-if="CotizacionImp.ProForma == false" style="color:#000000; font-size:13px;">Pro-forma:
                            No</strong>
                        </template>
                      </v-checkbox>
                    </v-col>


                    <v-col cols="12" md="2" sm="2">
                      <v-checkbox v-model="CotizacionFact.quitaritbis" class="mt-0 ma-3"
                                  color="teal " hide-details label="" @change="quitarItbisCotizacion()">
                        <template v-slot:label>
                          <strong v-if="CotizacionFact.quitaritbis == true"
                                  style="color:#000000; font-size:13px;">Quitar itbis: Si</strong>
                          <strong v-if="CotizacionFact.quitaritbis == false"
                                  style="color:#000000; font-size:13px;">Quitar itbis: No</strong>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" md="3" sm="3">
                      <v-checkbox v-model="CotizacionFact.provedorEstado"
                                  class="mt-0 ma-3" color="teal " hide-details label="">
                        <template v-slot:label>
                          <strong v-if="CotizacionFact.provedorEstado == true"
                                  style="color:#000000; font-size:13px;">Proveedor del estado: Si</strong>
                          <strong v-if="CotizacionFact.provedorEstado == false"
                                  style="color:#000000; font-size:13px;">Proveedor del estado: No</strong>
                        </template>
                      </v-checkbox>
                    </v-col>


                    <v-col cols="12" md="12" sm="12">
                      <p class="pa-0 ma-0 py-0 my-0 d-flex justify-end" style="border: 1px dashed  #616161;"><b>
                        SUB-TOTAL: </b> {{ currencyFormatter(CotizacionFact.subtotal) }}
                      </p>
                      <p class="pa-0 ma-0 py-0 my-0 d-flex justify-end" style="border: 1px dashed  #616161;"><b>
                        DESCUENTO : </b>
                        {{ currencyFormatter(CotizacionFact.valordescuento) }}</p>
                      <p class="pa-0 ma-0 py-0 my-0 d-flex justify-end" style="border: 1px dashed  #616161;"><b> ITBIS :
                      </b> {{ currencyFormatter(CotizacionFact.valorimpuesto) }}</p>
                      <hr style="border:1px solid #000000;">
                      <p class="pa-0 ma-0 py-0 my-0 d-flex justify-end" style="border: 1px dashed  #616161;"><b> TOTAL :
                      </b> {{ currencyFormatter(CotizacionFact.valor) }}</p>
                      <!-- <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0 d-flex justify-end"  ><b> TOTAL : </b> {{currencyFormatter(CotizacionFact.valor-CotizacionFact.valordescuento)}}</p> -->


                      <!-- Totales.totalGeneral.total
    Totales.totalGeneral.subtotal
    Totales.totalGeneral.itbis
    Totales.totalGeneral.descuento

     -->

                    </v-col>

                    <!-- Totales.totalGeneral.subtotal,Totales.totalGeneral.itbis,Totales.totalGeneral.descuento
    this.CotizacionFact.valor=this.Totales.totalGeneral.subtotal
    this.CotizacionFact.valordescuento=this.Totales.totalGeneral.descuento
    this.CotizacionFact.valorimpuesto=this.Totales.totalGeneral.itbis -->
                  </v-row>
                  <!-- Row 2 edicion Cotizacion ------------------------------------------->


                </v-form>
              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion Cotizacion-->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Crear Cotizacion-->


    <!-- ------------------------------------------------------ Modal-Vale de caja -->
    <v-dialog v-model="dialogValecaja" label="Modal Vale de caja" max-height="85%" max-width="95%" persistent
              transition="fab-transition">


      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Vale de caja
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Vale de caja: </span> Creación de
              Vale de caja</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="cancelarValecaja()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar y no Crear vale de caja</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="SalvarValecaja()" v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Aceptar y crear vale de caja </span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
        <v-card>
          <!-- columna informacion Vale de caja -->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> VALE DE CAJA</b>
                <v-form ref="formCrearValeCaja" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <!-- Row 1 edicion Vale de caja      ------------------------------------------->

                  <v-row>
                    <v-col cols="12" md="12" sm="12">
                      <VueAutonumeric v-model.number="Valecaja.valor" :rules="[$rules.required]" autocomplete="off"
                                      dense label="Valor"
                                      outlined style="font-size:13px;">
                        <template v-slot:prepend>
                          <i class="fa fa-usd" style="font-size: 20px;"></i>
                        </template>
                      </VueAutonumeric>


                      <v-text-field v-model="Valecaja.beneficiario" :rules="[$rules.required]" autocomplete="off"
                                    dense label="Beneficiario:" outlined required>
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field v-model="Valecaja.autorizadoPor" :rules="[$rules.required]" autocomplete="off"
                                    dense label="Autorizado Por:" outlined required>
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-textarea v-model="Valecaja.descripcion" :rules="[$rules.required]" autocomplete="off" dense
                                  label="Comentario:"
                                  outlined
                                  rows="5">
                        <template v-slot:prepend>
                          <i class="fa fa-commenting" style="font-size: 20px;"></i>
                        </template>
                      </v-textarea>
                    </v-col>

                  </v-row>
                  <!-- Row 2 edicion Vale de caja ------------------------------------------->


                </v-form>
              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion Vale de caja -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Crear Vale de caja-->


    <!-- ------------------------------------------------------ Modal- Nombre factura temporal-->
    <v-dialog v-model="dialogGuardartemporal" label="Modal factura temporal" max-height="85%" max-width="95%"
              persistent transition="fab-transition">

      <!--------------------- Creacion Nombre factura temporal ------------------------------->
      <div v-if="dialogGuardartemporal" v-dirkeydown="finalizarGuardartemporalKeyCtrl">
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Nombre a factura
                temporal
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Nombre : </span> Asignar nombre a
              factura temporal </i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark
                         small @click="dialogGuardartemporal = false, nombreFactTem = ''" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar </span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small
                         @click="ValidarFomsguardartemporal()"
                         v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Aceptar y Guardar factura temporal, Al presionar la tecla (CTRL), ejecuta este boton </span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

        </v-toolbar>
        <v-card>
          <!-- columna informacion  -->
          <v-col cols="12" md="12" sm="12">

            <v-container>
                      <span>
                          <b>Nota:</b><span style="color: #C62828;"> Salvar al presionar tecla (CTRL).</span>
                        </span>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> Nombre a factura temporal</b>
                <v-form ref="formNombreFactTem" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
                  <!-- Row 1 edicion      ------------------------------------------->

                  <v-row>

                    <v-col cols="12" md="12" sm="12">

                      <v-text-field ref="RefTextFieldNombreFactTem" v-model="nombreFactTem" :rules="[$rules.required]"
                                    autocomplete="off" dense
                                    label="Nombre:" outlined required>
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <!------------------------------- Sucursal:-->
                      <v-combobox v-if="cambiarDestinoSucursal == true" v-model="sucursalFactTemporal"
                                  :items="RSucursal" :rules="[$rules.required]"
                                  autocomplete="off" dense item-text="descripcion"
                                  label="Sucursal:"
                                  outlined @blur="SelctCbSucursal" @focus="CargarRSucursal">
                        <template v-slot:prepend>
                          <i class="fa fa-sitemap" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>


                    </v-col>

                  </v-row>
                  <!-- Row 1 edicion ------------------------------------------->


                </v-form>
              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Nombre factura temporal-->


    <!-------------------------------------------------------- Modal- Modal-Cierre de Cajas -->
    <v-dialog v-model="dialogCierreCaja" fullscreen hide-overlay label="Modal Crear editar cliente  " persistent
              transition="dialog-bottom-transition">
      <v-card v-if="dialogCierreCaja">
        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Cierre de Cajas
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>Cierre de Cajas: </span> Crea Cierre
              de Cajas</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="cancelarCierreCaja()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Cancela y retornar atrás</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="grey" dark small @click="newnewCierreCaja(), OpenCierreCaja()"
                         v-on="on">

                    <v-avatar color="transparent" size="28" tile>
                      <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                    </v-avatar>


                    <i style="font-size: 20px;"> </i>
                    NUEVO
                  </v-btn>
                </template>
                <span>NUEVO: Limpia los campo para un nuevo registro</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="SalvarCierreCaja" v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Crea o edita cliente y retornar atrás </span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
        <!-- no-gutters -->
        <v-col cols="12" md="12" sm="12">
          <v-row>
            <!--------- columna 1 Cierre ---------->
            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6" style="border: 1px solid #000000;">
              <!-- 285 id="divSelecProd"   v-bind:style="{  'max-height':this.windowSize.height-400+'px','border': '2px solid #000000' }" class="overflow-x-auto"  -->
              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                <h1><b>Cierre #{{ CierresCajas.cierrescajasPK.secuencia }}</b></h1>
                <v-container>

                  <v-form ref="formCierre" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
                    <v-card color="grey lighten-3">
                      <center><b> Tarjeta </b></center>
                      <v-row>
                        <v-col cols="12" md="6" sm="6">
                          <!-- ----------------------------- Cheques Emitidos -->
                          <v-text-field v-model.number="CierresCajas.cantidadtarjeta" autocomplete="off" dense
                                        hide-details label="(Cantidad):"
                                        outlined style="font-size: 13px;"
                                        @blur="blurCantidadtarjeta" @keyup="KeyUpCantidad"
                                        v-on:keyup="CalcularDenominacion">
                            <template v-slot:prepend>
                              <i class="fa fa-list-ol" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>

                        </v-col>
                        <v-col cols="12" md="6" sm="6">
                          <!-- ----------------------------- Cheques Emitidos -->
                          <VueAutonumeric v-model="CierresCajas.tarjeta" autocomplete="off" dense hide-details
                                          label="(Valor):"
                                          outlined required style="font-size: 13px;"
                                          @input="CalcularDenominacion">
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px;"></i>
                            </template>
                          </VueAutonumeric>
                        </v-col>
                      </v-row>
                    </v-card>
                    <hr>
                    <v-card color="grey lighten-3">
                      <center><b> Cheque </b></center>
                      <v-row>
                        <v-col cols="12" md="6" sm="6">
                          <v-text-field v-model.number="CierresCajas.cantidadcheques" autocomplete="off" dense
                                        hide-details label="(Cantidad):" outlined
                                        style="font-size: 13px;" @blur="blurCantidadcheques"
                                        @keyup="KeyUpCantidad" v-on:keyup="CalcularDenominacion">
                            <template v-slot:prepend>
                              <i class="fa fa-list-ol" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <VueAutonumeric v-model="CierresCajas.cheques" autocomplete="off" dense hide-details
                                          label="(Valor):"
                                          outlined required style="font-size: 13px;"
                                          @input="CalcularDenominacion">
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px;"></i>
                            </template>
                          </VueAutonumeric>

                        </v-col>
                      </v-row>
                    </v-card>
                    <hr>
                    <v-card color="grey lighten-3">
                      <center><b> Transferencia </b></center>
                      <v-row>
                        <v-col cols="12" md="6" sm="6">
                          <v-text-field v-model.number="CierresCajas.cantidadtranferencia" autocomplete="off" dense
                                        hide-details label="(Cantidad):"
                                        outlined
                                        style="font-size: 13px;" @blur="blurCantidadtranferencia"
                                        @keyup="KeyUpCantidad" v-on:keyup="CalcularDenominacion">
                            <template v-slot:prepend>
                              <i class="fa fa-list-ol" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <VueAutonumeric v-model="CierresCajas.transferencia" autocomplete="off" dense hide-details
                                          label="(Valor):"
                                          outlined required style="font-size: 13px;"
                                          @input="CalcularDenominacion">
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px;"></i>
                            </template>
                          </VueAutonumeric>

                        </v-col>
                      </v-row>
                    </v-card>
                    <hr>

                    <v-card color="grey lighten-3">
                      <center><b> Recibo </b></center>
                      <v-row>
                        <v-col cols="12" md="6" sm="6">
                          <v-text-field v-model.number="CierresCajas.cantidadrecibo" autocomplete="off" dense
                                        hide-details label="(Cantidad):"
                                        outlined style="font-size: 13px;"
                                        @blur="blurCantidadrecibo" @keyup="KeyUpCantidad"
                                        v-on:keyup="CalcularDenominacion">
                            <template v-slot:prepend>
                              <i class="fa fa-list-ol" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>


                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <VueAutonumeric v-model="CierresCajas.recibos" autocomplete="off" dense hide-details
                                          label="(Valor):"
                                          outlined required style="font-size: 13px;"
                                          @input="CalcularDenominacion">
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px;"></i>
                            </template>
                          </VueAutonumeric>

                        </v-col>
                      </v-row>
                    </v-card>
                    <hr>
                  </v-form>
                  <!--------------------------------------------------- tb MONEDA -->

                  <v-card>
                    <v-toolbar color="#BDBDBD" dense flat>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">

                          <v-btn color="green" dark fab x-small v-on="on" @click.prevent="AddMonedaCierrecaja">
                            <i class="fa fa-plus-square" style="font-size: 20px;"></i>
                          </v-btn>


                        </template>
                        <span>Agregar Moneda</span>
                      </v-tooltip>

                      <v-toolbar-title class="font-weight-light">
                        <v-card-title>MONEDA</v-card-title>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <strong style="font-size: 15px;">{{ Monedafactura.nombrecorto.trim() }}.{{
                          currencyFormatter(Totales.CierresCajas.totalTotal)
                        }}</strong>

                    </v-toolbar>
                    <v-data-table
                      :headers="[{ sortable: true, text: 'Valor', value: 'valor', width: 'auto' }, { sortable: false, text: 'Moneda', value: 'moneda', width: 200 }, { sortable: false, text: 'ACCIÓN', value: 'action', width: 90 }]"
                      :items="RLisMon">

                      <template v-slot:item.valor="props">
                        <!-- ----------------------------- cantidad -->
                        <VueAutonumeric v-model="props.item.valor" autocomplete="off" dense label="" outlined required
                                        style="font-size: 13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-money" style="font-size: 20px;"></i>
                          </template>
                        </VueAutonumeric>


                      </template>

                      <template v-slot:item.moneda="props">
                        <!-- -----------------------------------------Moneda   @blur="SelctCbMoneda"  -->
                        <v-combobox v-model="props.item.moneda" :items="Rmoneda" :rules="[$rules.required]"
                                    autocomplete="off" dense item-text="nombrecorto"
                                    label="" outlined
                                    style="font-size:13px;" @blur="SelctCbMonedaCierre(props.item.moneda)"
                                    @focus="cargarMoneda">
                          <template v-slot:prepend>
                            <i class="fa fa-usd" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                      </template>

                      <template v-slot:item.action="{ item }">
                        <!-- <v-btn fab @click.prevent="editMon(item)" x-small color="grey "><i style="font-size: 20px;" class="fa fa-pencil"></i></v-btn>  -->
                        <v-btn color="red darken-3" fab style="margin-top:-30px" x-small
                               @click.prevent="deleMondaCierre(item)"><i class="fa fa-trash-o"
                                                                         style="font-size: 20px;"></i></v-btn>

                      </template>
                    </v-data-table>
                  </v-card>
                  <!--------------------------------------------------- fn tb  MONEDA -->


                </v-container>
              </v-col>


            </v-col>
            <!--------- fn columna 1 Cierre ---------->

            <!--------- fn columna 2 Cierre ---------->
            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6" style="border: 1px solid #000000;">
              <v-form ref="formDenominacionPeso" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
                <v-data-table :headers="[{ text: 'Denominación', value: 'valor', width: 'auto' },
                { text: 'Cantidad', sortable: false, value: 'cantidad' },
                { text: 'Valor', value: 'Vtotal', width: 'auto' },
                ]" :items="ListDenomMoneda" :items-per-page="-1" class="elevation-1" color="primary" dense>


                  <template v-slot:item.valor="props">
                    <span style="font-size: 15px;">{{ currencyFormatter(props.item.valor) }}</span>
                  </template>


                  <template v-slot:item.cantidad="props">
                    <!-- ----------------------------- cantidad -->
                    <!-- <input
      style="border: 2px solid #607D8B; font-size: 15px; "
      autocomplete="off"
      size="5"
        dense outlined
        v-model.number="props.item.cantidad"
         @keyup="KeyUpCantidad"
         v-on:keyup="CalcularDenominacion"
     /> -->

                    <v-text-field v-model.number="props.item.cantidad" autocomplete="off" dense hide-details label=""
                                  outlined @blur="blurCantNotnull(props.item)"
                                  @keyup="KeyUpCantidad"
                                  v-on:input="CalcularDenominacion">
                    </v-text-field>

                  </template>

                  <template v-slot:item.Vtotal="props">
                    <p v-if="!props.item.hasOwnProperty('cantidad')" style="display:none;">{{ props.item.cantidad = 0 }}
                    </p>
                    <span v-bind:style="{ 'font-size': '17px;', 'color': getColor(props.item.Vtotal) }">
                    {{ Monedafactura.nombrecorto.trim() }}.{{
                        currencyFormatter(props.item.Vtotal)
                      }}</span>
                  </template>


                  <template v-slot:item.action="{ item }">
                    <!-- <v-btn fab @click.prevent="editMon(item)" x-small color="grey "><i style="font-size: 20px;" class="fa fa-pencil"></i></v-btn>  -->
                    <!-- <v-btn  fab @click.prevent="deleDenominPeso(item)" x-small color="red darken-3"><i style="font-size: 20px;" class="fa fa-trash-o"></i></v-btn> -->
                  </template>

                  <template v-if="windowSize.width > 600" v-slot:body.append>
                    <tr>
                      <td class="border-top-bottom"><strong></strong></td>
                      <td class="border-top-bottom"><strong class="d-flex justify-end"
                                                            style="font-size:13px;">Totales:</strong></td>
                      <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                        {{ currencyFormatter(Totales.CierresCajas.totalDenomiacionvalor) }} </strong></td>
                      <td class="border-top-bottom"><strong></strong></td>
                    </tr>
                  </template>

                  <template v-if="windowSize.width <= 600" v-slot:footer>
                    <v-list-item class="white--text" style="font-size: 80%; border: 2px solid #757575;">
                      <v-list-item-content>
                        <b>TOTAL: {{ currencyFormatter(Totales.CierresCajas.totalDenomiacionvalor) }}</b>
                      </v-list-item-content>
                    </v-list-item>
                  </template>


                </v-data-table>


              </v-form>


            </v-col>

          </v-row>
        </v-col>


      </v-card>
    </v-dialog>
    <!-------------------------------------------------------- fn Modal Cierre de Cajas -->


    <!-- ------------------------------------------------------ Modal-Cobertura de seguro-->
    <v-dialog v-model="dialogCoberturaSeguro" label="Modal Crear producto" max-height="85%" max-width="95%"
              persistent transition="fab-transition">

      <!--------------------- Creacion de Cobertura de seguro------------------------------->
      <div v-if="dialogCoberturaSeguro" v-dirkeydown="coberturaSeguroKeyCtrl">
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Cobertura de
                seguro
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Crear Cobertura de seguro: </span>
              Creación de Cobertura de seguro</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="cancelarCoberturaSeguro()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar y no Crear Cobertura de seguro</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="grey" dark small @click="newnewCoberturaSeguro()" v-on="on">

                    <v-avatar color="transparent" size="28" tile>
                      <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                    </v-avatar>


                    <i style="font-size: 20px;"> </i>
                    NUEVO
                  </v-btn>
                </template>
                <span>NUEVO: Limpia los campo para un nuevo registro</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="SalvarCoberturaSeguro()"
                         v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Aceptar y crear Cobertura de seguro, Al presionar la tecla (CTRL), ejecuta este boton</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
        <v-card>
          <!-- columna informacion producto -->
          <v-col cols="12" md="12" sm="12">
            <span>
<b>Nota:</b><span style="color: #C62828;"> Salvar al presionar tecla (CTRL).</span>
             </span>
            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> CREAR COBERTURA DE SEGURO</b>
                <v-form ref="formCrearCobertura" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <!-- Row 1 Cobertura de seguro      ------------------------------------------->

                  <v-row>

                    <v-col cols="12" md="12" sm="12">
                      <!-- ----------------------------- ARS -->
                      <v-combobox id="formdisabledInput" v-model="CoberturaSeguro.ars" :items="RArs"
                                  :rules="[$rules.required]" autocomplete="off"
                                  dense
                                  disabled item-text="nombre" label="ARS:" outlined
                                  @blur="SelctCbArs" @focus="cargarArs">

                        <template v-slot:prepend>
                          <i class="fa fa-shield" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>

                      <VueAutonumeric v-model.number="CoberturaSeguro.cobertura" :rules="[$rules.required]"
                                      autocomplete="off" dense label="Cobertura"
                                      outlined style="font-size:13px;"
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-dollar" style="font-size: 20px;"></i>
                        </template>
                      </VueAutonumeric>
                      <!-- fa fa-usd   fa fa-medkit -->

                      <v-text-field v-model="CoberturaSeguro.autorizacion" :rules="[$rules.required]" autocomplete="off"
                                    dense label="Autorización:" outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-check-square-o" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field v-model="CoberturaSeguro.medico" autocomplete="off" dense label="Médico:" outlined
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-user-md" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field v-model="CoberturaSeguro.exequartur" autocomplete="off" dense label="Exequartur:"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-id-badge" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field v-model="CoberturaSeguro.especialidad" autocomplete="off" dense
                                    label="Especialidad:" outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-stethoscope" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field v-if="false" v-model="CoberturaSeguro.diagnostico" autocomplete="off" dense
                                    label="Diagnostico:"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-heartbeat" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-combobox id="formdisabledInput" v-model="comboDiagnostico" :items="$RDiagnosticos"
                                  autocomplete="off"
                                  dense item-text="codnom" label="Diagnosticos:" outlined
                                  @blur="SelctCbDiagnostico" @change="changeDiagnostico" >

                        <template v-slot:prepend>
                          <i class="fa fa-heartbeat" style="font-size: 20px;"></i>
                        </template>

                        <template v-slot:selection="{ attrs, item, parent, selected }">
                           <span class="fontSize13 colorNombre"><b>{{item.codigoCIE10.trim()}}</b> - {{item.Diagnostico.trim()}}</span>
                        </template>
                        
                         <template slot="item" slot-scope="item">
                            <span style="display:none;">{{ item.item.codnom = `${item.item.codigoCIE10} - ${item.item.Diagnostico.trim()} ` }}</span>
                             <span class="fontSize13"><b>{{ item.item.codigoCIE10.trim() }}</b> - {{item.item.Diagnostico.trim()}}</span>
                         </template> 
                      </v-combobox>



                    </v-col>

                  </v-row>
                  <!-- Row 2 Cobertura de seguro ------------------------------------------->


                </v-form>
              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion Cobertura de seguro -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Cobertura de seguro-->


    <!-- ------------------------------------------------------ Modal-Otros Ingresos -->
    <v-dialog v-model="dialogOtrosIngreso" label="Modal Otros Ingresos" max-height="85%" max-width="95%"
              persistent transition="fab-transition">

      <!--------------------- Creacion de Otros Ingresos ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Recibos de Otros
                Ingresos
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Recibos de Otros Ingresos: </span>
              Creación de Recibos de Otros Ingresos</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="cancelarOtrosIngreso()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar y no Crear el Recibos de Otros Ingresos</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="grey" dark small @click="newnewOtrosIngreso()" v-on="on">

                    <v-avatar color="transparent" size="28" tile>
                      <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                    </v-avatar>


                    <i style="font-size: 20px;"> </i>
                    NUEVO
                  </v-btn>
                </template>
                <span>NUEVO: Limpia los campo para un nuevo registro</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="SalvarOtrosIngreso()" v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Aceptar y crear el Recibos de Otros Ingresos </span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
        <v-card>
          <!-- columna informacion  -->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> CREAR RECIBOS DE OTROS INGRESOS</b>
                <v-form ref="formOtrosIngresos" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <!-- Row 1      ------------------------------------------->

                  <v-row>

                    <v-col cols="12" md="12" sm="12">
                      <!-------------------------------------------------- fecha -->
                      <v-text-field v-model="OtrosIngreso.fecha" :rules="[$rules.required]" dense label="Fecha" outlined
                                    type="date">

                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 20px;"></i>
                        </template>

                      </v-text-field>

                      <!-------------------------------------------------- Referencia -->
                      <v-text-field v-model="OtrosIngreso.referencia" dense label="No.Referencia" outlined
                                    @blur="getDocumentoOtrosIngresos">
                        <template v-slot:prepend>
                          <i class="fa fa-map-signs" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <!-- ----------------------------- nombre -->

                      <v-text-field v-model="OtrosIngreso.nombre" :rules="[$rules.required]" autocomplete="off" dense
                                    label="* Nombre:"
                                    outlined @blur="getDocumentoOtrosIngresos">
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>
                      <v-text-field v-model="OtrosIngreso.telefono" v-mask="'(###)###-####'" autocomplete="off" dense
                                    label="Télefono:"
                                    maxlength="13" outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-phone" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field v-model="OtrosIngreso.identificacion" v-mask="MakCelRnc"
                                    :rules="[$rules.RulesCelRnc]" autocomplete="off" dense
                                    label="* Cedula/RNC:" maxlength="13" outlined
                                    @blur="MakaraCelOtroIngreso" @focus="MakCelRnc = '#############'">
                        <template v-slot:prepend>
                          <i class="fa fa-id-card-o" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <VueAutonumeric v-model.number="OtrosIngreso.valor" :rules="[$rules.required]" autocomplete="off"
                                      dense label="Valor"
                                      outlined style="font-size:13px;"
                                      @blur="contabilidadOtrosIngreso">
                        <template v-slot:prepend>
                          <i class="fa fa-usd" style="font-size: 20px;"></i>
                        </template>
                      </VueAutonumeric>


                      <!-- @blur="SelctCbImpuestoProducto"
                @focus="cargarImpuestoProducto" -->
                      <v-combobox v-model="OtrosIngreso.tipoRecibo" :items="RtipoOtroIngreso" autocomplete="off" dense
                                  item-text="nombre"
                                  label="Tipo:" outlined style="font-size: 13px;"
                                  @blur="SelctCbTipoRecibo">
                        <template v-slot:prepend>
                          <i class="fa fa-percent" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>

                      <!-------------------------------------------------- Concepto -->
                      <v-textarea v-model="OtrosIngreso.concepto" :rules="[$rules.required]" autocomplete="off" dense
                                  label="Concepto"
                                  outlined rows="5">
                        <template v-slot:prepend>
                          <i class="fa fa-commenting" style="font-size: 20px;"></i>
                        </template>
                      </v-textarea>


                    </v-col>

                  </v-row>
                  <!-- Row 2 ------------------------------------------->


                </v-form>
              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Otros Ingresos-->

    <!-- ------------------------------------------------------ Modal-Impresora Fiscal -->
    <v-dialog v-model="dialogImpFiscal" label="Modal Otros Ingresos" max-height="85%" max-width="95%"
              persistent transition="fab-transition">

      <!--------------------- Creacion de Otros Ingresos ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Impresora Fiscal
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Impresora Fiscal: </span> Impresora
              Fiscal</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="cancelarImpresoraFiscal()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar atras</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="grey" dark small @click="newnewImpresoraFiscal()" v-on="on">

                    <v-avatar color="transparent" size="28" tile>
                      <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                    </v-avatar>


                    <i style="font-size: 20px;"> </i>
                    NUEVO
                  </v-btn>
                </template>
                <span>NUEVO: Limpia los campo para un nuevo registro</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

        </v-toolbar>
        <v-card>
          <!-- columna informacion  -->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> IMPRESORA FISCAL</b>

                <v-col :class="`d-flex justify-center`" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                  <!-- <v-card-actions > </v-card-actions>  -->
                  <!-- Botones de Impresora fiscal -------------------------------------->
                  <v-row :class="`d-flex justify-center`">
                    <!-- Imp.Fiscal btn ------>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-hover v-slot:default="{ hover }" close-delay="200">
                          <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                                 :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                 dark
                                 height="50px" min-width="110px" v-on="on" @click.prevent="imprimirCierreZ()">
                            <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                            <span>

                              <v-avatar color="transparent" size="30" tile>
                                <img alt="CIERRE Z" src="@/assets/icons_pv/impfiscal/cierreZ64.png">
                              </v-avatar>


                              <br>
                              <b v-bind:style="{ 'font-size': '13px', 'color': hover ? 'white' : '#000000' }">CIERRE
                                Z</b>

                            </span>
                          </v-btn>
                        </v-hover>
                      </template>
                      <span><b> CIERRE Z</b> </span>
                    </v-tooltip>

                    <!-- Imp.Fiscal btn ------>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-hover v-slot:default="{ hover }" close-delay="200">
                          <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                                 :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                 dark
                                 height="50px" min-width="110px" v-on="on" @click.prevent="imprimirReporteX()">
                            <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                            <span>

                              <v-avatar color="transparent" size="30" tile>
                                <img alt="REPORTE X" src="@/assets/icons_pv/impfiscal/reportes64.png">
                              </v-avatar>


                              <br>
                              <b v-bind:style="{ 'font-size': '13px', 'color': hover ? 'white' : '#000000' }">REPORTE
                                X</b>

                            </span>
                          </v-btn>
                        </v-hover>
                      </template>
                      <span><b> REPORTE X</b> </span>
                    </v-tooltip>

                    <!-- Imp.Fiscal btn ------>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-hover v-slot:default="{ hover }" close-delay="200">
                          <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                                 :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                 dark
                                 height="50px" min-width="110px" v-on="on" @click.prevent="abrirLVentas()">
                            <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                            <span>

                              <v-avatar color="transparent" size="30" tile>
                                <img alt="L VENTAS" src="@/assets/icons_pv/impfiscal/ventas64.png">
                              </v-avatar>


                              <br>
                              <b v-bind:style="{ 'font-size': '13px', 'color': hover ? 'white' : '#000000' }">L
                                VENTAS</b>

                            </span>
                          </v-btn>
                        </v-hover>
                      </template>
                      <span><b> L VENTAS</b> </span>
                    </v-tooltip>

                    <!-- Imp.Fiscal btn ------>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-hover v-slot:default="{ hover }" close-delay="200">
                          <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                                 :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                 dark
                                 height="50px" min-width="110px" v-on="on" @click.prevent="imprimirUltimoDocumento()">
                            <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                            <span>

                              <v-avatar color="transparent" size="30" tile>
                                <img alt="Imp.Ult.Doc" src="@/assets/icons_pv/impfiscal/imprimir64.png">
                              </v-avatar>


                              <br>
                              <b
                                v-bind:style="{ 'font-size': '13px', 'color': hover ? 'white' : '#000000' }">Imp.Ult.Doc</b>

                            </span>
                          </v-btn>
                        </v-hover>
                      </template>
                      <span><b> Imprimir Ultimo Documento </b> </span>
                    </v-tooltip>

                    <!-- Imp.Fiscal btn ------>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-hover v-slot:default="{ hover }" close-delay="200">
                          <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                                 :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                 dark
                                 height="50px" min-width="110px" v-on="on" @click.prevent="cancelarUltimoDocumento()">
                            <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                            <span>

                              <v-avatar color="transparent" size="30" tile>
                                <img alt="Canc.Ult.Doc" src="@/assets/icons_pv/impfiscal/cancelarDocumento64.png">
                              </v-avatar>


                              <br>
                              <b
                                v-bind:style="{ 'font-size': '13px', 'color': hover ? 'white' : '#000000' }">Canc.Ult.Doc</b>

                            </span>
                          </v-btn>
                        </v-hover>
                      </template>
                      <span><b> Cancelar Ultimo Documento</b> </span>
                    </v-tooltip>
                    <!-- Botones de Impresora fiscal -------------------------------------->


                  </v-row>
                </v-col>


                <v-container>

                  <v-row>
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6" style="border: 1px solid #000000;">
                      <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                        <span :class="`d-flex justify-center white--text`"><b>CIERRE Z RANGO DE FECHAR</b></span>
                      </v-col>
                      <v-col cols="12" md="12" sm="12">
                        <v-form ref="formOtrosIngresos" v-model="valid" lazy-validation translate="no" class="notranslate">
                          <v-text-field v-model="CierreRangoFecha.fechaInicio" :rules="[$rules.required]" dense
                                        label="Fecha Inicial"
                                        outlined type="date">

                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 20px;"></i>
                            </template>

                          </v-text-field>

                          <v-text-field v-model="CierreRangoFecha.fechaFinal" :rules="[$rules.required]" dense
                                        label="Fecha Final"
                                        outlined type="date">

                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 20px;"></i>
                            </template>

                          </v-text-field>
                          <v-hover v-slot:default="{ hover }" close-delay="200">

                            <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'blue darken-3' : 'blue'"
                                   :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                   block dark>

                              <h2>IMPRIMIR</h2>

                            </v-btn>
                          </v-hover>

                        </v-form>
                      </v-col>
                    </v-col>

                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6" style="border: 1px solid #000000;">

                      <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                        <span :class="`d-flex justify-center white--text`"><b>CIERRE Z RANGO DE NÚMERO</b></span>
                      </v-col>

                      <v-col cols="12" md="12" sm="12">
                        <v-form ref="formCierreRangoNumero" v-model="valid" lazy-validation translate="no" class="notranslate">
                          <v-text-field v-model.number="CierreRangoNumero.inicio" :rules="[$rules.required]" dense
                                        label="Rango Inicial"
                                        outlined type="number">

                            <template v-slot:prepend>
                              <i class="fa fa-sort-numeric-asc" style="font-size: 20px;"></i>
                            </template>

                          </v-text-field>

                          <v-text-field v-model.number="CierreRangoNumero.final" :rules="[$rules.required]" dense
                                        label="Rango Final"
                                        outlined type="number">

                            <template v-slot:prepend>
                              <i class="fa fa-sort-numeric-desc" style="font-size: 20px;"></i>
                            </template>

                          </v-text-field>

                          <v-hover v-slot:default="{ hover }" close-delay="200">

                            <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'blue darken-3' : 'blue'"
                                   :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                   block dark>

                              <h2>IMPRIMIR</h2>

                            </v-btn>
                          </v-hover>

                        </v-form>
                      </v-col>

                    </v-col>
                  </v-row>
                </v-container>


              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal-Impresora Fiscal-->

    <!-------------------------------------------------------- Modal- Modal-Cambio Divisa -->
    <v-dialog v-model="dialogCambioDivisa" fullscreen hide-overlay label="Modal Crear editar cliente  " persistent
              transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Cambio Divisa
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>Cambio Divisa: </span> Crea y anular
              Cambio Divisa</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark
                         small v-on="on" @click.prevent="dialogCambioDivisa = false, NewNewCambioDivisa()">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Cancela y retornar atrás</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="grey" dark small v-on="on" @click.prevent="NewNewCambioDivisa()">

                    <v-avatar color="transparent" size="28" tile>
                      <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                    </v-avatar>


                    <i style="font-size: 20px;"> </i>
                    NUEVO
                  </v-btn>
                </template>
                <span>NUEVO: Limpia los campo para un nuevo registro</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small
                         v-on="on"
                         @click.prevent="SalvarCambioDivisa()">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Crea Cambio Divisay retornar atrás </span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>

        <v-col cols="12" md="12" sm="12">
          <v-row>
            <!--------- columna 1 Crear---------->
            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6" style="border: 1px solid #000000;">
              <!-- 285 id="divSelecProd"   v-bind:style="{  'max-height':this.windowSize.height-400+'px','border': '2px solid #000000' }" class="overflow-x-auto"  -->
              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                <span :class="`d-flex justify-center white--text`"><b>Crear Cambio Divisa </b></span>
              </v-col>

              <v-form ref="formCambioDivisa" v-model="valid" lazy-validation translate="no" class="notranslate">
                <v-row>

                  <!-- -----------------------------  Codigo -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field id="formdisabledInput" v-model="CambioDivisa.id" :disabled="true" dense hide-details
                                  label="Codigo:" outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-list-ol" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>
                  </v-col>


                  <!-- -----------------------------------------Moneda   @blur="SelctCbMoneda"  -->
                  <v-col class="py-0 my-0" cols="12" md="12" sm="12">
                    <v-combobox id="formdisabledInput" v-model="CambioDivisa.moneda" :disabled="CambioDivisa.id > 0"
                                :items="Rmoneda" :rules="[$rules.required]"
                                autocomplete="off"
                                dense item-text="nombrecorto" label="Monedas"
                                outlined style="font-size:13px;" @focus="cargarMoneda">
                      <template v-slot:prepend>
                        <i class="fa fa-money" style="font-size: 20px;"></i>
                      </template>

                      <template slot="item" slot-scope="item">
                        <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="font-size: 13px;">
                          <p class="pa-0 ma-0 py-0 my-0"><b>{{ item.item.descripcion }} ({{
                              item.item.nombrecorto
                            }})</b>
                          </p>
                        </v-col>
                      </template>
                    </v-combobox>
                  </v-col>

                  <!-- -----------------------------  Tasa Compra -->
                  <v-col v-if="CambioDivisa.moneda != null" class="py-0 my-0" cols="12" md="6" sm="6">
                    <v-text-field id="formdisabledInput" v-model.number="CambioDivisa.moneda.tasaCompra"
                                  :disabled="true" dense
                                  label="Tasa Compra:" outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-usd" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>
                  </v-col>
                  <!-- -----------------------------  Tasa Ventas -->
                  <v-col v-if="CambioDivisa.moneda != null" class="py-0 my-0" cols="12" md="6" sm="6">
                    <v-text-field id="formdisabledInput" v-model.number="CambioDivisa.moneda.tasaVenta" :disabled="true"
                                  dense
                                  label="Tasa Ventas:" outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-usd" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col class="py-0 my-0" cols="12" md="12" sm="12">

                    <span :class="`d-flex justify-center`"><b> OPERACIÓN </b></span>

                    <v-radio-group v-model="CambioDivisa.operacion" :disabled="CambioDivisa.id > 0"
                                   class="mt-0 d-flex justify-center" row @change="cambioMonedas">
                      <!-- <v-row></v-row>
                              <v-col cols="12" md="6"></v-col> -->
                      <v-radio :value="false" color="green darken-3" label="COMPRA"></v-radio>

                      <!-- <v-col cols="12" md="6"></v-col> -->
                      <v-radio :value="true" color="teal lighten-2" label="VENTA"></v-radio>
                    </v-radio-group>

                  </v-col>

                  <v-col class="py-0 my-0" cols="12" md="12" sm="12">

                    <!-- -----------------------------  Nombre -->
                    <v-text-field id="formdisabledInput" v-model="CambioDivisa.nombreCliente"
                                  :disabled="CambioDivisa.id > 0" :rules="[$rules.required]" autocomplete="off"
                                  dense label="* Nombre:"
                                  outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-font" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>


                  </v-col>


                  <!-- ----------------------------- cedula/rnc -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                    <v-text-field id="formdisabledInput" v-model="CambioDivisa.cedulaCliente" v-mask="MakCelRncCambDiv"
                                  :disabled="CambioDivisa.id > 0" :rules="[$rules.RulesCelRnc]" autocomplete="off" dense
                                  label="* Cedula/RNC:"
                                  maxlength="13" outlined
                                  @blur="MakaraCelCambio" @focus="MakCelRncCambDiv = '#############'">
                      <template v-slot:prepend>
                        <i class="fa fa-id-card-o" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>
                  </v-col>

                  <!-- ----------------------------- Télefono -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                    <v-text-field id="formdisabledInput" v-model="CambioDivisa.telefonoClietne" v-mask="'(###)###-####'"
                                  :disabled="CambioDivisa.id > 0" autocomplete="off"
                                  dense label="Télefono:" maxlength="13"
                                  outlined>
                      <template v-slot:prepend>
                        <i class="fa fa-phone" style="font-size: 20px;"></i>
                      </template>
                    </v-text-field>
                  </v-col>

                  <!-- ----------------------------- Cantidad a comprar -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                    <VueAutonumeric id="formdisabledInput" v-model.number="CambioDivisa.cantidadComprada"
                                    :disabled="CambioDivisa.id > 0" :label="tituloCompra + ':'"
                                    :rules="[$rules.required]" autocomplete="off" dense
                                    outlined
                                    style="font-size:13px;" @input="cambioMonedas">
                      <template v-slot:prepend>
                        <i class="fa fa-usd" style="font-size: 20px;"></i>
                      </template>
                    </VueAutonumeric>
                  </v-col>


                  <!-- ----------------------------- Cantidad a entregar -->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                    <VueAutonumeric id="formdisabledInput" v-model.number="CambioDivisa.cantidadEntregada"
                                    :rules="[$rules.required]" autocomplete="off" dense
                                    disabled label="Cantidad a entregar:"
                                    outlined
                                    style="font-size:13px;">
                      <template v-slot:prepend>
                        <i class="fa fa-usd" style="font-size: 20px;"></i>
                      </template>
                    </VueAutonumeric>
                  </v-col>

                  <!-- ----------------------------- Cantidad a recibida:-->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                    <VueAutonumeric id="formdisabledInput" v-model.number="CambioDivisa.cantidadRecivida"
                                    :disabled="CambioDivisa.id > 0" :rules="[$rules.required]"
                                    autocomplete="off" dense label="Cantidad recibida:"
                                    outlined
                                    style="font-size:13px;" @input="cambioMonedas">
                      <template v-slot:prepend>
                        <i class="fa fa-usd" style="font-size: 20px;"></i>
                      </template>
                    </VueAutonumeric>
                  </v-col>

                  <!-- ----------------------------- Devolver:-->
                  <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                    <VueAutonumeric id="formdisabledInput" v-model.number="CambioDivisa.devuelta"
                                    :rules="[$rules.Numericc]" autocomplete="off" dense disabled
                                    label="Devolver:" outlined
                                    style="font-size:13px;"
                                    @input="cambioMonedas">
                      <template v-slot:prepend>
                        <i class="fa fa-usd" style="font-size: 20px;"></i>
                      </template>
                    </VueAutonumeric>
                  </v-col>


                  <!-- -----------------------------  Btn Anular -->
                  <v-col v-if="CambioDivisa.id > 0" class="py-0 my-0" cols="12" md="6" sm="6">
                    <v-hover v-slot:default="{ hover }" close-delay="200">

                      <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red darken-3' : 'red'"
                             :elevation="hover ? 24 : 2" :outlined="hover ? true : false"
                             block dark
                             @click.prevent="anularCambioDivisa">

                        <h2>ANULAR</h2>

                      </v-btn>
                    </v-hover>
                  </v-col>

                  <!-- -----------------------------  Btn Imprimir -->
                  <v-col v-if="CambioDivisa.id > 0" class="py-0 my-0" cols="12" md="6" sm="6">
                    <v-hover v-slot:default="{ hover }" close-delay="200">

                      <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'blue darken-3' : 'blue'"
                             :elevation="hover ? 24 : 2" :outlined="hover ? true : false"
                             block dark
                             @click.prevent="imprimirCambioDivisa">

                        <h2>IMPRIMIR</h2>

                      </v-btn>
                    </v-hover>
                  </v-col>


                </v-row>
              </v-form>

            </v-col>
            <!--------- fn columna 1 Cambio Divisa ---------->


            <!--------- columna 2 Cambio Divisa ---------->
            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="6" sm="6" style="border: 1px solid #000000; ">

              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                <span :class="`d-flex justify-center white--text`"><b> Buscar registro Cambio Divisa </b></span>
              </v-col>

              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">

                <!--------------------------------------------------  Header tb Cambio Divisa -->
                <v-col class="py-0 my-0" cols="12" md="12" sm="12">
                  <v-form ref="formReimprecion" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
                    <v-row>


                      <v-col cols="12" md="6" sm="6">
                        <!--  Cambio Divisa busqueda secuencia  @blur="getCierreCaja" v-on:input="resertPaginacion" -------------->
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">

                            <v-text-field v-model.number="CambioDivisaBusqueda.secuencia" autocomplete="off" dense
                                          label="# Secuencia:" outlined style="font-size: 12px;"
                                          type="number" v-on="on">


                              <template v-slot:prepend>
                                <i class="fa fa-hashtag" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>


                          </template>
                          <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                            <span> Aquí se registra el número de cierre que deseamos búscar.</span>
                          </i>
                        </v-tooltip>

                        <!--  Cambio Divisa busqueda cliente  @blur="getCierreCaja" v-on:input="resertPaginacion" -------------->
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">

                            <v-text-field v-model="CambioDivisaBusqueda.cliente" autocomplete="off" dense
                                          label="Cliente:" outlined
                                          style="font-size: 12px;" v-on="on">


                              <template v-slot:prepend>
                                <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>


                          </template>
                          <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                            <span> Aquí se registra el nombre del cliente que deseamos búscar.</span>
                          </i>
                        </v-tooltip>

                      </v-col>


                      <v-col cols="12" md="6" sm="6">
                        <!--  Cambio Divisa busqueda Fecha Inicial @input="getCierreCaja"  v-on:input="resertPaginacion" -------------->

                        <v-tooltip top>
                          <template v-slot:activator="{ on }">

                            <v-text-field v-model="CambioDivisaBusqueda.fechaInicial" :rules="[$rules.required]" dense
                                          label="Fecha Inicial" outlined
                                          placeholder=" " style="font-size: 12px;"
                                          type="date"
                                          @blur="CargarBusquedaCambioDivisa" v-on="on">
                              <template v-slot:prepend>
                                <i class="fa fa-calendar" style="font-size: 18px;"></i>
                              </template>
                            </v-text-field>

                          </template>
                          <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                            <span> Aquí se registra la fecha a partir de la cual queremos la búsqueda.</span>
                          </i>
                        </v-tooltip>
                        <!--  Cambio Divisa busqueda Fecha final @input="getCierreCaja"  v-on:input="resertPaginacion" -------------->
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">

                            <v-text-field v-model="CambioDivisaBusqueda.fechaFinal" :rules="[$rules.required]" dense
                                          label="Fecha Final" outlined
                                          placeholder=" " style="font-size: 12px;"
                                          type="date"
                                          @blur="CargarBusquedaCambioDivisa" v-on="on">
                              <template v-slot:prepend>
                                <i class="fa fa-calendar" style="font-size: 18px;"></i>
                              </template>

                              <template v-slot:append-outer>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-btn color="green" dark small v-on="on"
                                           @click.prevent="CargarBusquedaCambioDivisa">
                                      <i class="fa fa-search" style="font-size: 20px;"></i>

                                    </v-btn>
                                  </template>
                                  <span>Buscar Cambio Divisa </span>
                                </v-tooltip>

                              </template>


                            </v-text-field>

                          </template>
                          <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                            <span> Aquí se registra la fecha hasta donde queremos la búsqueda.</span>
                          </i>
                        </v-tooltip>
                      </v-col>

                    </v-row>
                  </v-form>

                </v-col>
                <!-------------------------------------------------- fn Header tb Cambio Divisa  -->
                <!-------------------------------------------------- tb Cambio Divisa
    :single-select="true" :show-select="true"
    -->
                <div
                  class="overflow-x-auto"
                  v-bind:style="{ 'margin-top': '-20px', 'height': this.windowSize.height - 150 + 'px', 'max-height': this.windowSize.height - 150 + 'px' }">

                  <v-data-table :headers="[
                  { text: 'Fecha', sortable: false, value: 'nuevaFecha', width: 120 },
                  { text: '# Secuencia', sortable: false, value: 'id', width: 129 },
                  { text: 'Cliente', sortable: false, value: 'nombreCliente', width: 129 },
                  { text: 'Valor', sortable: false, value: 'cantidadComprada', width: 'auto', width: 105 },
                  ]" :items="CambioDivisalist" :items-per-page="-1" class="RowSelectColor" dense hide-default-footer
                                item-key="indx" style="border: 1px solid #000000; "
                                @click:row="CambioDivisaDatostabla">


                    <template v-slot:item.action="{ item }">

                      <!-- <v-btn fab @click.prevent="VerReporte(item)" x-small color="yellow accent-4"><i style="font-size: 20px;" class="fa fa-eye"></i></v-btn>  -->
                      <!-- <v-btn fab @click.prevent="deleFact(item)" x-small color="red darken-3"><i style="font-size: 20px;" class="fa fa-trash-o"></i></v-btn> -->

                    </template>

                    <template v-slot:item.nuevaFecha="props">
                      <span
                        style="font-size:13px; display:none;">{{
                          props.item.indx = CambioDivisalist.indexOf(props.item)
                        }}</span>
                      <span style="font-size:13px;">{{ FormatoFecha(props.item.nuevaFecha) }}</span>
                    </template>

                    <template v-slot:item.id="props">
                      <span style="font-size:13px;">{{ props.item.id }} </span>
                    </template>

                    <template v-slot:item.nombreCliente="props">
                      <span style="font-size:13px;">{{ props.item.nombreCliente }}</span>
                    </template>


                    <template v-slot:item.cantidadComprada="props">
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.cantidadComprada) }}</span>
                    </template>

                  </v-data-table>


                </div>
                <!-------------------------------------------------- fn tb Cambio Divisa -->


              </v-col>


            </v-col>
            <!--------- fn columna 2 Crear/editar ---------->

          </v-row>
        </v-col>
      </v-card>
    </v-dialog>
    <!--------------------------------------------------------  fn Modal- Cambio Divisa -->


    <!-- ------------------------------------------------------ Modal-Configuracion pv -->
    <v-dialog v-model="dialogConfigPv" label="M Configuracion pv " max-height="85%" max-width="95%"
              persistent
              transition="fab-transition">

      <!--------------------- Creacion de ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> CONFIGURACIÓN
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> CONFIGURACIÓN: </span>
              Configuración</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-4" fab small @click="dialogConfigPv = false">
              <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
            </v-btn>

          </v-card-actions>

        </v-toolbar>
        <v-card>
          <!-- columna informacion  -->
          <v-col cols="12" md="12" sm="12">

            <div class="px-2">
              <v-card color="grey lighten-3">

                <div class="px-2">

                  <v-row>
                    <!-- Columna 1 -->
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="4" sm="4" style="border: 1px solid #000000;">

                      <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                        <span :class="`d-flex justify-center white--text`"><b>CONFIGURACIÓN DE CAJA</b></span>
                      </v-col>

                      <v-col cols="12" md="12" sm="12">

                        <v-combobox v-model="caja" :items="RCaja" autocomplete="off" dense item-text="descripcion"
                                    label="Caja"
                                    outlined
                                    required @blur="SelctCbCajaConfigPv" @change="UpdateConfigPv"
                                    @focus="cargarCaja">
                          <template v-slot:prepend>
                            <i class="fa fa-fax" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                      </v-col>
                    </v-col>
                    <!-- fn Columna 1 -->
                    <!-- Columna 2 -->
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="4" sm="4" style="border: 1px solid #000000;">

                      <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                        <span :class="`d-flex justify-center white--text`"><b>CONFIGURACIÓN DE IMPRESORA</b></span>
                      </v-col>

                      <v-col cols="12" md="12" sm="12">

                        <v-combobox v-if="false" v-model="terminal" :items="listTerminal" autocomplete="off" dense
                                    item-text="terminal" label="Seleccione Terminal:" outlined
                                    @change="updateImpresoraLocal"
                                    @focus="findAllTerminal">
                          <template v-slot:prepend>
                            <i class="fa fa-trademark" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                        <v-combobox v-model="OtrasConfigPv.impresora" :items="terminal.impresoras" autocomplete="off"
                                    dense item-text="nombre"
                                    label="Seleccione Impresora:" outlined
                                    @change="updateImpresoraLocal"
                                    @focus="findAllTerminal"

                        >
                          <template v-slot:prepend>
                            <i class="fa fa-print" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                      </v-col>

                    </v-col>
                    <!-- fn Columna 2 -->
                    <!-- Columna 3 -->
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="4" sm="4" style="border: 1px solid #000000;">

                      <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                        <span :class="`d-flex justify-center white--text`"><b>CAMBIO DE TURNO</b></span>
                      </v-col>

                      <v-col cols="12" md="12" sm="12">

                        <v-combobox v-model="OtrasConfigPv.turno"
                        :items="RTurnoTrabajo" @blur="SelctCbTurnoTrabajoConfigPv"
                         autocomplete="off" dense item-text="descripcion"
                                    label="Turno:"
                                    outlined @change="UpdateConfigPvTurno"
                                    @focus="cargarTurnoTrabajo">
                          <template v-slot:prepend>
                            <i class="fa fa-clock-o" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                      </v-col>

                    </v-col>
                    <!-- fn Columna 3 -->


                  </v-row>
                </div>


              </v-card>
            </div>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Modal-Configuracion pv-->

    <!-------------------------------------------------------- Modal-Cotizacion a Factura-->
    <v-dialog v-model="dialogBucarCotizacion" fullscreen hide-overlay label="Modal Cotizacion a Factura " persistent
              transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> ver Cotización
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>ver Cotización: </span> Ver
              Cotización</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>

            <v-tooltip bottom>

              <template v-slot:activator="{ on }">
                <v-btn id="boton-mini" color="orange" dark
                       small @click="dialogBucarCotizacion = false, NewBucarCotizacion()" v-on="on">
                  <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                  CANCELAR
                </v-btn>
              </template>
              <span>CANCELAR: Cancela y retornar atrás</span>
            </v-tooltip>

          </v-card-actions>
        </v-toolbar>

        <v-col cols="12" md="12" sm="12">
          <v-card color="grey lighten-3">
            <br>

            <v-form ref="formReimprecion" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
              <v-row>

                <!--  reimprecion busqueda secuencia  @blur="getCierreCaja" v-on:input="resertPaginacion" -------------->
                <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model.number="CotizacionBusqueda.secuencia" autocomplete="off" dense
                                    label="# Secuencia:" outlined style="font-size: 12px;"
                                    type="number" v-on="on">


                        <template v-slot:prepend>
                          <i class="fa fa-hashtag" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra el número de secuencia que deseamos búscar.</span>
                    </i>
                  </v-tooltip>
                </v-col>

                <!--  reimprecion busqueda Fecha Inicial @input="getCierreCaja"  v-on:input="resertPaginacion" -------------->
                <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model="CotizacionBusqueda.fechaInicial" :rules="[$rules.required]" dense
                                    label="Fecha Inicial" outlined
                                    placeholder=" " style="font-size: 12px;" type="date"
                                    v-on="on">
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 18px;"></i>
                        </template>
                      </v-text-field>

                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra la fecha a partir de la cual queremos la búsqueda.</span>
                    </i>
                  </v-tooltip>
                </v-col>

                <!--  reimprecion busqueda Fecha Final @input="getCierreCaja"  v-on:input="resertPaginacion" -------------->
                <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model="CotizacionBusqueda.fechaFinal" :rules="[$rules.required]" dense
                                    label="Fecha Final" outlined
                                    placeholder=" " style="font-size: 12px;" type="date"
                                    v-on="on">
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 18px;"></i>
                        </template>
                      </v-text-field>

                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra la fecha hasta donde queremos la búsqueda.</span>
                    </i>
                  </v-tooltip>
                </v-col>
                <!--  reimprecion cliente @change="getFacVenta"  @blur="SelctCbCotizacionBuscar"-------------->
                <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-combobox ref="RefCombClienteCosFac" v-model="CotizacionBusqueda.cliente" :items="RCliente"
                                  autocomplete="off" dense
                                  item-text="codnom"
                                  label="cliente:" no-filter outlined
                                  style="font-size: 13px;"
                                  @focus="cargarClienteBusqueda" @keyup="CbFilcliente" v-on="on">

                        <template slot="item" slot-scope="item">
                          <span style="display:none;">{{
                              item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `
                            }}</span>
                          <span class="fontSize13"><b>{{ item.item.codigo }}</b> - {{ item.item.nombre.trim() }}</span>
                        </template>

                       

                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.nombre}}</span>
                    <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                  </template>

                        <template v-slot:prepend>
                          <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>
                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Se selecciona el cliente que desea buscar.</span>
                    </i>
                  </v-tooltip>


                </v-col>
                <v-col class="py-0 my-0" cols="12" md="1" sm="1">
                  <v-btn color="teal" small @click.prevent="getCotizacionlistFactCliente"><i class="fa fa-search"
                                                                                             style="font-size: 20px;"></i>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>

            <v-col class=" pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
              <v-data-table :footer-props="arrayPropiedases" :headers="[
                { text: 'Fecha', sortable: false, value: 'fecha', width: 120 },
                { text: '# Secuencia', sortable: false, value: 'secuencia', width: 129 },
                { text: 'Cliente', sortable: false, value: 'nombrecliente', width: 129 },
                { text: 'Valor', sortable: false, value: 'valor', width: 'auto', width: 105 },
              ]" :items="filterCotizacionAfactura(VerCotizacionlistFactCliente)"
                            :items-per-page="CotizacionPaginator.itemsPerPage" :server-items-length="TotalRegistros"
                            class="RowSelectColor" dense
                            item-key="indx" @pagination="CotizacionCargarPaginacion"
                            @click:row="VerCotizacionDatostabla">
                <template v-slot:item.fecha="props">

                  <span style="font-size:13px; display:none;">{{
                      props.item.indx =
                        VerCotizacionlistFactCliente.indexOf(props.item)
                    }}</span>
                  <span style="font-size:13px;">{{ FormatoFecha(props.item.fecha) }}</span>
                </template>

                <template v-slot:item.secuencia="props">
                  <span style="font-size:13px;">{{ props.item.secuencia }} </span>
                </template>

                <template v-slot:item.clinica.nombre="props">
                  <span v-if="props.item.cliente != null" style="font-size:13px;">{{ props.item.nombrecliente }} </span>
                </template>

                <template v-slot:item.valor="props">
                  <span style="font-size:13px;">{{ currencyFormatter(props.item.valor) }}</span>
                </template>
              </v-data-table>
            </v-col>

          </v-card>


        </v-col>

      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Modal- fn Cotizacion a Factura--->


    <!-- ------------------------------------------------------ Modal- Datos Vuelos-->
    <v-dialog v-model="dialogDatosVuelo" label="Modal Datos Vuelos" max-height="85%" max-width="95%"
              persistent
              transition="fab-transition">

      <!--------------------- Creacion Datos Vuelos ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Datos Vuelos
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Datos Vuelos: </span> Creación de
              Datos Vuelos</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="dialogDatosVuelo = false" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar y no Crear Datos Vuelos</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="grey" dark small @click="NewDatosVuelo()" v-on="on">

                    <v-avatar color="transparent" size="28" tile>
                      <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                    </v-avatar>

                    <i style="font-size: 20px;"> </i>
                    NUEVO
                  </v-btn>
                </template>
                <span>NUEVO: Limpia los campo para un nuevo registro</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="dialogDatosVuelo = false"
                         v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Aceptar y crear Datos Vuelos </span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
        <v-card>
          <!-- columna informacion Datos Vuelos -->
          <v-col cols="12" md="12" sm="12">

            <div class="px-2">
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> DATOS VUELOS</b>
                <v-form ref="formCrearDatoVuelo" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <!-- Row 1 edicion Datos Vuelos      ------------------------------------------->

                  <v-row>

                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="Facturasventa.lineaAerea" autocomplete="off" dense label="Linea Aerea:"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-plane" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="Facturasventa.numeroVuelo" autocomplete="off" dense label="# Vuelo:"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-plane" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" sm="6">
                      <p class="d-flex justify-center" style="font-size:18px;"><b>RUTA SALIDA</b></p>
                      <v-text-field v-model="Facturasventa.rutaSalidaE" autocomplete="off" dense label="E:" outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-plane" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field v-model="Facturasventa.rutaSalidaD" autocomplete="off" dense label="D:" outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-plane" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                    </v-col>


                    <v-col cols="12" md="6" sm="6">

                      <p class="d-flex justify-center" style="font-size:18px;"><b>RUTA RETORNO </b></p>
                      <v-text-field v-model="Facturasventa.rutaRetornoE" autocomplete="off" dense label="E:" outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-plane" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field v-model="Facturasventa.rutaRetornoD" autocomplete="off" dense label="D:" outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-plane" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>
                    </v-col>


                  </v-row>
                  <!-- Row 2 edicion Datos Vuelos  ------------------------------------------->


                </v-form>
              </v-card>
            </div>
          </v-col>
          <!-- columna informacion Datos Vuelos  -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Crear Datos Vuelos-->


    <!-- ------------------------------------------------------ Modal- Datos Del Pagare -->
    <v-dialog v-model="dialogPagare" fullscreen hide-overlay label="Datos Del Pagare" persistent
              transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <ComponentsPvModalPagare ref="RefComponentsPvModalPagare" :cajaSelect="caja"
                                 :clienteFactura="clienteFactura" :configuraciones="configuraciones"
                                 @DataRetornCancelarfacturaPagare="dialogPagare= false,dialogModalPagare=false"
                                 @DataRetornfacturaPagare="DataRetornfacturaPagare "
                                 @newDtosPagareFactura="newDtosPagareFactura" />
      </v-card>
    </v-dialog>
    <!-- ----------------------------------------------------- fn Modal- Datos Del Pagare -->


    <!-------------------------------------------------------- Modal Modal-Conduce a factura -->
    <v-dialog v-model="dialogBucarConduce" fullscreen hide-overlay label="Modal Reimprecion " persistent
              transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> ver Conduce
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>ver Conduce: </span> Ver Conduce</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>

            <v-tooltip bottom>

              <template v-slot:activator="{ on }">
                <v-btn id="boton-mini" color="orange" dark small
                       @click="dialogBucarConduce = false, NewBucarConduce()" v-on="on">
                  <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                  CANCELAR
                </v-btn>
              </template>
              <span>CANCELAR: Cancela y retornar atrás</span>
            </v-tooltip>

          </v-card-actions>
        </v-toolbar>

        <v-col cols="12" md="12" sm="12">
          <v-card color="grey lighten-3">
            <br>

            <v-form ref="formReimprecion" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
              <v-row>

                <!--  reimprecion busqueda secuencia  @blur="getCierreCaja" v-on:input="resertPaginacion" -------------->
                <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model.number="ConduceBusqueda.secuencia" autocomplete="off" dense
                                    label="# Secuencia:" outlined style="font-size: 12px;"
                                    type="number" v-on="on">


                        <template v-slot:prepend>
                          <i class="fa fa-hashtag" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra el número de secuencia que deseamos búscar.</span>
                    </i>
                  </v-tooltip>
                </v-col>

                <!--  reimprecion busqueda Fecha Inicial @input="getCierreCaja"  v-on:input="resertPaginacion" -------------->
                <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model="ConduceBusqueda.fechaInicial" :rules="[$rules.required]" dense
                                    label="Fecha Inicial" outlined
                                    placeholder=" " style="font-size: 12px;" type="date"
                                    v-on="on">
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 18px;"></i>
                        </template>
                      </v-text-field>

                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra la fecha a partir de la cual queremos la búsqueda.</span>
                    </i>
                  </v-tooltip>
                </v-col>

                <!--  reimprecion busqueda Fecha Final @input="getCierreCaja"  v-on:input="resertPaginacion" -------------->
                <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model="ConduceBusqueda.fechaFinal" :rules="[$rules.required]" dense
                                    label="Fecha Final" outlined
                                    placeholder=" " style="font-size: 12px;" type="date"
                                    v-on="on">
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 18px;"></i>
                        </template>
                      </v-text-field>

                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra la fecha hasta donde queremos la búsqueda.</span>
                    </i>
                  </v-tooltip>
                </v-col>
                <!--  reimprecion cliente @change="getFacVenta"  @blur="SelctCbConduceBuscar" -------------->
                <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-combobox v-model="ConduceBusqueda.cliente" :items="RCliente" autocomplete="off" dense
                                  item-text="codnom" label="cliente:"
                                  no-filter outlined style="font-size: 13px;"
                                   @focus="cargarClienteBusqueda" @keyup="CbFilcliente"
                                  v-on="on">
                        <template slot="item" slot-scope="item">
                          <span style="display:none;">{{
                              item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `
                            }}</span>
                          <span class="fontSize13"><b>{{ item.item.codigo }}</b> - {{ item.item.nombre.trim() }}</span>
                        </template>

                        <template v-slot:selection="{ attrs, item, parent, selected }">
                         <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.nombre}}</span>
                         <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                       </template>
                        
                        <template v-slot:prepend>
                          <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>
                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Se selecciona el cliente que desea buscar.</span>
                    </i>
                  </v-tooltip>


                </v-col>
                <v-col class="py-0 my-0" cols="12" md="1" sm="1">
                  <v-btn color="teal" small @click.prevent="getConducelistFactCliente"><i class="fa fa-search"
                                                                                          style="font-size: 20px;"></i>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>

            <v-col class=" pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
              <v-data-table :headers="[
                { text: 'Fecha', sortable: false, value: 'fecha', width: 120 },
                { text: '# Secuencia', sortable: false, value: 'conduceInventarioPK.secuencia', width: 129 },
                { text: 'Cliente', sortable: false, value: 'cliente', width: 129 },
                { text: 'Valor', sortable: false, value: 'valor', width: 'auto', width: 105 },
              ]" :items="VerConducelistFactCliente" class="RowSelectColor" dense item-key="indx"
                            @click:row="VerConduceDatostabla">
                <template v-slot:item.fecha="props">
                  <span style="font-size:13px; display:none;">{{
                      props.item.indx =
                        VerConducelistFactCliente.indexOf(props.item)
                    }}</span>
                  <span style="font-size:13px;">{{ FormatoFecha(props.item.fecha) }}</span>
                </template>

                <template v-slot:item.conduceInventarioPK.secuencia="props">
                  <span style="font-size:13px;">{{ props.item.documentoinventario.nombrecorto }} - {{
                      props.item.conduceInventarioPK.secuencia
                    }} </span>
                </template>

                <template v-slot:item.cliente="props">
                  <span v-if="props.item.cliente != null" style="font-size:13px;">{{ props.item.cliente.nombre }}
                  </span>
                </template>

                <template v-slot:item.valor="props">
                  <span style="font-size:13px;">{{ currencyFormatter(props.item.valor) }}</span>
                </template>
              </v-data-table>
            </v-col>

          </v-card>


        </v-col>

      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Modal- fn Modal-Conduce a factura-->


    <!-- ------------------------------------------------------ Modal- Notificacion Producto Controlado-->
    <v-dialog v-model="dialogNotifProdControlado" label="Modal Otros Ingresos" max-height="85%" max-width="55%"
              persistent transition="fab-transition">

      <!--------------------- Creacion de Otros Ingresos ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Producto
                controlado
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Producto cotrolado: </span>
              Producto cotrolado</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="green" dark small @click="EjecuModalProductoControlado('accept')"
                         v-on="on">

                    <i class="fa fa-check-circle" style="font-size: 20px;"> </i>
                    ACCEPTAR
                  </v-btn>
                </template>
                <span>ACCEPTAR: acceptar las condiciones del producto</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small
                         @click="EjecuModalProductoControlado('cancelar')"
                         v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar atras</span>
              </v-tooltip>


            </v-btn-toggle>

          </v-card-actions>

        </v-toolbar>
        <v-card>
          <!-- columna informacion  -->
          <v-col :class="`d-flex justify-center`" class="pa-0 ma-0 py-9 my-0" cols="12" md="12" sm="12">
            <center>
              <h1 class="py-9"><b>{{ LabelProdCotrolado }}</b></h1>
            </center>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Impresora Fiscal-->

    <!-------------------------------------------------------- Modal-Receta producto controlado -->
    <v-dialog v-model="dialogProdControlado" fullscreen hide-overlay label="Receta producto controlado" persistent
              transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <v-form ref="formRecetaProdControlado" v-model="valid" lazy-validation translate="no" class="notranslate">

          <v-toolbar color="#dd4b39" dark dense>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">

                <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Receta de
                  producto controlado
                </v-toolbar-title>

              </template>
              <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>Receta de producto controlado:
                </span></i>

            </v-tooltip>

            <v-spacer></v-spacer>

            <v-card-actions>
              <v-btn-toggle>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn id="boton-mini" color="orange" dark small v-on="on"
                           @click.prevent="CancelarRecetaControlada()">
                      <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                      CANCELAR
                    </v-btn>
                  </template>
                  <span>CANCELAR: Cancela y retornar atrás</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn id="boton-mini" color="light-blue darken-4" dark
                           small
                           v-on="on" @click.prevent="SalvaeRecetaControlada()">
                      <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                      SALVAR
                    </v-btn>
                  </template>
                  <span>SALVAR: Guardar Receta Controlada </span>
                </v-tooltip>


              </v-btn-toggle>

            </v-card-actions>

          </v-toolbar>

          <v-col cols="12" md="12" sm="12">
            <v-card color="grey lighten-3">

              <v-row no-gutters>
                <v-text-field v-model="RecetaProdControlado.numero" :rules="[$rules.required]" autocomplete="off" dense
                              hide-details
                              label="Receta No." outlined style="font-size: 12px;" @blur="findReceta">
                  <template v-slot:prepend>
                    <i class="fa fa-hashtag" style="font-size: 20px;"></i>
                  </template>
                </v-text-field>


                <v-text-field id="formdisabledInput" v-model="RecetaProdControlado.fecha" dense disabled hide-details
                              label="Fecha :" outlined style="font-size:13px;" type="date">

                  <template v-slot:prepend>
                    <i class="fa fa-calendar" style="font-size: 20px;"></i>
                  </template>
                </v-text-field>

              </v-row>


              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                <!-- Infomacion Selecionada -->
                <v-row no-gutters>
                  <v-col v-if="this.RecetaProdControlado.cliente != null" cols="12" md="6" sm="6">
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                      <span :class="`d-flex justify-center white--text`"><b>Datos Del Paciente</b></span>
                    </v-col>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> CÓDIGO #: </b>
                      {{ RecetaProdControlado.cliente.codigo }}</p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> NOMBRE: </b>
                      {{ RecetaProdControlado.cliente.nombre }}</p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> CÉDULA : </b>
                      {{ RecetaProdControlado.cliente.cedrnc }}</p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> TELEFONO : </b>
                      {{ RecetaProdControlado.cliente.telefono1 }}</p>
                    <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b> DIRECCIÓN: </b>
                      {{ RecetaProdControlado.cliente.direccion }}</p>
                  </v-col>

                  <v-col cols="12" md="6" sm="6">
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                      <span :class="`d-flex justify-center white--text`"><b>Datos Del Doctor</b></span>
                    </v-col>

                    <v-row class="px-2">
                      <v-col cols="12" md="6" sm="6">
                        <v-text-field v-model="RecetaProdControlado.medico" :rules="[$rules.required]"
                                      autocomplete="off"
                                      dense label="Médico:" outlined style="font-size: 13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-user-md" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>
                        <v-text-field v-model="RecetaProdControlado.exq" :rules="[$rules.required]" autocomplete="off"
                                      dense label="CIDC NO.:" outlined style="font-size: 13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-id-badge" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>

                      </v-col>

                      <v-col cols="12" md="6" sm="6">
                        <v-text-field v-model="RecetaProdControlado.telefono" v-mask="'(###)###-####'"
                                      autocomplete="off" dense label="Télefono:"
                                      maxlength="13" outlined style="font-size: 13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-phone" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>

                        <v-text-field v-model="RecetaProdControlado.especialidad" :rules="[$rules.required]"
                                      autocomplete="off" dense label="Especialidad:" outlined
                                      style="font-size: 13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-stethoscope" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="12" sm="12" style="margin-top: -25px;">
                        <v-textarea v-model="RecetaProdControlado.direccion" autocomplete="off" dense
                                    label="* Direccion:" outlined
                                    rows="1" style="font-size: 13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                          </template>
                        </v-textarea>

                        <v-combobox v-model="RecetaProdControlado.centroSalud" :items="RLiClinicas"
                                    :rules="[$rules.required]" dense item-text="nombre"
                                    label="Centro de Salud" outlined style="font-size: 13px;" @blur="SelctCbCentroSalud"
                                    @focus="CargarCentroSalud">
                          <template v-slot:prepend>
                            <i class="fa fa-ambulance" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                    </v-row>

                  </v-col>
                </v-row>
                <!-- fn Infomacion Selecionada -->

                <!--  Tabla  -->
                <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="border: 1px solid #000000;">

                  <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#dd4b39;">
                    <span :class="`d-flex justify-center white--text`"><b>Productos Controlados</b></span>
                  </v-col>

                  <v-data-table :headers="[
                    //    { text: 'Código', sortable: false,  value: 'productos.codigo', width:120, class: ['no-gutters  black--text'] },
                    { text: 'Medicamento', sortable: false, value: 'productos.descripcion', width: 'auto', class: ['no-gutters  black--text'] },
                    { text: 'Cantidad Recetada', sortable: false, value: 'cantidadRecetada', width: 'auto', class: ['no-gutters  black--text'] },
                    { text: 'cantidad Despachada', sortable: false, value: 'cantidadDespachada', width: 'auto', class: ['no-gutters  black--text'] },
                  ]" :items="RecetaProdControlado.detalleList" class="RowSelectColor TbSize13" dense item-key="indx">
                    <template v-slot:item.productos.descripcion="props">
                      <span style="display:none;">{{ props.item.indx = RecetaProdControlado.detalleList.indexOf(props.item) }}</span>
                      <span v-if="props.item.productos != null" style="font-size:13px;display:none">
                        {{ props.item.producto = props.item.productos }}
                      </span>
                      <span style="font-size:13px;">{{ props.item.productos.descripcion }}
                        {{ props.item.unidad.descripcion }} </span>
                    </template>

                    <template v-slot:item.cantidadRecetada="props">
                      <!-- <span style="font-size:13px;">{{props.item.cantidadRecetada}}  </span> -->
                    <!-- @blur="blurCantidadRecetada" onclick="blurCantidadRecetada(props.item)"-->
                     <div @click="blurCantidadRecetada(props.item,disableNumeroReceta)">
                    <VueAutonumeric id="formdisabledInput" v-model.number="props.item.cantidadRecetada"
                                      :disabled="disableNumeroReceta"
                                      :rules="[$rules.required]" autocomplete="off" dense hide-details label=""
                                      outlined
                                      style="font-size:13px;">
                      </VueAutonumeric>
                  </div>
                    </template>

                  </v-data-table>
                </v-col>
                <!-- fn Tabla  -->


              </v-col>

            </v-card>
          </v-col>
        </v-form>
      </v-card>
    </v-dialog>
    <!-------------------------------------------------------- fn Modal- Receta producto controlado -->


    <!-- ------------------------------------------------------ Modal-comprobante fiscal -->
    <v-dialog v-model="dialogComprobante" label="Modal comprobante fiscal" max-height="85%" max-width="95%"
              persistent transition="fab-transition">
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Comprobante
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Comprobante: </span> Selección de
              Comprobante</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="cancelarComprobante()" :disabled="fiscalPosGuardando" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar y no Crear vale de caja</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="SalvarComprobante()" :loading="fiscalPosGuardando" :disabled="fiscalPosGuardando" v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Aceptar Comprobante </span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
        <v-card>
          <!-- columna informacion comprobante fiscal-->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> Comprobante</b>
                <v-form ref="formComprobante" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <!-- Row 1 edicion comprobante fiscal     ------------------------------------------->

                  <v-row>

                    <v-col cols="12" md="12" sm="12">
                      <!-- filterTipoComprobantePv -->
                      <v-combobox v-model="ComprobanteFisc.comprobante" :readonly="fiscalPosGuardando"
                                  :items="filterTipoComprobantePvItbis(RtipoComprobante)" :rules="[$rules.required]"
                                  autocomplete="off"
                                  dense item-text="descripcion"
                                  label="Tipos de Comprobante:"
                                  outlined @blur="SelctCbTipoCompComprobant"
                                  @change="getChangeTipoComprobante" @focus="cargarTipoComprobante"
                                  v-on:change="changeCbTipoComprobante(ComprobanteFisc.comprobante,'RefTextFieldcedrncComprobante')">
                        <template v-slot:prepend>
                          <i class="fa fa-tag" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>
                      <!-- $rules.RulesCelRnc -->
                      <v-text-field v-if="cedularequired==false" v-model="ComprobanteFisc.cedrnc" v-mask="MakCelRnc" :readonly="fiscalPosGuardando" :loading="fiscalPosCargando"
                                    :rules="[$rules.RulesCelRncValidar]" autocomplete="off" dense
                                    label="Cedula/RNC:" maxlength="13" outlined
                                    @blur="MakaraCelComprobante" @focus="MakCelRnc = '#############'"
                                    v-on:blur="validandoCedRnc(ComprobanteFisc.cedrnc)">
                        <template v-slot:prepend>
                          <i class="fa fa-id-card-o" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                      <v-text-field v-if="cedularequired==true" ref="RefTextFieldcedrncComprobante"
                                    v-model="ComprobanteFisc.cedrnc" :readonly="fiscalPosGuardando" :loading="fiscalPosCargando"
                                    v-mask="MakCelRnc" :rules="[$rules.required,$rules.RulesCelRncValidar]"
                                    autocomplete="off" dense
                                    label="Cedula/RNC:" maxlength="13"
                                    outlined
                                    @blur="MakaraCelComprobante" @focus="MakCelRnc = '#############'"
                                    v-on:blur="validandoCedRnc(ComprobanteFisc.cedrnc)">
                        <template v-slot:prepend>
                          <i class="fa fa-id-card-o" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                      <v-text-field v-model="ComprobanteFisc.telefono" v-mask="'(###)###-####'" :readonly="fiscalPosGuardando"
                                    :rules="[$rules.RulesTel]" autocomplete="off" dense
                                    label="Télefono:" maxlength="13"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-phone" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field v-model="ComprobanteFisc.nombre" :rules="[$rules.required]" autocomplete="off" dense :readonly="fiscalPosGuardando" maxlength="250"
                                    label="Nombre:"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                      <v-textarea v-model="ComprobanteFisc.direccion" autocomplete="off" dense label="Direccion:" :readonly="fiscalPosGuardando" maxlength="150"
                                  outlined
                                  rows="1">
                        <template v-slot:prepend>
                          <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                        </template>
                      </v-textarea>
                    </v-col>

                  </v-row>
                  <!-- Row 2 edicion comprobante fiscal ------------------------------------------->


                </v-form>
              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion comprobante fiscal -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal-comprobante fiscal-->


    <!-- ------------------------------------------------------ Modal-Crear Farmaco Vigilancia -->
    <v-dialog v-model="dialogFarmacoVigilancia" fullscreen hide-overlay
              label="Modal Cotizacion" persistent transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <!--------------------- Creacion Fearmaco Vigilancia ------------------------------->
        <div>
          <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

          <v-toolbar color="#dd4b39" dark dense>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">

                <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Tratamiento uso
                  continuo
                </v-toolbar-title>

              </template>
              <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>Farmaco Vigilancia: </span>
                Creación de
                Farmaco Vigilancia</i>

            </v-tooltip>

            <v-spacer></v-spacer>

            <v-card-actions>
              <v-btn-toggle>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn id="boton-mini" color="orange" dark small @click="cancelarFarmacoVigilancia()" v-on="on">
                      <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                      CANCELAR
                    </v-btn>
                  </template>
                  <span>CANCELAR: Retornar y no Crear Farmaco Vigilancia</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn id="boton-mini" color="light-blue darken-4" dark small
                           @click="SalvarFarmacoVigilancia()" v-on="on">
                      <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                      SALVAR
                    </v-btn>
                  </template>
                  <span>SALVAR: Aceptar y crear Farmaco Vigilancia</span>
                </v-tooltip>

                <v-tooltip v-if="farmacoVigilancia.codigo>0 && farmacoVigilancia.farmacoVigilanciaDetalleList.length>0 "
                           bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn id="boton-mini" color="red lighten-2" dark small @click="eliminarFarmacoVigilancia()"
                           v-on="on">
                      <i class="fa fa-trash-o" style="font-size: 20px;"> </i>
                      ELIMINAR
                    </v-btn>
                  </template>
                  <span>ELIMINAR: Remueve la receta seleccionada</span>
                </v-tooltip>

              </v-btn-toggle>

            </v-card-actions>
          </v-toolbar>
          <v-card>
            <!-- columna informacion Farmaco Vigilancia -->
            <v-col cols="12" md="12" sm="12">
              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">

                <v-text-field v-model.number="buscarFarmVigilancia"
                              :label="buscarFarmVigBoolFactReceta==true? `#Factura:`:`#Receta:`"
                              autocomplete="off" class="fontSize13"
                              dense hide-details outlined
                              type="number" @keyup="KeyUpCantidad"
                >
                  <template v-slot:prepend>
                    <i class="fa fa-slack" style="font-size: 20px;"></i>
                  </template>
                  <template v-slot:append-outer>


                    <v-radio-group v-model="buscarFarmVigBoolFactReceta" column dense hide-details
                                   style="margin-top: -12%;"
                                   @change="">
                      <v-radio :value="false" color="teal lighten-2" label="#Receta"></v-radio>
                      <v-radio :value="true" color="teal lighten-2" label="#Factura"></v-radio>
                    </v-radio-group>

                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn color="blue darken-3" dark fab x-small
                               v-on="on" @click.prevent="buscarRecetaVigilancia">
                          <i class="fa fa-search" style="font-size: 20px;"></i>
                        </v-btn>

                      </template>
                      <span>Buscar</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on }">

                        <v-btn color="#90A4AE" dark fab x-small
                               v-on="on" @click.prevent="LimpiarFarmacoVigilancia">
                          <i class="fa fa-file-o" style="font-size: 20px;"></i>
                        </v-btn>

                      </template>
                      <span>Nuevo</span>
                    </v-tooltip>

                  </template>
                </v-text-field>


              </v-col>
              <!-- <v-container> -->
              <v-form ref="formfarmacoVigilancia" v-model="valid" lazy-validation translate="no" class="notranslate">
                <v-card color="grey lighten-3">
                  <b :class="`d-flex justify-start`">DATOS CLIENTE</b>
                  <!-- Row 1 edicion Farmaco Vigilancia     ------------------------------------------->
                  <v-row>
                    <v-col cols="12" md="4" sm="4">

                      <v-combobox id="formdisabledInput" v-model="farmacoVigilancia.cliente" autocomplete="off"
                                  class="fontSize13" dense
                                  disabled item-text="nombre" label="Nombre:"
                                  outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>

                      <v-textarea id="formdisabledInput" v-model="farmacoVigilancia.direccion"
                                  :rules="[$rules.required]" autocomplete="off"
                                  class="fontSize13" dense disabled label="Dirección:"
                                  outlined rows="1">
                        <template v-slot:prepend>
                          <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                        </template>
                      </v-textarea>

                    </v-col>

                    <v-col cols="12" md="4" sm="4">
                      <v-combobox id="formdisabledInput" v-model="farmacoVigilancia.ars" autocomplete="off"
                                  class="fontSize13" dense disabled
                                  item-text="nombre"
                                  label="ARS:" outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-shield" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>

                      <v-text-field id="formdisabledInput" v-model="farmacoVigilancia.telefono" v-mask="'(###)###-####'"
                                    autocomplete="off" class="fontSize13" dense
                                    disabled label="Teléfono:"
                                    maxlength="13"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-phone" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>
                    </v-col>


                    <v-col cols="12" md="4" sm="4">
                      <v-text-field id="formdisabledInput" v-model="farmacoVigilancia.nss" autocomplete="off"
                                    class="fontSize13" dense
                                    disabled label="NSS:"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field id="formdisabledInput" v-model="farmacoVigilancia.autorizacion" autocomplete="off"
                                    class="fontSize13"
                                    dense disabled label="Autorizacion" outlined
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-check-square-o" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- Row 1 edicion Crear Farmaco Vigilancia------------------------------------------->
                </v-card>

                <v-card color="grey lighten-3">
                  <b :class="`d-flex justify-start`">DATOS DE LA RECETA</b>
                  <!-- Row 1 edicion Farmaco Vigilancia     ------------------------------------------->
                  <v-row>
                    <v-col cols="12" md="4" sm="4">

                      <v-text-field id="formdisabledInput" v-model="farmacoVigilancia.fecha" :rules="[$rules.required]"
                                    dense disabled label="Fecha:"
                                    outlined type="date">
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field ref="RefTextFieldFarViMedico" v-model="farmacoVigilancia.medico" autocomplete="off"
                                    dense label="Médico:" outlined
                                    style="font-size: 13px;"
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-user-md" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                      <v-checkbox
                        v-if="farmacoVigilancia.codigo==0"
                        v-model="farmacoVigilanciaSoloReceta"
                        class="mt-0 ma-3" color="teal " hide-details label=""
                        @change="changeCombertirSoloReceta">
                        <template v-slot:label>
                          <strong v-if="farmacoVigilanciaSoloReceta == true"
                                  style="color:#000000; font-size:13px;">solo para registrar receta: Si</strong>
                          <strong v-if="farmacoVigilanciaSoloReceta == false"
                                  style="color:#000000; font-size:13px;">solo para registrar receta: No</strong>
                        </template>
                      </v-checkbox>


                    </v-col>

                    <v-col cols="12" md="4" sm="4">


                      <v-text-field v-model="farmacoVigilancia.hora" autocomplete="off" dense label="Hora:"
                                    outlined type="time">
                        <template v-slot:prepend>
                          <i class="fa fa-clock-o" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>

                      <v-text-field v-model="farmacoVigilancia.fechavencimiento" :rules="[$rules.required]" dense
                                    label="Fecha Reposición:"
                                    outlined type="date">
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                    </v-col>


                    <v-col cols="12" md="4" sm="4">
                      <VueAutonumeric id="formdisabledInput" v-model.number="farmacoVigilancia.monto"
                                      :rules="[$rules.required]" autocomplete="off" dense disabled
                                      label="Monto"
                                      outlined style="font-size:13px;">
                        <template v-slot:prepend>
                          <i class="fa fa-usd" style="font-size: 20px;"></i>
                        </template>
                      </VueAutonumeric>

                      <v-text-field v-model="farmacoVigilancia.padecimiento" :rules="[$rules.required]"
                                    autocomplete="off" class="fontSize13" dense
                                    label="Padecimiento:"
                                    outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-heartbeat" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- Row 1 edicion Crear Farmaco Vigilancia------------------------------------------->
                </v-card>

                <v-card style="border: 1px solid  #616161;">
                  <v-data-table :footer-props="arrayPropiedases" :headers="[
                    { text: 'PRODUCTO', value: 'producto', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'CANT.FACTURADA', value: 'cantfac', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'CANT.RECETADA', value: 'cantrec', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'CANT.FALTANTE', value: 'cantfal', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'INDICACIONES', value: 'cantind', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'FEC.REP', value: 'fechaReposicion', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'DETALLE', value: 'indic', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'ESTADO', sortable: false, value: 'estado', class: ['no-gutters black--text'] },

                  ]" :items="farmacoVigilancia.farmacoVigilanciaDetalleList" :items-per-page="15"
                                class="elevation-1 TbSize13"
                                dense>

                    <template v-slot:item.cantfal="props">
                    <span class="px-3">
                    <span v-if="(props.item.cantrec-props.item.cantfac)<0 " style="font-size: 13px;">0</span>
                    <span v-if="(props.item.cantrec-props.item.cantfac)>0"
                          style="font-size: 13px;">{{ (props.item.cantrec - props.item.cantfac) }}</span>
                    </span>
                    </template>

                    <template v-slot:item.estado="props">
                    <span v-if="farmacoVigilancia.codigo>0" class="px-3">
                     <i v-if="props.item.cantfac>= props.item.cantrec" class="fa fa-check-circle green--text"
                        style="font-size: 20px;"></i>
                     <i v-if="props.item.cantfac<props.item.cantrec && props.item.estatus==false"
                        class="fa fa-times-circle-o red--text"
                        style="font-size: 20px;" @click="props.item.estatus=true"></i>
                     <i v-if="props.item.cantfac<props.item.cantrec && props.item.estatus==true"
                        class="fa fa-check-circle green--text"
                        style="font-size: 20px;" @click="props.item.estatus=false"></i>
                    </span>
                      <span v-if="farmacoVigilancia.codigo==0" class="px-3">
                      <i v-if="props.item.cantfac>= props.item.cantrec" class="fa fa-check-circle green--text"
                         style="font-size: 20px;"></i>
                      <i v-if="props.item.cantfac<props.item.cantrec" class="fa fa-times-circle-o red--text"
                         style="font-size: 20px;"></i>
                    </span>

                    </template>

                    <template v-slot:item.producto="props">
                      <span style="font-size:13px;">{{ props.item.desprod }}</span>
                    </template>

                    <template v-slot:item.cantrec="props">
                      <v-text-field v-model.number="props.item.cantrec" :rules="[$rules.Numericc]" dense hide-details
                                    outlined
                                    type="number" @keyup="KeyUpCantidad">
                        <template v-slot:append-outer>
                          <span style="font-size:13px;"></span>
                        </template>
                      </v-text-field>
                    </template>

                    <template v-slot:item.cantind="props">
                      <v-text-field v-model.number="props.item.cantind " :rules="[$rules.Numericc]" dense hide-details
                                    outlined
                                    type="number" @keyup="KeyUpCantidad">
                        <template v-slot:append-outer>
                          <b style="font-size:13px;"> X DIA </b>
                        </template>
                      </v-text-field>
                    </template>

                    <template v-slot:item.indic="props">
                      <v-text-field v-model="props.item.indic" dense hide-details outlined
                                    type="text">
                      </v-text-field>
                    </template>

                    <template v-slot:item.fechaReposicion="props">
                      <v-text-field id="formdisabledInput" v-model="props.item.fechaReposicion" class="fontSize13" dense
                                    hide-details
                                    label="" outlined type="date">
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>
                    </template>


                  </v-data-table>
                </v-card>

              </v-form>
              <!-- </v-container> -->
            </v-col>
            <!-- columna informacion Farmaco Vigilancia-->

          </v-card>
        </div>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal-Crear Farmaco Vigilancia-->


    <!-- ------------------------------------------------------Modal Modal-Consulta de recetas creadas -->
    <v-dialog v-model="dialogConsultaRecetaCreada" label="Modal Crear producto" max-height="85%" max-width="95%"
              persistent transition="fab-transition">

      <!--------------------- Consulta de recetas creadas ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Consulta de recetas
                creadas
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Consulta: </span>recetas
              creadas</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">

                  <v-btn color="grey darken-4" fab x-small
                         @click="dialogConsultaRecetaCreada = false,consultaRecetaCreadaList=[], consultaRecetaFarmVig={desde:null,hasta:null}">
                    <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
                  </v-btn>
                  <!-- <v-btn id="boton-mini" v-on="on" @click="" color="orange" small dark>
                    <i style="font-size: 20px;" class="fa fa-reply-all"> </i>
                    CANCELAR
                  </v-btn> -->

                </template>
                <span>CERRAR: cierra el formulario</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
        <v-card>
          <!-- columna informacion producto -->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">
                <v-form ref="formConsultaRecetas" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <!-- Row 1 edicion producto      ------------------------------------------->
                  <!-- hide-details -->
                  <v-row>

                    <v-col cols="12" md="12" sm="12">

                      <v-row>
                        <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                          <v-combobox id="formdisabledInput" v-model="farmacoVigilancia.cliente" autocomplete="off"
                                      class="fontSize13" dense
                                      disabled item-text="nombre" label="Nombre:"
                                      outlined>
                            <template v-slot:prepend>
                              <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                            </template>
                          </v-combobox>
                        </v-col>
                        <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                          <v-text-field id="formdisabledInput" v-model="consultaRecetaFarmVig.desde" class="fontSize13"
                                        dense label="Desde:"
                                        outlined type="date"
                                        @blur="BlurDesdeFarmVig">
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                          <v-text-field id="formdisabledInput" v-model="consultaRecetaFarmVig.hasta" class="fontSize13"
                                        dense label="Hasta:"
                                        outlined type="date"
                                        @blur="BlurHastaFarmVig">
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                      </v-row>


                      <v-card style="border: 1px solid  #616161;">
                        <v-data-table :footer-props="arrayPropiedases" :headers="[
                    { text: '#RECETA', value: 'codigo', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'MEDICO', value: 'medico', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'FECHA', value: 'nuevaFecha', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'HORA', value: 'hora', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'TELEFONO', value: 'telefono', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'PADECIMIENTO', value: 'padecimiento', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'EDITAR', value: 'action', sortable: false, class: ['no-gutters black--text'] },

                  ]" :items="getConsultaRecetaCreadaList(consultaRecetaCreadaList)" :items-per-page="15"
                                      class="elevation-1 TbSize13" dense>


                          <template v-slot:item.action="{ item }">
                            <v-btn color="grey " fab x-small @click.prevent="editConsultaRecetas(item)"><i
                              class="fa fa-pencil"
                              style="font-size: 20px;"></i></v-btn>
                          </template>

                          <template v-slot:item.nuevaFecha="props">
                            <span style="font-size:13px;">{{ FormatoFecha(props.item.nuevaFecha) }}</span>
                          </template>

                          <template v-slot:item.hora="props">
                            <input id="formdisabledInput" :value="props.item.hora" disabled type="time" />
                          </template>


                        </v-data-table>
                      </v-card>

                    </v-col>


                  </v-row>
                  <!-- Row 1 Consulta de recetas creadas ------------------------------------------->


                </v-form>
              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion Consulta de recetas creadas-->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Consulta de recetas creadas -->


    <!-- ------------------------------------------------------ Modal- seleccion de cliente a credito con cobertura  -->
    <v-dialog v-model="dialogSelectClienteTempCredito" label="Modal comprobante fiscal" max-height="85%"
              max-width="95%"
              persistent transition="fab-transition">
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> cliente a crédito
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> cliente a crédito: </span>
              Selección de
              cliente a crédito</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="cancelarSeleccionClienteCredito()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar y no facturar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small
                         @click="SalvarSeleccionClienteCredito()" v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Aceptar y cobrar </span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
        <v-card>
          <!-- columna informacion comprobante fiscal-->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`" style="font-size: 25px;"> Cliente a Crédito</b>
                <v-form ref="formSeleccionClienteCreditoCobertura" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <!-- Row 1 edicion comprobante fiscal     ------------------------------------------->

                  <v-row>

                    <v-col cols="12" md="12" sm="12">

                      <v-col cols="12" md="12" sm="12">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-combobox ref="RefTextFieldBuscaClienteCredito" v-model="clienteTempCredito"
                                        :items="RCliente"
                                        :rules="[$rules.required]"
                                        autocomplete="off" background-color="white" color="grey darken-4" dense
                                        hide-details item-text="codnom"
                                        label="cliente a crédito:" no-filter
                                        outlined
                                        style="font-size: 13px;"
                                        @blur="SelctCbClienteBuscarCredito"
                                        @change="MakaraCelAuto(clienteTempCredito)" @focus="cargarClienteBusqueda"
                                        @keyup="CbFilcliente"
                                        v-on="on" @keyup.enter="SalvarSeleccionClienteCredito">
                              <template v-slot:prepend-inner>
                                <i class="fa fa-search" style="font-size: 25px;"></i>
                              </template>
                              <!-- margin-top="50px"style="font-size: 14px;" -->
                              <template slot="item" slot-scope="item">
                                <span style="display:none;">{{
                                    item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `
                                  }}</span>
                                <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>
                            style="border: 1px dashed  #616161;"
                              -->
                                <v-col class="pa-0 ma-0 py-0 my-0" cols="12"
                                       md="12" sm="12" style="border: 1px solid #000000; font-size: 13px; ">
                                  <p class="pa-0 ma-0 py-0 my-0"><b>NOMBRE:
                                    {{ item.item.nombre }}</b></p>

                                  <span class="pa-0 ma-0 py-0 my-0">
                              <span><b>TEL.: </b>
                                {{ selectTelefonoCliente(item.item) }}</span>
                              <span><b>CED/RNC: </b> {{ item.item.cedrnc }}</span>
                            </span>
                                  <p class="pa-0 ma-0 py-0 my-0"><b>DIRECCIÓN: </b>
                                    {{ item.item.direccion }} </p>
                                  <span v-if="item.item.hasOwnProperty('ars') && item.item.ars != null"><b> ARS
                                :{{ item.item.ars.nombre }}</b></span>
                                  <span v-if="item.item.diascredito > 0"><b> TIPO:
                                Cliente
                                Credito</b></span>
                                  <span v-if="item.item.diascredito == 0"><b>TIPO:
                                Cliente
                                Contado</b></span>
                                </v-col>


                              </template>

                            </v-combobox>
                          </template>
                          <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                            <span> Se selecciona el cliente a crédito.</span>
                          </i>
                        </v-tooltip>
                      </v-col>
                      <div v-if="clienteTempCredito!=null">
                        <v-row>
                          <!-- -----------------------------  Codigo -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                            <v-text-field id="formdisabledInput" v-model="clienteTempCredito.codigo" :disabled="true"
                                          dense hide-details
                                          label="Codigo:" outlined>
                              <template v-slot:prepend>
                                <i class="fa fa-list-ol" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>
                          </v-col>

                          <!-- -----------------------------  comentario -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                            <v-textarea id="formdisabledInput" v-model="clienteTempCredito.comentario" :disabled="true"
                                        autocomplete="off"
                                        dense label="comentario:" outlined
                                        rows="1">
                              <template v-slot:prepend>
                                <i class="fa fa-commenting" style="font-size: 20px"></i>
                              </template>
                            </v-textarea>
                          </v-col>

                          <!-- -----------------------------  Nombre -->
                          <v-col cols="12" md="6" sm="6">
                            <v-text-field id="formdisabledInput" v-model="clienteTempCredito.nombre" :disabled="true"
                                          :rules="[$rules.required]"
                                          autocomplete="off" dense label="* Nombre:"
                                          outlined>
                              <template v-slot:prepend>
                                <i class="fa fa-font" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>


                          </v-col>

                          <!-- ----------------------------- cedula/rnc -->
                          <v-col cols="12" md="6" sm="6">


                            <v-text-field id="formdisabledInput" v-model="clienteTempCredito.cedrnc" v-mask="MakCelRnc"
                                          :disabled="true" autocomplete="off"
                                          dense
                                          label="Cedula/RNC:" maxlength="13"
                                          outlined @blur="MakaraCel"
                            >
                              <template v-slot:prepend>
                                <i class="fa fa-id-card-o" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>

                          </v-col>


                          <!-- -----------------------------  Direccion -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                            <v-textarea v-model="clienteTempCredito.direccion" autocomplete="off" dense
                                        label="* Dirección:" outlined
                                        rows="1">
                              <template v-slot:prepend>
                                <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                              </template>
                            </v-textarea>
                          </v-col>


                          <!-- ----------------------------- Télefono -->
                          <v-col class="py-0 my-0 " cols="12" md="6" sm="6">
                            <v-text-field id="formdisabledInput" v-model="clienteTempCredito.telefono"
                                          v-mask="'(###)###-####'" :disabled="true" autocomplete="off"
                                          dense label="Télefono:"
                                          maxlength="13" outlined
                            >
                              <template v-slot:prepend>
                                <i class="fa fa-phone" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>

                          </v-col>

                          <!-- -----------------------------  Direccion -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                            <v-textarea v-model="clienteTempCredito.direccion2" autocomplete="off" dense
                                        label=" Dirección2:" outlined
                                        rows="1"
                            >
                              <template v-slot:prepend>
                                <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                              </template>
                            </v-textarea>
                          </v-col>

                          <!-- -----------------------------  email -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                            <v-text-field id="formdisabledInput" v-model="clienteTempCredito.email" :disabled="true"
                                          dense
                                          label="E-mail:" outlined>
                              <template v-slot:prepend>
                                <i class="fa fa-envelope-o" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>

                          </v-col>

                          <!-- ----------------------------- fecha de nacimiento   -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                            <v-text-field id="formdisabledInput" v-model="clienteTempCredito.fechanacimiento"
                                          :disabled="true" dense
                                          label="Fecha de Nacimiento:"
                                          outlined type="date"
                            >

                              <template v-slot:prepend>
                                <i class="fa fa-calendar" style="font-size: 20px;"></i>
                              </template>

                            </v-text-field>

                          </v-col>


                          <!-- ----------------------------- Ciudad-->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                            <v-text-field id="formdisabledInput" v-model="clienteTempCredito.ciudad" :disabled="true"
                                          autocomplete="off"
                                          dense
                                          label="* Ciudad:" outlined
                            >
                              <template v-slot:prepend>
                                <i class="fa fa-map" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>
                          </v-col>


                          <!-- -----------------------------sector -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                            <v-text-field id="formdisabledInput" v-model="clienteTempCredito.sector" :disabled="true"
                                          autocomplete="off"
                                          dense

                                          label="sector:" outlined>
                              <template v-slot:prepend>
                                <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>

                          </v-col>


                          <!-- ----------------------------- Dia de credito -->
                          <v-col v-if="false" class="py-0 my-0" cols="12" md="6" sm="6">

                            <v-text-field id="formdisabledInput" v-model="clienteTempCredito.diascredito"
                                          :disabled="true"
                                          dense
                                          label="Días de Crédito"
                                          outlined @keyup="KeyUpCantidad">
                              <template v-slot:prepend>
                                <i class="fa fa-credit-card" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>
                          </v-col>


                          <!-- ----------------------------- tipocomprobante -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                            <v-combobox id="formdisabledInput" v-model="clienteTempCredito.tipocomprobante"
                                        :disabled="true" :items="RtipoComprobante"
                                        :rules="[$rules.required]" autocomplete="off" dense
                                        item-text="descripcion" label="* Tipos de Comprobante:"
                                        outlined
                                        @blur="SelctCbTipoComprobanteTem" @focus="cargarTipoComprobante">
                              <template v-slot:prepend>
                                <i class="fa fa-tag" style="font-size: 20px;"></i>
                              </template>
                            </v-combobox>

                          </v-col>


                          <!-- -----------------------------sexo -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                            <!-- <v-text-field label="Sexo:" dense outlined
                              autocomplete="off"
                                v-model="clienteSeleccionado.sexo"
                                :rules="[$rules.required]"
                                >
                              <template v-slot:prepend>
                                      <i style="font-size: 20px;" class="fa fa-venus-mars"></i>
                              </template>
                                </v-text-field> -->

                          </v-col>

                        </v-row>

                      </div>


                    </v-col>

                  </v-row>
                  <!-- Row 2 edicion comprobante fiscal ------------------------------------------->


                </v-form>
              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion comprobante fiscal -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- seleccion de cliente a credito con cobertura-->

    <!-- ------------------------------------------------------ Modal Medicamentos Pendientes -->
    <v-dialog v-model="dialogMedicamentosPendientes" fullscreen hide-overlay persistent
              transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <ComponentsPvMedicamentosPendientes ref="RefComponentsPvMedicamentosPendientes" :cajaSelect="caja"
                                            :configuraciones="configuraciones"
                                            @DataRetornCancelarMedicPend="dialogMedicamentosPendientes= false" />
      </v-card>
    </v-dialog>
    <!-- fn Restaurar Factura ----------------------------------------------------------------------------------------------->

    <!-- ------------------------------------------------------ notif-->
    <v-dialog v-model="notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px;"></i>
            CONFIRMACIÓN
            <i class="fa fa-warning" style="font-size: 28px;"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn v-if="notif.Exec == 'quitarCliente'"
                 small @click.prevent="quitarClienteFactura(), (notif.estado = !notif.estado)">
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>

          <v-btn v-if="notif.Exec == 'factTemporalEnUso'"
                 small @click.prevent="contNotifiMensagefactTemporalEnUso(), (notif.estado = !notif.estado)">
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>


          <v-btn small @click.prevent="cerrarNotifMessage()">
            <i class="fa fa-ban" style="font-size: 20px;"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn notif -->


    <v-dialog
      v-model="dialogNotifQuitarDescuentoCliente"
      persistent
      width="500"
    >
      <v-card class="text-center">
        <v-alert
          border="left"
          outlined
          prominent
          type="warning"
        >
          <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
            Esta factura con forma de pago a crédito se le quitara el descuento.
          </v-col>
          <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
            <v-btn color="warning" outlined @click="QuitarDescuentoClienteCredito()">
              ACEPTAR
            </v-btn>
          </v-col>
        </v-alert>

      </v-card>
    </v-dialog>


    <!-- ------------------------------------------------------ Modal- Cliente preferencial -->
    <v-dialog v-model="dialogClientePreferencial" label="Modal Cliente preferencial " max-height="85%"
              max-width="95%"
              persistent transition="fab-transition">

      <!---------------------  Cliente preferencial ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Clientes
                preferencial
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Clientes preferencial: </span>
              Clientes preferencial</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="dialogClientePreferencial=false" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar atras</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

        </v-toolbar>
        <v-card>
          <!-- columna informacion  -->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> CLIENTES PREFERENCIAL</b>

                <v-container>

                  <v-col :class="`d-flex justify-center`" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                    <!-- <v-card-actions > </v-card-actions>  -->
                    <!-- Botones de Cliente preferencial -------------------------------------->
                    <v-row :class="`d-flex justify-center`">
                      <!-- Imp.Fiscal btn ------>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-hover v-slot:default="{ hover }" close-delay="200">
                            <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                                   :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                   dark
                                   height="100px" min-width="110px" v-on="on"
                                   @click.prevent="funcionValidaPermisoPv('AccBtnRegistrarClientesPreferencial')">
                              <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                              <span>

                              <v-avatar color="transparent" size="80" tile>
                                <img alt="CLIENTE" src="@/assets/icons_pv/menu/cliente64.png">
                              </v-avatar>


                              <br>
                              <b v-bind:style="{ 'font-size': '13px', 'color': hover ? 'white' : '#000000' }">REGISTRAR CLIENTES</b>

                            </span>
                            </v-btn>
                          </v-hover>
                        </template>
                        <span><b> REGISTRAR CLIENTES</b> </span>
                      </v-tooltip>

                      <!-- Imp.Fiscal btn ------>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-hover v-slot:default="{ hover }" close-delay="200">
                            <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                                   :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                   dark
                                   height="100px" min-width="110px" v-on="on"
                                   @click.prevent="funcionValidaPermisoPv('AccBtnConsultaClientesPreferencial')">
                              <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                              <span>

                              <v-avatar color="transparent" size="80" tile>
                                <img alt="REPORTE X" src="@/assets/icons_pv/impfiscal/reportes64.png">
                              </v-avatar>


                              <br>
                              <b v-bind:style="{ 'font-size': '13px', 'color': hover ? 'white' : '#000000' }">CONSULTA DE CONSUMO CLIENTES</b>

                            </span>
                            </v-btn>
                          </v-hover>
                        </template>
                        <span><b> CONSULTA DE CONSUMO CLIENTES </b> </span>
                      </v-tooltip>

                      <!-- Imp.Fiscal btn ------>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-hover v-slot:default="{ hover }" close-delay="200">
                            <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                                   :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                   dark
                                   height="100px" min-width="110px" v-on="on"
                                   @click.prevent="openConsultaBalancePunto()">
                              <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                              <span>

                              <v-avatar color="transparent" size="80" tile>
                                <img alt="L VENTAS" src="@/assets/icons_pv/impfiscal/ventas64.png">
                              </v-avatar>


                              <br>
                              <b v-bind:style="{ 'font-size': '13px', 'color': hover ? 'white' : '#000000' }">CONSULTA BALANCES PUNTOS</b>

                            </span>
                            </v-btn>
                          </v-hover>
                        </template>
                        <span><b> CONSULTA BALANCES PUNTOS</b> </span>
                      </v-tooltip>

                      <!-- Botones de Cliente preferencial -------------------------------------->


                    </v-row>
                  </v-col>

                </v-container>


              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Cliente preferencial-->


    <!-- ------------------------------------------------------ Modal- consulta balance punto  -->
    <v-dialog v-model="dialogConsultaBalancePunto" label="Modal consulta balance punto " max-height="100%"
              max-width="100%"
              persistent transition="fab-transition">
      <v-card class="mx-auto">
        <ComponentsPvModalConsultaBalancePunto ref="RefComponentsPvModalConsultaBalancePunto"
                                               @DataRetornCancelarClienteBalancePunto="dialogConsultaBalancePunto= false" />
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- consulta balance punto-->


    <!-- ------------------------------------------------------ Modal- Consulta Consumo Cliente  -->
    <v-dialog v-model="dialogConsultaConsumoCliente" label="Modal consulta Consumo Cliente " max-height="100%"
              max-width="100%"
              persistent transition="fab-transition">
      <v-card class="mx-auto">
        <ComponentsPvModalConsultaConsumoCliente ref="RefComponentsPvModalConsultaConsumoCliente"
                                                 @DataRetornCancelarConsumoCliente="dialogConsultaConsumoCliente= false" />
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Consulta Consumo Cliente-->


    <!-- ------------------------------------------------------ Modal- Crear y modificar cliente -->
    <v-dialog v-model="dialogCrearModificarCliente" label="Modal Crear y modificar cliente " max-height="100%"
              max-width="100%"
              persistent transition="fab-transition">
      <v-card class="mx-auto">
        <ComponentsPvModalCrearModificarCliente ref="RefComponentsPvModalCrearModificarCliente"
                                                @DataRetornCancelarCrearModificarCliente="dialogCrearModificarCliente=false" />
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Crear y modificar cliente -->


    <!-- ------------------------------------------------------ Modal- Pagares -->
    <v-dialog v-model="dialogModalPagare" label="Modal Pagares " max-height="85%" max-width="95%"
              persistent transition="fab-transition">

      <!---------------------  Pagares ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> PAGARÉ
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> PAGARÉ: </span> PAGARÉ</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="dialogModalPagare=false" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar atras</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

        </v-toolbar>
        <v-card>
          <!-- columna informacion  -->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> PAGARÉ</b>

                <v-container>

                  <v-col :class="`d-flex justify-center`" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                    <!-- <v-card-actions > </v-card-actions>  -->
                    <!-- Botones de Cliente preferencial -------------------------------------->
                    <v-row :class="`d-flex justify-center`">
                      <!-- Imp.Fiscal btn ------>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-hover v-slot:default="{ hover }" close-delay="200">
                            <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                                   :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                   dark
                                   height="100px" min-width="110px" v-on="on"
                                   @click.prevent="OpenDialogDatosPagareFactura()">
                              <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                              <span>

                              <v-avatar color="transparent" size="80" tile>
                                <img alt="CLIENTE" src="@/assets/icons_pv/menu/contrato64.png">
                              </v-avatar>


                              <br>
                              <b v-bind:style="{ 'font-size': '13px', 'color': hover ? 'white' : '#000000' }">REGISTRAR CONTRATO</b>

                            </span>
                            </v-btn>
                          </v-hover>
                        </template>
                        <span><b> REGISTRAR CONTRATO</b> </span>
                      </v-tooltip>

                      <!-- Imp.Fiscal btn ------>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-hover v-slot:default="{ hover }" close-delay="200">
                            <v-btn v-ripple="{ class: `white--text` }" :color="hover ? 'red' : 'grey darken-2'"
                                   :elevation="hover ? 24 : 2" :outlined="hover ? false : true"
                                   dark
                                   height="100px" min-width="110px" v-on="on" @click.prevent="openPagoPagares()">
                              <!-- <i style="font-size: 50px;" class="fa fa-floppy-o"></i>  -->
                              <span>
                              <v-avatar color="transparent" size="80" tile>
                                <img alt="REPORTE X" src="@/assets/icons_pv/menu/pagare64.png">
                              </v-avatar>


                              <br>
                              <b v-bind:style="{ 'font-size': '13px', 'color': hover ? 'white' : '#000000' }">PAGO A PAGARÉ</b>

                            </span>
                            </v-btn>
                          </v-hover>
                        </template>
                        <span><b> PAGO A PAGARÉ </b> </span>
                      </v-tooltip>


                      <!-- Botones de Pagares -------------------------------------->


                    </v-row>
                  </v-col>

                </v-container>


              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Pagares-->

    <!-- ------------------------------------------------------ Modal ModalPagoPagare-->
    <v-dialog v-model="dialogModalPagoPagare" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <v-col class="pa-0 ma-0 py-0 my-0 d-flex justify-end" cols="12" md="12" sm="12"
               style="background-color: #dd4b39">
          <v-btn color="grey darken-4" fab x-small @click="dialogModalPagoPagare = false">
            <i class="fa fa-close" style="font-size: 20px; color: white"></i>
          </v-btn>
        </v-col>

        <v-list subheader three-line>
          <ComponentsPagoPagare ref="RefComponentsPagoPagare" />
        </v-list>
      </v-card>
    </v-dialog>
    <!-- fn Modal ModalPagoPagareo ----------------------------------------------------------------------------------------------->


    <!-- ------------------------------------------------------ Modal- Notificacion Plan Beneficio-->
    <v-dialog v-model="planBeneficio.dialogNotifPlanBeneficio" label="Modal Producto Plan Beneficio" max-height="85%"
              max-width="55%"
              persistent transition="fab-transition">

      <!--------------------- Creacion de Producto Plan Beneficio ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Producto
                Plan Beneficio
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Producto Plan Beneficio: </span>
              Producto Plan Beneficio</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="green" dark small @click="acceptarPlanbeneficio()"
                         v-on="on">

                    <i class="fa fa-check-circle" style="font-size: 20px;"> </i>
                    ACCEPTAR
                  </v-btn>
                </template>
                <span>ACCEPTAR: acceptar las condiciones del producto</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="NewplanBeneficio()"
                         v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar atras</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

        </v-toolbar>
        <v-card>
          <!-- columna informacion  -->
          <v-col :class="`d-flex justify-center`" class="pa-0 ma-0 py-9 my-0" cols="12" md="12" sm="12">
            <center>
              <h1 class="py-9"><b>Este Producto está en plan Beneficio<b v-show="clienteFactura==null">, debe indicar un cliente</b></b></h1>
            </center>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Impresora Fiscal-->

    <!-- ------------------------------------------------------ Modal- Editar receta producto controlado cantidad recetada-->
    <v-dialog transition="fab-transition"  label="Modal Editar receta" v-model="dialogRecProCantidadControlada" persistent max-width="100%"
          max-height="100%" >
          <!-- style="margin-top: 10%;" -->
          <center   >
          <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="7" sm="12" >
          <!--  -->
              <v-card style="border: 2px solid #dd4b39;"  >
                <v-toolbar dark color="#dd4b39" dense>
                  <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                  <v-toolbar-title v-on="on"> <i style="font-size: 20px;" class="fa fa-info-circle"> </i> EDITAR RECETA
                  </v-toolbar-title>

                </template>
                <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> <span> EDITAR RECETA </span></i>
                  </v-tooltip>
                  <v-spacer></v-spacer>
                  <v-card-actions>
                  <v-btn-toggle>
                  <v-col  v-if="false" class="pa-0 ma-0 py-0 my-0 d-flex justify-end" cols="12" md="12" sm="12">
                    <v-btn color="grey darken-4" fab x-small @click="dialogRecProCantidadControlada = false">
                      <i style="font-size: 20px; color: white" class="fa fa-close"></i>
                    </v-btn>
                  </v-col>
                  </v-btn-toggle>
                  </v-card-actions>

                </v-toolbar>
                <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0 pt-1 px-2 pb-2" v-if="dialogRecProCantidadControlada==true" >
                  <div style="border: 1px solid #000000; ">
                    <v-form class="pt-3 px-2 notranslate" translate="no"  ref="formTransporte" @submit.prevent="" v-model="valid" lazy-validation >
                        
                      <v-text-field id="formdisabledInput" :value="`${objTempRecPro.productos.descripcion} ${objTempRecPro.unidad.descripcion}`"
                                          disabled autocomplete="off"
                                          dense label="DESCRIPCIÓN PRODUCTO:"
                                          outlined
                                          style="font-size:13px;">
                              <template v-slot:prepend>
                                <i class="fa fa-font" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>
                      <!--v-model.number=""  v-model.number=""-->
                            <VueAutonumeric label="CANTIDAD RECETADA:" dense outlined autocomplete="off" :rules="[$rules.Numericc]"
                              style="font-size:13px;" v-model.number="objTempRecPro.cantidadRecetada"    >
                            <template v-slot:prepend>
                              <i  style="font-size: 20px;" class="fa fa-briefcase"></i>
                            </template>
                          </VueAutonumeric>

                            <VueAutonumeric label="CANTIDAD DESPACHADA:" dense outlined autocomplete="off" :rules="[$rules.Numericc]"
                              style="font-size:13px;"
                              v-model.number="objTempRecPro.cantidadDespachada" >
                            <template v-slot:prepend>
                              <i  style="font-size: 20px;" class="fa fa-briefcase"></i>
                            </template>
                          </VueAutonumeric>
                    
                    </v-form>
        <!-- no-gutters             -->
    <v-row >

                    <!-- Btn-Cancelar -->
                <v-col class=" py-0 my-0" cols="12" md="6" sm="6" >
                  <v-hover v-slot:default="{ hover }" close-delay="200">
                    <v-btn :elevation="hover ? 24 : 2" :outlined="hover ? false : true" dark block
                      @click.prevent="dialogRecProCantidadControlada=false, objTemp=null" :color="hover ? 'orange darken-3' : 'orange'"
                      v-ripple="{ class: `white--text` }" :loading="!ejecucion" :disabled="!ejecucion"  >

                      <h2>CANCELAR</h2>
                      <template v-slot:loader>
                              <span class="custom-loader">
                                <i light style="font-size: 28px; color:#424242;" class="fa fa-reply-all"> </i>

                                <!-- <v-icon light>cached</v-icon> -->
                              </span>
                            </template>
                    </v-btn>
                  </v-hover>
                </v-col>
                  <!-- fn Btn-Cancelar -->

                    <!-- Btn-ACEPTAR -->
                <v-col class="py-0 my-0" cols="12" md="6" sm="6" >
                  <v-hover v-slot:default="{ hover }" close-delay="200">
                    <v-btn :elevation="hover ? 24 : 2" :outlined="hover ? false : true" dark block
                      @click.prevent="saveCantidadRecetada" :color="hover ? 'green darken-3' : 'green'"
                      v-ripple="{ class: `white--text` }" :loading="!ejecucion" :disabled="!ejecucion"  >

                      <h2>ACEPTAR</h2>
                      <template v-slot:loader>
                              <span class="custom-loader">
                                <i light style="font-size: 28px; color:#424242;" class="fa fa-plus"> </i>

                                <!-- <v-icon light>cached</v-icon> -->
                              </span>
                            </template>
                    </v-btn>
                  </v-hover>
                </v-col>
                  <!-- fn Btn-ACEPTAR -->

                  
    </v-row>

    <br/>

                  </div>
        
                
                </v-col>
              </v-card>
            
          </v-col>
        </center>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Modal- Transporte Factura-->


<!-------------------------------------------------------- Modal Modal-Conduce multiple a factura -->
    <v-dialog v-model="dialogBucarConduceMultiple" fullscreen hide-overlay label="Modal Reimprecion " persistent
              transition="dialog-bottom-transition">
      <v-card class="mx-auto">
        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> ver Conduce Multiples
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span>ver Conduce Multiples: </span> Ver Conduce Multiples</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>

            <v-tooltip bottom>

              <template v-slot:activator="{ on }">
                <v-btn id="boton-mini" color="orange" dark small
                       @click="dialogBucarConduceMultiple = false, NewBucarConduceMultiple()" v-on="on">
                  <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                  CANCELAR
                </v-btn>
              </template>
              <span>CANCELAR: Cancela y retornar atrás</span>
            </v-tooltip>

          </v-card-actions>
        </v-toolbar>

        <v-col cols="12" md="12" sm="12">
          <v-card color="grey lighten-3">
            <br>

            <v-form ref="formReimprecion" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
              <v-row>

                <!--  reimprecion busqueda secuencia  @blur="getCierreCaja" v-on:input="resertPaginacion" -------------->
                <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model.number="ConduceBusquedaMultiple.secuencia" autocomplete="off" dense
                                    label="# Secuencia:" outlined style="font-size: 12px;"
                                    type="number" v-on="on">


                        <template v-slot:prepend>
                          <i class="fa fa-hashtag" style="font-size: 20px;"></i>
                        </template>
                      </v-text-field>


                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra el número de secuencia que deseamos búscar.</span>
                    </i>
                  </v-tooltip>
                </v-col>

                <!--  reimprecion busqueda Fecha Inicial @input="getCierreCaja"  v-on:input="resertPaginacion" -------------->
                <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model="ConduceBusquedaMultiple.fechaInicial" :rules="[$rules.required]" dense
                                    label="Fecha Inicial" outlined
                                    placeholder=" " style="font-size: 12px;" type="date"
                                    v-on="on">
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 18px;"></i>
                        </template>
                      </v-text-field>

                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra la fecha a partir de la cual queremos la búsqueda.</span>
                    </i>
                  </v-tooltip>
                </v-col>

                <!--  reimprecion busqueda Fecha Final @input="getCierreCaja"  v-on:input="resertPaginacion" -------------->
                <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                      <v-text-field v-model="ConduceBusquedaMultiple.fechaFinal" :rules="[$rules.required]" dense
                                    label="Fecha Final" outlined
                                    placeholder=" " style="font-size: 12px;" type="date"
                                    v-on="on">
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 18px;"></i>
                        </template>
                      </v-text-field>

                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Aquí se registra la fecha hasta donde queremos la búsqueda.</span>
                    </i>
                  </v-tooltip>
                </v-col>
                <!--  reimprecion cliente @change="getFacVenta"  @blur="SelctCbConduceBuscar" -------------->
                <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-combobox v-model="ConduceBusquedaMultiple.cliente" :items="RCliente" autocomplete="off" dense
                                  item-text="codnom" label="cliente:" :rules="[$rules.required]"
                                  no-filter outlined style="font-size: 13px;"
                                   @focus="cargarClienteBusqueda" @keyup="CbFilcliente"
                                  v-on="on">
                        <template slot="item" slot-scope="item">
                          <span style="display:none;">{{
                              item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `
                            }}</span>
                          <span class="fontSize13"><b>{{ item.item.codigo }}</b> - {{ item.item.nombre.trim() }}</span>
                        </template>

                        <template v-slot:selection="{ attrs, item, parent, selected }">
                         <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.nombre}}</span>
                         <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                       </template>
                        
                        <template v-slot:prepend>
                          <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>
                    </template>
                    <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                      <span> Se selecciona el cliente que desea buscar.</span>
                    </i>
                  </v-tooltip>
                </v-col>
                <v-col class="py-0 my-0" cols="12" md="1" sm="1">
                  <!-- <v-btn color="teal" small @click.prevent="getConduceMultiplelistFactCliente">
                    <i class="fa fa-search" style="font-size: 20px;"></i>
                  </v-btn> -->
                  <v-btn @click.prevent="getConduceMultiplelistFactCliente"  color="light-blue" dense  small  dark>
                  <i style="font-size: 20px;" class="fa fa-search"> </i> Buscar
                  </v-btn>
                </v-col>

                <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                  <v-btn @click.prevent="aplicarConduceMultiple"  color="teal lighten-2" dense  small  dark>
                  <i style="font-size: 20px;" class="fa fa-check-square-o"> </i> Aplicar
                  </v-btn>
                </v-col>

              



                <!-- <v-col class="py-0 my-0" cols="12" md="1" sm="1">
                  <v-btn color="teal" small @click.prevent="getConduceMultiplelistFactCliente"><i class="fa fa-search"
                                                                                          style="font-size: 20px;"></i>
                  </v-btn>
                </v-col> -->


              </v-row>
            </v-form>

            <v-col class=" pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
            <!-- @item-selected="obtenerDatoSelectConduceMultiple" -->
            <v-data-table :headers="[
                { text: 'Fecha', sortable: false, value: 'fecha', width: 120 },
                { text: '# Secuencia', sortable: false, value: 'conduceInventarioPK.secuencia', width: 129 },
                { text: 'Cliente', sortable: false, value: 'cliente', width: 129 },
                { text: 'Valor', sortable: false, value: 'valor', width: 'auto', width: 105 },
              ]" :items="VerConducelistFactCliente" class="RowSelectColor" dense item-key="indx"
                    :show-select="true" :loading="loaderTabla"  
                    v-model="selectedListConduceMultiple"
                    
                    @click:row="obtenerDatoSelectConduceMultipleClickRow">
                <template v-slot:item.fecha="props">
                  <span style="font-size:13px; display:none;">{{
                      props.item.indx =
                        VerConducelistFactCliente.indexOf(props.item)
                    }}</span>
                  <span style="font-size:13px;">{{ FormatoFecha(props.item.fecha) }}</span>
                </template>

                <template v-slot:item.conduceInventarioPK.secuencia="props">
                  <span style="font-size:13px;">{{ props.item.documentoinventario.nombrecorto }} - {{
                      props.item.conduceInventarioPK.secuencia
                    }} </span>
                </template>

                <template v-slot:item.cliente="props">
                  <span v-if="props.item.cliente != null" style="font-size:13px;">{{ props.item.cliente.nombre }}
                  </span>
                </template>

                <template v-slot:item.valor="props">
                  <span style="font-size:13px;">{{ currencyFormatter(props.item.valor) }}</span>
                </template>
              </v-data-table>
            </v-col>

          </v-card>


        </v-col>

      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Modal- fn Modal-Conduce multiple a factura-->

    <!-- ------------------------------------------------------ Modal- seleccion de cliente a factura conduce multiple  -->
    <v-dialog v-model="dialogSelectClienteTempConduceMultiple" label="Modal comprobante fiscal" max-height="85%"
              max-width="95%"
              persistent transition="fab-transition">
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> ASIGNACIÓN DE CLIENTE A LA FACTURA
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> ASIGNACIÓN DE CLIENTE A LA FACTURA: </span>
              ASIGNACIÓN DE CLIENTE A LA FACTURA</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="dialogSelectClienteTempConduceMultiple=false, clienteTempConduceMultiple=null, objTemp=null" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar y no facturar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small
                         @click="SalvarSeleccionClienteTempConduceMultiple()" v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    ASIGNAR
                  </v-btn>
                </template>
                <span>ASIGNA: Aceptar </span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

        </v-toolbar>
        <v-card>
          <!-- columna informacion comprobante fiscal-->
          <v-col cols="12" md="12" sm="12">

            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`" style="font-size: 25px;"> ASIGNACIÓN DE CLIENTE A LA FACTURA</b>
                <v-form ref="formSeleccionClienteConduceMultiple" v-model="valid" lazy-validation translate="no" class="notranslate">
                  <!-- Row 1 edicion comprobante fiscal     ------------------------------------------->

                  <v-row>

                    <v-col cols="12" md="12" sm="12">

                      <v-col cols="12" md="12" sm="12">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-combobox ref="RefTextFieldBuscaClienteCredito" v-model="clienteTempConduceMultiple"
                                        :items="RCliente"
                                        :rules="[$rules.required]"
                                        autocomplete="off" background-color="white" color="grey darken-4" dense
                                        hide-details item-text="codnom"
                                        label="Cliente de la Factura:" no-filter
                                        outlined
                                        style="font-size: 13px;"
                                        @blur="SelctCbClienteTempConduceMultiple"
                                        @change="MakaraCelAuto(clienteTempCredito)" @focus="cargarClienteBusqueda"
                                        @keyup="CbFilcliente"
                                        v-on="on" @keyup.enter="SalvarSeleccionClienteTempConduceMultiple">
                              <template v-slot:prepend-inner>
                                <i class="fa fa-search" style="font-size: 25px;"></i>
                              </template>
                              <!-- margin-top="50px"style="font-size: 14px;" -->
                              <template slot="item" slot-scope="item">
                                <span style="display:none;">{{
                                    item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `
                                  }}</span>
                                <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>
                            style="border: 1px dashed  #616161;"
                              -->
                                <v-col class="pa-0 ma-0 py-0 my-0" cols="12"
                                       md="12" sm="12" style="border: 1px solid #000000; font-size: 13px; ">
                                  <p class="pa-0 ma-0 py-0 my-0"><b>NOMBRE:
                                    {{ item.item.nombre }}</b></p>

                                  <span class="pa-0 ma-0 py-0 my-0">
                              <span><b>TEL.: </b>
                                {{ selectTelefonoCliente(item.item) }}</span>
                              <span><b>CED/RNC: </b> {{ item.item.cedrnc }}</span>
                            </span>
                                  <p class="pa-0 ma-0 py-0 my-0"><b>DIRECCIÓN: </b>
                                    {{ item.item.direccion }} </p>
                                  <span v-if="item.item.hasOwnProperty('ars') && item.item.ars != null"><b> ARS
                                :{{ item.item.ars.nombre }}</b></span>
                                  <span v-if="item.item.diascredito > 0"><b> TIPO:
                                Cliente
                                Credito</b></span>
                                  <span v-if="item.item.diascredito == 0"><b>TIPO:
                                Cliente
                                Contado</b></span>
                                </v-col>


                              </template>

                            </v-combobox>
                          </template>
                          <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                            <span> Se selecciona el cliente a crédito.</span>
                          </i>
                        </v-tooltip>
                      </v-col>
                      <div v-if="clienteTempConduceMultiple!=null">
                        <v-row>
                          <!-- -----------------------------  Codigo -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                            <v-text-field id="formdisabledInput" v-model="clienteTempConduceMultiple.codigo" :disabled="true"
                                          dense hide-details
                                          label="Codigo:" outlined>
                              <template v-slot:prepend>
                                <i class="fa fa-list-ol" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>
                          </v-col>

                          <!------------------------------- cedula/rnc -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                            <v-text-field id="formdisabledInput" v-model="clienteTempConduceMultiple.cedrnc" v-mask="MakCelRnc"
                                          :disabled="true" autocomplete="off"
                                          dense
                                          label="Cedula/RNC:" maxlength="13"
                                          outlined @blur="MakaraCel"
                            >
                              <template v-slot:prepend>
                                <i class="fa fa-id-card-o" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>
                          </v-col>

                          <!-- -----------------------------  Nombre -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                            <v-text-field id="formdisabledInput" v-model="clienteTempConduceMultiple.nombre" :disabled="true"
                                          :rules="[$rules.required]"
                                          autocomplete="off" dense label="* Nombre:"
                                          outlined>
                              <template v-slot:prepend>
                                <i class="fa fa-font" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>
                          </v-col>


                          <!-- -----------------------------  Direccion -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">
                            <v-textarea v-model="clienteTempConduceMultiple.direccion" autocomplete="off" dense
                                        label="* Dirección:" outlined
                                        rows="1">
                              <template v-slot:prepend>
                                <i class="fa fa-map-marker" style="font-size: 20px;"></i>
                              </template>
                            </v-textarea>
                          </v-col>


                          <!-- ----------------------------- Télefono -->
                          <v-col class="py-0 my-0 " cols="12" md="6" sm="6">
                            <v-text-field id="formdisabledInput" v-model="clienteTempConduceMultiple.telefono"
                                          v-mask="'(###)###-####'" :disabled="true" autocomplete="off"
                                          dense label="Télefono:"
                                          maxlength="13" outlined
                            >
                              <template v-slot:prepend>
                                <i class="fa fa-phone" style="font-size: 20px;"></i>
                              </template>
                            </v-text-field>

                          </v-col>


                          <!-- ----------------------------- tipocomprobante -->
                          <v-col class="py-0 my-0" cols="12" md="6" sm="6">

                            <v-combobox id="formdisabledInput" v-model="clienteTempConduceMultiple.tipocomprobante"
                                        :disabled="true" :items="RtipoComprobante"
                                        :rules="[$rules.required]" autocomplete="off" dense
                                        item-text="descripcion" label="* Tipos de Comprobante:"
                                        outlined
                                        @blur="SelctCbTipoComprobanteTem" @focus="cargarTipoComprobante">
                              <template v-slot:prepend>
                                <i class="fa fa-tag" style="font-size: 20px;"></i>
                              </template>
                            </v-combobox>

                          </v-col>
                        </v-row>

                      </div>


                    </v-col>

                  </v-row>
                  <!-- Row 2 edicion comprobante fiscal ------------------------------------------->


                </v-form>
              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion comprobante fiscal -->

        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- seleccion de cliente a factura conduce multiple-->

<!-- ------------------------------------------------------ Modal- Notificacion Confirmacion Adicional -->
    <v-dialog transition="fab-transition" label="Modal Otros Ingresos" v-model="notifConfAdicional.estado" persistent
      max-width="60%" max-height="85%">

      <!--------------------- Creacion de Otros Ingresos ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

     
        <v-col style="background-color:#dd4b39;" class="pa-2 ma-0 py-1 my-0" cols="12" md="12" sm="12">
            <span style="font-size: 22px;"  :class="`d-flex justify-start white--text`"> <i dense class="fa fa-info-circle"> <b> NOTIFICACIÓN</b></i></span>
         </v-col>
        
        <v-card >
          <!-- style="border: 1px solid #000000;" -->
          <!-- columna informacion  -->
          <v-col style="border: 1px solid #000000;"   class="pa-0 ma-0 py-2 my-0" cols="12" md="12" sm="12" :class="`d-flex justify-center`">
            <center >
            <!-- <h2 class="py-5">  </h2> -->
              <code :class="`black--text`" style=" font-size: 25px;border: 1px solid #000000;">
              <b>{{ notifConfAdicional.nombre }}</b>
              </code>

           <v-card-actions :class="`d-flex justify-center`">
          <v-btn  color="green" v-if="notifConfAdicional.Exec == 'contAsignarMensajero'"
            @click.prevent="contNotifAdicAsignarMensajero(notifConfAdicional.objTemp)" large>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn  color="red" 
          @click.prevent="cerrarNotificacionAdic" large>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>

           </v-card-actions>

          
            </center>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
     <!-- ------------------------------------------------------ FIN Modal- Notificacion Confirmacion Adicional  -->

   <!-- ------------------------------------------------------ Modal-Internamientos-->
    <v-dialog v-model="dialogInternamientos" label="Modal Internamientos" max-height="85%" max-width="95%"
              persistent transition="fab-transition">

      <!--------------------- Creacion de Internamientos------------------------------->
     <!-- v-dirkeydown="coberturaSeguroKeyCtrl" -->
      <div v-if="dialogInternamientos" >
        <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> Registro de Internamientos
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> Crear Registro de Internamientos: </span>
              Creación de Registro de Internamientos</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="cancelarInternamientos()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar y no Crear Registro de Internamientos</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="grey" dark small @click="newnewInternamientos()" v-on="on">

                    <v-avatar color="transparent" size="28" tile>
                      <img alt="Limpiar" src="@/assets/icons_pv/extras/limpiarPantalla.png">
                    </v-avatar>


                    <i style="font-size: 20px;"> </i>
                    NUEVO
                  </v-btn>
                </template>
                <span>NUEVO: Limpia los campo para un nuevo registro</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="SalvarInternamiento()"
                         v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
                <span>SALVAR: Aceptar y crear Registro de Internamientos</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
         <v-card>
          <!-- columna informacion Internamientos-->
          <v-col cols="12" md="12" sm="12">
            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`"> CREAR REGISTRO DE INTERNAMIENTOS</b>
          
                <v-form ref="formCrearInternamiento" v-model="valid" lazy-validation translate="no" class="notranslate">
               <v-row>

<!-- columna 1 -->
<v-col cols="12" md="6" sm="6">
<!-- -----------------------------  Codigo -->
                  
                  <v-text-field 
                  id="formdisabledInput"
                    label="Codigo:"
                    dense
                    outlined
                    v-model="internamiento.codigo"
                    :disabled="true"
                    style="font-size: 13px;"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-list-ol"></i>
                    </template>
                  </v-text-field>

<!-- -----------------------------  desde  -->
<v-text-field
        dense
        outlined
        type="date"  
        label="Fecha Ingresa"
         :rules="[$rules.required]"
        v-model="internamiento.fechaIngreso"
        style="font-size: 13px;"
        @blur="BlurfechaIngreso"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

                </v-text-field>

<!-- ----------------------------- ARS -->
<!-- @blur="SelctCbArs -->
<v-combobox id="formdisabledInput" v-model="internamiento.ars" :items="RArs"
                                  :rules="[$rules.required]" autocomplete="off"
                                  dense
                                  disabled item-text="nombre" label="ARS:" outlined
                                  @focus="cargarArs"
                                  style="font-size:13px;">

                        <template v-slot:prepend>
                          <i class="fa fa-shield" style="font-size: 20px;"></i>
                        </template>
                      </v-combobox>

<v-text-field 
                    label="No Habitacion:"
                    autocomplete="off"
                    dense
                    outlined
                    :rules="[$rules.required]"
                    v-model="internamiento.nohabitacion"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-slack"></i>
                    </template>
                  </v-text-field>

</v-col>
<!-- fn columna 1 -->
<!-- columna 1 -->
<v-col cols="12" md="6" sm="6" >
<!-- -----------------------------  cliente  -->
<v-combobox
            autocomplete="off"
            dense
            outlined
            label="cliente:"
            :items="RCliente"
            item-text="codnom"
            style="font-size: 13px;"
            v-model="internamiento.cliente"
            @focus="cargarClienteBusqueda"
            no-filter
            disabled
          >
          <template slot="item" slot-scope="item">
                  <span style="display:none;">{{ item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} ` }}</span>
                  <span class="fontSize13"><b>{{ item.item.codigo}}</b> - {{item.item.nombre.trim()}}</span>
                  </template>

                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <span class="fontSize13 colorNombre"><b>{{ item.codigo}}</b> - {{item.nombre}}</span>
                  </template>

                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-user-circle"></i>
                      </template>
                    </v-combobox>

  <!-- -----------------------------  hasta  -->
<v-text-field
        dense
        outlined
        type="date"  
        label="Fecha Salida"
        v-model="internamiento.fechaSalida"
        style="font-size: 13px;"
        id="formdisabledInput"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

                </v-text-field>

<v-text-field 
                    label="Tipo Asistencia:"
                    autocomplete="off"
                    dense
                    outlined
                    :rules="[$rules.required]"
                    v-model="internamiento.tipoasistencia"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-font"></i>
                    </template>
                  </v-text-field>

</v-col>
        
              </v-row>
                </v-form>
               </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion Internamientos-->
        </v-card>
      </div>

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- Internamientos-->


    <!-- fn modales -->

    <!---------------------  Panel Menu Opcion Botones style="max-height:300px;" ------------------------------->
    <div v-show="false" class="overflow-x-auto">
      <!-- columna  ---------------------->
      <ComponentsPvImprecionViewer ref="RefPvImprecionViewer" />
    </div>

    <!---------------------  Panel Menu Opcion Facturacion Eletronica style="max-height:300px;" ------------------------------->
    <div v-show="false" class="overflow-x-auto">
      <!-- columna  ---------------------->
      <PvDgiiFacturacionEletronica ref="RefPvDgiiFacturacionEletronica" />
    </div>

    <!---------------------  Panel Menu Opcion Anular Factura style="max-height:300px;" ------------------------------->
    <div v-show="false" class="overflow-x-auto">
      <!-- columna  ---------------------->
      <ComponentsAnularFacturas ref="RefComponentsAnularFacturas" @DataRetornAlerta="alerta" />
    </div>

  </div>
</template>

<script>
import { EventBus } from "../../event-bus"
import VueAutonumeric from "../../components/AutoNumericNuevo"
import AutoNumericNuevoWithOptions from "../../components/AutoNumericNuevoWithOptions.vue"
import PvMenuOpcionBotones from "@/PuntodeVenta/UtilidadComponents/PvMenuOpcionBotones.vue"
import ComponentsRecibosIngresos from "@/CuentaXCobrar/Trans/RecibosIngresos.vue"
import ComponentsPvMedicamentosPendientes from "@/PuntodeVenta/UtilidadComponents/PvMedicamentosPendientesEntregar.vue"
import ComponentsPvImprecionViewer from "@/PuntodeVenta/UtilidadComponents/PvImprecionViewer.vue"
import ComponentsPvModalConsultaBalancePunto from "@/PuntodeVenta/UtilidadComponents/PvModalConsultaBalancePunto.vue"
import ComponentsPvModalConsultaConsumoCliente from "@/PuntodeVenta/UtilidadComponents/PvModalConsultaConsumoCliente.vue"
import ComponentsPvModalCrearModificarCliente from "@/PuntodeVenta/UtilidadComponents/PvModalCrearModificarCliente.vue"
import ComponentsPvModalPagare from "@/PuntodeVenta/UtilidadComponents/PvModalPagare.vue"
import ComponentsPagoPagare from "@/CuentaXCobrar/Trans/PagoPagares.vue"
import PvDgiiFacturacionEletronica from "@/PuntodeVenta/UtilidadComponents/PvDgiiFacturacionEletronica.vue"
import ComponentsAnularFacturas from "@/PuntodeVenta/Mant/AnularFacturas.vue"
import {
  currencyFormatter,
  fechaNueva,
  FormatoFecha,
  getFechaZone,
  getHoraActual,
  getParamFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoBasico,
  RedondeoValor,
  RedondeoValorCantRed,
  validaCedRnc,
  sinRedondeoCantidad,
  diasTranscurridos
} from "@/js/Funciones.js"
import {
  buscarArsCache,
  buscarClientesCache,
  buscarMensajerosCache,
  buscarProductosCache,
  buscarTiposTarjetaCache,
  buscarVendedoresCache,
  contarClientesCache,
  contarFacturasPendientes,
  guardarArs,
  guardarClientes,
  guardarFacturaPendiente,
  guardarMensajeros,
  guardarProductosBusqueda,
  guardarProductosCatalogo,
  guardarTiposTarjeta,
  guardarVendedores,
  marcarFacturaError,
  marcarFacturaSincronizada,
  marcarFacturaSincronizando,
  obtenerFacturasPendientes,
} from "@/js/pv-offline-db.js"

import clienteFiscalPos from "@/PuntodeVenta/UtilidadComponents/clienteFiscalPos.js"

export default {
  mixins: [clienteFiscalPos],
  components: {
    VueAutonumeric,
    PvMenuOpcionBotones,
    AutoNumericNuevoWithOptions,
    ComponentsRecibosIngresos,
    ComponentsPvMedicamentosPendientes,
    ComponentsPvImprecionViewer,
    ComponentsPvModalConsultaBalancePunto,
    ComponentsPvModalConsultaConsumoCliente,
    ComponentsPvModalCrearModificarCliente,
    ComponentsPvModalPagare,
    ComponentsPagoPagare,
    PvDgiiFacturacionEletronica,
    ComponentsAnularFacturas,
  },
  directives: {
    dirkeydown: {
      // Definición de directiva
      bind(el, binding) {
        // __HandleScrollHandler__
        el.__HandledKey__ = event => binding.value(event)
        document.body.addEventListener("keydown", el.__HandledKey__)
      },
      unbind(el) {
        document.body.removeEventListener("keydown", el.__HandledKey__)
      },

    },
  },

  created() {
    var json = {
      titulo: "Punto de ventas",
      descripcion: "Punto de ventas",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      accion: [
        "ReportesChequesBeneficiarioNew",
        "ReportesChequesBeneficiarioSave",
        "ReportesChequesBeneficiarioRemove",
        "ReportesChequesBeneficiarioAnular",
        "ReportesChequesBeneficiarioPrintList",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
    this.loadPv()
  },

  mounted() {
    this.onResize()
    // this.onkeydownCode()
   console.log(new Date(this.getParamFecha(this.fechaNueva())))
   
    EventBus.$on("emitEjecConfigPv", this.validaEjecConfigPv)
    //EventBus.$on("emitReportesChequesBeneficiario", this.datostabla);
    // this.onkeydownCode()
    this.IncluirItbisGeneral =
      this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido
    this.ConfImpfiscal = this.$store.getters.GetConfiguracionGeneral.config.impresoraFiscal
    this.UsarLote = this.$store.getters.GetConfiguracionGeneral.configInv.usarLote
    this.cambiarDestinoSucursal = this.$store.getters.GetConfiguracionGeneral.configPv.cambiarDestino
    this.SoloCxc = this.$store.getters.GetConfiguracionGeneral.configPv.soloCxc

    if (this.$store.getters.GetConfiguracionGeneral.configPv.activarListasPrecios != null && this.$store.getters.GetConfiguracionGeneral.configPv.activarListasPrecios == true) {
      this.activarListasPrecios = this.$store.getters.GetConfiguracionGeneral.configPv.activarListasPrecios
      var CONFIGPV = this.$store.getters.GetConfiguracionGeneral.configPv
      if (CONFIGPV.hasOwnProperty("listaPrecio") && CONFIGPV.listaPrecio != null) {
        this.listaPrecioDefecto = CONFIGPV.listaPrecio
      }
      /*else{
        this.alerta(`Debe de Seleccionar una "Lista precio por defecto" en la configuracion`,"error")
      }*/
    }

 this.codUsuAutorDev=this.$store.getters.GetdatosInfUsu.usuario.codigo
    // EventBus.$on("onResize", this.onResize);
    //console.log(this.$store.getters.GetConfiguracionGeneral.configPv.soloCxc)
    // this.NotfFactRestaurarInterval()
    //  console.log("VIENDO-->",parseInt('0012'))
    // Registrar evento cuando se carga el componente
  
 var boolEstacion= (this.$store.getters.GetConfiguracionGeneral.config.estacion==true || this.$store.getters.GetConfiguracionGeneral.config.estacionCombustible )
if(boolEstacion==true){
  this.cargarTurnoTrabajo()
this.turnoEstacionInterval()
}

    window.addEventListener("beforeunload", this.handleBeforeUnload)
    window.addEventListener("online", this.actualizarEstadoConexionPv)
    window.addEventListener("offline", this.actualizarEstadoConexionPv)
    this.iniciarVerificacionConexionOfflinePv()
    this.inicializarPvOffline()
  },

  beforeDestroy() {
    // removing eventBus listener
    EventBus.$off("emitEjecConfigPv")
    this.canselarBuscarRestaurarFacturasFrecuencia()
    this.canselarFactRestaurarInterval()
    clearTimeout(this.timeoutBuscarProductoFluida)
    clearTimeout(this.timeoutBuscarProductoEnter)
 var boolEstacion= (this.$store.getters.GetConfiguracionGeneral.config.estacion==true || this.$store.getters.GetConfiguracionGeneral.config.estacionCombustible )
if(boolEstacion==true){
    this.canselarTurnoEstacionInterval()
  }

    if (this.deleteFacturaTemporal != null) {
      localStorage.setItem("dataFactTemporal", JSON.stringify(this.deleteFacturaTemporal))
      this.updateFactTemEnUso(this.deleteFacturaTemporal)
    }
    // Limpiar el evento cuando se destruye el componente
    window.removeEventListener("beforeunload", this.handleBeforeUnload)
    window.removeEventListener("online", this.actualizarEstadoConexionPv)
    window.removeEventListener("offline", this.actualizarEstadoConexionPv)
    this.detenerVerificacionConexionOfflinePv()
  },

  data: () => ({

    bloqueoTemp: false,
    disabledTextFieldProducto: false,
    arrayPropiedases: {
      "items-per-page-options": [10, 15, 20, 50],
      "items-per-page-text": "Cantidad de Registros Por Paginas",
      showFirstLastPage: false,
    },
    comboDiagnostico:null,
    codUsuAutorDev:null,
    contFactDescLimitTarjeta:false,
    loaderTabla: false,
    actualizarDecimal: true,
    contFactExcedeLimitCredito: false,
    listaPrecioDefecto: null,
    activarListasPrecios: false,
    setIntervalBuscarRestaurar: null,
    setIntervalNotfFactRestaurar: null,
    setIntervalturnoEstacion:null,
    timeoutBuscarProductoFluida: null,
    timeoutBuscarProductoEnter: null,
    ultimaBusquedaProductoFluida: 0,
    ultimaBusquedaProductoEnter: 0,
    busquedaProductoEnCurso: {},
    precargaProductoEnCurso: {},
    cacheDescuentoProducto: {},
    cacheListaPrecioProducto: {},
    cacheUnidadProducto: {},
    cacheOfertaProducto: {},
    cacheBusquedaProducto: {},
    pvOnline: typeof navigator === "undefined" ? true : navigator.onLine,
    pvSincronizandoOffline: false,
    pvSincronizandoCatalogoOffline: false,
    pvFacturasOfflinePendientes: 0,
    pvUltimoErrorOffline: "",
    pvOfflineForzado: false,
    pvIntervalVerificacionConexion: null,
    pvTimeoutReintentoCatalogoOffline: null,
    pvVerificandoConexionOffline: false,
    activoF7: false,
    searchVendedorCodigo: "",
    activaConduceCredito: false,
    disableNumeroReceta: false,
    UsarLote: false,
    cambiarDestinoSucursal: false,
    RSucursal: [],
    sucursalFactTemporal: null,
    ConfImpfiscal: false,
    SoloCxc: false,
    EjecutarPermisoPv: false,
    ObjEjecPermisoPv: null,
    dialogGuardartemporal: false,
    deleteFacturaTemporal: null,
    nombreFactTem: "",
    EjecutarInfSaveProd: true,
    objTemp: null,
    objTempaplicarDescuentoGlobalFacturaXencimaMaximo: null,
    MakCelRnc: "#############",
    RVendedor: [],
    Rpropietario: [],
    RCaja: [],
    Rproducto: [],
    RCuenta: [],
    RImpuesto: [],
    RCliente: [],
    RtipoComprobante: [],
    RArs: [],
    RTurnoTrabajo:[],
    pedirNombre: false,
    configuraciones: null,
    conexion: null,
    toggle_exclusive: false,
    TasaMoneda: 1,
    CantRedondeo: 2,

    dialogNotifQuitarDescuentoCliente: false,
    dialogNotifProdControlado: false,
    LabelProdCotrolado: "",
    OpenEjecProdControlado: false,
    dialogProdControlado: false,
    dialogMedicamentosPendientes: false,
    valid: true,
    RLiClinicas: [],
    ObjRectPro: null,
    EsNuevoObjRectPro: true,
    ProductoOpcionVer: false,
    VerRecProdControlado: false,
    RecetaProdControlado: {
      codigo: 0,
      numero: null,
      exq: "",
      fecha: fechaNueva(),
      cliente: null,
      telefono: null,
      direccion: null,
      centroSalud: null,
      activo: true,
      estatus: true,
      medico: null,
      especialidad: null,
      detalleList: [],
    },

    BuscarClienteFormaPagoNC: null,
    ListFormaPagoNC: [],
    NombreFormaPagoCheqTras: "",
    impresoraConectada: false,
    selectedListFPagoNC: [],
    bancoCheque: null,
    tipoTarjeta: null,
    RTipoTarjeta: [],
    RBanco: [],
    PanelFormaPagoColmna1: true,
    PanelFormaPagoColmna2: true,
    PanelFormaPagoTarjeta: false,
    PanelFormaPagoCheque: false,
    PanelFormaPagoNotaCredito: false,
    dialogConfigPv: false,
    OtrasConfigPv: {
      caja: null,
      terminal: null,
      impresora: null,
      turno: null,
      cajero: null,
      moneda: null,
    },
    listTerminal: [],
    terminal: {
      defaulPrinter: "",
      impresoras: [],
      terminal: "",
    },
    dialogBucarCotizacion: false,
    cargandoCotizacionFactura: false,
    VerCotizacionlistFactCliente: [],
    CotizacionBusqueda: {
      secuencia: 0,
      fechaInicial: fechaNueva(),
      fechaFinal: fechaNueva(),
      cliente: null,
    },

    dialogBucarConduce: false,
    cargandoConduceFactura: false,

    VerConducelistFactCliente: [],
    ConduceBusqueda: {
      secuencia: 0,
      fechaInicial: fechaNueva(),
      fechaFinal: fechaNueva(),
      cliente: null,
    },

    ConduceBusquedaMultiple: {
      secuencia: 0,
      fechaInicial: fechaNueva(),
      fechaFinal: fechaNueva(),
      cliente: null,
    },

    
    dialogBucarConduceMultiple:false,
    selectedListConduceMultiple:[],
    ListConduceMultiple:[],
    
      dialogSelectClienteTempConduceMultiple:false,
    clienteTempConduceMultiple:null,


    cambioTipoTarjetaDomicilio:null,
    cambioPagoDomicilio: null,
    RCambioPagoDomicilio: [
      { codigo: 1, descripcion: "EFECTIVO" },
      { codigo: 2, descripcion: "TARJETA" },
      { codigo: 3, descripcion: "CHEQUE" },
      { codigo: 4, descripcion: "TRANSFERENCIA" },
    ],


    dialogPagare: false,
    OpenEjecDatosPagareFactura: false,
    DatosPagareFactura: null,

    caja: null,

    IncluirItbisGeneral: false,
    selected: null,
    selecteTemRecCont: null,
    SelectedFactPendiente: null,
    busquedaCliente: null,
    producto: null,
    clienteFactura: null,
    dialogSelectClienteTempCredito: false,
    clienteTempCredito: null,
    filtroTipoCliente: 3,
    ReimprecionFacturaSeleccionada: {
      secuencia: 0,
      fecha: null,
      ncf: "",
      cliente: "",
      comentario: "",
      turno: 0,
      formapago: "",
      DetalleList: [],
    },

    DevolucionSelected: [],
    DevolucionlistFactCliente: [],
    devolucion: {
      devoclucionPK: { documento: 0, secuencia: 0 },
      fecha: new Date(),
      referencia: "",
      valor: 0,
      usuario: "",
      ncf: "",
      caja: 0,
      numerocierre: 0,
      efectivo: false,
      cobertura: 0,
      fechaImpresion: null,
      nif: "",
      horaImpresion: null,
      comentario: "",
      borrado: false,
      devolucionDetalleList: [],
      facturasventa: null,
      nombre: "",
      cedula: "",
      notacreditocontado: null,
      notacreditoclientes: null,
      documentoinventario: null,
      almacen: null,
    },
    DevolucionFacturaSeleccionada: {
      secuencia: 0,
      fecha: null,
      ncf: "",
      cliente: "",
      comentario: "",
      turno: 0,
      formapago: "",
      DetalleList: [],
      devtarjeta: false,
    },

    ReimprecionSelected: [],
    ReciboIngresoFactPendHist: true,
    OpenEjecReciboIngreso: false,

    PanelReciboFormaPago: false,
    NombrePanelReciboFormaPago: "",
    devueltaRecIngreso: 0.0,
    ReciboIngresoFactura: {
      efectivo: 0,
      tarjeta: 0,
      cheque: 0,
      transferencia: 0,
      numeroCheque: null,
      bancoCheque: null,
      tipoTarjeta: null,
      numtar: null,
    },

    ReciboIngreso: {
      precio: 0,
      abono: 0,
      retencion: 0,
      descuento: 0,
      isr: 0,
      DescValorPorc: false,
      retenValorPorc: true,
      isrValorPorc: true,
    },
    dialogComprobante: false,
    ComprobanteFisc: {
      comprobante: null,
      nombre: null,
      telefono: "",
      direccion: "",
      cedrnc: "",
    },
    conduceSelect: null,
    dialogDatosVuelo: false,
    Facturasventa: {
      facturasventaPK: { secuencia: 0, documento: 0 },
      empresa: 1,
      fecha: new Date(),
      referencia: "",
      diascredito: 0,
      ncf: "",
      valor: 0.0,
      tasa: 1,
      comentario: "",
      valordescuencto: 0.0,
      valorimpuesto: 0.0,
      pendiente: 0.0,
      activada: true,
      efectivo: 0.0,
      tarjeta: 0.0,
      cheques: 0.0,
      cxc: 0.0,
      puntos: 0.0,
      valorbonogas:0.0,
      valorasignacion:0.0,
      valorPruebaMetro:0.0,
      valorConduce: 0.0,
      cupones: 0.0,
      gaspremium: 0.0,
      valordonacion: 0.0,
      valorTraspaso:0.0,
      valorcomision: 0.0,
      valorotros: 0.0,
      cedularncncf: "",
      direccionncf: "",
      telefononcf: "",
      codigocupon: "",
      numeroCheque: "",
      nombreDgii: "",
      documentoFactura: null,
      umerocierre: 0,
      autorizacion: null,
      cobertura: null,
      medico: null,
      exequartur: null,
      diagnostico: null,
      especialidad: null,
      enviada: false,
      glosada: false,
      coberturaPendiente: null,
      arsCobrarEmpleado: false,
      arsIncobrable: false,
      arsComentario: null,
      usuario: "",
      usuarioCobro: "",
      fechaImpresion: null,
      nif: null,
      horaImpresion: null,
      receta: null,
      valorRecargo: 0,
      descGloblal: true,
      recgGlobal: false,
      numtar: null,
      valorNc: 0.0,
      codigoNc: null,
      secuenciaNc: null,
      retencion: 0.0,
      sumado: false,
      ncfVencimiento: null,
      medicoCodigo: null,
      totalIsr: 0.0,
      totalOtroImpuesto: 0,
      motivoAnular: null,
      facturaManual: false,
      descripcion: "",
      numeroOrden: null,
      lineaAerea: null,
      numeroVuelo: null,
      rutaSalidaE: null,
      rutaSalidaD: null,
      rutaRetornoE: null,
      rutaRetornoD: null,
      turno: null,
      borrado: false,
      fechaIngreso: null,
      fechaSalida: null,
      tipoAsistencia: null,
      numeroHabitacion: null,
      facturaRecurrente: false,
      configuracionDocumentoRecurrente: 0,
      detalleJson: "",
      generadaDesdeEnviosPaquetes: false,
      generadaDesdeBoleteria: false,
      conduceSecuencia: null,
      conduceDocumento: null,
      shipto: null,
      incoterms: null,
      pagare: null,
      pagareValor: null,
      usuariosAnulacion: null,
      fechaAnulacion: null,
      usuariosEditar: null,
      fechaEdicion: null,
      bancoCheque: null,
      ars: null,
      caja: null,
      cliente: null,
      clinica: null,
      impuesto: null,
      moneda: null,
      sucursal: null,
      tipoTarjeta: null,
      tipocomprobante: null,
      vendedor: null,
      contabilidad: null,
      transferencia: 0.0,
      domicilio: null,
      facturasventaDetalleList: [],
      datoTarjeta: null,
      horaFactura: null,
      infAdicionales:null,
      registroInternamiento:null
    },
    contabilidad: null,
    ObtemRListFactpendiente: [],
    RListFactpendiente: [],
    HeadInfFactPendienteSelecc: {
      fecha: fechaNueva(),
      factura: "",
      valorf: 0,
      pendiente: 0,
      ncf: "",
      referencia: "",
    },
    //ObtemFactPendienteSeleccionado:null,
    FactPendienteSeleccionado: null,
    ListaProdxAlmacen: [],
    ListProductoSustitutos: [],
    ListaProdxLote: [],
    selectedListProdxLote: [],
    productoSeleccionado: {
      cantidad: 1,
      precio: 0,
      descuento: 0,
      descuentoKeys: 0,
      vendedor: null,
      recargo: 0,
      ValorPorcRecarg: false,
      cobertura: 0,
      productos: null,
      valor: 0,
      ValorPorc: false,
      cobValorPorc:false
    },
    cedularequired: false,
    clienteSeleccionado: {
      codigo: 0,
      nombre: null,
      cedrnc: "",
      ciudad: null,
      direccion: null,
      telefono: "",
      sector: "",
      tipocomprobante: null,
      email: "",
      sexo: "",
      dondetrabaja: "",
      diascredito: 0,
      fechanacimiento: null,
      carnet: "",
      ars: null,
      contrato: "",
      nss: "",
      planlan: 0,
      comentario: "",
      pasaporte: "",
      zonaRuta: null,
      ordenVisita: 0,
      diaVisita: null,
      balancePuntos: 0,
      codigoBarraPreferencial: null,

    },
    unidadesProductos: {
      codigobarra: "",
      precio: 0.0,
      costo: 0.0,
      porbeneficio: 0.0,
      factor: 1,
      unidades: null,
      productos: {
        borrado: false,
        activo: false,
        codigo: 0,
        descripcion: "",
        puntoVenta: true,
        impuesto: null,
      },
      unidadminima: true,
      unidadcompra: true,
      borrado: false,
    },

    RTipoAnulacion: [
      { codigo: 1, descripcion: "Deterioro de Factura Pre-Impresa" },
      { codigo: 2, descripcion: "Errores de Impresión(Factrua Pre-Impresa" },
      { codigo: 3, descripcion: "Impresión Defectuosa" },
      { codigo: 4, descripcion: "Duplicidad de Factura" },
      { codigo: 5, descripcion: "Correción de la Información" },
      { codigo: 6, descripcion: "Cambio de Productos" },
      { codigo: 7, descripcion: "Devolución de Productos" },
      { codigo: 8, descripcion: "Omisión de Productos" },
      { codigo: 9, descripcion: "Errorres en la secuencias NCF" },
    ],
    TipoAnulacion: null,

    dialogAnulacion: false,
    AnulacionBusqueda: {
      secuencia: 0,
    },

    AnulacionlistFactCliente: [],
    AnulacionSelected: [],
    AnulacionFacturaSeleccionada: null,

    DevolucionBusqueda: {
      secuencia: 0,
    },

    BtnReimprecionvalue: 0,
    LabelReimprecion: "SELECCIONAR TIPO DE IMPRESIÓN",
    ReimprecionSheet: false,
    ReimpresionBusqueda: {
      secuencia: 0,
      fechaInicial: fechaNueva(),
      fechaFinal: fechaNueva(),
      cliente: null,
      opcion:0,
      referencia:''
    },

    // RecetaBusqueda:{
    //   receta:"",
    //   fechaInicial:new Date().toISOString().substr(0,10),
    //   fechaFinal: new Date().toISOString().substr(0,10),
    //   paciente:""

    //   },Código, Fecha,#Receta,Paciente,Doctor

    dialogVerRecetaCompleta: false,
    dialogRecetas: false,
    RecetaSelected: [],
    listFactVent: [],
    RecetaSeleccionado: null,
    recetaFacturaList: [],
    RecetaBusqueda: {
      receta: "0",
      fechaInicial: fechaNueva(),
      fechaFinal: fechaNueva(),
      paciente: "",
    },
    RecetaPaginator: {
      itemsPerPage: 15,
      pageStart: 1,
      page: 1,
      pageStop: 15,
      pageCount: 10,
      itemsLength: 5,
    },
    RestaurarFactlistFact: [],
    dialogRestaurarFactura: false,
    restaurandoFacturaTemporal: false,

    selectFactTem: null,
    TbPaginatorFactTem: {
      itemsLength: 0,
      itemsPerPage: 15,
      page: 1,
      pageCount: 0,
      pageStart: 0,
      pageStop: 0,
    },
    RestaurarFacturaBusqueda: {
      buscar: "",
      sucursal: null,
    },

    dialogCrearProduct: false,
    dialogCrearEditarCliente: false,
    dialogReimprecion: false,
    dialogDevolucion: false,

    dialogAceptarDevolucion: false,
    AceptarDevolucion: {
      nombre: null,
      cedula: "",
    },

    dialogReciboIngreso: false,
    PanelMenuOpcionCompleto: true,
    PanelMenuOpcionBotones: true,
    PanelMenuOpcionVendedor: false,
    PanelMenuOpcionMedico: false,
    PanelMenuOpcionDescuentoFactura: false,
    PanelMenuOpcionRetencionFactura: false,
    PanelMenuOpcionRecargoFactura: false,
    PanelMenuOpcionMonedaFactura: false,
    PanelMenuOpcionComentarioFactura: false,
    PanelMenuOpcionFacturaDomicilio: false,

    PanelSelectProducto: true,
    PanelInfProduct: false,
    boolRuleprodprecio: false,
    ProdCompOrSelecProd: false,
    EditProdCompa: false,
    rulePrecioProdBajoPrecio: 0,
    boolEnterPrecioProdSelect: false,
    ReimprecionlistFactCliente: [],
    Recetaslist: [],
    ListaTiposClientes: [],
    RallProducto: [],
    RProductoCompra: [],
    RProductoCompraTemp: [],
    RProductoCompraOfercta: [],
    RHistorialCompracliente: [],
    TbTotalItemHisCli: 0,
    TbPaginatorHisCli: {
      page: 1,
      itemsPerPage: 10,
      pageStart: 1,
      pageStop: 15,
      pageCount: 10,
      itemsLength: 5,
    },


    listHiscliente: [],
    totales: {
      debito: 0,
      credito: 0,
      BalanceTotal: 0,
    },

    windowSize: { width: "auto", height: "auto" },
    windowSizeCaja: { width: "auto", height: "auto" },

    searchProducto: "",

    formaPago: {
      efectivo: 0,
      tarjeta: 0,
      cheques: 0,
      cxc: 0,
      puntos: 0,
      cupones: 0,
      valorbonogas:0,
      valorasignacion:0,
      valorPruebaMetro:0,
      valorTraspaso:0,
      valordonacion:0
    },

    CrearProducto: {
      nombre: "",
      precio: 0,
      costo: 0,
      impuesto: null,
    },

    TotalRegistros: 1,
    resertPagi: true,
    ReimprecionPaginator: {
      itemsPerPage: 15,
      pageStart: 1,
      page: 1,
      pageStop: 15,
      pageCount: 10,
      itemsLength: 5,
    },
    CotizacionPaginator: {
      itemsPerPage: 15,
      pageStart: 1,
      page: 1,
      pageStop: 15,
      pageCount: 10,
      itemsLength: 5,
    },

    dialogValecaja: false,
    Valecaja: {
      fecha: fechaNueva(),
      valor: 0,
      beneficiario: "",
      Autorizado: "",
      Concepto: "",
      secuencia: 0,
      caja: null,
      numerocierre: 0,
      cajero: null,
    },
    ListReimprecion: [],
    dialogCierreCaja: false,
    Rmoneda: [],
    RLisMon: [],
    ListDenomMoneda: [],
    CierresCajas: {
      cierrescajasPK: { caja: 0, secuencia: 0 },
      cantidadtarjeta: 0,
      tarjeta: 0,
      cantidadcheques: 0,
      cheques: 0,
      cantidadrecibo: 0,
      recibos: 0,
      efectivo: 0,
      cierrecajaMonedaList: [],
      DenominacionCierrecajaList: [],
      datoTarjeta: null,
      cantidadtranferencia: 0,
      transferencia: 0,

    },
    OpenEjecCoberturaSeguro: false,
    dialogCoberturaSeguro: false,
    objTempCobertura: null,
    CoberturaSeguro: {
      ars: null,
      cobertura: 0,
      autorizacion: "",
      medico: "",
      exequartur: "",
      especialidad: "",
      diagnostico: "",
    },
    RtipoOtroIngreso: [
      { codigo: 1, nombre: "INGRESO A CAJA" },
      { codigo: 2, nombre: "INGRESO A BANCO" },
    ],
    dialogOtrosIngreso: false,
    OtrosIngreso: {
      //secuencia2: 12
      //secuencia: 20
      activo: true,
      caja: 1,
      concepto: "",
      documento: null,
      fecha: new Date(),
      identificacion: "",
      nombre: "",
      referencia: "",
      telefono: "",
      tipoRecibo: null,
      valor: 0,
    },
    dialogClientePreferencial: false,
    dialogConsultaBalancePunto: false,
    dialogConsultaConsumoCliente: false,
    dialogCrearModificarCliente: false,
    dialogImpFiscal: false,

    dialogModalPagare: false,
    dialogModalPagoPagare: false,

    CierreRangoFecha: {
      fechaInicio: fechaNueva(),
      fechaFinal: fechaNueva(),
    },
    devuelta: 0.0,
    MakCelRncCambDiv: "#############",
    dialogCambioDivisa: false,
    CambioDivisalist: [],
    CambioDivisa: {
      id: 0,
      nombreCliente: "",
      telefonoClietne: "",
      cedulaCliente: "",
      operacion: true,
      tasaCompra: 0,
      tasaVenta: 0,
      cantidadRecivida: 0,
      devuelta: 0,
      cuadre: 0,
      caja: 0,
      usuario: null,
      fecha: new Date(),
      usuarioAnulado: null,
      fechaAnulada: null,
      cantidadEntregada: 0,
      cantidadComprada: 0,
      activada: true,
      direccionCliente: null,
      cajero: null,
      borrado: false,
      moneda: null,
    },
    CambioDivisaBusqueda: {
      secuencia: 0,
      cliente: "0",
      fechaInicial: fechaNueva(),
      fechaFinal: fechaNueva(),
    },
    CierreRangoNumero: {
      inicio: 0,
      final: 0,
    },
    RVendedor: [],
    SelectVendedorFactura: null,
    RMedico: [],
    SelectMedicoFactura: null,
    Descuentofactura: {
      ValorPorc: true,
      descuento: 0,
      DescuentoFacturaGlobal: false,
    },
    Retencionfactura: {
      ValorPorc: true,
      Retencion: 0,
    },
    Recargofactura: {
      recargo: 0,
      ValorPorc: true,
    },
    Otros: {
      comentario: "",
      numeroOrden: "",
      ShipTo: "",
      incoterms: "",
    },
    Monedafactura: null,
    tituloCompra: "",
    RDireccionDomicilio: [],
    RFacturasRutasMensajeros: [],
    OpenEjecFacturaDomicilio: false,
    domiciliofactura: null,
    dialogMensajero: false,
    dialogRecibirMensajeros: false,
    dialogAsignarMensajeros: false,
    dialogFacturasRutasMensajeros: false,
    filtroFacturaRutaCliente: "",
    filtroAsigMensajero: {
      fact: "",
      sector: "",
      caja: null,
    },
    nuevoMensajeroSelect: null,
    dialogCambiarMensajeros: false,
    selectedCambiarMensajeros: [],
    selectedAsignarMensajero: [],
    selectedRecibirMensajeros: [],
    VerFacturaDomicilioMensajero: false,
    FacturaDomicilioMensajero: null,
    buscarMensajero: null,
    Rmensajero: [],
    RRecibirMensajeros: [],
    RFacturasDomicilio: [],
    MensageroSeleccionado: {
      codigo: 0,
      nombre: "",
      telefono: "",
      cedula: "",
      metadeenvios: 0,
      sucursal: { descripcion: "" },
    },
    totalDomicilio: {
      valor: 0,
    },
    CotizacionImp: { CotImg: false, ProForma: false },
    dialogCotizacion: false,
    cotizacionAfacturaSelect: null,
    CotizacionFact: {
      secuencia: 0,
      activo: false,
      caja: null,
      concepto: "",
      conceptoPago: "",
      correo: "",
      direccion: "",
      facturada: false,
      fecha: new Date(),
      moneda: null,
      nombrecliente: "",
      sucursal: null,
      tasa: 1,
      telefono: "",
      valido: "",
      valor: 0,
      valordescuento: 0,
      valorimpuesto: 0,
      subtotal: 0,
      quitaritbis: false,
      provedorEstado: false,
    },
    OpenEjecFarmacoVigilancia: false,
    dialogFarmacoVigilancia: false,
    buscarFarmVigBoolFactReceta: false,
    buscarFarmVigilancia: 0,
    farmacoVigilanciaSoloReceta: false,
    farmacoVigilancia: {
      codigo: 0,
      autorizacion: "",
      direccion: "",
      fecha: fechaNueva(),
      fechavencimiento: null,
      hora: null,
      medico: "",
      padecimiento: "",
      monto: 0,
      nss: "",
      telefono: "",
      borrado: false,
      ars: null,
      cliente: null,
      farmacoVigilanciaDetalleList: [],
      facturasventa: null,
    },
    dialogConsultaRecetaCreada: false,
    consultaRecetaFarmVig: {
      desde: null,
      hasta: null,
    },
    consultaRecetaCreadaList: [],

    planBeneficio: {
      dialogNotifPlanBeneficio: false,
      planBeneficio: false,
      objtem: null,
    },

    objTempRecPro:null,
      dialogRecProCantidadControlada:false,

    Totales: {
      ReciboIngreso: {
        abono: 0,
        retencion: 0,
        descuento: 0,
        isr: 0,
        pendiente: 0,
      },

      totalGeneral: {
        subtotal: 0,
        itbis: 0,
        total: 0,
        descuento: 0,
        Retencion: 0,
        recargo: 0,
        cobertura: 0,
        valorLey: 0,
      },

      CierresCajas: {
        totalTotal: 0,
        totalDenomiacionvalor: 0,
      },
    },
    puntoVenta: {
      activo: true,
      codigo: 0,
    },
    
    ejecucion: true,
    pvGuardandoFactura: false,
    ejecutarAplRestFact: true,
    ejecutarEliminarProd: true,
    ejecucionValecaja:true,
    text: "",
    valid: true,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?",
    },
    aalert: {
      estado: false,
      color: null,
      timeout: 3000,
      top: false,
      right: false,
    },
    notif: {
      estado: false,
      nombre: "",
      Exec: "",
    },

notifConfAdicional: {
      estado: false,
      nombre: "",
      Exec: "",
      objTemp:null
    },

     dialogInternamientos:false,
     OpenEjecInternamientos:false,
     internamiento: {
        codigo: 0,
        activo: true,
        fechaIngreso: fechaNueva(),
        fechaSalida:null,
        cliente:null,
        ars:null,
        tipoasistencia:'',
        nohabitacion:'',
        documentoFactura: null,
        secuenciaFactura: null,
        borrado: false
      },


  }),
  methods: {

    async inicializarPvOffline() {
      await this.actualizarEstadoConexionPv()
      await this.actualizarCantidadFacturasOffline()
      if (this.pvOnline == true && this.pvFacturacionOfflineActiva()) {
        await this.sincronizarFacturasOfflinePendientes()
        await this.asegurarCatalogosOfflineCriticos()
        this.programarSincronizacionCatalogoOfflinePesado()
      }
    },

    pvFacturacionOfflineActiva() {
      var configPv = this.$store.getters.GetConfiguracionGeneral.configPv
      return configPv != null && configPv.hasOwnProperty("activarFacturacionOffline") && configPv.activarFacturacionOffline == true
    },

    iniciarVerificacionConexionOfflinePv() {
      this.detenerVerificacionConexionOfflinePv()
      this.pvIntervalVerificacionConexion = setInterval(() => {
        this.verificarConexionServidorPv()
      }, 10000)
    },

    detenerVerificacionConexionOfflinePv() {
      if (this.pvIntervalVerificacionConexion != null) {
        clearInterval(this.pvIntervalVerificacionConexion)
        this.pvIntervalVerificacionConexion = null
      }
    },

    async verificarConexionServidorPv() {
      if (this.pvFacturacionOfflineActiva() == false || this.pvVerificandoConexionOffline == true) {
        return
      }
      await this.actualizarCantidadFacturasOffline()
      var debeVerificar = this.pvOfflineForzado == true || this.pvOnline == false || this.pvFacturasOfflinePendientes > 0 || (typeof navigator !== "undefined" && navigator.onLine == false)
      if (debeVerificar == false) {
        return
      }
      this.pvVerificandoConexionOffline = true
      try {
        var res = await this.$axios.get(this.$hostname + this.$hName + "/tarjeta/findall/", {
          headers: this.$store.getters.GetheadersAxios,
          timeout: 8000,
        })
        this.pvOnline = true
        if (res != null && res.data != null) {
          this.RTipoTarjeta = res.data
          await this.guardarTiposTarjetaOffline(res.data)
        }
        await this.actualizarCantidadFacturasOffline()
        if (this.pvFacturasOfflinePendientes > 0) {
          await this.sincronizarFacturasOfflinePendientes()
        } else {
          this.pvOfflineForzado = false
          this.actualizarLabelFacturacionSinConexion(false)
        }
        this.programarSincronizacionCatalogoOfflinePesado()
      } catch (error) {
        if (this.esErrorConexionPv(error)) {
          this.activarModoOfflinePorErrorConexion(error)
        } else if (this.servidorRespondioPv(error)) {
          this.pvOnline = true
          await this.actualizarCantidadFacturasOffline()
          if (this.pvFacturasOfflinePendientes > 0) {
            await this.sincronizarFacturasOfflinePendientes()
          } else {
            this.pvOfflineForzado = false
            this.actualizarLabelFacturacionSinConexion(false)
          }
          await this.asegurarCatalogosOfflineCriticos()
        this.programarSincronizacionCatalogoOfflinePesado()
        }
      } finally {
        this.pvVerificandoConexionOffline = false
      }
    },
    async actualizarEstadoConexionPv() {
      this.pvOnline = typeof navigator === "undefined" ? true : navigator.onLine
      if (this.pvFacturacionOfflineActiva() == false) {
        return
      }
      if (this.pvOnline == true) {
        await this.actualizarCantidadFacturasOffline()
        if (this.pvFacturasOfflinePendientes == 0 && this.pvSincronizandoOffline == false) {
          this.pvOfflineForzado = false
          this.actualizarLabelFacturacionSinConexion(false)
          await this.asegurarCatalogosOfflineCriticos()
        this.programarSincronizacionCatalogoOfflinePesado()
          return
        }
        await this.sincronizarFacturasOfflinePendientes()
        await this.asegurarCatalogosOfflineCriticos()
        this.programarSincronizacionCatalogoOfflinePesado()
      } else {
        this.actualizarLabelFacturacionSinConexion(true)
      }
    },

    async actualizarCantidadFacturasOffline() {
      if (!this.pvFacturacionOfflineActiva()) {
        this.pvFacturasOfflinePendientes = 0
        this.actualizarLabelFacturacionSinConexion(false)
        return
      }
      try {
        this.pvFacturasOfflinePendientes = await contarFacturasPendientes()
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error leyendo facturas offline"
      }
    },

    debeGuardarFacturaOffline(forzarPorErrorConexion) {
      return this.pvFacturacionOfflineActiva() == true && (forzarPorErrorConexion == true || this.pvOfflineForzado == true || (typeof navigator !== "undefined" && navigator.onLine == false))
    },

    esErrorConexionPv(error) {
      if (!error || !error.response) {
        return true
      }
      var status = error.response.status
      var data = error.response.data != null ? error.response.data : ""
      var dataText = typeof data === "string" ? data : JSON.stringify(data)
      var responseText = error.response.request && error.response.request.responseText ? error.response.request.responseText : ""
      var mensaje = ((error.message || "") + " " + (error.code || "") + " " + dataText + " " + responseText).toString().toLowerCase()
      var esFallaConexion = (
        mensaje.indexOf("unable to acquire jdbc connection") >= 0 ||
        mensaje.indexOf("jdbcconnectionexception") >= 0 ||
        mensaje.indexOf("dataaccessresourcefailureexception") >= 0 ||
        mensaje.indexOf("hikaripool") >= 0 ||
        mensaje.indexOf("sqltransientconnectionexception") >= 0 ||
        mensaje.indexOf("connection has been closed") >= 0 ||
        mensaje.indexOf("request timed out after") >= 0 ||
        mensaje.indexOf("connection is not available") >= 0 ||
        mensaje.indexOf("noroutetohost") >= 0 ||
        mensaje.indexOf("no route to host") >= 0 ||
        mensaje.indexOf("el intento de conexi") >= 0 ||
        mensaje.indexOf("timeout") >= 0 ||
        mensaje.indexOf("network error") >= 0 ||
        mensaje.indexOf("econnaborted") >= 0
      )
      if (status >= 500 && esFallaConexion == true) {
        return true
      }
      if (status == 403 && this.pvFacturacionOfflineActiva() == true && (esFallaConexion == true || this.pvOfflineForzado == true || (typeof navigator !== "undefined" && navigator.onLine == false))) {
        return true
      }
      return false
    },

    servidorRespondioPv(error) {
      return error != null && error.response != null
    },

    activarModoOfflinePorErrorConexion(error) {
      if (this.pvFacturacionOfflineActiva() == false) {
        return
      }
      this.pvOnline = false
      this.pvOfflineForzado = true
      this.actualizarLabelFacturacionSinConexion(true)
      this.pvUltimoErrorOffline = error != null ? error.toString() : "Servidor no disponible"
    },

    desactivarModoOfflineForzado() {
      this.pvOfflineForzado = false
      this.pvOnline = typeof navigator === "undefined" ? true : navigator.onLine
    },

    validarCobroDuranteSincronizacionOffline() {
      if (this.pvSincronizandoOffline == true) {
        this.alerta("Espere un momento: el punto de venta esta sincronizando facturas offline pendientes. No puede cobrar hasta finalizar la sincronizacion.", "warning")
        this.loading(false)
        this.ejecucion = true
        return false
      }
      return true
    },

    actualizarLabelFacturacionSinConexion(estado) {
      localStorage.setItem("pvFacturacionSinConexionActiva", estado == true ? "true" : "false")
      window.dispatchEvent(new CustomEvent("pv-facturacion-offline", { detail: { activo: estado == true } }))
    },

    validarFacturaOfflineEmergencia() {
      if (!this.pvFacturacionOfflineActiva()) {
        return "La facturacion offline no esta activada en la configuracion del sistema."
      }
      if (this.cotizacionAfacturaSelect != null) {
        return "La modalidad offline no permite convertir cotizaciones a factura."
      }
      if (this.Facturasventa.valorNc > 0 || this.selectedListFPagoNC.length > 0) {
        return "La modalidad offline no permite pagar con nota de credito."
      }
      if (this.Facturasventa.cupones > 0 || this.Facturasventa.puntos > 0 || this.Facturasventa.valorbonogas > 0 || this.Facturasventa.valorasignacion > 0 || this.Facturasventa.valorPruebaMetro > 0 || this.Facturasventa.valorTraspaso > 0 || this.Facturasventa.valordonacion > 0) {
        return "La modalidad offline no permite esta forma de pago en contingencia."
      }
      if (this.Facturasventa.cxc > 0 && (this.clienteFactura == null || !this.clienteFactura.hasOwnProperty("codigo"))) {
        return "Para credito offline debe seleccionar un cliente."
      }
      var comprobante = this.configuraciones.configPv.comprobantefacturacion
      if (comprobante == null || !comprobante.hasOwnProperty("codigo")) {
        return "No hay comprobante de consumo configurado para ventas offline."
      }
      if (comprobante.codigo != 1 && comprobante.tipoEcf != 32) {
        return "La modalidad offline solo permite comprobante de consumo."
      }
      return ""
    },

    prepararFacturaOfflineParaGuardar(MONEDAFACTURATASA) {
      var FACTURAS_VENTA = JSON.parse(JSON.stringify(this.Facturasventa))
      FACTURAS_VENTA.tipocomprobante = JSON.parse(JSON.stringify(this.configuraciones.configPv.comprobantefacturacion))
      FACTURAS_VENTA.efectivo = JSON.parse(JSON.stringify(this.Facturasventa.efectivo * MONEDAFACTURATASA))
      FACTURAS_VENTA.tarjeta = JSON.parse(JSON.stringify(this.Facturasventa.tarjeta * MONEDAFACTURATASA))
      FACTURAS_VENTA.cheques = JSON.parse(JSON.stringify(this.Facturasventa.cheques * MONEDAFACTURATASA))
      FACTURAS_VENTA.transferencia = JSON.parse(JSON.stringify(this.Facturasventa.transferencia * MONEDAFACTURATASA))
      FACTURAS_VENTA.cxc = JSON.parse(JSON.stringify(this.Facturasventa.cxc * MONEDAFACTURATASA))
      FACTURAS_VENTA.cupones = 0
      FACTURAS_VENTA.valorConduce = JSON.parse(JSON.stringify(this.Facturasventa.valorConduce * MONEDAFACTURATASA))
      FACTURAS_VENTA.valorNc = 0
      FACTURAS_VENTA.valorbonogas = 0
      FACTURAS_VENTA.valorasignacion = 0
      FACTURAS_VENTA.valorPruebaMetro = 0
      FACTURAS_VENTA.valorTraspaso = 0
      FACTURAS_VENTA.valordonacion = 0
      FACTURAS_VENTA.turno = this.OtrasConfigPv.turno
      var PORCIENTO_LEY = this.$store.getters.GetConfiguracionGeneral.configPv.porcientoLey
      if (PORCIENTO_LEY != null && PORCIENTO_LEY > 0) {
        FACTURAS_VENTA.porcientoLey = PORCIENTO_LEY
        FACTURAS_VENTA.valorLey = this.RedondeoValor(((this.Totales.totalGeneral.subtotal * PORCIENTO_LEY) / 100))
      } else {
        FACTURAS_VENTA.porcientoLey = 0
        FACTURAS_VENTA.valorLey = 0
      }
      if (this.SelectMedicoFactura != null && this.SelectMedicoFactura.hasOwnProperty("codigo")) {
        FACTURAS_VENTA.medicoCodigo = this.SelectMedicoFactura.codigo
        FACTURAS_VENTA.medico = this.SelectMedicoFactura.nombre
      }
      FACTURAS_VENTA.envioArs = false
      return FACTURAS_VENTA
    },

    async guardarFacturaOfflineDesdePayload(FACTURAS_VENTA, operacionOffline) {
      var mensajeValidacion = this.validarFacturaOfflineEmergencia()
      if (mensajeValidacion.trim().length > 0) {
        this.alerta(mensajeValidacion, "error")
        this.ejecucion = true
        this.pvGuardandoFactura = false
        this.loading(false)
        return false
      }
      try {
        this.actualizarLabelFacturacionSinConexion(true)
        var registro = await guardarFacturaPendiente(FACTURAS_VENTA, {
          caja: this.caja,
          sucursal: this.caja != null ? this.caja.sucursal : null,
          usuario: this.OtrasConfigPv.cajero,
          cliente: this.clienteFactura,
          operacion: operacionOffline || "factura",
        })
        await this.actualizarCantidadFacturasOffline()
        this.ejecucion = true
        this.pvGuardandoFactura = false
        this.loading(false)
        this.alerta("Factura guardada localmente en modo offline. Pendiente de sincronizar: " + registro.offlineId, "warning")
        this.imprimirFacturaOfflineLocal(registro.factura, registro.meta.operacion, registro.offlineId)
        this.limpiarPuntoVentaCompleto()
        return true
      } catch (error) {
        this.alerta(error != null ? error.toString() : "No se pudo guardar la factura offline", "error")
        this.ejecucion = true
        this.pvGuardandoFactura = false
        this.loading(false)
        return false
      }
    },

    referenciaOfflineServidor(offlineId) {
      var valor = offlineId != null ? offlineId.toString().trim() : ""
      if (valor.length == 0) {
        valor = "OFF-" + Date.now().toString()
      }
      if (valor.length <= 20) {
        return valor
      }
      return "OFF-" + valor.replace(/[^a-zA-Z0-9]/g, "").slice(-16)
    },

    documentoFacturaOffline() {
      var documento = null
      if (this.configuraciones != null && this.configuraciones.configPv != null && this.configuraciones.configPv.comprobantefacturacion != null) {
        documento = JSON.parse(JSON.stringify(this.configuraciones.configPv.comprobantefacturacion))
      }
      if (documento == null || !documento.hasOwnProperty("codigo")) {
        documento = { codigo: 0, nombrecorto: "OFF", descripcion: "Factura offline", cantidadcopias: 1 }
      }
      if (documento.nombrecorto == null || documento.nombrecorto.toString().trim().length == 0) {
        documento.nombrecorto = "OFF"
      }
      if (documento.cantidadcopias == null || Number(documento.cantidadcopias) <= 0) {
        documento.cantidadcopias = 1
      }
      return documento
    },

    prepararFacturaOfflineParaImprimir(FACTURAS_VENTA, offlineId) {
      var facturaImprimir = JSON.parse(JSON.stringify(FACTURAS_VENTA || {}))
      var documentoFactura = facturaImprimir.documentoFactura != null && facturaImprimir.documentoFactura.hasOwnProperty("codigo") ? facturaImprimir.documentoFactura : this.documentoFacturaOffline()
      var documento = documentoFactura.codigo != null ? documentoFactura.codigo : (facturaImprimir.documento != null ? facturaImprimir.documento : 0)
      facturaImprimir.documentoFactura = documentoFactura
      facturaImprimir.documento = documento
      if (facturaImprimir.tipocomprobante == null || !facturaImprimir.tipocomprobante.hasOwnProperty("codigo")) {
        facturaImprimir.tipocomprobante = JSON.parse(JSON.stringify(documentoFactura))
      }
      if (facturaImprimir.moneda == null || !facturaImprimir.moneda.hasOwnProperty("codigo")) {
        facturaImprimir.moneda = JSON.parse(JSON.stringify(this.Monedafactura))
      }
      if (facturaImprimir.cliente == null) {
        delete facturaImprimir.cliente
      }
      if (facturaImprimir.vendedor == null) {
        delete facturaImprimir.vendedor
      }
      if (facturaImprimir.domicilio == null) {
        delete facturaImprimir.domicilio
      }
      if (facturaImprimir.facturasventaPK == null) {
        facturaImprimir.facturasventaPK = {
          documento: documento,
          secuencia: parseInt(Date.now().toString().slice(-7), 10),
        }
      }
      if (facturaImprimir.facturasventaPK.documento == null || Number(facturaImprimir.facturasventaPK.documento) == 0) {
        facturaImprimir.facturasventaPK.documento = documento
      }
      if (facturaImprimir.fecha == null || facturaImprimir.fecha.toString().trim().length == 0) {
        facturaImprimir.fecha = new Date().toISOString()
      }
      facturaImprimir.nuevaFecha = facturaImprimir.nuevaFecha || facturaImprimir.fecha
      facturaImprimir.ncf = facturaImprimir.ncf || "OFFLINE-LOCAL"
      facturaImprimir.referencia = this.referenciaOfflineServidor(offlineId)
      facturaImprimir.offlineId = offlineId
      return facturaImprimir
    },
    imprimirFacturaOfflineLocal(FACTURAS_VENTA, operacionOffline, offlineId) {
      var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
      var impresora = null
      if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
        impresora = selectImpre.nombre
      }
      var operacion = operacionOffline || "factura"
      var formato = this.caja.formatoimpresioncontado != null ? this.caja.formatoimpresioncontado.trim() : ""
      if (operacion == "conduce" && this.caja.formatoImprecionConduce != null) {
        formato = this.caja.formatoImprecionConduce.trim()
      }
      var msg = {
        accion: "print",
        formato: formato,
        impresora: impresora,
        data: this.configuraciones,
        fac: this.prepararFacturaOfflineParaImprimir(FACTURAS_VENTA, offlineId),
        caja: this.caja,
        totales: this.Totales != null ? this.Totales.totalGeneral : null,
      }
      this.imprimir(msg, operacion)
    },

    async guardarFacturaOfflineDesdeEstado(MONEDAFACTURATASA) {
      var FACTURAS_VENTA = this.prepararFacturaOfflineParaGuardar(MONEDAFACTURATASA)
      return this.guardarFacturaOfflineDesdePayload(FACTURAS_VENTA, "factura")
    },

    async sincronizarFacturasOfflinePendientes() {
      if (this.pvFacturacionOfflineActiva() == false || this.pvSincronizandoOffline == true || this.pvOnline == false || this.ejecucion == false) {
        return
      }
      this.pvSincronizandoOffline = true
      try {
        var pendientes = await obtenerFacturasPendientes()
        for (const item of pendientes) {
          var facturaSincronizar = null
          try {
            facturaSincronizar = await marcarFacturaSincronizando(item.offlineId)
            if (facturaSincronizar == null) {
              continue
            }
            var operacion = facturaSincronizar.meta && facturaSincronizar.meta.operacion ? facturaSincronizar.meta.operacion : "factura"
            var endpoint = operacion == "conduce" ? "/conduce/save" : "/pv/save"
            var facturaServidor = JSON.parse(JSON.stringify(facturaSincronizar.factura || {}))
            facturaServidor.referencia = this.referenciaOfflineServidor(facturaSincronizar.offlineId)
            const res = await this.$axios.post(this.$hostname + this.$hName + endpoint, facturaServidor, {
              headers: this.$store.getters.GetheadersAxios,
            })
            await marcarFacturaSincronizada(facturaSincronizar.offlineId, res.data)
          } catch (error) {
            await marcarFacturaError(facturaSincronizar != null ? facturaSincronizar.offlineId : item.offlineId, error && error.response && error.response.request ? error.response.request.responseText : error)
            if (this.esErrorConexionPv(error)) {
              this.pvOnline = false
              break
            }
          }
        }
      } finally {
        this.pvSincronizandoOffline = false
        await this.actualizarCantidadFacturasOffline()
        if (this.pvFacturasOfflinePendientes == 0 && this.pvOnline == true && (typeof navigator === "undefined" || navigator.onLine == true)) {
          this.pvOfflineForzado = false
          this.actualizarLabelFacturacionSinConexion(false)
        }
      }
    },

    claveSincronizacionCatalogoOffline() {
      var tenant = this.$store.getters.GetheadersAxios["X-TENANT-ID"] || this.$store.getters.GetheadersAxios["x-tenant-id"] || "tenant"
      var sucursal = this.caja != null && this.caja.sucursal != null ? this.caja.sucursal.codigo : 0
      return "pv-offline-catalogo-v3-" + tenant + "-" + sucursal
    },

    debeSincronizarCatalogoOffline() {
      var ultima = localStorage.getItem(this.claveSincronizacionCatalogoOffline())
      if (ultima == null) {
        return true
      }
      return (Date.now() - Number(ultima)) > 5 * 60 * 60 * 1000
    },

    cajaCobradoraCatalogoOffline() {
      return this.caja != null && this.caja.cobradora == true
    },

    catalogoOfflinePesadoPermitido() {
      if (this.pvFacturacionOfflineActiva() == false) {
        return false
      }
      if (this.cajaCobradoraCatalogoOffline() == false) {
        return false
      }
      return localStorage.getItem("pv-offline-sync-heavy") != "false"
    },

    programarSincronizacionCatalogoOfflinePesado() {
      if (this.catalogoOfflinePesadoPermitido() == false) {
        console.log("CATALOGO OFFLINE PESADO NO INICIA", this.cajaCobradoraCatalogoOffline() == false ? "caja no cobradora" : "sincronizacion masiva desactivada")
        return
      }
      if (this.pvTimeoutReintentoCatalogoOffline != null) {
        clearTimeout(this.pvTimeoutReintentoCatalogoOffline)
      }
      var espera = 10 * 60 * 1000
      console.log("CATALOGO OFFLINE PESADO PROGRAMADO", Math.round(espera / 60000), "minutos")
      this.pvTimeoutReintentoCatalogoOffline = setTimeout(() => {
        this.pvTimeoutReintentoCatalogoOffline = null
        this.sincronizarCatalogoOfflineBase()
      }, espera)
    },
    claveProgresoCatalogoOffline(tipo) {
      return this.claveSincronizacionCatalogoOffline() + "-" + tipo + "-ultimo"
    },

    obtenerProgresoCatalogoOffline(tipo) {
      var progreso = Number(localStorage.getItem(this.claveProgresoCatalogoOffline(tipo)))
      return isNaN(progreso) || progreso < 0 ? 0 : progreso
    },

    guardarProgresoCatalogoOffline(tipo, ultimo) {
      localStorage.setItem(this.claveProgresoCatalogoOffline(tipo), Number(ultimo).toString())
    },

    limpiarProgresoCatalogoOffline() {
      localStorage.removeItem(this.claveProgresoCatalogoOffline("productos"))
      localStorage.removeItem(this.claveProgresoCatalogoOffline("clientes"))
    },

    programarReintentoCatalogoOffline(motivo) {
      if (this.pvFacturacionOfflineActiva() == false || this.pvOnline == false || this.cajaCobradoraCatalogoOffline() == false) {
        return
      }
      if (this.pvTimeoutReintentoCatalogoOffline != null) {
        clearTimeout(this.pvTimeoutReintentoCatalogoOffline)
      }
      console.log("CATALOGO OFFLINE REINTENTO PROGRAMADO", motivo != null ? motivo.toString() : "error")
      this.pvTimeoutReintentoCatalogoOffline = setTimeout(() => {
        this.pvTimeoutReintentoCatalogoOffline = null
        this.sincronizarCatalogoOfflineBase()
      }, 30 * 60 * 1000)
    },

    async sincronizarCatalogoOfflineBase() {
      if (this.pvFacturacionOfflineActiva() == false) {
        console.log("CATALOGO OFFLINE NO INICIA", "parametro offline desactivado")
        return
      }
      if (this.cajaCobradoraCatalogoOffline() == false) {
        console.log("CATALOGO OFFLINE NO INICIA", "caja no cobradora")
        return
      }
      if (this.pvSincronizandoCatalogoOffline == true) {
        console.log("CATALOGO OFFLINE NO INICIA", "sincronizacion en proceso")
        return
      }
      if (this.pvOnline == false) {
        console.log("CATALOGO OFFLINE NO INICIA", "POS sin conexion")
        return
      }
      if (this.catalogoOfflinePesadoPermitido() == false) {
        await this.asegurarCatalogosOfflineCriticos()
        console.log("CATALOGO OFFLINE NO INICIA", "sincronizacion masiva desactivada")
        return
      }
      if (this.debeSincronizarCatalogoOffline() == false) {
        await this.asegurarCatalogosOfflineCriticos()
        console.log("CATALOGO OFFLINE NO INICIA", "catalogo vigente")
        return
      }
      this.pvSincronizandoCatalogoOffline = true
      console.log("CATALOGO OFFLINE INICIADO")
      try {
        await this.sincronizarProductosCatalogoOffline()
        await this.sincronizarClientesCatalogoOffline()
        await this.sincronizarTiposTarjetaCatalogoOffline()
        await this.sincronizarArsCatalogoOffline()
        await this.sincronizarMensajerosCatalogoOffline()
        await this.sincronizarVendedoresCatalogoOffline()
        localStorage.setItem(this.claveSincronizacionCatalogoOffline(), Date.now().toString())
        this.limpiarProgresoCatalogoOffline()
        if (this.pvTimeoutReintentoCatalogoOffline != null) {
          clearTimeout(this.pvTimeoutReintentoCatalogoOffline)
          this.pvTimeoutReintentoCatalogoOffline = null
        }
        console.log("CATALOGO OFFLINE CARGADO")
      } catch (error) {
        console.error("CATALOGO OFFLINE ERROR", error)
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error sincronizando catalogo offline"
        this.programarReintentoCatalogoOffline(this.pvUltimoErrorOffline)
      } finally {
        this.pvSincronizandoCatalogoOffline = false
      }
    },

    timeoutCatalogoOffline() {
      return 5 * 60 * 1000
    },
    async sincronizarProductosCatalogoOffline() {
      var limit = 500
      var ultimo = this.obtenerProgresoCatalogoOffline("productos")
      var total = 0
      var USAR_MINIMA = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaUnidadMinima
      var minima = USAR_MINIMA == null ? "null" : USAR_MINIMA
      var sucursal = this.caja != null && this.caja.sucursal != null ? this.caja.sucursal.codigo : 0
      console.log("CATALOGO PRODUCTOS INICIADO")
      if (ultimo > 0) {
        console.log("CATALOGO PRODUCTOS RETOMANDO", ultimo)
      }
      do {
        var link = this.$hostname + this.$hName + "/unidades-productos/offlineCatalogo/" + limit + "/" + ultimo + "/" + minima
        var res = await this.$axios.get(link, { headers: this.$store.getters.GetheadersAxios, timeout: this.timeoutCatalogoOffline() })
        var productos = res.data && res.data.ListItems ? res.data.ListItems : []
        total = res.data && res.data.TbTotalItem ? res.data.TbTotalItem : productos.length
        await guardarProductosCatalogo(productos, sucursal)
        console.log("CATALOGO PRODUCTOS PROGRESO", ultimo + productos.length, "de", total)
        this.guardarProgresoCatalogoOffline("productos", ultimo + productos.length)
        ultimo += productos.length
        if (productos.length == 0) {
          break
        }
      } while (ultimo < total)
      console.log("CATALOGO PRODUCTOS CARGADO", ultimo, "productos")
    },

    async asegurarClientesOffline() {
      if (this.pvFacturacionOfflineActiva() == false || (typeof navigator !== "undefined" && navigator.onLine == false)) {
        return false
      }
      try {
        var totalClientesCache = await contarClientesCache()
        if (totalClientesCache >= 25) {
          return true
        }
        console.log("CATALOGO CLIENTES NO INICIA", "cache vacio y sincronizacion masiva desactivada")
        return false
      } catch (error) {
        if (this.esErrorConexionPv(error)) {
          this.activarModoOfflinePorErrorConexion(error)
        } else {
          this.pvUltimoErrorOffline = error != null ? error.toString() : "Error asegurando cache de clientes"
        }
      }
      return false
    },
    async sincronizarClientesCatalogoOffline() {
      var limit = 500
      var ultimo = this.obtenerProgresoCatalogoOffline("clientes")
      console.log("CATALOGO CLIENTES INICIADO")
      if (ultimo > 0) {
        console.log("CATALOGO CLIENTES RETOMANDO", ultimo)
      }
      while (true) {
        var link = this.$hostname + this.$hName + "/clientes/offlineCatalogo/" + limit + "/" + ultimo
        var res = await this.$axios.get(link, { headers: this.$store.getters.GetheadersAxios, timeout: this.timeoutCatalogoOffline() })
        var clientes = res.data || []
        await this.guardarClientesOffline(clientes)
        console.log("CATALOGO CLIENTES PROGRESO", ultimo + clientes.length)
        this.guardarProgresoCatalogoOffline("clientes", ultimo + clientes.length)
        ultimo += clientes.length
        if (clientes.length < limit) {
          break
        }
      }
      console.log("CATALOGO CLIENTES CARGADO", ultimo, "clientes")
    },

    async sincronizarArsCatalogoOffline() {
      var res = await this.$axios.get(this.$hostname + this.$hName + "/ars/findallactivos", {
        headers: this.$store.getters.GetheadersAxios,
        timeout: this.timeoutCatalogoOffline(),
      })
      await this.guardarArsOffline(res.data || [])
    },

    async sincronizarMensajerosCatalogoOffline() {
      var res = await this.$axios.get(this.$hostname + this.$hName + "/Mesajeros/findall/activos", {
        headers: this.$store.getters.GetheadersAxios,
        timeout: this.timeoutCatalogoOffline(),
      })
      await this.guardarMensajerosOffline(res.data || [])
    },

    async sincronizarVendedoresCatalogoOffline() {
      var res = await this.$axios.get(this.$hostname + this.$hName + "/vendedores/findallactiv", {
        headers: this.$store.getters.GetheadersAxios,
        timeout: this.timeoutCatalogoOffline(),
      })
      await this.guardarVendedoresOffline(res.data || [])
      console.log("CATALOGO VENDEDORES CARGADO", (res.data || []).length, "vendedores")
    },

    async guardarProductosOfflineBusqueda(cacheKey, texto, productos) {
      if (this.pvFacturacionOfflineActiva() == false) {
        return
      }
      try {
        var sucursal = this.caja != null && this.caja.sucursal != null ? this.caja.sucursal.codigo : 0
        await guardarProductosBusqueda(cacheKey, texto, sucursal, JSON.parse(JSON.stringify(productos || [])))
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error guardando cache de productos"
      }
    },

    async buscarProductosOfflineBusqueda(cacheKey, texto) {
      if (this.pvFacturacionOfflineActiva() == false) {
        return
      }
      try {
        var sucursal = this.caja != null && this.caja.sucursal != null ? this.caja.sucursal.codigo : 0
        var productos = await buscarProductosCache(cacheKey, texto, sucursal)
        this.RallProducto = JSON.parse(JSON.stringify(productos))
        if (productos.length == 0) {
          this.alerta("No hay productos en la cache offline de esta PC. Abra el POS con conexion para sincronizar el catalogo antes de usar contingencia.", "warning")
        }
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error buscando productos offline"
      }
    },

    async guardarClientesOffline(clientes) {
      if (this.pvFacturacionOfflineActiva() == false) {
        return
      }
      try {
        await guardarClientes(JSON.parse(JSON.stringify(clientes || [])))
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error guardando cache de clientes"
      }
    },

    async buscarClientesOffline(texto) {
      if (this.pvFacturacionOfflineActiva() == false) {
        return
      }
      try {
        var totalClientesCache = await contarClientesCache()
        this.RCliente = await buscarClientesCache(texto, this.filtroTipoCliente)
        if (totalClientesCache == 0) {
          this.alerta("No hay clientes en la cache offline de esta PC. Abra el POS con conexion para sincronizar el catalogo antes de usar contingencia.", "warning")
        }
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error buscando clientes offline"
      }
    },

    async guardarArsOffline(arsList) {
      if (this.pvFacturacionOfflineActiva() == false) {
        return
      }
      try {
        await guardarArs(JSON.parse(JSON.stringify(arsList || [])))
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error guardando cache de ARS"
      }
    },

    async cargarArsOffline(texto) {
      if (this.pvFacturacionOfflineActiva() == false) {
        return false
      }
      try {
        this.RArs = await buscarArsCache(texto)
        if (this.RArs.length > 0) {
          return true
        }
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error buscando ARS offline"
      }
      return false
    },

    async guardarMensajerosOffline(mensajeros) {
      if (this.pvFacturacionOfflineActiva() == false) {
        return
      }
      try {
        await guardarMensajeros(JSON.parse(JSON.stringify(mensajeros || [])))
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error guardando cache de mensajeros"
      }
    },

    async cargarMensajerosOffline() {
      if (this.pvFacturacionOfflineActiva() == false || this.caja == null || this.caja.sucursal == null) {
        return false
      }
      try {
        this.Rmensajero = await buscarMensajerosCache(this.caja.sucursal.codigo)
        return this.Rmensajero.length > 0
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error buscando mensajeros offline"
      }
      return false
    },

    async asegurarTiposTarjetaOffline() {
      if (this.pvFacturacionOfflineActiva() == false || (typeof navigator !== "undefined" && navigator.onLine == false)) {
        return false
      }
      var cargoOffline = await this.cargarTiposTarjetaOffline()
      if (cargoOffline == true) {
        return true
      }
      try {
        var res = await this.$axios.get(this.$hostname + this.$hName + "/tarjeta/findall/", {
          headers: this.$store.getters.GetheadersAxios,
          timeout: 8000,
        })
        this.RTipoTarjeta = res.data || []
        await this.guardarTiposTarjetaOffline(this.RTipoTarjeta)
        return this.RTipoTarjeta.length > 0
      } catch (error) {
        if (this.esErrorConexionPv(error)) {
          this.activarModoOfflinePorErrorConexion(error)
        }
      }
      return false
    },
    async sincronizarTiposTarjetaCatalogoOffline() {
      var res = await this.$axios.get(this.$hostname + this.$hName + "/tarjeta/findall/", {
        headers: this.$store.getters.GetheadersAxios,
        timeout: this.timeoutCatalogoOffline(),
      })
      await this.guardarTiposTarjetaOffline(res.data || [])
      console.log("CATALOGO TIPOS TARJETA CARGADO", (res.data || []).length, "tipos")
    },

    async asegurarCatalogosOfflineCriticos() {
      if (this.cajaCobradoraCatalogoOffline() == false) {
        console.log("CATALOGO OFFLINE CRITICO NO INICIA", "caja no cobradora")
        return
      }
      if (this.pvFacturacionOfflineActiva() == false || this.pvOnline == false || (typeof navigator !== "undefined" && navigator.onLine == false)) {
        return
      }
      try {
        await this.asegurarTiposTarjetaOffline()
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error asegurando cache de tipos de tarjeta"
      }
      try {
        await this.sincronizarArsCatalogoOffline()
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error asegurando cache de ARS"
      }
      try {
        await this.sincronizarMensajerosCatalogoOffline()
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error asegurando cache de mensajeros"
      }
      try {
        await this.asegurarVendedoresOffline()
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error asegurando cache de vendedores"
      }    },

    async guardarVendedoresOffline(vendedores) {
      if (this.pvFacturacionOfflineActiva() == false) {
        return
      }
      try {
        await guardarVendedores(JSON.parse(JSON.stringify(vendedores || [])))
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error guardando cache de vendedores"
      }
    },

    async cargarVendedoresOffline(texto) {
      if (this.pvFacturacionOfflineActiva() == false || this.caja == null || this.caja.sucursal == null) {
        return false
      }
      try {
        this.RVendedor = await buscarVendedoresCache(this.caja.sucursal.codigo, texto)
        return this.RVendedor.length > 0
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error buscando vendedores offline"
      }
      return false
    },

    async asegurarVendedoresOffline() {
      if (this.pvFacturacionOfflineActiva() == false || (typeof navigator !== "undefined" && navigator.onLine == false)) {
        return false
      }
      var cargoOffline = await this.cargarVendedoresOffline("")
      if (cargoOffline == true) {
        return true
      }
      try {
        await this.sincronizarVendedoresCatalogoOffline()
        return await this.cargarVendedoresOffline("")
      } catch (error) {
        if (this.esErrorConexionPv(error)) {
          this.activarModoOfflinePorErrorConexion(error)
        } else {
          this.pvUltimoErrorOffline = error != null ? error.toString() : "Error asegurando cache de vendedores"
        }
      }
      return false
    },
    async guardarTiposTarjetaOffline(tiposTarjeta) {
      if (this.pvFacturacionOfflineActiva() == false) {
        return
      }
      try {
        await guardarTiposTarjeta(JSON.parse(JSON.stringify(tiposTarjeta || [])))
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error guardando cache de tipos de tarjeta"
      }
    },

    async cargarTiposTarjetaOffline() {
      if (this.pvFacturacionOfflineActiva() == false) {
        return false
      }
      try {
        this.RTipoTarjeta = await buscarTiposTarjetaCache()
        return this.RTipoTarjeta.length > 0
      } catch (error) {
        this.pvUltimoErrorOffline = error != null ? error.toString() : "Error buscando tipos de tarjeta offline"
      }
      return false
    },
    currencyFormatter,
    FormatoFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoValorCantRed,
    fechaNueva,
    getParamFecha,
    validaCedRnc,
    getFechaZone,
    getHoraActual,
    sinRedondeoCantidad,
    diasTranscurridos,
    validaEjecConfigPv() {
      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv("AccCambiarCaja")
        return
      }

    },

    EjecConfigPv() {
      this.findAllTerminal()
      // :items="terminal.impresoras"
      //  v-model="OtrasConfigPv.impresora"

      if (localStorage.hasOwnProperty("printerSelect")) {
        this.OtrasConfigPv.impresora = JSON.parse(localStorage.printerSelect)
      } else {
        this.OtrasConfigPv.impresora = null
      }

      this.dialogConfigPv = true
    },


    // Llamar a una función en un componente secundario para los permisos de usuario.
    funcionValidaPermisoPv(e) {

      var Sudo = this.$store.getters.GetdatosInfUsu.usuario.sudo
      var permiso = this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList

      //if (Sudo == false) { }
      var obj = {
        accion: JSON.parse(JSON.stringify(e)),
        Permiso: permiso,
        Sudo: Sudo,
      }
      this.$refs.RefPvMenuOpcionBotones.ClickAccionPadreEjecut(obj)

    },
    DataRetornPadrePermisoPv(e) {
      // console.log('viendo-Data2->',e)

      //Permite Cambiar Cantidad a producto"
      if (e == "AccCambioCantidadProd") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.$refs.RefTextFieldProductoCantidad.focus()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }
      //Permite Cambiar Precio a producto"
      if (e == "AccCambioPrecioProd") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.$refs.RefTextFieldProductoPrecio.focus()
          _this.EjecutarPermisoPv = false
        }, 999)
        return
      }
// Modificar receta producto controlado(Cant.Recetada y Despachada)
 if (e == "AccModificarRecProdControlado") {
        //this.EjecutarPermisoPv = true

        var _this = this
        setTimeout(function() {
          _this.dialogRecProCantidadControlada=true
          //_this.EjecutarPermisoPv = false
        }, 999)
        return
      }
     
if (e == "CancelarAccModificarRecProdControlado") {
    this.objTempRecPro=null
  }
      

//permitir vender por debajo del precio actual
      if (e == "AccCambiarPrecioProductoBajoPrecioActual") {
        var Config = this.$store.getters.GetConfiguracionGeneral
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {

          if (Config.configPv.venderalcosto == false && _this.rulePrecioProdBajoPrecio < _this.productoSeleccionado.costo) {
            _this.productoSeleccionado.precio = JSON.parse(JSON.stringify(_this.productoSeleccionado.costo))
            _this.productoSeleccionado.precioDig = JSON.parse(JSON.stringify(_this.productoSeleccionado.costo))
          } else {
            _this.productoSeleccionado.precio = JSON.parse(JSON.stringify(_this.rulePrecioProdBajoPrecio))
            _this.productoSeleccionado.precioDig = JSON.parse(JSON.stringify(_this.rulePrecioProdBajoPrecio))
          }
          // _this.$refs.RefTextFieldProductoPrecio.focus();
          _this.EjecutarPermisoPv = false
          if (_this.boolEnterPrecioProdSelect == true) {
            _this.boolEnterPrecioProdSelect = false
            setTimeout(function() {
              _this.SalvarProductoCompraEnter()
            }, 100)
          }


        }, 500)
        return
      }


      //Permite Cambiar Descuento a producto"
      if (e == "AccCambiarDescuentoProd") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.$refs.RefTextFieldProductoDescuento.focus()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }

      //Permite Cambiar vendedor a producto"
      if (e == "AccCambiarVendedorProd") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.$refs.RefTextFieldProductoVendedor.focus()
          _this.cargarVendedorProducto()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }

      //Permite Cambiar vendedor a producto"
      if (e == "AccEliminarLineaProd") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.eliminarInfProductoCompra()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }

      //Permite Cambiar recargo a producto"
      if (e == "AccCambiarRecargoProd") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.$refs.RefTextFieldProductoRecargo.focus()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }

      //Permite Crear Cliente"
      if (e == "AccCrearEditarCliente") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.SalvarCrearEditarCliente()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }

      //Cancelar Creacion de Factura
      if (e == "AccPermitirLimpiarPantalla") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.limpiarPuntoVentaCompleto()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }


      //Abrir Caja Registradora F2
      if (e == "AccAbrirCajaRegistradoraF2") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.openCashDrawer()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }


      //entraga mensajero domicilio
      if (e == "AccMensajeroEntregado") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.slvarEntregado()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }

      // no entraga mensajero domicilio
      if (e == "AccMensajeroNoEntregado") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.salvarNoEntregado()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }

      //Anular cambio de divisa
      if (e == "AccAnularCambioDivisa") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.anularCambioDivisa()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }

      //imprimir cambio de divisa
      if (e == "AccImprimirCambioDivisa") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.imprimirCambioDivisa()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }

      //imprimir Guardar temporal
      if (e == "AccGuardartemporal") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.OpenDialogGuardartemporal()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }


      //Aplicar RestaurarFact
      if (e == "AccAplicarRestaurarFact") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          // _this.AplicarRestaurarFact(_this.ObjEjecPermisoPv)
          _this.verificarusofacturatemporalAplicar(_this.ObjEjecPermisoPv)
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }


      //Aplicar RestaurarFact
      if (e == "AccImprimirRestaurarFact") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.ImprimirRestaurarFact(_this.ObjEjecPermisoPv)
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }


      //Aplicar RestaurarFact
      if (e == "AccImprimirRestaurarFact") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.ImprimirRestaurarFact(_this.ObjEjecPermisoPv)
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }


      //Aplicar deleRestaurarFact
      if (e == "AccDeleRestaurarFact") {
        this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.LlamadeleRestaurarFact(_this.ObjEjecPermisoPv)
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }

      if (e == "AccReimpresionOpcRecibo") {
        this.BtnReimprecionvalue = 1
        this.ReimprecionSheet = false
        this.ReimprecionResetCargarPaginacion()
        return
      }

      if (e == "AccReimpresionOpcOtrosingresos") {
        this.BtnReimprecionvalue = 2
        this.ReimprecionSheet = false
        this.ReimprecionResetCargarPaginacion()
        return
      }

      if (e == "AccReimpresionOpcFactura") {
        this.BtnReimprecionvalue = 3
        this.ReimprecionSheet = false
        this.ReimprecionResetCargarPaginacion()
        return
      }

      if (e == "AccReimpresionOpcDevolución") {
        this.BtnReimprecionvalue = 4
        this.ReimprecionSheet = false
        this.ReimprecionResetCargarPaginacion()
        return
      }

      if (e == "AccReimpresionOpcValeCaja") {
        this.BtnReimprecionvalue = 5
        this.ReimprecionSheet = false
        this.ReimprecionResetCargarPaginacion()
        return
      }

      if (e == "AccReimpresionOpcCotizacion") {
        this.BtnReimprecionvalue = 6
        this.ReimprecionSheet = false
        this.ReimprecionResetCargarPaginacion()
        return
      }

      if (e == "AccReimpresionOpcConduce") {
        this.BtnReimprecionvalue = 7
        this.ReimprecionSheet = false
        this.ReimprecionResetCargarPaginacion()
        return
      }

      if (e == "AccDescuentoGlobalFactura") {
        this.aplicarDescuentoGlobalFacturaXencimaMaximo()
        return
      }


      //Permite Cambiar Cantidad a producto"
      if (e == "AccCambiarCaja") {
        // this.EjecutarPermisoPv = true
        var _this = this
        setTimeout(function() {
          _this.EjecConfigPv()
          _this.EjecutarPermisoPv = false
        }, 500)
        return
      }

      //Permitir facturar a cliente que excede limite de crédito
      if (e == "AccFactExcedeLimitCredito") {
        var _this = this
        setTimeout(function() {
          _this.contFactExcedeLimitCredito = true
          _this.ContrealizarCobro()
        }, 500)
        return
      }

      //Permitir Facturar a cliente que excede Suspensión Por Días.
      if (e == "AccPermitirExcederLimiteSuspensionDias") {
        var _this = this
        setTimeout(function() {
          _this.clienteFactura.clienteSupencion = false
          _this.ContrealizarCobro()
        }, 500)
        return
      }


//Registrar Clientes Preferencial
      if (e == "AccBtnRegistrarClientesPreferencial") {
        var _this = this
        setTimeout(function() {
          _this.openCrearModificarCliente()
        }, 500)
        return
      }


      //Registrar Clientes Preferencial
      if (e == "AccBtnConsultaClientesPreferencial") {
        var _this = this
        setTimeout(function() {
          _this.openConsultaConsumoCliente()
        }, 500)
        return
      }


      //Registrar Clientes Preferencial
      if (e == "AccCambiarDevolucionEfectivo") {
        this.DevolucionFacturaSeleccionada.efectivo = true
        /* var _this = this;
        setTimeout(function () {
          _this.openConsultaConsumoCliente()
        }, 500);*/
        return
      }


      //Permitir facturar a cliente que excede limite de crédito
      if (e == "AccFactDescLimitTarjeta") {
        var _this = this
        setTimeout(function() {
          _this.contFactDescLimitTarjeta = true
          _this.ContrealizarCobro()
        }, 500)
        return
      }


   // Cambiar Vendedor con F7
 if (e == "AccCambiarVendedorF7") {
        //this.EjecutarPermisoPv = true
       this.activoF7 = true
        var _this = this
        setTimeout(function() {
          _this.$refs.RefTextFieldBuscaVendedorCodigo.focus()
        }, 500)
        return
      }


      // NotifAdicAsignarMensajero
 if (e == "AccNotifAdicAsignarMensajero") {
this.cerrarNotificacionAdic()
  var _this = this
          setTimeout(function() {
            _this.contSalvarAsignarMensagero()
          }, 500)

        //this.EjecutarPermisoPv = true
       /*this.activoF7 = true
        var _this = this
        setTimeout(function() {
          _this.$refs.RefTextFieldBuscaVendedorCodigo.focus()
        }, 500)*/
        return
      }

    },

    DataRetornMenuOpcBotonesPermisosPv(e) {
      // console.log('Data 1-->',e)
      //Abre el boton del menu producto
      if (e == "BtnProducto") {
        this.openCrearPoducto()
        return
      }
      //Abre el boton del menu Cliente
      if (e == "BtnClientes") {
        this.OpenDialogCrearEditarCliente(), this.filtroTipoCliente = 3
        var _this = this
        setTimeout(function() {
          _this.$refs.RefTextFieldBuscaCliente.focus()
        }, 500)
        return
      }

      //Abre el boton del menu Reimprimir
      if (e == "BtnReimprimir") {
        this.dialogReimprecion = true
        return
      }

      //Abre el boton del menu devolucion
      if (e == "BtnFacturaDevolucion") {
        this.OpenBuscarFacturaDevolucion()
        return
      }


      //Abre el boton del menu ReciboIngreso
      if (e == "BtnReciboIngreso") {
        this.OpenDialogReciboIngreso()
        return
      }

      //Abre el boton del menu RestaurarFactura
      if (e == "BtnRestaurarFactura") {
        this.dialogRestaurarFactura = true,
          this.BuscarRestaurarFacturas()
        this.RedireccionFocus("RefTextFieldBuscarResFact")

        var configPv = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.configPv))
        if (configPv.hasOwnProperty("tiempoActualizarFacturaTemporal") && configPv.tiempoActualizarFacturaTemporal != null && configPv.tiempoActualizarFacturaTemporal > 0) {
          this.ejecutarBuscarRestaurarFacturasFrecuencia()
        }

        return
      }

      //Abre el boton del menu cierre de caja
      if (e == "BtnCierreCaja") {
        var NO_DOMI_PEN = false
        if (this.$store.getters.GetConfiguracionGeneral.configPv.noDomiciliosPendiete != null) {
          NO_DOMI_PEN = this.$store.getters.GetConfiguracionGeneral.configPv.noDomiciliosPendiete
        }

        if (NO_DOMI_PEN == false) {
          this.OpenCierreCaja()
        } else {
          this.verificarPermitirDomicilio()
        }
        return
      }

      //Abre el boton del Vendedores
      if (e == "BtnVendedores") {
        this.OpenVendedores()
        return
      }

      //Abre el boton del Factura Domicilio
      if (e == "BtnFacturaDomicilio") {
        this.OpenFacturaDomicilio()
        return
      }


      //Abre el boton del AsignarMensajeros
      if (e == "BtnAsignarMensajero") {
        this.OpenDialogAsignarMensajeros()
        return
      }

      //Abre el boton del RecibirMensajeros
      if (e == "BtnRecibirMensajeros") {
        this.OpenDialogRecibirMensajeros()
        return
      }

      //Abre el boton del FacturasRutas
      if (e == "BtnFacturasRutas") {
        this.OpenDialogFacturasRutasMensajeros()
        return
      }

      //Abre el boton del FacturasRutas
      if (e == "BtnCambiarMensajeros") {
        this.OpenDialogCambiarMensajeros()
        return
      }

      //Abre el boton del menu comentario
      if (e == "BtnComentarioFactura") {
        this.OpenComentarioFactura()
        return
      }

      //Abre el boton del menu Descuento factura global
      if (e == "BtnDescuentoFacturaGlobal") {
        this.Descuentofactura.ValorPorc = false
        this.OpenDescuentoFactura()
        return
      }

      //Abre el boton del menu Descuento factura global
      if (e == "BtnDescuentoFacturaGlobalValorPorc") {
        this.OpenDescuentoFactura()
        return
      }


      //Abre el boton del menu Recargo factura global
      if (e == "BtnRecargoFacturaGlobal") {
        this.OpenRecargoFactura()
        return
      }

      //Abre el boton del menu Retenciones Gub
      if (e == "BtnRetencionesGub") {
        this.OpenRetencionFactura()
        return
      }

      //Abre el boton del menu Seguro
      if (e == "BtnSeguro") {
        this.OpenCoberturaSeguro()
        return
      }

       //Abre el boton del menu Internamientos
      if (e == "BtnInternamiento") {
       this.OpenInternamientos()
        return
      }

      //Abre el boton del menu receta
      if (e == "BtnRecetaControlada") {
        this.OpenRecProdControlado()
        return
      }

      //Abre el boton del menu Lista Receta
      if (e == "BtnListaReceta") {
        this.Recetaslist = []
        this.dialogRecetas = true
        this.CargarBusquedaRecetas()
        return
      }

      //Abre el boton del menu Vale de Caja
      if (e == "BtnCotizacion") {
        this.OpenDialogCotizacion()
        return
      }
      //Abre el boton del menu Vale de Caja
      if (e == "BtnValeCaja") {
        this.dialogValecaja = true
        this.newnewValecaja()
        return
      }


      //Abre el boton del menu Otros ingresos
      if (e == "BtnOtrosingresos") {
        this.dialogOtrosIngreso = true
        return
      }


      //Abre el boton del menu Moneda
      if (e == "BtnMoneda") {
        this.OpenMonedaFactura()
        return
      }

      //Abre el boton del menu BucarCotizacion
      if (e == "BtnBucarCotizacion") {
        this.dialogBucarCotizacion = true
        this.getCotizacionlistFactCliente()
        return
      }


      //Abre el boton del menu BucarConduce
      if (e == "BtnBucarConduce") {
        var BOOL_CONDUCE_MULTIPLE=this.$store.getters.GetConfiguracionGeneral.configPv.conduceMultiple
        if(BOOL_CONDUCE_MULTIPLE!=null && BOOL_CONDUCE_MULTIPLE==true){
            this.dialogBucarConduceMultiple=true
        }else{
          this.dialogBucarConduce = true
        }
        
        return
      }

      //Abre el boton del menu Impresora fiscal
      if (e == "BtnImpresorafiscal") {
        this.dialogImpFiscal = true
        return
      }


      //Abre el boton del menu Cambio divisas
      if (e == "BtnCambiodivisas") {
        this.OpenDialogCambioDivisa()
        return
      }


      //Abre el boton del menu medico
      if (e == "BtnMedico") {
        this.OpenMedico()
        return
      }


      //Abre el boton del menu DatosVuelo
      if (e == "BtnDatosVuelo") {
        this.dialogDatosVuelo = true
        return
      }


      //Abre el boton del menu DatosPagareFactura
      if (e == "BtnDatosPagareFactura") {
        this.OpenDialogModalPagare()
        //this.OpenDialogDatosPagareFactura()
        return
      }


      //Abre el boton del menu anular factura
      if (e == "BtnAnularFactura") {
        this.OpenBuscarFacturaAnular()
        return
      }


      //Abre el boton Comprobantes
      if (e == "BtnComprobantes") {
        this.ComprobanteFisc = {
          comprobante: JSON.parse(JSON.stringify(this.Facturasventa.tipocomprobante)),
          nombre: JSON.parse(JSON.stringify(this.Facturasventa.nombreDgii)),
          telefono: JSON.parse(JSON.stringify(this.Facturasventa.telefononcf)),
          direccion: JSON.parse(JSON.stringify(this.Facturasventa.direccionncf)),
          cedrnc: JSON.parse(JSON.stringify(this.Facturasventa.cedularncncf)),
        },


          this.dialogComprobante = true
        return
      }

//Abre el boton del menu anular factura
      if (e == "BtnFarmVigilancia") {
        this.openFarmacoVigilancia()

        return
      }


      //Abre el boton del menu anular factura
      if (e == "BtnPendientesEntrega") {
        this.openPendientesEntrega()
        return
      }


      //Abre el boton del menu Impresora fiscal
      if (e == "BtnClientePreferencial") {
        this.dialogClientePreferencial = true
        return
      }


      //Registrar Clientes Preferencial
      if (e == "AccBtnRegistrarClientesPreferencial") {
        var _this = this
        setTimeout(function() {
          _this.openCrearModificarCliente()
        }, 500)
        return
      }


      //Registrar Clientes Preferencial
      if (e == "AccBtnConsultaClientesPreferencial") {
        var _this = this
        setTimeout(function() {
          _this.openConsultaConsumoCliente()
        }, 500)
        return
      }


    },

    permisolimpiarPuntoVentaCompleto(){
      if (this.EjecutarPermisoPv == false) {
          this.funcionValidaPermisoPv("AccPermitirLimpiarPantalla")
          return
        }
    },

    // Limpiando el formulario completo.
    limpiarPuntoVentaCompleto() {
      this.limpiarCacheProductoFactura()
      // this.devuelta = 0;
      if (this.deleteFacturaTemporal != null) {
        this.updateFactTemEnUso(this.deleteFacturaTemporal)
      }
      this.bloqueoTemp=false
      this.codUsuAutorDev=this.$store.getters.GetdatosInfUsu.usuario.codigo
      this.disabledTextFieldProducto = false
      this.dialogNotifQuitarDescuentoCliente = false
      var DEVUELTA = JSON.parse(JSON.stringify(this.devuelta))
      this.searchVendedorCodigo = ""
      this.activoF7 = false
      this.SelectMedicoFactura = null
      this.cotizacionAfacturaSelect = null
      this.deleteFacturaTemporal = null
      this.dialogGuardartemporal = false
      this.nombreFactTem = ""
      this.sucursalFactTemporal = null
      this.TipoAnulacion = null
      this.ejecucion = true
      this.pvGuardandoFactura = false
      this.tipoTarjeta = null
      this.conduceSelect = null
      this.objTempaplicarDescuentoGlobalFacturaXencimaMaximo = null
      this.NewclienteSeleccionado()
      this.NewNewRetencionFactura()
      this.cedularequired = false
      this.objTemp = null
      this.ejecucionValecaja=true
      this.clienteSeleccionado = {
        codigo: 0,
        nombre: null,
        cedrnc: "",
        ciudad: null,
        direccion: null,
        telefono: "",
        sector: "",
        tipocomprobante: null,
        email: "",
        sexo: "",
        dondetrabaja: "",
        diascredito: 0,
        fechanacimiento: null,
        carnet: "",
        ars: null,
        contrato: "",
        nss: "",
        planlan: 0,
        pasaporte: "",
        zonaRuta: null,
        ordenVisita: 0,
        diaVisita: null,
        balancePuntos: 0,
        codigoBarraPreferencial: null,
      }

      this.Totales = {
        ReciboIngreso: {
          abono: 0,
          retencion: 0,
          descuento: 0,
          isr: 0,
        },
        totalGeneral: {
          subtotal: 0,
          itbis: 0,
          total: 0,
          descuento: 0,
          Retencion: 0,
          recargo: 0,
          cobertura: 0,
          valorLey: 0,
        },
        CierresCajas: {
          totalTotal: 0,
          totalDenomiacionvalor: 0,
        },
      }
      this.cancelarInfProducto()
      this.productoSeleccionado = {
        cantidad: 1,
        precio: 0,
        descuento: 0,
        descuentoKeys: 0,
        vendedor: null,
        recargo: 0,
        ValorPorcRecarg: false,
        cobertura: 0,
        productos: null,
        valor: 0,
        ValorPorc: false,
        cobValorPorc:false
      }
      this.RallProducto = []
      this.RProductoCompra = []
      this.RProductoCompraTemp = []
      this.RProductoCompraOfercta = []
      this.selectedListProdxLote = []
      this.ListDenomMoneda = []
      this.formaPago = {
        efectivo: 0,
      }
      this.clienteFactura = null
      this.clienteTempCredito = null
      this.dialogSelectClienteTempCredito = false
      this.filtroTipoCliente = 3
      this.busquedaCliente = null
      this.DatosPagareFactura = null
      this.Facturasventa = {
        facturasventaPK: { secuencia: 0, documento: 0 },
        empresa: 1,
        fecha: new Date(),
        referencia: "",
        diascredito: 0,
        ncf: "",
        valor: 0.0,
        tasa: 1,
        comentario: "",
        valordescuencto: 0.0,
        valorimpuesto: 0.0,
        pendiente: 0.0,
        activada: true,
        efectivo: 0.0,
        tarjeta: 0.0,
        cheques: 0.0,
        cxc: 0.0,
        puntos: 0.0,
        valorbonogas:0.0,
        valorasignacion:0.0,
        valorPruebaMetro:0.0,
        valorConduce: 0.0,
        cupones: 0.0,
        gaspremium: 0.0,
        valordonacion: 0.0,
        valorcomision: 0.0,
        valorotros: 0.0,
        valorTraspaso: 0.0,
        cedularncncf: "",
        direccionncf: "",
        telefononcf: "",
        codigocupon: "",
        numeroCheque: "",
        nombreDgii: "",
        documentoFactura: null,
        umerocierre: 0,
        autorizacion: null,
        cobertura: null,
        medico: null,
        exequartur: null,
        diagnostico: null,
        especialidad: null,
        enviada: false,
        glosada: false,
        coberturaPendiente: null,
        arsCobrarEmpleado: false,
        arsIncobrable: false,
        arsComentario: null,
        usuario: "",
        usuarioCobro: "",
        fechaImpresion: null,
        nif: null,
        horaImpresion: null,
        receta: null,
        valorRecargo: 0,
        descGloblal: true,
        recgGlobal: false,
        numtar: null,
        valorNc: 0.0,
        codigoNc: null,
        secuenciaNc: null,
        retencion: 0.0,
        sumado: false,
        ncfVencimiento: null,
        medicoCodigo: null,
        totalIsr: 0.0,
        totalOtroImpuesto: 0,
        motivoAnular: null,
        facturaManual: false,
        descripcion: "",
        numeroOrden: null,
        lineaAerea: null,
        numeroVuelo: null,
        rutaSalidaE: null,
        rutaSalidaD: null,
        rutaRetornoE: null,
        rutaRetornoD: null,
        turno: null,
        borrado: false,
        fechaIngreso: null,
        fechaSalida: null,
        tipoAsistencia: null,
        numeroHabitacion: null,
        facturaRecurrente: false,
        configuracionDocumentoRecurrente: 0,
        detalleJson: "",
        generadaDesdeEnviosPaquetes: false,
        generadaDesdeBoleteria: false,
        conduceSecuencia: null,
        conduceDocumento: null,
        shipto: null,
        incoterms: null,
        pagare: null,
        pagareValor: null,
        usuariosAnulacion: null,
        fechaAnulacion: null,
        usuariosEditar: null,
        fechaEdicion: null,
        bancoCheque: null,
        ars: null,
        caja: null,
        cliente: null,
        clinica: null,
        impuesto: null,
        moneda: null,
        sucursal: null,
        tipoTarjeta: null,
        tipocomprobante: null,
        vendedor: null,
        contabilidad: null,
        transferencia: 0.0,
        domicilio: null,
        facturasventaDetalleList: [],
        datoTarjeta: null,
        infAdicionales:null,
        registroInternamiento:null
      }
      this.newnewCotizacion()
      this.dialogDevolucion = false
      this.cancelarAceptarDevolucion()
      this.DevolucionFacturaSeleccionada.secuencia = 0
      this.DevolucionFacturaSeleccionada.devtarjeta = false

      this.Monedafactura = this.configuraciones.config.monedabase
      this.UpdateConfigMoneda()
      this.SalvarMonedaFactura()
      this.NewAnulacionFacturaSeleccionada()
      this.devueltaRecIngreso = 0.0
      this.ReciboIngresoFactura = {
        efectivo: 0,
        tarjeta: 0,
        cheque: 0,
        transferencia: 0,
        numeroCheque: null,
        bancoCheque: null,
        tipoTarjeta: null,
        numtar: null,
      }

      this.ReciboIngreso = {
        precio: 0,
        abono: 0,
        retencion: 0,
        descuento: 0,
        isr: 0,
        DescValorPorc: false,
        retenValorPorc: true,
        isrValorPorc: true,
      }


      this.Descuentofactura = {
        ValorPorc: true,
        descuento: 0,
        DescuentoFacturaGlobal: false,
      }


      this.PanelFormaPagoNotaCredito = false
      this.PanelMenuOpcionBotones = true
      this.selectedListFPagoNC = []
      this.ListFormaPagoNC = []
      this.ListProductoSustitutos = []
      this.activaConduceCredito = false
      this.DatosPagareFactura = null

      this.NewRecetaProdCOntrolado()
      this.filtroFacturaRutaCliente = ""
      this.filtroAsigMensajero = {
        fact: "",
        sector: "",
        caja: null,
      },
        this.boolRuleprodprecio = false
      this.contFactExcedeLimitCredito = false
      this.contFactDescLimitTarjeta=false
      this.nuevoFarmacoVigilancia()
      this.NewplanBeneficio()
      this.loading(false)
      this.selecteTemRecCont = null
        this.newnewInternamientos()
        this.comboDiagnostico=null
      var _this = this
      setTimeout(function() {
        _this.devuelta = JSON.parse(JSON.stringify(DEVUELTA))
        _this.verificarVendedor()
      }, 2000)

      this.bancoCheque = null
      this.selectFactTem = null
      this.ejecutarEliminarProd = true

      this.dialogRecProCantidadControlada=false
        this.turnoEstacionInterval()
       this.selectedListConduceMultiple=[]
       this.ListConduceMultiple=[]
    },
    // Cargar los datos de la base de datos y almacenarlos en el almacenamiento local dotos.
    async loadPv() {

      var User = ""
      if (this.$store.getters.GetdatosInfUsu.usuario.nombre == null) {
        User = this.$store.getters.GetdatosInfUsu.usuario.username
      } else {
        User = this.$store.getters.GetdatosInfUsu.usuario.nombre
      }
      this.OtrasConfigPv = {
        caja: null,
        terminal: null,
        impresora: null,
        turno: null,
        cajero: User,
        moneda: null,
      }
      if (!localStorage.caja) {
        this.dialogConfigPv = true
      } else {
        var d = JSON.parse(localStorage.caja)
        await this.$axios
          .get(
            this.$hostname + this.$hName + "/cajas/findbycodigo/" + d.codigo,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            this.RestaurarFacturaBusqueda.sucursal = res.data.sucursal
            this.sucursalFactTemporal = res.data.sucursal
            this.caja = res.data
            localStorage.setItem("caja", JSON.stringify(res.data))
            var _this = this
            setTimeout(function() {
              _this.verificarVendedor()
            }, 300)
          })
          .catch((error) => {
            this.dialogConfigPv = true
            console.error(error)
          })
      }
      await this.$axios
        .get(this.$hostname + this.$hName + "/configuraciones/find", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          this.configuraciones = res.data
          //this.$store.commit('MutationaddConfiguracionGeneral',res.data);
        })
        .catch((error) => console.error(error))
      //this.configuraciones =this.$store.getters.GetConfiguracionGeneral;
      // console.log(!localStorage.hasOwnProperty("printerSelect"))
      // console.log(!this.OtrasConfigPv.hasOwnProperty("impresora"))

      //!localStorage.printerSelect
      if (
        !localStorage.hasOwnProperty("printerSelect") ||
        !this.OtrasConfigPv.hasOwnProperty("impresora")
      ) {
        this.OtrasConfigPv.impresora = null
      } else {
        this.OtrasConfigPv.impresora = JSON.parse(localStorage.printerSelect)
      }
      this.Monedafactura = this.configuraciones.config.monedabase

      this.InfomCaja()
      this.findCierreActual()
      this.findAllTerminal()
    },
    close() {
    },

    limpiarCacheProductoFactura() {
      ++this.ultimaBusquedaProductoEnter
      ++this.ultimaBusquedaProductoFluida
      clearTimeout(this.timeoutBuscarProductoEnter)
      clearTimeout(this.timeoutBuscarProductoFluida)
      this.busquedaProductoEnCurso = {}
      this.precargaProductoEnCurso = {}
      this.cacheDescuentoProducto = {}
      this.cacheListaPrecioProducto = {}
      this.cacheUnidadProducto = {}
      this.cacheOfertaProducto = {}
      this.cacheBusquedaProducto = {}
    },

    NewplanBeneficio() {
      this.planBeneficio = {
        dialogNotifPlanBeneficio: false,
        planBeneficio: false,
        objtem: null,
      }
    },


    enviarImprimirFactura(FACT_FACT) {
      var FACT = JSON.parse(JSON.stringify(FACT_FACT))
      FACT.fecha = FACT_FACT.nuevaFecha
      var _this = this
      setTimeout(function() {
        _this.alerta("Datos salvado correctamente !!!", "bien")
        if (localStorage.printerSelect != null) {
        }
        var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
        var impresora = null
        if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
          impresora = JSON.parse(localStorage.printerSelect).nombre
        }
        var msg = {
          accion: "print",
          formato: _this.caja.formatoimpresioncontado.trim(),
          impresora: impresora,
          data: _this.configuraciones,
          fac: FACT,
          caja: _this.caja,
        }
        _this.imprimir(msg, "factura")

      }, 100)
    },


    urlImpresoraLocal(path) {
      return ["http://localhost:15999" + path, "http://127.0.0.1:15999" + path]
    },

    async getImpresoraLocal(path) {
      var urls = this.urlImpresoraLocal(path)
      var ultimoError = null
      for (const url of urls) {
        try {
          //, { timeout: 5000 }
          return await this.$axios.get(url)
        } catch (error) {
          ultimoError = error
        }
      }
      throw ultimoError
    },

    async postImpresoraLocal(path, datos) {
      var urls = this.urlImpresoraLocal(path)
      var ultimoError = null
      for (const url of urls) {
        try {
        //, { timeout: 10000 }
          return await this.$axios.post(url, datos)
        } catch (error) {
          ultimoError = error
        }
      }
      throw ultimoError
    },

    manejarErrorImpresoraLocal(error) {
      console.error(error)
      this.alerta("No fue posible conectar con la aplicacion de impresora local. Verifique que ImpresoraWeb este abierta en esta PC.", "error")
    },

    // Envío de una solicitud POST al servidor con los datos a imprimir.
    imprimir(datos, operacion) {

      datos.operacion = operacion
      datos.schema = this.$store.getters.GetheadersAxios["X-TENANT-ID"]
      if (datos.formato.trim() === "rolloBlue") {
        if (datos.operacion.trim() === "factura") {
          var FACT = datos.fac.hasOwnProperty("factura") ? datos.fac.factura.factura : datos.fac
          var _this = this
          setTimeout(function() {
            _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(FACT)
            // _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(datos.fac.factura.factura)
          }, 800)

        }

      } else {
        if (datos.impresora == null) {
          this.alerta(" seleccione la impresora", "error")
          return
        }

        if (datos.formato === "fiscale") {
          this.getImpresoraLocal("/impresora/imprimir/validad").then(res => {
            if (res.data.LastError === 0) {
              this.postImpresoraLocal("/impresora/imprimir", datos)
                .then((res) => {
                  this.limpiarPuntoVentaCompleto()
                })
                .catch((error) => {
                  this.manejarErrorImpresoraLocal(error)
                })
            } else {
              console.log("#1-Error-fiscale-->", res.data)
              console.log("#2-Error-fiscale-->", res.data.LastError)

              //this.cancelarUltimoDocumento();

              //this.alerta("La impresora esta desconectada o esta apagada!!!","error")
              return
            }
          })
            .catch((error) => {
              this.manejarErrorImpresoraLocal(error)
            })
        } else {
          this.postImpresoraLocal("/impresora/imprimir", datos)
            .then((res) => {
              this.limpiarPuntoVentaCompleto()
            })
            .catch((error) => {
              this.manejarErrorImpresoraLocal(error)
            })
        }

      }


    },
    imprimir2(datos, operacion, callback) {
      datos.schema = this.$store.getters.GetheadersAxios["X-TENANT-ID"]
      if (datos.impresora == null) {
        this.alerta(" seleccione la impresora", "error")
        return
      }
      datos.operacion = operacion
      if (datos.formato === "fiscale") {
        this.getImpresoraLocal("/impresora/imprimir/validad").then(res => {
          if (res.data.LastError === 0) {
            this.postImpresoraLocal("/impresora/imprimir", datos)
              .then((res) => {
                this.limpiarPuntoVentaCompleto()

                callback(datos.fac)
              })
            .catch((error) => {
              this.manejarErrorImpresoraLocal(error)
            })
          } else {
            this.alerta("La impresora esta desconectada o esta apagada!!!", "error")
            return
          }
        })
          .catch((error) => {
            this.manejarErrorImpresoraLocal(error)
          })
      } else {
        this.postImpresoraLocal("/impresora/imprimir", datos)
          .then((res) => {
            callback(datos.fac)
            this.limpiarPuntoVentaCompleto()
          })
          .catch((error) => {
            this.manejarErrorImpresoraLocal(error)
          })
      }
    },


    imprimirVigilancia(datos, operacion) {
      datos.schema = this.$store.getters.GetheadersAxios["X-TENANT-ID"]
      datos.operacion = operacion
      if (datos.formato.trim() === "rolloBlue") {
        if (datos.operacion.trim() === "factura") {
          var FACT = datos.fac.hasOwnProperty("factura") ? datos.fac.factura.factura : datos.fac
          var _this = this
          setTimeout(function() {
            _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(FACT)
            // _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(datos.fac.factura.factura)
          }, 800)

        }

      } else {
        if (datos.impresora == null) {
          this.alerta(" seleccione la impresora", "error")
          return
        }

        if (datos.formato === "fiscale") {
          this.getImpresoraLocal("/impresora/imprimir/validad").then(res => {
            if (res.data.LastError === 0) {
              this.postImpresoraLocal("/impresora/imprimir", datos)
                .then((res) => {
                  this.cancelarFarmacoVigilancia()
                })
                .catch((error) => {
                  this.manejarErrorImpresoraLocal(error)
                })
            } else {
              this.alerta("La impresora esta desconectada o esta apagada!!!", "error")
              return
            }
          })
            .catch((error) => {
              this.manejarErrorImpresoraLocal(error)
            })
        } else {
          this.postImpresoraLocal("/impresora/imprimir", datos)
            .then((res) => {
              this.cancelarFarmacoVigilancia()
            })
            .catch((error) => {
              this.manejarErrorImpresoraLocal(error)
            })
        }

      }


    },

    calculostotales() {
      if (this.Facturasventa.efectivo > 0) {
      }
      if (this.Facturasventa.cxc > 0) {
      }
      this.calcularDevuelta()
    },
    ConfDefoul() {
      this.dialogRestaurarFactura = false
      this.dialogCrearEditarCliente = false
      this.NewclienteSeleccionado()
      if (this.PanelMenuOpcionVendedor == true) {
        this.cancelarVendedores()
      }
      if (this.PanelMenuOpcionDescuentoFactura == true) {
        this.cancelarDescuentoFactura()
      }

    },
    imprimirCierreZ() {
      if (localStorage.printerSelect != null) {
      }
      var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
      var impresora = null
      if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
        impresora = JSON.parse(localStorage.printerSelect).nombre
      }
      var msg = {
        accion: "cierrez",
        formato: this.caja.formatoimpresioncontado.trim(),
        impresora: impresora,
        data: this.configuraciones,
        caja: this.caja,
        cajero: this.$store.getters.GetOtrasConfigPv.cajero,
      }
      this.imprimir(msg, "reporteFiscal")

    },
    imprimirReporteX() {
      if (localStorage.printerSelect != null) {
      }
      var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
      var impresora = null
      if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
        impresora = JSON.parse(localStorage.printerSelect).nombre
      }
      var msg = {
        accion: "cierrex",
        formato: this.caja.formatoimpresioncontado.trim(),
        impresora: impresora,
        data: this.configuraciones,
        caja: this.caja,
        cajero: this.$store.getters.GetOtrasConfigPv.cajero,
      }
      this.imprimir(msg, "reporteFiscal")

    },
    abrirLVentas() {
      if (localStorage.printerSelect != null) {
      }
      var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
      var impresora = null
      if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
        impresora = JSON.parse(localStorage.printerSelect).nombre
      }

      var msg = {
        accion: "lventa",
        formato: this.caja.formatoimpresioncontado.trim(),
        impresora: impresora,
        data: this.configuraciones,
        caja: this.caja,
        cajero: this.$store.getters.GetOtrasConfigPv.cajero,
      }
      this.imprimir(msg, "reporteFiscal")

    },
    imprimirUltimoDocumento() {
      if (localStorage.printerSelect != null) {
      }
      var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
      var impresora = null
      if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
        impresora = JSON.parse(localStorage.printerSelect).nombre
      }

      var msg = {
        accion: "ultimodocumento",
        formato: this.caja.formatoimpresioncontado.trim(),
        impresora: impresora,
        data: this.configuraciones,
        caja: this.caja,
        cajero: this.$store.getters.GetOtrasConfigPv.cajero,
      }
      this.imprimir(msg, "reporteFiscal")

    },
    cancelarUltimoDocumento() {
      if (localStorage.printerSelect != null) {
      }
      var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
      var impresora = null
      if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
        impresora = JSON.parse(localStorage.printerSelect).nombre
      }
      var msg = {
        accion: "anularultimo",
        formato: this.caja.formatoimpresioncontado.trim(),
        impresora: impresora,
        data: this.configuraciones,
        caja: this.caja,
        cajero: this.$store.getters.GetOtrasConfigPv.cajero,
      }
      this.imprimir(msg, "reporteFiscal")

    },
    onkeydownCode(ee) {
      // ee.Handled = true;
      var _this = this
      if (ee.keyCode >= 112 && ee.keyCode <= 123) {
        ee.preventDefault()
        this.ConfDefoul()
      }

      if (ee.keyCode >= 33 && ee.keyCode <= 36 || ee.keyCode == 45 || ee.keyCode == 46) {
        ee.preventDefault()
        this.ConfDefoul()
      }


      //key:"F2":113 :Abrir caja registradora
      if (ee.keyCode == 113) {
        if (this.EjecutarPermisoPv == false) {
          this.funcionValidaPermisoPv("AccAbrirCajaRegistradoraF2")
          return
        }
        //  this.openCashDrawer()
        return
      }

      //key:"F3":114: Guardar Factura Temporal
      if (ee.keyCode == 114) {
        this.OpenDialogGuardartemporal()
        return
      }


      //key:"F4":115
      if (ee.keyCode == 115) {
        /* this.dialogRestaurarFactura = true
        this.BuscarRestaurarFacturas()
        return;*/
        /* this.dialogRestaurarFactura = true,
        this.BuscarRestaurarFacturas()
var configPv = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.configPv))
if( configPv.hasOwnProperty('tiempoActualizarFacturaTemporal')&& configPv.tiempoActualizarFacturaTemporal!=null && configPv.tiempoActualizarFacturaTemporal>0){
  this.ejecutarBuscarRestaurarFacturasFrecuencia()
      }*/
        this.$refs.RefPvMenuOpcionBotones.ClickAccion("BtnRestaurarFactura")

        return

      }

      //key:"F5":116
      if (ee.keyCode == 116) {

        if (this.deleteFacturaTemporal != null) {
          this.updateFactTemEnUso(this.deleteFacturaTemporal)
        }
        if (this.EjecutarPermisoPv == false) {
          this.funcionValidaPermisoPv("AccPermitirLimpiarPantalla")
          return
        }
        // this.limpiarPuntoVentaCompleto()

      }

//key:"F6":117
      if (ee.keyCode == 117) {
        //ee.preventDefault()
       // console.log('F6--->',ee)
      }

      //key:"F7":118
      if (ee.keyCode == 118) {

this.funcionValidaPermisoPv("AccCambiarVendedorF7")

      // para permiso vendedor
       /* this.activoF7 = true
        var _this = this
        setTimeout(function() {
          _this.$refs.RefTextFieldBuscaVendedorCodigo.focus()
        }, 500)
        */

        /* this.OpenVendedores()
        setTimeout(function () {
          _this.$refs.RefTextFieldBuscaVendedor.focus();
        }, 500); */
        return
      }
      //key:"F8":119
      if (ee.keyCode == 119) {
        /*this.OpenDialogCrearEditarCliente()
        this.filtroTipoCliente = 3*/
        this.$refs.RefPvMenuOpcionBotones.ClickAccion("BtnClientes")
        setTimeout(function() {
          _this.$refs.RefTextFieldBuscaCliente.focus()
        }, 500)

        return
      }

      //key:"F9":120 //key:"F10":120
      if (ee.keyCode == 120 || ee.keyCode == 121) {
        //pporciento
        // this.OpenDescuentoFactura()
        this.$refs.RefPvMenuOpcionBotones.ClickAccion("BtnDescuentoFacturaGlobalValorPorc")
        setTimeout(function() {
          _this.Descuentofactura.descuento = 0
          if (ee.keyCode == 120) {
            _this.Descuentofactura.ValorPorc = false
          }
          if (ee.keyCode == 121) {
            _this.Descuentofactura.ValorPorc = true
          }

          // _this.$refs.RefTextFieldDescuentoFactura.focus();
        }, 500)


        var _this = this
        setTimeout(function() {
          _this.$refs.RefTextFieldDescuentoFactura.focus()
        }, 1000)


        return
      }


      //key:"END":35
      if (ee.keyCode == 35) {
        var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
        var MONEDAFACTURATASA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)
        var SumaTotal = this.RedondeoBasico((this.Facturasventa.efectivo + this.Facturasventa.tarjeta + this.Facturasventa.transferencia + this.Facturasventa.cheques + this.Facturasventa.cxc
        + this.Facturasventa.cupones + this.Facturasventa.puntos + this.Facturasventa.valorConduce + this.Facturasventa.valorNc + this.Facturasventa.valorbonogas +this.Facturasventa.valorasignacion 
        +this.Facturasventa.valorPruebaMetro+this.Facturasventa.valorTraspaso+this.Facturasventa.valordonacion) * MONEDAFACTURATASA)

        if (SumaTotal > 0) {
          this.realizarCobro()
          return
        }

       /* if (this.devuelta >= 0) {
          this.realizarCobro()
          return
        }*/

        if (this.SoloCxc == true) {
          this.$refs.RefTextFieldForPagoCxc.focus()
        } else {
          this.$refs.RefTextFieldForPagoEfectivo.focus()
        }

        // this.realizarCobro()
        return
      }


      //key:"Backquote":192
      if (ee.keyCode == 192) {
        ee.preventDefault()
       // this.FocusInputProductoBusqueda()
        return
      }


      // OpenDialogCrearEditarCliente(), filtroTipoCliente = 3
      //key:"F1"/112
      //this.openCrearPoducto()
      //pauseSound();

    },

    //
    handleBeforeUnload(e) {
      if (this.deleteFacturaTemporal != null) {
        localStorage.setItem("dataFactTemporal", JSON.stringify(this.deleteFacturaTemporal))
        this.updateFactTemEnUso(this.deleteFacturaTemporal)
      }

      /*var _this = this;
        setTimeout(function () { }, 5000);
 // Esta lógica se ejecuta antes de recargar o salir
      const mensaje = '¿Estás seguro de que deseas salir o recargar la página?';
      e.preventDefault();       // Necesario para algunos navegadores
      e.returnValue = mensaje;  // Estándar
      return mensaje;  */


      // Para compatibilidad
    },

    FocusInputProductoBusqueda() {
      var _this = this
      //Crear Producto
      if (this.dialogCrearProduct == true) {
        this.cancelarCrearProducto()
      }
      //Crear / Editar Cliente
      if (this.dialogCrearEditarCliente == true) {
        this.dialogCrearEditarCliente = false
        this.NewclienteSeleccionado()
      }

      //Reimpresión
      if (this.dialogReimprecion == true) {
        this.ListReimprecion = []
        this.NewReimprecionFacturaSeleccionada()
        this.BtnReimprecionvalue = 1
        this.dialogReimprecion = false
      }

      // Devolucion
      if (this.dialogDevolucion == true) {
        this.cancelarAceptarDevolucion()
        this.NewDevolucionFacturaSeleccionada()
        this.dialogDevolucion = false
      }

      //Recibo de ingreso
      if (this.dialogReciboIngreso == true) {
        this.dialogReciboIngreso = false
        this.NewclienteSeleccionado()
      }

      // Restaurar Factura
      if (this.dialogRestaurarFactura == true) {
        this.dialogRestaurarFactura = false
      }

      //Cierre de Cajas
      if (this.dialogCierreCaja == true) {
        this.cancelarCierreCaja()
      }

      //Seleccionar y Ver Mensajero
      if (this.dialogMensajero == true) {
        this.VerFacturaDomicilioMensajero = false
        this.FacturaDomicilioMensajero = null
        this.dialogMensajero = false
        this.dialogRecibirMensajeros = false
        this.dialogAsignarMensajeros = false
        this.dialogFacturasRutasMensajeros = false
        this.dialogCambiarMensajeros = false

        this.NewMensagero()
      }

      // Cobertura de seguro
      if (this.dialogCoberturaSeguro == true) {
        this.cancelarCoberturaSeguro()
      }

      //Recetas
      if (this.dialogRecetas == true) {
        this.dialogRecetas = false
      }

      //Receta de producto controlado
      if (this.dialogProdControlado == true) {
        this.CancelarRecetaControlada()

      }

      //Cotización
      if (this.dialogCotizacion == true) {
        this.cancelarCotizacion()
      }

      //Vale de caja
      if (this.dialogValecaja == true) {
        this.cancelarValecaja()
      }

      // Recibos de Otros Ingresos
      if (this.dialogOtrosIngreso == true) {
        this.cancelarOtrosIngreso()
      }
      // ver Cotización
      if (this.dialogBucarCotizacion == true) {
        this.dialogBucarCotizacion = false
        this.NewBucarCotizacion()
      }

      // ver Conduce
      if (this.dialogBucarConduce) {
        this.dialogBucarConduce = false
        this.NewBucarConduce()
      }
      
 // ver Conduce
      if (this.dialogBucarConduceMultiple) {
        this.dialogBucarConduceMultiple = false
        this.NewBucarConduceMultiple()
      }
      // ver Conduce
      

      //Impresora Fiscal
      if (this.dialogImpFiscal == true) {
        this.cancelarImpresoraFiscal()
      }
      //Impresora Fiscal
      if (this.dialogClientePreferencial == true) {
        this.dialogClientePreferencial = false
      }

      //Cambio Divisa
      if (this.dialogCambioDivisa == true) {
        this.dialogCambioDivisa = false
        this.NewNewCambioDivisa()
      }

      //Anulación de factura
      if (this.dialogAnulacion == true) {
        this.NewAnulacionFacturaSeleccionada()
      }

      setTimeout(function() {
        _this.$refs.RefTextFieldProducto.focus()
      }, 500)


    },


    onResize() {
      //divSelecProd
      var jsn = { width: window.innerWidth, height: window.innerHeight - 112 }
      this.windowSize = jsn
      //this.windowSize=e
    },
    AddInfProd() {
    },
    VerInfProd() {
    },

    // Un método que se llama en el vue html.
    classObjProdSelect(e) {
      //class="RowSelectColorPv" class="white--text"

      if (this.selected == null) {
        return ""
      }

      if (this.selected != null) {
        if (e.indx == this.selected.indx) {
          return "RowSelectColorPv white--text "
        } else {
          return ""
        }
      }
      return ""
    },


    // Un método que se llama en el vue html.
    classObjProdSelectFabricanteProveedor(e) {
      //class="RowSelectColorPv" class="white--text"

      if (this.selected == null) {
        return "green--text"
      }

      if (this.selected != null) {
        if (e.indx == this.selected.indx) {
          return "white--text"
        } else {
          return "green--text"
        }
      }
      return ""
    },

    classObjProdSelectAlmacenAdicional(e) {
      //class="RowSelectColorPv" class="white--text"

      if (this.selected == null) {
        return "indigo--text"
      }

      if (this.selected != null) {
        if (e.indx == this.selected.indx) {
          return "white--text"
        } else {
          return "indigo--text"
        }
      }
      return ""
    },


    classObjProdSelectReferencia(e) {
      //class="RowSelectColorPv" class="white--text"
      if (this.selected == null) {
        return "deep-orange--text"
      }

      if (this.selected != null) {
        if (e.indx == this.selected.indx) {
          return "white--text"
        } else {
          return "deep-orange--text"
        }
      }
      return ""
    },

     classObjProdSelectDescontinuado(e) {
      //class="RowSelectColorPv" class="white--text"
      if (this.selected == null) {
        return "red--text"
      }

      if (this.selected != null) {
        if (e.indx == this.selected.indx) {
          return "white--text"
        } else {
          return "red--text"
        }
      }
      return ""
    },


    VerInfom() {
      // var elemento = document.getElementById("scroll-target");
      // document.getElementById('scroll-target').scrollTop += 20;
      //   var elem = document.getElementById('para');
      //  elem.style.color = newColor;
      // function move_up() {
      //   document.getElementById('divElem').scrollTop += 10;
      // }
      // function move_down() {
      //   document.getElementById('divElem').scrollTop -= 10;
      // }
    },

    obtenerDatoSelect(e) {
      this.datostabla(e.item)
    },
    permisosPV() {
    },

    // Validando el formulario y luego se está comprobando si el producto es válido o no.
    ValidarProductoOpcionVer(e) {
      if (this.$refs.formCampProdc.validate()) {
        var Config = this.$store.getters.GetConfiguracionGeneral

        /*
        NOTA: COMENTADO POR REGLA NUEVA EN MODULO USUARIO / OPC (PRODUCTO)
        permitir vender por debajo del precio actual
        if (Config.configPv.noBajaPrecio == true) {
          if (this.RedondeoValor(e.precio) < this.RedondeoValor(e.precioOrig)) {
            this.productoSeleccionado.precio = JSON.parse(JSON.stringify(e.precioOrig))
            this.productoSeleccionado.precioDig = JSON.parse(JSON.stringify(e.precioOrig))
            this.alerta("Este producto no se permite vender por debajo del precio actual", "error");
            return;
          }

        }*/

        if (Config.configPv.hasOwnProperty("bajaPrecioDescuentoMaxProducto") && Config.configPv.bajaPrecioDescuentoMaxProducto == true) {
          if (this.productoSeleccionado.productos.hasOwnProperty("descuento") && this.productoSeleccionado.productos.descuento != null && this.productoSeleccionado.productos.descuento > 0) {
            var precDescMax = (this.productoSeleccionado.precioOrig - ((this.productoSeleccionado.precioOrig * this.productoSeleccionado.productos.descuento) / 100))
            if (this.productoSeleccionado.precio < precDescMax) {
              this.alerta(`Precio minimo del producto es $.${this.currencyFormatter2(this.getTasaMonedaSelect(precDescMax))} `, "warning")
              this.productoSeleccionado.precio = JSON.parse(JSON.stringify(precDescMax))
              this.productoSeleccionado.precioDig = JSON.parse(JSON.stringify(precDescMax))
            } else {
              this.productoSeleccionado.precioDig = JSON.parse(JSON.stringify(e.precio))
            }
          }

        } else {

          if (Config.configPv.venderalcosto == false) {
            if (this.RedondeoValor(e.precio) < this.RedondeoValor(e.costo)) {
              this.productoSeleccionado.precio = JSON.parse(JSON.stringify(e.costo))
              this.productoSeleccionado.precioDig = JSON.parse(JSON.stringify(e.costo))
              this.alerta("Este producto no se permite vender por debajo del costo actual", "error")
              return
            }
          }

        }

        
        this.productoSeleccionado.precioDig = JSON.parse(JSON.stringify(this.productoSeleccionado.precio))
        e.precioDig = JSON.parse(JSON.stringify(this.productoSeleccionado.precioDig))

    
        if (this.configuraciones.configInv.permitirNegativos == false) {
        var ObjProRow =[]
        var UsarLote = this.$store.getters.GetConfiguracionGeneral.configInv.usarLote
        if(UsarLote==true){
                var sumaCantidad= this.RProductoCompra.filter( (ee) => ee.productos.codigo == e.productos.codigo &&
                  ee.unidades.codigo == e.unidades.codigo && ee.lote==e.lote && ee.paramOfert == false).reduce((total, item) => total + item.cantidad, 0)+e.cantidad;

                var sumaExitLote= this.selectedListProdxLote.filter( (ee) => ee.lote==e.lote).reduce((total, item) => total + item.balance, 0);

                          // if (e.productos.servicio == false && sumaCantidad > e.existencias) {
                           if (e.productos.servicio == false && sumaCantidad > sumaExitLote) {
                          this.searchProducto = ""
                            this.alerta("la cantidad que intenta vender, es mayor a la existencia", "error")
                            return
                          }

                }else{
                  //       ObjProRow = this.RProductoCompra.filter( (ee) => ee.productos.codigo == e.productos.codigo &&
                  // ee.unidades.codigo == e.unidades.codigo && ee.paramOfert == false)   

                        if (e.productos.servicio == false && e.cantidad > e.existencias) {
                            this.searchProducto = ""
                            this.alerta("la cantidad que intenta vender, es mayor a la existencia", "error")
                            return
                          }
                      }

        }
        if (this.ProductoOpcionVer == false) {
          this.loading(true)
          if (this.EjecutarInfSaveProd == true) {
            this.EjecutarInfSaveProd = false
            this.preValidadorProducto(e)
            this.loading(false)
          }

        } else {
          this.loading(true)
          if (this.EjecutarInfSaveProd == true) {
            this.EjecutarInfSaveProd = false
            this.ProductoOpcionVer = false
            this.BtnSelectAddProducto(e)
            this.loading(false)
            this.EjecutarInfSaveProd = true
          }


        }
        
        // (this.UsarLote == true && this.productoSeleccionado.productos.servicio==false) 
        if (this.UsarLote == true && e.productos.servicio==false) {
          if (this.selectedListProdxLote[0].fechaVencimiento != null) {
            var FechSel = this.selectedListProdxLote[0].fechaVencimiento.fecha
            var ObjProRow = this.ListaProdxLote.filter((ee) => ee.fechaVencimiento.codigo != e.lote && ee.fechaVencimiento.fecha < FechSel)
            if (ObjProRow.length > 0) {
              this.alerta("Existe un lote más antigüo  que el que sea seleccionado", "error")
            }
          }
        } 
      } else {
        this.alerta("los campos en rojo son requeridos", "error")
      }

    },

    // Comprobar si el producto es válido o no.
    preValidadorProducto(e) {
      if (e.hasOwnProperty("ProductoValidado") && e.ProductoValidado == true) {
        this.SalvarInfProducto()
      } else {

        if (this.configuraciones.configInv.permitirNegativos == false) {

          var BOOL_OMITI_REGLA = false
          if (e.hasOwnProperty("omitirRegla") && e.omitirRegla == true) {
            BOOL_OMITI_REGLA = true
          }

          if (BOOL_OMITI_REGLA == false && this.productoSeleccionado.productos.servicio == false && this.productoSeleccionado.cantidad > this.productoSeleccionado.existencias) {
            this.searchProducto = ""
            this.alerta("la cantidad que intenta vender, es mayor a la existencia", "error")
            this.PanelSelectProducto = true
            return
          }
        }


        e.ProductoValidado = true
        this.SalvarInfProducto()/* */

      }


    },

    FabricanteOrProveedor() {
      var MOSTRAR_PROD = this.$store.getters.GetConfiguracionGeneral.configPv.proveedorListaProductoBusqueda
      // me quede aquii
      // var MOSTRAR_PROD=null
      var Desc = ""
      if (MOSTRAR_PROD == null || MOSTRAR_PROD == false) {
        Desc = "Fabricante: "
      } else {
        Desc = "Proveedor: "
      }
      return Desc
    },
    mostrarFabricanteProveedor(ITEM) {
      var MOSTRAR_PROD = this.$store.getters.GetConfiguracionGeneral.configPv.proveedorListaProductoBusqueda
      // Fabricante:

      var Desc = ""
      if (MOSTRAR_PROD == null || MOSTRAR_PROD == false) {
        Desc = `${ITEM.productos.fabricante.nombre.trim()}`
      } else {
        if (ITEM.productos.listaProveedor.length > 0) {
          Desc = ITEM.productos.listaProveedor[0].nombre.trim()
        } else {
          Desc = "N/A"
        }
      }
      // props.item.productos.fabricante.nombre.trim()
      return Desc
    },

    mostrarProveedor(ITEM) {
      var Desc = ""

      if (ITEM.productos.listaProveedor.length > 0) {
        Desc = ITEM.productos.listaProveedor[0].nombre.trim()
      } else {
        Desc = "N/A"
      }

      // props.item.productos.fabricante.nombre.trim()
      return Desc
    },

mostrarimpuesto(ITEM){
var IMPUESTO=""
if(ITEM.hasOwnProperty('productos')&& ITEM.productos != null && ITEM.productos.hasOwnProperty('impuesto') && ITEM.productos.impuesto!=null && ITEM.productos.impuesto.hasOwnProperty('codigo')){
IMPUESTO=`${(ITEM.productos.impuesto.descripcion+"").trim()}`
}

return IMPUESTO;

},

    descuentoProductoOffline(ObjProd) {
      var descuento = 0
      if (ObjProd != null) {
        if (ObjProd.hasOwnProperty("descuento") && ObjProd.descuento != null) {
          descuento = ObjProd.descuento
        } else if (ObjProd.hasOwnProperty("descuentoKeys") && ObjProd.descuentoKeys != null) {
          descuento = ObjProd.descuentoKeys
        } else if (ObjProd.productos != null && ObjProd.productos.hasOwnProperty("descuento") && ObjProd.productos.descuento != null) {
          descuento = ObjProd.productos.descuento
        }
      }
      return { descuento: descuento, especial: false }
    },

    // Haciendo una llamada axios al servidor para obtener el descuento del producto.
    BuscPropiedadProductoSelct(ObjProd, Destino) {

       if (this.bloqueoTemp) {
          return;
          }

           this.bloqueoTemp = true;
       if (this.$store.getters.GetConfiguracionGeneral.configPv.activarMonedaCambioRepresentacion != null && this.$store.getters.GetConfiguracionGeneral.configPv.activarMonedaCambioRepresentacion == true) {
          //console.log('Vienod-ProductoSelct-->',ObjProd)
          var MCR_TASA=this.$store.getters.GetConfiguracionGeneral.configPv.monedaCambioRepresentacion.tasa
          ObjProd.costo=(ObjProd.costo*MCR_TASA)
          ObjProd.precio=(ObjProd.precio*MCR_TASA)

       }

        
      if (Destino == "ver") {
        this.pedirNombre = ObjProd.productos.pedirNombre
      }
      if (ObjProd.hasOwnProperty("omitirRegla") && ObjProd.omitirRegla == true) {
        if (Destino == "add") {
          this.BtnSelectAddProducto(ObjProd)
        }
        if (Destino == "ver") {
          this.BtnVerProductoSelect(ObjProd)
        }
      } else {
        var cli = 0
        if (this.clienteFactura != null) {
          cli = this.clienteFactura.codigo
        }
        var SoloCxc = this.$store.getters.GetConfiguracionGeneral.configPv.soloCxc
        //  .config.soloCxc,
        // console.log(SoloCxc)!this.Facturasventa.efectivo
        this.obtenerDescuentoProducto(ObjProd, SoloCxc, cli)
          .then(res => {
            var CANTIDAD = ObjProd.hasOwnProperty("cantidad") && ObjProd.cantidad != null ? ObjProd.cantidad : 1
            var ObjProRow =[]
            if(this.UsarLote==true){
             ObjProRow = this.RProductoCompra.filter((ee) => ee.productos.codigo == ObjProd.productos.codigo && ee.unidades.codigo == ObjProd.unidades.codigo && ee.lote==ObjProd.lote)
              }else{
              ObjProRow = this.RProductoCompra.filter((ee) => ee.productos.codigo == ObjProd.productos.codigo && ee.unidades.codigo == ObjProd.unidades.codigo)
              }
              
            if (ObjProRow.length > 0) {
              var OBJ_PROD_SELE = JSON.parse(JSON.stringify(ObjProRow[0]))
              var BOOLUNIPRO = (OBJ_PROD_SELE.unidadesProductosPK.producto == ObjProd.unidadesProductosPK.producto && OBJ_PROD_SELE.unidadesProductosPK.unidad == ObjProd.unidadesProductosPK.unidad)

              if (BOOLUNIPRO == true && OBJ_PROD_SELE.productos.servicio == true && OBJ_PROD_SELE.descripcion.trim() != (`${ObjProd.productos.descripcion.trim()} ${ObjProd.unidades.descripcion.trim()}`)) {
                this.productoSeleccionado = JSON.parse(JSON.stringify(ObjProd))
                this.productoSeleccionado.cantidad = ObjProd.hasOwnProperty("cantidad") && ObjProd.cantidad != null ? ObjProd.cantidad : 1
                var CANTIDAD = ObjProd.hasOwnProperty("cantidad") && ObjProd.cantidad != null ? ObjProd.cantidad : 1
              } else {
// OBJ_PROD_SELE.cantidad = (CANTIDAD+ObjProRow[0].cantidad)
                this.productoSeleccionado = JSON.parse(JSON.stringify(OBJ_PROD_SELE))
                var CANTIDAD = ObjProd.hasOwnProperty("cantidad") && ObjProd.cantidad != null ? ObjProd.cantidad : 1
              this.productoSeleccionado.cantidad=CANTIDAD
              }

            } else {

              this.productoSeleccionado = JSON.parse(JSON.stringify(ObjProd))
              this.productoSeleccionado.cantidad = ObjProd.hasOwnProperty("cantidad") && ObjProd.cantidad != null ? ObjProd.cantidad : 1
              var CANTIDAD = ObjProd.hasOwnProperty("cantidad") && ObjProd.cantidad != null ? ObjProd.cantidad : 1

              var BOOL_PROD_NOLOTE = (ObjProd.lote != null && ObjProd.lote.toString().trim().length > 0)
              if (this.UsarLote == true && BOOL_PROD_NOLOTE == false) {
                Destino = "ver"
              }
            }
            this.productoSeleccionado.descuento = res.descuento
            this.productoSeleccionado.descuentoKeys = res.descuento
            this.productoSeleccionado.paramEspecial = res.especial
            this.verficardatos(this.productoSeleccionado)
            var ProObj = JSON.parse(JSON.stringify(this.productoSeleccionado))
            //ProObj.cantidad=CANTIDAD
            // console.log('All done BuscPropiedadProductoSelct !');
            if (res.descuento > 0) {
              ProObj.ValorPorc = false
            } else {
              ProObj.ValorPorc = false /*ProObj.ValorPorc = true*/
            }
            if (Destino == "add") {
              this.BtnSelectAddProducto(ProObj)
            }
            if (Destino == "ver") {
              this.BtnVerProductoSelect(ProObj)
            }

          })
          .catch(error => {
              console.log("-E-:" + error)
            },
          )
      }
var _this = this
    setTimeout(() => {
      this.bloqueoTemp = false;
    }, 1000);




    },

    obtenerDescuentoProducto(ObjProd, SoloCxc, cli) {
      var key = [
        ObjProd.productos.codigo,
        SoloCxc,
        this.domiciliofactura != null,
        this.Totales.totalGeneral.cobertura > 0,
        this.Facturasventa.tarjeta > 0,
        this.RedondeoValorCantRed((this.Totales.totalGeneral.subtotal + ObjProd.precio), 2),
        cli,
      ].join("|")

      if (this.cacheDescuentoProducto[key] != null) {
        return Promise.resolve(this.cacheDescuentoProducto[key])
      }
      if (this.debeGuardarFacturaOffline()) {
        var descuentoOffline = this.descuentoProductoOffline(ObjProd)
        this.cacheDescuentoProducto[key] = descuentoOffline
        return Promise.resolve(descuentoOffline)
      }

      var link = `/producto/${ObjProd.productos.codigo}/descuento/${SoloCxc}/${this.domiciliofactura != null}/${this.Totales.totalGeneral.cobertura > 0}/${this.Facturasventa.tarjeta > 0}/${this.RedondeoValorCantRed((this.Totales.totalGeneral.subtotal + ObjProd.precio), 2)}/${cli}`
      return this.$axios
        .get(
          this.$hostname +
          this.$hName +
          link,
          {
            headers: this.$store.getters.GetheadersAxios,
            timeout: 8000,
          },
        )
        .then(res => {
          this.desactivarModoOfflineForzado()
          this.cacheDescuentoProducto[key] = res.data
          return res.data
        })
        .catch(error => {
          if (this.esErrorConexionPv(error)) {
            this.activarModoOfflinePorErrorConexion(error)
            var descuentoOffline = this.descuentoProductoOffline(ObjProd)
            this.cacheDescuentoProducto[key] = descuentoOffline
            return descuentoOffline
          }
          throw error
        })
    },

    mostrarExistenciaHeaderProducto(ITEM) {
      var UsarLote = this.$store.getters.GetConfiguracionGeneral.configInv.usarLote
      if(UsarLote==false){
            if (ITEM != null && ITEM.hasOwnProperty("existenciaBalanceInventario") && ITEM.existenciaBalanceInventario != null) {
              return ITEM.existenciaBalanceInventario
            }
            return ITEM != null && ITEM.hasOwnProperty("existencias") ? ITEM.existencias : ""
      }else{
        var sumaLoteExist = this.ListaProdxLote.reduce((total, item) => total + item.balance, 0);
        return ITEM.hasOwnProperty("factor") && ITEM.factor!=null && ITEM.factor>0?(sumaLoteExist/ITEM.factor):(sumaLoteExist/1);
       // return 0;
      }

    },


    mostrarExistenciaAdicional(ITEM) {
      // <b>{{FabricanteOrProveedor()}}</b>{{mostrarExistenciaAdicional(props.item)}}
      var EXIST_ADIC = this.$store.getters.GetConfiguracionGeneral.configInv.existenciaAdicionalPv
      var ALMAC = this.$store.getters.GetConfiguracionGeneral.configInv.almacenExistencia


      var ObjProRow = ITEM.listExistenciaAlmacen.filter((ee) => ee.codigoAlmacen == ALMAC.codigo)
      var desc = "N/A"
      if (ObjProRow.length > 0) {
        desc = `ALM. ${ObjProRow[0].almacen.trim()} EXIT. ${this.currencyFormatter2(ObjProRow[0].existencion)}`
      }


      return desc
    },


    verFotodeProducto(e) {
      var images = require("@/assets/img/Nofoto.png")

      if (e.foto == null) {
        return images
      }

      if (e.foto != null && e.foto.length == 0) {
        return images
      }

      if (e.foto != null && e.foto.length > 0) {
        return e.foto
      }
      return images

    },


    findUnidaProducto(codpro, coduni) {
      var CACHE_KEY = `${codpro}/${coduni}`
      if (this.cacheUnidadProducto[CACHE_KEY] != null) {
        return Promise.resolve(this.cacheUnidadProducto[CACHE_KEY])
      }

      return new Promise((resolve, reject) => {
        var VARLINK = `${codpro}/${coduni}`
        EventBus.$emit("loading", true)
        this.$axios.get(this.$hostname + this.$hName + "/unidades-productos/find/" + VARLINK, { headers: this.$store.getters.GetheadersAxios })
          .then(res => {
            this.cacheUnidadProducto[CACHE_KEY] = res.data
            resolve(res.data)
            EventBus.$emit("loading", false)
          })
          .catch(error => {
            EventBus.$emit("loading", false)
            resolve(null)
          })

      })

    },


    findListaprecioUnidaProducto(codpro, coduni, codlispre) {
      var CACHE_KEY = `${codpro}/${coduni}/${codlispre}`
      if (this.cacheListaPrecioProducto[CACHE_KEY] != null) {
        return Promise.resolve(this.cacheListaPrecioProducto[CACHE_KEY])
      }

      return new Promise((resolve, reject) => {
        var VARLINK = `findListaprecioUnidaProducto/${codpro}/${coduni}/${codlispre}`
        EventBus.$emit("loading", true)
        this.$axios.get(this.$hostname + this.$hName + "/unidades-productos/" + VARLINK, { headers: this.$store.getters.GetheadersAxios })
          .then(res => {
            if (res.data.hasOwnProperty("id")) {
              this.cacheListaPrecioProducto[CACHE_KEY] = res.data
              resolve(res.data)
            } else {
              resolve(null)
            }
            EventBus.$emit("loading", false)
          })
          .catch(error => {
            EventBus.$emit("loading", false)
            resolve(null)
          })

      })
    },


    // Añadir un producto al carrito de la compra.
    async BtnSelectAddProducto(Datos) {

      var e = JSON.parse(JSON.stringify(Datos))

      // LISTA DE PRECIO CLIENTE
      if (this.activarListasPrecios == true) {
        var CODPRO = e.unidadesProductosPK.producto
        var CODUNI = e.unidadesProductosPK.unidad
        var CODLISPRE = this.listaPrecioDefecto.id
        if (this.clienteFactura != null && this.clienteFactura.listaPrecio != null && this.clienteFactura.listaPrecio.activo == true) {
          CODLISPRE = this.clienteFactura.listaPrecio.id
        }
        const [result, resUniPro] = await Promise.all([
          this.findListaprecioUnidaProducto(CODPRO, CODUNI, CODLISPRE),
          this.findUnidaProducto(CODPRO, CODUNI),
        ])
        if (result != null) {
          e.precio = result.precio
          e.precioDig = result.precio
          e.precioOrig = resUniPro.precio
        }
      }else{

      var boolEstacion= (this.$store.getters.GetConfiguracionGeneral.config.estacion==true || this.$store.getters.GetConfiguracionGeneral.config.estacionCombustible )
        if(boolEstacion==true && this.clienteFactura != null && this.clienteFactura.hasOwnProperty('codigo')){
          var desc =0
          if(this.clienteFactura.descuento>0){
            //desc= ((this.clienteFactura.descuentovalor * 100) / (e.precio * e.cantidad))
              desc= ((e.precio*this.clienteFactura.descuento)/100)
          }

          if(this.clienteFactura.descuentovalor>0){
          desc=this.clienteFactura.descuentovalor
          }
          e.descuentoKeys=desc
          e.descuento=desc
          e.ValorPorc=true
        }

var PRIORI_CLIEN_DESC = this.$store.getters.GetConfiguracionGeneral.configPv.prioridadDescuentoCliente
      if(PRIORI_CLIEN_DESC==true && this.clienteFactura != null && this.clienteFactura.hasOwnProperty('codigo')){
        if(this.clienteFactura.descuento>0 || this.clienteFactura.descuentovalor>0 ){
          var desc =0
          if(this.clienteFactura.descuento>0){
            //desc= ((this.clienteFactura.descuentovalor * 100) / (e.precio * e.cantidad))
              desc= ((e.precio*this.clienteFactura.descuento)/100)
          }

          if(this.clienteFactura.descuentovalor>0){
          desc=this.clienteFactura.descuentovalor
          }
          e.descuentoKeys=desc
          e.descuento=desc
          e.ValorPorc=true
        }
        }

      }
      

      
      var selc = JSON.parse(JSON.stringify(e))
      this.selected = JSON.parse(JSON.stringify(e))

     var ObjProRow =[]
     if(this.UsarLote==true){
      ObjProRow = this.RProductoCompra.filter( (ee) => ee.productos.codigo == e.productos.codigo &&
          ee.unidades.codigo == e.unidades.codigo && ee.lote==e.lote && ee.paramOfert == false)
              }else{
                ObjProRow = this.RProductoCompra.filter( (ee) => ee.productos.codigo == e.productos.codigo &&
          ee.unidades.codigo == e.unidades.codigo && ee.paramOfert == false)   
              }

      if (ObjProRow.length > 0) {
        if (e.productos.controlado == true) {
          var ObjProControlRow = this.RecetaProdControlado.detalleList.filter((ec) => ec.productos.codigo == e.productos.codigo && ec.unidad.codigo == e.unidades.codigo)[0]
          // if (ObjProRow[0].cantidad >= ObjProControlRow.cantidadRecetada)
          if (ObjProRow[0].cantidad + ObjProControlRow.cantidadDespachada > ObjProControlRow.cantidadRecetada) {
            this.alerta(
              "Producto Controlado: La cantidad a despachar esta por encima de la cantiadad recetada",
              "error",
            )
            return
          }
        }
        var canttt = 1
        if (e.cantidad != null) {
          if (this.EditProdCompa == false && this.PanelInfProduct == true) {
            canttt = (this.productoSeleccionado.cantidad + ObjProRow[0].cantidad)
          } else {
            //COMENT PR
            //canttt = (1 + ObjProRow[0].cantidad)
              canttt = this.RedondeoValorCantRed((e.cantidad + ObjProRow[0].cantidad), 2)
          }

          //canttt = (e.cantidad + ObjProRow[0].cantidad)
          //if(this.UsarLote==true){ validacantExit=canttt+ObjProRow[0].cantidad }
          // console.log(ObjProRow[0].productos.servicio)

          if (ObjProRow[0].productos.servicio == false && this.configuraciones.configInv.permitirNegativos == false && canttt > ObjProRow[0].existencias) {
         if(this.ProductoOpcionVer==true){ console.log('Papararr--->',this.ProductoOpcionVer)}
            //this.ProductoOpcionVer = true
            this.alerta("la cantidad que intenta vender, es mayor a la existencia", "error")
            return
          }

        } else {
          canttt += (ObjProRow[0].cantidad)
          // console.log(ObjProRow[0].productos.servicio)
          if (ObjProRow[0].productos.servicio == false && this.configuraciones.configInv.permitirNegativos == false && canttt > ObjProRow[0].existencias) {
            this.alerta("la cantidad que intenta vender, es mayor a la existencia", "error")
            return
          }
        }

        var OBJ_PROD_SELE = JSON.parse(JSON.stringify(ObjProRow[0]))
        var BOOLUNIPRO = (OBJ_PROD_SELE.unidadesProductosPK.producto == selc.unidadesProductosPK.producto && OBJ_PROD_SELE.unidadesProductosPK.unidad == selc.unidadesProductosPK.unidad)

        if (BOOLUNIPRO == true && OBJ_PROD_SELE.productos.servicio == true && OBJ_PROD_SELE.descripcion.trim() != (`${selc.productos.descripcion.trim()} ${selc.unidades.descripcion.trim()}`)) {
          this.BtnAgregarProductoSelect(selc)
        } else {

          /*ANTES 02-08-2025
        this.RProductoCompra.filter((ee) => ee.productos.codigo == e.productos.codigo && ee.unidades.codigo == e.unidades.codigo && ee.paramOfert==false
        )[0].cantidad = canttt;

         if(selc.hasOwnProperty("DescValor")){
                this.RProductoCompra.filter((ee) => ee.productos.codigo == e.productos.codigo &&
                  ee.unidades.codigo == e.unidades.codigo)[0].DescValor = selc.DescValor;
                    }
        */

          var OBJEDIT ={}
          if(this.UsarLote==true){
           OBJEDIT = this.RProductoCompra.filter((ee) => ee.productos.codigo == e.productos.codigo && ee.unidades.codigo == e.unidades.codigo && ee.lote==e.lote && ee.paramOfert == false
          )[0]
        }else{
          OBJEDIT = this.RProductoCompra.filter((ee) => ee.productos.codigo == e.productos.codigo && ee.unidades.codigo == e.unidades.codigo && ee.paramOfert == false
          )[0]
        }

          OBJEDIT.cantidad = canttt


          if (selc.hasOwnProperty("DescValor")) {
            OBJEDIT.DescValor = selc.DescValor
          }

          this.RProductoCompraTemp = JSON.parse(JSON.stringify(this.RProductoCompra))
          this.buscarAgregarEliminarOferta(OBJEDIT)
          this.loaderTablaCargar()
          var _this = this
          setTimeout(function() {
            _this.CalcularTotalesProductosCompra()
            _this.LimpiaInfProducto()
          }, 300)
        }


      } else {

        if (selc.hasOwnProperty("omitirRegla") && selc.omitirRegla == true) {
          this.BtnAgregarProductoSelect(selc)
        } else {
          if (selc.productos.controlado == true) {
            if (this.selecteTemRecCont == null) {
              this.selecteTemRecCont = JSON.parse(JSON.stringify(selc))
            }
            this.EjecuModalProductoControlado("notf")
          } else {

            //if(this.clienteFactura == null && selc.productos.planBeneficio == true)
            if(selc.productos.planBeneficio == true) {
              this.planBeneficio.dialogNotifPlanBeneficio = true
              this.planBeneficio.planBeneficio = true
              this.planBeneficio.objtem = JSON.parse(JSON.stringify(selc))

            } else {
              this.BtnAgregarProductoSelect(selc)
            }


          }
        }


      }


      //this.RallProducto=[]
    },

    BtnAgregarProductoSelect(e) {

      if (e.hasOwnProperty("omitirRegla") && e.omitirRegla == true) {
        this.continuarBtnAgregarProductoSelect(e)
      } else {

        if (e.productos.controlado == true) {
          this.EjecuModalProductoControlado("notf")
        } else {
          this.continuarBtnAgregarProductoSelect(e)
        }

      }

      this.RallProducto = []
      //this.NewproductoSeleccionado()
      //var eftc = JSON.parse(JSON.stringify(e))
      //-----Aqui para la modificacion de los productos ---------------------
      return 0
    },

    continuarBtnAgregarProductoSelect(e) {
      this.selected = JSON.parse(JSON.stringify(e))
      this.EditProdCompa = false
      var selc = JSON.parse(JSON.stringify(e))
      selc.vendedor = e.hasOwnProperty("vendedor") && e.vendedor != null ? e.vendedor : null
      selc.paramOfert = false
      selc.recargo = 0
      selc.cobertura = 0
      selc.descuento = e.descuento
      selc.DescValor = e.hasOwnProperty("DescValor") && e.DescValor != null ? e.DescValor : 0
      selc.descuentoKeys = e.hasOwnProperty("descuentoKeys") && e.descuentoKeys != null ? e.descuentoKeys : 0
      selc.ValorPorc = e.hasOwnProperty("ValorPorc") && e.ValorPorc != null ? e.ValorPorc : true
      selc.RecarValor = 0
      selc.valor = 0
      selc.cantidad = e.hasOwnProperty("cantidad") && e.cantidad != null ? e.cantidad : 1
      selc.omitirRegla = e.hasOwnProperty("omitirRegla") ? e.omitirRegla : false
      // selc.ValorPorc = false;
      selc.ValorPorcRecarg = true
      selc.precioOrig = e.hasOwnProperty("precioOrig") ? e.precioOrig : e.precio
      selc.precioDig = e.precio
      selc.descripcion = e.hasOwnProperty("descripcion") && e.descripcion != null ? e.descripcion : e.productos.descripcion + " " + e.unidades.descripcion
      if(selc.cobertura>0){selc.cobValorPorc=true}else{selc.cobValorPorc=false}
      // selc.descripcion= e.productos.descripcion + " " + e.unidades.descripcion;
      this.pedirNombre = e.productos.pedirNombre
      this.productoSeleccionado = JSON.parse(JSON.stringify(selc))

      if (this.UsarLote === true && !selc.hasOwnProperty("fechaLoteInicial")) {
        if (selc.hasOwnProperty("lote") && selc.listExistenciaAlmacen.length > 0) {
          var COD_LOTE = parseInt(selc.lote.toString().trim())
          var ObjProRow = selc.listExistenciaAlmacen.filter((ee) => ee.fechaVencimiento != null && ee.fechaVencimiento.codigo === COD_LOTE)
          if (ObjProRow.length > 0) {
            this.productoSeleccionado.fechaLoteInicial = ObjProRow[0].fechaVencimiento.fechaInicial
          }
        }
      }

      if (selc.hasOwnProperty("omitirRegla") && selc.omitirRegla == true) {
        this.preValidadorProducto(selc)
      } else {
        if (selc.productos.digitarcantidadenpv) {
          this.PanelMenuOpcionCompleto = false
          this.PanelSelectProducto = false
          this.PanelInfProduct = true
          this.$refs.RefScroll.scrollTop = 0
          var _this = this
          setTimeout(function() {
            _this.$refs.RefTextFieldProductoCantidad.focus()
            _this.getExistProdXAlmacen()
            _this.getProductoSustitutos()
          }, 500)


        } else {
          this.PanelSelectProducto = false
          this.preValidadorProducto(selc)
          //this.SalvarInfProducto();
        }
      }


    },

    // Verificando si el producto tiene descuento y si lo tiene es verificando si el descuento es mayor
    // al descuento máximo permitido para el producto.
    verficardatos() {
      if (this.productoSeleccionado.productos != null) {
        var Cant = this.productoSeleccionado.cantidad

        var PrecioVal = 0
        if (this.ConfImpfiscal == true) {
          PrecioVal = this.productoSeleccionado.precio
        } else {

          if (this.productoSeleccionado.productos.incluirimpuestoenprecio == true) {
            if (this.productoSeleccionado.productos.impuesto != null) {
              PrecioVal = (this.productoSeleccionado.precio) / (1 + (this.productoSeleccionado.productos.impuesto.tasa / 100))
            } else {
              PrecioVal = this.productoSeleccionado.precio
            }
          } else {

            PrecioVal = this.productoSeleccionado.precio
          }

        }

        //this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList

        var DescPorencima = false
        var SuperAdmin = this.$store.getters.GetdatosInfUsu.usuario.sudo
        if (this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList.length > 0) {
          var ObjPerm = this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList.filter((ee) => ee.fn == 3 && ee.op == 14)
          if (ObjPerm.length > 0) {
            DescPorencima = ObjPerm[0].permiso
          } else {
            DescPorencima = false
          }
        }

        if (this.productoSeleccionado.ValorPorc == true) {
          //convirtiendo en porciento
          var valorDesc = ((this.productoSeleccionado.descuentoKeys * 100) / (PrecioVal * Cant))
          var DescOdeMax = ((this.productoSeleccionado.descuentoKeys * 100) / (PrecioVal * Cant))
          this.productoSeleccionado.descuento = JSON.parse(JSON.stringify(this.productoSeleccionado.descuentoKeys))

          if (this.productoSeleccionado.paramEspecial == false) {
            if (SuperAdmin == false && DescPorencima == false) {
              if (valorDesc > this.productoSeleccionado.productos.descuentomaximo) {
                var valorrr = ((this.productoSeleccionado.productos.descuentomaximo * (PrecioVal * Cant)) / 100)
                this.productoSeleccionado.descuento = valorrr
                this.productoSeleccionado.descuentoKeys = valorrr
                DescOdeMax = this.productoSeleccionado.productos.descuentomaximo
              }
            }
          }

          this.productoSeleccionado.DescValor = this.productoSeleccionado.descuento
          this.productoSeleccionado.valordescuento = this.productoSeleccionado.descuento
          this.productoSeleccionado.descuento = DescOdeMax
        } else {
          this.productoSeleccionado.descuento = JSON.parse(JSON.stringify(this.productoSeleccionado.descuentoKeys))

          if (this.productoSeleccionado.paramEspecial == false) {
            if (SuperAdmin == false && DescPorencima == false) {
              if (this.productoSeleccionado.descuento > this.productoSeleccionado.productos.descuentomaximo) {
                this.productoSeleccionado.descuento = this.productoSeleccionado.productos.descuentomaximo
                this.productoSeleccionado.descuentoKeys = this.productoSeleccionado.productos.descuentomaximo
              }
            }
          }
          //convirtiendo en valor
          this.productoSeleccionado.DescValor = ((this.productoSeleccionado.descuento * (PrecioVal * Cant)) / 100)
          this.productoSeleccionado.valordescuento = ((this.productoSeleccionado.descuento * (PrecioVal * Cant)) / 100)
        }


var PRIORI_CLIEN_DESC = this.$store.getters.GetConfiguracionGeneral.configPv.prioridadDescuentoCliente
      if(PRIORI_CLIEN_DESC==true && this.clienteFactura != null && this.clienteFactura.hasOwnProperty('codigo')){
        if(this.clienteFactura.descuento>0 || this.clienteFactura.descuentovalor>0 ){
          var descC=0
          if(this.clienteFactura.descuento>0){
          this.productoSeleccionado.descuento =this.clienteFactura.descuento
          this.productoSeleccionado.DescValor = ((this.clienteFactura.descuento * (PrecioVal * Cant)) / 100)
          this.productoSeleccionado.valordescuento = ((this.clienteFactura.descuento * (PrecioVal * Cant)) / 100)
          this.productoSeleccionado.ValorPorc == false
          }

          if(this.clienteFactura.descuentovalor>0){
            this.productoSeleccionado.DescValor = this.clienteFactura.descuentovalor
          this.productoSeleccionado.valordescuento = this.clienteFactura.descuentovalor
          //CONVERTIR VALOR EN PORCIENDO
          var DESC_POC = ((this.clienteFactura.descuentovalor * 100) / (PrecioVal * Cant))
          this.productoSeleccionado.descuento =DESC_POC
          this.productoSeleccionado.ValorPorc=true
          }

        }
        }



        if (this.productoSeleccionado.ValorPorcRecarg == true) {
          this.productoSeleccionado.RecarValor = this.productoSeleccionado.recargo
        } else {
          this.productoSeleccionado.RecarValor = ((this.productoSeleccionado.recargo * (this.productoSeleccionado.precio * Cant)) / 100)
        }

      }

      return true
    },
    cambiarPrecios() {
      if (
        !this.configuracion.configPv.venderalcosto &&
        this.productoSeleccionado.precio < this.productoSeleccionado.costo
      ) {
        this.alerta("No puede dijitar el precio por debajo del costo", "error")
        return
      }
      if (
        this.configuracion.configPv.noBajaPrecio &&
        this.productoSeleccionado.precio < this.productoSeleccionado.precioOrig
      ) {
        this.alerta("No puede bajar el precio", "error")
        return
      }
    },
    BtnVerProductoSelect(e) {
      //var eftc = JSON.parse(JSON.stringify(e))
      //-----Aqui para la modificacion de los productos ---------------------
      this.EditProdCompa = false
      this.ProductoOpcionVer = true
      var selc = JSON.parse(JSON.stringify(e))
      this.selected = JSON.parse(JSON.stringify(e))
      selc.vendedor = null
      selc.paramOfert = false
      selc.recargo = 0
      selc.cobertura = 0
      selc.descuento = 0
      selc.descuentoKeys = e.hasOwnProperty("descuentoKeys") && e.descuentoKeys != null ? e.descuentoKeys : 0
      selc.DescValor = 0
      selc.RecarValor = 0
      selc.valor = 0
      selc.cantidad = 1
      selc.ValorPorc = false
      selc.ValorPorcRecarg = false
      selc.precioOrig = e.precio
      selc.precioDig = e.precio
      selc.descripcion = e.productos.descripcion + " " + e.unidades.descripcion
      if(selc.cobertura>0){selc.cobValorPorc=true}else{selc.cobValorPorc=false}
        var boolEstacion= (this.$store.getters.GetConfiguracionGeneral.config.estacion==true || this.$store.getters.GetConfiguracionGeneral.config.estacionCombustible )
        if(boolEstacion==true && this.clienteFactura != null && this.clienteFactura.hasOwnProperty('codigo')){
          var desc =0
          if(this.clienteFactura.descuento>0){
            //desc= ((this.clienteFactura.descuentovalor * 100) / (selc.precio * selc.cantidad))
            desc= ((selc.precio*this.clienteFactura.descuento)/100)
          }

          if(this.clienteFactura.descuentovalor>0){
          desc=this.clienteFactura.descuentovalor
          }
          selc.descuentoKeys=desc
          selc.descuento=desc
          selc.ValorPorc=true
        }


      this.productoSeleccionado = JSON.parse(JSON.stringify(selc))
      this.PanelMenuOpcionCompleto = false
      this.PanelSelectProducto = false
      this.PanelInfProduct = true
      this.$refs.RefScroll.scrollTop = 0
      var _this = this
      setTimeout(function() {
        _this.$refs.RefTextFieldProductoCantidad.focus()
        _this.getExistProdXAlmacen()
        _this.getProductoSustitutos()
      }, 500)

      //this.NewproductoSeleccionado()

      return 0
    },

    EditarProductoSelect(e, st) {

      if (e.hasOwnProperty("paramOfert") && e.paramOfert == true) {
        this.alerta("No puede editar este producto porque es una oferta", "error")
        return
      }
      var _this = this
      setTimeout(function() {
        _this.EditProdCompa = st
        var selc = JSON.parse(JSON.stringify(e))
        if (!e.hasOwnProperty("recargo") || e.hasOwnProperty("recargo") && e.recargo == null) {
          selc.recargo = 0
          selc.ValorPorcRecarg = true
        }

        if (!e.hasOwnProperty("ValorPorcRecarg") || e.hasOwnProperty("ValorPorcRecarg") && e.ValorPorcRecarg == null) {
          selc.ValorPorcRecarg = true
        }

        selc.ValorPorc = false
        selc.ValorPorcRecarg = true
        if (e.hasOwnProperty("descuento")) {
          selc.descuentoKeys = e.descuento
        }
      
       if(selc.cobertura>0){selc.cobValorPorc=true}else{selc.cobValorPorc=false}

        selc.paramEspecial = false
        _this.productoSeleccionado = JSON.parse(JSON.stringify(selc))
        if (st) {
          _this.PanelMenuOpcionCompleto = false
          _this.PanelSelectProducto = false
          _this.PanelInfProduct = true
          _this.$refs.RefScrollProductoCompra.scrollTop = 0
          setTimeout(function() {
            _this.$refs.RefTextFieldProductoCantidad.focus()
            _this.getExistProdXAlmacen()
            _this.getProductoSustitutos()
          }, 500)
        }

      }, 500)

      /*   this.EditProdCompa = st;
         var selc = JSON.parse(JSON.stringify(e));
         this.productoSeleccionado = JSON.parse(JSON.stringify(selc));
         if (st) {
           this.PanelMenuOpcionCompleto = false;
           this.PanelSelectProducto = false;
           this.PanelInfProduct = true;
           this.$refs.RefScrollProductoCompra.scrollTop = 0;
           var _this = this;
           setTimeout(function () {
             _this.$refs.RefTextFieldProductoCantidad.focus();
             _this.getExistProdXAlmacen()
           }, 500);
         }


   */


      return 0

    },


    // Obtener los datos de la base de datos y mostrarlos en una tabla.
    getExistProdXAlmacen() {

      if (!this.productoSeleccionado.hasOwnProperty("unidadesProductosPK")) {
        return
      }

      if (this.debeGuardarFacturaOffline()) {
        if (this.UsarLote == true && this.productoSeleccionado.lote != null && this.productoSeleccionado.lote.toString().trim().length > 0) {
          this.ListaProdxLote = [{
            codigo: this.productoSeleccionado.codlote || this.productoSeleccionado.lote,
            lote: this.productoSeleccionado.lote,
            loteFabricante: this.productoSeleccionado.loteFabricante,
            fechaVencimiento: this.productoSeleccionado.fechaVencimiento || this.productoSeleccionado.fechaLoteInicial || null,
            almacen: this.caja != null ? this.caja.almacen : null,
            balance: this.productoSeleccionado.existencias,
          }]
          this.selectedListProdxLote = JSON.parse(JSON.stringify(this.ListaProdxLote))
        } else {
          this.ListaProdxAlmacen = [{
            codigoAlmacen: this.caja != null && this.caja.almacen != null ? this.caja.almacen.codigo : 0,
            almacen: this.caja != null && this.caja.almacen != null ? this.caja.almacen.descripcion : "",
            existencion: this.productoSeleccionado.existencias,
          }]
        }
        return
      }

      if (this.UsarLote == false) {
        this.ListaProdxAlmacen = []
        var obj = {
          unidadProducto: JSON.parse(JSON.stringify(this.productoSeleccionado)),
        }

        this.$axios
          .post(this.$hostname + this.$hName + "/producto/ProductoAlmacExist", obj, {
            headers: this.$store.getters.GetheadersAxios,
            timeout: 8000,
          })
          .then((res) => {
            this.ListaProdxAlmacen = res.data

          })
          .catch((error) => {
            console.log("Catch---")
          })
      }
      if (this.UsarLote == true) {
        this.ListaProdxLote = []

        this.$axios
          .post(this.$hostname + this.$hName + "/producto/ProductoLoteExist", this.productoSeleccionado.productos, {
            headers: this.$store.getters.GetheadersAxios,
            timeout: 8000,
          })
          .then((res) => {
            this.ListaProdxLote = res.data

            if (this.productoSeleccionado.lote != null && this.productoSeleccionado.lote.toString().trim().length > 0) {
              var COD_LOTE = parseInt(this.productoSeleccionado.lote.toString().trim())
              var _this = this
              setTimeout(function() {
                //  cosnole
                _this.SelectorListProdXlote(COD_LOTE)
              }, 800)

            } else {
              if(res.data.length==1){
                this.selectedListProdxLote=this.ListaProdxLote 
                this.obtenerDatoSelectProdxLoteClickRow(this.ListaProdxLote[0])
              }

              //this.alerta("Seleccione el lote al que pertenece el producto", "error")
// var ObjProRow = this.ListaProdxLote.filter((ee) => ee.lote == e)
//       this.selectedListProdxLote = ObjProRow

//               if(res.data){}
              
            }

            return
            var ObjList = res.data
            var ObjProRow = ObjList.filter((ee) => ee.fechaVencimiento.codigo == this.productoSeleccionado.lote)

            if (ObjProRow.length > 0) {
              this.ListaProdxLote = ObjList
              var _this = this
              setTimeout(function() {
                _this.SelectorListProdXlote(ObjProRow[0])
              }, 800)
            } else {

              var Intlote = 0
              if (this.productoSeleccionado.lote.length == 0) {
                Intlote = 0
              } else {
                Intlote = this.productoSeleccionado.lote
              }

              this.$axios.get(this.$hostname + this.$hName + "/unidades-productos/findFecha/" + Intlote, {
                headers: this.$store.getters.GetheadersAxios,
              })
                .then((res) => {
                  this.ListaProdxLote = ObjList
                  var oobj = {
                    balance: 0,
                    codigo: res.data.codigo,
                    fechaVencimiento: { codigo: res.data.codigo, fecha: res.data.fecha },
                  }
                  this.ListaProdxLote.push(oobj)
                  var _this = this
                  setTimeout(function() {
                    _this.SelectorListProdXlote(oobj)
                  }, 800)

                })
                .catch((error) => {
                  console.log("Catch---")
                })
            }

          })
          .catch((error) => {
            console.log("Catch--->", error)
          })
      }

    },

    getHeadersExisteLote(){
      var BOOL_LoFAB= this.$store.getters.GetConfiguracionGeneral.configInv.hasOwnProperty('usarLoteFabricante') && this.$store.getters.GetConfiguracionGeneral.configInv.usarLoteFabricante!=null? this.$store.getters.GetConfiguracionGeneral.configInv.usarLoteFabricante:false
       
var HEADERS_EXIST=[

                      { text: 'CÓDIGO', value: 'codigo', sortable: false, class: ['no-gutters black--text'] },
                      { text: 'LOTE', value: 'lote', sortable: false, class: ['no-gutters black--text'] },
                      { text: 'FECHA VENCIMIENTO', value: 'fechaVencimiento', sortable: false, class: ['no-gutters black--text'] },
                      { text: 'ALMACEN', value: 'almacen.descripcion', sortable: false, class: ['no-gutters black--text'] },
                      { text: 'EXISTENCIA', value: 'balance', sortable: false, class: ['no-gutters black--text'] },
                    ]



if (BOOL_LoFAB) {
var newRow={ text: 'L_FABRICANTE', value: 'loteFabricante', sortable: false, class: ['no-gutters black--text'] };
  HEADERS_EXIST.splice(2, 0, newRow);
}

return HEADERS_EXIST;

    },

    // Llamar a una API y obtener los datos de la API y almacenarlos en la variable
    // ListProductoSustitutos.
    getProductoSustitutos() {
      this.ListProductoSustitutos = []
      if (!this.productoSeleccionado.hasOwnProperty("unidadesProductosPK")) {
        return
      }

      if (this.debeGuardarFacturaOffline()) {
        return
      }

      this.$axios
        .get(
          this.$hostname + this.$hName + "/unidades-productos/getSubstitutoUnidadProducto/" + this.productoSeleccionado.unidadesProductosPK.producto + "/" + this.caja.codigo,
          { headers: this.$store.getters.GetheadersAxios, timeout: 8000 },
        )
        .then((res) => {
          this.desactivarModoOfflineForzado()
          this.ListProductoSustitutos = res.data
        })
        .catch((error) => {
          console.log("Catch---")
        })

    },

    // Filtrando el array de objetos por la propiedad "fechaVencimiento.codigo" y devolviendo el objeto
    // que coincida con el valor de la propiedad.
    SelectorListProdXlote(e) {
      // var ObjProRow = this.ListaProdxLote.filter((ee) => ee.fechaVencimiento.codigo == e.fechaVencimiento.codigo);
      var ObjProRow = this.ListaProdxLote.filter((ee) => ee.lote == e)
      this.selectedListProdxLote = ObjProRow
    },


    obtenerDatoSelectProdxLote(e) {
      this.obtenerDatoSelectProdxLoteClickRow(e.item)
    },
    obtenerDatoSelectProdxLoteClickRow(e) {
      this.selectedListProdxLote = []
      this.selectedListProdxLote.push(e)
      if (this.productoSeleccionado != null && !this.productoSeleccionado.hasOwnProperty("existenciaBalanceInventario")) {
        this.productoSeleccionado.existenciaBalanceInventario = JSON.parse(JSON.stringify(this.productoSeleccionado.existencias))
      }
      this.productoSeleccionado.lote = JSON.parse(JSON.stringify(e.lote))
      if(e.hasOwnProperty("loteFabricante") && e.loteFabricante != null && e.loteFabricante.trim().length>0 ){
          this.productoSeleccionado.loteFabricante= JSON.parse(JSON.stringify(e.loteFabricante))
      }
      
      if (e.hasOwnProperty("fechaVencimiento") && e.fechaVencimiento != null && typeof e.fechaVencimiento === "object") {
        this.productoSeleccionado.fechaLoteInicial = e.fechaVencimiento.fechaInicial
      }
      var factor=this.productoSeleccionado!=null && this.productoSeleccionado.hasOwnProperty("factor")?this.productoSeleccionado.factor:1;
      this.productoSeleccionado.existencias = JSON.parse(JSON.stringify(e.balance/factor))
    },

    // Hacer una llamada API al servidor y obtener los datos.
    CargarRproducto() {
      this.RallProducto = []
      this.selected = null
      return
      if (this.searchProducto.length == 0) {
        this.$axios
          .get(
            this.$hostname + this.$hName + "/unidades-productos/*/false/" + this.caja.sucursal.codigo + "/buscar",
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            this.RallProducto = res.data
          })
      }


    },
    // El código anterior es una función que se llama cuando se presiona una tecla,
    //marca y despliega el indice del record posicionado de color diferente.
    SelectMarcaProducto(e) {
      if (this.ProdCompOrSelecProd == false) {
        // ArrowUp/ArrowDown
        if (e.keyCode == 38 || e.keyCode == 40) {
          if (this.selected == null && this.RallProducto.length != 0) {
            this.selected = JSON.parse(JSON.stringify(this.RallProducto[0]))
            this.$refs.RefScroll.scrollTop = 0
            return 0
          }
        }

        if (this.selected != null) {
          //key: "Enter"keyCode: 13
          if (e.keyCode == 13) {
            if (this.validarBusProductoBarraReferencia(e.target.value) == true) {
              return
            }

            this.EditProdCompa = false
            var selc = JSON.parse(JSON.stringify(this.selected))

            if (!this.selected.hasOwnProperty("recargo") || this.selected.hasOwnProperty("recargo") && this.selected.recargo == null || !isNaN(this.selected.recargo)) {
              selc.recargo = 0
              selc.ValorPorcRecarg = true
            }

            if (!this.selected.hasOwnProperty("ValorPorcRecarg") || this.selected.hasOwnProperty("ValorPorcRecarg") && this.selected.ValorPorcRecarg == null || !isNaN(this.selected.recargo)) {
              selc.ValorPorcRecarg = true
            }
            //!isNaN:Verifica si es solo numero el string
            if (this.UsarLote == true && this.searchProducto.length == 14 && !isNaN(this.searchProducto)) {
              selc.lote = parseInt(this.searchProducto.substr(10))
            }

           if(selc.cobertura>0){selc.cobValorPorc=true}else{selc.cobValorPorc=false}

            //console.log(isNum('13579'));
            // this.BtnSelectAddProducto(selc)
            this.BuscPropiedadProductoSelct(selc, "add")
            this.RallProducto = []
            /* if (selc.productos.controlado == true) {
               this.EjecuModalProductoControlado("notf");
             } else {
               this.BtnAgregarProductoSelect(selc);
             }*/
            this.calcularDevuelta()
            return 0
            //this.NewproductoSeleccionado()
          }

          //key: "ArrowUp"keyCode: 38
          if (e.keyCode == 38) {
            var VarInddx = JSON.parse(JSON.stringify(this.selected.indx - 1))
            if (this.RallProducto[VarInddx] != undefined) {
              this.selected = JSON.parse(
                JSON.stringify(this.RallProducto[VarInddx]),
              )
              // this.$refs.RefScroll.scrollTop -= 40;

              const totalRegistros = this.RallProducto.length
              const registroDestino = VarInddx
              const porcentaje = (registroDestino - 1) / totalRegistros
              const maxScroll = this.$refs.RefScroll.scrollHeight - this.$refs.RefScroll.clientHeight


              if ((maxScroll * porcentaje) >= -50 && (maxScroll * porcentaje) <= 50) {
                this.$refs.RefScroll.scrollTop = 0
              } else {
                this.$refs.RefScroll.scrollTop = ((maxScroll * porcentaje))
              }


            } else {
              this.selected = JSON.parse(
                JSON.stringify(this.RallProducto[VarInddx + 1]),
              )
            }

            return 0
          }

          //key: "ArrowDown"keyCode: 40
          if (e.keyCode == 40) {
            var VarInddx = JSON.parse(JSON.stringify(this.selected.indx + 1))
            if (this.RallProducto[VarInddx] != undefined) {
              this.selected = JSON.parse(
                JSON.stringify(this.RallProducto[VarInddx]),
              )
              //this.$refs.RefScroll.scrollTop += 40;
              const totalRegistros = this.RallProducto.length
              const registroDestino = VarInddx
              const porcentaje = (registroDestino - 1) / totalRegistros
              const maxScroll = this.$refs.RefScroll.scrollHeight - this.$refs.RefScroll.clientHeight
              this.$refs.RefScroll.scrollTop = ((maxScroll * porcentaje))

              if ((maxScroll * porcentaje) >= (maxScroll - 150) && (maxScroll * porcentaje) <= (maxScroll)) {
                this.$refs.RefScroll.scrollTop = maxScroll
              } else {
                this.$refs.RefScroll.scrollTop = ((maxScroll * porcentaje))
              }


            } else {
              this.selected = JSON.parse(
                JSON.stringify(this.RallProducto[VarInddx - 1]),
              )
            }
            return 0
          }
        }
      }

      // Porducto seleccionado para comprar
      if (this.ProdCompOrSelecProd == true) {
        if (this.selected == null && this.RProductoCompra.length != 0) {
          this.selected = JSON.parse(JSON.stringify(this.RProductoCompra[0]))
          return 0
        }
        if (this.selected != null) {
          if (e.keyCode == 13) {
            this.EditProdCompa = true
            var selc = JSON.parse(JSON.stringify(this.selected))
            if (!this.selected.hasOwnProperty("recargo") || this.selected.hasOwnProperty("recargo") && this.selected.recargo == null || !isNaN(this.selected.recargo)) {
              selc.recargo = 0
              selc.ValorPorcRecarg = true
            }

            if (!this.selected.hasOwnProperty("ValorPorcRecarg") || this.selected.hasOwnProperty("ValorPorcRecarg") && this.selected.ValorPorcRecarg == null || !isNaN(this.selected.recargo)) {
              selc.ValorPorcRecarg = true
            }
            selc.ValorPorc = false
            selc.ValorPorcRecarg = false
            if (this.selected.hasOwnProperty("descuento")) {
              selc.descuentoKeys = this.selected.descuento
            }
            if(selc.cobertura>0){selc.cobValorPorc=true}else{selc.cobValorPorc=false}
            this.productoSeleccionado = JSON.parse(JSON.stringify(selc))
            this.PanelMenuOpcionCompleto = false
            this.PanelSelectProducto = false
            this.PanelInfProduct = true
            this.$refs.RefScrollProductoCompra.scrollTop = 0
            var _this = this
            setTimeout(function() {
              _this.$refs.RefTextFieldProductoCantidad.focus()
              _this.getExistProdXAlmacen()
              _this.getProductoSustitutos()
            }, 500)
            return 0
          }

          //key: "ArrowUp"keyCode: 38
          if (e.keyCode == 38) {
            var VarCompInddx = JSON.parse(
              JSON.stringify(this.selected.indx - 1),
            )
            if (this.RProductoCompra[VarCompInddx] != undefined) {
              this.selected = JSON.parse(
                JSON.stringify(this.RProductoCompra[VarCompInddx]),
              )

              /*const registrosVisibles = ((this.windowSizeCaja.height/this.RProductoCompra.length)+(VarCompInddx/2));
              console.log('pamparaDelBloque-->',this.windowSizeCaja.height)
            //  this.$refs.RefScrollProductoCompra.scrollTop -= registrosVisibles;
              this.$refs.RefScrollProductoCompra.scrollTop -= 35;*/

              const totalRegistros = this.RProductoCompra.length
              const registroDestino = VarCompInddx
              const porcentaje = (registroDestino - 1) / totalRegistros
              const maxScroll = this.$refs.RefScrollProductoCompra.scrollHeight - this.$refs.RefScrollProductoCompra.clientHeight


              if ((maxScroll * porcentaje) >= -50 && (maxScroll * porcentaje) <= 50) {
                this.$refs.RefScrollProductoCompra.scrollTop = 0
              } else {
                this.$refs.RefScrollProductoCompra.scrollTop = ((maxScroll * porcentaje))
              }


            } else {
              this.selected = JSON.parse(
                JSON.stringify(this.RProductoCompra[VarCompInddx + 1]),
              )
            }

            return 0
          }

          //key: "ArrowDown"keyCode: 40
          if (e.keyCode == 40) {
            var VarCompInddx = JSON.parse(
              JSON.stringify(this.selected.indx + 1),
            )
            if (this.RProductoCompra[VarCompInddx] != undefined) {
              this.selected = JSON.parse(
                JSON.stringify(this.RProductoCompra[VarCompInddx]),
              )

              //568---(568/80)*2
              // Número de registros visibles (en pantalla)

              /* BIEN
             // const registrosVisibles = ((this.windowSizeCaja.height/this.RProductoCompra.length)+(VarCompInddx/2));
              //this.$refs.RefScrollProductoCompra.scrollTop += registrosVisibles;
              */

              /*const alturaRegistro = 50; // px, por ejemplo this.$refs.RefScrollProductoCompra.clientHeight
                  const indiceRegistro = 50; // ir al registro número 50 (índice base 1)
                  const posicionScroll = this.$refs.RefScrollProductoCompra.clientHeight * (VarCompInddx - 1);
                  this.$refs.RefScrollProductoCompra.scrollTop = posicionScroll*/

              const totalRegistros = this.RProductoCompra.length
              const registroDestino = VarCompInddx
              const porcentaje = (registroDestino - 1) / totalRegistros
              const maxScroll = this.$refs.RefScrollProductoCompra.scrollHeight - this.$refs.RefScrollProductoCompra.clientHeight
              this.$refs.RefScrollProductoCompra.scrollTop = ((maxScroll * porcentaje))

              if ((maxScroll * porcentaje) >= (maxScroll - 150) && (maxScroll * porcentaje) <= (maxScroll)) {
                this.$refs.RefScrollProductoCompra.scrollTop = maxScroll
              } else {
                this.$refs.RefScrollProductoCompra.scrollTop = ((maxScroll * porcentaje))
              }

              // Altura de cada registro (en píxeles)
              //const alturaRegistro = 50; // ajusta esto según tu diseño(this.windowSizeCaja.height)
              // Calcula el total a mover en píxeles
              // const pixelesScroll = registrosVisibles * this.windowSizeCaja.height;
              // this.$refs.RefScrollProductoCompra.scrollTop += 35;


            } else {
              this.selected = JSON.parse(
                JSON.stringify(this.RProductoCompra[VarCompInddx - 1]),
              )
            }
            return 0
          }

          //key: "Delete"keyCode: 46
          if (e.keyCode == 46) {

            var selc = JSON.parse(JSON.stringify(this.selected))
            this.productoSeleccionado = JSON.parse(JSON.stringify(selc))
            var _this = this
            setTimeout(function() {
              _this.eliminarInfProductoCompra()
            }, 500)
          }

          if (e.keyCode == 117) {
            this.EditProdCompa = true
            var selc = JSON.parse(JSON.stringify(this.selected))
            this.productoSeleccionado = JSON.parse(JSON.stringify(selc))
            this.PanelMenuOpcionCompleto = false
            this.PanelSelectProducto = false
            this.PanelInfProduct = true
            this.$refs.RefScrollProductoCompra.scrollTop = 0
            var _this = this
            setTimeout(function() {
              _this.$refs.RefTextFieldProductoPrecio.focus()
              _this.getExistProdXAlmacen()
              _this.getProductoSustitutos()
            }, 500)
            return 0
          }


        }
      }
    },

    async ActualizarProductPago() {
      ///--problema aqui
      if (this.Totales.totalGeneral.total == 0 && this.Totales.totalGeneral.cobertura == 0) {
        return 0
      }

      /*   this.loading(true)
         var _this = this;
         setTimeout(function () {
           _this.LimpiaInfProducto()
         }, 500);*/

      const result = await this.LimpiaInfProducto()
      return new Promise(resolve => {
        setTimeout(() => {
          resolve("resolved")
        }, 500)
      })

    },
    condicionByPago() {
      if (this.clienteFactura == null) {
        this.filtroTipoCliente = 1
        this.OpenDialogCrearEditarCliente()
      }
    },
    // Tomando el valor del campo de entrada y agregándolo al valor del campo cxc completand el valor del faltante.
    enterCxc() {
      var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.cxc),
        )
      }
      this.Facturasventa.cxc = Objefc
      this.calcularDevuelta()
    },
    // Tomando el valor de la entrada y sumándolo al valor de la variable para saver el valor efectivo.
    enterEfectivo() {
      var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.efectivo),
        )
      }
      this.Facturasventa.efectivo = Objefc
      //this.Facturasventa.efectivo = this.Totales.totalGeneral.total
      this.calcularDevuelta()
    },
    //  //  convierte la devuelta de la Nota de credito para poner el monto restante a el campo faltante.
    enterNC() {
      var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.valorNc),
        )
      }
      this.Facturasventa.valorNc = Objefc

      this.calcularDevuelta()
    },
    // Tomando el valor de la entrada y agregándolo al objeto del pago de tarjeta.
    enterTarjeta() {
      var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.tarjeta),
        )
      }

      this.Facturasventa.tarjeta = Objefc
      this.calcularDevuelta()
    },
    // Tomando el valor de la entrada de cheques y sumándolo al valor de la entrada devuelta.
    enterCheque() {
      var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.cheques),
        )
      }
      this.Facturasventa.cheques = Objefc
      this.calcularDevuelta()
    },
    // convierte la devuelta de la conduce para poner el monto restante a el campo faltante.
    enterConduce() {
      var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.valorConduce),
        )
      }
      this.Facturasventa.valorConduce = Objefc
      this.calcularDevuelta()
    },
    //  convierte la devuelta de la cupones para poner el monto restante a el campo faltante.
    enterCupones() {
      var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.cupones),
        )
      }
      this.Facturasventa.cupones = Objefc
      this.calcularDevuelta()
    },
    // convierte la devuelta de la tranferencia para poner el monto restante a el campo.
    enterTransferencia() {
      var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.transferencia),
        )
      }

      this.Facturasventa.transferencia = Objefc
      this.calcularDevuelta()
    },

    // Tomando el valor de la entrada y sumándolo al valor de la variable para saver el valor punto.
    enterPunto() {
      var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.puntos),
        )
      }
      this.Facturasventa.puntos = Objefc
      //this.Facturasventa.efectivo = this.Totales.totalGeneral.total
      this.calcularDevuelta()
    },


enterBonogas(){
      var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.valorbonogas),
        )
      }

      this.Facturasventa.valorbonogas = Objefc
      this.calcularDevuelta()
    },

enterAsignaciones(){

  var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.valorasignacion),
        )
      }

      this.Facturasventa.valorasignacion = Objefc
      this.calcularDevuelta()
},


enterPruebaMetro(){

  var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.valorPruebaMetro),
        )
      }

      this.Facturasventa.valorPruebaMetro = Objefc
      this.calcularDevuelta()
},
    

enterTraspaso(){

  var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.valorTraspaso),
        )
      }

      this.Facturasventa.valorTraspaso = Objefc
      this.calcularDevuelta()
},


enterDonacion(){

  var Objefc = 0
      if (this.devuelta < 0) {
        Objefc = JSON.parse(
          JSON.stringify(this.devuelta * -1 + this.Facturasventa.valordonacion),
        )
      }

      this.Facturasventa.valordonacion = Objefc
      this.calcularDevuelta()
},

    // Un método que se llama cuando el usuario abandona el campo de entrada.
    BlurEfectivoPago() {
      if (this.Facturasventa.efectivo < 0) {
        this.Facturasventa.efectivo = 0
        this.calculostotales()
      }
    },

    BlurTarjetaPago() {
      if (this.Facturasventa.tarjeta < 0) {
        this.Facturasventa.tarjeta = 0
        this.calculostotales()
      }
    },
    // Un método que se llama cuando el usuario abandona el campo de entrada.
    BlurChequesPago() {
      if (this.Facturasventa.cheques < 0) {
        this.Facturasventa.cheques = 0
        this.calculostotales()
      }
    },

    BlurTransferenciaPago() {
      if (this.Facturasventa.transferencia < 0) {
        this.Facturasventa.transferencia = 0
        this.calculostotales()
      }
    },
    BlurCxcPago() {
      if (this.Facturasventa.cxc < 0) {
        this.Facturasventa.cxc = 0
        this.calculostotales()
      }

      var QUITAR_DESC = this.$store.getters.GetConfiguracionGeneral.configPv.quitarDescuentoClienteCredito
      if (QUITAR_DESC != null && QUITAR_DESC == true) {
        if (this.Facturasventa.cxc > 0 && this.Totales.totalGeneral.descuento > 0) {
          this.dialogNotifQuitarDescuentoCliente = true
          return
        }
      }


    },

    BlurCuponesPago() {
      if (this.Facturasventa.cupones < 0) {
        this.Facturasventa.cupones = 0
        this.calculostotales()
      }
    },
    BlurConducePago() {
      if (this.Facturasventa.valorConduce < 0) {
        this.Facturasventa.valorConduce = 0
        this.calculostotales()
      }
    },
    BlurValorNcPago() {
      if (this.Facturasventa.valorNc < 0) {
        this.Facturasventa.valorNc = 0
        this.calculostotales()
      }
    },

// Un método que se llama cuando el usuario abandona el campo de entrada.
    BlurPuntos() {
      if (this.Facturasventa.puntos < 0) {
        this.Facturasventa.puntos = 0
        this.calculostotales()
      }
    },


    // Activa conduce a credito
    btnActivaInactivaConduceCredito() {
      this.activaConduceCredito = !this.activaConduceCredito

      if (this.activaConduceCredito == true) {
        this.Facturasventa.efectivo = 0
        this.Facturasventa.tarjeta = 0
        this.Facturasventa.cheques = 0
        this.Facturasventa.transferencia = 0
        this.Facturasventa.cxc = 0
        this.Facturasventa.puntos = 0
        this.Facturasventa.valorbonogas=0
        this.Facturasventa.valorasignacion=0
        this.Facturasventa.valorPruebaMetro=0
        this.Facturasventa.valorTraspaso=0
        this.Facturasventa.valordonacion=0
        // this.Facturasventa.cupones=0
        this.Facturasventa.valorNc = 0
        this.Facturasventa.numtar = null
        this.tipoTarjeta = null
        this.bancoCheque = null
        this.Facturasventa.numeroCheque = ""
      }

      this.calculostotales()


    },


    // Cálculo del cambio a devolver al cliente.
    calcularDevuelta() {


      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)
      var tot = this.RedondeoBasico(
        (
          this.Facturasventa.efectivo +
          this.Facturasventa.cxc +
          this.Facturasventa.cupones +
          this.Facturasventa.puntos +
          this.Facturasventa.transferencia +
          this.Facturasventa.valorNc +
          this.Facturasventa.cheques +
          this.Facturasventa.valorConduce +
          this.Facturasventa.tarjeta +
          this.Facturasventa.valorbonogas+
          this.Facturasventa.valorasignacion+
          this.Facturasventa.valorPruebaMetro+
          this.Facturasventa.valorTraspaso+
          this.Facturasventa.valordonacion) * MONEDAFACTURA,
      )

      this.devuelta = Math.round((tot - this.Totales.totalGeneral.total) * 100) / 100

      /*  return new Promise(resolve => {
    setTimeout(() => {
      resolve('resolved');
    }, 2000);
  });*/


      /*   var _this = this;
             setTimeout(function () {
                _this.loading(false)
             }, 300);*/

    },
    buscardor(e) {
      clearTimeout(0)
      // setTimeout(this.SeachFilProducto(e),300);
      //this.SeachFilProducto(e);
    },


    SeachFilkeyEnterProd(e) {
      this.SeachFilProducto(e)
    },


    SelectMarcaProductoKeyNofluido(e) {

      // @keydown="SelectMarcaProducto"
      //key: "ArrowUp"keyCode: 38
      //key: "ArrowDown"keyCode: 40
      //key: "Delete"keyCode: 46
      //key: "F6"keyCode: 117
      //key: "Enter"keyCode: 13

      if (this.selected != null && e.keyCode == 13) {
        this.SelectMarcaProducto(e)
        return
      }

      // var pru=(e.keyCode != 38 && e.keyCode != 40 && e.keyCode != 46 && e.keyCode != 117)
      // console.log(pru)

      if (e.keyCode != 38 && e.keyCode != 40 && e.keyCode != 46 && e.keyCode != 117) {
        this.selected = null
        if (e.keyCode != 13) {
          this.programarPrecargaBusquedaProductoEnter()
        }
        return
      }

      this.SelectMarcaProducto(e)


    },

    // Una función que se ejecuta cuando el usuario ingresa un valor en la entrada, la función se
    // ejecuta y el valor se envía al backend, el backend devuelve los datos y los datos se muestran en
    // la entrada.
    SeachFilProducto(e) {

      //Enter:13,ArrowUp:38,ArrowDown:40
      if (e.keyCode != 13 && e.keyCode != 38 && e.keyCode != 40) {
        this.selected = null
      }
      /*var MODALIDAD_CLI_PRE=this.$store.getters.GetConfiguracionGeneral.configPv.modalidadClientePreferencial
      console.log('viendo-->',MODALIDAD_CLI_PRE)
      console.log('viendo-->',e.target.value)*/


      var MODALIDAD_CLI_PRE = this.$store.getters.GetConfiguracionGeneral.configPv.modalidadClientePreferencial
      if (MODALIDAD_CLI_PRE == true) {
        var BANDERA_CODBAR_CLI_PRE = this.$store.getters.GetConfiguracionGeneral.configPv.banderaCodigoBarraPreferencial
        //key: "Enter"keyCode: 13
        if (e.keyCode == 13) {
          if (e.target.value.substr(0, 2) === BANDERA_CODBAR_CLI_PRE) {
            this.calcularDevuelta()
            this.SeachTextFilBarraPreferencial(e.target.value)
            return
          }
        }
      }

      var BUS_CODIGO_BARR_REF = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaPorCodigobarraReferencia
      if (BUS_CODIGO_BARR_REF && e.target.value.substr(0, 2) === "**") {
        //console.log('Desc-->',e.target.value.substr(2).trim())
        this.SeachProductoBusquedaConsulta(e.target.value.substr(2).trim().replaceAll("/", "*-S-*"))
        return

      }

      var BUSQUEDA_FLUIDA = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaFluido
      if (BUSQUEDA_FLUIDA == true && MODALIDAD_CLI_PRE == false) {
        this.calcularDevuelta()
        if (e.keyCode == 13) {
          var textoBusqueda = e.target.value.trim()
          if (textoBusqueda.length == 0) {
            return
          }
          clearTimeout(this.timeoutBuscarProductoFluida)
          this.ejecutarBusquedaProductoFluida(textoBusqueda)
          return
        }
        this.SeachProductoFluida()

      } else {
//key: "Enter"keyCode: 13
        if (e.keyCode == 13) {
          if (e.target.value.trim().length == 0) {
            return
          }

          //console.log('viendo-->',e.target.value)
          this.calcularDevuelta()
          // this.disabledTextFieldProducto=true
          this.SeachProducto()
          if (
            e.keyCode != 38 &&
            e.keyCode != 40 &&
            e.keyCode != 13 &&
            e.keyCode != 46
          ) {
            this.NewproductoSeleccionado()
          }
        }
      }


    },


    SeachProductoBtnMovilNofluido() {
      console.log("SeachProductoBtnMovilNofluido", this.$refs.RefTextFieldProducto.internalSearch.trim())
//  @click="SeachProducto"
      //

      this.$refs.RefTextFieldProducto.blur()
      var _this = this
      setTimeout(function() {
        _this.SeachProducto()
      }, 500)
      return

      if (this.$refs.RefTextFieldProducto.internalSearch.trim().length == 0) {
        return
      }
      this.RallProducto = []
      var USAR_BUSQ_UNID = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaPorUnidades
      var link = `${this.$hostname + this.$hName}`
      if (USAR_BUSQ_UNID == null || USAR_BUSQ_UNID == false) {
        link += `/unidades-productos/${this.$refs.RefTextFieldProducto.internalSearch.trim().replaceAll("/", "*-S-*")}/false/${this.caja.sucursal.codigo}/buscar`
        // this.$hostname +this.$hName +"/unidades-productos/" +this.$refs.RefTextFieldProducto.value +"/false/" + this.caja.sucursal.codigo + "/buscar"
      } else {
        var USAR_MINIMA = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaUnidadMinima
        // link+=`/unidades-productos/${this.$refs.RefTextFieldProducto.internalSearch.trim().replaceAll('/', '*-S-*')}/false/${this.caja.sucursal.codigo}/buscar/true`
        link += `/unidades-productos/${this.$refs.RefTextFieldProducto.internalSearch.trim().replaceAll("/", "*-S-*")}/false/${this.caja.sucursal.codigo}/buscar/${USAR_MINIMA}`

      }
      //{qrt}/{bandera}/buscar/{minima}

      this.$axios
        .get(
          link,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
            //  this.RallProducto = res.data
            // &&res.data[0].productos.controlado==false
            var _this = this
            if (res.data.length == 1) {
              this.disabledTextFieldProducto = true
              this.selected = res.data[0]
              this.RallProducto = res.data
              this.BuscPropiedadProductoSelct(res.data[0], "add")
              if (res.data[0].productos.controlado == true) {
                this.selecteTemRecCont = res.data[0]
              }

              setTimeout(function() {
                _this.disabledTextFieldProducto = false
                // _this.$refs.RefTextFieldProducto.focus();
              }, 2000)

            } else {
              this.disabledTextFieldProducto = false
              this.RallProducto = res.data
            }

            var _this = this
            setTimeout(function() {
              _this.$refs.RefTextFieldProducto.blur()
            }, 300)

          },
        )

    },


    programarPrecargaBusquedaProductoEnter() {
      clearTimeout(this.timeoutBuscarProductoEnter)
      this.timeoutBuscarProductoEnter = setTimeout(() => {
        if (this.debeGuardarFacturaOffline() ||
          this.$store.getters.GetConfiguracionGeneral.configPv.busquedaFluido == true ||
          this.$store.getters.GetConfiguracionGeneral.configPv.modalidadClientePreferencial == true) {
          return
        }

        var texto = this.$refs.RefTextFieldProducto != null && this.$refs.RefTextFieldProducto.value != null
          ? this.$refs.RefTextFieldProducto.value.trim()
          : ""

        if (texto.length < 3 || texto.substr(0, 2) === "**") {
          return
        }

        var ACTIVAR_BANDERA_PESO = this.$store.getters.GetConfiguracionGeneral.configPv.activarBanderaPeso
        var BANDERA_PESO = this.$store.getters.GetConfiguracionGeneral.configPv.banderapeso
        if (ACTIVAR_BANDERA_PESO == true && texto.substr(0, 2) === BANDERA_PESO) {
          return
        }

        var USAR_BUSQ_UNID = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaPorUnidades
        var link = this.$hostname + this.$hName + "/unidades-productos/" + texto.replaceAll("/", "*-S-*") + "/false/" + this.caja.sucursal.codigo + "/buscar"
        if (USAR_BUSQ_UNID == true) {
          var USAR_MINIMA = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaUnidadMinima
          link += "/" + USAR_MINIMA
        }

        if (this.cacheBusquedaProducto[link] != null || this.busquedaProductoEnCurso[link] != null ||
          this.precargaProductoEnCurso[link] != null) {
          return
        }

        var tokenPrecarga = this.ultimaBusquedaProductoEnter
        var solicitud = this.$axios.get(link, { headers: this.$store.getters.GetheadersAxios, timeout: 8000 })
        this.precargaProductoEnCurso[link] = solicitud
        solicitud
          .then((res) => {
            if (tokenPrecarga == this.ultimaBusquedaProductoEnter) {
              this.cacheBusquedaProducto[link] = JSON.parse(JSON.stringify(res.data))
            }
          })
          .catch(() => {})
          .finally(() => {
            if (this.precargaProductoEnCurso[link] === solicitud) {
              delete this.precargaProductoEnCurso[link]
            }
          })
      }, 180)
    },


    solicitarBusquedaProductoOnline(link) {
      if (this.busquedaProductoEnCurso[link] != null) {
        return this.busquedaProductoEnCurso[link]
      }

      var precarga = this.precargaProductoEnCurso[link]
      var cache = this.cacheBusquedaProducto[link]
      var solicitud = precarga != null && cache == null
        ? precarga.then(res => this.refrescarExistenciasBusquedaProducto(link, res.data))
        : this.refrescarExistenciasBusquedaProducto(link, cache)
      var pendiente = solicitud.finally(() => {
        if (this.busquedaProductoEnCurso[link] === pendiente) {
          delete this.busquedaProductoEnCurso[link]
        }
      })
      this.busquedaProductoEnCurso[link] = pendiente
      return pendiente
    },


    refrescarExistenciasBusquedaProducto(link, cache) {
      // Los codigos con lote y la bandera de peso conservan su consulta original.
      var refrescarBalance = Array.isArray(cache) && cache.length > 0 &&
        !/\/true\/\d+\/buscar/.test(link) && cache.every(item =>
          (item.lote == null || String(item.lote).trim() === "") &&
          item.unidadesProductosPK != null && item.unidadesProductosPK.producto > 0)
      var productos = refrescarBalance
        ? [...new Set(cache.map(item => item.unidadesProductosPK.producto))] : []
      var opciones = { headers: this.$store.getters.GetheadersAxios, timeout: 8000 }
      if (refrescarBalance && productos.length <= 200) {
        return this.$axios.post(
          this.$hostname + this.$hName + "/unidades-productos/existencias-pos/" + this.caja.sucursal.codigo,
          productos, opciones,
        ).then(res => {
          if (!Array.isArray(res.data) || res.data.some(saldo => !Number.isFinite(saldo.existencias))) {
            throw new Error("Respuesta de existencias invalida")
          }
          var saldos = new Map(res.data.map(saldo => [saldo.producto + "|" + saldo.unidad, saldo.existencias]))
          var data = JSON.parse(JSON.stringify(cache)).filter(item => {
            var pk = item.unidadesProductosPK
            var key = pk.producto + "|" + pk.unidad
            if (!saldos.has(key)) return false
            item.existencias = saldos.get(key)
            return true
          })
          return { data }
        })
      }
      return this.$axios.get(link, opciones)
    },


    SeachProducto() {

      //console.log('inf-->-SeachProducto',this.$refs.RefTextFieldProducto)

      //Nota: this.$refs.RefTextFieldProducto.value.trim().replaceAll('/', '*-S-*') esto es para que los get no den error
      //
      // console.log('--viendo Informacion--',this.$refs.RefTextFieldProducto.value.trim().replaceAll('/', '*-S-*'))
      // this.$store.getters.GetConfiguracionGeneral.configPv.busquedaUnidadMinima
      clearTimeout(this.timeoutBuscarProductoEnter)
      var tokenBusquedaEnter = ++this.ultimaBusquedaProductoEnter
      if (this.$refs.RefTextFieldProducto.value.trim().length == 0) {
        this.RallProducto = []
        return
      }
      this.RallProducto = []
      var USAR_BUSQ_UNID = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaPorUnidades
      var USAR_MINIMA = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaUnidadMinima
      var ACTIVAR_BANDERA_PESO = this.$store.getters.GetConfiguracionGeneral.configPv.activarBanderaPeso
      var cantBarraPESO=null
      var V_BANDERA=false

      var DES_PRODUC=JSON.parse(JSON.stringify(this.$refs.RefTextFieldProducto.value.trim()))
      var ACTIVAR_BANDERA_PESO = this.$store.getters.GetConfiguracionGeneral.configPv.activarBanderaPeso


        if (ACTIVAR_BANDERA_PESO == true) { 
          var BANDERA_PESO = this.$store.getters.GetConfiguracionGeneral.configPv.banderapeso.trim()

          if (DES_PRODUC.substr(0, 2) === BANDERA_PESO) {
            V_BANDERA=true
            cantBarraPESO =  Number(DES_PRODUC.substr(8,4).slice(0, 2) + "." + DES_PRODUC.substr(8,4).slice(2));
            DES_PRODUC=DES_PRODUC.substr(2,5)
          } 
       }

      
      var link = `${this.$hostname + this.$hName}`
      if (USAR_BUSQ_UNID == null || USAR_BUSQ_UNID == false) {
        link += `/unidades-productos/${DES_PRODUC.replaceAll("/", "*-S-*")}/${V_BANDERA}/${this.caja.sucursal.codigo}/buscar`
        // this.$hostname +this.$hName +"/unidades-productos/" +this.$refs.RefTextFieldProducto.value +"/false/" + this.caja.sucursal.codigo + "/buscar"
      } else {
        // console.log('viendoo-DESC->',this.$refs.RefTextFieldProducto.value.trim())
        // link+=`/unidades-productos/${this.$refs.RefTextFieldProducto.value.trim().replaceAll('/', '*-S-*')}/false/${this.caja.sucursal.codigo}/buscar/true`
        link += `/unidades-productos/${DES_PRODUC.replaceAll("/", "*-S-*")}/${V_BANDERA}/${this.caja.sucursal.codigo}/buscar/${USAR_MINIMA}`
      }
      //{qrt}/{bandera}/buscar/{minima}

      if (this.debeGuardarFacturaOffline()) {
        this.buscarProductosOfflineBusqueda(link, DES_PRODUC)
        return
      }

      var procesarResultado = (datos) => {
        if (tokenBusquedaEnter != this.ultimaBusquedaProductoEnter) {
          return
        }

        var resultado = JSON.parse(JSON.stringify(datos))
        if (ACTIVAR_BANDERA_PESO == true && V_BANDERA == true && cantBarraPESO != null) {
          resultado = resultado.map(item => ({ ...item, cantidad: cantBarraPESO }))
        }

        if (resultado.length == 1) {
          this.disabledTextFieldProducto = true
          this.selected = resultado[0]
          this.RallProducto = resultado
          this.BuscPropiedadProductoSelct(resultado[0], "add")
          if (resultado[0].productos.controlado == true) {
            this.selecteTemRecCont = resultado[0]
          }

          var _this = this
          setTimeout(function() {
            _this.disabledTextFieldProducto = false
          }, 2000)

          setTimeout(function() {
            _this.RedireccionFocus("RefTextFieldProducto")
          }, 2500)
        } else {
          this.disabledTextFieldProducto = false
          this.RallProducto = resultado
        }
      }

      return this.solicitarBusquedaProductoOnline(link)
        .then((res) => {
          if (tokenBusquedaEnter != this.ultimaBusquedaProductoEnter) return
          this.desactivarModoOfflineForzado()
          this.cacheBusquedaProducto[link] = JSON.parse(JSON.stringify(res.data))
          this.guardarProductosOfflineBusqueda(link, DES_PRODUC, res.data)
          procesarResultado(res.data)
        })
        .catch((error) => {
          if (this.esErrorConexionPv(error) && tokenBusquedaEnter == this.ultimaBusquedaProductoEnter) {
            this.activarModoOfflinePorErrorConexion(error)
            this.buscarProductosOfflineBusqueda(link, DES_PRODUC)
          }
          if (tokenBusquedaEnter == this.ultimaBusquedaProductoEnter) {
            this.disabledTextFieldProducto = false
            if (!this.esErrorConexionPv(error)) {
              this.alerta("No fue posible actualizar la existencia. Intente buscar nuevamente.", "error")
            }
          }
        })
    },


    SeachProductoFluida() {
      //Nota: this.$refs.RefTextFieldProducto.value.trim().replaceAll('/', '*-S-*') esto es para que los get no den error
      // this.$store.getters.GetConfiguracionGeneral.configPv.busquedaUnidadMinima
      ++this.ultimaBusquedaProductoFluida
      var textoBusqueda = this.$refs.RefTextFieldProducto.value.trim()
      if (textoBusqueda.length == 0) {
        clearTimeout(this.timeoutBuscarProductoFluida)
        this.RallProducto = []
        return
      }

      clearTimeout(this.timeoutBuscarProductoFluida)
      this.timeoutBuscarProductoFluida = setTimeout(() => {
        this.ejecutarBusquedaProductoFluida(textoBusqueda)
      }, 250)

    },


    ejecutarBusquedaProductoFluida(textoBusqueda) {
      var tokenBusqueda = ++this.ultimaBusquedaProductoFluida
      this.RallProducto = []
      var texto = textoBusqueda.replaceAll("/", "*-S-*")

      var USAR_BUSQ_UNID = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaPorUnidades

      var link = `${this.$hostname + this.$hName}`
      if (USAR_BUSQ_UNID == null || USAR_BUSQ_UNID == false) {
        link += `/unidades-productos/${texto}/false/${this.caja.sucursal.codigo}/buscar`
        // this.$hostname +this.$hName +"/unidades-productos/" +this.$refs.RefTextFieldProducto.value +"/false/" + this.caja.sucursal.codigo + "/buscar"
      } else {
        var USAR_MINIMA = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaUnidadMinima
        // link+=`/unidades-productos/${this.$refs.RefTextFieldProducto.value.trim().replaceAll('/', '*-S-*')}/false/${this.caja.sucursal.codigo}/buscar/true`
        link += `/unidades-productos/${texto}/false/${this.caja.sucursal.codigo}/buscar/${USAR_MINIMA}`
      }
      //{qrt}/{bandera}/buscar/{minima}

      var CACHE_KEY = link
      if (this.debeGuardarFacturaOffline()) {
        this.buscarProductosOfflineBusqueda(CACHE_KEY, textoBusqueda)
        return
      }
      return this.solicitarBusquedaProductoOnline(link)
        .then((res) => {
          //  this.RallProducto = res.data
          // &&res.data[0].productos.controlado==false
          if (tokenBusqueda != this.ultimaBusquedaProductoFluida) {
            return
          }
          this.desactivarModoOfflineForzado()
          this.RallProducto = res.data
          this.cacheBusquedaProducto[CACHE_KEY] = JSON.parse(JSON.stringify(res.data))
          this.guardarProductosOfflineBusqueda(CACHE_KEY, textoBusqueda, res.data)
        })
        .catch((error) => {
          if (this.esErrorConexionPv(error) && tokenBusqueda == this.ultimaBusquedaProductoFluida) {
            this.activarModoOfflinePorErrorConexion(error)
            this.buscarProductosOfflineBusqueda(CACHE_KEY, textoBusqueda)
          } else if (tokenBusqueda == this.ultimaBusquedaProductoFluida) {
            this.alerta("No fue posible actualizar la existencia. Intente buscar nuevamente.", "error")
          }
        })
    },

    validarBusProductoBarraReferencia(DESCPROD) {
      var BOOL = false
      var BUS_CODIGO_BARR_REF = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaPorCodigobarraReferencia
      if (typeof DESCPROD === "string" && BUS_CODIGO_BARR_REF && DESCPROD.substr(0, 2) === "**") {
        var PERM_AGR_PROD_BUS_REF = this.$store.getters.GetConfiguracionGeneral.configPv.permitirAgregarProductoBusquedaReferencia
        if(PERM_AGR_PROD_BUS_REF==true){
          BOOL = false
        }else{
          BOOL = true
        }
        
      }
      return BOOL
    },

    validarBusProductoExisteLote(props){
      var BOOL = false
         //console.log('props-->',props)
        var PerNegat= this.$store.getters.GetConfiguracionGeneral.configInv.permitirNegativos
        var UsarLote = this.$store.getters.GetConfiguracionGeneral.configInv.usarLote
        var sumaExist = props.listExistenciaAlmacen.reduce((total, item) => total + item.existencion, 0);
        if(PerNegat==false && UsarLote==true && sumaExist==0){
          BOOL=true
        }
       return BOOL
    },

    mostrarReferencia(ITEM) {
         var Desc = ""
  
        if(ITEM.productos.hasOwnProperty('referencia')&& ITEM.productos.referencia!=null && ITEM.productos.referencia.trim().length>0){
        Desc = `${ITEM.productos.referencia.trim()}`
        }else{
        Desc = "N/A"
        }

      // props.item.productos.fabricante.nombre.trim()
      return Desc
    },

    SeachProductoBusquedaConsulta(DESC) {
      // this.$store.getters.GetConfiguracionGeneral.configPv.busquedaUnidadMinima
      if (this.$refs.RefTextFieldProducto.value.trim().length == 0) {
        return
      }

      var USAR_BUSQ_UNID = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaPorUnidades

      var link = `${this.$hostname + this.$hName}`
      if (USAR_BUSQ_UNID == null || USAR_BUSQ_UNID == false) {
        link += `/unidades-productos/${DESC}/false/${this.caja.sucursal.codigo}/buscarConsulta`
        // this.$hostname +this.$hName +"/unidades-productos/" +this.$refs.RefTextFieldProducto.value +"/false/" + this.caja.sucursal.codigo + "/buscar"
      } else {
        var USAR_MINIMA = this.$store.getters.GetConfiguracionGeneral.configPv.busquedaUnidadMinima
        // link+=`/unidades-productos/${DESC}/false/${this.caja.sucursal.codigo}/buscar/true`
        link += `/unidades-productos/${DESC}/false/${this.caja.sucursal.codigo}/buscar/${USAR_MINIMA}`
      }
      //{qrt}/{bandera}/buscar/{minima}

      this.$axios
        .get(
          link,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.RallProducto = res.data
        })
    },

    SelctCbProduc() {
      if (this.producto == null) {
        this.producto = ""
      }
      if (this.producto.codigo == undefined) {
        this.alerta("Seleccione un producto", "error")
        this.producto = ""
        return
      }
    },
    ChangeProductoselectValorPorcc() {
      // if(e==true){this.productoSeleccionado.descuento=0
      // }else{this.productoSeleccionado.descuentoValor=0}
    },

    // Comprobando si el usuario tiene permiso para cambiar la cantidad de un producto.
    FocusProductoCantidad() {
      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv("AccCambioCantidadProd")
        return
      }

    },
    // Comprobar si el usuario tiene permiso para cambiar el precio de un producto.
    FocusProductoPrecio() {
      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv("AccCambioPrecioProd")
        return
      }

    },
    FocusProductoDescuento() {
      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv("AccCambiarDescuentoProd")
        return
      }

    },

    FocusProductoRecargo() {
      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv("AccCambiarRecargoProd")
        return
      }

    },

    async getRulesProductoPrecio() {

      if (this.PanelInfProduct == false) {
        this.boolRuleprodprecio = false
        return false
      } else {
        var BOOL = await this.$refs.RefPvMenuOpcionBotones.EjecutVerificarPermiso("AccCambiarProductoAOferta")
        this.boolRuleprodprecio = BOOL
        return BOOL
      }

    },

    enterPrecioProdSelect() {
      this.EjecutarPermisoPv = false
      var _this = this
      setTimeout(function() {
        if (_this.productoSeleccionado.precio != _this.productoSeleccionado.precioOrig) {
          _this.boolEnterPrecioProdSelect = true
          _this.blurPrecioProductoSelecc()
        } else {
          _this.SalvarProductoCompraEnter()
        }
      }, 300)

    },

    async blurPrecioProductoSelecc() {
      var Config = this.$store.getters.GetConfiguracionGeneral

      if (Config.configPv.hasOwnProperty("bajaPrecioDescuentoMaxProducto") && Config.configPv.bajaPrecioDescuentoMaxProducto == true) {
        var _this = this
        setTimeout(function() {

          if (_this.productoSeleccionado.productos.hasOwnProperty("descuento") && _this.productoSeleccionado.productos.descuento != null && _this.productoSeleccionado.productos.descuento > 0) {
            var precDescMax = (_this.productoSeleccionado.precioOrig - ((_this.productoSeleccionado.precioOrig * _this.productoSeleccionado.productos.descuento) / 100))
            if (_this.productoSeleccionado.precio < precDescMax) {
              _this.alerta(`Precio minimo del producto es $.${_this.currencyFormatter2(_this.getTasaMonedaSelect(precDescMax))} `, "warning")
              _this.productoSeleccionado.precio = JSON.parse(JSON.stringify(precDescMax))
              _this.productoSeleccionado.precioDig = JSON.parse(JSON.stringify(precDescMax))
            } else {
              _this.productoSeleccionado.precioDig = JSON.parse(JSON.stringify(_this.productoSeleccionado.precio))
            }

          }


        if (_this.boolEnterPrecioProdSelect == true) {
            _this.SalvarProductoCompraEnter()
          }

        }, 300)

      } else {

        var BOOL = await this.$refs.RefPvMenuOpcionBotones.EjecutVerificarPermiso("AccCambiarPrecioProductoBajoPrecioActual")
        var _this = this
        setTimeout(function() {
          if (BOOL == false && _this.productoSeleccionado.precio < _this.productoSeleccionado.precioOrig) {
            _this.EjecutarPermisoPv = true
            _this.rulePrecioProdBajoPrecio = JSON.parse(JSON.stringify(_this.productoSeleccionado.precio))
            _this.productoSeleccionado.precio = JSON.parse(JSON.stringify(_this.productoSeleccionado.precioOrig))
            _this.funcionValidaPermisoPv("AccCambiarPrecioProductoBajoPrecioActual")
            return
          } else {

            _this.productoSeleccionado.precioDig = JSON.parse(JSON.stringify(_this.productoSeleccionado.precio))
            if (_this.boolEnterPrecioProdSelect == true) {
              setTimeout(function() {
                _this.SalvarProductoCompraEnter()
              }, 100)
            }
          }
        }, 300)

      }

      /*precio: 1200
precioDig: 1200
precioOrig: 1300.78*/

      /*var _this=this;
setTimeout(function(){
  _this.productoSeleccionado.precioDig=JSON.parse(JSON.stringify(_this.productoSeleccionado.precio));
}, 300);*/

    },

    // Verificar si el producto está controlado y si el producto está controlado es verificar si la
    // cantidad es mayor a la prescrita.
    ValidaRecetaProduControlado() {
      //alert('Hola')

      if (this.productoSeleccionado.productos != null) {
        if (this.productoSeleccionado.productos.controlado == true
          && this.RecetaProdControlado.detalleList.length > 0) {
          this.productoSeleccionado.productos.codigo
          this.productoSeleccionado.unidades.codigo
          /*console.log(this.RecetaProdControlado.detalleList)
console.log("CodiPro:"+this.productoSeleccionado.productos.codigo)
console.log("UniPro:"+this.productoSeleccionado.unidades.codigo)*/
          var ObjProRow = this.RecetaProdControlado.detalleList.filter(
            (e) =>
              e.productos.codigo ==
              this.productoSeleccionado.productos.codigo &&
              e.unidad.codigo == this.productoSeleccionado.unidades.codigo,
          )[0]
          if (this.productoSeleccionado.cantidad + ObjProRow.cantidadDespachada > ObjProRow.cantidadRecetada) {
            //  this.productoSeleccionado.cantidad = 1;
            this.productoSeleccionado.cantidad = (ObjProRow.cantidadRecetada - ObjProRow.cantidadDespachada)
            this.alerta(
              "La cantidad a despachar esta por encima de la cantiadad recetada",
              "error",
            )

            return
          }
        }
      }

    },

    async SalvarProductoCompraEnter() {
      var Bool_PERM_VENDER_BAJO_COSTO = this.$store.getters.GetConfiguracionGeneral.configPv.venderalcosto
       
      if(Bool_PERM_VENDER_BAJO_COSTO==false && (this.productoSeleccionado.precioDig-this.productoSeleccionado.valordescuento)<this.productoSeleccionado.costo){
          this.alerta("Este producto no se permite vender por debajo del costo actual", "error")
          return
      }
       
      if(this.productoSeleccionado.productos.hasOwnProperty("venderaldetalle") && this.productoSeleccionado.productos.venderaldetalle==false){
        this.productoSeleccionado.cantidad= parseInt(this.productoSeleccionado.cantidad);
      }
      this.productoSeleccionado.productos.venderaldetalle
     

      if (this.clienteFactura == null && this.productoSeleccionado.productos.planBeneficio == true) {
        this.planBeneficio.dialogNotifPlanBeneficio = true
        this.planBeneficio.planBeneficio = true
        this.planBeneficio.objtem = JSON.parse(JSON.stringify(this.productoSeleccionado))
        return
      }
      
     
      if (this.UsarLote == true && this.productoSeleccionado.productos.servicio==false && this.selectedListProdxLote.length == 0) {
        this.alerta("Seleccione un lote al que pertenece el producto", "error")
        return
      }
      if (await this.getRulesProductoPrecio() == true && this.productoSeleccionado.precio == 0) {
        this.AgregarOfertasCompra(this.productoSeleccionado)
        return
      }

      if (this.EjecutarPermisoPv == true) {
        return
      }

      if(this.productoSeleccionado.cobertura>0 && this.productoSeleccionado.cobValorPorc==false){
        var VALOR_COB=(((this.productoSeleccionado.cantidad*this.productoSeleccionado.precioDig)*this.productoSeleccionado.cobertura)/100);
        this.productoSeleccionado.cobertura=this.RedondeoValorCantRed((VALOR_COB), 2)
      }

      this.verficardatos()
      this.ValidaRecetaProduControlado()
      
      this.ValidarProductoOpcionVer(this.productoSeleccionado)
      this.boolEnterPrecioProdSelect = false
       return
      //999
    },

    // Creando un nuevo objeto y asignándolo a la variable productoSeleccionado.
    NewproductoSeleccionado() {
      this.selected = null
      this.productoSeleccionado = {
        cantidad: 1,
        precio: 0,
        descuento: 0,
        vendedor: null,
        recargo: 0,
        ValorPorcRecarg: false,
        cobertura: 0,
        productos: null,
        valor: 0,
        ValorPorc: false,
      }
      this.EjecutarInfSaveProd = true
      this.ejecutarEliminarProd = true
      this.rulePrecioProdBajoPrecio = 0
      this.boolEnterPrecioProdSelect = false
    },

    // Guardando la información del producto en la tabla.
    SalvarInfProducto_ORIGINAL() {

      console.log('viendo-SalvarInfProducto->')
      this.loading(true)

      if (this.EditProdCompa == false) {
        var ProTem = JSON.parse(JSON.stringify(this.productoSeleccionado))
        ProTem.indx = 0

        if (ProTem.hasOwnProperty("omitirRegla")) {
          //  ProTem.omitirRegla=false
        }
        this.RProductoCompra.unshift(JSON.parse(JSON.stringify(ProTem)))
        this.RProductoCompraTemp.unshift(JSON.parse(JSON.stringify(ProTem)))
        this.$refs.RefScroll.scrollTop = 0
        this.$refs.RefScrollProductoCompra.scrollTop = 0
        this.PanelSelectProducto = true
        this.buscarAgregarEliminarOferta(ProTem)
        this.loaderTablaCargar()

        var _this = this
        setTimeout(function() {
          _this.CalcularTotalesProductosCompra()
          _this.LimpiaInfProducto()
        }, 300)
      }


      if (this.EditProdCompa == true) {
        var prods = JSON.parse(JSON.stringify(this.productoSeleccionado))
        if (prods.hasOwnProperty("omitirRegla")) {
          //  prods.omitirRegla=false
        }
        //prods.indx = 0;
        //this.eliminarInfProductoCompra();

        /* prrrruwba
        var ObjRow = this.RProductoCompra.filter((e) => e.indx == this.productoSeleccionado.indx)[0];
        const index = this.RProductoCompra.indexOf(ObjRow);
        this.RProductoCompra.splice(index, 1);
        this.RProductoCompraTemp.splice(index, 1);*/

        let INDX_PRO = this.RProductoCompra.findIndex(ee => ee.indx === this.productoSeleccionado.indx)
        prods.indx = INDX_PRO
        this.RProductoCompra[INDX_PRO] = (JSON.parse(JSON.stringify(prods)))
        this.RProductoCompraTemp[INDX_PRO] = (JSON.parse(JSON.stringify(prods)))
        this.cancelarInfProducto()
        this.buscarAgregarEliminarOferta(prods)
        this.loaderTablaCargar()

        /*
       prrueva
        setTimeout(function () {
          _this.RProductoCompra.unshift(JSON.parse(JSON.stringify(prods)));
          _this.RProductoCompraTemp.unshift(JSON.parse(JSON.stringify(prods)));
          _this.$refs.RefScroll.scrollTop = 0;
          _this.$refs.RefScrollProductoCompra.scrollTop = 0;
        }, 300);

        setTimeout(function () {
          _this.LimpiaInfProducto();
        }, 400);

        */


      }
      this.loading(false)
      //this.LimpiaInfProducto();


      setTimeout(function() {
        _this.$refs.RefTextFieldProducto.focus()
      }, 500)


//NOTA: CUANDO EL PRODCTO ES CONTROLADO se queda el loader
      setTimeout(function() {
        _this.loading(false)
      }, 2000)


      /*setTimeout(function () {
           _this.LimpiaInfProducto();
         }, 400);*/


      //
      /*   if (this.Descuentofactura.DescuentoFacturaGlobal==false) {
         var _this = this;
         setTimeout(function () {
           _this.ReActualizarProductoCompra();
         }, 900);
          }*/

    },

      // Guardando la información del producto en la tabla.
    SalvarInfProducto() {
      this.loading(true)
      var _this = this

      var ProTem = JSON.parse(JSON.stringify(this.productoSeleccionado))
        var boolEstacion= (this.$store.getters.GetConfiguracionGeneral.config.estacion==true || this.$store.getters.GetConfiguracionGeneral.config.estacionCombustible )
       
        if(boolEstacion==true && this.clienteFactura != null && this.clienteFactura.hasOwnProperty('codigo')){
          var desc =0
          if(this.clienteFactura.descuento>0){
            desc= ((ProTem.precioDig*this.clienteFactura.descuento)/100)
           // desc= ((this.clienteFactura.descuentovalor * 100) / (e.precio * e.cantidad))

          }

          if(this.clienteFactura.descuentovalor>0){
          desc=this.clienteFactura.descuentovalor
          }

          ProTem.ValorPorc=true
          ProTem.descuento=(((desc*ProTem.cantidad) * 100) / (ProTem.precioDig * ProTem.cantidad))
          ProTem.descuentoKeys=(desc*ProTem.cantidad)
          ProTem.valordescuento=(desc*ProTem.cantidad)
          ProTem.DescValor=(desc*ProTem.cantidad)
        }


      if (this.EditProdCompa == false) {
        ProTem.indx = 0

        if (ProTem.hasOwnProperty("omitirRegla")) {
          //  ProTem.omitirRegla=false
        }
        this.RProductoCompra.unshift(JSON.parse(JSON.stringify(ProTem)))
        this.RProductoCompraTemp.unshift(JSON.parse(JSON.stringify(ProTem)))
        this.$refs.RefScroll.scrollTop = 0
        this.$refs.RefScrollProductoCompra.scrollTop = 0
        this.PanelSelectProducto = true
        this.buscarAgregarEliminarOferta(ProTem)
        this.loaderTablaCargar()
        this.CalcularTotalesProductosCompra()
        this.LimpiaInfProducto()
      }


      if (this.EditProdCompa == true) {
        // var prods = JSON.parse(JSON.stringify(this.productoSeleccionado))
        if (ProTem.hasOwnProperty("omitirRegla")) {
          //  prods.omitirRegla=false
        }
        //prods.indx = 0;
        //this.eliminarInfProductoCompra();

        /* prrrruwba
        var ObjRow = this.RProductoCompra.filter((e) => e.indx == this.productoSeleccionado.indx)[0];
        const index = this.RProductoCompra.indexOf(ObjRow);
        this.RProductoCompra.splice(index, 1);
        this.RProductoCompraTemp.splice(index, 1);*/

        let INDX_PRO = this.RProductoCompra.findIndex(ee => ee.indx === this.productoSeleccionado.indx)
        ProTem.indx = INDX_PRO
        this.RProductoCompra[INDX_PRO] = (JSON.parse(JSON.stringify(ProTem)))
        this.RProductoCompraTemp[INDX_PRO] = (JSON.parse(JSON.stringify(ProTem)))
        this.cancelarInfProducto()
        this.buscarAgregarEliminarOferta(ProTem)
        this.loaderTablaCargar()
        this.CalcularTotalesProductosCompra()

        /*
       prrueva
        setTimeout(function () {
          _this.RProductoCompra.unshift(JSON.parse(JSON.stringify(prods)));
          _this.RProductoCompraTemp.unshift(JSON.parse(JSON.stringify(prods)));
          _this.$refs.RefScroll.scrollTop = 0;
          _this.$refs.RefScrollProductoCompra.scrollTop = 0;
        }, 300);

        setTimeout(function () {
          _this.LimpiaInfProducto();
        }, 400);

        */


      }
      this.loading(false)
      //this.LimpiaInfProducto();


      setTimeout(function() {
        _this.$refs.RefTextFieldProducto.focus()
      }, 500)


//NOTA: CUANDO EL PRODCTO ES CONTROLADO se queda el loader
      setTimeout(function() {
        _this.loading(false)
      }, 2000)


      /*setTimeout(function () {
           _this.LimpiaInfProducto();
         }, 400);*/


      //
      /*   if (this.Descuentofactura.DescuentoFacturaGlobal==false) {
         var _this = this;
         setTimeout(function () {
           _this.ReActualizarProductoCompra();
         }, 900);
          }*/

    },


    // Una función que se llama cuando un usuario hace clic en un botón.
    async LimpiaInfProducto() {
      this.PanelMenuOpcionCompleto = true
      this.PanelSelectProducto = true
      this.PanelInfProduct = false
      this.searchProducto = ""
      this.ObjRectPro = null
      this.EsNuevoObjRectPro = true
      this.NewproductoSeleccionado()
      var _this = this

      /* prrueva
      const result = await this.ReActualizarProductoCompra();
      return new Promise(resolve => {
        setTimeout(() => {
          resolve('resolved');
        }, 500);
      });*/


    },

    // Eliminando el último elemento de la lista.
    cancelarInfProducto() {

      if (this.EditProdCompa == false && this.EsNuevoObjRectPro == true) {
        if (this.productoSeleccionado.productos != null && this.productoSeleccionado.productos.controlado == true) {
          if (this.RecetaProdControlado.detalleList.length > 1) {
            var size = this.RecetaProdControlado.detalleList.length - 1
            var RectPro = this.RecetaProdControlado.detalleList[size]
            const index = this.RecetaProdControlado.detalleList.indexOf(RectPro)
            this.RecetaProdControlado.detalleList.splice(index, 1)
          } else {
            this.NewRecetaProdCOntrolado()
          }

        }
      }


      this.PanelMenuOpcionCompleto = true
      this.PanelSelectProducto = true
      this.PanelInfProduct = false
      this.searchProducto = ""
      this.ejecutarEliminarProd = true
      this.selecteTemRecCont = null

      this.NewproductoSeleccionado()
      this.NewplanBeneficio()
      var _this = this
      setTimeout(function() {
        _this.$refs.RefTextFieldProducto.focus()
        _this.CalcularTotalesProductosCompra()
      }, 500)
    },

    // Eliminación de un elemento de una lista.
    async eliminarInfProductoCompra() {
      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv("AccEliminarLineaProd")
        return
      }

      // Removiendo Producto controlado de la receta
      /*  if (this.productoSeleccionado.productos.controlado == true) {

          if (this.RecetaProdControlado.detalleList.length > 1) {
            var ObjRow = this.RecetaProdControlado.detalleList.filter((e) => e.productos.codigo == this.productoSeleccionado.productos.codigo
              && e.unidad.codigo == this.productoSeleccionado.unidades.codigo)[0];
            const index = this.RecetaProdControlado.detalleList.indexOf(ObjRow);
            this.RecetaProdControlado.detalleList.splice(index, 1);
          } else {
            this.NewRecetaProdCOntrolado();
          }

        }*/

      //ELIMINAR: Remueve producto a la lista


      if (this.ejecutarEliminarProd == false) {
        return
      }


      var _this = this
      this.ejecutarEliminarProd = false


      setTimeout(function() {
        var ObjProRow = _this.RProductoCompra.filter(
          (ee) => ee.indx == _this.productoSeleccionado.indx)[0]
        const index = _this.RProductoCompra.indexOf(ObjProRow)
        _this.cancelarInfProducto()

        _this.RProductoCompra.splice(index, 1)
        _this.RProductoCompraTemp.splice(index, 1)

        /*var codPro = _this.productoSeleccionado.productos.codigo
      var codUni = _this.productoSeleccionado.unidades.codigo
      var RProTem = JSON.parse(JSON.stringify(_this.RProductoCompraTemp))
      var RProTemBse = JSON.parse(JSON.stringify(_this.RProductoCompraTemp))*/

        /*console.log('RProTem',RProTem)
      console.log('RProTemBse',RProTemBse)*/
        // RProTemBse.forEach((ele) => {});
        // (async () => {   })()
        /* await Promise.all(RProTemBse.map(async (ele) => {
        if (ele.hasOwnProperty("paramOfert") && ele.paramOfert == true) {
          if (ele.ProductoBase.productos.codigo == codPro && ele.ProductoBase.unidades.codigo == codUni) {
            const ix = RProTem.indexOf(ele);
            RProTem.splice(ix, 1);
          }

        }
      }));*/


      }, 400)


      //ELIMINAR: Remueve producto a la lista
      /*     this.RProductoCompra.forEach((element) => {
             if (element.indx == this.productoSeleccionado.indx) {
               const index = this.RProductoCompra.indexOf(element);
               // const index2 =  this.RProductoCompraTemp.indexOf(element)
               this.RProductoCompra.splice(index, 1);
               this.RProductoCompraTemp.splice(index, 1);
               this.cancelarInfProducto();
             }
           }); */


      setTimeout(function() {
        // _this.RProductoCompra = JSON.parse(JSON.stringify(RProTem))
        // _this.RProductoCompraTemp = JSON.parse(JSON.stringify(RProTem))
        _this.CalcularTotalesProductosCompra()
      }, 800)
    },

    // El código anterior es una función que se llama cuando el usuario hace clic en un botón.
    //calcula los decuento automatico de el producto
    // La función se llama ReActualizarProductoCompra()
    // La función se llama cuando el usuario hace clic en un botón.
    async ReActualizarProductoCompra() {
      if (this.Descuentofactura.descuento <= 0) {
        //NOTA: PARA QUE EL TOTAL SE ACTUALICE  y Busque el %DESCUENTO
        this.CalcularTotalesProductosCompra()
      }
      var Totales = this.Totales.totalGeneral
      var cxc = this.Facturasventa.cxc
      var efectivo = this.Facturasventa.efectivo
      var tarjeta = this.Facturasventa.tarjeta
      var SoloCxc = this.$store.getters.GetConfiguracionGeneral.configPv.soloCxc
      var cli = 0
      if (this.clienteFactura != null) {
        cli = this.clienteFactura.codigo
      }
      if (this.RProductoCompra.length > 0) {
        this.loading(true)
        /* var RObjProductoCompra = JSON.parse(JSON.stringify(this.RProductoCompra));
         this.RProductoCompraTemp = JSON.parse(JSON.stringify(this.RProductoCompra));*/
        var RObjProductoCompra = JSON.parse(JSON.stringify(this.RProductoCompraTemp.filter((ee) => !ee.hasOwnProperty("paramOfert") || ee.paramOfert == false)))
        this.RProductoCompraTemp = JSON.parse(JSON.stringify(this.RProductoCompraTemp.filter((ee) => !ee.hasOwnProperty("paramOfert") || ee.paramOfert == false)))
        this.RProductoCompraTemp = []
        this.RProductoCompra = []

        this.RProductoCompraOfercta = this.RProductoCompraOfercta.filter((ee) => ee.ProductoBase == null)

        if (this.Descuentofactura.descuento > 0) {


          var bar1 = new Promise((resolve, reject) => {


            Promise.all(RObjProductoCompra.map(async (element) => {
              var link1 = `/producto/getOferctaProducto/${element.cantidad}/${element.productos.codigo}/${element.unidades.codigo}`
              this.$axios.get(this.$hostname + this.$hName + link1,
                { headers: this.$store.getters.GetheadersAxios })
                .then(res => {


                  if (res.data.sizeList > 0) {
                    this.AgregarEliminarOfertasCompra(res.data.listUniProd, element)
                  }

                  var _this = this
                  setTimeout(function() {
                    resolve()
                  }, 600)

                })
                .catch(error => {
                    console.log("-E-:" + error)
                  },
                )
            }))

            // })()

          })

          bar1.then(() => {
            var ObjProRow = RObjProductoCompra.filter((ee) => !ee.hasOwnProperty("paramOfert") || ee.paramOfert == false)
            this.RProductoCompraTemp = ObjProRow.concat(this.RProductoCompraOfercta)
            this.RProductoCompra = JSON.parse(JSON.stringify(this.RProductoCompraTemp))

            var _this = this
            setTimeout(function() {
              _this.CalcularTotalesProductosCompra()
            }, 300)

            return new Promise(resolve => {
              setTimeout(() => {
                _this.loading(false)
                resolve("resolved")
              }, 400)
            })

          })


        } else {
          var bar = new Promise((resolve, reject) => {
            // RObjProductoCompra.forEach((element) => {});
            // (async () => {
            //await

            Promise.all(RObjProductoCompra.map(async (element) => {


              if (!element.hasOwnProperty("paramOfert") || element.paramOfert == false) {
                var link = `/producto/${element.productos.codigo}/descuento/${cxc > 0}/${this.domiciliofactura != null}/${Totales.cobertura > 0}/${tarjeta > 0}/${this.RedondeoValorCantRed(Totales.subtotal, 2)}/${cli}`
                this.$axios.get(this.$hostname + this.$hName + link,
                  { headers: this.$store.getters.GetheadersAxios })
                  .then(res => {
                    if (element.descuento <= 0) {
                      element.descuento = res.data.descuento
                      element.descuentoKeys = res.data.descuento
                      element.paramEspecial = res.data.especial
                      if (res.data.descuento > 0) {
                        element.ValorPorc = false
                      } else {
                        element.ValorPorc = true
                      }
                      this.verficarDescuentoProducto(element)
                    }
                    var link1 = `/producto/getOferctaProducto/${element.cantidad}/${element.productos.codigo}/${element.unidades.codigo}`
                    this.$axios.get(this.$hostname + this.$hName + link1,
                      { headers: this.$store.getters.GetheadersAxios })
                      .then(res => {


                        if (res.data.sizeList > 0) {
                          this.AgregarEliminarOfertasCompra(res.data.listUniProd, element)
                        }

                        var _this = this
                        setTimeout(function() {
                          resolve()
                        }, 600)

                      })
                      .catch(error => {
                          console.log("-E-:" + error)
                        },
                      )
                  })
                  .catch(error => {
                      console.log("-E-:" + error)
                    },
                  )
              }
            }))
            //  })()

          })

          bar.then(() => {
            var ObjProRow = RObjProductoCompra.filter(
              (ee) => !ee.hasOwnProperty("paramOfert") || ee.paramOfert == false)
            var _this = this
            this.RProductoCompraTemp = ObjProRow.concat(this.RProductoCompraOfercta)
            this.RProductoCompra = JSON.parse(JSON.stringify(this.RProductoCompraTemp))

            var _this = this
            setTimeout(function() {
              _this.CalcularTotalesProductosCompra()
              _this.loading(false)
            }, 300)

            return new Promise(resolve => {
              setTimeout(() => {
                _this.loading(false)
                resolve("resolved")
              }, 400)
            })

          })


        }


        /* setTimeout(function () {
           _this.RProductoCompraTemp = ObjProRow.concat(_this.RProductoCompraOfercta)
           _this.RProductoCompra = JSON.parse(JSON.stringify(_this.RProductoCompraTemp));
           // _this.RProductoCompraTemp = JSON.parse(JSON.stringify(RObjProductoCompra))
           // _this.RProductoCompra = JSON.parse(JSON.stringify(RObjProductoCompra))
         }, 700);*/


        /* var _this = this;
         setTimeout(function () {
           _this.CalcularTotalesProductosCompra();
         }, 800);*/

      }
    },

    // Agregar una nueva propiedad al objeto.
    async AgregarEliminarOfertasCompra(e, ProductoBase) {
      //e.forEach(element => {});
      await Promise.all(e.map(async (element) => {
        element.ProductoBase = ProductoBase
        element.DescValor = 0
        element.ProductoValidado = true
        element.RecarValor = 0
        element.ValorPorc = false
        element.ValorPorcRecarg = 0
        element.cobertura = 0
        element.descuento = 0
        element.descuentoKeys = 0
        element.recargo = 0
        element.descripcion = element.productos.descripcion.trim() + " " + element.unidades.descripcion.trim()
        element.valor = 0
        element.paramEspecial = false,
          element.paramOfert = true

        if (this.UsarLote == true) {
          element.facturasventaDetallePK = {
            documento: 0,
            secuencia: 0,
            producto: 0,
            unidad: 0,
            id: 0,
          }
          if (element.lote == null || element.lote != null && (element.lote + "").trim().length == 0) {
            element.lote = 0
            element.facturasventaDetallePK.lote = 0
          }
        }


        this.RProductoCompraOfercta.push(element)
      }))

    },

    //esto es cuando el producto en la opcion de editar se coloca el precio 0
    AgregarOfertasCompra(e) {
      this.loading(true)
      var element = JSON.parse(JSON.stringify(e))

      element.ProductoBase = null
      element.DescValor = 0
      element.ProductoValidado = true
      element.RecarValor = 0
      element.ValorPorc = false
      element.ValorPorcRecarg = 0
      element.cobertura = 0
      element.descuento = 0
      element.descuentoKeys = 0
      element.recargo = 0
      element.descripcion = element.productos.descripcion.trim() + " " + element.unidades.descripcion.trim()
      element.valor = 0
      element.paramEspecial = false,
        element.paramOfert = true

      if (this.UsarLote == true) {
        element.facturasventaDetallePK = {
          documento: 0,
          secuencia: 0,
          producto: 0,
          unidad: 0,
          id: 0,
        }
        if (element.lote == null || element.lote != null && (element.lote + "").trim().length == 0) {
          element.lote = 0
          element.facturasventaDetallePK.lote = 0
        }
      }

      this.RProductoCompraOfercta.push(element)
      this.RProductoCompra.push(element)
      this.RProductoCompraTemp.push(element)
      //this.BtnAgregarProductoSelect(element)

      var _this = this
      setTimeout(function() {
        _this.cancelarInfProducto()
        //  _this.CalcularTotalesProductosCompra();
        _this.loading(false)
      }, 400)


    },


    async buscarAgregarEliminarOferta(ProductoBase) {

      return new Promise((resolve, reject) => {

        //eliminando las ofertas del producto
        this.RProductoCompra.filter((ee) => ee.paramOfert == true && ee.ProductoBase != null &&
          ee.ProductoBase.productos.codigo == ProductoBase.productos.codigo &&
          ee.ProductoBase.unidades.codigo == ProductoBase.unidades.codigo,
        ).forEach(async (element) => {
          (async () => {
            const index = this.RProductoCompra.indexOf(element)
            this.RProductoCompra.splice(index, 1)
            this.RProductoCompraTemp.splice(index, 1)
          })()
        });


        /* */
// fn eliminando las ofertas del producto

//  buscar la oferta  del producto
        (async () => {
          var link1 = `/producto/getOferctaProducto/${ProductoBase.cantidad}/${ProductoBase.productos.codigo}/${ProductoBase.unidades.codigo}`
          var CACHE_KEY = `${ProductoBase.cantidad}/${ProductoBase.productos.codigo}/${ProductoBase.unidades.codigo}`
          var ofertaRequest = this.cacheOfertaProducto[CACHE_KEY] != null
            ? Promise.resolve(this.cacheOfertaProducto[CACHE_KEY])
            : this.$axios.get(this.$hostname + this.$hName + link1,
              { headers: this.$store.getters.GetheadersAxios }).then(res => {
              this.cacheOfertaProducto[CACHE_KEY] = res.data
              return res.data
            })

          ofertaRequest
            .then(res => {
              if (res.sizeList > 0) {
                this.AgregarOfertasCompraProBase(res.listUniProd, ProductoBase)
                this.CalcularTotalesProductosCompra()
              }

              resolve()

            })
            .catch(error => {
                console.log("-E-:" + error)
                resolve()
              },
            )
        })()
//  fin buscar la oferta  del producto
      })

    },

    async AgregarOfertasCompraProBase(ListOferta, ProductoBase) {
      // ListOferta.forEach(element => {
      await Promise.all(ListOferta.map(async (element) => {
        var OBJ = JSON.parse(JSON.stringify(element))
        OBJ.ProductoBase = ProductoBase
        OBJ.DescValor = 0
        OBJ.ProductoValidado = true
        OBJ.RecarValor = 0
        OBJ.ValorPorc = false
        OBJ.ValorPorcRecarg = 0
        OBJ.cobertura = 0
        OBJ.descuento = 0
        OBJ.descuentoKeys = 0
        OBJ.recargo = 0
        OBJ.descripcion = OBJ.productos.descripcion.trim() + " " + OBJ.unidades.descripcion.trim()
        OBJ.valor = 0
        OBJ.valorneto = 0
        OBJ.valorimpuesto = 0
        OBJ.paramEspecial = false,
          OBJ.paramOfert = true
        if (this.UsarLote == true) {
          OBJ.facturasventaDetallePK = {
            documento: 0,
            secuencia: 0,
            producto: 0,
            unidad: 0,
            id: 0,
          }
          if (OBJ.lote == null || OBJ.lote != null && (OBJ.lote + "").trim().length == 0) {
            OBJ.lote = 0
            OBJ.facturasventaDetallePK.lote = 0
          }
        }


        const index = this.RProductoCompra.indexOf(ProductoBase)
        let INDX_PRO = this.RProductoCompra.findIndex(ee => ee.indx === ProductoBase.indx)
        // const indexTEM = this.RProductoCompraTemp.indexOf(ProductoBase);
        // console.log('--index---')
        // console.log(index)
        if (INDX_PRO == -1) {
          this.RProductoCompra.splice(1, 0, OBJ)
          this.RProductoCompraTemp.splice(1, 0, OBJ)
        } else {
          this.RProductoCompra.splice(INDX_PRO + 1, 0, OBJ)
          this.RProductoCompraTemp.splice(INDX_PRO + 1, 0, OBJ)
        }

        // this.RProductoCompra.push(element)
      }))
// });


    },

    verficarDescuentoProducto(e) {
      var DescPorencima = false
      var SuperAdmin = this.$store.getters.GetdatosInfUsu.usuario.sudo
      if (this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList.length > 0) {
        var ObjPerm = this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList.filter((ee) => ee.fn == 3 && ee.op == 14)
        if (ObjPerm.length > 0) {
          DescPorencima = ObjPerm[0].permiso
        } else {
          DescPorencima = false
        }
      }

      if (e.productos != null) {
        var Cant = e.cantidad
        if (e.ValorPorc == true) {
          var valorDesc = ((e.descuentoKeys * 100) / (e.precio * Cant))
          var DescOdeMax = ((e.descuentoKeys * 100) / (e.precio * Cant))

          if (e.paramEspecial == false) {
            if (SuperAdmin == false && DescPorencima == false) {
              if (valorDesc > e.productos.descuentomaximo) {
                var valorrr = ((e.productos.descuentomaximo * (e.precio * Cant)) / 100)
                e.descuento = valorrr
                e.descuentoKeys = valorrr
                DescOdeMax = e.productos.descuentomaximo
              }
            }

          }

          //e.DescValor = e.descuento
          e.DescValor = e.descuentoKeys
          e.descuento = DescOdeMax
        } else {
          var valorDesc = e.descuentoKeys
          e.descuento = e.descuentoKeys
          if (e.paramEspecial == false) {
            if (SuperAdmin == false && DescPorencima == false) {
              if (e.descuento > e.productos.descuentomaximo) {
                e.descuento = e.productos.descuentomaximo
                valorDesc = e.productos.descuentomaximo
                e.descuentoKeys = e.productos.descuentomaximo
              }
            }
          }


          e.DescValor = ((valorDesc * (e.precio * Cant)) / 100)

          // console.log(e.descuento + "*(" + e.precio + "*" + Cant + "))/100) =" + e.DescValor)

        }

        if (e.ValorPorcRecarg == true) {
          e.RecarValor = e.recargo
        } else {
          e.RecarValor = ((e.recargo * (e.precio * Cant)) / 100)

        }

      }

    },

    RemoveTax(prod, precio) {
      var pre = 0
      if (prod.incluirimpuestoenprecio == true && prod.impuesto != null) {
        pre = (precio / (1 + (prod.impuesto.tasa / 100)))
        // console.log(`RT-FORM->  pre = (${precio} / (1 + (${prod.impuesto.tasa} / 100)))`)
      } else {
        pre = precio
      }
      //var RED3 =this.RedondeoValorCantRed(pre,2)
      //var RED3 =this.RedondeoValorCantRed(pre,2)
      // var RED3 =this.RedondeoValor(pre)
      //4
      var RED3 = this.RedondeoValorCantRed(pre, 4)
      /* console.log('RT-pre->',pre)
      console.log('RT-RED3->',RED3)*/
      return RED3
      //return pre;
    },
    CalculateTax(element) {
      //element.precio = this.RedondeoValor(element.precio / tasaMoneda);
      //esto es para la tributacion rst
      var BOOLREGTRIB = this.$store.getters.GetConfiguracionGeneral.configPv.regimenTributacionRst
      if (BOOLREGTRIB == false) {
        if (this.Facturasventa.tipocomprobante != null && this.Facturasventa.tipocomprobante.itbis == false) {
          // element.precio = this.RemoveTax(element.productos, element.precio); element.precioOrig
          //3
          element.precio = this.RedondeoValorCantRed(this.RemoveTax(element.productos, element.precioDig), 3)
          element.valor = element.precio * element.cantidad
          return 0.00
        }
      }


      if (this.ConfImpfiscal == true) {

        if (element.productos.incluirimpuestoenprecio == false && element.productos.impuesto != null) {
          // var pre = (element.precioDig / (1 + (element.productos.impuesto.tasa / 100)))
          var PRECPROD = (element.cantidad * ((element.precioDig - (element.DescValor / element.cantidad)) * (element.productos.impuesto.tasa / 100)))
          return PRECPROD
        }


        if (element.productos.incluirimpuestoenprecio == true && element.productos.impuesto != null) {
          return element.cantidad * this.RedondeoValor((element.precio - (element.DescValor / element.cantidad)) - ((element.precio - (element.DescValor / element.cantidad)) / (1 + (element.productos.impuesto.tasa / 100))))
        }
      } else {
        // var precioVar = this.RemoveTax(element.productos, element.precio) element.precioOrig
        var precioVar = this.RemoveTax(element.productos, element.precioDig)
        // console.log(`Ite==> ${element.cantidad} * ((${precioVar} - (${element.DescValor} / ${element.cantidad})) * (${element.productos.impuesto.tasa} / 100))`)
        // return element.cantidad * this.RedondeoValor(this.RedondeoValorCantRed(((precioVar - (element.DescValor / element.cantidad)) * (element.productos.impuesto.tasa / 100)),2))
        /*   console.log('--precioVar--')
       console.log(element.precioDig-precioVar)
       //console.log( element.cantidad * (((precioVar - (element.DescValor / element.cantidad)) * (element.productos.impuesto.tasa / 100))))
       console.log(`${element.cantidad} * (((${precioVar} - (${element.DescValor} / ${element.cantidad})) * (${element.productos.impuesto.tasa} / 100)))`)*/

        if (element.productos.incluirimpuestoenprecio == true && element.productos.impuesto != null) {
          //   return element.cantidad * this.RedondeoValorCantRed(((precioVar - (element.DescValor / element.cantidad)) * (element.productos.impuesto.tasa / 100)),2)
          //4/4 - bueno
          /*
          console.log(`CT-SIN CANT-> ((${precioVar} - (${element.DescValor} / ${element.cantidad})) * (${element.productos.impuesto.tasa} / 100))`)
          console.log(`CT-SIN-CANT-REDONDEADO->`,this.RedondeoValorCantRed(((precioVar - (element.DescValor / element.cantidad)) * (element.productos.impuesto.tasa / 100)), 4))
          console.log(`CT--CANT-> (${element.cantidad} * (((${precioVar} - (${element.DescValor} / ${element.cantidad})) * (${element.productos.impuesto.tasa} / 100))))`)
          console.log(`CT--CANT-REDONDEADO->`,this.RedondeoValorCantRed(element.cantidad * this.RedondeoValorCantRed(((precioVar - (element.DescValor / element.cantidad)) * (element.productos.impuesto.tasa / 100)), 4), 4))
         */
        return this.RedondeoValorCantRed(element.cantidad * this.RedondeoValorCantRed(((precioVar - (element.DescValor / element.cantidad)) * (element.productos.impuesto.tasa / 100)), 4), 4)
        
          //return this.RedondeoValor(element.cantidad * this.RedondeoValorCantRed(((precioVar - (element.DescValor / element.cantidad)) * (element.productos.impuesto.tasa / 100)),2))
          //return element.cantidad * this.RedondeoValorCantRed((element.precioDig-(precioVar)),2)
        }

        if (element.productos.incluirimpuestoenprecio == false && element.productos.impuesto != null) {
          var pre = (element.precioDig / (1 + (element.productos.impuesto.tasa / 100)))
          //console.log(`(${element.precioDig} / (1 + (${element.productos.impuesto.tasa} / 100)))`)
          //return element.cantidad * this.RedondeoValorCantRed(((precioVar - (element.DescValor / element.cantidad)) * (element.productos.impuesto.tasa / 100)),2)
          return this.RedondeoValorCantRed(element.cantidad * ((precioVar - (element.DescValor / element.cantidad)) * (element.productos.impuesto.tasa / 100)), 2)


        }

        //return element.cantidad * this.RedondeoValorCantRed((element.precioDig-precioVar),2)
        //Original: 26-03-2024: return element.cantidad * this.RedondeoValorCantRed(((precioVar - (element.DescValor / element.cantidad)) * (element.productos.impuesto.tasa / 100)),2)
      }

    },
    // Crear un objeto con las propiedades del objeto y calcula
    //los totales de los producto a comprar.
    async CalcularTotalesProductosCompra() {
      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURATASA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)


      this.Totales.totalGeneral = {
        subtotal: 0,
        itbis: 0,
        total: 0,
        descuento: 0,
        Retencion: 0,
        recargo: 0,
        cobertura: 0,
        valorLey: 0,

      }

      //if (this.CoberturaSeguro.ars != null) { }
      if (this.RProductoCompra.length > 0) {
        // if(this.RProductoCompraTemp==null){
        //   this.RProductoCompraTemp=JSON.parse(JSON.stringify(this.RProductoCompra))
        // }

        var RObjProductoCompra = JSON.parse(
          JSON.stringify(this.RProductoCompraTemp),
        )
        //cambio por cambio de moneda(01-03-2024)
        //var tasaMoneda = JSON.parse(JSON.stringify(this.Monedafactura.tasa));
        var tasaMoneda = this.$store.getters.GetConfiguracionGeneral.config.monedabase.tasa
        //
        var Ccobertura = 0
        RObjProductoCompra.forEach((element) => {

          if (!element.hasOwnProperty("paramOfert") || element.paramOfert == false) {
            /* element.precio = this.RedondeoValor(element.precio / tasaMoneda);
            element.valor = this.RedondeoValor(element.precio * element.cantidad);*/
            //precioOrig
            element.precio = this.RedondeoValor(element.precioDig / tasaMoneda)
            element.valor = this.RedondeoValor(element.precio * element.cantidad)

            if (this.ConfImpfiscal == false) {
              if (element.productos.incluirimpuestoenprecio == true) {
                if (element.productos.impuesto != null) {
                  // var precioVar = this.RemoveTax(element.productos, element.precio)

                  var precioVar = this.RemoveTax(element.productos, element.precioDig)
                  this.Totales.totalGeneral.subtotal += (element.cantidad * precioVar)
                  var VALOR_IMPUESTO = this.CalculateTax(element)
                  element.valorimpuesto = VALOR_IMPUESTO
                  this.Totales.totalGeneral.itbis += VALOR_IMPUESTO
                }

                if (element.productos.incluirimpuestoenprecio == false) {
                  if (element.productos.impuesto != null) {
                    var VALOR_IMPUESTO = this.CalculateTax(element)
                    element.valorimpuesto = VALOR_IMPUESTO
                    this.Totales.totalGeneral.itbis += VALOR_IMPUESTO
                  }
                }
                this.Totales.totalGeneral.descuento += this.RedondeoBasico(element.DescValor)
                this.Totales.totalGeneral.recargo += element.RecarValor
              } else {
                this.Totales.totalGeneral.subtotal += this.RedondeoBasico(element.valor)
                if (element.productos.incluirimpuestoenprecio == true) {
                  if (element.productos.impuesto != null) {
                    var VALOR_IMPUESTO = this.CalculateTax(element)
                    element.valorimpuesto = VALOR_IMPUESTO
                    this.Totales.totalGeneral.itbis += VALOR_IMPUESTO
                  }
                }
                if (element.productos.incluirimpuestoenprecio == false) {
                  if (element.productos.impuesto != null) {
                    var VALOR_IMPUESTO = this.CalculateTax(element)
                    element.valorimpuesto = VALOR_IMPUESTO
                    this.Totales.totalGeneral.itbis += VALOR_IMPUESTO
                  }
                }

                this.Totales.totalGeneral.descuento += this.RedondeoBasico(element.DescValor)
                this.Totales.totalGeneral.recargo += this.RedondeoBasico(element.RecarValor)
              }
            } else {


              if (element.productos.incluirimpuestoenprecio == true) {
                if (element.productos.impuesto != null) {
                  // var precioVar = element.precio    element.precioOrig
                  var precioVar = JSON.parse(JSON.stringify(element.precioDig))
                  this.Totales.totalGeneral.subtotal += this.RedondeoBasico((element.cantidad * precioVar))

                  var VALOR_IMPUESTO = this.CalculateTax(element)
                  element.valorimpuesto = VALOR_IMPUESTO
                  this.Totales.totalGeneral.itbis += VALOR_IMPUESTO
                }

                if (element.productos.incluirimpuestoenprecio == false) {
                  if (element.productos.impuesto != null) {
                    var VALOR_IMPUESTO = this.CalculateTax(element)
                    element.valorimpuesto = VALOR_IMPUESTO
                    this.Totales.totalGeneral.itbis += VALOR_IMPUESTO
                  }
                }
                this.Totales.totalGeneral.descuento += this.RedondeoBasico(element.DescValor)
                this.Totales.totalGeneral.recargo += this.RedondeoBasico(element.RecarValor)
              } else {

                this.Totales.totalGeneral.subtotal += this.RedondeoBasico(element.valor)
                if (element.productos.incluirimpuestoenprecio == true) {
                  if (element.productos.impuesto != null) {
                    var VALOR_IMPUESTO = this.CalculateTax(element)
                    element.valorimpuesto = VALOR_IMPUESTO
                    this.Totales.totalGeneral.itbis += VALOR_IMPUESTO
                  }
                }
                if (element.productos.incluirimpuestoenprecio == false) {
                  if (element.productos.impuesto != null) {
                    var VALOR_IMPUESTO = this.CalculateTax(element)
                    element.valorimpuesto = VALOR_IMPUESTO
                    this.Totales.totalGeneral.itbis += VALOR_IMPUESTO
                  }
                }

                this.Totales.totalGeneral.descuento += this.RedondeoBasico(element.DescValor * MONEDAFACTURATASA)
                this.Totales.totalGeneral.recargo += this.RedondeoBasico(element.RecarValor)
              }


            }
            Ccobertura += element.cobertura != null ? element.cobertura : 0
          }
        })

        this.RProductoCompra = JSON.parse(JSON.stringify(RObjProductoCompra))
        if (Ccobertura > 0) {
          this.Totales.totalGeneral.cobertura = this.RedondeoBasico(Ccobertura)
          this.CoberturaSeguro.cobertura = this.RedondeoBasico(Ccobertura)
        }

        // this.RProductoCompra.forEach(element => {
        // element.precio= this.RedondeoValor(element.precio)
        // element.valor= this.RedondeoValor(element.precio*element.cantidad)
        // this.Totales.totalGeneral.subtotal+=element.valor
        // //--calculando itbis al producto
        // if(element.productos.incluirimpuestoenprecio==true){
        // if(element.productos.impuesto!=null){
        // this.Totales.totalGeneral.itbis +=(element.cantidad*element.precio)-((element.cantidad*element.precio)/ (1+(element.productos.impuesto.tasa/100)))
        // }
        // }
        // if(element.productos.incluirimpuestoenprecio==false){
        // if(element.productos.impuesto!=null){
        // this.Totales.totalGeneral.itbis +=((element.cantidad*element.precio)*(element.productos.impuesto.tasa/100))
        // }

        // }

        // });
      }

      this.Descuentofactura.descuento = JSON.parse(JSON.stringify(this.Totales.totalGeneral.descuento))
      this.Descuentofactura.ValorPorc = true

      this.Recargofactura.recargo = JSON.parse(JSON.stringify(this.Totales.totalGeneral.recargo))
      this.Recargofactura.ValorPorc = true

      this.CalcularTotalesGeneral()


    },

    CalcularTotalesGeneral() {
      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURATASA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)

      // Monedafactura.tasa
      // Descuentofactura.descuento,
      // Retencionfactura.Retencion,
      // Recargofactura.recargo,
      // CoberturaSeguro.cobertura,
      // Totales.totalGeneral.total

      if (this.Descuentofactura.descuento > 0) {
        if (this.Descuentofactura.ValorPorc == true) {
          this.Totales.totalGeneral.descuento = ((this.Descuentofactura.descuento * MONEDAFACTURATASA) / this.Monedafactura.tasa)
        }
        if (this.Descuentofactura.ValorPorc == false) {
          this.Totales.totalGeneral.descuento = this.RedondeoBasico(
            (this.Descuentofactura.descuento *
              this.Totales.totalGeneral.subtotal) /
            100 /
            this.Monedafactura.tasa)
        }
      } else {
        this.Totales.totalGeneral.descuento = 0
      }

      if (this.Retencionfactura.Retencion > 0) {
        if (this.Retencionfactura.ValorPorc == true) {
          this.Totales.totalGeneral.Retencion =
            this.Retencionfactura.Retencion / this.Monedafactura.tasa
        }
        if (this.Retencionfactura.ValorPorc == false) {
          this.Totales.totalGeneral.Retencion = this.RedondeoBasico(
            (this.Retencionfactura.Retencion *
              this.Totales.totalGeneral.subtotal) /
            100 /
            this.Monedafactura.tasa)
        }
      } else {
        this.Totales.totalGeneral.Retencion = 0
      }

      if (this.Recargofactura.recargo > 0) {
        if (this.Recargofactura.ValorPorc == true) {
          this.Totales.totalGeneral.recargo = this.RedondeoBasico(
            this.Recargofactura.recargo / this.Monedafactura.tasa)
        }
        if (this.Recargofactura.ValorPorc == false) {
          this.Totales.totalGeneral.recargo =
            (this.Recargofactura.recargo * this.Totales.totalGeneral.subtotal) /
            100 /
            this.Monedafactura.tasa
        }
      } else {
        this.Totales.totalGeneral.recargo = 0
      }

      if (this.CoberturaSeguro.cobertura > 0) {
        this.Totales.totalGeneral.cobertura = this.RedondeoBasico(
          this.CoberturaSeguro.cobertura / this.Monedafactura.tasa)
      } else {
        this.Totales.totalGeneral.cobertura = 0
      }

      var PORCIENTO_LEY = this.$store.getters.GetConfiguracionGeneral.configPv.porcientoLey
      if (this.domiciliofactura==null && PORCIENTO_LEY != null && PORCIENTO_LEY > 0 && this.Totales.totalGeneral.subtotal > 0) {
        this.Totales.totalGeneral.valorLey = this.RedondeoValor(((this.Totales.totalGeneral.subtotal * PORCIENTO_LEY) / 100))
      } else {
        this.Totales.totalGeneral.valorLey = 0.00
      }

      /*var PORCIENTO_LEY=_this.$store.getters.GetConfiguracionGeneral.configPv.porcientoLey
          if(PORCIENTO_LEY!=null && PORCIENTO_LEY>0 && _this.Totales.totalGeneral.subtotal>0 ){
            _this.Totales.totalGeneral.valorLey=_this.RedondeoValor(((_this.Totales.totalGeneral.subtotal*PORCIENTO_LEY)/100))
          }else{
            _this.Totales.totalGeneral.valorLey=0.00
          }*/

      //this.Totales.totalGeneral.subtotal=(this.Totales.totalGeneral.subtotal/this.Monedafactura.tasa)

      //this.Totales.totalGeneral.total=((this.Totales.totalGeneral.subtotal+ this.Totales.totalGeneral.recargo)-(this.Totales.totalGeneral.descuento + this.Totales.totalGeneral.Retencion +this.Totales.totalGeneral.cobertura))

      // console.log("--- Viendo IncluirItbisGeneral  ---")
      // console.log(this.IncluirItbisGeneral)
      // console.log(this.Totales.totalGeneral.subtotal + this.Totales.totalGeneral.itbis)
      //this.Totales.totalGeneral.total=this.Totales.totalGeneral.subtotal + this.Totales.totalGeneral.itbis


      if (this.ConfImpfiscal == true) {
        if (this.IncluirItbisGeneral == false) {

          /* this.IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
    this.ConfImpfiscal = this.$store.getters.GetConfiguracionGeneral.config.impresoraFiscal*/

          //this.Totales.totalGeneral.itbis +
          this.Totales.totalGeneral.total = this.RedondeoBasico(
            this.Totales.totalGeneral.subtotal + this.Totales.totalGeneral.valorLey +
            this.Totales.totalGeneral.recargo - (this.Totales.totalGeneral.descuento + this.Totales.totalGeneral.Retencion + this.Totales.totalGeneral.cobertura))
          //this.Totales.totalGeneral.total= this.Totales.totalGeneral.subtotal + this.Totales.totalGeneral.itbis
        }

        if (this.IncluirItbisGeneral == true) {
          this.Totales.totalGeneral.total = this.RedondeoBasico(
            this.Totales.totalGeneral.subtotal + this.Totales.totalGeneral.valorLey +
            this.Totales.totalGeneral.recargo -
            (this.Totales.totalGeneral.descuento +
              this.Totales.totalGeneral.Retencion +
              this.Totales.totalGeneral.cobertura))
          //this.Totales.totalGeneral.total= this.Totales.totalGeneral.subtotal
        }

      } else {

        this.Totales.totalGeneral.total = this.RedondeoBasico(
          this.Totales.totalGeneral.subtotal + this.Totales.totalGeneral.valorLey +
          this.Totales.totalGeneral.itbis +
          this.Totales.totalGeneral.recargo -
          (this.Totales.totalGeneral.descuento +
            this.Totales.totalGeneral.Retencion +
            this.Totales.totalGeneral.cobertura))

      }

      // if(this.Facturasventa.tipocomprobante!=null && this.Facturasventa.tipocomprobante.itbis==false){
      //   this.Totales.totalGeneral.itbis=0
      //   this.Totales.totalGeneral.total =  (this.Totales.totalGeneral.subtotal + this.Totales.totalGeneral.recargo) -(this.Totales.totalGeneral.descuento + this.Totales.totalGeneral.Retencion +this.Totales.totalGeneral.cobertura);
      // }

      //   this.Totales.totalGeneral={
      //   subtotal:0,
      //   itbis:0,
      //   total:0,
      //   descuento:0,
      //   Retencion:0,
      //   recargo:0,
      //   cobertura:0
      // }

      /* var ObjProRow = this.RProductoCompraTemp.filter(
         (ee) => ee.paramOfert == false);

       console.log('----ElRealFiltre---')
       console.log(ObjProRow)*/

      /*por aqui régimen de tributación RST*/
      var TIPOCOMPROBANTE = null
      if (this.Facturasventa.tipocomprobante == null || this.Facturasventa.tipocomprobante != null &&
        !this.Facturasventa.tipocomprobante.hasOwnProperty("codigo")) {
        TIPOCOMPROBANTE = this.$store.getters.GetConfiguracionGeneral.configPv.comprobantefacturacion
      } else {
        TIPOCOMPROBANTE = this.Facturasventa.tipocomprobante
      }

      var _this = this
      setTimeout(function() {
        var BOOLREGTRIB = _this.$store.getters.GetConfiguracionGeneral.configPv.regimenTributacionRst
        if (BOOLREGTRIB == true && TIPOCOMPROBANTE.codigo == 1) {
          /*por aqui régimen de tributación RST*/
          _this.Totales.totalGeneral.subtotal = _this.RedondeoBasico(_this.Totales.totalGeneral.subtotal + _this.Totales.totalGeneral.itbis)
          _this.Totales.totalGeneral.itbis = 0
        }

        _this.calcularDevuelta()
      }, 500)


    },

    CalcularValorProductoRPCompra(element) {
      var subtotalvar = 0
      var itbisvar = 0
      var descuentovar = 0
      var recargovar = 0
      var coberturavar = 0
      element.RecarValor = (element.hasOwnProperty("RecarValor") && element.RecarValor != null ? element.RecarValor : 0)
      element.valorRecargo = (element.hasOwnProperty("valorRecargo") && element.valorRecargo != null ? element.valorRecargo : 0)
      if (!element.hasOwnProperty("paramOfert") || element.paramOfert == false) {
        if (this.ConfImpfiscal == null) {
          this.ConfImpfiscal = false
        }
        if (this.ConfImpfiscal == false) {
          if (element.productos.incluirimpuestoenprecio == true) {
            if (element.productos.impuesto != null) {
              // var precioVar = this.RedondeoValorCantRed(this.RemoveTax(element.productos, element.precio),3) element.precioOrig
              //var precioVar = this.RedondeoValorCantRed(this.RemoveTax(element.productos, element.precioDig),3)
              var precioVar = this.RemoveTax(element.productos, element.precioDig)
              subtotalvar = (element.cantidad * precioVar)
              itbisvar = this.CalculateTax(element)
            }

            if (element.productos.incluirimpuestoenprecio == false) {
              if (element.productos.impuesto != null) {
                itbisvar = this.CalculateTax(element)
              }
            }
            descuentovar = this.RedondeoBasico(element.DescValor)
            recargovar = (element.hasOwnProperty("RecarValor") && element.RecarValor != null ? element.RecarValor : 0)
            coberturavar = element.cobertura
          } else {
            subtotalvar = this.RedondeoBasico(element.valor)
            if (element.productos.incluirimpuestoenprecio == true) {
              if (element.productos.impuesto != null) {
                itbisvar = this.CalculateTax(element)
              }
            }
            if (element.productos.incluirimpuestoenprecio == false) {
              if (element.productos.impuesto != null) {
                itbisvar = this.CalculateTax(element)
              }
            }

            descuentovar += this.RedondeoBasico(element.DescValor)
            recargovar += this.RedondeoBasico(element.RecarValor)
          }
        } else {


          if (element.productos.incluirimpuestoenprecio == true) {
            if (element.productos.impuesto != null) {
              var precioVar = element.precioDig
              subtotalvar += (element.cantidad * precioVar)
              itbisvar = this.CalculateTax(element)
            }

            if (element.productos.incluirimpuestoenprecio == false) {
              if (element.productos.impuesto != null) {
                itbisvar = this.CalculateTax(element)
              }
            }
            descuentovar += this.RedondeoBasico(element.DescValor)
            recargovar += this.RedondeoBasico(element.RecarValor)

          } else {
            subtotalvar = this.RedondeoBasico(element.valor)
            // this.Totales.totalGeneral.subtotal += element.valor;
            if (element.productos.incluirimpuestoenprecio == true) {
              if (element.productos.impuesto != null) {
                itbisvar = this.CalculateTax(element)
              }
            }
            if (element.productos.incluirimpuestoenprecio == false) {
              if (element.productos.impuesto != null) {
                itbisvar = this.CalculateTax(element)
              }
            }

            descuentovar += this.RedondeoBasico(element.DescValor)
            recargovar += this.RedondeoBasico(element.RecarValor)
          }


        }

      }
      //console.log(`verr-Total-> ((((${subtotalvar} + ${recargovar}) - ${descuentovar}) + ${itbisvar}) - ${coberturavar})`)

      //console.log(`verr-Total-todo-> ${this.RedondeoValorCantRed(((((subtotalvar + recargovar) - descuentovar) + itbisvar) - coberturavar), 3)} `)


      //console.log('ObjBa==>',element)
      //console.log(`((((${subtotalvar} + ${recargovar}) - ${descuentovar}) + ${itbisvar}) - ${coberturavar})`)
      var TotalVar = this.RedondeoValorCantRed(((((subtotalvar + recargovar) - descuentovar) + itbisvar) - coberturavar), 3)
        // console.log(`verr-TotalVar-> ${TotalVar}`)
      // this.currencyFormatter2(((element.valor + element.RecarValor) -element.DescValor) - element.cobertura)

      /* console.log(`Formula==> ((((${subtotalvar} + ${recargovar}) - ${descuentovar}) + ${itbisvar}) - ${coberturavar})  `)
      console.log('--Viendo Redond--')
      console.log(this.currencyFormatter2(this.RedondeoValorCantRed(TotalVar,2)))*/
     //this.sinRedondeoCantidad(,2)
      return this.getTasaMonedaSelect(TotalVar)

    },


    // Crear un nuevo objeto y asignarle valores a unidadesProductos.
    NewCrearProducto() {
      this.unidadesProductos = {
        codigobarra: "",
        precio: 0.0,
        costo: 0.0,
        porbeneficio: 0.0,
        factor: 1,
        unidades: null,
        productos: {
          borrado: false,
          activo: false,
          codigo: 0,
          descripcion: "",
          puntoVenta: true,
          impuesto: null,
        },
        unidadminima: true,
        unidadcompra: true,
        borrado: false,
      }

      this.ejecucion = true
      this.loading(false)
    },
    openCrearPoducto() {
      this.dialogCrearProduct = true
    },
    // Envío de una solicitud POST al servidor.
    SalvarCrearProducto() {
      if (this.$refs.formCrearProduct.validate()) {
        if (this.ejecucion == true) {
          this.ejecucion = false
          this.loading(true)
          this.unidadesProductos.unidades =
            this.configuraciones.configInv.unidadDefault
          this.unidadesProductos.tasa =
            this.configuraciones.config.monedabase.tasa
          this.$axios
            .post(
              this.$hostname + this.$hName + "/unidades-productos/save/",
              this.unidadesProductos,
              { headers: this.$store.getters.GetheadersAxios },
            )
            .then((res) => {
              this.alerta("Dato guardado correctamente!", "bien2")
              this.NewCrearProducto()
              this.dialogCrearProduct = false
            })
            .catch((error) => {
                this.loading(false)
                this.alerta("Dato no guardado correctamente", "error")
              },
            )
        }
      } else {
        this.alerta("los campos en rojo son requeridos", "error")
      }
    },
    // Cerrar el cuadro de diálogo y restablecer el formulario.
    cancelarCrearProducto() {
      this.dialogCrearProduct = false
      this.NewCrearProducto()
    },

    SelctCbVendedorProducto() {
    },
    // Llamar a una API y obtener los datos de vendedor.
    cargarVendedorProducto() {
      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv("AccCambiarVendedorProd")
        return
      }

      this.cargarVendedorFactura()
      /*this.$axios
        .get(this.$hostname + this.$hName + "/vendedores/findbydesc/25/a", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RVendedor = res.data));*/
    },
    // Hacer una llamada axios al servidor y devolver los datos .
    async CbFilVendedorProducto(e) {
      var texto = e.target.value
      if (texto.length >= 2) {
        if (this.pvOnline == false || (typeof navigator !== "undefined" && navigator.onLine == false)) {
          await this.cargarVendedoresOffline(texto)
          return
        }
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/vendedores/findbydesc/25/" +
            texto,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then(async (res) => {
            this.RVendedor = res.data
            await this.guardarVendedoresOffline(res.data || [])
          })
          .catch(async (error) => {
            if (this.esErrorConexionPv(error)) {
              this.activarModoOfflinePorErrorConexion(error)
              await this.cargarVendedoresOffline(texto)
            }
          })
      }
    },
    // Llamar a una API y obtener los datos de la API y almacenarlos en la variable RImpuesto.
    cargarImpuestoProducto() {
      this.$axios
        .get(this.$hostname + this.$hName + "/impuestos/findallActivos", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RImpuesto = res.data))
    },
    // Comprobando si el valor de la selección es nulo o indefinido. Si es nulo o indefinido, mostrará
    // una alerta y establecerá el valor de la selección en una cadena vacía.
    SelctCbImpuestoProducto() {
      if (this.unidadesProductos.productos.impuesto == null) {
        this.unidadesProductos.productos.impuesto = ""
      }
      if (this.unidadesProductos.productos.impuesto.codigo == undefined) {
        this.alerta("Seleccione un impuesto", "error")
        this.unidadesProductos.productos.impuesto = ""
        return
      }
    },

    acceptarPlanbeneficio(){

      if(this.clienteFactura != null && this.clienteFactura.hasOwnProperty("codigo")){
        //this.SeleccionarClienteFactura()
        /**/ 
         if (this.planBeneficio.planBeneficio == true) {
          var objtem = JSON.parse(JSON.stringify(this.planBeneficio.objtem))
          this.BtnAgregarProductoSelect(objtem)
          this.NewplanBeneficio()
        }
        
      }else{
        this.OpenDialogCrearEditarCliente()
      }
      

    },
    OpenDialogCrearEditarCliente() {
      this.NewclienteSeleccionado()
      this.dialogCrearEditarCliente = true
      if (this.clienteFactura != null) {
        this.busquedaCliente = JSON.parse(JSON.stringify(this.clienteFactura))
        this.clienteSeleccionado = JSON.parse(JSON.stringify(this.clienteFactura))
        if (this.clienteFactura.telefonosClientesList.length > 0) {
          this.clienteSeleccionado.telefono = this.clienteFactura.telefonosClientesList[0].telefonosClientesPK.telefono
        }
        if (this.clienteFactura.cedrnc == null) {
          this.clienteFactura.cedrnc = ""
        }
        this.CargarHistorialCliente()
      }
      if (this.clienteFactura == null) {
        var _this = this
        setTimeout(function() {
          _this.$refs.RefTextFieldBuscaCliente.focus()
        }, 500)
      }
    },
    // Restableciendo el formulario de cliente .
    NewclienteSeleccionado() {
      this.busquedaCliente = null
      this.clienteSeleccionado = {
        codigo: 0,
        nombre: null,
        cedrnc: "",
        ciudad: null,
        direccion: null,
        telefono: "",
        sector: "",
        tipocomprobante: null,
        email: "",
        sexo: "",
        dondetrabaja: "",
        diascredito: 0,
        fechanacimiento: null,
        carnet: "",
        ars: null,
        contrato: "",
        nss: "",
        planlan: 0,
        comentario: "",
        pasaporte: "",
      }
      this.RHistorialCompracliente = []

      this.SelectedFactPendiente = null
      this.FactPendienteSeleccionado = null
      this.RListFactpendiente = []
      this.ObtemRListFactpendiente = []

      this.HeadInfFactPendienteSelecc = {
        fecha: fechaNueva(),
        factura: "",
        valorf: 0,
        pendiente: 0,
        ncf: "",
        referencia: "",
      }

      this.ReciboIngreso.abono = 0
      this.ReciboIngreso.descuento = 0
      this.ReciboIngreso.DescValorPorc = false
      this.devueltaRecIngreso = 0
      this.Totales.ReciboIngreso = {
        pendiente: 0,
        abono: 0,
        descuento: 0,
        retencion: 0,
        isr: 0,
      }

      this.NewHistorialClientRecIng()


    },
    // Cerrando el cuadro de diálogo del cliente.
    CancelarCrearEditarCliente() {
      this.dialogCrearEditarCliente = false,
        this.NewclienteSeleccionado()
      this.OpenEjecReciboIngreso = false
      this.OpenEjecCoberturaSeguro = false
      this.OpenEjecFacturaDomicilio = false
      this.OpenEjecDatosPagareFactura = false
      this.OpenEjecProdControlado = false
      this.OpenEjecFarmacoVigilancia = false
      this.selecteTemRecCont = null
      this.NewplanBeneficio()
    },

    // Modifica un objecto cliente para enviarlo a guardar.
    SalvarCrearEditarCliente() {

       //COMP: PERSONA, GUBERNAMENTAL,ESPECIAL
            var COD_TIPO_COMP=[2,3,4]
            var BOOL_ced = this.clienteSeleccionado.cedrnc==null || this.clienteSeleccionado.cedrnc!=null && this.clienteSeleccionado.cedrnc.trim().length==0
            if(BOOL_ced ==true && this.clienteSeleccionado.tipocomprobante!=null && this.clienteSeleccionado.tipocomprobante.hasOwnProperty('codigo') && COD_TIPO_COMP.includes(this.clienteSeleccionado.tipocomprobante.codigo)){
             this.clienteSeleccionado.cedrnc="0 "
             this.alerta(` El comprobante: ${this.clienteSeleccionado.tipocomprobante.descripcion.trim()} Requiere un Cédula/RNC `, "error")
             this.$refs.formBuscarCliente.validate()
            return
            }

      if (this.$refs.formCrearEditarCliente.validate()) {
        if (this.cedularequired == true) {
          if (this.clienteSeleccionado.cedrnc == null || this.clienteSeleccionado.cedrnc != null && this.clienteSeleccionado.cedrnc.trim().length == 0) {
            this.$refs.formCrearEditarCliente.validate()
            this.alerta(`el campo "cedula/RNC" es requeridos`, "error")
            return
          }
        }

        if (this.clienteSeleccionado.cedrnc != null && this.clienteSeleccionado.cedrnc.length > 0) {
          var CEDULA = this.clienteSeleccionado.cedrnc.replace("-", "")
          CEDULA = CEDULA.replace(/-/g, "")
          if (this.validaCedRnc(CEDULA) == false) {
            var NOM = CEDULA.length > 10 ? "CEDULA" : "RNC"
            this.alerta(`${NOM} Invalida `, "error")
            //  return;
          }
        }


        if (this.EjecutarPermisoPv == false) {
          this.funcionValidaPermisoPv("AccCrearEditarCliente")
          return
        }
        if (this.ejecucion == true) {
          this.ejecucion = false
          this.loading(true)
          if (this.clienteSeleccionado.hasOwnProperty("telefonosClientesList") && this.clienteSeleccionado.telefonosClientesList.length > 0) {

            if (this.clienteSeleccionado.telefono != null && this.clienteSeleccionado.telefono.length > 3) {
              this.clienteSeleccionado.telefonosClientesList[0].telefonosClientesPK.telefono = this.clienteSeleccionado.telefono
            }


          } else {
            this.clienteSeleccionado.telefonosClientesList = []
            var obj = {
              telefonosClientesPK: {
                telefono: this.clienteSeleccionado.telefono,
                cliente: this.clienteSeleccionado.codigo,
              }, borrado: false,
            }
            this.clienteSeleccionado.telefonosClientesList.push(obj)
          }

          this.$axios
            .post(
              this.$hostname + this.$hName + "/clientes/save/",
              this.clienteSeleccionado,
              { headers: this.$store.getters.GetheadersAxios },
            )
            .then((res) => {
              var CLIENTE_SELECT = JSON.parse(JSON.stringify(res.data))
              CLIENTE_SELECT.codnom = `${res.data.codigo} - ${res.data.nombre.trim()}`
              this.busquedaCliente = JSON.parse(JSON.stringify(CLIENTE_SELECT))
              this.getChangeClienteBusqueda(CLIENTE_SELECT)
              if (this.clienteFactura != null && this.clienteFactura.codigo == CLIENTE_SELECT.codigo) {
                this.clienteFactura = CLIENTE_SELECT
              }

              this.alerta("cliente guardado corretamente", "bien2")
            })
            /* .catch(error => {
              this.ejecucion = true;
              this.loading(false)
            }
            );*/
            .catch(error => {

              this.ejecucion = true
              this.loading(false)
              var MESSAGE = ""
              if (error.response) {
                MESSAGE = error.response.data
                // this.alerta(error.response.data, "error")
              } else if (error.request) {
                MESSAGE = error.request
                // this.alerta(error.request, "error")
              } else {
                MESSAGE = error.message
                // this.alerta(error.message, "error")
              }

              if (MESSAGE.trim().length == 0) {
                MESSAGE = "DATO NO GUARDADO CORRECTAMENTE"
              }

              this.alerta(MESSAGE, "error")
            })


          //.then((res) => (this.RCliente = res.data));
        }
      } else {
        this.alerta("los campos en rojo son requeridos", "error")
      }
    },
    // Llamar a una API y obtener los datos del cliente.
    cargarClienteBusqueda() {
      var param = ""
      if (this.$store.getters.GetConfiguracionGeneral.configPv.modalidadRutaVendedor == true && this.Facturasventa.vendedor != null && this.Facturasventa.vendedor.hasOwnProperty("codigo")) {
        var sem = ["d", "l", "ma", "mi", "j", "v", "s"]
        var fecha = new Date()
        var semana = sem[fecha.getUTCDay()]
        var param = "/" + this.Facturasventa.vendedor.codigo + "/" + semana
      }

      this.$axios
        .get(this.$hostname + this.$hName + "/clientes/findtodo/a/" + this.filtroTipoCliente + "/25/0" + param, {
          headers: this.$store.getters.GetheadersAxios,
          timeout: 8000,
        })
        .then((res) => {
          this.desactivarModoOfflineForzado()
          this.RCliente = res.data
          this.guardarClientesOffline(res.data)
        })
        .catch((error) => {
          console.log('ver klk-error->',error)
          if (this.esErrorConexionPv(error)) {
            this.activarModoOfflinePorErrorConexion(error)
            this.buscarClientesOffline("a")
          }
        })
    },
    // Hacer una llamada API al servidor y devolver los datos al cliente.
    CbFilcliente(e) {
      if (e.target.value.length >= 0) {

        var param = ""
        if (this.$store.getters.GetConfiguracionGeneral.configPv.modalidadRutaVendedor == true && this.Facturasventa.vendedor != null && this.Facturasventa.vendedor.hasOwnProperty("codigo")) {
          var sem = ["d", "l", "ma", "mi", "j", "v", "s"]
          var fecha = new Date()
          var semana = sem[fecha.getUTCDay()]
          var param = "/" + this.Facturasventa.vendedor.codigo + "/" + semana
        }

        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/clientes/findtodo/" +
            (e.target.value === null || e.target.value.length == 0 ? "A" : e.target.value) +
            "/" + this.filtroTipoCliente + "/25/0" + param,
            { headers: this.$store.getters.GetheadersAxios, timeout: 8000 },
          )
          .then((res) => {
            this.desactivarModoOfflineForzado()
            this.RCliente = res.data
            this.guardarClientesOffline(res.data)
          })
          .catch((error) => {
            if (this.esErrorConexionPv(error)) {
              this.activarModoOfflinePorErrorConexion(error)
              this.buscarClientesOffline(e.target.value === null || e.target.value.length == 0 ? "A" : e.target.value)
            }
          })
      }
    },
    // Un método que recibe un cliente y verifica en una lista si tiene telefono .
    selectTelefonoCliente(e) {
      if (typeof e === "object" && e.hasOwnProperty("telefonosClientesList") && e.telefonosClientesList != null && e.telefonosClientesList.length > 0) {
        return e.telefonosClientesList[0].telefonosClientesPK.telefono.trim()
      } else {
        return " "
      }
    },

    selectBalanceCliente(e) {
      if (typeof e === "object" && e.hasOwnProperty("balancecliente") && e.balancecliente != null && e.balancecliente.hasOwnProperty("balance") && e.balancecliente.balance != null) {
        // return this.currencyFormatter2(e.balancecliente.balance)
        return e.balancecliente.balance
      } else {
        //return this.currencyFormatter2(0)
        return 0
      }
    },


    selectLimiteCredito(e) {

      if (typeof e === "object" && e.hasOwnProperty("limitecredito") && e.limitecredito != null) {
        //return this.currencyFormatter2(e.limitecredito)
        return e.limitecredito
      } else {
        return 0
        // return this.currencyFormatter2(0)
      }

    },


    // Comprobando si el valor de la entrada es nulo o indefinido.
    SelctCbClienteBuscar() {
      var _this = this
      setTimeout(function() {
        if (_this.busquedaCliente == null) {
          _this.busquedaCliente = ""
        }

        if (!_this.busquedaCliente.hasOwnProperty("codigo")) {
          _this.busquedaCliente = ""
          _this.busquedaCliente = null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
      }, 300)


      /* console.log('Lalallal Pamoinjn')
      if (this.busquedaCliente == null) {
        this.busquedaCliente = "";
      }
      if (this.busquedaCliente.codigo == undefined) {
        this.busquedaCliente = "";
        this.alerta("Seleccione un cliente", "error");
        return;
      }*/
    },
    // Una función que se llama cuando un usuario selecciona un cliente de una lista desplegable.
    getChangeClienteBusqueda(e) {
      if (typeof e === "object" && e != null) {

        /* if (e.statuscliente != null) {
          if (e.statuscliente == 2 || e.statuscliente == 3) {
            this.busquedaCliente = null
            this.alerta("Este cliente esta suspendido o cancelado, no puede Seleccinarlo", "error");
            return
          }
        }*/

        /* if(e.statuscliente!=null){
           if(e.statuscliente==2 || e.statuscliente==3){
             this.alerta("Este cliente esta suspendido o cancelado, no puede Seleccinarlo", "error");
             this.busquedaCliente=null
             this.clienteSeleccionado =null
             return
           }
         }*/

        //ars

        if (e.ordenCompraPv != null && e.ordenCompraPv == true) {
          this.alerta(`Nota: El cliente seleccionado requiere un numero de orden obligatorio.`, "warning")

          var _this = this
          setTimeout(function() {
            _this.$refs.formCrearEditarCliente.validate()
          }, 500)


        }

        if (e.ars != null && e.ars.hasOwnProperty("codigo") && e.ars.activo == false) {
          this.alerta(`Nota: La ARS que posee este cliente esta In-activa`, "warning")
        }

        if (e.ars != null && e.ars.hasOwnProperty("codigo") && e.ars.borrado == true) {
          this.alerta(`Nota: La ARS que posee este cliente esta borrada`, "warning")
        }


        var obj = JSON.parse(JSON.stringify(e))
        obj.telefono = this.selectTelefonoCliente(e)
        if (e.fechanacimiento != null) {
          /* var fecnac=this.getParamFecha(e.fechanacimiento)
          obj.fechanacimiento=fecnac.split("T")[0]*/
          obj.fechanacimiento = JSON.parse(JSON.stringify(e.fechanacimiento))
        }

        if (e.cedrnc != null) {
          obj.cedrnc = e.cedrnc.trim()
        } else {
          obj.cedrnc = ""
        }
        this.clienteSeleccionado = obj

        //statuscliente--Suspendido:2
        //statuscliente--statuscliente:2
        //statuscliente:--Cancelado:3

        this.TbTotalItemHisCli = 0
        this.TbPaginatorHisCli = {
          page: 1,
          itemsPerPage: 10,
          pageStart: 1,
          pageStop: 15,
          pageCount: 10,
          itemsLength: 5,
        }

        var _this = this
        setTimeout(function() {
          _this.CargarHistorialCliente(e)
        }, 500)

      }
    },

    // Una función que que validad si el cliente seleccionado es a credito y desabilita el nombre y la direccion .
    validarDisabledClienteCredito(e) {
      var MODIF_NOMB = this.$store.getters.GetConfiguracionGeneral.configPv.modificarNombreClienteCredito
      var BOOLSTADO = false
      if (MODIF_NOMB != null && MODIF_NOMB == false) {
        if (typeof e === "object" && e != null) {
          if (e.hasOwnProperty("diascredito") && e.diascredito != null && e.diascredito > 0) {
            BOOLSTADO = true
          }
        }
      }

      return BOOLSTADO


    },


    cargarPaginacionAllHisCli(e) {
      this.TbPaginatorHisCli = JSON.parse(JSON.stringify(e))
      this.CargarHistorialCliente()
    },

    // Llamar a una API y obtener los datos factura historial del cliente..
    CargarHistorialCliente() {
      this.RHistorialCompracliente = []
      if (this.clienteSeleccionado == null || this.clienteSeleccionado.codigo == 0) {
        return
      }

      //    /FindHistorialCliente/{limit}/{ultimo}/{cliente}
      var obj =
        this.TbPaginatorHisCli.itemsPerPage +
        "/" +
        this.TbPaginatorHisCli.pageStart +
        "/" +
        this.clienteSeleccionado.codigo

      this.$axios
        .get(
          this.$hostname + this.$hName + "/facturasventas/FindHistorialCliente/" + obj,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          (this.RHistorialCompracliente = res.data.ListHistCliente),
            (this.TbTotalItemHisCli = res.data.TbTotalItem)
        })


    },


    // Llamar a una API y obtener los datos historial del cliente..
    historialClieList() {
      if (this.clienteFactura == null) {
        return 0
      }

      this.listHiscliente = []
      var q2 = ""
      var tasa = 1.00

      if (this.clienteFactura != null) {
        q2 = ` and clientecod = ${this.clienteFactura.codigo} `
      }
      if (this.Monedafactura != null) {
        tasa = this.Monedafactura.tasa
      }


      var f1 = "1900-01-01"
      var f2 = this.fechaNueva()

      // var Obj={}

      var link = `/ConsultaRapida/historialClieList/${this.clienteFactura.codigo}/${f1}/${f2}/${q2}/${tasa}`
      this.$axios
        .get(this.$hostname + this.$hName + link, { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.CalcularBalance(res.data)
        })
        .catch(error => {
          this.alerta("Reporte no Impreso(" + error + ")", "error")
        })

    },

    // Cálculo del saldo de un cliente.
    async CalcularBalance(e) {

      this.totales = {
        BalanceTotal: 0,
        credito: 0,
        debito: 0,
      }


      var obj = JSON.parse(JSON.stringify(e.list))

      // await obj.forEach(elent => {});
      await Promise.all(obj.map(async (elent) => {


        if (!elent.descripcion.includes("Contado")) {
          this.totales.BalanceTotal += (elent.debito - elent.credito)
        }
        elent.balance = this.totales.BalanceTotal
        this.totales.debito += elent.debito
        this.totales.credito += elent.credito
      }))

      this.listHiscliente = JSON.parse(JSON.stringify(obj))

    },


    async ActualizarListaPrecioCambioCliente() {
      var LISTAPRODUCTO = JSON.parse(JSON.stringify(this.RProductoCompra))
      this.RProductoCompra = []
      this.RProductoCompraTemp = []
      this.RProductoCompraTemp = []
      //RProductoCompra:Array[1]
      //RProductoCompraTemp:Array[1]
      //RProductoCompraOfercta:Array[0]
      var NEWLISTAPRODUCTO = []
      var bar = new Promise((resolve, reject) => {

        //LISTAPRODUCTO.forEach(async (element) => {  });
        (async () => {
          await Promise.all(LISTAPRODUCTO.map(async (element) => {
            var OBJ = JSON.parse(JSON.stringify(element))
            var CODPRO = OBJ.unidadesProductosPK.producto
            var CODUNI = OBJ.unidadesProductosPK.unidad
            var CODLISPRE = this.listaPrecioDefecto.id

            if (this.clienteFactura != null && this.clienteFactura.listaPrecio != null && this.clienteFactura.listaPrecio.activo == true) {
              CODLISPRE = this.clienteFactura.listaPrecio.id
            }
            const result = await this.findListaprecioUnidaProducto(CODPRO, CODUNI, CODLISPRE)
            // const resUniPro =  await this.findUnidaProducto(CODPRO,CODUNI);
            if (result != null) {
              OBJ.precio = result.precio
              OBJ.precioDig = result.precio
              OBJ.precioOrig = element.precioOrig
              OBJ.omitirRegla = true
            } else {
              OBJ.precio = element.precioOrig
              OBJ.precioDig = element.precioOrig
              OBJ.precioOrig = element.precioOrig
              OBJ.omitirRegla = true
            }
            NEWLISTAPRODUCTO.push(OBJ)
            var _this = this
            setTimeout(function() {
              resolve()
            }, 600)

          }))

        })()

      })

      bar.then(() => {
// console.log(NEWLISTAPRODUCTO)
        NEWLISTAPRODUCTO.sort(function(a, b) {
          if (a.indx > b.indx) {
            return 1
          }
          if (a.indx < b.indx) {
            return -1
          }
          return 0
        });


        // NEWLISTAPRODUCTO.forEach(element => {});

        //this.BuscPropiedadProductoSelct(element, 'add')
        (async () => {
          await Promise.all(NEWLISTAPRODUCTO.map(async (element) => {


            element.RecarValor = (element.hasOwnProperty("RecarValor") && element.RecarValor != null ? element.RecarValor : 0)
            element.valorRecargo = (element.hasOwnProperty("valorRecargo") && element.valorRecargo != null ? element.valorRecargo : 0)
            //this.BuscPropiedadProductoSelct(element, 'add')
            this.RProductoCompra.unshift(JSON.parse(JSON.stringify(element)))
            this.RProductoCompraTemp.unshift(JSON.parse(JSON.stringify(element)))


          }))

          var _this = this
          setTimeout(function() {
            _this.LimpiaInfProducto()
          }, 400)
        })()

        // this.BuscPropiedadProductoSelct(OBJ, 'add')
        console.log("All done ActualizarListaPrecioCambioCliente!")
        //console.log(NEWLISTAPRODUCTO);
      })


    },
    // Una función que se llama cuando un usuario selecciona un cliente de una lista de clientes.
    async SeleccionarClienteFactura() {
      if (this.busquedaCliente == null) {
        this.alerta(
          "Seleccione un cliente para aplicarlo a la factura",
          "error",
        )
        this.$refs.RefTextFieldBuscaCliente.focus()
        return
      }

      if (!this.$refs.formBuscarCliente.validate()) {
        this.alerta("Seleccione un cliente para aplicarlo a la factura", "error")
        this.$refs.RefTextFieldBuscaCliente.focus()
        return
      }
      if (typeof this.busquedaCliente === "object" && this.busquedaCliente != null) {


        var ordenBOOL = this.busquedaCliente.ordenCompraPv != null && this.busquedaCliente.ordenCompraPv == true
          && !this.busquedaCliente.hasOwnProperty("numeroOrden") || this.busquedaCliente.hasOwnProperty("numeroOrden") &&
          this.busquedaCliente.numeroOrden == null || this.busquedaCliente.numeroOrden != null && this.busquedaCliente.numeroOrden.trim().length == 0

        if (ordenBOOL == true) {
          this.alerta(`Nota: El cliente seleccionado requiere un numero de orden obligatorio.`, "warning")
          var _this = this
          setTimeout(function() {
            _this.$refs.formCrearEditarCliente.validate()
          }, 500)

          return
        }

        if (this.busquedaCliente.cedrnc != null && this.busquedaCliente.cedrnc.length > 0) {
          var CEDULA = this.busquedaCliente.cedrnc.replace("-", "")
          CEDULA = CEDULA.replace(/-/g, "")
          if (this.validaCedRnc(CEDULA) == false) {
            var NOM = CEDULA.length > 10 ? "CEDULA" : "RNC"
            this.alerta(`${NOM} Invalida `, "error")
            return
          }
        }
        this.clienteFactura = JSON.parse(JSON.stringify(this.busquedaCliente))
        this.dialogCrearEditarCliente = false

        if (this.activarListasPrecios == true && this.RProductoCompra.length > 0) {
          const result = await this.ActualizarListaPrecioCambioCliente()
        }

        this.NewclienteSeleccionado()
        var EJECUTAR_BLUR_PRODUCTO = true
        if (this.OpenEjecReciboIngreso == true) {
          this.OpenEjecReciboIngreso = false
          EJECUTAR_BLUR_PRODUCTO = false
          this.OpenDialogReciboIngreso()
        }
        if (this.OpenEjecCoberturaSeguro == true) {
          this.OpenEjecCoberturaSeguro = false
          EJECUTAR_BLUR_PRODUCTO = false
          this.OpenCoberturaSeguro()
        }
        if (this.OpenEjecFacturaDomicilio == true) {
          this.OpenEjecFacturaDomicilio = false
          EJECUTAR_BLUR_PRODUCTO = false
          this.OpenFacturaDomicilio()
        }
        if (this.OpenEjecDatosPagareFactura == true) {
          this.OpenEjecDatosPagareFactura = false
          EJECUTAR_BLUR_PRODUCTO = false
          this.OpenDialogDatosPagareFactura()
        }

        if (this.OpenEjecProdControlado == true) {
          this.OpenEjecProdControlado = false
          EJECUTAR_BLUR_PRODUCTO = false
          this.OpenDialogProdControlado()
        }

        if (this.OpenEjecFarmacoVigilancia == true) {
          this.OpenEjecFarmacoVigilancia = false
          EJECUTAR_BLUR_PRODUCTO = false
          this.openFarmacoVigilancia()
        }
          if (this.OpenEjecInternamientos == true) {
          this.OpenEjecInternamientos = false
          this.OpenInternamientos()
        }



        if (this.planBeneficio.planBeneficio == true) {
          var objtem = JSON.parse(JSON.stringify(this.planBeneficio.objtem))
          this.BtnAgregarProductoSelect(objtem)
          this.NewplanBeneficio()
        }


        /*this.$axios
        .get(this.$hostname + this.$hName + "/vendedores/findbydesc/25/a", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RVendedor = res.data));*/

        this.CompletaDatoClienteSelectFactura()

        if (EJECUTAR_BLUR_PRODUCTO == true) {
           var _this = this
          setTimeout(function() {
            _this.$refs.RefTextFieldProducto.focus()
          }, 500)
        }


        if (this.activarListasPrecios == false) {
          var _this = this
          setTimeout( async function() {
            _this.CalcularTotalesProductosCompra()
        
        var PRIORI_CLIEN_DESC = _this.$store.getters.GetConfiguracionGeneral.configPv.prioridadDescuentoCliente
      if(PRIORI_CLIEN_DESC==true && _this.clienteFactura != null && _this.clienteFactura.hasOwnProperty('codigo')){
        if(_this.clienteFactura.descuento>0 || _this.clienteFactura.descuentovalor>0 ){
          var desc =0
          if(_this.clienteFactura.descuento>0){
            //desc= ((this.clienteFactura.descuentovalor * 100) / (e.precio * e.cantidad))
              desc= (_this.clienteFactura.descuento)
              _this.Descuentofactura.ValorPorc = false
          }

          if(_this.clienteFactura.descuentovalor>0){
          desc=_this.clienteFactura.descuentovalor
          _this.Descuentofactura.ValorPorc = true
          }
          _this.Descuentofactura.descuento = desc
          await _this.SalvarDescuentoFactura();
        }
        }
        
          }, 800)
        }

        this.suspensiondiascreditoCliente(this.clienteFactura)
        /*this.ComprobanteFisc={
              comprobante:JSON.parse(JSON.stringify(this.Facturasventa.tipocomprobante)),
              nombre:JSON.parse(JSON.stringify(this.Facturasventa.nombreDgii)),
              telefono:JSON.parse(JSON.stringify(this.Facturasventa.telefononcf)),
              direccion:JSON.parse(JSON.stringify(this.Facturasventa.direccionncf)),
              cedrnc:JSON.parse(JSON.stringify(this.Facturasventa.cedularncncf))
            },*/


        // this.clienteFactura = JSON.parse(JSON.stringify(this.busquedaCliente));
        // this.Facturasventa.vendedor
      }
     var BOOL46=this.clienteFactura.hasOwnProperty('tipocomprobante') && this.clienteFactura.tipocomprobante!=null && this.clienteFactura.tipocomprobante.hasOwnProperty('tipoEcf') && this.clienteFactura.tipocomprobante.tipoEcf!=null && this.clienteFactura.tipocomprobante.tipoEcf==46 
      if(BOOL46==true){
          this.ComprobanteFisc.cedrnc=this.clienteFactura.pasaporte
          this.Facturasventa.cedularncncf =this.clienteFactura.pasaporte

this.Facturasventa.infAdicionales=`FechaEmbarque: 03-08-2026,
NumeroEmbarque: XXX,
NumeroContenedor: XX,
NumeroReferencia: XX,
NombrePuertoEmbarque: N/A,
Flete: 0.00,
RegimenAduanero: EXPORTACION NACIONAL,
ViaTransporte:02,
PaisOrigen: REPUBLICA DOMINICANA,
DireccionDestino: ${this.clienteFactura.ciudad.trim()},
PaisDestino: ${this.clienteFactura.pais.nombre.trim()},
NumeroAlbaran:XXXXXX` 
      }

      if(this.CoberturaSeguro.cobertura>0){
        console.log('ahsgdhh-->',this.CoberturaSeguro)
           var _this = this
          setTimeout(function() {
            _this.OpenCoberturaSeguro()
          }, 400)
      }

    },

    suspensiondiascreditoCliente(e) {

      if (e.suspensiondiascredito != null && e.suspensiondiascredito > 0) {
        this.$axios
          .get(this.$hostname + this.$hName + "/reciboingreos/findUltimaFechaDetallePendient/" + e.codigo + "/", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {

            /*fechaSupencion:"2024-04-15"
          supencion: true*/

            if (res.data.supencion == true) {
              var CANT_DIA = 0
              if (typeof e.diascredito === "number" && !isNaN(e.diascredito)) {
                CANT_DIA += e.diascredito
              }

              if (typeof e.suspensiondiascredito === "number" && !isNaN(e.suspensiondiascredito)) {
                CANT_DIA += e.suspensiondiascredito
              }
              var Ahora = new Date()
              var NEW_EXPIRA = new Date(res.data.fechaSupencion)
              NEW_EXPIRA.setDate(NEW_EXPIRA.getDate() + CANT_DIA)
              NEW_EXPIRA = new Date(NEW_EXPIRA)
              if (Ahora >= NEW_EXPIRA) {
                this.clienteFactura.clienteSupencion = true
              } else {
                this.clienteFactura.clienteSupencion = false
              }
            } else {
              this.clienteFactura.clienteSupencion = false
            }

          })
          .catch(error => {
            this.clienteFactura.clienteSupencion = false
          })
      } else {
        this.clienteFactura.clienteSupencion = false
      }


      /*console.log('Viendo-->klk,',)
this.clienteFactura.diascredito
this.clienteFactura.suspensiondiascredito
reciboingreos/findUltimaFechaDetallePendient/{cliente}*/


    },


    async LimpiaInfProducto_DatoClienteSelectRestFact(e) {
      // _this.Facturasventa.tipocomprobante = e.tipoComprobante
      //_this.Facturasventa.tipocomprobante = e.tipoComprobante
      /**/
      if (e.cliente != null) {
        this.clienteFactura = JSON.parse(JSON.stringify(e.cliente))
        this.clienteFactura.codnom = `${e.cliente.codigo} - ${e.cliente.nombre.trim()} `

        if (e.OBJ.hasOwnProperty("numeroOrden") && e.OBJ.numeroOrden != null) {
          this.clienteFactura.numeroOrden = e.OBJ.numeroOrden
        }

      } else {
        if (e.OBJ.descripcion != null && e.OBJ.hasOwnProperty("descripcion") && e.OBJ.descripcion.trim().length > 0) {
          this.Facturasventa.descripcion = e.OBJ.descripcion
        }
      }

      if (e.vendedor != null) {
        this.Facturasventa.vendedor = e.vendedor
      }

      if (e.tipoComp != null) {
        this.Facturasventa.tipocomprobante = e.tipoComp
      } else {
        this.Facturasventa.tipocomprobante = this.$store.getters.GetConfiguracionGeneral.configPv.comprobantefacturacion
      }


      this.PanelMenuOpcionCompleto = true
      this.PanelSelectProducto = true
      this.PanelInfProduct = false
      this.searchProducto = ""
      this.ObjRectPro = null
      this.EsNuevoObjRectPro = true
      this.NewproductoSeleccionado()
      //MIC-2510: https://decasystem.atlassian.net/browse/MIC-2510
      // const result = await this.ReActualizarProductoCompra();
      const result = await this.CalcularTotalesProductosCompra()
      var _this = this
      return new Promise(resolve => {
        setTimeout(() => {
          resolve("resolved")
        }, 999)
      })


      /*if (this.clienteFactura.telefonosClientesList.length > 0) {
  this.Facturasventa.telefononcf = this.clienteFactura.telefonosClientesList[0].telefonosClientesPK.telefono
}
if (this.clienteFactura.cedrnc != null && this.clienteFactura.cedrnc.length > 0) {
  this.Facturasventa.cedularncncf = this.clienteFactura.cedrnc.trim()
}
this.Facturasventa.nombreDgii = this.clienteFactura.nombre
this.Facturasventa.direccionncf = this.clienteFactura.direccion*/

    },


    // Obtener los datos del vendedor de la base de datos y completar el formulario.
    CompletaDatoClienteSelectFactura() {

      // vendedor
      if (this.clienteFactura.vendedor != null) {
        this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/find/" + this.clienteFactura.vendedor, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.Facturasventa.vendedor = res.data
          })

      }

      if (this.clienteFactura.tipocomprobante != null) {
        this.Facturasventa.tipocomprobante = this.clienteFactura.tipocomprobante
      } else {
        this.Facturasventa.tipocomprobante = this.$store.getters.GetConfiguracionGeneral.configPv.comprobantefacturacion
      }

      if (this.clienteFactura.telefonosClientesList.length > 0) {
        this.Facturasventa.telefononcf = this.clienteFactura.telefonosClientesList[0].telefonosClientesPK.telefono
      }

      if (this.clienteFactura.cedrnc != null && this.clienteFactura.cedrnc.length > 0) {
        this.Facturasventa.cedularncncf = this.clienteFactura.cedrnc.trim()
      }

      this.Facturasventa.nombreDgii = this.clienteFactura.nombre
      this.Facturasventa.direccionncf = this.clienteFactura.direccion

    },

    NotifMessage(exc) {

      var notif = {
        estado: true,
        nombre: "Este cliente posee operaciones, si quita el cliente se limpiara  la pantalla completa. \n ¿Seguro que desea quitar este cliente?",
        Exec: exc,
      }
      this.notif = JSON.parse(JSON.stringify(notif))

    },


    cerrarNotifMessage() {
      this.objTemp = null
      this.notif.estado = !this.notif.estado
    },


    ejecNotifMessage(exc, infData) {

      var notif = {
        estado: true,
        nombre: infData,
        Exec: exc,
      }
      this.notif = JSON.parse(JSON.stringify(notif))
    },

    getNombreClienteSelectGlobal(e) {
      var DESC = ""
      if (e != null && e.hasOwnProperty("codigo")) {

        var MODALIDAD_CLI_PRE = this.$store.getters.GetConfiguracionGeneral.configPv.modalidadClientePreferencial
        if (MODALIDAD_CLI_PRE == true) {
          DESC = `.ACUM. ${currencyFormatter(e.balancePuntos)}`
        } else {
          DESC = `${e.nombre.trim()}`
        }
      }
      return DESC
    },


    quitarClienteFactura() {

      var _this = this
      setTimeout(function() {
        _this.clienteFactura = null
        _this.busquedaCliente = null
        _this.SelctCbClienteBuscar()
      }, 200)


      this.NewclienteSeleccionado()
      this.limpiarPuntoVentaCompleto()
      //quitarClienteFactura,clienteFactura.nombre,

      /*  var _this = this;
        setTimeout(function () {
          _this.CalcularTotalesProductosCompra();
        }, 200);*/
    },

    // Llamar a una API  y devolver los datos del comprobante.
    cargarTipoComprobante() {
      this.$axios
        .get(this.$hostname + this.$hName + "/tiponcf/findallactivo", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          this.RtipoComprobante = res.data.filter((ee) => ee.pv == true || ee.especial == true)
        })
    },

    getChangeTipoComprobante(e) {

      if (typeof e === "object" && e != null) {
        //-->/secuenciaComprobantes/existesecuencia/
        // var links=`${this.caja.sucursal.documentofacturacion}/${e.codigo}/PV`
        var links = `${this.caja.sucursal.documentofacturacion}/${e.codigo}/PV/${this.caja.sucursal.rnc.trim()}`
        this.$axios.get(this.$hostname + this.$hName + "/secuenciaComprobantes/existesecuenciaRnc/" + links, {
          headers: this.$store.getters.GetheadersAxios,
        })
          .then((res) => {
            if (res.data == false) {
              this.ComprobanteFisc.comprobante = null
              this.alerta("no posee secuencia este tipo de comprobante", "error")
            }

          })

      }
    },

    filterTipoComprobantePvItbis(List) {
      //RtipoComprobante
      return List.filter((ee) => ee.pv == true && ee.itbis == true || ee.descripcion.trim().toLowerCase().includes("regimen especial") || ee.especial == true)
      //return List.filter((ee) => ee.pv==true && ee.itbis==true );
    },


    filterTipoComprobantePv(List) {
      //RtipoComprobante
      return List.filter((ee) => ee.pv == true)
    },

    changeCbTipoComprobante(e, nombreFocu) {
// cuando el codigo sea mayor a  y que pv sea true
      if (e != null && e.hasOwnProperty("codigo")) {
        var CODCOM = e.codigo
        //  if(CODCOM==2|| CODCOM==3 || CODCOM==4){

        if (CODCOM > 1 && e.pv == true) {
          this.cedularequired = true
          this.RedireccionFocus(nombreFocu)
        } else {
          this.cedularequired = false
        }
      }

    },


    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbTipoComprobante() {

      var _this = this
      setTimeout(function() {
        if (_this.clienteSeleccionado.tipocomprobante == null) {
          _this.clienteSeleccionado.tipocomprobante = ""
        }

        if (!_this.clienteSeleccionado.tipocomprobante.hasOwnProperty("codigo")) {
          _this.alerta("Seleccione un Tipo Comprobante", "error")
          _this.clienteSeleccionado.tipocomprobante = ""
          _this.clienteSeleccionado.tipocomprobante = null
          return
        }
        var CODCOM = _this.clienteSeleccionado.tipocomprobante.codigo
        var BOOLPV = _this.clienteSeleccionado.tipocomprobante.pv
        // if(CODCOM==2|| CODCOM==3 || CODCOM==4){
        if (CODCOM > 1 && BOOLPV == true) {
          _this.cedularequired = true
        } else {
          _this.cedularequired = false
        }


      }, 300)

    },
    SelctCbTipoComprobanteTem() {

      var _this = this
      setTimeout(function() {
        if (_this.clienteTempCredito.tipocomprobante == null) {
          _this.clienteTempCredito.tipocomprobante = ""
        }

        if (!_this.clienteTempCredito.tipocomprobante.hasOwnProperty("codigo")) {
          _this.alerta("Seleccione un Tipo Comprobante", "error")
          _this.clienteTempCredito.tipocomprobante = ""
          _this.clienteTempCredito.tipocomprobante = null
          return
        }
        var CODCOM = _this.clienteTempCredito.tipocomprobante.codigo
        var BOOLPV = _this.clienteTempCredito.tipocomprobante.pv
        // if(CODCOM==2|| CODCOM==3 || CODCOM==4){
        if (CODCOM > 1 && BOOLPV == true) {
          _this.cedularequired = true
        } else {
          _this.cedularequired = false
        }


      }, 300)


    },

    // Llamar a una API y obtener los datos de la API y almacenarlos en la variable RArs.
    cargarArs() {
      this.$axios
        .get(this.$hostname + this.$hName + "/ars/findallactivos", {
          headers: this.$store.getters.GetheadersAxios,
          timeout: 8000,
        })
        .then((res) => {
          this.desactivarModoOfflineForzado()
          this.RArs = res.data
          this.guardarArsOffline(res.data)
        })
        .catch((error) => {
          if (this.esErrorConexionPv(error)) {
            this.activarModoOfflinePorErrorConexion(error)
            this.cargarArsOffline()
          }
        })
    },
    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbArs() {
      if (this.CoberturaSeguro.ars == null) {
        this.CoberturaSeguro.ars = ""
      }
      if (this.CoberturaSeguro.ars.codigo == undefined) {
        this.alerta("Seleccione una ars", "error")
        this.CoberturaSeguro.ars = ""
        return
      }
    },


    SelctCbArsClient() {
      var _this = this
      setTimeout(function() {
        if (_this.clienteSeleccionado.ars == null) {
          _this.clienteSeleccionado.ars = ""
        }

        if (!_this.clienteSeleccionado.ars.hasOwnProperty("codigo")) {
          _this.clienteSeleccionado.ars = ""
          _this.clienteSeleccionado.ars = null
          return
        }
      }, 300)
    },

verklk(e){
console.log('holamundo-->',e)
},

    // Obtener una lista de objetos del servidor y luego insertarlos en una tabla los datos obtenidos.
    async getReimprecionlistFactCliente() {
      this.ListReimprecion = []
      if (this.ReimpresionBusqueda.secuencia.length == 0) {
        this.ReimpresionBusqueda.secuencia = 0
      }
      //var lccaja = JSON.parse(localStorage.caja);
      //lccaja.codigo
      //lccaja.sucursal.codigo

      var cliente = "null"
      var fecini = "null"
      var fecfin = "null"
      var sec = 0
      var caja = ""
      var param = ""

      if (this.$refs.formReimprecion.validate()) {
        var url = ""
        if (this.BtnReimprecionvalue == 0) {
          return
        }
        if (this.BtnReimprecionvalue == 1) {
          url = "recibos"
          if (this.$store.getters.GetConfiguracionGeneral.configPv.modalidadRutaVendedor == true && this.Facturasventa.vendedor != null && this.Facturasventa.vendedor.hasOwnProperty("codigo")) {
            var param = "/" + this.Facturasventa.vendedor.codigo
          }
        }
        if (this.BtnReimprecionvalue == 2) {
          url = "otrosingresos"
        }
        if (this.BtnReimprecionvalue == 3) {

         /* if(this.ReimpresionBusqueda.referencia){}
          if (this.ReimpresionBusqueda.secuencia > 0) {   }*/

          if (this.ReimpresionBusqueda.secuencia > 0) {
             url = "facturas"
          } else {
            url = "facturasCaja"
            caja = "/" + this.caja.codigo
            if (this.$store.getters.GetConfiguracionGeneral.configPv.modalidadRutaVendedor == true && this.Facturasventa.vendedor != null && this.Facturasventa.vendedor.hasOwnProperty("codigo")) {
              var param = "/" + this.Facturasventa.vendedor.codigo
            }
          }

        }
        if (this.BtnReimprecionvalue == 4) {
          url = "devolucion"
        }
        if (this.BtnReimprecionvalue == 5) {
          url = "valecajas"
        }
        if (this.BtnReimprecionvalue == 6) {
          url = "cotizacion"
          if (this.$store.getters.GetConfiguracionGeneral.configPv.modalidadRutaVendedor == true && this.Facturasventa.vendedor != null && this.Facturasventa.vendedor.hasOwnProperty("codigo")) {
            var param = "/" + this.Facturasventa.vendedor.codigo
          }
        }
        if (this.BtnReimprecionvalue == 7) {
          url = "conduce"
          if (this.$store.getters.GetConfiguracionGeneral.configPv.modalidadRutaVendedor == true && this.Facturasventa.vendedor != null && this.Facturasventa.vendedor.hasOwnProperty("codigo")) {
            var param = "/" + this.Facturasventa.vendedor.codigo
          }
        }
        if (this.ReimpresionBusqueda.cliente != null) {
          //cliente = this.ReimpresionBusqueda.cliente.nombre;
          // cliente = this.$refs.RefCombClienteReImprimir.internalSearch;
          // cliente = this.$refs.RefCombClienteReImprimir.internalValue
          if (this.$refs.RefCombClienteReImprimir.selectedItem.hasOwnProperty("codigo")) {
            cliente = this.$refs.RefCombClienteReImprimir.selectedItem.nombre
          } else {
            cliente = this.$refs.RefCombClienteReImprimir.selectedItem
          }

        }
        if (this.ReimpresionBusqueda.fechaInicial != null) {
          fecini = this.ReimpresionBusqueda.fechaInicial
        }
        if (this.ReimpresionBusqueda.fechaFinal != null) {
          fecfin = this.ReimpresionBusqueda.fechaFinal
        }
        if (this.ReimpresionBusqueda.secuencia != null) {
          sec = this.ReimpresionBusqueda.secuencia
        }


        var _this = this
        setTimeout(function() {

          var LINKCOMPL = _this.$hostname + _this.$hName +
            "/reimpresion/" + url + "/" + sec +
            "/" + fecini + "/" + fecfin + "/" + cliente + "/" +
            _this.ReimprecionPaginator.itemsPerPage +
            "/" + (_this.ReimprecionPaginator.pageStart) + caja + param

          // _this.$hostname +
          // _this.$hName +
          // "/reimpresion/" +
          // url +
          // "/" +
          // sec +
          // "/" +
          // fecini +
          // "/" +
          // fecfin +
          // "/" +
          // cliente +
          // "/" +
          // _this.ReimprecionPaginator.itemsPerPage +
          // "/" +
          // (_this.ReimprecionPaginator.pageStart)
          _this.$axios
            .get(LINKCOMPL,
              { headers: _this.$store.getters.GetheadersAxios },
            )
            .then((res) => {
              _this.ListReimprecion = [];
              (_this.TotalRegistros = res.data.cantidad),
                (_this.listFactVent = res.data.listas)

              //  _this.listFactVent.forEach((e) => {});

//(async () => {
              //  await
              Promise.all(_this.listFactVent.map(async (e) => {
                var det = null
                if (_this.BtnReimprecionvalue == 1) {
                  console.log("RECBO--", e)
                  det = {
                    // fecha: e.fecha,
                    fecha: e.nuevaFecha,
                    secuencia: e.recibosdeingresoPK.secuencia,
                    secdoc: e.documentocxc.nombrecorto.trim() + "-" + e.recibosdeingresoPK.secuencia,
                    nombre: e.cliente === null ? "" : e.cliente.nombre,
                    valor: e.valor,
                    ncf: "",
                    comentario: e.concepto,
                    turno: "",
                    pago: _this.ObtenerFormaDepago(e),
                    detalle: e.recibosingresoDetalleList,
                    recibos: e,
                    moneda: e.moneda,
                    tasa: e.tasa,
                  }
                }
                if (_this.BtnReimprecionvalue == 2) {
                  det = {
                    fecha: e.fecha,
                    secuencia: e.secuencia2,
                    secdoc: e.documento.nombrecorto.trim() + "-" + e.secuencia2,
                    nombre: e.nombre.trim(),
                    valor: e.valor,
                    ncf: "",
                    comentario: e.concepto,
                    turno: "",
                    pago: _this.ObtenerFormaDepago(e),
                    detalle: e.facturasventaDetalleList,
                    recibo: e,
                    moneda: e.moneda,
                    tasa: e.tasa,
                  }
                }
                if (_this.BtnReimprecionvalue == 3) {
                  var nomDes = e.descripcion === null ? "" : e.descripcion


                  det = {
                    // fecha: e.fecha,
                    fecha: e.nuevaFecha,
                    secuencia: e.facturasventaPK.secuencia,
                    secdoc: e.documentoFactura.nombrecorto.trim() + "-" + e.facturasventaPK.secuencia,
                    nombre: e.cliente === null ? nomDes : e.cliente.nombre,
                    valor: e.valor,
                    ncf: e.ncf,
                    comentario: e.comentario,
                    turno: e.turno,
                    pago: _this.ObtenerFormaDepago(e),
                    detalle: e.facturasventaDetalleList,
                    factura: e,
                    moneda: e.moneda,
                    tasa: e.tasa,
                  }
                }
                if (_this.BtnReimprecionvalue == 4) {
                  //(e.notacreditocontado===null && e.notacreditocontado.cliente===null ?'':e.notacreditocontado.cliente.nombre),
                  det = {
                    fecha: e.fecha,
                    secuencia: e.devoclucionPK.secuencia,
                    secdoc: e.documentoinventario.nombrecorto.trim() + "-" + e.devoclucionPK.secuencia,
                    nombre:
                      e.notacreditocontado != null &&
                      e.notacreditocontado.cliente != null
                        ? e.notacreditocontado.cliente
                        : "",
                    valor: e.valor,
                    ncf: e.ncf,
                    comentario: e.comentario,
                    turno: "",
                    pago: _this.ObtenerFormaDepago(e),
                    detalle: e.devolucionDetalleList,
                    devolucion: e,
                    moneda: e.moneda,
                    tasa: e.tasa,
                  }
                }
                if (_this.BtnReimprecionvalue == 5) {
                  det = {
                    fecha: e.fecha,
                    secuencia: e.secuencia,
                    secdoc: e.secuencia,
                    nombre: e.beneficiario,
                    valor: e.valor,
                    ncf: "",
                    comentario: e.descripcion,
                    turno: "",
                    pago: _this.ObtenerFormaDepago(e),
                    detalle: e.facturasventaDetalleList,
                    valecaja: e,
                    moneda: _this.$store.getters.GetConfiguracionGeneral.config.monedabase,
                    tasa: _this.$store.getters.GetConfiguracionGeneral.config.monedabase.tasa,
                  }
                }
                if (_this.BtnReimprecionvalue == 6) {
                  det = {
                    fecha: e.nuevaFecha,
                    secuencia: e.secuencia,
                    secdoc: e.secuencia,
                    nombre: e.nombrecliente,
                    valor: e.valor,
                    ncf: "",
                    comentario: e.comentario,
                    turno: "",
                    pago: _this.ObtenerFormaDepago(e),
                    detalle: e.cotizacionDetalleList,
                    cotizacion: e,
                    moneda: _this.$store.getters.GetConfiguracionGeneral.config.monedabase,
                    tasa: _this.$store.getters.GetConfiguracionGeneral.config.monedabase.tasa,
                  }
                }
                if (_this.BtnReimprecionvalue == 7) {
                  det = {
                    fecha: e.fecha,
                    secuencia: e.conduceInventarioPK.secuencia,
                    //nombre: e.cliente == null ? "" : e.cliente.nombre,
                    nombre: e.descripcion !=null? e.descripcion.trim() :"",
                    secdoc: e.documentoinventario.nombrecorto.trim() + "-" + e.conduceInventarioPK.secuencia,
                    valor: e.valor,
                    ncf: "",
                    comentario: e.comentario,
                    turno: null,
                    pago: _this.ObtenerFormaDepago(e),
                    detalle: e.conduceInventarioDetalleList,
                    conduce: e,
                    //  moneda:_this.$store.getters.GetConfiguracionGeneral.config.monedabase,
                    //tasa:_this.$store.getters.GetConfiguracionGeneral.config.monedabase.tasa
                    moneda: e.dtmoneda,
                    tasa: e.tasa,
                  }
                  if(e.cliente!=null && e.cliente.hasOwnProperty("codigo")){
                    det.codigoCentro=e.cliente.codigoCentro
                    det.directorCentro=e.cliente.directorCentro
                    det.numeroRegistroCentro=e.cliente.numeroRegistroCentro
                  }
                }
                if (det != null) {
                  _this.ListReimprecion.push(det)
                }
              }))
              //  })()
            })

        }, 300)

      } else {
        this.alerta("Los campos en rojo son requeridos", "error")
      }
    },
    // Comprobando si el objeto tiene una propiedad y si la tiene devuelve el valor de la propiedad.
    ObtenerFormaDepago(e) {
      var Fpago = ""

if (e.hasOwnProperty("valordonacion") && e.valordonacion > 0) {
        Fpago = "Donacion"
        return Fpago
      }
      
if (e.hasOwnProperty("valorTraspaso") && e.valorTraspaso > 0) {
        Fpago = "Traspaso"
        return Fpago
      }
      
if (e.hasOwnProperty("valorPruebaMetro") && e.valorPruebaMetro > 0) {
        Fpago = "Prueba Metro"
        return Fpago
      }

      
 if (e.hasOwnProperty("valorasignacion") && e.valorasignacion > 0) {
        Fpago = "asignacion"
        return Fpago
      }
      
 if (e.hasOwnProperty("valorbonogas") && e.valorbonogas > 0) {
        Fpago = "bonogas"
        return Fpago
      }

      if (e.hasOwnProperty("puntos") && e.puntos > 0) {
        Fpago = "Puntos"
        return Fpago
      }

      if (e.hasOwnProperty("cxc") && e.cxc > 0) {
        Fpago = "Cuenta Por Cobrar"
        return Fpago
      }

      if (e.hasOwnProperty("tarjeta") && e.tarjeta > 0) {
        Fpago = "Tarjeta de Credito"
        return Fpago
      }

      if (e.hasOwnProperty("cheques") && e.cheques > 0) {
        Fpago = "Cheques"
        return Fpago
      }

      if (e.hasOwnProperty("transferencia") && e.transferencia > 0) {
        Fpago = "Transferencia"
        return Fpago
      }

      if (e.hasOwnProperty("efectivo") && e.efectivo > 0) {
        Fpago = "Efectivo"
        return Fpago
      }

      return Fpago

    },

    // Comprobando si el usuario tiene permiso para imprimir un dato.
    ReimpresionOpciones(e) {
      this.ListReimprecion = []
      this.NewReimprecionFacturaSeleccionada()
      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv(e)
        return
      }

    },

    // Restableciendo la paginación Reimprecion.
    ReimprecionResetCargarPaginacion() {
      this.ReimprecionPaginator = {
        itemsPerPage: 15,
        pageStart: 0,
        page: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      }

      var _this = this
      setTimeout(function() {
        _this.getReimprecionlistFactCliente()
      }, 300)

    },

    ReimprecionCargarPaginacion(e) {
      this.ReimprecionSelected = []
      this.ReimprecionPaginator = e
      if (this.ReimprecionPaginator.itemsPerPage == 1) {
        this.ReimprecionPaginator.itemsPerPage = 15
      }
      this.getReimprecionlistFactCliente()
    },

    // Crear un nuevo objeto con las mismas propiedades que el objeto en la matriz.
    NewReimprecionFacturaSeleccionada() {
      this.ReimprecionFacturaSeleccionada = {
        secuencia: 0,
        fecha: null,
        ncf: "",
        cliente: "",
        comentario: "",
        turno: 0,
        formapago: "",
        DetalleList: [],
        fac: {},
      }
    },

    // Restablecimiento de los datos en el formulario.
    NewAnulacionFacturaSeleccionada() {
      this.dialogAnulacion = false
      this.AnulacionBusqueda.secuencia = 0
      this.AnulacionlistFactCliente = []
      this.AnulacionSelected = []
      this.AnulacionFacturaSeleccionada = null

      this.AnulacionBusqueda = {
        secuencia: 0,
      }
    },

    OpenBuscarFacturaAnular() {
      this.AnulacionBusqueda.secuencia = 0
      this.AnulacionFacturaSeleccionada = null
      this.dialogAnulacion = true
      this.AnulacionSelected = []
      this.AnulacionlistFactCliente = []
      this.getCierreCajaUltima()
      return
      var lccaja = JSON.parse(localStorage.caja)

      var fech = this.fechaNueva()
      //console.log(fech.setDate(fech.getDate() - 1))
      //fech =new Date(fech)
      var cliente = "null",
        fecini = this.fechaNueva(),
        fecfin = this.fechaNueva(),
        sec = 0
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/reimpresion/facturasCaja/" +
          sec +
          "/" +
          fecini +
          "/" +
          fecfin +
          "/" +
          cliente +
          "/" +
          30 +
          "/" +
          0 +
          "/" +
          lccaja.codigo,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.AnulacionlistFactCliente = res.data.listas
        })
        .catch((error) => this.alerta(" ", "error"))
    },

    getCierreCajaUltima() {

      var _this = this
      this.$axios
        .get(this.$hostname + this.$hName + "/cierrecaja/ultimocierre/" +
          this.caja.codigo + "/", { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.CierresCajas.cierrescajasPK.secuencia = res.data
        })

    },


    // Restablecimiento de los valores del objeto.
    CancelarAnulacionFacturaSeleccionada() {
      this.AnulacionBusqueda.secuencia = 0
      this.AnulacionSelected = []
      this.AnulacionFacturaSeleccionada = null

      this.AnulacionBusqueda = {
        secuencia: 0,
      }
    },

    // Llamar a una API y obtener los datos de la API mostrarlo en una tabla.
    buscarFacturaAnulada(e) {
      if (e.target.value == 0) {
        this.OpenBuscarFacturaAnular()
        return 0
      }

      this.AnulacionSelected = []
      this.AnulacionlistFactCliente = []
      var lccaja = JSON.parse(localStorage.caja)
      var cliente = "null",
        fecini = "null",
        fecfin = "null",
        sec = e.target.value
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/reimpresion/facturasCaja/" +
          sec +
          "/" +
          fecini +
          "/" +
          fecfin +
          "/" +
          cliente +
          "/" +
          30 +
          "/" +
          0 +
          "/" +
          lccaja.codigo,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {

          if (res.data.listas.length == 0) {
            this.alerta("Esta factura no existe o no pertenece a la caja seleccionada.", "error")
          }

          this.AnulacionlistFactCliente = res.data.listas
        })
        .catch((error) => this.alerta(" ", "error"))
    },

    AnularObtenerDatoSelect(e) {
      this.AnularDatostabla(e.item)
    },

    // Creando un nuevo objeto y asignándolo a la variable AnulacionFacturaSeleccionada.
    AnularDatostabla(e) {
      if (e.hasOwnProperty("domicilio") && e.domicilio != null) {
        if (e.domicilio.hasOwnProperty("mensajero") && e.domicilio.mensajero != null) {
          this.alerta("No puede hacer una anulación de esta factura porque esta asignada a un mensajero. se debe realizar el proceso de no entregada", "error")
          return
        }
      }
      this.AnulacionSelected = []
      this.AnulacionFacturaSeleccionada = { ...e }
      this.AnulacionSelected.push(e)
      // this.AnulacionFacturaSeleccionada=objjt
    },


    // Comprobar si el formulario es válido, si es válido, es comprobar si la
    // AnulacionFacturaSeleccionada.cxc es mayor a 0 y si la AnulacionFacturaSeleccionada.valor no es
    // igual a la AnulacionFacturaSeleccionada.pendiente. Si lo es, está alertando al usuario de que no
    // se puede anular la factura. Si no es así, se está comprobando si la ejecución es cierta. Si es
    // así, está configurando el ejec
    AnulacionFacturaAnular() {
      if (this.$refs.formAnulacion.validate()) {

        /*if(this.AnulacionFacturaSeleccionada.hasOwnProperty('signatureValue') && this.AnulacionFacturaSeleccionada.signatureValue !=null){
       this.alerta("Esta factura no puede ser Anulada, porque fue realizada con facturacion eletronica", "warning");
       return
      }*/

      console.log('verificar--Anular-->',this.AnulacionFacturaSeleccionada)
/*if(!objData.hasOwnProperty('trackId') || objData.hasOwnProperty('trackId') && objData.trackId==null || objData.trackId!=null && !objData.trackId.includes("estado")){
          this.alerta(`NOTA: La factura: ${objData.ncf!=null?objData.ncf.trim():" "} de esta 'DEVOLUCION' no ha sido emitida en el proceso eletronico. (REVISE)`, "error")
          return
         }*/

var doc = this.caja.sucursal.documentoNotaCredito
this.$axios.get(this.$hostname + this.$hName + "/documentocxc/find/" + doc,
        { headers: this.$store.getters.GetheadersAxios },
      ).then(resdoc => {

          if (resdoc.data.comprobante == true) {
            //-->/secuenciaComprobantes/existesecuencia/
            // var link = resdoc.data.codigo +"/" + "CXC"
            var link = resdoc.data.codigo + "/" + "CXC/" + this.caja.sucursal.rnc.trim()
            this.$axios.get(this.$hostname + this.$hName + "/secuenciaComprobantes/existesecuenciaRnc/" + link,
              { headers: this.$store.getters.GetheadersAxios })
              .then(res => {
                if (res.data == true) {

                  var docDev = this.caja.sucursal.documentoDevolucion
                  this.$axios.get(this.$hostname + this.$hName + "/documento-inv/" + docDev,
                    { headers: this.$store.getters.GetheadersAxios }).then(resdocInv => {
                       if(resdocInv.data.comprobante == true){

                            var linkDev = resdocInv.data.codigo + "/" + "INV/" + this.caja.sucursal.rnc.trim()
                            this.$axios.get(this.$hostname + this.$hName + "/secuenciaComprobantes/existesecuenciaRnc/" + linkDev,
                            { headers: this.$store.getters.GetheadersAxios })
                            .then(resp => {
                                if (resp.data == true) {
                                  this.ContAnulacionFacturaAnular()
                                }else{
                                  this.alerta("No posee secuencia para la Devolucion/Anulacion que está intentado realizar", "error")
                                }

                            })
                            .catch(error => {
                              this.alerta(error, "error")
                              this.loading(false)

                            })


                       }else{
                          this.ContAnulacionFacturaAnular()
                       }

                  })
                    .catch(error => {
                      this.alerta(error, "error")
                      this.loading(false)
                    })

                } else {
                  this.alerta("No posee secuencia para la Notas de Crédito que está intentado realizar", "error")
                }
              })
              .catch(error => {
                this.alerta(error, "error")
                this.loading(false)

              })

          } else {
            this.ContAnulacionFacturaAnular()
          }
      })
          
       
      } else {
        this.alerta("los campos en rojo son requeridos", "error")
      }
    },


    ContAnulacionFacturaAnular(){
       var link = `${this.AnulacionFacturaSeleccionada.facturasventaPK.secuencia}/${this.AnulacionFacturaSeleccionada.facturasventaPK.documento}`
        this.$axios
          .get(
            this.$hostname + this.$hName + "/devolucion/devolucionFactura/" + link,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {

            if (res.data == true) {
              this.alerta("Esta factura no puede ser anulada, porque tiene devoluciones de venta aplicada", "error")
              return
            } else {

              // if (this.AnulacionFacturaSeleccionada.cxc > 0 && this.AnulacionFacturaSeleccionada.valor != this.AnulacionFacturaSeleccionada.pendiente)
              if (this.AnulacionFacturaSeleccionada.cxc > 0 && this.AnulacionFacturaSeleccionada.cxc != this.AnulacionFacturaSeleccionada.pendiente) {
                this.alerta("Esta factura no se puede anular ya que posee algún movimiento.", "error")
                return
              }
              if (this.ejecucion == true) {
                this.ejecucion = false
                var BOOL_ELET = this.AnulacionFacturaSeleccionada.hasOwnProperty("signatureValue") && this.AnulacionFacturaSeleccionada.signatureValue != null

                if (BOOL_ELET == true) {
                  var OBJ = {
                    documento: this.AnulacionFacturaSeleccionada.documentoFactura,
                    factura: this.AnulacionFacturaSeleccionada.facturasventaPK.secuencia,
                    ncf: this.AnulacionFacturaSeleccionada.ncf.trim(),
                    tipoAnulacion: this.TipoAnulacion,
                    movimiento: false,
                    facturasventa: this.AnulacionFacturaSeleccionada,
                    numerocierre: this.CierresCajas.cierrescajasPK.secuencia,
                    caja: this.caja,
                    sucursal: this.caja.sucursal,
                  }
                  this.$refs.RefComponentsAnularFacturas.continuandoFinalizarDevolucionFactura(OBJ)
                } else {
                  this.hacerAnulacion(this.AnulacionFacturaSeleccionada)
                }
              }

            }

          })
          .catch((error) => {
            console.error(error)
          })
    },
  

    hacerAnulacion(OBJ_DATA) {

      //TipoAnulacion
      this.AnulacionFacturaSeleccionada.motivoAnular =
        this.TipoAnulacion.descripcion
      //     var obj={
      //   datos:JSON.parse(JSON.stringify(this.anular)),
      //   usuario:JSON.parse(JSON.stringify(this.$user))
      // }


      if (
        this.AnulacionFacturaSeleccionada.hasOwnProperty("datoTarjeta") &&
        this.AnulacionFacturaSeleccionada.datoTarjeta != null
      ) {
        this.Anulacioncarnet()
      }

      if (
        this.AnulacionFacturaSeleccionada.hasOwnProperty("datoTarjeta") &&
        this.AnulacionFacturaSeleccionada.datoTarjeta == null
      ) {
        this.loading(true)
        this.ProcessFacturaAnula()
      }

    },


    // Envío de una solicitud POST al servidor para anular la factura.
    ProcessFacturaAnula() {
      //this.AnulacionFacturaSeleccionada.
      var obj = {
        secuencia: this.AnulacionFacturaSeleccionada.facturasventaPK.secuencia,
        documento: this.AnulacionFacturaSeleccionada.facturasventaPK.documento,
        motivoAnular: this.AnulacionFacturaSeleccionada.motivoAnular,
        datoTarjeta: this.AnulacionFacturaSeleccionada.datoTarjeta,
        usuariosAnulacion: this.$store.getters.GetdatosInfUsu.usuario.usuario,
        fechaAnulacion: this.fechaNueva().trim().substr(0, 10) + "T04:00",
      }


      this.$axios
        .post(
          this.$hostname + this.$hName + "/AnularFactura/AnularFacturaPv",
          JSON.parse(JSON.stringify(obj)),
        )
        .then((res) => {
          this.alerta("Dato Anulado correctamente", "bien")
          this.loading(false)
          if (localStorage.printerSelect != null) {
          }
          var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
          var impresora = null
          if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
            impresora = JSON.parse(localStorage.printerSelect).nombre
          }
          var msg = {
            accion: "print",
            formato: this.caja.formatoimpresioncontado.trim(),
            impresora: impresora,
            data: this.configuraciones,
            fac: res.data,
            caja: this.caja,
          }
          this.imprimir(msg, "factura")


        })
        .catch((error) => {
          this.alerta(error, "error")
          this.loading(false)
        })
    },

    // Creación de un nuevo objeto con las propiedades del objeto DevolucionFacturaSeleccionada.
    NewDevolucionFacturaSeleccionada() {
      this.DevolucionSelected = []
      this.DevolucionFacturaSeleccionada = {
        secuencia: 0,
        fecha: null,
        ncf: "",
        cliente: "",
        comentario: "",
        turno: 0,
        formapago: "",
        DetalleList: [],
        devtarjeta: false,
      }
      
    },

    // Hacer una llamada API al servidor y obtiene un lista de facturas.
    OpenBuscarFacturaDevolucion() {
      var codUser=JSON.parse(sessionStorage.getItem("codUsuAutorizacion"))
       if(codUser!=null){ 
       this.codUsuAutorDev=codUser;
      }else{
        this.codUsuAutorDev=this.$store.getters.GetdatosInfUsu.usuario.codigo
      }

      this.DevolucionBusqueda.secuencia = 0
      this.DevolucionSelected = []
      this.DevolucionlistFactCliente = []
      this.dialogDevolucion = true


      /*let date = new Date();
      var fech = date.toLocaleDateString("en-CA");*/
      var fech = this.fechaNueva()
      // console.log(this.$hostname+this.$hName+'/devolucion/'+fech+'/facturasFecha/'+this.caja.sucursal.codigo)

      var param = ""
      if (this.$store.getters.GetConfiguracionGeneral.configPv.modalidadRutaVendedor == true && this.Facturasventa.vendedor != null && this.Facturasventa.vendedor.hasOwnProperty("codigo")) {
        var param = "/" + this.Facturasventa.vendedor.codigo
      }


      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/devolucion/" +
          fech +
          "/facturasFecha/" +
          this.caja.sucursal.codigo + param,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.DevolucionlistFactCliente = res.data
        })
    },

    // Hacer una llamada axios al backend y devolver una lista de objetos de factura.
    buscarFacturaDevolucion(e) {
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/devolucion/" +
          e.target.value +
          "/facturas/" +
          this.caja.sucursal.codigo,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.DevolucionlistFactCliente = res.data
        })
    },

    filterFacturaDevolucion(list) {
      // console.log('list-->',list)
      var LIST_DIRE = list.filter((ee) => ee.domicilio == null || ee.domicilio != null && ee.domicilio.devuelto == false)
      return JSON.parse(JSON.stringify(LIST_DIRE))
    },


    /*FinalizarDevolucionFactura(){
      if(this.DevolucionFacturaSeleccionada.cxc!=null&& this.DevolucionFacturaSeleccionada.cxc>0){
        var FactObj= this.DevolucionSelected[0]
     if(FactObj.cxc!= FactObj.pendiente){
      //notas: hay que ir a verificar si tiene recibo de increso
      this.alerta("Devolucion salvada correctamente !!!", "bien");
     }

      }else{
        this.ContFinalizarDevolucionFactura()
      }
     //
    },*/

    // Crear un nuevo objeto y asignarle valores.
    async FinalizarDevolucionFactura() {

      var _this = this

      if (this.ejecucion == true) {
        this.ejecucion = false
        this.loading(true)
        var _this = this
                    setTimeout(function() {
              _this.$axios.get(_this.$hostname + _this.$hName + "/cierrecaja/ultimocierre/" +
              _this.caja.codigo + "/", { headers: _this.$store.getters.GetheadersAxios })
                    .then((res) => {
                      _this.CierresCajas.cierrescajasPK.secuencia = res.data
                      setTimeout(function() {
                        _this.continuandoFinalizarDevolucionFactura()
                      }, 300)
                    })  

                    }, 600)
      }
    },


    async continuandoFinalizarDevolucionFactura() {
      var DEV_FAC_SEL = this.DevolucionFacturaSeleccionada

      if (DEV_FAC_SEL.hasOwnProperty("domicilio") && DEV_FAC_SEL.domicilio != null && DEV_FAC_SEL.domicilio.facturado == false) {
        var BOOLMEN = (!DEV_FAC_SEL.hasOwnProperty("mensejero") || DEV_FAC_SEL.hasOwnProperty("mensejero") && DEV_FAC_SEL.mensejero == null)
        if (BOOLMEN == true) {
          if (DEV_FAC_SEL.DetalleList.length != DEV_FAC_SEL.SeletDetalleList.length || DEV_FAC_SEL.valortotal != DEV_FAC_SEL.domicilio.valor) {
            this.alerta("Esta factura es de domicilio y no esta asignada a un mensajero, debe de anular o hacer la devolución completa.", "error")
            return
          }
        }

      }

      //this.$store.getters.GetdatosInfUsu.usuario.nombre
      //this.$store.getters.GetdatosInfUsu.usuario.codigo
      EventBus.$emit("loading", true)
      var l = this.DevolucionSelected[0]
      if (l.hasOwnProperty("horaFactura")) {
        delete l["horaFactura"]
      }


      var domnoentre = null
      if (this.DevolucionFacturaSeleccionada.hasOwnProperty("domicilionoentregado") && this.DevolucionFacturaSeleccionada.domicilionoentregado != null) {
        domnoentre = this.DevolucionFacturaSeleccionada.domicilionoentregado
      }
 
      this.devolucion = {
        devoclucionPK: { documento: 0, secuencia: 0 },
        // fecha: new Date(),
        fecha: null,
        referencia: "",
        valor: 0.0,
        valorItbis: 0.0,
       // usuario: this.$store.getters.GetdatosInfUsu.usuario.codigo,
        usuario: this.codUsuAutorDev,
        ncf: "",
        caja: this.caja.codigo,
        numerocierre: this.CierresCajas.cierrescajasPK.secuencia,
        efectivo: this.DevolucionFacturaSeleccionada.efectivo,
        quitaritbis: this.DevolucionFacturaSeleccionada.quitaritbis,
        cobertura: null,
        fechaImpresion: null,
        nif: null,
        horaImpresion: null,
        comentario: this.DevolucionFacturaSeleccionada.comentario,
        borrado: false,
        devolucionDetalleList: [],
        facturasventa: l,
        nombre: this.AceptarDevolucion.nombre,
        cedula: this.AceptarDevolucion.cedula,
        notacreditocontado: null,
        notacreditoclientes: null,
        documentoinventario: null,
        almacen: this.caja.almacen,
        activo: true,
        domicilionoentregado: domnoentre,
        moneda: this.DevolucionFacturaSeleccionada.moneda,
        tasa: this.DevolucionFacturaSeleccionada.tasa,
        devtarjeta: this.DevolucionFacturaSeleccionada.devtarjeta,
        qrdgii: this.DevolucionFacturaSeleccionada.hasOwnProperty("qrdgii") && this.DevolucionFacturaSeleccionada.qrdgii != null ? this.DevolucionFacturaSeleccionada.qrdgii : null,
        signatureValue: this.DevolucionFacturaSeleccionada.hasOwnProperty("signatureValue") && this.DevolucionFacturaSeleccionada.signatureValue != null ? this.DevolucionFacturaSeleccionada.signatureValue : null,
        trackId: this.DevolucionFacturaSeleccionada.hasOwnProperty("trackId") && this.DevolucionFacturaSeleccionada.trackId != null ? this.DevolucionFacturaSeleccionada.trackId : null,
        fechafirmadgii: this.DevolucionFacturaSeleccionada.hasOwnProperty("fechafirmadgii") && this.DevolucionFacturaSeleccionada.fechafirmadgii != null ? this.DevolucionFacturaSeleccionada.fechafirmadgii : null,
      }


      this.devolucion.devolucionDetalleList = []
      /* var bar = new Promise((resolve, reject) => {
        this.DevolucionFacturaSeleccionada.SeletDetalleList.forEach(async (d) => {
        this.detalleDevolucion(d);
        //this.devolucion.valor = this.devolucion.valor + d.cantidad * d.precio;
        this.devolucion.valor = this.devolucion.valor + d.valor;
        resolve()
      });
     });

  bar.then(() => {
  console.log('All done Devolucion arrays!')
  this.saveDevolucion();
    });


     */
      await Promise.all(this.DevolucionFacturaSeleccionada.SeletDetalleList.map(async (d) => {
        this.detalleDevolucion(d)
       // this.devolucion.valor = this.devolucion.valor + d.valor
        if (this.DevolucionFacturaSeleccionada.quitaritbis == true) {
          this.devolucion.valorItbis = 0
        } else {
          this.devolucion.valorItbis = this.devolucion.valorItbis + (d.cantidad * d.valorimpuesto)
          //this.devolucion.valorItbis = this.devolucion.valorItbis + d.valor;
        }
      }))

    //this.devolucion.valor = this.DevolucionFacturaSeleccionada.valordevolucion
    console.log('DETA-valor->',this.DevolucionFacturaSeleccionada.valordevolucion)
    console.log('DETA-valor-this.DevolucionFacturaSeleccionada->',this.DevolucionFacturaSeleccionada)
   this.devolucion.valor =  parseFloat(this.currencyFormatter2(this.DevolucionFacturaSeleccionada.valordevolucion).replaceAll(',', ''))
    // console.log('his.devolucion->',this.devolucion)

      this.devolucion.totalDescuento=this.DevolucionFacturaSeleccionada.SeletDetalleList.reduce((total, item) => total + item.valordescuento, 0);
      this.preValidarSaveDevolucion()

    },

    preValidarSaveDevolucion() {

      this.$axios.post(
        this.$hostname + this.$hName + "/devolucion/verificarDevolucion",
        this.devolucion,
        { headers: this.$store.getters.GetheadersAxios },
      )
        .then((res) => {
          if (res.data.continuarDev == false) {
            this.alerta(res.data.mensage, res.data.estado)
            //DevolucionFacturaSeleccionada.SeletDetalleList
            //DevolucionFacturaSeleccionada.DetalleList

            this.DevolucionFacturaSeleccionada.SeletDetalleList.filter((ee) => ee.facturasventaDetallePK.producto == res.data.producto &&
              ee.facturasventaDetallePK.unidad == res.data.unidad &&
              ee.facturasventaDetallePK.secuencia == res.data.secFac &&
              ee.facturasventaDetallePK.documento == res.data.docFac,
            )[0].cantidadPendiente = res.data.catPendiente

            this.DevolucionFacturaSeleccionada.DetalleList.filter((ee) => ee.facturasventaDetallePK.producto == res.data.producto &&
              ee.facturasventaDetallePK.unidad == res.data.unidad &&
              ee.facturasventaDetallePK.secuencia == res.data.secFac &&
              ee.facturasventaDetallePK.documento == res.data.docFac,
            )[0].cantidadPendiente = res.data.catPendiente

          }
          if (res.data.continuarDev == true) {
            this.saveDevolucion()
          }

        })
        .catch((error) => {
          this.loading(false)
          if (error.response) {
            this.alerta(error.response.request.responseText, "error")
          } else {
            this.alerta(error, "error")
          }
        })

    },

    // Envío de una solicitud POST al servidor guardando la devolucion.
    saveDevolucion() {

      //var doc=this.caja.sucursal
      //documentoNotaCredito
      //console.log(this.devolucion);
      /*if(this.DevolucionFacturaSeleccionada.efectivo==false){
        var doc=this.caja.sucursal.documentoNotaCredito
      }else{

      }
      return*/
      //var doc=this.caja.sucursal.documentofacturacredito

      var doc = this.caja.sucursal.documentoNotaCredito
      this.$axios.get(this.$hostname + this.$hName + "/documentocxc/find/" + doc,
        { headers: this.$store.getters.GetheadersAxios },
      ).then(resdoc => {

        if (this.devolucion.devolucionDetalleList.length > 0) {

          if (resdoc.data.comprobante == true) {
            //-->/secuenciaComprobantes/existesecuencia/
            // var link = resdoc.data.codigo +"/" + "CXC"
            var link = resdoc.data.codigo + "/" + "CXC/" + this.caja.sucursal.rnc.trim()
            this.$axios.get(this.$hostname + this.$hName + "/secuenciaComprobantes/existesecuenciaRnc/" + link,
              { headers: this.$store.getters.GetheadersAxios })
              .then(res => {
                if (res.data == true) {

                  var docDev = this.caja.sucursal.documentoDevolucion
                  this.$axios.get(this.$hostname + this.$hName + "/documento-inv/" + docDev,
                    { headers: this.$store.getters.GetheadersAxios }).then(resdocInv => {

                    var BOOL_ELET = this.caja.sucursal.facturacionEletronica == true && this.caja.facturacionEletronica == true
//  console.log('verificar',BOOL_ELET==true && resdocInv.data.comprobante==false)
                    if (BOOL_ELET == true && resdocInv.data.comprobante == false) {
                      this.alerta(`Nota: Esta caja esta asignada como facturador electrónico y el documento: "${resdocInv.data.nombrecorto}- ${resdocInv.data.descripcion}". no genera comprobante.`, "error")
                      return
                    }

                    var _this = this
                    setTimeout(function() {
                      _this.ContinuarsaveDevolucion()
                    }, 600)

                  })
                    .catch(error => {
                      this.alerta(error, "error")
                      this.loading(false)
                    })

                } else {
                  this.alerta("No posee secuencia para la Notas de Crédito que está intentado realizar", "error")
                }
              })
              .catch(error => {
                this.alerta(error, "error")
                this.loading(false)

              })

          } else {
            this.ContinuarsaveDevolucion()
          }

        } else {
          this.ejecucion = true
          EventBus.$emit("loading", false)
        }

      })
    },

    ContinuarsaveDevolucion() {
      if (this.devolucion.devolucionDetalleList.length > 0) {
        //this.devolucion.usuario=this.$store.getters.GetOtrasConfigPv.cajero
        this.loading(true)
        this.$axios.post(
          this.$hostname + this.$hName + "/devolucion/save",
          this.devolucion,
          { headers: this.$store.getters.GetheadersAxios },
        )
          .then((res) => {
            this.codUsuAutorDev=this.$store.getters.GetdatosInfUsu.usuario.codigo
            var BOOL_ELET = this.caja.sucursal.facturacionEletronica == true && this.caja.facturacionEletronica == true && res.data.facturasventa.hasOwnProperty("signatureValue") && res.data.facturasventa.signatureValue != null

            if (BOOL_ELET == true) {
              this.DevolucionEletronicaGet(res.data)
            } else {
              this.devolucion = res.data
              this.cancelarAceptarDevolucion()
              this.enviarImprimirDevolucion(res.data)

            }/**/

            // this.enviarImprimirDevolucion(res.data)

          })
          .catch((error) => {
            this.loading(false)
            if (error.response) {
              this.alerta(error.response.request.responseText, "error")
            } else {
              this.alerta(error, "error")
            }
          })
      } else {
        this.ejecucion = true
        EventBus.$emit("loading", false)
      }
    },

    enviarImprimirDevolucion(DEV) {
      /**/
      var _this = this
      setTimeout(function() {
        _this.alerta("Devolucion salvada correctamente !!!", "bien")
        if (localStorage.printerSelect != null) {
        }
        var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
        var impresora = null
        if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
          impresora = JSON.parse(localStorage.printerSelect).nombre
        }
        var msg = {
          accion: "print",
          formato: _this.caja.formatoimpresioncontado.trim(),
          impresora: impresora,
          data: _this.configuraciones,
          devolucion: DEV,
          caja: _this.caja,
          cajero: _this.$store.getters.GetOtrasConfigPv.cajero,
        }
        _this.imprimir(msg, "devolucion")
        _this.limpiarPuntoVentaCompleto()
      }, 100)

    },


    // Agregar un nuevo objeto a la lista de devolucion detalle.
    async detalleDevolucion(datos) {
      var det = {
        cantidad: datos.cantidad,
        precio: datos.precio,
        costo: datos.costounidad,
        codigo: 0,
        documentofactura: null,
        borrado: false,
        producto: datos.productos,
        unidad: datos.unidades,
        quitaritbis: this.DevolucionFacturaSeleccionada.quitaritbis,
        valor: datos.valor,
        valordescuento: datos.valordescuento,
        valorimpuesto: datos.valorimpuesto,
      }

      if(datos.hasOwnProperty("loteFabricante") && datos.loteFabricante != null && datos.loteFabricante.trim().length>0 ){
          det.loteFabricante=datos.loteFabricante;
      }

      if (this.UsarLote == true) {
        det.lote = datos.lote
      }

      this.devolucion.devolucionDetalleList.push(det)
    },

    DevolucionVerificaCantidad(e) {
      if (e.cantidad > e.cantidadPendiente) {
        e.cantidad = e.cantidadPendiente
      }
      if (e.cantidad <= 0) {
        e.cantidad = e.cantidadPendiente
      }
    },
    devolucionDescuento(ee) {

      var Cant = ee.cantidad
      var PrecioVal = 0


      if (this.ConfImpfiscal == true) {
        PrecioVal = ee.precio
      } else {

        if (ee.productos.incluirimpuestoenprecio == true) {
          if (ee.productos.impuesto != null) {
            PrecioVal = (ee.precio) / (1 + (ee.productos.impuesto.tasa / 100))
          } else {
            PrecioVal = ee.precio
          }
        } else {

          PrecioVal = ee.precio
        }

      }

// ee.DescValor = ((ee.descuento * (PrecioVal * Cant)) / 100)
      var valordescuento = ((ee.descuento * (PrecioVal * Cant)) / 100)

      return valordescuento

    },

    // DevolucionValor METODO ORIGINAL
    DevolucionValor_Original(e) {
      //DevolucionFacturaSeleccionada.DetalleList
      //this.RedondeoBasico(this.Facturasventa.tarjeta)
      //this.DevolucionFacturaSeleccionada.quitaritbis
      var itbisTasa = 0.00
      var itbis = 0.00
      var descuento = 0.00
      var descuentoValor = 0.00
      var precioSinItbis = 0.00
      var valor = 0.00
      if (e.productos.impuesto != null) {
        itbisTasa = e.productos.impuesto.tasa
      }
      if (e.valordescuento > 0) {
        var DESCUENTOVALOR = this.devolucionDescuento(e)
        descuentoValor = this.RedondeoValor(DESCUENTOVALOR / e.cantidad)
      }
      if (e.descuento > 0) {
        if (itbisTasa > 0) {
          if (e.productos.incluirimpuestoenprecio) {
            descuento = e.cantidad * this.RedondeoValor(((e.precio / (1 + (itbisTasa / 100))) * (e.descuento / 100)))
            precioSinItbis = e.cantidad * this.RedondeoValor((e.precio / (1 + (itbisTasa / 100))))
            itbis = this.RedondeoValor((precioSinItbis - descuento) * (itbisTasa / 100))
            if (this.DevolucionFacturaSeleccionada.quitaritbis) {
              itbis = 0
            }
            valor = (precioSinItbis - descuento) + itbis
          } else {
            descuento = e.cantidad * this.RedondeoValor((e.precio * (e.descuento / 100)))
            precioSinItbis = e.cantidad * this.RedondeoValor(e.precio)
            itbis = this.RedondeoValor((precioSinItbis - descuento) * (itbisTasa / 100))
            if (this.DevolucionFacturaSeleccionada.quitaritbis) {
              itbis = 0
            }
            valor = (precioSinItbis - descuento) + itbis
          }
        } else {
          if (descuentoValor > 0) {
            valor = (e.cantidad * e.precio) - (e.cantidad * descuentoValor)
          } else {
            valor = e.cantidad * (e.precio) * (e.descuento / 100)
          }
        }
      } else {
        if (this.DevolucionFacturaSeleccionada.quitaritbis) {
          if (e.valorimpuesto > 0) {
            valor = e.cantidad * (e.precio - e.valorimpuesto)
          } else {
            valor = e.cantidad * (e.precio)
          }
        } else {
          valor = e.cantidad * e.precio
        }
      }
      if (this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido == true) {
        e.valor = valor
      } else {
        e.valor = (valor + (e.valorimpuesto * e.cantidad))
      }


      return e.valor
    },

    DevolucionValor(e) {
      //DevolucionFacturaSeleccionada.DetalleList
      //this.RedondeoBasico(this.Facturasventa.tarjeta)
      //this.DevolucionFacturaSeleccionada.quitaritbis
      var itbisTasa = 0.00
      var itbis = 0.00
      var descuento = 0.00
      var descuentoValor = 0.00
      var precioSinItbis = 0.00
      var valor = 0.00

      if (!e.hasOwnProperty("cantFact") || e.hasOwnProperty("cantFact") && e.cantFact == null) {
        e.cantFact = JSON.parse(JSON.stringify(e.cantidad))
      }

      if (e.productos.impuesto != null) {
        itbisTasa = e.productos.impuesto.tasa
      }
      if (e.valordescuento > 0) {
        var DESCUENTOVALOR = this.devolucionDescuento(e)
        //descuentoValor = this.RedondeoValor(DESCUENTOVALOR / e.cantidad);
        // descuentoValor = this.RedondeoValor(DESCUENTOVALOR / e.cantFact)
        descuentoValor = JSON.parse(JSON.stringify(this.RedondeoValor(DESCUENTOVALOR/e.cantidad)))
        e.valordescuento=JSON.parse(JSON.stringify(this.RedondeoValor(DESCUENTOVALOR)))

      }
      if (e.descuento > 0) {
        if (itbisTasa > 0) {

          if (e.productos.incluirimpuestoenprecio) {
            descuento = e.cantidad * this.RedondeoValor(((e.precio / (1 + (itbisTasa / 100))) * (e.descuento / 100)))
            precioSinItbis = e.cantidad * this.RedondeoValor((e.precio / (1 + (itbisTasa / 100))))
            itbis = this.RedondeoValor((precioSinItbis - descuento) * (itbisTasa / 100))
            if (this.DevolucionFacturaSeleccionada.quitaritbis) {
              itbis = 0
            }
            valor = (precioSinItbis - descuento) + itbis
          } else {
            //((prec-(desc/cantfat))+itbis)*cantdev
            //((585.64-(117.12799999999999/2))+94.875)*2
            descuento = (e.valordescuento / e.cantFact)
            itbis = e.valorimpuesto

            if (this.DevolucionFacturaSeleccionada.quitaritbis) {
              itbis = 0
            }
            
            valor = this.RedondeoValor(((e.precio - (descuento)) + itbis) * e.cantidad)

          }

        } else {
          if (descuentoValor > 0) {
            valor = (e.cantidad * e.precio) - (e.cantidad * descuentoValor)
          } else {
            valor = e.cantidad * (e.precio) * (e.descuento / 100)
          }
        }
      } else {

        if (e.productos.incluirimpuestoenprecio) {
          console.log("quitaritbis-->", this.DevolucionFacturaSeleccionada.quitaritbis)
          if (this.DevolucionFacturaSeleccionada.quitaritbis) {
            if (e.valorimpuesto > 0) {
              valor = e.cantidad * (e.precio - e.valorimpuesto)
            } else {
              valor = e.cantidad * (e.precio)
            }
          } else {
            valor = e.cantidad * e.precio
          }
        } else {
          //((prec-(desc/cantfat))+itbis)*cantdev
          //((585.64-(117.12799999999999/2))+94.875)*2
          descuento = (e.valordescuento / e.cantFact)
          itbis = e.valorimpuesto
//valor=this.RedondeoValor(((e.precio-(descuentoValor))+itbis)*e.cantidad)
          if (this.DevolucionFacturaSeleccionada.quitaritbis) {
            itbis = 0
          }

          valor = this.RedondeoValor(((e.precio - (descuento)) + itbis) * e.cantidad)
        }


      }



      if (this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido == true) {
        e.valor = valor
      } else {
        e.valor = valor
      }


      return this.RedondeoValor(e.valor)
    },

    verificarVenFacDev() {
      var fechaHoy = this.fechaNueva()
      var fechBase = this.DevolucionFacturaSeleccionada.fecha
      var fechNew = new Date(this.DevolucionFacturaSeleccionada.fecha)
      fechNew.setDate(fechNew.getDate() + 30)
      fechNew = new Date(fechNew).toLocaleDateString("en-CA")
      if (fechaHoy > fechNew) {
        this.alerta(`La factura pasa de los 30 días de su emisión ${this.FormatoFecha(this.DevolucionFacturaSeleccionada.fecha)}, se recomiendo quitar el itbis`, "error")
      }
    },

DevoItemCant(){

 var _this = this
        setTimeout(function() {
          // console.log('ejecutando-DevoItemCant-->')
          _this.DevolucionValorTotal()
        }, 500)
},

    async DevolucionValorTotal() {
      this.DevolucionFacturaSeleccionada.valordevolucion = 0
      if (this.DevolucionFacturaSeleccionada.SeletDetalleList.length > 0) {
        await Promise.all(this.DevolucionFacturaSeleccionada.SeletDetalleList.map(async (element) => {
          this.DevolucionFacturaSeleccionada.valordevolucion += element.valor
        }))

      }
    },

    DevolucionObtenerDatoSelect(e) {
      this.DevolucionDatostabla(e.item)
    },

    async DevolucionDatostabla(e) {
      if (e.hasOwnProperty("cobertura") && e.cobertura != null && e.cobertura > 0) {
        this.alerta("No puede hacer una devolución de esta factura porque es de seguro. esta se debe anular", "error")
        return
      }

      if (e.hasOwnProperty("domicilio") && e.domicilio != null && e.domicilio.facturado == false) {
        if (e.domicilio.hasOwnProperty("mensajero") && e.domicilio.mensajero != null) {
          this.alerta("No puede hacer una devolución de esta factura porque esta asignada a un mensajero. se debe realizar el proceso de no entregada", "error")
          this.DevolucionSelected = []
          return
        }
      }

      this.DevolucionSelected = []
      var objjt = {
        factcaja: e.caja,
        valordevolucion: 0,
        valortotal: e.valor,
        secuencia: e.facturasventaPK.secuencia,
        //fecha: new Date(e.fecha).toISOString().substr(0, 10),
        fecha: e.nuevaFecha,
        ncf: e.ncf,
        cliente: e.cliente == null ? "" : e.cliente.nombre,
        cedula: e.cliente != null ? e.cliente.cedrnc : "",
        comentario: "",
        turno: e.turno,
        formapago: this.ObtenerFormaDepago(e),
        DetalleList: [],
        SeletDetalleList: [],
        efectivo: false,
        quitaritbis: false,
        moneda: e.moneda,
        tasa: e.tasa,
        domicilio: e.hasOwnProperty("domicilio") ? e.domicilio : null,
        cheques: e.hasOwnProperty("cheques") && e.cheques != null ? e.cheques : 0,
        cupones: e.hasOwnProperty("cupones") && e.cupones != null ? e.cupones : 0,
        cxc: e.hasOwnProperty("cxc") && e.cupones != null ? e.cxc : 0,
        Pagoefec: e.hasOwnProperty("efectivo") && e.cupones != null ? e.efectivo : 0,
        puntos: e.hasOwnProperty("puntos") && e.puntos != null ? e.puntos : 0,
        tarjeta: e.hasOwnProperty("tarjeta") && e.tarjeta != null ? e.tarjeta : 0,
        valorNc: e.hasOwnProperty("valorNc") && e.valorNc != null ? e.valorNc : 0,
        transferencia: e.hasOwnProperty("transferencia") && e.transferencia != null ? e.transferencia : 0,
        valorbonogas: e.hasOwnProperty("valorbonogas") && e.valorbonogas != null ? e.valorbonogas : 0,
        valorasignacion: e.hasOwnProperty("valorasignacion") && e.valorasignacion != null ? e.valorasignacion : 0,
        valorPruebaMetro: e.hasOwnProperty("valorPruebaMetro") && e.valorPruebaMetro != null ? e.valorPruebaMetro : 0,
        valorTraspaso: e.hasOwnProperty("valorTraspaso") && e.valorTraspaso != null ? e.valorTraspaso : 0,
        valordonacion: e.hasOwnProperty("valordonacion") && e.valordonacion != null ? e.valordonacion : 0,
        pendiente: e.hasOwnProperty("pendiente") && e.pendiente != null ? e.pendiente : 0,
        numerocierre: e.numerocierre,
        devtarjeta: false,
        qrdgii: null,
        signatureValue: null,
        trackId: null,
        fechafirmadgii: null,
        /*qrdgii:e.hasOwnProperty("qrdgii") && e.qrdgii != null ? e.qrdgii : null,
        signatureValue:e.hasOwnProperty("signatureValue") && e.signatureValue != null ? e.signatureValue : null,
        trackId:e.hasOwnProperty("trackId") && e.trackId != null ? e.trackId : null,
        fechafirmadgii:e.hasOwnProperty("fechafirmadgii") && e.fechafirmadgii != null ? e.fechafirmadgii : null*/
      }
      //DetalleList:e.facturasventaDetalleList,
      //e.facturasventaDetalleList.forEach((element) => { });
      await Promise.all(e.facturasventaDetalleList.map(async (element) => {
        element.cantFact = JSON.parse(JSON.stringify(element.cantidad))
        element.cantidad = element.cantidadPendiente
        objjt.DetalleList.push(element)
      }))


      this.DevolucionSelected.push(e)
      this.DevolucionFacturaSeleccionada = objjt

      var fechaHoy = this.fechaNueva()
      var fechBase = e.nuevaFecha
      var fechNew = new Date(e.nuevaFecha)
      fechNew.setDate(fechNew.getDate() + 30)
      fechNew = new Date(fechNew).toLocaleDateString("en-CA")
      var _this = this
      setTimeout(function() {
        if (fechaHoy > fechNew) {
          _this.alerta(`La factura pasa de los 30 días de su emisión ${_this.FormatoFecha(e.nuevaFecha)}, se recomiendo quitar el itbis`, "error")
          _this.DevolucionFacturaSeleccionada.quitaritbis = true
          _this.DevolucionValorTotal()
        }

      }, 900)

    },

    ReimprecionObtenerDatoSelect(e) {
      this.ReimprecionDatostabla(e.item)
    },
    async ReimprecionDatostabla(e) {
      this.NewReimprecionFacturaSeleccionada()
      this.ReimprecionSelected = []
      this.ReimprecionSelected.push(e)
      var objjt = null
      objjt = {
        secuencia: e.secuencia,
        secdoc: e.secdoc,
        fecha: new Date(e.fecha),
        ncf: e.ncf,
        cliente: e.nombre,
        comentario: e.comentario,
        turno: e.turno,
        formapago: e.pago,
        DetalleList: e.detalle,
        valor: e.valor,
        factura: JSON.parse(JSON.stringify(e)),
        moneda: e.moneda,
        tasa: e.tasa,
      }
      if (this.BtnReimprecionvalue == 1) {
        objjt.factura.recibos.fecha = new Date(e.recibos.fecha).toISOString().substr(0, 10)

        if (e.recibos.ncAutomatico == true) {
          await Promise.all(objjt.factura.recibos.recibosingresoDetalleList.filter((ee) => ee.descuentoInformativoNc > 0).map(async (element) => {
            element.descuento = element.descuentoInformativoNc
          }))
          objjt.DetalleList = JSON.parse(JSON.stringify(objjt.factura.recibos.recibosingresoDetalleList))
        }

      }
      if (this.BtnReimprecionvalue == 2) {
        objjt.factura.recibo.fecha = new Date(e.fecha).toISOString().substr(0, 10)
      }

      if (this.BtnReimprecionvalue == 3) {
        objjt.factura.fecha = new Date(e.fecha).toISOString().substr(0, 10)
        objjt.factura.factura.fecha = new Date(e.fecha).toISOString().substr(0, 10)
        if (objjt.factura.factura.ncfVencimiento != null) {
          objjt.factura.factura.ncfVencimiento = objjt.factura.factura.ncfVencimientonuevaFecha
        }
        objjt.lineaAerea = e.lineaAerea
        objjt.numeroVuelo = e.numeroVuelo
        objjt.rutaRetornoD = e.rutaRetornoD
        objjt.rutaRetornoE = e.rutaRetornoE
        objjt.rutaSalidaD = e.rutaSalidaD
        objjt.rutaSalidaE = e.rutaSalidaE
      
        objjt.qrdgii= e.factura.qrdgii
        objjt.signatureValue=e.factura.signatureValue
        objjt.trackId=e.factura.trackId
        objjt.fechafirmadgii=e.factura.fechafirmadgii

        /*var sec=e.factura.facturasventaPK.secuencia
        var doc=e.factura.facturasventaPK.documento
        this.$axios
        .get(this.$hostname + this.$hName + `/facturasventas/findDomicilioFactura/${sec}/${doc}`, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          console.log('domicilio')
          console.log(res.data)
        })
        .catch((error) => console.log(error));*/

      }

      if (this.BtnReimprecionvalue == 4) {
        objjt.factura.devolucion.fecha = new Date(e.devolucion.fecha).toISOString().substr(0, 10)
        objjt.factura.devolucion.facturasventa.fecha = new Date(e.devolucion.facturasventa.fecha).toISOString().substr(0, 10)
        objjt.quitaritbis = e.devolucion.quitaritbis
   
        objjt.qrdgii= e.devolucion.qrdgii
        objjt.signatureValue=e.devolucion.signatureValue
        objjt.trackId=e.devolucion.trackId
        objjt.fechafirmadgii=e.devolucion.fechafirmadgii
      }

      if (this.BtnReimprecionvalue == 5) {
        objjt.factura.valecaja.fecha = new Date(e.valecaja.fecha).toISOString().substr(0, 10)
      }

      if (this.BtnReimprecionvalue == 6) {
        objjt.factura.cotizacion.fecha = new Date(e.cotizacion.fecha).toISOString().substr(0, 10)
      }

      if (this.BtnReimprecionvalue == 7) {
        objjt.factura.conduce.fecha = new Date(e.conduce.fecha).toISOString().substr(0, 10)
      }

      //objjt.factura.fecha=new Date(e.fecha).toISOString().substr(0, 10)
      /* var tzoffset = (new Date(e.fecha)).getTimezoneOffset() * 60000; //offset in milliseconds
       var localISOTime = (new Date(Date.now(e.fecha) - tzoffset)).toISOString().slice(0, -1);
       console.log(localISOTime)  // => '2015-01-26T06:40:36.181'
       objjt.factura.fecha=localISOTime
       objjt.factura.factura.fecha=localISOTime*/
      /* console.log('Imprimiendo aqui...')
       console.log(new Date(e.fecha).toISOString().substr(0, 10))*/
      // console.log(objjt)
      this.ReimprecionFacturaSeleccionada = objjt

    },

    changeDevolucionEfectivo() {
      var _this = this
      setTimeout(function() {
        if (_this.DevolucionFacturaSeleccionada.efectivo == true) {
          var CODCAJASELC = _this.DevolucionFacturaSeleccionada.factcaja.codigo
          if (_this.caja.codigo != CODCAJASELC) {
            _this.DevolucionFacturaSeleccionada.efectivo = false
            _this.alerta("Esta Factura no se realizo en esta caja, no puede hacer la devolucion en efectivo ", "error")
            return
          }

          _this.verificarCheckDevolucionEfectivo()

        }

      }, 300)

    },

    verificarCheckDevolucionEfectivo() {
      this.DevolucionFacturaSeleccionada.efectivo = false
      var _this = this
      setTimeout(function() {
        _this.funcionValidaPermisoPv("AccCambiarDevolucionEfectivo")
      }, 300)
    },


    changeDevolucionTarjeta() {
      var _this = this
      setTimeout(function() {
        if (_this.DevolucionFacturaSeleccionada.devtarjeta == true) {
          var CODCAJASELC = _this.DevolucionFacturaSeleccionada.factcaja.codigo
          if (_this.caja.codigo != CODCAJASELC) {
            _this.DevolucionFacturaSeleccionada.devtarjeta = false
            _this.alerta("Esta Factura no se realizo en esta caja, no puede hacer la devolucion en tarjeta ", "error")
            return
          }

//_this.verificarCheckDevolucionEfectivo()

        }

      }, 300)

    },


    ReimprecionItemSelectValor(e) {
      //this.BtnReimprecionvalue == 4

      // console.log(this.ReimprecionFacturaSeleccionada)
      // console.log('--ReimprecionItemValor--')
      // console.log(e)

      //props.item.cantidad *props.item.costo
      // ReimprecionItemValor(props.item.valor)

      var varcosto = 0
      //10-05-2024 nota: caso MIC-2071
      //var costo = e.costo
      var costo = e.precio
      if (this.ReimprecionFacturaSeleccionada.quitaritbis != null && this.ReimprecionFacturaSeleccionada.quitaritbis == true) {
        if (e.producto.impuesto != null && e.producto.impuesto.hasOwnProperty("tasa")) {
          var impprod = e.producto.impuesto.tasa
          //valor=(costo/1+(impprod/100))
          varcosto = ((costo / (1 + (impprod / 100))))
          return (e.cantidad * varcosto)
        } else {
          return (e.cantidad * e.costo)
        }
      } else {
        //10-05-2024 nota: caso MIC-2071
        //return (e.cantidad * e.costo)
        return (e.cantidad * e.precio)
      }

    },

    MakaraCelAceptarDevolucion() {
      if (this.AceptarDevolucion.cedula.toString().length == 9) {
        this.MakCelRnc = "###-#####-#"
      }

      if (this.AceptarDevolucion.cedula.toString().length >= 11) {
        this.MakCelRnc = "###-#######-#"
      }
    },


    validandoCedRnc(e) {

      if (e != null && e.length > 0) {
        if (this.validaCedRnc(e) == false) {
          var NOM = e.length > 10 ? "CEDULA" : "RNC"
          this.alerta(`${NOM} Invalida `, "error")
          return false
        }
      }

      return true

    },

    // Comprobando si el usuario ha seleccionado al menos un producto para devolver.
  
openAceptarDevolucion(){
   this.loading(true)
var _this = this
          setTimeout(function() {
            _this.despuesOpenAceptarDevolucion()
          }, 800)
},

   despuesOpenAceptarDevolucion() {

 /*if (this.DevolucionFacturaSeleccionada.cxc > 0 && this.DevolucionFacturaSeleccionada.cxc != this.DevolucionFacturaSeleccionada.pendiente) {
              this.alerta("No puede hacerle devolución a esta factura ya que posee algún movimiento de pago.", "error")
              return
            }*/
          
      if (this.DevolucionFacturaSeleccionada.cxc > 0 && this.DevolucionFacturaSeleccionada.valordevolucion > this.DevolucionFacturaSeleccionada.pendiente) {
              this.alerta("No puede hacerle devolución a esta factura ya que posee algún movimiento de pago.", "error")
              return
            }
      
      if (this.DevolucionFacturaSeleccionada.SeletDetalleList.length == 0) {
        this.alerta("Seleccione al menos 1 producto", "error")
        return 0
      }

      var ObjProRow = this.DevolucionFacturaSeleccionada.SeletDetalleList.filter((ee) => ee.cantidadPendiente == 0)

      if (ObjProRow.length > 0) {
        this.alerta("no puede hacer una devolución a un producto con la cantidad en 0", "error")
        return 0
      }

      if (this.DevolucionFacturaSeleccionada.efectivo == true) {
        var _this = this
        this.$axios
          .get(this.$hostname + this.$hName + "/cierrecaja/ultimocierre/" +
            this.caja.codigo + "/", { headers: this.$store.getters.GetheadersAxios })
          .then((res) => {
            this.CierresCajas.cierrescajasPK.secuencia = res.data
            var BOOL_DEVOLUCION_FueraCierre=this.$store.getters.GetConfiguracionGeneral.configPv.hasOwnProperty('devolucionFueraCierre')&& this.$store.getters.GetConfiguracionGeneral.configPv.devolucionFueraCierre!=null?this.$store.getters.GetConfiguracionGeneral.configPv.devolucionFueraCierre: false   
          
          if(this.caja.codigo == this.DevolucionFacturaSeleccionada.factcaja.codigo){
          
              if(BOOL_DEVOLUCION_FueraCierre==true){
                    this.contOpenAceptarDevolucion()
              }else{
                    if (res.data == this.DevolucionFacturaSeleccionada.numerocierre) {
                    this.contOpenAceptarDevolucion()
                  } else {
                    this.alerta("No puede realizar la devolución en efectivo, porque esta factura no pertenece al mismo cierre", "error")
                  }
              }
            }else{
              this.alerta("No puede realizar la devolución en efectivo, porque esta factura no pertenece a la misma caja", "error")
            }

          })

      } else {
        this.contOpenAceptarDevolucion()
      }
    },



    contOpenAceptarDevolucion() {
      if (this.DevolucionFacturaSeleccionada.signatureValue != null) {
        // var BOOL_FACELEC=this.DevolucionFacturaSeleccionada.signatureValue!=null && this.caja.facturacionEletronica !=true && this.caja.sucursal.facturacionEletronica!=true
        var BOOL_FACELEC = this.caja.facturacionEletronica === true && this.caja.sucursal.facturacionEletronica === true

        if (BOOL_FACELEC == false) {
          this.alerta("NOTA: Esta factura fue generada con comprobante eletronico y la caja/sucursal no esta asignada con facturación electronica", "error")
          return
        }
      }

      if (this.DevolucionFacturaSeleccionada.cliente.length == 0) {
        this.newnewAceptarDevolucion()
        this.dialogAceptarDevolucion = true
      } else {
        this.AceptarDevolucion = {
          nombre: this.DevolucionFacturaSeleccionada.cliente,
          cedula: this.DevolucionFacturaSeleccionada.cedula,
        }
        this.FinalizarDevolucionFactura()
      }
    },


    // Creando un nuevo objeto llamado AceptarDevolucion y asignándolo a la propiedad de datos del mismo
    // nombre.
    newnewAceptarDevolucion() {
      this.AceptarDevolucion = {
        nombre: null,
        cedula: "",
      }
    },

    // Validando el formulario y si es válido llamará al método FinalizarDevolucionFactura().
    SalvarAceptarDevolucion() {

      if (this.$refs.formAceptarDevolucion.validate()) {

        if (this.AceptarDevolucion.cedula != null && this.AceptarDevolucion.cedula.length > 0) {
          var CEDULA = this.AceptarDevolucion.cedula.replace("-", "")
          if (this.validaCedRnc(CEDULA) == false) {
            var NOM = CEDULA.length > 10 ? "CEDULA" : "RNC"
            this.alerta(`${NOM} Invalida `, "error")
            return 0
          }
        }
    this.dialogAceptarDevolucion=false
    this.FinalizarDevolucionFactura()
         
      } else {
        this.alerta("los campos en rojo son Requeridos", "error")
      }
    },

    // Cerrando el cuadro de diálogo del modal de la devolucion.
    cancelarAceptarDevolucion() {

      this.dialogAceptarDevolucion = false
      this.newnewAceptarDevolucion()
      this.NewDevolucionFacturaSeleccionada()
      this.DevolucionSelected = []
      this.loading(false)
    },

    // Impresión de un Objecto.
    ImpriReimprimirFactura() {

      /* if(localStorage.printerSelect!=null&& localStorage.printerSelect.trim().length > 0){
        impresora=JSON.parse(localStorage.printerSelect).nombre
      }*/
      //JSON.parse()
      // var OBJIMPSELE={"nombre": "Microsoft Print to PDF","codigo": 4}
      var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
      //var selectImpre=JSON.parse(localStorage.printerSelect)
      // selectImpre.to.trim().length > 0 &&

      var impresora = null
      if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
        impresora = JSON.parse(localStorage.printerSelect).nombre
      }


      if (localStorage.printerSelect != null) {
      }
      var msg = {
        accion: "reprint",
        formato: this.caja.formatoimpresioncontado.trim(),
        //  impresora: JSON.parse(localStorage.printerSelect).nombre,
        impresora: impresora,
        data: this.configuraciones,
        fac: this.ReimprecionFacturaSeleccionada,
        cajero: this.OtrasConfigPv.cajero,
        caja: this.caja,
      }
      if (this.BtnReimprecionvalue == 1) {
        this.imprimir(msg, "recibo")
      }
      if (this.BtnReimprecionvalue == 2) {
        this.imprimir(msg, "otros-ingreso")
      }
      if (this.BtnReimprecionvalue == 3) {
        this.imprimir(msg, "factura")

      }
      if (this.BtnReimprecionvalue == 4) {
        console.log("INF-IMPR->", msg)
        if (msg.fac.factura.devolucion.caja == null) {
          msg.fac.factura.devolucion.caja = this.caja.codigo
        }
        this.imprimir(msg, "devolucion")
      }
      if (this.BtnReimprecionvalue == 5) {
        this.imprimir(msg, "vale")
      }
      if (this.BtnReimprecionvalue == 6) {
        this.imprimir(msg, "cotizacion")
      }
      if (this.BtnReimprecionvalue == 7) {

        if (this.caja.marca) {
          msg.formato = this.caja.formatoImprecionConduce.trim()
        }

        this.imprimir(msg, "conduce")
      }


    },

    calcularReciboIngPendienteDespues(e) {
      var balanceTotal = 0
      if (e.pendientedespues > 0) {
        var abdesreisr = this.RedondeoValor(e.abono + e.descuento + e.retencion + e.retencionIsr)
        //element.balanceTotal
        balanceTotal = this.RedondeoValor(e.pendientedespues - (abdesreisr))
      } else {
        balanceTotal = 0
      }
      return balanceTotal

    },
    async cargarReciboListFactpendiente() {
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/reciboingreos/facturaspendientes/" +
          this.clienteFactura.codigo,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          /*  this.objTemp = res.data;
         this.RListFactpendiente = res.data;
          this.ObtemRListFactpendiente = res.data;*/

          var OBJ = res.data
          OBJ.sort(function(a, b) {
            if (a.fechafactura > b.fechafactura) {
              return 1
            }
            if (a.fechafactura < b.fechafactura) {
              return -1
            }
            // a must be equal to b
            return 0
          })

          this.objTemp = OBJ
          this.RListFactpendiente = OBJ
          this.ObtemRListFactpendiente = OBJ

          this.Totales.ReciboIngreso.pendiente = 0
          this.Totales.ReciboIngreso.abono = 0
          if (res.data.length > 0) {

            // (async () => {
            //OBJ.forEach((elent) => {});
            //await
            Promise.all(OBJ.map(async (elent) => {
              this.Totales.ReciboIngreso.pendiente += this.RedondeoBasico(elent.pendientedespues)
            }))
            // })()


          }
        })
    },
    obtenerDatoSelectFactPendiente(e) {
      this.datostablaFactPendiente(e.item)
    },
    datostablaFactPendiente(e) {
      this.HeadInfFactPendienteSelecc = {
        fecha: fechaNueva(),
        factura: "",
        valorf: 0,
        pendiente: 0,
        ncf: "",
        referencia: "",
      }

      this.SelectedFactPendiente = null
      this.FactPendienteSeleccionado = null
      this.SelectedFactPendiente = JSON.parse(JSON.stringify(e))
      this.FactPendienteSeleccionado = JSON.parse(JSON.stringify(e))
      this.FactPendienteSeleccionado.DescValorPorc = false;

      //this.ObtemFactPendienteSeleccionado=JSON.parse(JSON.stringify(e))

      (this.HeadInfFactPendienteSelecc.fecha = new Date(e.fechafactura)
        .toISOString()
        .substr(0, 10))


      // (this.HeadInfFactPendienteSelecc.pendiente = e.pendientedespues);

      if (e.facturasventa != null) {
        this.HeadInfFactPendienteSelecc.pendiente = this.RedondeoBasico(e.facturasventa.pendiente)
      }

      if (e.notadebitoclientes != null) {
        this.HeadInfFactPendienteSelecc.pendiente = this.RedondeoBasico(e.notadebitoclientes.pendiente)
      }


      if (e.facturasventa != null) {
        this.HeadInfFactPendienteSelecc.factura =
          e.facturasventa.documentoFactura.nombrecorto +
          "-" +
          e.facturasventa.facturasventaPK.secuencia
        this.HeadInfFactPendienteSelecc.valorf = e.facturasventa.valor
        this.HeadInfFactPendienteSelecc.ncf = e.facturasventa.ncf
        this.HeadInfFactPendienteSelecc.referencia = e.facturasventa.referencia
      }

      if (e.notadebitoclientes != null) {
        this.HeadInfFactPendienteSelecc.factura =
          e.notadebitoclientes.documentocxc.nombrecorto +
          "-" +
          e.notadebitoclientes.notadebitoclientesPK.secuencia
        this.HeadInfFactPendienteSelecc.valorf = e.notadebitoclientes.valor
        this.HeadInfFactPendienteSelecc.ncf = e.notadebitoclientes.ncf
        this.HeadInfFactPendienteSelecc.referencia =
          e.notadebitoclientes.referencia
      }
    },

    OpenRecProdControlado() {
      if (this.RecetaProdControlado.detalleList.length > 0) {
        this.dialogProdControlado = true
        this.EsNuevoObjRectPro = false
        this.VerRecProdControlado = true
        this.ObjRectPro = JSON.parse(JSON.stringify(this.RecetaProdControlado))
      } else {
        this.alerta("No ha realizado receta con producto controlado", "error")
      }
    },

    OpenDialogReciboIngreso() {
      if (this.clienteFactura == null) {
        this.OpenEjecReciboIngreso = true
        this.OpenDialogCrearEditarCliente()
      }
      if (this.clienteFactura != null) {

        var RECIBO_ING_AVANZ = this.$store.getters.GetConfiguracionGeneral.configPv.reciboIngresoAvanzadopv

        if (RECIBO_ING_AVANZ == true) {
          this.dialogReciboIngreso = true
          this.OpenEjecReciboIngreso = false
          this.openComponentsRecibosIngresos()
        } else {
          //se cambio por el recibo de ingreso heredado
          this.dialogReciboIngreso = true
          this.OpenEjecReciboIngreso = false
          this.cargarReciboListFactpendiente()
        }


        /*  console.log(this.caja.sucursal.documentorecibo)
        console.log(this.CierresCajas.cierrescajasPK.secuencia)
        console.log(this.clienteFactura)*/

      }
    },


    openComponentsRecibosIngresos() {

      var _this = this
      this.$axios
        .get(this.$hostname + this.$hName + "/cierrecaja/ultimocierre/" +
          this.caja.codigo + "/", { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.CierresCajas.cierrescajasPK.secuencia = res.data
          setTimeout(function() {
            _this.$refs.RefComptsRecibosIngresos.form.recibo.numerocierre = res.data
            _this.$refs.RefComptsRecibosIngresos.form.recibo.cliente = _this.clienteFactura
            _this.$refs.RefComptsRecibosIngresos.form.caja = _this.caja
            _this.$refs.RefComptsRecibosIngresos.isComponente = true
            _this.$refs.RefComptsRecibosIngresos.form.recibo.documentocxc = _this.caja.sucursal.docrecibo
            _this.$refs.RefComptsRecibosIngresos.form.recibo.usuario = _this.$store.getters.GetOtrasConfigPv.cajero
            _this.$refs.RefComptsRecibosIngresos.FactPendientes()
            _this.$refs.RefComptsRecibosIngresos.cargarNotaCreditoAutomatica()
            //_this.$refs.RefComptsRecibosIngresos.headerFactura.vendedor=data.datos.headerFactura.vendedor
          }, 300)

        })
    },

    closeComponentsRecibosIngresos() {
      this.$refs.RefComptsRecibosIngresos.newwnuevo()
      this.dialogReciboIngreso = false
    },

    DataRetornComptsRecibosIngresos(e) {

      if (e.opcion == "GuardarRecibo") {
        var _this = this
        setTimeout(function() {
          // _this.loading(true)
          _this.closeComponentsRecibosIngresos()
          _this.alerta("Dato guardado correctamente", "bien")
          var lccaja = JSON.parse(localStorage.caja)
          if (localStorage.printerSelect != null) {
          }
          var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
          var impresora = null
          if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
            impresora = JSON.parse(localStorage.printerSelect).nombre
          }

          var msg = {
            accion: "print",
            formato: _this.caja.formatoimpresioncontado.trim(),
            impresora: impresora,
            data: _this.configuraciones,
            ingreso: e.datos,
            caja: lccaja,
            cajero: _this.$store.getters.GetOtrasConfigPv.cajero,
          }
          _this.imprimir(msg, "recibo")

        }, 300)
      }

    },


    OpenDialogProdControlado() {
      if (this.clienteFactura == null) {
        this.OpenEjecProdControlado = true
        this.OpenDialogCrearEditarCliente()
      }
      if (this.clienteFactura != null) {
        // EjecuModalProductoControlado
        // this.dialogProdControlado=true
        this.EjecuModalProductoControlado("notf")
      }
    },

    EjecuModalProductoControlado(e) {
      if (e == "notf") {
        if (this.clienteFactura == null) {
          this.LabelProdCotrolado =
            "Este Producto está controlado, debe indicar un cliente"
          this.dialogNotifProdControlado = true
        }

        if (this.clienteFactura != null) {
          this.LabelProdCotrolado =
            "Este Producto está controlado, debe indicar una receta"
          this.dialogNotifProdControlado = true
        }
      }

      if (e == "accept") {
        if (this.clienteFactura == null) {
          this.dialogNotifProdControlado = false
          this.OpenDialogProdControlado()
          return
        }

        if (this.clienteFactura != null) {
          this.RecetaProdControlado.cliente = JSON.parse(
            JSON.stringify(this.clienteFactura),
          )

          var selc
          if (this.selected == null) {
            this.selected = JSON.parse(JSON.stringify(this.selecteTemRecCont))
            //this.selecteTemRecCont=null
          }
          
          selc = {
            productos: this.selected.productos,
            unidad: this.selected.unidades,
            cantidadRecetada: 0,
            cantidadDespachada: 0,
            lote:this.selected.lote
          }

         var ObjProRow =[]
            if(this.UsarLote==true){
             ObjProRow = this.RecetaProdControlado.detalleList.filter((ee) => ee.productos.codigo == selc.productos.codigo && ee.unidad.codigo == selc.unidad.codigo && ee.lote==selc.lote)
              }else{
             ObjProRow = this.RecetaProdControlado.detalleList.filter((ee) => ee.productos.codigo == selc.productos.codigo && ee.unidad.codigo == selc.unidad.codigo)
              }

              if (ObjProRow.length == 0) {
                this.RecetaProdControlado.detalleList.push(selc)
              }

          this.dialogNotifProdControlado = false
          this.dialogProdControlado = true
          // this.ObjRectPro = JSON.parse(JSON.stringify(this.RecetaProdControlado));

        }
      }
      //canselar en modal
      if (e == "cancelar") {
        this.dialogNotifProdControlado = false
        this.selecteTemRecCont = null
        this.cancelarInfProducto()
      }
    },

    SalvaeRecetaControlada() {
      if (this.$refs.formRecetaProdControlado.validate()) {
        this.dialogProdControlado = false
        this.ObjRectPro = null

        // console.log('Viendo-selected->',this.selected)
        //console.log('Viendo-->',this.selecteTemRecCont)
        if (this.VerRecProdControlado == false) {
          this.EsNuevoObjRectPro = true
          // var selc = JSON.parse(JSON.stringify(this.selected));
          //var e = JSON.parse(JSON.stringify(this.selected));
          var selc = JSON.parse(JSON.stringify(this.selecteTemRecCont))
          var e = JSON.parse(JSON.stringify(this.selecteTemRecCont))

          selc.vendedor = null
          selc.recargo = 0
          selc.cobertura = 0
          selc.descuento = 0
          selc.valor = 0
          selc.cantidad = 1
          selc.ValorPorc = true
          selc.ValorPorcRecarg = true
          selc.precioOrig = e.precio
          selc.precioDig = e.precio
          selc.descripcion = e.productos.descripcion + " " + e.unidades.descripcion
          selc.descuentoKeys = e.hasOwnProperty("descuentoKeys") && e.descuentoKeys != null ? e.descuentoKeys : 0
          selc.DescValor = e.hasOwnProperty("DescValor") && e.DescValor != null ? e.DescValor : 0
          if(selc.cobertura>0){selc.cobValorPorc=true}else{selc.cobValorPorc=false}
          this.pedirNombre = e.productos.pedirNombre
          this.productoSeleccionado = JSON.parse(JSON.stringify(selc))

          this.PanelMenuOpcionCompleto = false
          this.PanelSelectProducto = false
          this.PanelInfProduct = true
          this.$refs.RefScroll.scrollTop = 0
          var _this = this
          setTimeout(function() {
            _this.selecteTemRecCont = null
            _this.$refs.RefTextFieldProductoCantidad.focus()
            _this.getExistProdXAlmacen()
            _this.getProductoSustitutos()
          }, 500)

        }
        // selc.vendedor=null
        // selc.recargo=0
        // selc.ValorPorcRecarg=true
        // selc.cobertura=0
        // selc.descuento=0
        // selc.valor=0
        // selc.ValorPorc=false
        // this.productoSeleccionado =JSON.parse(JSON.stringify(selc))
        // this.PanelMenuOpcionCompleto=false
        // this.PanelSelectProducto=false
        // this.PanelInfProduct=true
        // this.$refs.RefScroll.scrollTop=0
        // var _this=this;
        // setTimeout(function(){
        // _this.$refs.RefTextFieldProductoCantidad.focus();
        //  }, 500);


      } else {
        this.alerta("los campos en rojo son requeridos", "error")
      }
    },

    // Un método que se llama cuando el usuario hace clic en el botón cancelar de un cuadro de diálogo y
    //lo cierra  asignando variables necesaria.
    CancelarRecetaControlada() {

      if (this.EsNuevoObjRectPro == true) {
        this.dialogProdControlado = false
        if (this.ObjRectPro != null) {
          this.RecetaProdControlado = JSON.parse(JSON.stringify(this.ObjRectPro))
          this.ObjRectPro = null
        }

        if (this.ObjRectPro == null) {

          if (this.RecetaProdControlado.detalleList.length > 1) {
            var size = this.RecetaProdControlado.detalleList.length - 1
            var RectPro = this.RecetaProdControlado.detalleList[size]
            const index = this.RecetaProdControlado.detalleList.indexOf(RectPro)
            this.RecetaProdControlado.detalleList.splice(index, 1)
          } else {
            this.NewRecetaProdCOntrolado()
          }
        }
      } else {

        this.RecetaProdControlado = JSON.parse(JSON.stringify(this.ObjRectPro))
        this.dialogProdControlado = false
        this.ObjRectPro = null
      }


    },

    // Creando un nuevo objeto y asignándolo a la variable RecetaProdControlado.
    NewRecetaProdCOntrolado() {
      this.RecetaProdControlado = {
        codigo: 0,
        numero: null,
        exq: "",
        fecha: fechaNueva(),
        cliente: null,
        telefono: null,
        direccion: null,
        centroSalud: null,
        activo: true,
        estatus: true,
        medico: null,
        especialidad: null,
        detalleList: [],
      }
      this.ObjRectPro = null
      this.EsNuevoObjRectPro = true
    },

    // Hacer una solicitud al servidor y devolver los datos de centro de salud.
    CargarCentroSalud() {
      this.$axios
        .get(this.$hostname + this.$hName + "/centrosalud/findall/", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          this.RLiClinicas = res.data
        })
        .catch((error) => console.log(error))
    },

    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbCentroSalud() {
      if (this.RecetaProdControlado.centroSalud == null) {
        this.RecetaProdControlado.centroSalud = ""
      }

      if (this.RecetaProdControlado.centroSalud.codigo == undefined) {
        this.alerta("Seleccione un Centro de salud", "error")
        this.RecetaProdControlado.centroSalud = ""
        return
      }
    },

    classObjFactPenSelect(e) {
      if (this.SelectedFactPendiente == null) {
        return ""
      }
      if (this.SelectedFactPendiente != null) {
        if (e.indx == this.SelectedFactPendiente.indx) {
          return "RowSelectColorPv1"
        } else {
          return ""
        }
      }
      return ""
    },
    // Crear un nuevo objeto y empujarlo a un objto detalle de factura.
    llenarDetalle(dato) {
      var VALORPRODUCTO = this.CalcularValorProductoRPCompra(dato)
      var COMISIONPRODUCTO = dato.productos.comision != null ? dato.productos.comision : 0
      var VALORCOMISION = 0
      // productos.comision
      //valorComisionProducto: dato.productos.comision!=null && dato.productos.comision>0 ?this.RedondeoBasico(((VALORPRODUCTO*COMISIONPRODUCTO)/100)):0,

      if (dato.vendedor != null && dato.vendedor != null && dato.vendedor.hasOwnProperty("codigo")) {
        if (dato.vendedor.comisionventa != null && dato.vendedor.comisionventa > 0) {
          if (dato.vendedor.comisionventa < dato.productos.comision) {
            VALORCOMISION = this.RedondeoBasico(((VALORPRODUCTO * dato.vendedor.comisionventa) / 100))
          } else {
            if (COMISIONPRODUCTO == 0) {
              VALORCOMISION = this.RedondeoBasico(((VALORPRODUCTO * dato.vendedor.comisionventa) / 100))
            } else {
              VALORCOMISION = dato.productos.comision != null && dato.productos.comision > 0 ? this.RedondeoBasico(((VALORPRODUCTO * COMISIONPRODUCTO) / 100)) : 0
            }
          }
        } else {
          VALORCOMISION = dato.productos.comision != null && dato.productos.comision > 0 ? this.RedondeoBasico(((VALORPRODUCTO * COMISIONPRODUCTO) / 100)) : 0
        }

      } else {
        if (this.Facturasventa.vendedor != null && this.Facturasventa.vendedor != null && this.Facturasventa.vendedor.hasOwnProperty("codigo")) {

          if (this.Facturasventa.vendedor.comisionventa != null && this.Facturasventa.vendedor.comisionventa > 0) {
            if (this.Facturasventa.vendedor.comisionventa < dato.productos.comision) {
              VALORCOMISION = this.RedondeoBasico(((VALORPRODUCTO * this.Facturasventa.vendedor.comisionventa) / 100))
            } else {
              if (COMISIONPRODUCTO == 0) {
                VALORCOMISION = this.RedondeoBasico(((VALORPRODUCTO * this.Facturasventa.vendedor.comisionventa) / 100))
              } else {
                VALORCOMISION = dato.productos.comision != null && dato.productos.comision > 0 ? this.RedondeoBasico(((VALORPRODUCTO * COMISIONPRODUCTO) / 100)) : 0
              }
            }

          } else {
            VALORCOMISION = dato.productos.comision != null && dato.productos.comision > 0 ? this.RedondeoBasico(((VALORPRODUCTO * COMISIONPRODUCTO) / 100)) : 0
          }

          dato.vendedor = JSON.parse(JSON.stringify(this.Facturasventa.vendedor))
        } else {
          VALORCOMISION = dato.productos.comision != null && dato.productos.comision > 0 ? this.RedondeoBasico(((VALORPRODUCTO * COMISIONPRODUCTO) / 100)) : 0
        }

      }
      var detalle = {
        facturasventaDetallePK: {
          documento: 0,
          secuencia: 0,
          producto: 0,
          unidad: 0,
          id: 0,
        },
        almacen: this.caja.almacen.codigo,
        cantidad: dato.cantidad,
        valordescuento: dato.valordescuento,
        valorimpuesto: dato.valorimpuesto,
        precio: dato.precio,
        descuento: dato.descuento,
        codigocupon: null,
        valorcupon: 0.0,
        cantidadPendiente: dato.cantdad,
        oferta: null,
        valorRecargo: dato.RecarValor,
        recargo: 0.0,
        descripcion: dato.descripcion,
        costounidad: dato.costo,
        cantidadDespachada: dato.cantidadDespachada,
        borrado: false,
        cobertura: dato.hasOwnProperty("cobertura") ? dato.cobertura : 0,
        impuesto: dato.productos.hasOwnProperty("impuesto") ? dato.productos.impuesto : null,
        productos: dato.productos,
        unidades: dato.unidades,
        vendedor: dato.vendedor != null && dato.vendedor.hasOwnProperty("codigo") ? dato.vendedor : null,
        valorComisionProducto: VALORCOMISION,
        planBeneficio:dato.productos.planBeneficio
      }
      if (this.UsarLote == true) {
        detalle.lote = dato.lote
        detalle.facturasventaDetallePK.lote = dato.lote
        detalle.lote = dato.lote

      if(dato.hasOwnProperty("loteFabricante") && dato.loteFabricante != null && dato.loteFabricante.trim().length>0 ){
          detalle.loteFabricante=dato.loteFabricante;
      }

        detalle.fechaLoteInicial = dato.hasOwnProperty("fechaLoteInicial") ? dato.fechaLoteInicial : null
      }
      this.Facturasventa.facturasventaDetalleList.push(detalle)
    },


    // Creación de una nueva factura.
    async PostrealizarCobro() {

      this.loading(false)
          this.ejecucion = true
        //console.log('verrr-compted->',this.ComprobanteFisc)
         if(this.Totales.totalGeneral.total>250000){
          var VALIDA_TIENE_cedrnc= (this.ComprobanteFisc.cedrnc!=null && this.ComprobanteFisc.cedrnc.trim().length>8 || this.clienteFactura!=null && this.clienteFactura.hasOwnProperty('cedrnc') && this.clienteFactura.cedrnc!=null && this.clienteFactura.cedrnc.trim().length>8)
         if(VALIDA_TIENE_cedrnc==false){
          this.alerta(`NOTA:se está intentado hacer una factura con un monto mayos a los 250,000.00 y no se a identificado la cedula o RNC del cliente.`, "warning")
          return
         }
         }
        
      if (this.validarCobroDuranteSincronizacionOffline() == false) {
        return 0
      }
      if (this.pvGuardandoFactura == true || this.ejecucion == false) {
        return 0
      }
      this.pvGuardandoFactura = true
      /* console.log('--Hora1--:')
       console.log(new Date())
       console.log('--Hora2--:')
       console.log(new Date().getTime())
        console.log('--Hora3--:')
       console.log(this.HoraFormatter2(new Date()))
       console.log('--Hora4--:')
       var hora =new Date()
       console.log(hora.getHours() + ':' + hora.getMinutes() + ':' + hora.getSeconds())*/

      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURATASA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)
      this.Facturasventa.fecha = new Date().valueOf()
      var _this = this

      if (this.bancoCheque != null) {
        this.Facturasventa.bancoCheque = this.bancoCheque.codigo
      }
      if (this.tipoTarjeta) {
        this.Facturasventa.tipoTarjeta = this.tipoTarjeta.codigo
      }
      this.Facturasventa.horaFactura = new Date().getTime()
      this.Facturasventa.facturasventaDetalleList = []
      if(this.Facturasventa.cobertura==null){this.Facturasventa.cobertura=0}

      this.RProductoCompra.forEach((d) => {
        d.valorimpuesto = 0
        if (d.productos.incluirimpuestoenprecio == true) {
          if (d.productos.impuesto != null) {
            // d.valorimpuesto =d.precio - d.precio / (1 + d.productos.impuesto.tasa / 100);
            // var objimpuesto= (((objprecc)-d.valordescuento)* (d.productos.impuesto.tasa/100))

            /* var objprecc= this.RedondeoBasico(d.precio / (1 + (d.productos.impuesto.tasa/ 100)));
            var objimpuesto= (((objprecc))* (d.productos.impuesto.tasa/100));
             d.valorimpuesto =this.RedondeoBasico(objimpuesto);*/
            //console.log(objimpuesto)

            var VALOR_IMPUESTO = this.CalculateTax(d)
            d.valorimpuesto = (VALOR_IMPUESTO / d.cantidad)
            // console.log(d.valorimpuesto)
          }
        }
        if (d.productos.incluirimpuestoenprecio == false) {
          if (d.productos.impuesto != null) {
            //d.valorimpuesto = d.precio * (d.productos.impuesto.tasa / 100);
            var VALOR_IMPUESTO = this.CalculateTax(d)
            d.valorimpuesto = (VALOR_IMPUESTO / d.cantidad)
          }
        }

        this.llenarDetalle(d)
      })

      var BOOL_COBERTURA = false
      if (this.clienteFactura != null) {
        this.Facturasventa.cliente = this.clienteFactura
        if (this.CoberturaSeguro.cobertura > 0) {
          this.Facturasventa.ars = this.CoberturaSeguro.ars
          this.Facturasventa.cobertura = this.Totales.totalGeneral.cobertura
          this.Facturasventa.coberturaPendiente = this.Totales.totalGeneral.cobertura
          this.Facturasventa.autorizacion = this.CoberturaSeguro.autorizacion
          this.Facturasventa.medico = this.CoberturaSeguro.medico
          this.Facturasventa.dianostico = this.CoberturaSeguro.dianostico
          this.Facturasventa.especialidad = this.CoberturaSeguro.especiales
          this.Facturasventa.exequartur = this.CoberturaSeguro.exequartur
          BOOL_COBERTURA = true
        }
        this.Facturasventa.descripcion = this.clienteFactura.nombre.trim()
        
        if (this.clienteFactura.hasOwnProperty("numeroOrden") && this.clienteFactura.numeroOrden != null) {
          this.Facturasventa.numeroOrden = this.clienteFactura.numeroOrden
        }
      }
      this.Facturasventa.caja = this.caja
      this.Facturasventa.nombreCliente = this.Facturasventa.descripcion 
      if (
        this.Facturasventa.tipocomprobante == null ||
        this.Facturasventa.tipocomprobante == ""
      ) {
        this.Facturasventa.tipocomprobante =
          this.configuraciones.configPv.comprobantefacturacion
      }
      if (this.DatosPagareFactura != null && this.DatosPagareFactura.contrato.CantidadCuotas > 0) {

        var Obj = {
          secuencia: 0,
          fecha: fechaNueva().trim().substr(0, 10) + "T04:00",
          valorPrestamo: this.DatosPagareFactura.contrato.valorPrestamo,
          fechaInicial: this.DatosPagareFactura.contrato.fecha.trim().substr(0, 10) + "T04:00",
          inicial: this.DatosPagareFactura.contrato.inicio,
          valorRecibido: this.DatosPagareFactura.contrato.valorRecibido,
          porcientoInteres: this.DatosPagareFactura.contrato.interes,
          cantidadCuotas: this.DatosPagareFactura.contrato.CantidadCuotas,
          capitalPaga: this.DatosPagareFactura.contrato.Capitalpagar,
          interesTotal: this.DatosPagareFactura.contrato.Interespagar,
          montoCuota: this.DatosPagareFactura.contrato.MontoCuotas,
          tipoInteres: this.DatosPagareFactura.contrato.TipoInteres.codigo,
          interesMora: this.DatosPagareFactura.contrato.InteresMora,
          prorroga: this.DatosPagareFactura.contrato.prorroga,
          cliente: this.clienteFactura,
          activo: true,
          pagareDetalleList: this.DatosPagareFactura.pagareDetalleList,
          pagoAnticipado: this.DatosPagareFactura.pagoAnticipado,
          borrado: false,
        }

        this.Facturasventa.pagareObj = Obj
      } else {
        this.Facturasventa.pagareObj = null
      }
      if (this.RecetaProdControlado != null) {
        this.Facturasventa.recetaObj = this.RecetaProdControlado
        this.Facturasventa.recetaObj.recetaDetalleList = this.RecetaProdControlado.detalleList
        this.Facturasventa.receta = this.RecetaProdControlado.numero
        this.Facturasventa.exequartur = this.RecetaProdControlado.exq
        this.Facturasventa.medico = this.RecetaProdControlado.medico
        this.Facturasventa.recetaObj.fecha = this.RecetaProdControlado.fecha.trim().substr(0, 10) + "T04:00"
      }

      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/cierrecaja/ultimocierre/" +
          this.caja.codigo +
          "/",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.Facturasventa.numerocierre = res.data
        })

      //this.Facturasventa.numerocierre= this.CierresCajas.cierrescajasPK.secuencia
      //numerocierre: datos.nuemrocierre,,
      this.Facturasventa.sucursal = this.caja.sucursal
      this.Facturasventa.valor = this.Totales.totalGeneral.total
      this.Facturasventa.valorimpuesto = this.Totales.totalGeneral.itbis
      this.Facturasventa.valordescuento = this.Totales.totalGeneral.descuento
      this.Facturasventa.retencion = this.Totales.totalGeneral.Retencion
      this.Facturasventa.valorRecargo = this.Totales.totalGeneral.recargo
      this.Facturasventa.moneda = this.Monedafactura
      this.Facturasventa.tasa = this.Monedafactura.tasa
      this.Facturasventa.usuario = this.OtrasConfigPv.cajero
      this.Facturasventa.usuarioCobro = this.OtrasConfigPv.cajero
      if (this.Facturasventa.vendedor != null) {
        this.Facturasventa.vendedor = this.Facturasventa.vendedor
      }

      if (this.Facturasventa.tipocomprobante == null ||
        this.Facturasventa.tipocomprobante != null &&
        !this.Facturasventa.tipocomprobante.hasOwnProperty("codigo")) {
        this.Facturasventa.tipocomprobante = this.configuraciones.configPv.comprobantefacturacion
      }

      if (this.domiciliofactura != null) {
        this.ConstruirDomicilio(this.Facturasventa, this.devuelta)
      }

      if (BOOL_COBERTURA == true) {
        this.Facturasventa.clienteArs = JSON.parse(JSON.stringify(this.clienteFactura))
        if (this.Facturasventa.cxc > 0) {
          this.Facturasventa.cliente = JSON.parse(JSON.stringify(this.clienteTempCredito))
        } else {
          this.Facturasventa.cliente = JSON.parse(JSON.stringify(this.clienteFactura))
        }

      }

      if (
        BOOL_COBERTURA == false &&
        this.Facturasventa.cxc > 0 &&
        this.tieneRecetaControladaActiva() &&
        this.clienteTempCredito != null &&
        this.clienteTempCredito.hasOwnProperty("codigo") &&
        this.clienteCreditoNoValidoParaFactura(this.clienteFactura)
      ) {
        this.Facturasventa.cliente = JSON.parse(JSON.stringify(this.clienteTempCredito))
        this.Facturasventa.descripcion = this.clienteTempCredito.nombre.trim()
      }


      if (this.selectedListFPagoNC.length > 0) {
        this.Facturasventa.codigoNc = this.selectedListFPagoNC[0].notacreditocontadoPK.documento
        this.Facturasventa.secuenciaNc = this.selectedListFPagoNC[0].notacreditocontadoPK.secuencia
      }
        
      //VALIDACION DE CONDUCE POR HORA
       const BOOL_CALIF_HORA_COND = await this.validacionConducePorHora()
      var condFAct = (this.conduceSelect != null)
      if (BOOL_CALIF_HORA_COND==true) {
        if (this.ejecucion == true) {
          this.loading(true)
          this.ejecucion = false
          this.Facturasventa.fecha = new Date().valueOf()
          var FACTURAS_VENTA = JSON.parse(JSON.stringify(this.Facturasventa))
          FACTURAS_VENTA.efectivo = JSON.parse(JSON.stringify(this.Facturasventa.efectivo * MONEDAFACTURATASA))
          FACTURAS_VENTA.tarjeta = JSON.parse(JSON.stringify(this.Facturasventa.tarjeta * MONEDAFACTURATASA))
          FACTURAS_VENTA.cheques = JSON.parse(JSON.stringify(this.Facturasventa.cheques * MONEDAFACTURATASA))
          FACTURAS_VENTA.transferencia = JSON.parse(JSON.stringify(this.Facturasventa.transferencia * MONEDAFACTURATASA))
          FACTURAS_VENTA.cxc = JSON.parse(JSON.stringify(this.Facturasventa.cxc * MONEDAFACTURATASA))
          FACTURAS_VENTA.cupones = JSON.parse(JSON.stringify(this.Facturasventa.cupones * MONEDAFACTURATASA))
          FACTURAS_VENTA.valorConduce = JSON.parse(JSON.stringify(this.Facturasventa.valorConduce * MONEDAFACTURATASA))
          FACTURAS_VENTA.valorNc = JSON.parse(JSON.stringify(this.Facturasventa.valorNc * MONEDAFACTURATASA))

          FACTURAS_VENTA.valorbonogas = JSON.parse(JSON.stringify(this.Facturasventa.valorbonogas * MONEDAFACTURATASA))
          FACTURAS_VENTA.valorasignacion = JSON.parse(JSON.stringify(this.Facturasventa.valorasignacion * MONEDAFACTURATASA))
          FACTURAS_VENTA.valorPruebaMetro = JSON.parse(JSON.stringify(this.Facturasventa.valorPruebaMetro * MONEDAFACTURATASA))
          FACTURAS_VENTA.valorTraspaso = JSON.parse(JSON.stringify(this.Facturasventa.valorTraspaso * MONEDAFACTURATASA))
          FACTURAS_VENTA.valordonacion = JSON.parse(JSON.stringify(this.Facturasventa.valordonacion * MONEDAFACTURATASA))
          
          
          // if(this.activaConduceCredito==false){ }

          if (FACTURAS_VENTA.efectivo > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
            FACTURAS_VENTA.devuelta = this.RedondeoBasico((FACTURAS_VENTA.efectivo - this.Totales.totalGeneral.total))
            FACTURAS_VENTA.efectivo = this.Totales.totalGeneral.total
            FACTURAS_VENTA.valorConduce = this.Totales.totalGeneral.total

          } else {
            //this.Facturasventa.efectivo=this.Facturasventa.valorConduce
            FACTURAS_VENTA.efectivo = this.Totales.totalGeneral.total
            FACTURAS_VENTA.valorConduce = this.Totales.totalGeneral.total
          }


          //  _this.$hostname + _this.$hName + "/conduce/save",_this.Facturasventa,
          if (this.debeGuardarFacturaOffline()) {
            this.guardarFacturaOfflineDesdePayload(FACTURAS_VENTA, "conduce")
            return
          }
         
          setTimeout(function() {
            _this.$axios
              .post(
                _this.$hostname + _this.$hName + "/conduce/save",
                FACTURAS_VENTA,
                { headers: _this.$store.getters.GetheadersAxios },
              )
              .then((res) => {
                if (_this.deleteFacturaTemporal != null) {
                  _this.deleRestaurarFact(_this.deleteFacturaTemporal)
                }
                if (_this.cotizacionAfacturaSelect != null) {
                  _this.ActualizarCotizacionFActurada(_this.cotizacionAfacturaSelect)
                }
                _this.objTemp = res.data
                _this.RListFactpendiente = res.data
                if (localStorage.printerSelect != null) {
                }
                var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
                var impresora = null
                if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
                  impresora = JSON.parse(localStorage.printerSelect).nombre
                }

                var msg = {
                  accion: "print",
                  // formato: _this.caja.formatoimpresioncontado.trim(),
                  formato: _this.caja.formatoImprecionConduce.trim(),
                  impresora: impresora,
                  data: _this.configuraciones,
                  fac: res.data,
                  caja: _this.caja,
                  //   fac:this.ReimprecionFacturaSeleccionada
                }
                _this.imprimir(msg, "conduce")

                _this.alerta("Datos salvado correctamente !!!", "bien")
              })
              .catch((error) => {
                if (_this.esErrorConexionPv(error) && _this.debeGuardarFacturaOffline(true)) {
                  _this.guardarFacturaOfflineDesdePayload(FACTURAS_VENTA, "conduce")
                  return
                }
                if (error.response) {
                  _this.alerta(error.response.request.responseText, "error")
                  _this.ejecucion = true
                  _this.pvGuardandoFactura = false
                  _this.loading(false)
                } else {
                  _this.alerta(error, "error")
                  _this.ejecucion = true
                  _this.pvGuardandoFactura = false
                  _this.loading(false)
                }
              })
          }, 600)
          //--
        }


      } else if ((this.Facturasventa.valorConduce * MONEDAFACTURATASA) > 0) {
        if (this.caja.sucursal.documentoConduce == null) {
          this.alerta("La sucursal no esta configurada para conduce.", "error")
          this.pvGuardandoFactura = false
          return
        }
        if (this.ejecucion == true) {
          this.Facturasventa.fecha = new Date().valueOf()
          this.ejecucion = false
          this.Facturasventa.conduceCredito = this.activaConduceCredito
          /* if(this.activaConduceCredito==false){
            if(this.Facturasventa.valorConduce>this.RedondeoBasico(this.Totales.totalGeneral.total)){
              this.Facturasventa.efectivo=this.Totales.totalGeneral.total
              this.Facturasventa.devuelta=this.RedondeoBasico((this.Facturasventa.valorConduce-this.Totales.totalGeneral.total))
            }else{
                   //this.Facturasventa.efectivo=this.Facturasventa.valorConduce
                   this.Facturasventa.efectivo=this.Totales.totalGeneral.total
            }

          }*/

//  _this.$hostname + _this.$hName + "/conduce/save",_this.Facturasventa,
          var FACTURAS_VENTA = JSON.parse(JSON.stringify(this.Facturasventa))
          FACTURAS_VENTA.efectivo = JSON.parse(JSON.stringify(this.Facturasventa.efectivo * MONEDAFACTURATASA))
          FACTURAS_VENTA.tarjeta = JSON.parse(JSON.stringify(this.Facturasventa.tarjeta * MONEDAFACTURATASA))
          FACTURAS_VENTA.cheques = JSON.parse(JSON.stringify(this.Facturasventa.cheques * MONEDAFACTURATASA))
          FACTURAS_VENTA.transferencia = JSON.parse(JSON.stringify(this.Facturasventa.transferencia * MONEDAFACTURATASA))
          FACTURAS_VENTA.cxc = JSON.parse(JSON.stringify(this.Facturasventa.cxc * MONEDAFACTURATASA))
          FACTURAS_VENTA.cupones = JSON.parse(JSON.stringify(this.Facturasventa.cupones * MONEDAFACTURATASA))
          FACTURAS_VENTA.valorConduce = JSON.parse(JSON.stringify(this.Facturasventa.valorConduce * MONEDAFACTURATASA))
          FACTURAS_VENTA.valorNc = JSON.parse(JSON.stringify(this.Facturasventa.valorNc * MONEDAFACTURATASA))
          FACTURAS_VENTA.valorbonogas = JSON.parse(JSON.stringify(this.Facturasventa.valorbonogas * MONEDAFACTURATASA))
          FACTURAS_VENTA.valorasignacion = JSON.parse(JSON.stringify(this.Facturasventa.valorasignacion * MONEDAFACTURATASA))
          FACTURAS_VENTA.valorPruebaMetro = JSON.parse(JSON.stringify(this.Facturasventa.valorPruebaMetro * MONEDAFACTURATASA))
          FACTURAS_VENTA.valorTraspaso = JSON.parse(JSON.stringify(this.Facturasventa.valorTraspaso * MONEDAFACTURATASA))
          FACTURAS_VENTA.valordonacion = JSON.parse(JSON.stringify(this.Facturasventa.valordonacion * MONEDAFACTURATASA))
          FACTURAS_VENTA.turno = this.OtrasConfigPv.turno
          var _this = this

          if (this.activaConduceCredito == false) {
            if (FACTURAS_VENTA.valorConduce > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
              FACTURAS_VENTA.efectivo = this.Totales.totalGeneral.total
              FACTURAS_VENTA.devuelta = this.RedondeoBasico((FACTURAS_VENTA.valorConduce - this.Totales.totalGeneral.total))
            } else {
              //this.Facturasventa.efectivo=this.Facturasventa.valorConduce
              FACTURAS_VENTA.efectivo = this.Totales.totalGeneral.total
            }

          } else {
            FACTURAS_VENTA.efectivo = 0
            FACTURAS_VENTA.valorConduce = 0
          }

          if (this.debeGuardarFacturaOffline()) {
            this.guardarFacturaOfflineDesdePayload(FACTURAS_VENTA, "conduce")
            return
          }

          setTimeout(function() {
            _this.$axios
              .post(
                _this.$hostname + _this.$hName + "/conduce/save",
                FACTURAS_VENTA,
                { headers: _this.$store.getters.GetheadersAxios },
              )
              .then((res) => {
                if (_this.deleteFacturaTemporal != null) {
                  _this.deleRestaurarFact(_this.deleteFacturaTemporal)
                }
                if (_this.cotizacionAfacturaSelect != null) {
                  _this.ActualizarCotizacionFActurada(_this.cotizacionAfacturaSelect)
                }
                if (_this.conduceSelect != null) {
                  _this.deleteConduce(_this.conduceSelect)
                }

                if(_this.ListConduceMultiple.length>0){
                        var COND_MULTIPLE={
                          facturasventaPK:{secuencia:0,documento:0},
                          listaConduce:_this.ListConduceMultiple
                        }
                        _this.deleteConduceMultiple(COND_MULTIPLE)

                      }


                _this.objTemp = res.data
                _this.RListFactpendiente = res.data
                if (localStorage.printerSelect != null) {
                }
                var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
                var impresora = null
                if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
                  impresora = JSON.parse(localStorage.printerSelect).nombre
                }

                var FORMATOIMP = _this.caja.formatoimpresioncontado.trim()
                if (_this.caja.marca) {
                  FORMATOIMP = _this.caja.formatoImprecionConduce.trim()
                }

                var msg = {
                  accion: "print",
                  // formato: _this.caja.formatoimpresioncontado.trim(),
                  formato: FORMATOIMP,
                  impresora: impresora,
                  data: _this.configuraciones,
                  fac: res.data,
                  caja: _this.caja,
                  //   fac:this.ReimprecionFacturaSeleccionada
                }
                _this.imprimir(msg, "conduce")

                _this.alerta("Datos salvado correctamente !!!", "bien")
              })
              .catch((error) => {
                if (_this.esErrorConexionPv(error) && _this.debeGuardarFacturaOffline(true)) {
                  _this.guardarFacturaOfflineDesdePayload(FACTURAS_VENTA, "conduce")
                  return
                }
                if (error.response) {
                  _this.alerta(error.response.request.responseText, "error")
                } else {
                  _this.alerta(error, "error")
                }
                _this.loading(false)
                _this.ejecucion = true
              })
          }, 600)
          //--

        }
      } else {

        var docu = 0
        if ((this.Facturasventa.cxc * MONEDAFACTURATASA) > 0) {
          docu = this.caja.sucursal.documentofacturacredito
        } else {
          docu = this.caja.sucursal.documentofacturacion
        }


        //-->/secuenciaComprobantes/existesecuencia/
        // var link = docu + "/" + this.Facturasventa.tipocomprobante.codigo + "/" + "PV"
        var link = docu + "/" + this.Facturasventa.tipocomprobante.codigo + "/" + "PV/" + this.caja.sucursal.rnc.trim()

        if (this.debeGuardarFacturaOffline()) {
          this.ejecucion = false
          this.loading(true)
          this.Facturasventa.fecha = new Date(new Date().toLocaleDateString("en-DO")).toISOString()
          this.guardarFacturaOfflineDesdeEstado(MONEDAFACTURATASA)
          return
        }

        this.$axios.get(this.$hostname + this.$hName + "/secuenciaComprobantes/existesecuenciaRnc/" + link,
          { headers: this.$store.getters.GetheadersAxios })
          .then(res => {
            if (res.data == true) {

              if (this.ejecucion == true) {
                //  this.Facturasventa.fecha = new Date().toISOString().substr(0, 10)
                var fech = new Date(new Date().toLocaleDateString("en-DO")).toISOString()
                //this.Facturasventa.fecha = new Date().valueOf()

                /*his.loading(false)
                return */

                //_this.$hostname + _this.$hName + "/pv/save", _this.Facturasventa,
                this.ejecucion = false
                this.loading(true)
                this.Facturasventa.fecha = fech

                var FACTURAS_VENTA = JSON.parse(JSON.stringify(this.Facturasventa))
                FACTURAS_VENTA.efectivo = JSON.parse(JSON.stringify(this.Facturasventa.efectivo * MONEDAFACTURATASA))
                FACTURAS_VENTA.tarjeta = JSON.parse(JSON.stringify(this.Facturasventa.tarjeta * MONEDAFACTURATASA))
                FACTURAS_VENTA.cheques = JSON.parse(JSON.stringify(this.Facturasventa.cheques * MONEDAFACTURATASA))
                FACTURAS_VENTA.transferencia = JSON.parse(JSON.stringify(this.Facturasventa.transferencia * MONEDAFACTURATASA))
                FACTURAS_VENTA.cxc = JSON.parse(JSON.stringify(this.Facturasventa.cxc * MONEDAFACTURATASA))
                FACTURAS_VENTA.cupones = JSON.parse(JSON.stringify(this.Facturasventa.cupones * MONEDAFACTURATASA))
                FACTURAS_VENTA.valorConduce = JSON.parse(JSON.stringify(this.Facturasventa.valorConduce * MONEDAFACTURATASA))
                FACTURAS_VENTA.valorNc = JSON.parse(JSON.stringify(this.Facturasventa.valorNc * MONEDAFACTURATASA))
                FACTURAS_VENTA.valorbonogas = JSON.parse(JSON.stringify(this.Facturasventa.valorbonogas * MONEDAFACTURATASA))
                FACTURAS_VENTA.valorasignacion = JSON.parse(JSON.stringify(this.Facturasventa.valorasignacion * MONEDAFACTURATASA))
                FACTURAS_VENTA.valorPruebaMetro = JSON.parse(JSON.stringify(this.Facturasventa.valorPruebaMetro * MONEDAFACTURATASA))
                FACTURAS_VENTA.valorTraspaso = JSON.parse(JSON.stringify(this.Facturasventa.valorTraspaso * MONEDAFACTURATASA))
                FACTURAS_VENTA.valordonacion = JSON.parse(JSON.stringify(this.Facturasventa.valordonacion * MONEDAFACTURATASA))
                FACTURAS_VENTA.subTotal= parseFloat(this.currencyFormatter2(this.Totales.totalGeneral.subtotal).replaceAll(',', ''))
                FACTURAS_VENTA.turno = this.OtrasConfigPv.turno
                var isClinica= this.$store.getters.GetConfiguracionGeneral.config.hasOwnProperty('clinica') && this.$store.getters.GetConfiguracionGeneral.config.clinica==true
               if(isClinica==true && FACTURAS_VENTA.registroInternamiento!=null){
                //this.fechaNueva().trim().substr(0, 10) + "T04:00"
                if(FACTURAS_VENTA.registroInternamiento.fechaIngreso!=null && FACTURAS_VENTA.registroInternamiento.fechaIngreso.toString().length > 0){
                  FACTURAS_VENTA.registroInternamiento.fechaIngreso= FACTURAS_VENTA.registroInternamiento.fechaIngreso.trim().substr(0, 10) + "T04:00"
                }
                if(FACTURAS_VENTA.registroInternamiento.fechaSalida!=null && FACTURAS_VENTA.registroInternamiento.fechaSalida.toString().length > 0){
                  FACTURAS_VENTA.registroInternamiento.fechaSalida= FACTURAS_VENTA.registroInternamiento.fechaSalida.trim().substr(0, 10) + "T04:00"
                }

                } /**/

                var PORCIENTO_LEY = this.$store.getters.GetConfiguracionGeneral.configPv.porcientoLey
                if (PORCIENTO_LEY != null && PORCIENTO_LEY > 0) {
                  FACTURAS_VENTA.porcientoLey = PORCIENTO_LEY
                  FACTURAS_VENTA.valorLey = this.RedondeoValor(((this.Totales.totalGeneral.subtotal * PORCIENTO_LEY) / 100))
                } else {
                  FACTURAS_VENTA.porcientoLey = 0
                  FACTURAS_VENTA.valorLey = 0
                }

                if (this.SelectMedicoFactura != null && this.SelectMedicoFactura.hasOwnProperty("codigo")) {
                  FACTURAS_VENTA.medicoCodigo = this.SelectMedicoFactura.codigo
                  FACTURAS_VENTA.medico = this.SelectMedicoFactura.nombre
                }
              FACTURAS_VENTA.envioArs=false

                  _this.$axios.post(_this.$hostname + _this.$hName + "/pv/save", FACTURAS_VENTA, {
                      headers: _this.$store.getters.GetheadersAxios,
                    })
                    .then((res) => {
                      if (_this.deleteFacturaTemporal != null) {
                        _this.deleRestaurarFact(_this.deleteFacturaTemporal)
                      }
                      if (_this.conduceSelect != null) {
                        _this.deleteConduce(_this.conduceSelect)
                      }
                      if(_this.ListConduceMultiple.length>0){
                        var COND_MULTIPLE={
                          facturasventaPK:res.data.facturasventaPK,
                          listaConduce:_this.ListConduceMultiple
                        }
                        _this.deleteConduceMultiple(COND_MULTIPLE)

                      }


                      if (_this.cotizacionAfacturaSelect != null) {
                        _this.ActualizarCotizacionFActurada(_this.cotizacionAfacturaSelect)
                      }

                      _this.objTemp = res.data
                      _this.RListFactpendiente = res.data

                      // _this.enviarImprimirFactura(res.data)
                      var VALOR_Traspaso_PruebaMetro=(res.data.valorPruebaMetro+res.data.valorTraspaso)
                      var BOOL_TraspasoOrPrueb =  (_this.boolModoEstacion()==true && VALOR_Traspaso_PruebaMetro>0 && VALOR_Traspaso_PruebaMetro==res.data.valor)
                      if (res.data.sucursal.facturacionEletronica == true && _this.caja.facturacionEletronica == true && BOOL_TraspasoOrPrueb==false) {
                        _this.facturacionEletronicaGet(res.data)
                      } else {

                        _this.enviarImprimirFactura(res.data)
                      }


                    })
                    .catch((error) => {
                      if (_this.esErrorConexionPv(error) && _this.debeGuardarFacturaOffline(true)) {
                        _this.guardarFacturaOfflineDesdePayload(FACTURAS_VENTA)
                        return
                      }
                      var mensaje = error && error.response && error.response.request ? error.response.request.responseText : error
                      _this.alerta(mensaje || "No se pudo guardar la factura", "error")
                      _this.ejecucion = true
                      _this.pvGuardandoFactura = false
                      _this.loading(false)
                    })

              }


            } else {
              this.alerta("No posee secuencia para la factura que está intentado realizar", "error")
              this.ejecucion = true
              this.pvGuardandoFactura = false
              this.loading(false)
            }
          })
          .catch(error => {
            if (this.esErrorConexionPv(error) && this.debeGuardarFacturaOffline(true)) {
              this.ejecucion = false
              this.loading(true)
              this.Facturasventa.fecha = new Date(new Date().toLocaleDateString("en-DO")).toISOString()
              this.guardarFacturaOfflineDesdeEstado(MONEDAFACTURATASA)
              return
            }
            var mensaje = error && error.response && error.response.request ? error.response.request.responseText : error
            this.alerta(mensaje || "No se pudo validar la secuencia de la factura", "error")
            this.ejecucion = true
            this.pvGuardandoFactura = false
            this.loading(false)
          })


      }
    },

    // Esperando a que el usuario haga clic en el botón para inicial el proceso de cobro de factura.
    async realizarCobro() {

      if (this.validarCobroDuranteSincronizacionOffline() == false) {
        return 0
      }

      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURATASA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)

      if (this.caja != null) {

        if (this.caja.cobradora == false) {
          this.alerta("En esta caja no esta permitido cobrar", "error")
          return 0
        }

       if (this.caja.soloDomicilio == true && this.domiciliofactura==null) {
          this.alerta("NOTA: Esta caja esta asignada para cobrar solo con domicilio", "error")
          return 0
        }


      } else {
        this.alerta("Seleccione una caja", "error")
        return 0
      }
      var totalTotalFac = this.RedondeoBasico((this.Totales.totalGeneral.subtotal + this.Totales.totalGeneral.itbis))

      var SumaTotal = this.RedondeoBasico((this.Facturasventa.efectivo + this.Facturasventa.tarjeta + this.Facturasventa.transferencia + this.Facturasventa.cheques + this.Facturasventa.cxc
        + this.Facturasventa.cupones + this.Facturasventa.puntos + this.Facturasventa.valorConduce + this.Facturasventa.valorNc + this.Facturasventa.valorbonogas +this.Facturasventa.valorasignacion 
        +this.Facturasventa.valorPruebaMetro+this.Facturasventa.valorTraspaso+this.Facturasventa.valordonacion) * MONEDAFACTURATASA)

      if (this.CoberturaSeguro.cobertura > 0 && this.CoberturaSeguro.cobertura == totalTotalFac) {

      } else {
        if (SumaTotal == 0) {
          this.alerta("Dijite una forma de pago", "error")
          return 0
        }
      }

      if (this.clienteFactura != null && this.Facturasventa.cxc > 0) {
        var clienteEstadoCredito = this.clienteFactura
        if (
          this.tieneRecetaControladaActiva() &&
          this.clienteTempCredito != null &&
          this.clienteTempCredito.hasOwnProperty("codigo")
        ) {
          clienteEstadoCredito = this.clienteTempCredito
        }

        if (
          !this.tieneRecetaControladaActiva() ||
          (this.tieneRecetaControladaActiva() && this.clienteTempCredito != null && this.clienteTempCredito.hasOwnProperty("codigo"))
        ) {
          if (clienteEstadoCredito.statuscliente != null) {
            if (clienteEstadoCredito.statuscliente == 2 || clienteEstadoCredito.statuscliente == 3) {
              this.alerta("Este cliente esta suspendido o cancelado, no puede facturarle a credito", "error")
              return
            }
          }
        }
      }

      var vend = this.$store.getters.GetConfiguracionGeneral.configPv.vendedorobligatorio
      var Medic = this.$store.getters.GetConfiguracionGeneral.configPv.usarMedico
      var comentarioObligatorio = this.$store.getters.GetConfiguracionGeneral.configPv.comentarioObligatorio

      if (vend == true && this.Facturasventa.vendedor == null) {
        this.alerta("Debe seleccionar un vendedor", "error")
        return 0
      }


      if (Medic == true && this.SelectMedicoFactura == null) {
        this.alerta("Debe seleccionar un medico", "error")
        return 0
      }


      if (comentarioObligatorio == true && this.Facturasventa.comentario.trim().length == 0) {
        this.alerta("Debe colocar un comentario a esta factura", "error")
        this.OpenComentarioFactura()
        return 0
      }

      if (this.Totales.totalGeneral.cobertura > 0 && this.clienteFactura.ars == null) {
        this.alerta("Debe asignarle una ars a  el cliente seleccionado.", "error")
        return 0
      }

      var QUITAR_DESC = this.$store.getters.GetConfiguracionGeneral.configPv.quitarDescuentoClienteCredito
      if (QUITAR_DESC != null && QUITAR_DESC == true) {
        if ((this.Facturasventa.cxc * MONEDAFACTURATASA) > 0 && this.Totales.totalGeneral.descuento > 0) {
          this.dialogNotifQuitarDescuentoCliente = true
          return
        }
      }


// validar el balance de cliente punto preferencial
      var MODALIDAD_CLI_PRE = this.$store.getters.GetConfiguracionGeneral.configPv.modalidadClientePreferencial
      if (MODALIDAD_CLI_PRE == true && this.Facturasventa.puntos > 0 && this.clienteFactura != null) {


        this.$axios.get(this.$hostname + this.$hName + "/clientes/find/" + this.clienteFactura.codigo, {
          headers: this.$store.getters.GetheadersAxios,
        })
          .then((res) => {

            this.clienteFactura.balancePuntos = this.RedondeoBasico(res.data.balancePuntos)
            if (res.data.hasOwnProperty("codigo")) {
              if (this.Facturasventa.puntos > this.RedondeoBasico(res.data.balancePuntos)) {
                this.alerta(`Los puntos digitado (${currencyFormatter(this.Facturasventa.puntos)}) sobre pasa a los puntos del cliente (${currencyFormatter(res.data.balancePuntos)}) `, "error")
                return
              }

              this.loading(true)
              this.ContrealizarCobro()

            } else {
              this.alerta("error validando los punto acumulado del cliente", "error")
            }

          })
          .catch(error => {
            this.alerta("error validando los punto acumulado del cliente", "error")
          })
      } else {

        this.loading(true)
        // const result = await this.ActualizarProductPago();
        // this.loading(false)
        this.ContrealizarCobro()

      }
    },


    tieneRecetaControladaActiva() {
      return this.RecetaProdControlado != null &&
        this.RecetaProdControlado.numero != null &&
        this.RecetaProdControlado.detalleList != null &&
        this.RecetaProdControlado.detalleList.length > 0 &&
        this.RecetaProdControlado.cliente != null &&
        this.RecetaProdControlado.cliente.hasOwnProperty("codigo")
    },

    clienteCreditoNoValidoParaFactura(cliente) {
      if (cliente == null || !cliente.hasOwnProperty("codigo")) {
        return true
      }

      if (cliente.statuscliente != null && (cliente.statuscliente == 2 || cliente.statuscliente == 3)) {
        return true
      }

      if (
        cliente.hasOwnProperty("suspensiondiascredito") &&
        cliente.suspensiondiascredito != null &&
        cliente.suspensiondiascredito == true
      ) {
        return true
      }

      if (cliente.hasOwnProperty("clienteSupencion") && cliente.clienteSupencion == true) {
        return true
      }

      if (cliente.diascredito == null || cliente.diascredito == 0) {
        return true
      }

      if (cliente.limitecredito == null || cliente.limitecredito == 0) {
        return true
      }

      var balancecliente = 0
      if (cliente.balancecliente != null && cliente.balancecliente.balance > 0) {
        balancecliente = cliente.balancecliente.balance
      }

      var cliBalanc = balancecliente / this.Monedafactura.tasa + this.Facturasventa.cxc
      return cliBalanc > cliente.limitecredito
    },

    abrirSeleccionClienteCreditoControlado() {
      this.loading(false)
      this.alerta("Seleccione el cliente responsable del credito para esta factura", "warning")
      this.dialogSelectClienteTempCredito = true
      this.filtroTipoCliente = 3
      this.RedireccionFocus("RefTextFieldBuscaClienteCredito")
    },

    // Comprobando si el pago es mayor al total de la factura.
    async ContrealizarCobro() {
      if (this.validarCobroDuranteSincronizacionOffline() == false) {
        return 0
      }
      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURATASA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)
      //var moneda=this.$store.getters.GetOtrasConfigPv.moneda
      if (this.RProductoCompra.length <= 0) {
        this.alerta("agrege al menos un producto a la lista", "error")
        return 0
      }

      if (this.UsarLote == true) {
        var ObjRow = this.RProductoCompra.filter((ee) => ee.lote.length == 0)
        if (ObjRow.length > 0) {
          var msj = `Esta utilizando la configuración de lote, y este producto:#${ObjRow[0].indx + 1}-(${ObjRow[0].descripcion}),no tiene lote asignado`
          this.alerta(msj, "error")
        }

      }

      if (this.devuelta < 0) {
        this.alerta(
          "El valor a pagar es menor que el valor de la factura",
          "error",
        )
        return 0
      }

      if (this.Totales.totalGeneral.total == 0 && this.Totales.totalGeneral.cobertura == 0) {
        return 0
      }
      //RedondeoBasico
      //currencyFormatter2
      //if(this.Facturasventa.efectivo<=0){}

      if (this.clienteFactura == null) {
        var ObjRow = this.RProductoCompra.filter((ee) => ee.productos.planBeneficio == true)
        if (ObjRow.length > 0) {
          var msj = `El producto:#${ObjRow[0].indx + 1}-(${ObjRow[0].descripcion}),Tiene asignado plan Beneficio, debe seleccionar un cliente`
          this.alerta(msj, "error")
          return
        }

      }


      if (this.RedondeoBasico(this.Facturasventa.tarjeta * MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' Tarjeta ' sobre pasa el total de la factura  ", "error")
        return 0
      }

      if (this.RedondeoBasico(this.Facturasventa.cheques * MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' Cheques ' sobre pasa el total de la factura  ", "error")
        return 0
      }

      if (this.RedondeoBasico(this.Facturasventa.transferencia * MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' Transferencia ' sobre pasa el total de la factura  ", "error")
        return 0
      }

      if (this.RedondeoBasico(this.Facturasventa.cxc * MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' Crédito(cxc) ' sobre pasa el total de la factura  ", "error")
        return 0
      }

      if (this.RedondeoBasico(this.Facturasventa.cupones * MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' cupones ' sobre pasa el total de la factura  ", "error")
        return 0
      }

      if (this.RedondeoBasico(this.Facturasventa.puntos * MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' puntos ' sobre pasa el total de la factura  ", "error")
        return 0
      }

      /*if (this.RedondeoBasico(this.Facturasventa.valorConduce*MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' valor Conduce ' sobre pasa el total de la factura  ", "error")
        return 0;
      }*/

      if (this.RedondeoBasico(this.Facturasventa.valorNc * MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' Nota de crédito ' sobre pasa el total de la factura  ", "error")
        return 0
      }

    if (this.RedondeoBasico(this.Facturasventa.valorbonogas * MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' bonogas ' sobre pasa el total de la factura  ", "error")
        return 0
      }

      if (this.RedondeoBasico(this.Facturasventa.valorasignacion * MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' Asignacion ' sobre pasa el total de la factura  ", "error")
        return 0
      }
       if (this.RedondeoBasico(this.Facturasventa.valorPruebaMetro * MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' Prueba Metro ' sobre pasa el total de la factura  ", "error")
        return 0
       }

        if (this.RedondeoBasico(this.Facturasventa.valorTraspaso * MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' Traspaso ' sobre pasa el total de la factura  ", "error")
        return 0
       }
       
 if (this.RedondeoBasico(this.Facturasventa.valordonacion * MONEDAFACTURATASA) > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("La forma de pago ' Donacion ' sobre pasa el total de la factura  ", "error")
        return 0
       }


if(this.Facturasventa.tipocomprobante!=null && this.Facturasventa.tipocomprobante.tipoEcf!=null && this.Facturasventa.tipocomprobante.tipoEcf!=32){

  if(this.Facturasventa.cedularncncf==null || this.Facturasventa.cedularncncf!=null && this.Facturasventa.cedularncncf.trim().length==0){
  this.alerta(` NOTA: EL COMPROBANTE :${this.Facturasventa.tipocomprobante.descripcion.trim()} NO POSEE EL CAMPO: (CEDULA/RNC) `, "warning")
  this.ComprobanteFisc = {
          comprobante: JSON.parse(JSON.stringify(this.Facturasventa.tipocomprobante)),
          nombre: JSON.parse(JSON.stringify(this.Facturasventa.nombreDgii)),
          telefono: JSON.parse(JSON.stringify(this.Facturasventa.telefononcf)),
          direccion: JSON.parse(JSON.stringify(this.Facturasventa.direccionncf)),
          cedrnc: JSON.parse(JSON.stringify(this.Facturasventa.cedularncncf)),
        }
  this.dialogComprobante = true
  return
  }

}
  
      //this.Facturasventa.valorConduce +
      var SumaTotal = this.RedondeoBasico(
        (this.Facturasventa.tarjeta + this.Facturasventa.transferencia + this.Facturasventa.cheques + this.Facturasventa.cxc
          + this.Facturasventa.cupones + this.Facturasventa.puntos + this.Facturasventa.valorNc + this.Facturasventa.valorbonogas
          + this.Facturasventa.valorPruebaMetro+ this.Facturasventa.valorTraspaso+this.Facturasventa.valorasignacion
          + this.Facturasventa.valordonacion ) * MONEDAFACTURATASA
      )

      if (SumaTotal > this.RedondeoBasico(this.Totales.totalGeneral.total)) {
        this.alerta("Las formas de pago sobre pasa el total de la factura  ", "error")
        return 0
      }

      var MODALIDAD_CLI_PRE = this.$store.getters.GetConfiguracionGeneral.configPv.modalidadClientePreferencial
      if (MODALIDAD_CLI_PRE == true && this.Facturasventa.puntos > 0 && this.clienteFactura != null) {

        if (this.Facturasventa.puntos > this.clienteFactura.balancePuntos) {
          this.alerta(`Los puntos digitado (${currencyFormatter(this.Facturasventa.puntos)}) sobre pasa a los puntos del cliente (${currencyFormatter(this.clienteFactura.balancePuntos)}) `, "error")
          return
        }


      }


      if (this.activaConduceCredito == true) {

        if (this.clienteFactura == null) {
          this.alerta("Para hacer esta operación necesita elegir un cliente a credito", "error")
          return 0
        } else {
          if (this.clienteFactura.diascredito == null || this.clienteFactura.diascredito == 0) {
            this.alerta("Para hacer esta operación necesita elegir un cliente a credito", "error")
            return 0
          }
        }

        var CONDUC_DOCUM = this.$store.getters.GetConfiguracionGeneral.configCxc.documentoVenta

        if (CONDUC_DOCUM == null) {
          this.alerta("No tiene la configuración necesaria para hacer esta operación", "error")
          return 0
        }

      }


      /*this.Facturasventa.efectivo*/
// valirdar cliente credito y si contiene credito
      if (this.Facturasventa.cxc * MONEDAFACTURATASA > 0 && this.CoberturaSeguro.cobertura == 0) {
        var CLIENTE_VALIDAR_CREDITO = this.clienteFactura
        if (this.tieneRecetaControladaActiva() && this.clienteCreditoNoValidoParaFactura(this.clienteFactura)) {
          if (this.clienteTempCredito == null || !this.clienteTempCredito.hasOwnProperty("codigo")) {
            this.abrirSeleccionClienteCreditoControlado()
            return 0
          }
          CLIENTE_VALIDAR_CREDITO = this.clienteTempCredito
        }

        if (
          CLIENTE_VALIDAR_CREDITO.hasOwnProperty("suspensiondiascredito") &&
          CLIENTE_VALIDAR_CREDITO.suspensiondiascredito != null &&
          CLIENTE_VALIDAR_CREDITO.suspensiondiascredito == true
        ) {
          if (this.tieneRecetaControladaActiva()) {
            this.abrirSeleccionClienteCreditoControlado()
          } else {
            this.alerta("El Cliente Esta suspeniddo", "error")
          }
          return 0
        }

        if (CLIENTE_VALIDAR_CREDITO.diascredito == 0) {
          if (this.tieneRecetaControladaActiva()) {
            this.abrirSeleccionClienteCreditoControlado()
          } else {
            this.alerta(
              "El cliente seleccionado no es un cliente a credito",
              "error",
            )
          }
          return 0
        } else {

          if (CLIENTE_VALIDAR_CREDITO.hasOwnProperty("clienteSupencion") && CLIENTE_VALIDAR_CREDITO.clienteSupencion == true) {
            if (this.tieneRecetaControladaActiva()) {
              this.abrirSeleccionClienteCreditoControlado()
            } else {
              this.funcionValidaPermisoPv("AccPermitirExcederLimiteSuspensionDias")
              this.alerta("El Cliente esta Suspendido... ", "error")
            }
            return 0
          }

          if (
            CLIENTE_VALIDAR_CREDITO.limitecredito == null ||
            CLIENTE_VALIDAR_CREDITO.limitecredito == 0
          ) {

            if (this.tieneRecetaControladaActiva()) {
              this.abrirSeleccionClienteCreditoControlado()
              return 0
            }

            if (this.contFactExcedeLimitCredito == false) {
              this.funcionValidaPermisoPv("AccFactExcedeLimitCredito")
              this.alerta("El Cliente excede limite de credito ", "error")
              return 0
            }

          } else {

            var balancecliente = 0
            if (
              CLIENTE_VALIDAR_CREDITO.balancecliente != null &&
              CLIENTE_VALIDAR_CREDITO.balancecliente.balance > 0
            ) {
              balancecliente = CLIENTE_VALIDAR_CREDITO.balancecliente.balance
            }

            var cliBalanc = balancecliente / this.Monedafactura.tasa + this.Facturasventa.cxc
            if (cliBalanc > CLIENTE_VALIDAR_CREDITO.limitecredito) {
              if (this.tieneRecetaControladaActiva()) {
                this.abrirSeleccionClienteCreditoControlado()
                return 0
              }
              if (this.contFactExcedeLimitCredito == false) {
                this.funcionValidaPermisoPv("AccFactExcedeLimitCredito")
                this.alerta("El Cliente excede limite de credito ", "error")
                return 0
              }
            }
          }
        }
      }


// valirdar cliente credito y si contiene credito y con cobertura
      if (this.Facturasventa.cxc * MONEDAFACTURATASA > 0 && this.CoberturaSeguro.cobertura > 0) {
        var CLIENTE_VALIDAR_CREDITO = null
        //this.clienteTempCredito
        if (this.clienteTempCredito == null) {
          CLIENTE_VALIDAR_CREDITO = JSON.parse(JSON.stringify(this.clienteFactura))
          this.clienteTempCredito = JSON.parse(JSON.stringify(this.clienteFactura))

        } else {
          CLIENTE_VALIDAR_CREDITO = JSON.parse(JSON.stringify(this.clienteTempCredito))
        }

        if (
          CLIENTE_VALIDAR_CREDITO.hasOwnProperty("suspensiondiascredito") &&
          CLIENTE_VALIDAR_CREDITO.suspensiondiascredito != null &&
          CLIENTE_VALIDAR_CREDITO.suspensiondiascredito == true
        ) {
          this.alerta("El Cliente seleccionado Esta suspeniddo", "error")
          this.dialogSelectClienteTempCredito = true
          this.filtroTipoCliente = 3
          this.RedireccionFocus("RefTextFieldBuscaClienteCredito")
          return 0
        }

        if (CLIENTE_VALIDAR_CREDITO.diascredito == 0) {
          this.alerta(
            "El cliente seleccionado no es un cliente a credito",
            "error",
          )
          this.dialogSelectClienteTempCredito = true
          this.filtroTipoCliente = 3
          this.RedireccionFocus("RefTextFieldBuscaClienteCredito")
          return 0
        } else {
          if (
            CLIENTE_VALIDAR_CREDITO.limitecredito == null ||
            CLIENTE_VALIDAR_CREDITO.limitecredito == 0
          ) {
            this.alerta("El Cliente no tiene credito ", "error")
            this.dialogSelectClienteTempCredito = true
            this.filtroTipoCliente = 3
            this.RedireccionFocus("RefTextFieldBuscaClienteCredito")
            return 0
          } else {
            var balancecliente = 0
            if (
              CLIENTE_VALIDAR_CREDITO.balancecliente != null &&
              CLIENTE_VALIDAR_CREDITO.balancecliente.balance > 0
            ) {
              balancecliente = CLIENTE_VALIDAR_CREDITO.balancecliente.balance
            }

            //var moneda=this.$store.getters.GetOtrasConfigPv.moneda
            //(App.client.selectedClient.balancecliente.balance / _this.util.exchangeRate) +
            //(_this.pago.creditValue / _this.util.exchangeRate) > App.client.selectedClient.limiteCredito)

            //---------validando balance del cliente
            var cliBalanc =balancecliente / this.Monedafactura.tasa + this.Facturasventa.cxc
            if (cliBalanc > CLIENTE_VALIDAR_CREDITO.limitecredito) {
              /*this.alerta("El Cliente excede limite de credito ", "error")
              this.dialogSelectClienteTempCredito = true
              this.filtroTipoCliente = 3
              this.RedireccionFocus("RefTextFieldBuscaClienteCredito")*/
               if (this.contFactExcedeLimitCredito == false) {
               this.funcionValidaPermisoPv("AccFactExcedeLimitCredito")
              this.alerta("El Cliente excede limite de credito.", "error")

              return 0
            }
            }
          }
        }


        this.clienteTempCredito = JSON.parse(JSON.stringify(CLIENTE_VALIDAR_CREDITO))


      }


      if (this.Facturasventa.valorNc * MONEDAFACTURATASA > 0) {

        if (this.selectedListFPagoNC.length == 0) {
          this.alerta("Debe seleccionar una nota de crédito para poder cobrar con nota de crédito", "error")
          return 0
        }

        if (this.Facturasventa.valorNc * MONEDAFACTURATASA > this.Totales.totalGeneral.total) {
          this.alerta("El valor de pago nota de crédito es mayor al valor de la factura", "error")
          return 0
        }

      }


      // && this.Facturasventa.tipoTarjeta==null
      // this.Facturasventa.numtar

      // ------- pagos con tarjeta de credito
      if (this.Facturasventa.tarjeta * MONEDAFACTURATASA > 0) {
        await this.cargarTipoTarjeta()
        if (this.RTipoTarjeta.length == 0) {
          this.alerta("No hay tipos de tarjeta disponibles. Verifique que esta PC haya sincronizado el catalogo offline con conexion.", "error")
          this.OpenPanelFormaPagoTarjeta()
          return 0
        }
        if (this.SelctCbTipoTarjeta(true) == false || !this.$refs.formTarjetaFormPago.validate()) {
          this.alerta("Los datos de la tarjeta son requeridos ", "error")
          this.OpenPanelFormaPagoTarjeta()
          return 0
        }

        var CONFDESCTARJ = this.$store.getters.GetConfiguracionGeneral.configPv.descuentoTarjeta
        if (CONFDESCTARJ > 0 && this.Totales.totalGeneral.descuento > 0) {
          //  po=((desc/subtotal)*100)
          var po = this.RedondeoBasico(((this.Totales.totalGeneral.descuento / this.Totales.totalGeneral.subtotal) * 100))
          if (po > CONFDESCTARJ) {

              if (this.contFactDescLimitTarjeta == false) {
              this.funcionValidaPermisoPv("AccFactDescLimitTarjeta")
              this.alerta("El descuento de esta factura sobre pasa el por ciento de descuento con tarjeta.", "error")
             // return 0
              return
            }

          }

        }

        var lccaja = JSON.parse(localStorage.caja)
        if (lccaja.veryFoms == true) {

          if (this.tipoTarjeta.azul == true) {
            return 0
          }
          if (this.tipoTarjeta.cardnet == true) {
            this.validarcarnet()
            return 0
          }
          this.PostrealizarCobro()
        } else {
          this.PostrealizarCobro()
        }
      } else {
        this.PostrealizarCobro()
      }
    },

    // Hacer una solicitud de publicación al servidor.
    async validarcarnet() {
      this.loading(true)
      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURATASA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)
      //http://localhost:22105/api/Prueba
      // this.$axios.get(this.$hostname+this.$hName+'/monedas/findallActivos/',{headers:this.$store.getters.GetheadersAxios})
      // .then(res=>( this.Rmoneda=res.data))

      var num = ""
      num = ((this.Facturasventa.tarjeta * MONEDAFACTURATASA).toFixed(2) + "").replace(".", "")

      var obj = {
        amount: num,
        tax: 0,
        otherTaxes: 0,
        invoiceId: 0,
        quantyOfPayments: 0,
        host: 0,
        referenceNumber: 0,
      }

      //var stobj='{"Status":"Successful","Host":{"Value":6,"Description":"Credit"},"Mode":{"Value":"C@5","Description":"Sale with CHIP(EMV)"},"Card":{"Product":"Mastercard","CardNumber":"534217******5024","HolderName":"SCOTIABANK/TARJETAHABIENTE"},"Transaction":{"AuthorizationNumber":"007656","Reference":2,"RetrievalReference":214611000062,"DataTime":"26/5/2022 11:04:40 a. m.","ApplicationIdentifier":"A0000000041010","LoyaltyDeferredNumber":null,"TID":null},"Batch":22,"TerminalID":"80029126","MerchantID":"349011300","Acquired":"CardNET","Reserved":null,"Signature":null}'

      this.$axios
        .post("http://localhost:22105/api/ProcessNormalSale", obj, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          this.loading(false)
          var e = JSON.parse(res.data)
          e.tipo = "Carnet"

          if (e.Status == "Successful") {
            this.Facturasventa.numtar = e.Card.CardNumber
            this.Facturasventa.datoTarjeta = JSON.stringify(e)

            //   App.checkIn();
            this.alerta("Transacción finalizada correctamente", "bien2")
            var _this = this
            setTimeout(function() {
              _this.PostrealizarCobro()
            }, 3000)
          }

          if (e.Status == "Failed") {
            this.alerta("Transacción cancelada", "error")
          }
        })
        .catch((error) => {
          console.log(".Rescatch-->", res.data)
          this.alerta("Transacción cancelada", "error")
          this.loading(false)
        })
    },

    // Hacer una solicitud de publicación al servidor enviando y comprobando los datos de carnet .
    Anulacioncarnet() {
      // var bool=true

      // if(bool==true){
      //   this.ProcessFacturaAnula()
      //   return 0;
      // }
      this.loading(true)
      var obj = JSON.parse(this.AnulacionFacturaSeleccionada.datoTarjeta)

      var objinf = {
        amount: 0,
        tax: 0,
        otherTaxes: 0,
        invoiceId: 0,
        quantyOfPayments: 0,
        host: obj.Host.Value,
        referenceNumber: obj.Transaction.Reference,
      }

      this.$axios
        .post("http://localhost:22105/api/ProcessAnnulment", objinf, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          this.loading(false)
          var e = JSON.parse(res.data)

          if (e.Status == "Successful") {
            obj.TarjetaAnulada = e
            this.AnulacionFacturaSeleccionada.datoTarjeta = JSON.stringify(obj)
            var _this = this
            setTimeout(function() {
              _this.ProcessFacturaAnula()
            }, 3000)
          }

          if (e.Status == "Failed") {
            this.alerta("Anulacion cancelada", "error")
          }
        })
        .catch((error) => this.alerta("Anulacion cancelada", "error"))

      //AnulafacturatarjetacreditoCar
    },

    // Hacer una solicitud  al servidor para procesar el cierre del veriphone.
    async validarCierreCarnet() {
      this.loading(true)
      //http://localhost:22105/api/Prueba
      // this.$axios.get(this.$hostname+this.$hName+'/monedas/findallActivos/',{headers:this.$store.getters.GetheadersAxios})
      // .then(res=>( this.Rmoneda=res.data))

      var num = ""
      num = (this.Facturasventa.tarjeta.toFixed(2) + "").replace(".", "")

      var obj = {
        amount: 0,
        tax: 0,
        otherTaxes: 0,
        invoiceId: 0,
        quantyOfPayments: 0,
        host: 0,
        referenceNumber: 0,
      }

      //var stobj='{"Status":"Successful","Host":{"Value":6,"Description":"Credit"},"Mode":{"Value":"C@5","Description":"Sale with CHIP(EMV)"},"Card":{"Product":"Mastercard","CardNumber":"534217******5024","HolderName":"SCOTIABANK/TARJETAHABIENTE"},"Transaction":{"AuthorizationNumber":"007656","Reference":2,"RetrievalReference":214611000062,"DataTime":"26/5/2022 11:04:40 a. m.","ApplicationIdentifier":"A0000000041010","LoyaltyDeferredNumber":null,"TID":null},"Batch":22,"TerminalID":"80029126","MerchantID":"349011300","Acquired":"CardNET","Reserved":null,"Signature":null}'

      this.$axios
        .post("http://localhost:22105/api/ProcessClose", obj, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          this.loading(false)
          var e = JSON.parse(res.data)
          var _this = this
          if (e.Status == "Successful") {
            this.CierresCajas.datoTarjeta = JSON.stringify(e)
            this.alerta("Cierre finalizada correctamente", "bien2")
            setTimeout(function() {
              _this.PostSalvarCierreCaja(true)
            }, 3000)
          }

          if (e.Status == "Failed") {
            if (
              e.Messages[0] ==
              "La cadena de entrada no tiene el formato correcto."
            ) {
              setTimeout(function() {
                _this.PostSalvarCierreCaja(false)
              }, 3000)
            } else {
              this.alerta("Transacción cancelada", "error")
            }
          }
        })
        .catch((error) => {
          this.alerta("Transacción cancelada", "error")
          this.loading(false)
        })
    },

    // Creando un nuevo objeto llamado domicilio y asignándole valores.
    ConstruirDomicilio(datos, devuelta) {
      var TIPOCOMPROBANTE = 0
      if (datos.tipocomprobante != null) {
        TIPOCOMPROBANTE = datos.tipocomprobante.codigo
      } else {
        TIPOCOMPROBANTE = this.$store.getters.GetConfiguracionGeneral.configPv.comprobantefacturacion.codigo
      }


      var domicilio = {
        codigo: 0,
        direccion: this.domiciliofactura.direccion,
        telefono: this.domiciliofactura.telefonoPrincipal,
        valor: datos.valor,
        itbis: datos.valorimpuesto,
        descuento: datos.valordescuento,
        diascredito: 0,
        tipocomprobante: TIPOCOMPROBANTE,
        tasa: datos.tasa,
        facturado: false,
        devuelta: devuelta,
        fecha: datos.fecha,
        moneda: datos.moneda.codigo,
        devuelto: false,
        numerocierre: datos.numerocierre,
        caja: datos.caja.codigo,
        usuario: "",
        sucursal: datos.sucursal.codigo,
        borrado: false,
        horaPedido: null,
        horaEntrega: null,
        domciliosDetalleList: this.crearDetalle(datos.facturasventaDetalleList),
        cliente: datos.cliente,
        facturasventa: null,
        mensajero: null,
      }
      this.Facturasventa.domicilio = domicilio

    },
    // Crear una nueva lista de objetos a partir de los datos pasados.
    crearDetalle(datos) {
      var List = []

      // (async () => {
      datos.forEach((l) => {
        /*await Promise.all(datos.map(async (l) => {
         }));*/
        var detalle = {
          domciliosDetallePK: { codigo: 0, producto: 0, unidad: 0 },
          precio: l.precio,
          cantidad: l.cantidad,
          valordescuento: l.valordescuento,
          impuesto: l.impuesto != null && l.impuesto.hasOwnProperty("codigo") ? l.impuesto.codigo : null,
          valorimpuesto: l.valorimpuesto,
          valorcupon: 0.0,
          codigocupon: "",
          descuento: l.descuento,
          borrado: false,
          productos: l.productos,
          unidades: l.unidades,
          vendedor: l.vendedor,
        }
        List.push(detalle)
      })
      //  })()
      return List
    },
    ChangeReciboIngresoValorPorcc() {
      this.CalcularReciboIngreso()
    },

    reciboIngresoKeyCtrl(e) {
      //key:"Ctrl":17
      if (e.keyCode == 17) {
        if (this.ReciboIngresoFactPendHist == true) {
          this.SalvarReciboIngresoFacPen()
        }

      }


    },

    ReciboEnterEfectivo() {
      var Valortotal =
        this.ReciboIngresoFactura.efectivo +
        this.ReciboIngresoFactura.tarjeta +
        this.ReciboIngresoFactura.cheque +
        this.ReciboIngresoFactura.transferencia

      var Objefc = 0
      if (Valortotal < this.Totales.ReciboIngreso.abono) {
        Objefc = JSON.parse(
          JSON.stringify(this.Totales.ReciboIngreso.abono - Valortotal),
        )
      }
      this.ReciboIngresoFactura.efectivo = Objefc
    },

    ReciboEnterTarjeta() {
      var Valortotal =
        this.ReciboIngresoFactura.efectivo +
        this.ReciboIngresoFactura.tarjeta +
        this.ReciboIngresoFactura.cheque +
        this.ReciboIngresoFactura.transferencia

      var Objefc = 0
      if (Valortotal < this.Totales.ReciboIngreso.abono) {
        Objefc = JSON.parse(
          JSON.stringify(this.Totales.ReciboIngreso.abono - Valortotal),
        )
      }
      this.ReciboIngresoFactura.tarjeta = Objefc
    },

    ReciboEnterCheques() {
      var Valortotal =
        this.ReciboIngresoFactura.efectivo +
        this.ReciboIngresoFactura.tarjeta +
        this.ReciboIngresoFactura.cheque +
        this.ReciboIngresoFactura.transferencia

      var Objefc = 0
      if (Valortotal < this.Totales.ReciboIngreso.abono) {
        Objefc = JSON.parse(
          JSON.stringify(this.Totales.ReciboIngreso.abono - Valortotal),
        )
      }
      this.ReciboIngresoFactura.cheque = Objefc

      this.calcularToTalRecIng()
    },

    ReciboEnterTransferencia() {
      var Valortotal =
        this.ReciboIngresoFactura.efectivo +
        this.ReciboIngresoFactura.tarjeta +
        this.ReciboIngresoFactura.cheque +
        this.ReciboIngresoFactura.transferencia

      var Objefc = 0
      if (Valortotal < this.Totales.ReciboIngreso.abono) {
        Objefc = JSON.parse(
          JSON.stringify(this.Totales.ReciboIngreso.abono - Valortotal),
        )
      }
      this.ReciboIngresoFactura.transferencia = Objefc
      this.calcularToTalRecIng()
    },

    
    SalvarReciboIngresoFacPen(){

//if(this.ejecucion==true){
      //this.ejecucion = false
      this.loading(true)
        var _this = this
       setTimeout(function() {
              _this.contSalvarReciboIngresoFacPen();
            }, 600)
//}

    },
    //Agrega el recibo combleto
    contSalvarReciboIngresoFacPen() {
      if (this.caja != null) {
        if (this.caja.cobradora == false) {
          this.alerta("En esta caja no esta permitido cobrar", "error")
          return 0
        }
      } else {
        this.alerta("Seleccione una caja", "error")
        return 0
      }

      this.Totales.ReciboIngreso.pendiente = this.RedondeoBasico(this.Totales.ReciboIngreso.pendiente)
      this.Totales.ReciboIngreso.abono = this.RedondeoBasico(this.Totales.ReciboIngreso.abono)
      this.ReciboIngreso.abono = this.RedondeoBasico(this.ReciboIngreso.abono)
      if (this.ReciboIngreso.abono > this.Totales.ReciboIngreso.pendiente) {
        this.alerta("El valor a abonar es mayor que el valor pendiente.", "error")
        return
      }

      if (this.Totales.ReciboIngreso.abono == 0) {
        this.alerta(
          "Debe de abonar en al menos una factura pendiente",
          "error",
        )
        return 0
      }

      var Valortotal =
        this.ReciboIngresoFactura.efectivo +
        this.ReciboIngresoFactura.tarjeta +
        this.ReciboIngresoFactura.cheque +
        this.ReciboIngresoFactura.transferencia

      if (Valortotal < this.Totales.ReciboIngreso.abono) {
        this.alerta(
          "El valor a pagar es menor que el valor abonado a la factura",
          "error",
        )
        return 0
      }

      /*   if (Valortotal > this.Totales.ReciboIngreso.abono) {
           this.alerta(
             "El valor a pagar debe ser igual al valor abonado a la factura",
             "error"
           );
           return 0;
         }*/


      //if(this.ReciboIngresoFactura.efectivo<=0){}
      if (this.ReciboIngresoFactura.cheque > this.Totales.ReciboIngreso.abono) {
        this.alerta("La forma de pago ' Cheque ' sobre pasa el monto ha abonar de la factura  ", "error")
        return 0
      }

      if (this.ReciboIngresoFactura.transferencia > this.Totales.ReciboIngreso.abono) {
        this.alerta("La forma de pago ' Transferencia ' sobre pasa el monto ha abonar de la factura  ", "error")
        return 0
      }

      if (this.ReciboIngresoFactura.tarjeta > this.Totales.ReciboIngreso.abono) {
        this.alerta("La forma de pago ' Tarjeta ' sobre pasa el monto ha abonar de la factura  ", "error")
        return 0
      }


      var SumaTotal = (this.ReciboIngresoFactura.cheque + this.ReciboIngresoFactura.transferencia + this.ReciboIngresoFactura.tarjeta)

      if (SumaTotal > this.Totales.ReciboIngreso.abono) {
        this.alerta("Las formas de pago sobre pasa el monto ha abonar de la factura  ", "error")
        return 0
      }


      if (this.ReciboIngresoFactura.tarjeta > 0) {
        if (!this.$refs.formRecibTarjetaFormPago.validate()) {
          this.alerta("Los datos de la tarjeta son requeridos ", "error")
          this.OpenPanelReciboFormaPago("Tarjeta")
          return 0
        }

        var lccaja = JSON.parse(localStorage.caja)
        if (lccaja.veryFoms == true) {

          if (this.ReciboIngresoFactura.tipoTarjeta.azul == true) {
            return 0
          }
          if (this.ReciboIngresoFactura.tipoTarjeta.cardnet == true) {
            this.validarcarnetReciboIngreso()
            return 0
          }
          this.FinalizarSalvarReciboIngresoFacPen()
        } else {
          this.FinalizarSalvarReciboIngresoFacPen()
        }

      } else {
        this.FinalizarSalvarReciboIngresoFacPen()
      }


      //this.FinalizarSalvarReciboIngresoFacPen()

      //this.alerta("Dato guardado correctamente!", "bien2")
    },




    // Hacer una solicitud  api  para verificar y procesar transacion tarjeta carnet.
    validarcarnetReciboIngreso() {
      this.loading(true)
      //http://localhost:22105/api/Prueba
      // this.$axios.get(this.$hostname+this.$hName+'/monedas/findallActivos/',{headers:this.$store.getters.GetheadersAxios})
      // .then(res=>( this.Rmoneda=res.data))

      var num = ""
      num = (this.ReciboIngresoFactura.tarjeta.toFixed(2) + "").replace(".", "")

      var obj = {
        amount: num,
        tax: 0,
        otherTaxes: 0,
        invoiceId: 0,
        quantyOfPayments: 0,
        host: 0,
        referenceNumber: 0,
      }

      //var stobj='{"Status":"Successful","Host":{"Value":6,"Description":"Credit"},"Mode":{"Value":"C@5","Description":"Sale with CHIP(EMV)"},"Card":{"Product":"Mastercard","CardNumber":"534217******5024","HolderName":"SCOTIABANK/TARJETAHABIENTE"},"Transaction":{"AuthorizationNumber":"007656","Reference":2,"RetrievalReference":214611000062,"DataTime":"26/5/2022 11:04:40 a. m.","ApplicationIdentifier":"A0000000041010","LoyaltyDeferredNumber":null,"TID":null},"Batch":22,"TerminalID":"80029126","MerchantID":"349011300","Acquired":"CardNET","Reserved":null,"Signature":null}'

      this.$axios
        .post("http://localhost:22105/api/ProcessNormalSale", obj, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          this.loading(false)
          var e = JSON.parse(res.data)
          e.tipo = "Carnet"

          if (e.Status == "Successful") {
            this.ReciboIngresoFactura.numtar = e.Card.CardNumber
            this.ReciboIngreso.datoTarjeta = JSON.stringify(e)

            //   App.checkIn();
            this.alerta("Transacción finalizada correctamente", "bien2")
            var _this = this
            setTimeout(function() {
              _this.FinalizarSalvarReciboIngresoFacPen()
            }, 3000)
          }

          if (e.Status == "Failed") {
            this.alerta("Transacción cancelada", "error")
          }
        })
        .catch((error) => {
          this.alerta("Transacción cancelada", "error")
          this.loading(false)
        })

    },

    // Guardar un recibo en la base de datos.
    async FinalizarSalvarReciboIngresoFacPen() {

      var lccaja = JSON.parse(localStorage.caja)
      this.ReciboIngreso.formaPago = JSON.parse(
        JSON.stringify(this.ReciboIngresoFactura),
      )
      var ObjRow = this.RListFactpendiente.filter((e) => e.abono > 0)
      // console.log(new Date().getTime())
// ObjRow.forEach(element => {  });
      await Promise.all(ObjRow.map(async (element) => {
        if (element.facturasventa != null) {
          delete element.facturasventa["horaFactura"]
          /*  console.log(element.facturasventa.horaFactura.getTime())
            element.facturasventa.horaFactura=new Date(element.facturasventa.horaFactura)*/
        }
      }))


      this.ReciboIngreso.FactList = JSON.parse(JSON.stringify(ObjRow))
      this.FactPendienteSeleccionado = null
      //cajero:this.$store.getters.GetdatosInfUsu.usuario.nombre,
      //moneda: this.$store.getters.GetConfiguracionGeneral.config.monedabase.descripcion,
      var obj = {
        banco: null,
        caja: this.caja,
        cheque: this.ReciboIngreso.formaPago.cheque,
        cliente: this.clienteFactura,
        concepto: null,
        contabilidad: null,
        descuento: this.Totales.ReciboIngreso.descuento,
        documentocxc: lccaja.sucursal.documentorecibo,
        efectivo: this.ReciboIngreso.formaPago.efectivo,
        fecha: new Date(),
        moneda: this.Monedafactura,
        numeroTarjeta: this.ReciboIngreso.formaPago.numtar,
        numeroCheque: this.ReciboIngreso.formaPago.numeroCheque,
        bancoTipo: this.ReciboIngreso.formaPago.hasOwnProperty("bancoCheque") && this.ReciboIngreso.formaPago.bancoCheque != null ? this.ReciboIngreso.formaPago.bancoCheque.codigo : null,
        recibosdeingresoPK: { secuencia: 0 },
        recibosingresoDetalleList: ObjRow,
        referencia: null,
        tarjeta: this.ReciboIngreso.formaPago.tarjeta,
        tarjetaTipo: this.ReciboIngreso.formaPago.hasOwnProperty("tipoTarjeta") && this.ReciboIngreso.formaPago.tipoTarjeta != null ? this.ReciboIngreso.formaPago.tipoTarjeta.codigo : null,
        tasa: this.Monedafactura.tasa,
        tipoDescuento: 1,
        transferencia: this.ReciboIngreso.formaPago.transferencia,
        valor: this.Totales.ReciboIngreso.abono,
        vendedor: null,
        usuario: this.$store.getters.GetOtrasConfigPv.cajero,
        totalRetencion: this.Totales.ReciboIngreso.retencion,
        totalIsr: this.Totales.ReciboIngreso.isr,
        datoTarjeta: this.ReciboIngreso.datoTarjeta,
        vendedor: this.Facturasventa.vendedor,
      }


      var _this = this
      setTimeout(function() {


        if (_this.ejecucion == true) {
          _this.ejecucion = false
          _this.loading(true)

          _this.$axios
            .post(_this.$hostname + _this.$hName + "/reciboingreos/save", obj, {
              headers: _this.$store.getters.GetheadersAxios,
            })
            .then((res) => {

              _this.dialogReciboIngreso = false
              _this.alerta("Dato guardado correctamente", "bien")
              if (localStorage.printerSelect != null) {
              }
              var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
              var impresora = null
              if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
                impresora = JSON.parse(localStorage.printerSelect).nombre
              }
              var msg = {
                accion: "print",
                formato: _this.caja.formatoimpresioncontado.trim(),
                impresora: impresora,
                data: _this.configuraciones,
                ingreso: res.data,
                caja: lccaja,
                cajero: _this.$store.getters.GetOtrasConfigPv.cajero,
              }

              _this.imprimir(msg, "recibo")

            })
            .catch((error) => {
              _this.loading(true), _this.alerta(error, "error")
            })
        }
      }, 300)


    },

    //Agrega el abonado a la factura seleccionado
    async SalvarReciboIngresoSelctAbono() {
      //volviendo factura  abono=0
      if (this.FactPendienteSeleccionado.abono == 0) {
        this.Totales.ReciboIngreso.abono = 0
        if (this.FactPendienteSeleccionado.facturasventa != null) {
          this.FactPendienteSeleccionado.pendientedespues = JSON.parse(
            JSON.stringify(
              this.FactPendienteSeleccionado.facturasventa.pendiente,
            ),
          )
        }

        if (this.FactPendienteSeleccionado.notadebitoclientes != null) {
          this.FactPendienteSeleccionado.pendientedespues = JSON.parse(
            JSON.stringify(
              this.FactPendienteSeleccionado.notadebitoclientes.pendiente,
            ),
          )
        }

        // await this.RListFactpendiente.forEach((elet) => {});
        await Promise.all(this.RListFactpendiente.map(async (elet) => {
          if (elet.indx == this.FactPendienteSeleccionado.indx) {
            elet.abono = JSON.parse(
              JSON.stringify(this.FactPendienteSeleccionado.abono),
            )
            elet.pendientedespues = JSON.parse(
              JSON.stringify(this.FactPendienteSeleccionado.pendientedespues),
            )
          }

          this.Totales.ReciboIngreso.abono += this.RedondeoBasico(elet.abono)
        }))
      }

      //calculando abono=0
      if (this.FactPendienteSeleccionado.abono > 0) {
        this.Totales.ReciboIngreso.abono = 0

        if (this.FactPendienteSeleccionado.facturasventa != null) {
          var abono = JSON.parse(
            JSON.stringify(this.FactPendienteSeleccionado.abono),
          )
          var pendiente = JSON.parse(
            JSON.stringify(
              this.FactPendienteSeleccionado.facturasventa.pendiente,
            ),
          )
          this.FactPendienteSeleccionado.facturasventa.pendiente

          if (abono >= pendiente) {
            this.FactPendienteSeleccionado.abono = pendiente
            this.FactPendienteSeleccionado.pendientedespues = 0
          } else {
            this.FactPendienteSeleccionado.facturasventa.pendiente
            this.FactPendienteSeleccionado.pendientedespues = pendiente - abono
          }
        }

        if (this.FactPendienteSeleccionado.notadebitoclientes != null) {
          var abono = JSON.parse(
            JSON.stringify(this.FactPendienteSeleccionado.abono),
          )
          var pendiente = JSON.parse(
            JSON.stringify(
              this.FactPendienteSeleccionado.notadebitoclientes.pendiente,
            ),
          )
          this.FactPendienteSeleccionado.notadebitoclientes.pendiente

          if (abono >= pendiente) {
            this.FactPendienteSeleccionado.abono = pendiente
            this.FactPendienteSeleccionado.pendientedespues = 0
          } else {
            this.FactPendienteSeleccionado.notadebitoclientes.pendiente
            this.FactPendienteSeleccionado.pendientedespues = pendiente - abono
          }
        }

        //var list = JSON.parse(JSON.stringify(this.RListFactpendiente))

        //  await this.RListFactpendiente.forEach((elet) => {});
        await Promise.all(this.RListFactpendiente.map(async (elet) => {
          if (elet.indx == this.FactPendienteSeleccionado.indx) {
            elet.abono = JSON.parse(
              JSON.stringify(this.FactPendienteSeleccionado.abono),
            )
            elet.pendientedespues = JSON.parse(
              JSON.stringify(this.FactPendienteSeleccionado.pendientedespues),
            )
          }

          this.Totales.ReciboIngreso.abono += this.RedondeoBasico(elet.abono)
        }))
      }

      this.FactPendienteSeleccionado = null
    },

    // Cálculo de la cantidad de dinero que está siendo pagado por el cliente en el recibo de ingreso.
    async SalvarReciboIngresoSelctAbono1() {
      this.Totales.ReciboIngreso.abono = 0
      this.Totales.ReciboIngreso.descuento = 0
      this.Totales.ReciboIngreso.retencion = 0
      if (this.FactPendienteSeleccionado.facturasventa != null) {
        this.FactPendienteSeleccionado.pendientedespues = JSON.parse(
          JSON.stringify(this.FactPendienteSeleccionado.facturasventa.pendiente),
        )
      }

      if (this.FactPendienteSeleccionado.notadebitoclientes != null) {
        this.FactPendienteSeleccionado.pendientedespues = JSON.parse(
          JSON.stringify(
            this.FactPendienteSeleccionado.notadebitoclientes.pendiente,
          ),
        )
      }

      if (this.FactPendienteSeleccionado.abono == 0) {
        this.FactPendienteSeleccionado.descuento = 0
        this.FactPendienteSeleccionado.retencion = 0
        this.Totales.ReciboIngreso.abono = 0
        this.Totales.ReciboIngreso.descuento = 0
        this.Totales.ReciboIngreso.retencion = 0


        // await this.RListFactpendiente.forEach((elet) => {});
        await Promise.all(this.RListFactpendiente.map(async (elet) => {


          if (elet.indx == this.FactPendienteSeleccionado.indx) {
            elet.abono = JSON.parse(
              JSON.stringify(this.FactPendienteSeleccionado.abono),
            )
            elet.pendientedespues = JSON.parse(
              JSON.stringify(this.FactPendienteSeleccionado.pendientedespues),
            )
            elet.descuento = JSON.parse(
              JSON.stringify(this.FactPendienteSeleccionado.descuento))

            elet.retencion = JSON.parse(
              JSON.stringify(this.FactPendienteSeleccionado.retencion),
            )
          }
          //  Totales.ReciboIngreso.retencion;

          this.Totales.ReciboIngreso.abono += this.RedondeoBasico(elet.abono)
          this.Totales.ReciboIngreso.descuento += this.RedondeoBasico(elet.descuento)
          this.Totales.ReciboIngreso.retencion += this.RedondeoBasico(elet.retencion)
        }))
      }

      //calculando abono=0
      if (this.FactPendienteSeleccionado.abono > 0) {
        this.Totales.ReciboIngreso.abono = 0

        var abono = JSON.parse(JSON.stringify(this.FactPendienteSeleccionado.abono))
        var pendiente = this.RedondeoBasico(JSON.parse(JSON.stringify(this.FactPendienteSeleccionado.pendientedespues)))
        var descontado = 0
        var retencion = 0

        var VALOR_FACT = 0
        var DescValorPorc = this.FactPendienteSeleccionado.DescValorPorc

        if (this.FactPendienteSeleccionado.facturasventa != null) {
          VALOR_FACT = this.RedondeoBasico(this.FactPendienteSeleccionado.facturasventa.pendiente)
        }

        if (this.FactPendienteSeleccionado.notadebitoclientes != null) {
          VALOR_FACT = this.RedondeoBasico(this.FactPendienteSeleccionado.notadebitoclientes.pendiente)
        }


        if (this.FactPendienteSeleccionado.descuento != null) {
          /*  descontado = JSON.parse(
            JSON.stringify(this.FactPendienteSeleccionado.descuento)
          );*/
          if (DescValorPorc == false) {
            descontado = this.RedondeoBasico((VALOR_FACT * this.FactPendienteSeleccionado.descuento) / 100)
            if (descontado > this.FactPendienteSeleccionado.abono) {
              descontado = 0
            }
          } else {
            descontado = JSON.parse(JSON.stringify(this.FactPendienteSeleccionado.descuento))
            if (descontado > this.FactPendienteSeleccionado.abono) {
              descontado = VALOR_FACT - 1
            }
          }
        }
        if (this.FactPendienteSeleccionado.retencion != null) {
          retencion = JSON.parse(
            JSON.stringify(this.FactPendienteSeleccionado.retencion),
          )
        }

        if (abono >= pendiente) {
          this.FactPendienteSeleccionado.abono = this.RedondeoBasico(pendiente)
          this.FactPendienteSeleccionado.pendientedespues = 0
          if (retencion <= abono) {
            this.FactPendienteSeleccionado.abono -= retencion
          }
          if (descontado <= abono) {
            this.FactPendienteSeleccionado.abono -= descontado
          }
        } else {
          // this.FactPendienteSeleccionado.facturasventa.pendiente

          if (retencion >= abono) {
            this.FactPendienteSeleccionado.retencion = abono - 1
            retencion = abono - 1
          }

          if (descontado >= abono) {
            this.FactPendienteSeleccionado.descuento = abono - 1
            descontado = abono - 1
          }

          var SUMA_ABO_DESC = (this.FactPendienteSeleccionado.abono + descontado)
          if (SUMA_ABO_DESC > pendiente) {
            this.FactPendienteSeleccionado.abono -= descontado
          }

          var SUMA_ABO_RET = (this.FactPendienteSeleccionado.abono + retencion)
          if (SUMA_ABO_RET > pendiente) {
            this.FactPendienteSeleccionado.abono -= retencion
          }

          this.FactPendienteSeleccionado.pendientedespues = (pendiente - (abono + descontado + retencion))
          //this.FactPendienteSeleccionado.pendientedespues = pendiente - abono;
        }

        if (this.FactPendienteSeleccionado.abono == 0) {
          this.FactPendienteSeleccionado.descuento = 0
          this.FactPendienteSeleccionado.retencion = 0
        }

        //var list = JSON.parse(JSON.stringify(this.RListFactpendiente))
        // var VALOR_FACT=this.FactPendienteSeleccionado.facturasventa.cxc

        //  ojo aquii

        // this.RedondeoBasico(this.FactPendienteSeleccionado.facturasventa.pendiente)

        // await this.RListFactpendiente.forEach((elet) => {});
        await Promise.all(this.RListFactpendiente.map(async (elet) => {


          if (elet.indx == this.FactPendienteSeleccionado.indx) {
            elet.abono = JSON.parse(
              JSON.stringify(this.FactPendienteSeleccionado.abono),
            )
            elet.pendientedespues = JSON.parse(
              JSON.stringify(this.FactPendienteSeleccionado.pendientedespues),
            )


            if (DescValorPorc == false) {
              elet.descuento = this.RedondeoBasico((VALOR_FACT * this.FactPendienteSeleccionado.descuento) / 100)
              if (elet.descuento > elet.abono) {
                elet.descuento = 0
              }
            } else {
              elet.descuento = JSON.parse(JSON.stringify(this.FactPendienteSeleccionado.descuento))
              if (elet.descuento > elet.abono) {
                descontado = elet.descuento - 1
              }
            }

            elet.retencion = JSON.parse(
              JSON.stringify(this.FactPendienteSeleccionado.retencion),
            )
          }

          this.Totales.ReciboIngreso.abono += this.RedondeoBasico(elet.abono)
          this.Totales.ReciboIngreso.descuento += this.RedondeoBasico(elet.descuento)
          this.Totales.ReciboIngreso.retencion += this.RedondeoBasico(elet.retencion)
        }))
      }

      //this.ReciboIngreso.abono = JSON.parse(JSON.stringify(this.FactPendienteSeleccionado.abono))
      this.ReciboIngreso.abono = JSON.parse(JSON.stringify(this.Totales.ReciboIngreso.abono))
      this.FactPendienteSeleccionado = null
      this.calcularToTalRecIng()
    },

    // Cálculo de la cantidad de dinero que se le va aplicar a las facturas del cliente en la lista de recibos de ingreso
    async CalcularReciboIngreso1() {
      this.FactPendienteSeleccionado = null

      this.Totales.ReciboIngreso.abono = JSON.parse(
        JSON.stringify(this.ReciboIngreso.abono),
      )

      if (this.ObtemRListFactpendiente.length > 0) {
        this.Totales.ReciboIngreso.descuento = 0
        var list = JSON.parse(JSON.stringify(this.ObtemRListFactpendiente))
        var abonoTotal = this.ReciboIngreso.abono
        //var Lodescontado=JSON.parse(JSON.stringify(this.ReciboIngreso.descuento))

        var DESC_PORC = this.ReciboIngreso.descuento
        var totalDesc = 0
        var totalReten = 0
        var totalAbono = 0

        // await list.forEach((elent) => {
        await Promise.all(list.map(async (elent) => {
          //props.item.descuento
          // if(Lodescontado>0){ReciboIngreso.DescValorPorc}
          var DescProFact = 0
          var DESC_MAXPRO_REC = this.$store.getters.GetConfiguracionGeneral.configCxc.descuentoMaxProReciboingreso
          var ObjProRow = null
          if (elent.facturasventa != null) {
            ObjProRow = elent.facturasventa.facturasventaDetalleList.filter((ee) => ee.productos != null && ee.productos.descuento > 0)
            if (DESC_MAXPRO_REC == true && this.ReciboIngreso.descuento > 0) {
              await Promise.all(ObjProRow.map(async (eleObj) => {
                if (eleObj.productos.incluirimpuestoenprecio == true && eleObj.productos.impuesto != null) {
                  var pre = (eleObj.precio / (1 + (eleObj.productos.impuesto.tasa / 100)))
                  DescProFact += ((eleObj.productos.descuento * (pre * eleObj.cantidad)) / 100)

                } else {
                  DescProFact += ((eleObj.productos.descuento * (eleObj.precio * eleObj.cantidad)) / 100)
                }
              }))

              DescProFact = this.RedondeoValorCantRed(DescProFact, 4)
              //if(element.descuento>DescProFact){element.descuento=JSON.parse(JSON.stringify(DescProFact))}
            }
          }

          var Lodescontado = 0
          if (this.ReciboIngreso.descuento > 0) {
            if (this.ReciboIngreso.DescValorPorc == true) {
              if (this.ReciboIngreso.descuento >= this.ReciboIngreso.abono) {
                this.ReciboIngreso.descuento = JSON.parse(JSON.stringify(this.ReciboIngreso.abono - 1))
                //this.ReciboIngreso.descuento = 0;
                this.Totales.ReciboIngreso.descuento = JSON.parse(JSON.stringify(this.ReciboIngreso.descuento))
              }
              Lodescontado = JSON.parse(JSON.stringify(this.ReciboIngreso.descuento))
            } else {
              if (this.ReciboIngreso.descuento > 100) {
                this.ReciboIngreso.descuento = 100
              }
              Lodescontado = this.RedondeoBasico((elent.pendientedespues * this.ReciboIngreso.descuento) / 100)
              // this.Totales.ReciboIngreso.descuento =(this.ReciboIngreso.abono * this.ReciboIngreso.descuento) / 100;
            }
          }


          if (DESC_MAXPRO_REC == true && DescProFact > 0 && Lodescontado > DescProFact) {
            Lodescontado = JSON.parse(JSON.stringify(DescProFact))
          }

          if (ObjProRow != null && DESC_MAXPRO_REC == true && ObjProRow.length == 0) {
            Lodescontado = 0
          }

          if (abonoTotal >= elent.pendientedespues) {
            elent.abono = this.RedondeoBasico(elent.pendientedespues)
            abonoTotal -= this.RedondeoBasico(elent.pendientedespues)
            elent.pendientedespues = 0
            if (Lodescontado > elent.abono) {
              Lodescontado = 0
            }

            if (Lodescontado <= elent.abono) {

              elent.descuento = JSON.parse(JSON.stringify(Lodescontado))

              elent.abono -= elent.descuento
              abonoTotal += Lodescontado

            }
          } else {
            elent.abono = this.RedondeoBasico(abonoTotal)
            if (Lodescontado > elent.abono) {
              Lodescontado = 0
            }
            if (abonoTotal != 0) {
              abonoTotal += Lodescontado
              elent.descuento = JSON.parse(JSON.stringify(Lodescontado))
            }

            elent.pendientedespues -= this.RedondeoBasico(abonoTotal)
            abonoTotal = 0
          }

          // this.Totales.ReciboIngreso.descuento += elent.descuento;

          if (elent.abono == 0) {
            elent.descuento = 0
            elent.retencion = 0
          }

          if (elent.pendientedespues < 0) {
            elent.descuento = this.RedondeoBasico((elent.descuento + (elent.pendientedespues)))
            elent.pendientedespues = 0
          }

          totalDesc += elent.descuento
          totalReten += elent.retencion
          totalAbono += elent.abono

        }))
        // });


        this.Totales.ReciboIngreso.descuento = JSON.parse(JSON.stringify(totalDesc))
        this.Totales.ReciboIngreso.retencion = JSON.parse(JSON.stringify(totalReten))
        this.RListFactpendiente = JSON.parse(JSON.stringify(list))
        this.ReciboIngreso.abono = JSON.parse(JSON.stringify(totalAbono))
        this.Totales.ReciboIngreso.abono = JSON.parse(JSON.stringify(totalAbono))
        this.calcularToTalRecIng()
        // RListFactpendiente
      }
    },


// Cálculo de la cantidad de dinero que se le va aplicar a las facturas del cliente en la lista de recibos de ingreso
    async CalcularReciboIngreso11() {
      // NOTA: este metodo es el anterior al CalcularReciboIngreso1 (se cambio por que el descuento se le resta a lo pendiente,
// y cuando no se salda el pendiente completo el balance da en negativo).
      this.FactPendienteSeleccionado = null

      this.Totales.ReciboIngreso.abono = JSON.parse(
        JSON.stringify(this.ReciboIngreso.abono),
      )

      if (this.ObtemRListFactpendiente.length > 0) {
        this.Totales.ReciboIngreso.descuento = 0
        var list = JSON.parse(JSON.stringify(this.ObtemRListFactpendiente))
        var abonoTotal = this.ReciboIngreso.abono
        //var Lodescontado=JSON.parse(JSON.stringify(this.ReciboIngreso.descuento))
        var totalDesc = 0
        var totalReten = 0


        // await list.forEach((elent) => { });
        await Promise.all(list.map(async (elent) => {
          //props.item.descuento
          // if(Lodescontado>0){ReciboIngreso.DescValorPorc}
          var Lodescontado = 0

          if (this.ReciboIngreso.descuento > 0) {
            if (this.ReciboIngreso.DescValorPorc == true) {
              if (this.ReciboIngreso.descuento >= this.ReciboIngreso.abono) {
                this.ReciboIngreso.descuento = JSON.parse(
                  JSON.stringify(this.ReciboIngreso.abono - 1),
                )
                this.Totales.ReciboIngreso.descuento = JSON.parse(
                  JSON.stringify(this.ReciboIngreso.descuento),
                )
              }
              Lodescontado = JSON.parse(JSON.stringify(this.ReciboIngreso.descuento))
            } else {
              if (this.ReciboIngreso.descuento > 100) {
                this.ReciboIngreso.descuento = 100
              }
              Lodescontado =
                (this.ReciboIngreso.abono * this.ReciboIngreso.descuento) / 100
              this.Totales.ReciboIngreso.descuento =
                (this.ReciboIngreso.abono * this.ReciboIngreso.descuento) / 100
            }
          }
          if (abonoTotal >= elent.pendientedespues) {
            elent.abono = this.RedondeoBasico(elent.pendientedespues)
            abonoTotal -= elent.pendientedespues
            elent.pendientedespues = 0

            if (Lodescontado <= elent.abono) {
              elent.descuento = JSON.parse(JSON.stringify(Lodescontado))
              elent.abono -= elent.descuento
              abonoTotal += Lodescontado
            }
          } else {
            elent.abono = this.RedondeoBasico(abonoTotal)

            if (abonoTotal != 0) {
              abonoTotal += Lodescontado
              elent.descuento = JSON.parse(JSON.stringify(Lodescontado))
            }

            elent.pendientedespues -= abonoTotal
            abonoTotal = 0
          }

          // this.Totales.ReciboIngreso.descuento += elent.descuento;

          if (elent.abono == 0) {
            elent.descuento = 0
            elent.retencion = 0
          }
          totalDesc += elent.descuento
          totalReten += elent.retencion


        }))
        this.Totales.ReciboIngreso.descuento = JSON.parse(JSON.stringify(totalDesc))
        this.Totales.ReciboIngreso.retencion = JSON.parse(JSON.stringify(totalReten))
        this.RListFactpendiente = JSON.parse(JSON.stringify(list))
        this.calcularToTalRecIng()
        // RListFactpendiente
      }
    },

    async CalcularReciboIngreso() {
      var Lodescontado = 0
      var LoRetenido = 0
      var LoRetenidoIsr = 0
      this.Totales.ReciboIngreso.abono = JSON.parse(
        JSON.stringify(this.ReciboIngreso.abono),
      )
      if (this.ReciboIngreso.abono > 0) {
        if (this.ReciboIngreso.DescValorPorc == true) {
          if (this.ReciboIngreso.descuento >= this.ReciboIngreso.abono) {
            this.ReciboIngreso.descuento = JSON.parse(
              JSON.stringify(this.ReciboIngreso.abono - 1),
            )
            this.Totales.ReciboIngreso.descuento = JSON.parse(
              JSON.stringify(this.ReciboIngreso.descuento),
            )
          }
          Lodescontado = JSON.parse(
            JSON.stringify(this.ReciboIngreso.descuento),
          )
        } else {
          if (this.ReciboIngreso.descuento > 100) {
            this.ReciboIngreso.descuento = 100
          }
          Lodescontado =
            (this.ReciboIngreso.abono * this.ReciboIngreso.descuento) / 100
          this.Totales.ReciboIngreso.descuento =
            (this.ReciboIngreso.abono * this.ReciboIngreso.descuento) / 100
        }
        if (this.ReciboIngreso.retenValorPorc == true) {
          if (this.ReciboIngreso.retencion >= this.ReciboIngreso.abono) {
            this.ReciboIngreso.retencion = JSON.parse(
              JSON.stringify(this.ReciboIngreso.abono - 1),
            )
            this.Totales.ReciboIngreso.retencion = JSON.parse(
              JSON.stringify(this.ReciboIngreso.retencion),
            )
          }
          LoRetenido = JSON.parse(JSON.stringify(this.ReciboIngreso.retencion))
        } else {
          if (this.ReciboIngreso.retencion > 100) {
            ReciboIngreso.retencion = 100
          }
          LoRetenido =
            (this.ReciboIngreso.abono * this.ReciboIngreso.retencion) / 100
          this.Totales.ReciboIngreso.retencion =
            (this.ReciboIngreso.abono * this.ReciboIngreso.retencion) / 100
        }
        if (this.ReciboIngreso.isrValorPorc == true) {
          if (this.ReciboIngreso.isr >= this.ReciboIngreso.abono) {
            this.ReciboIngreso.isr = JSON.parse(
              JSON.stringify(this.ReciboIngreso.abono - 1),
            )
            this.Totales.ReciboIngreso.isr = JSON.parse(
              JSON.stringify(this.ReciboIngreso.isr),
            )
          }
          LoRetenidoIsr = JSON.parse(JSON.stringify(this.ReciboIngreso.isr))
        } else {
          if (this.ReciboIngreso.isr > 100) {
            ReciboIngreso.isr = 100
          }
          LoRetenidoIsr =
            (this.ReciboIngreso.abono * this.ReciboIngreso.isr) / 100
          this.Totales.ReciboIngreso.isr =
            (this.ReciboIngreso.abono * this.ReciboIngreso.isr) / 100
        }
        if (this.RListFactpendiente.length > 0) {
          this.RListFactpendiente = JSON.parse(JSON.stringify(this.objTemp))
          if (this.ReciboIngreso.abono > 0) {
            var LoAbono = JSON.parse(JSON.stringify(this.ReciboIngreso.abono))

            // this.RListFactpendiente.forEach((el) => { });
            await Promise.all(this.RListFactpendiente.map(async (el) => {


              if (LoAbono > 0 && LoAbono < this.RedondeoBasico(el.pendiente)) {
                var sumaloabono = LoRetenido + LoRetenidoIsr + Lodescontado
                var re = sumaloabono - LoAbono + 1
                if (sumaloabono >= LoAbono) {
                  if (Lodescontado > 0) {
                    if (Lodescontado > re) {
                      (el.descuento = this.RedondeoBasico(Lodescontado - re)),
                        (re = 0),
                        (sumaloabono = sumaloabono - re)
                    } else {
                      (el.descuento = 0),
                        (re = re - Lodescontado),
                        (sumaloabono = sumaloabono - re)
                    }
                  }
                } else {
                  el.descuento = Lodescontado
                }
                if (sumaloabono >= LoAbono) {
                  if (LoRetenido > 0) {
                    if (LoRetenido > re) {
                      (el.descuento = this.RedondeoBasico(LoRetenido - re)),
                        (re = 0),
                        (sumaloabono = sumaloabono - re)
                    } else {
                      (el.descuento = 0),
                        (re = re - LoRetenido),
                        (sumaloabono = sumaloabono - re)
                    }
                  }
                } else {
                  el.retencion = LoRetenido
                }
                if (sumaloabono >= LoAbono) {
                  if (LoRetenidoIsr > 0) {
                    if (LoRetenidoIsr > re) {
                      (el.descuento = this.RedondeoBasico(LoRetenidoIsr - re)),
                        (re = 0),
                        (sumaloabono = sumaloabono - re)
                    } else {
                      (el.descuento = 0),
                        (re = re - LoRetenidoIsr),
                        (sumaloabono = sumaloabono - re)
                    }
                  }
                } else {
                  el.isr = LoRetenidoIsr
                }
                el.pendiente = this.RedondeoBasico(el.pendiente - LoAbono)
                el.abono = this.RedondeoBasico(
                  LoAbono - el.descuento - el.retencion - el.isr,
                )
                LoAbono = 0
                return 0
              }
              if (LoAbono > 0 && LoAbono >= this.RedondeoBasico(el.pendiente)) {
                el.abono = JSON.parse(
                  JSON.stringify(this.RedondeoBasico(el.pendiente)),
                )
                var sumaloabono = LoRetenido + LoRetenidoIsr + Lodescontado
                var re = sumaloabono - LoAbono + 1
                if (sumaloabono >= LoAbono) {
                  if (Lodescontado > 0) {
                    if (Lodescontado > re) {
                      (el.descuento = this.RedondeoBasico(Lodescontado - re)),
                        (re = 0),
                        (sumaloabono = sumaloabono - re)
                    } else {
                      (el.descuento = 0),
                        (re = re - Lodescontado),
                        (sumaloabono = sumaloabono - re)
                    }
                  }
                } else {
                  el.descuento = Lodescontado
                }
                if (sumaloabono >= LoAbono) {
                  if (LoRetenido > 0) {
                    if (LoRetenido > re) {
                      (el.descuento = this.RedondeoBasico(LoRetenido - re)),
                        (re = 0),
                        (sumaloabono = sumaloabono - re)
                    } else {
                      (el.descuento = 0),
                        (re = re - LoRetenido),
                        (sumaloabono = sumaloabono - re)
                    }
                  }
                } else {
                  el.retencion = LoRetenido
                }

                if (sumaloabono >= LoAbono) {
                  if (LoRetenidoIsr > 0) {
                    if (LoRetenidoIsr > re) {
                      (el.descuento = this.RedondeoBasico(LoRetenidoIsr - re)),
                        (re = 0),
                        (sumaloabono = sumaloabono - re)
                    } else {
                      (el.descuento = 0),
                        (re = re - LoRetenidoIsr),
                        (sumaloabono = sumaloabono - re)
                    }
                  }
                } else {
                  el.isr = LoRetenidoIsr
                }

                // el.descuento=Lodescontado, el.retencion=LoRetenido, el.isr=LoRetenidoIsr
                el.pendiente = 0

                if (el.abono > el.descuento) {
                  el.descuento = el.descuento
                  el.abono = this.RedondeoBasico(el.abono - el.descuento)
                  LoAbono = LoAbono + el.descuento
                } else {
                  el.descuento = 0
                }

                if (el.abono > el.retencion) {
                  el.retencion = el.retencion
                  el.abono = this.RedondeoBasico(el.abono - el.retencion)
                  LoAbono = LoAbono + el.retencion
                } else {
                  el.retencion = 0
                }

                if (el.abono > el.retencion) {
                  el.isr = el.isr
                  el.abono = this.RedondeoBasico(el.abono - el.isr)
                  LoAbono = LoAbono + el.isr
                } else {
                  el.isr = 0
                }

                LoAbono = LoAbono - el.abono
                //LoAbono =((LoAbono-el.pendiente)+el.abono+el.descuento+el.retencion+el.isr)
                return 0
              }
            }))//aqui
          }
        }

        // @input="CalcularReciboIngreso()"
        // Totales:{
        //   ReciboIngreso:{
        //   abono:0,
        //   retencion:0,
        //   descuento:0,
        // }
        // ReciboIngreso:{
        //   precio:0,
        //   abono:0,
        //   retencion:0,
        //   descuento:0,
        //   DescValorPorc:true,
        //   retenValorPorc:true
        // }
      }
    },

    SelctCbTipoTarjetaReciboFacturaFormPag() {
      if (this.ReciboIngresoFactura.tipoTarjeta == null) {
        this.ReciboIngresoFactura.tipoTarjeta = ""
      }

      if (this.ReciboIngresoFactura.tipoTarjeta.codigo == undefined) {
        this.alerta("Seleccione un Tipo de tarjeta", "error")
        this.ReciboIngresoFactura.tipoTarjeta = ""
        return
      }
    },

    SelctCbBancoReciboFacturaFormPag() {
      if (this.ReciboIngresoFactura.bancoCheque == null) {
        this.ReciboIngresoFactura.bancoCheque = ""
      }

      if (this.ReciboIngresoFactura.bancoCheque.codigo == undefined) {
        this.alerta("Seleccione un banco", "error")
        this.ReciboIngresoFactura.bancoCheque = ""
        return
      }
    },

    OpenPanelReciboFormaPago(e) {
      this.NombrePanelReciboFormaPago = e
      this.PanelReciboFormaPago = true
      if (e == "Tarjeta") {
        this.cargarTipoTarjeta()
      }
    },

    // Hacer una llamada API al servidor y obtener los datos.
    CargarBusquedaRecetas() {
      this.Recetaslist = []
      var paciente = "null"
      if (this.RecetaBusqueda.paciente !== "") {
        paciente = this.RecetaBusqueda.paciente
      }

      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/receta/find/" +
          this.RecetaBusqueda.receta +
          "/" +
          this.RecetaBusqueda.fechaInicial +
          "/" +
          this.RecetaBusqueda.fechaFinal +
          "/" +
          paciente +
          "/15/0",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.Recetaslist = res.data.listas
          this.TotalRegistros = res.data.cantidad
        })
    },
    RecetaObtenerDatoSelect(e) {
      this.RecetaDatostabla(e.item)
    },
    findReceta(e) {
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/receta/find/" +
          this.RecetaProdControlado.numero,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          if (res.data.toString().length == 0) {
            this.disableNumeroReceta = false
            return
          }
          this.disableNumeroReceta = true
          //if(){}
          if (res.data.cliente.codigo != this.RecetaProdControlado.cliente.codigo) {
            this.alerta("El cliente no es el mismo que tiene la receta. revise el número de receta.", "error")
            return
          }
          this.RecetaProdControlado = res.data
          // this.RecetaProdControlado.fecha = new Date(res.data.fecha).toISOString().substr(0, 10)
          this.RecetaProdControlado.fecha = res.data.nuevaFecha
          this.RecetaProdControlado.detalleList = []
          res.data.recetaDetalleList.forEach(e => {
            var det = {
              productos: e.producto,
              unidad: e.unidad,
              cantidadRecetada: e.cantidadRecetada,
              cantidadDespachada: e.cantidadDespachada,
            }
            this.RecetaProdControlado.detalleList.push(det)
          })


        })
    },
    // Tomando los datos de la tabla y colocándolos en un cuadro de diálogo.
    RecetaDatostabla(e) {
      this.$axios.get(this.$hostname + this.$hName + "/receta/findfacturareceta/" + e.numero, { headers: this.$store.getters.GetheadersAxios })
        .then(res => {


          var FACTURAS = ""
          var bar = new Promise((resolve, reject) => {
            res.data.forEach((element, index, array) => {

              if (FACTURAS.length > 0) {
                FACTURAS += ", "
              }
              FACTURAS += `${element.facturasventaPK.secuencia}`
              // facturasventaPK.secuencia:53327
            })
            resolve()

          })

          bar.then(() => {
            this.RecetaSelected = []
            this.RecetaSeleccionado = null
            this.RecetaSelected.push(JSON.parse(JSON.stringify(e)))
            this.RecetaSeleccionado = JSON.parse(JSON.stringify(e))
            this.RecetaSeleccionado.faturas = FACTURAS
            this.dialogVerRecetaCompleta = true

          })


        })


    },
    // Un método que se llama cuando se cambia el paginador.
    RecetaCargarPaginacion(e) {
      this.RecetaSelected = []
      this.RecetaPaginator = e
      if (this.RecetaPaginator.itemsPerPage == -1) {
        this.RecetaPaginator.itemsPerPage = 15
      }
    },
    // Cerrando el cuadro de diálogo.
    CerrarVerRecetaCompleta() {
      this.RecetaSelected = []
      this.RecetaSeleccionado = null
      this.dialogVerRecetaCompleta = false
      this.recetaFacturaList = []
    },
    // Hacer una solicitud HTTP a un servidor y obtener una respuesta de recetas.
    RecetaProdctoDatostabla(e) {
      this.recetaFacturaList = []
      //http://10.0.0.95:8080/micromarket/services/recetas/receta/2151/9253/482

      // this.$axios.get(this.$hostname+this.$hName+'/services/cliente-c/+'+this.clienteFactura.codigo+'/facturas-pendientes',{headers:this.$store.getters.GetheadersAxios})
      // .then(res=>{
      //   this.recetaFacturaList=res.data
      // })

      //http://10.0.0.95:8080/micromarket/services/recetas/receta/2151/9253/482 []

      // 0: 1
      // 1: "Fco"
      // 2: "2021-08-19"
      // 3: 199725

      // 1, 'Fco', '2021-08-19', 199725

      this.recetaFacturaList = []
      //+'/'+e.producto.codigo+'/'+e.unidad.codigo+''
      this.$axios.get(this.$hostname + this.$hName + "/receta/findReceta/" + this.RecetaSeleccionado.numero, { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.recetaFacturaList = res.data
        })
    },

    ejecutarBuscarRestaurarFacturasFrecuencia() {
      var INTERVALO = ((this.$store.getters.GetConfiguracionGeneral.configPv.tiempoActualizarFacturaTemporal) * 1000)
      this.$store.getters.GetConfiguracionGeneral.configPv.tiempoActualizarFacturaTemporal
      var _this = this
      this.setIntervalBuscarRestaurar = setInterval(function() {
        _this.BuscarRestaurarFacturas()
      }, INTERVALO)

    },

    canselarBuscarRestaurarFacturasFrecuencia() {
      clearInterval(this.setIntervalBuscarRestaurar)
      this.setIntervalBuscarRestaurar = null
      this.ejecutarAplRestFact = true
      this.dialogRestaurarFactura = false
      this.ObjEjecPermisoPv = null
    },

    NotfFactRestaurarInterval() {
      //var _this=this;
      //this.setIntervalNotfFactRestaurar=setInterval(function(){ _this.ejecutarNotfFactRestaurar() }, 10000);

    },

    canselarFactRestaurarInterval() {
      clearInterval(this.setIntervalNotfFactRestaurar)
      this.setIntervalNotfFactRestaurar = null
    },

    ejecutarNotfFactRestaurar() {
      //this.RestaurarFacturaBusqueda.sucursal.codigo


      /*if(this.dialogRestaurarFactura==false && this.RestaurarFacturaBusqueda.sucursal!=null && this.RestaurarFacturaBusqueda.sucursal.hasOwnProperty('codigo') ){

var _this = this;
      this.$axios
        .get(this.$hostname + this.$hName + "/temporales/todas/" + this.RestaurarFacturaBusqueda.sucursal.codigo, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          setTimeout(function () {
            _this.$refs.RefPvMenuOpcionBotones.notfFacTem=res.data.length;
           // _this.RestaurarFactlistFact = JSON.parse(JSON.stringify(res.data));
          }, 600);
        })
        .catch((error) =>{
          this.$refs.RefPvMenuOpcionBotones.notfFacTem=0;
        });
      }*/

    },

    // Hacer una solicitud GET al servidor y devolver una lista de objetos de facturas temporales.
    BuscarRestaurarFacturas(e) {
      if (typeof e === "object" && e != null) {

        if (e.keyCode == 38 || e.keyCode == 40 || e.keyCode == 37 || e.keyCode == 39) {
          return
        }
        /* console.log(e.hasOwnProperty('keyCode'))
        if(e.hasOwnProperty('keyCode')){
          console.log('keyCode--')
          console.log(e.keyCode === 40)
          if(e.keyCode == 38){return}
          if(e.keyCode == 40){return}
          if(e.keyCode == 37){return}
          if(e.keyCode == 39){return}
        }*/
        //&&

      }

      if (this.$store.getters.GetConfiguracionGeneral.configPv.modalidadRutaVendedor == true && this.Facturasventa.vendedor != null && this.Facturasventa.vendedor.hasOwnProperty("codigo")) {
        this.RestaurarFactlistFact = []
        this.selectFactTem = null
        this.TbPaginatorFactTem.pageCount = 0
        this.TbPaginatorFactTem.pageStart = 0
        var _this = this
        this.$axios
          .get(this.$hostname + this.$hName + "/temporales/todas/" + this.RestaurarFacturaBusqueda.sucursal.codigo + "/" + this.Facturasventa.vendedor.codigo, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            setTimeout(function() {
              _this.RestaurarFactlistFact = JSON.parse(JSON.stringify(res.data))
            }, 600)
          })
          .catch((error) => {
            this.loading(false)
          })

      } else {

        this.RestaurarFactlistFact = []
        this.selectFactTem = null
        this.TbPaginatorFactTem.pageCount = 0
        this.TbPaginatorFactTem.pageStart = 0
        var _this = this
        this.$axios
          .get(this.$hostname + this.$hName + "/temporales/todas/" + this.RestaurarFacturaBusqueda.sucursal.codigo, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            setTimeout(function() {
              _this.RestaurarFactlistFact = JSON.parse(JSON.stringify(res.data))
            }, 600)
          })
          .catch((error) => {
            this.loading(false)
          })
      }
    },

    // Devolver una cadena basada en el valor del objeto.
    TipoRestaurarFactura(e) {
      var data = ""

      if (e.ars != null && e.hasOwnProperty("cobertura") && e.cobertura != null && e.cobertura > 0) {
        return data = " Sequro "
      }

      if (e.telefonoDomicilio != null) {
        return data = " Domicilio "
      }

      if (e.cxc != null && e.cxc > 0) {
        return data = " Cuenta por cobrar "
      }

      if (e.tarjeta != null && e.tarjeta > 0) {
        return data = " Tarjeta "
      }

      if (e.efectivo != null && e.efectivo > 0) {
        return data = " Efectivo "
      }
      return data
    },
    RestaurarFacturaDatostabla() {
    },

    RestaurarFacturaTelefono(e) {
      if (e.cliente != null) {
        return this.selectTelefonoCliente(e.cliente)
      } else {
        return " "
      }

    },

    GetColorRestaurarFact(e) {
      if (e.hasOwnProperty("reimprimida") && e.reimprimida != null && e.reimprimida == true) {
        return "#66BB6A"
      } else {
        if (e.hasOwnProperty("cobertura") && e.cobertura != null && e.cobertura > 0) {
          return "#CE93D8"
        } else {
          if (e.hasOwnProperty("telefonoDomicilio") && e.telefonoDomicilio != null && e.telefonoDomicilio.trim().length > 0) {
            return "#FFD180"
          } else {
            return "transparent"
          }
        }


      }

      /* #81C784 */
      //

      // return "RowSelectColorPvGreen black--text ";
    },

    getBorderColorSelectFactTem(e) {


      var FACTTEMSELEC = this.selectFactTem
      /*console.log('FACTTEMSELEC')
      console.log(FACTTEMSELEC)

      console.log('--e--')
      console.log(e)*/

      if (e != null) {


        if (FACTTEMSELEC != null && FACTTEMSELEC.hasOwnProperty("indx") && FACTTEMSELEC.indx == e.indx && FACTTEMSELEC.secuencia == e.secuencia) {
          // return '#FF9800'
          return "3px dashed #dd4b39"
        } else {
          return "3px dashed transparent"
        }
      } else {
        return "3px dashed transparent"
      }
    },

    cargarPaginacionAllFactTem(e) {
      this.TbPaginatorFactTem = JSON.parse(JSON.stringify(e))
    },

    SelectMarcaFactTemp(e) {
      //ArrowRight:39
      if (e.keyCode == 39) {
        if (this.RestaurarFactlistFact.length != 0) {
          if (this.TbPaginatorFactTem.pageStop != this.RestaurarFactlistFact.length) {

            if (this.TbPaginatorFactTem.pageCount == 0 || this.TbPaginatorFactTem.page < this.TbPaginatorFactTem.pageCount) {
              this.TbPaginatorFactTem.page = (this.TbPaginatorFactTem.page + 1)
            } else {
              this.TbPaginatorFactTem.page = this.TbPaginatorFactTem.pageCount
            }


            var _this = this
            setTimeout(function() {
              var list = JSON.parse(JSON.stringify(_this.RestaurarFactlistFact.filter((ee) => ee.hasOwnProperty("indx") && ee.indx != null)))
              if (_this.RestaurarFacturaBusqueda.buscar.length > 0) {
                _this.selectFactTem = list[_this.TbPaginatorFactTem.pageStart]
              } else {
                _this.selectFactTem = JSON.parse(JSON.stringify(_this.RestaurarFactlistFact[_this.TbPaginatorFactTem.pageStart]))
              }
            }, 500)
            return 0

          }
        }
      }

      //ArrowLeft:37
      if (e.keyCode == 37) {
        if (this.RestaurarFactlistFact.length != 0) {
          if (this.TbPaginatorFactTem.pageStart > 0) {
            this.TbPaginatorFactTem.page = (this.TbPaginatorFactTem.page - 1)
            var _this = this
            setTimeout(function() {
              var list = JSON.parse(JSON.stringify(_this.RestaurarFactlistFact.filter((ee) => ee.hasOwnProperty("indx") && ee.indx != null)))
              if (_this.RestaurarFacturaBusqueda.buscar.length > 0) {
                _this.selectFactTem = list[_this.TbPaginatorFactTem.pageStart]
              } else {
                _this.selectFactTem = JSON.parse(JSON.stringify(_this.RestaurarFactlistFact[_this.TbPaginatorFactTem.pageStart]))
              }
            }, 500)
            return 0
          }
        }
      }

      // ArrowUp/ArrowDown
      if (e.keyCode == 38 || e.keyCode == 40) {
        if (this.selectFactTem == null && this.RestaurarFactlistFact.length != 0) {
          var list = JSON.parse(JSON.stringify(this.RestaurarFactlistFact.filter((ee) => ee.hasOwnProperty("indx") && ee.indx != null)))
          this.selectFactTem = JSON.parse(JSON.stringify(this.RestaurarFactlistFact[list[0].indx]))
          return 0
        }
      }

      if (this.selectFactTem != null) {

        //key: "Enter
        if (e.keyCode == 13) {

          var OBJ = JSON.parse(JSON.stringify(this.selectFactTem))
          this.selectFactTem = null
          this.verificarusofacturatemporalAplicar(OBJ)
          //this.addClikProd(this.selectProducto)
        }

        //key: "ArrowUp"keyCode: 38
        if (e.keyCode == 38) {
          // var VarInddx = JSON.parse(JSON.stringify(this.selectFactTem.indx - 1));
          //var VarInddx = JSON.parse(JSON.stringify(this.selectFactTem.indx + 1));
          var BASEVarInddx = JSON.parse(JSON.stringify(this.selectFactTem.indx))
          //cuando se filtra bucando index
          var list = JSON.parse(JSON.stringify(this.RestaurarFactlistFact.filter((ee) => ee.hasOwnProperty("indx") && ee.indx != null)))
          var NEWINND = list.filter((ee) => ee.hasOwnProperty("indx") && ee.indx != null && ee.indx < BASEVarInddx)
          var INND = 0
          if (NEWINND.length > 0) {
            INND = NEWINND[NEWINND.length - 1].indx
          } else {
            INND = this.selectFactTem.indx
          }
          var VarInddx = INND
          if (this.RestaurarFactlistFact[VarInddx] != undefined) {
            this.selectFactTem = JSON.parse(JSON.stringify(this.RestaurarFactlistFact[VarInddx]))
          } else {
            this.selectFactTem = JSON.parse(
              JSON.stringify(this.RestaurarFactlistFact[VarInddx + 1]),
            )
          }

          return 0
        }

//key: "ArrowDown"keyCode: 40
        if (e.keyCode == 40) {

          //var VarInddx = JSON.parse(JSON.stringify(this.selectFactTem.indx + 1));
          var BASEVarInddx = JSON.parse(JSON.stringify(this.selectFactTem.indx))
          //cuando se filtra bucando index
          var list = JSON.parse(JSON.stringify(this.RestaurarFactlistFact.filter((ee) => ee.hasOwnProperty("indx") && ee.indx != null)))
          var NEWINND = list.filter((ee) => ee.hasOwnProperty("indx") && ee.indx != null && ee.indx > BASEVarInddx)
          var INND = 0
          if (NEWINND.length > 0) {
            INND = NEWINND[0].indx
          } else {
            INND = this.selectFactTem.indx
          }
          var VarInddx = INND
          if (this.RestaurarFactlistFact[VarInddx] != undefined) {
            this.selectFactTem = JSON.parse(JSON.stringify(this.RestaurarFactlistFact[VarInddx]))

          } else {
            this.selectFactTem = JSON.parse(
              JSON.stringify(this.RestaurarFactlistFact[VarInddx - 1]),
            )
          }
          return 0
        }

      }

    },


    verificarusofacturatemporalAplicar(e) {
      this.RestaurarFacturaBusqueda.buscar = ""
      // this.AplicarRestaurarFact(res.data.Facturastemporales)
// var _this=this;
// setTimeout(function(){ }, 300);

// verifOrUpdate:true: verifica , verifOrUpdate:false: resetea a uso false


      var permitirAbrirFacTEM = this.$store.getters.GetConfiguracionGeneral.configPv.permitirAbrirFacTempLugaresDiferente

      if (permitirAbrirFacTEM == true) {
        if (this.ejecutarAplRestFact == true) {
          this.ejecutarAplRestFact = false
          this.AplicarRestaurarFact(e)
        }
      } else {
        var objFacTem = {
          secuencia: e.secuencia,
          verifOrUpdate: true,
        }


        this.$axios
          .post(this.$hostname + this.$hName + "/temporales/verifOrUpdateusofacturatemporal/", objFacTem, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            if (res.data.enUso == true) {
              //this.alerta("Esta factura temporal está en uso,no puede modificarla.", "error")
              this.objTemp = JSON.parse(JSON.stringify(e))
              var infData = `ESTA FACTURA ESTA SIENDO USADA POR OTRO USUARIO.\n ¿DESEA ABRIRLA?`
              this.ejecNotifMessage("factTemporalEnUso", infData)
            } else {
              //this.AplicarRestaurarFact(res.data.Facturastemporales)
              if (this.ejecutarAplRestFact == true) {
                if (this.deleteFacturaTemporal != null) {
                  this.updateFactTemEnUso(this.deleteFacturaTemporal)
                }
                var _this = this
                setTimeout(function() {
                  _this.ejecutarAplRestFact = false
                  _this.AplicarRestaurarFact(e)
                }, 400)

              }
            }
            // this.BuscarRestaurarFacturas();
          })
          .catch((error) => {
            console.log("No verificacion.", "error")
          })

      }


      /* if (this.EjecutarPermisoPv == false) {
        this.ObjEjecPermisoPv = JSON.parse(JSON.stringify(e))
        this.funcionValidaPermisoPv('AccAplicarRestaurarFact')
        return;
      }
      this.loading(true)

      this.$axios
        .post(this.$hostname + this.$hName + "/temporales/verificarusofacturatemporal/", e, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
         console.log('--vIENDO iNFOMACION')
         console.log(res.data)
          if(res.data.enUso==true){
            this.alerta("Esta factura temporal está en uso", "error")
          }else{
            this.AplicarRestaurarFact(res.data.Facturastemporales)
            this.canselarBuscarRestaurarFacturasFrecuencia()
          }
          // this.BuscarRestaurarFacturas();
        })
        .catch((error) =>
          console.log("Dato no conectado.", "error")
        );
*/


    },


    contNotifiMensagefactTemporalEnUso() {

      console.log("viendoDeleteFact-->", this.deleteFacturaTemporal)
      console.log("viendothis.objTemp-->", this.objTemp)

      var objTemp = JSON.parse(JSON.stringify(this.objTemp))
      if (this.ejecutarAplRestFact == true) {
        if (this.deleteFacturaTemporal != null) {
          this.updateFactTemEnUso(this.deleteFacturaTemporal)
        }
        var _this = this
        setTimeout(function() {
          _this.ejecutarAplRestFact = false
          _this.AplicarRestaurarFact(objTemp)
        }, 400)
      }


      /*var objFacTem={
    secuencia:this.objTemp.secuencia,
    verifOrUpdate:true
  }

this.$axios
        .post(this.$hostname + this.$hName + "/temporales/verifOrUpdateusofacturatemporal/", objFacTem, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
         var objTemp = JSON.parse(JSON.stringify(this.objTemp))
            if(this.ejecutarAplRestFact==true){
                  if(this.deleteFacturaTemporal!=null){
                  this.updateFactTemEnUso(this.deleteFacturaTemporal)
                  }
               var _this=this;
               setTimeout(function(){
                  _this.ejecutarAplRestFact=false
                  _this.AplicarRestaurarFact(objTemp)
               }, 400);
              }
        })
        .catch((error) =>
          console.log("Dato no conectado.", "error")
        );
*/


    },


    async AplicarRestaurarFact(e) {
      if (this.restaurandoFacturaTemporal == true) {
        return
      }
      this.restaurandoFacturaTemporal = true
      this.limpiarPuntoVentaCompleto()
      this.loading(true)
      await this.$nextTick()
      this.ContAplicarRestaurarFact(e)
    },

    // Una función que se llama cuando se hace clic en un botón y carga el objecto factura temporal
    //y asignando los valores de la factura.
    async ContAplicarRestaurarFact(e) {
      this.dialogRestaurarFactura = false
      this.canselarBuscarRestaurarFacturasFrecuencia()
      this.clienteFactura = null
      this.RProductoCompraTemp = []
      this.RProductoCompra = []
      this.RProductoCompraOfercta = []
      this.Facturasventa.vendedor = null
      this.Facturasventa.tipocomprobante = null
      this.Facturasventa.telefononcf = ""
      this.Facturasventa.cedularncncf = ""
      this.Facturasventa.nombreDgii = ""
      this.Facturasventa.direccionncf = ""
      this.Facturasventa.caja = this.caja
      this.Facturasventa.sucursal = this.caja.sucursal
      this.Facturasventa.comentario = ""

      this.configuraciones.config.monedabase.tasa
      /*this.Monedafactura=JSON.parse(JSON.stringify(this.configuraciones.config.monedabase))
      this.Facturasventa.moneda=JSON.parse(JSON.stringify(this.configuraciones.config.monedabase))*/
      if (e.moneda != null) {
        var monedaa = e.moneda
        monedaa.tasa = e.tasa
        this.Monedafactura = monedaa
        this.Facturasventa.moneda = monedaa
        this.Facturasventa.tasa = monedaa.tasa
      }
      this.SalvarMonedaFactura()
      console.log('veer-klk-AplicarRestaurarFact->',e)
      var _this = this
      this.deleteFacturaTemporal = JSON.parse(JSON.stringify(e))
      /*this.Descuentofactura = {
        descuento: e.valordescuento,
        ValorPorc: true,
        DescuentoFacturaGlobal: true
      }*/

      //Verifica si de la lista de producto la existencia no alcansa
      var BOOL_existencia = false
      var OBJrestrList = []
      var bar = new Promise((resolve, reject) => {
        (async () => {

          if (e.facturastemporalesDetalleList.length > 0) {

            //var listFtempDetalle = JSON.parse(JSON.stringify(e.facturastemporalesDetalleList.filter((ee) => ee.precio>0)))
            var listFtempDetalle = JSON.parse(JSON.stringify(e.facturastemporalesDetalleList.filter((ee) => ee.precio >= 0)))
            listFtempDetalle.sort(function(a, b) {
              if (a.facturastemporalesDetallePK.id < b.facturastemporalesDetallePK.id) {
                return 1
              }
              if (a.facturastemporalesDetallePK.id > b.facturastemporalesDetallePK.id) {
                return -1
              }
              // a must be equal to b
              return 0
            })
            ;(async () => {
                var TIPOCOM = e.cliente != null && e.cliente.hasOwnProperty("tipocomprobante") ? e.cliente.tipocomprobante : e.tipocomprobante

                // console.log(listFtempDetalle)
                Promise.all(listFtempDetalle.map(async (element) => {
                  element.precioDig = JSON.parse(JSON.stringify(element.precio))
                }))
                const restrList = await this.detalleRestaurarFactTem(listFtempDetalle, TIPOCOM)
                OBJrestrList = JSON.parse(JSON.stringify(restrList.ListTem))

         /* console.log()

         BOOL_existencia=restrList.BOOL_existencia
          console.log('--DFBOOL_existencia--')
          console.log(BOOL_existencia)*/
                if (restrList.BOOL_existencia == true) {
                  _this.alerta("hay producto que intenta vender, que la cantiada es mayor a la existencia", "error")
                }
                if (OBJrestrList.length > 0) {
                  // console.log('--restrList--')
                  // console.log(OBJrestrList)
                  this.RProductoCompraOfercta = JSON.parse(JSON.stringify(restrList.ListTem.filter((ee) => ee.paramOfert == true)))

                  await Promise.all(OBJrestrList.map(async (element) => {
                    // this.BuscPropiedadProductoSelct(element, 'add')
                    // this.productoSeleccionado=JSON.parse(JSON.stringify(element))
                    // this.SalvarInfProducto()
                    element.RecarValor = (element.hasOwnProperty("RecarValor") && element.RecarValor != null ? element.RecarValor : 0)
                    element.valorRecargo = (element.hasOwnProperty("valorRecargo") && element.valorRecargo != null ? element.valorRecargo : 0)
                    this.RProductoCompra.unshift(JSON.parse(JSON.stringify(element)))
                    this.RProductoCompraTemp.unshift(JSON.parse(JSON.stringify(element)))
                    /* //this.BuscPropiedadProductoSelct(element, 'add')*/

                  }))

                  this.loading(false)
                  this.$refs.RefScroll.scrollTop = 0
                  this.$refs.RefScrollProductoCompra.scrollTop = 0

                  var DATO = {
                    cliente: e.cliente,
                    vendedor: e.vendedor,
                    tipoComp: e.cliente != null && e.cliente.hasOwnProperty("tipocomprobante") ? e.cliente.tipocomprobante : e.tipocomprobante,
                    OBJ: JSON.parse(JSON.stringify(e)),
                  }

                  // _this.LimpiaInfProducto()
                  _this.LimpiaInfProducto_DatoClienteSelectRestFact(DATO)
                  /*OBJrestrList.forEach(async(element) => {
            this.BuscPropiedadProductoSelct(element, 'add')
          });*/
                }
                resolve()
              })()

          } else {
            resolve()
          }

          /* setTimeout(() => {
          resolve()
        }, 500); */


        })()

      })


      bar.then(() => {
        if (e.cobertura != null && e.cobertura > 0) {
          this.CoberturaSeguro.ars = e.ars
          this.CoberturaSeguro.cobertura = e.cobertura
          this.CoberturaSeguro.autorizacion = e.autorizacion
          this.CoberturaSeguro.medico = e.medico
          this.CoberturaSeguro.exequartur = e.execuantum
          this.CoberturaSeguro.especialidad = e.especialidaMedico
          this.CoberturaSeguro.diagnostico = e.diagnostico
        }


        if (e.receta != null && e.receta.length > 0) {
          this.RecetaProdControlado = JSON.parse(e.receta)
        }


        this.ObjEjecPermisoPv = null

        setTimeout(function() {

          _this.SelectMedicoFactura = e.medicoCodigo
          _this.Facturasventa.vendedor = e.vendedor
          _this.Facturasventa.nombreDgii = e.nombreDgii
          _this.Facturasventa.cedularncncf = e.cedulaDgii
          _this.Facturasventa.telefononcf = e.telefonoDgii
          _this.Facturasventa.direccionncf = e.direccionDgii
          _this.Facturasventa.nombreFactTem = e.descripcion
          if (e.comentario != null) {
            _this.Facturasventa.comentario = e.comentario
          } else {
            _this.Facturasventa.comentario = ""
          }

          _this.nombreFactTem = e.descripcion

          if (e.cliente == null && e.descripcion != null && e.hasOwnProperty("descripcion") && e.descripcion.trim().length > 0) {
            _this.Facturasventa.nombreDgii = e.descripcion
          }

          if (e.telefonoDomicilio != null) {
            // _this.OpenFacturaDomicilio()
            if (e.cliente != null) {
              _this.domiciliofactura = JSON.parse(JSON.stringify(e.cliente))
            }


            _this.PanelMenuOpcionBotones = false
            _this.PanelMenuOpcionFacturaDomicilio = true
            var jsn = [
              {
                codigo: 1,
                descripcion: "Dirección 1",
                direccion: e.cliente.direccion,
              },
              {
                codigo: 2,
                descripcion: "Dirección 2",
                direccion: e.cliente.direccion2,
              },
              { codigo: 3, descripcion: "Otra dirección ", direccion: " " },
            ]
            _this.RDireccionDomicilio = JSON.parse(JSON.stringify(jsn))
            //this.OpenFacturaDomicilio()
            //  e.codDir
            // console.log(this.RDireccionDomicilio)
            _this.domiciliofactura.telefonoPrincipal = e.telefonoDomicilio
            var LIST_DIRE = jsn.filter((ee) => ee.codigo == e.codDir)
            _this.domiciliofactura.selctDireccion = LIST_DIRE[0]
            _this.domiciliofactura.direccion = LIST_DIRE[0].direccion
            // _this.ConstruirDomicilio(_this.Facturasventa, _this.devuelta);
            _this.AceptarFacturaDomicilio()
          }

          if (e.cobertura != null && e.cobertura > 0) {
            _this.CalcularTotalesProductosCompra()
          }

          _this.restaurandoFacturaTemporal = false
          _this.loading(false)
        }, 800)
      });

      (async () => {
        if (e.efectivo > 0) {
          this.Facturasventa.efectivo = JSON.parse(JSON.stringify(e.efectivo))
        }

        if (e.cxc > 0) {
          this.Facturasventa.cxc = JSON.parse(JSON.stringify(e.cxc))
        }

        if (e.cheque > 0) {
          this.Facturasventa.cheques = JSON.parse(JSON.stringify(e.cheque))
          this.Facturasventa.numeroCheque = e.numeroCheque
          this.bancoCheque = e.bancoCheque
        }

        if (e.transferencia > 0) {
          this.Facturasventa.transferencia = JSON.parse(JSON.stringify(e.transferencia))
          this.Facturasventa.numeroCheque = e.numeroCheque
          this.bancoCheque = e.bancoCheque
        }

        if (e.tarjeta > 0) {
          this.Facturasventa.tarjeta = JSON.parse(JSON.stringify(e.tarjeta))
          this.Facturasventa.numtar = JSON.parse(JSON.stringify(e.numtar))

          if (e.tipotar != null) {
            this.$axios
              .get(this.$hostname + this.$hName + "/tarjeta/findall/", {
                headers: this.$store.getters.GetheadersAxios,
              })
              .then((res) => {
                if (res.data.length > 0) {
                  var ObjProRow = res.data.filter((ee) => ee.codigo == e.tipotar)
                  if (ObjProRow.length > 0) {
                    this.tipoTarjeta = ObjProRow[0]
                  }
                }

              })

          }

        }

      
// if (e.cliente != null) {
// setTimeout(function () {
//           var DATO={
//               cliente:e.cliente,
//               vendedor:e.vendedor,
//               tipoComp:e.tipoComprobante
//             }

//           _this.LimpiaInfProducto_DatoClienteSelectRestFact(DATO);

//         }, 400);
//       }else{
//           this.Facturasventa.descripcion=e.descripcion
//         }


      })()

      // this.RProductoCompraTemp=JSON.parse(JSON.stringify(this.RProductoCompra))


      /*RProductoCompra:Array[3]
      RProductoCompraOfercta:Array[0]
      RProductoCompraTemp:*/

      /*if(e.valordescuento!=null){


        var Descuentofactura={
          descuento:e.valordescuento,
          ValorPorc:true,
          DescuentoFacturaGlobal:true
        }

        this.Descuentofactura=Descuentofactura

      }*/


      //this.SalvarDescuentoFactura()

      /*e.facturastemporalesDetalleList.forEach(element => {
       var Link=`${element.productos.codigo }/${element.unidades.codigo }`
         this.$axios
             .get(
               this.$hostname + this.$hName + "/unidades-productos/find/"+Link,
               { headers: this.$store.getters.GetheadersAxios }
             )
             .then((res) => {
               var Obj=res.data
               Obj.cantidad=element.cantidad
               this.BuscPropiedadProductoSelct(Obj, 'add')
             });
         }); */


      //clienteFactura
      // Facturasventa.vendedor


      /*   facturastemporalesDetalleList
         return
         this.RProductoCompraTemp = JSON.parse(
           JSON.stringify(e.facturastemporalesDetalleList)
         );


         this.RProductoCompra = JSON.parse(
           JSON.stringify(e.facturastemporalesDetalleList)
         );
         setTimeout(function () {
           _this.$refs.RefTextFieldProducto.focus();
           _this.CalcularTotalesProductosCompra();
         }, 500);
   */

      // var _this=this;
      // this.$axios.get(this.$hostname+this.$hName+'/temporales/'+e.secuencia+'/detalle',{headers:this.$store.getters.GetheadersAxios})
      // .then(res=>{
      // this.dialogRestaurarFactura=false,
      // this.RProductoCompra=res.data,
      // setTimeout(function(){
      // _this.$refs.RefTextFieldProducto.focus();
      // _this.CalcularTotalesProductosCompra()
      //  }, 500);

      // })
    },


    findUnidadProductoConExistenciaAlmacen(VARLINK) {
      return new Promise((resolve, reject) => {
// var VARLINK=`${codpro}/${coduni}`
        EventBus.$emit("loading", true)
        this.$axios.get(this.$hostname + this.$hName + "/unidades-productos/findUnidadProductoConExistenciaAlmacen/" + VARLINK, { headers: this.$store.getters.GetheadersAxios })
          .then(res => {
            resolve(res.data)
            //  EventBus.$emit("loading", false);
          })
          .catch(error => {
            // EventBus.$emit("loading", false);
            resolve(null)
          })

      })

    },


//Organizar Y preparar detalle factura temporal
    async detalleRestaurarFactTem(listFtempDetalle, tipocomprobante) {
      var OBJDATA = {
        sucursal: this.caja.sucursal.codigo,
        permitirNegativos: this.configuraciones.configInv.permitirNegativos,
        facturaTempDetalle: listFtempDetalle,
        tipoComprobante: tipocomprobante,
      }
      return new Promise((rresolve, reject) => {
        this.$axios
          .post(
            this.$hostname + this.$hName + "/temporales/existenciaListFactTemDetalle",
            OBJDATA,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            this.loading(false)
            rresolve(res.data)

            /*this.alerta(res.data.mensage, res.data.estado);
              this.cancelarFarmacoVigilancia();*/
          })
          .catch((error) => {
              this.loading(false)
              this.restaurandoFacturaTemporal = false
              rresolve({ ListTem: [], BOOL_existencia: false })
              /* this.alerta("Dato no borrado correctamente", "error")*/
            },
          )
      })
    },

    async detalleRestaurarFactTem2(listFtempDetalle) {
      var OBJ = {
        ListTem: [],
        BOOL_existencia: false,
      }
      return new Promise((rresolve, reject) => {
        var bar = new Promise((resolve, reject) => {
          // (async () => { })()
          listFtempDetalle.forEach(async (element, index, array) => {
            (async () => {
              //findUnidadProductoConExistenciaAlmacen
              var Link = `${element.productos.codigo}/${element.unidades.codigo}/${this.caja.sucursal.codigo}`
              const resUniPro = await this.findUnidadProductoConExistenciaAlmacen(Link)

              /*
            Obj.precioOrig = res.data.precio
                Obj.precioDig = res.data.precio
              this.$axios
              .get(
                this.$hostname + this.$hName + "/unidades-productos/findUnidadProductoConExistenciaAlmacen/" + Link,
                { headers: this.$store.getters.GetheadersAxios }
              )
              .then((res) => {var resUniPro=res.data});
            */

              if (resUniPro != null) {
                var Obj = resUniPro
                Obj.cantidad = element.cantidad
                Obj.omitirRegla = true
                Obj.DescValor = element.valordescuento
                Obj.descuentoKeys = element.valordescuento
                Obj.descuento = element.descuento
                Obj.ValorPorc = true
                Obj.precio = element.precio
                Obj.precioOrig = resUniPro.precio
                Obj.precioDig = resUniPro.precio

                if (this.configuraciones.configInv.permitirNegativos == false) {
                  if (resUniPro.productos.servicio == false && element.cantidad > resUniPro.existencias) {
                    OBJ.BOOL_existencia = true
                  } else {
                    OBJ.ListTem.push(Obj)
                    // this.BuscPropiedadProductoSelct(Obj, 'add')
                  }

                } else {
                  OBJ.ListTem.push(Obj)
                }
              }

            })()

          })
          resolve()
        })

        bar.then(() => {
          var _this = this
          setTimeout(function() {
            rresolve(OBJ)

          }, 500)

        })
        // OBJ.ListTem=ListDetalleTemp


      })

    },

    // Impresión de un recibo.
    ImprimirRestaurarFact(d) {
      if (this.EjecutarPermisoPv == false) {
        this.ObjEjecPermisoPv = JSON.parse(JSON.stringify(d))
        this.funcionValidaPermisoPv("AccImprimirRestaurarFact")
        return
      }


      var permitirAbrirFacTEM = this.$store.getters.GetConfiguracionGeneral.configPv.permitirAbrirFacTempLugaresDiferente

      if (permitirAbrirFacTEM == true) {
        this.contImprimirRestaurarFact(d)
      } else {

        var objFacTem = {
          secuencia: d.secuencia,
          verifOrUpdate: true,
          soloVerif: true,
        }

        this.$axios
          .post(this.$hostname + this.$hName + "/temporales/verifOrUpdateusofacturatemporal/", objFacTem, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            if (res.data.enUso == true) {
              this.alerta("Esta factura temporal está en uso,no puede imprimirla.", "error")
            } else {
              this.contImprimirRestaurarFact(d)
            }
            // this.BuscarRestaurarFacturas();
          })
          .catch((error) =>
            console.log("Dato no conectado.", "error"),
          )
      }


    },

    contImprimirRestaurarFact(d) {


      if (localStorage.printerSelect != null) {
      }
      // d.reimprimida=true
      // this.actualizarRestaurarFacReimprimida(d)
      var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
      var impresora = null
      if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
        impresora = JSON.parse(localStorage.printerSelect).nombre
      }
      var OBJ = d
      OBJ.imprimirPrefacturaSinencabezado = this.$store.getters.GetConfiguracionGeneral.configPv.imprimirPrefacturaSinencabezado
      var msg = {
        accion: "print",
        formato: this.caja.formatoimpresioncontado.trim(),
        impresora: impresora,
        data: this.configuraciones,
        fac: OBJ,
        caja: this.caja,
      }
      this.imprimir2(msg, "factura-temp", this.actualizarRestaurarFacReimprimida)

    },


    // Llamar a una función que verificará si el usuario tiene permiso para eliminar un registro. Si el
    // usuario no tiene permiso llama un panel para validar el usuario con permiso
    LlamadeleRestaurarFact(e) {

      if (this.EjecutarPermisoPv == false) {
        this.ObjEjecPermisoPv = JSON.parse(JSON.stringify(e))
        this.funcionValidaPermisoPv("AccDeleRestaurarFact")
        return
      }


      var permitirAbrirFacTEM = this.$store.getters.GetConfiguracionGeneral.configPv.permitirAbrirFacTempLugaresDiferente

      if (permitirAbrirFacTEM == true) {
        this.deleRestaurarFact(e)
      } else {

        var objFacTem = {
          secuencia: e.secuencia,
          verifOrUpdate: true,
          soloVerif: true,
        }
        this.$axios
          .post(this.$hostname + this.$hName + "/temporales/verifOrUpdateusofacturatemporal/", objFacTem, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            if (res.data.enUso == true) {
              this.alerta("Esta factura temporal está en uso,no puede Eliminada.", "error")
            } else {
              this.deleRestaurarFact(e)
            }
            // this.BuscarRestaurarFacturas();
          })
          .catch((error) =>
            console.log("Dato no conectado.", "error"),
          )

      }


      return
      this.deleRestaurarFact(e)
    },
    // Hacer una solicitud de publicación al servidor para borrar la factura temporal.
    deleRestaurarFact(e) {
      this.$axios
        .post(this.$hostname + this.$hName + "/temporales/borrado/", e, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          // this.alerta(res.data.mensage, res.data.estado);
          // this.RestaurarFacturaBusqueda.buscar=""
          this.BuscarRestaurarFacturas()
        })
        .catch((error) =>
          this.alerta("Dato no eliminado correctamente.", "error"),
        )
    },

    actualizarRestaurarFacReimprimida(e) {
    var OBJ_JSON=JSON.parse(JSON.stringify(e))

    //OBJ_JSON.hora =e.hora.trim().substr(0, 10) + "T04:00"
  /*  OBJ_JSON.hora =new Date(e.hora)
    OBJ_JSON.fecha=new Date(e.fecha)*/
   /* delete OBJ_JSON["hora"]
    delete OBJ_JSON["fecha"] */

    // var OBJ_JSON= {
    //   secuencia: e.secuencia
    // }
      this.$axios
        .post(this.$hostname + this.$hName + "/temporales/reimprimida/", OBJ_JSON, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          this.RestaurarFactlistFact[e.indx].reimprimida = res.data
          // this.BuscarRestaurarFacturas();
        })
        .catch((error) =>
          this.alerta("Dato no eliminado correctamente.", "error"),
        )

    },


    // Eliminación de una fila de una tabla.
    deleteConduce(e) {
      this.$axios
        .get(this.$hostname + this.$hName + "/conduce/deleteConduce/" + e.secuencia + "/" + e.documento, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          this.VerConducelistFactCliente = []
        })

    },
    // Creando un nuevo objeto con las propiedades del objeto Valecaja.
    newnewValecaja() {
      this.Valecaja = {
        valor: 0,
        beneficiario: "",
        Autorizado: "",
        Concepto: "",
        secuencia: 0,
        // fecha: new Date(),
        fecha: fechaNueva(),
        caja: null,
        numerocierre: 0,
        cajero: null,
      }
    },
    // Envío de una solicitud POST al servidor guardando el vale de caja.
    SalvarValecaja() {
      // this.Valecaja.secuencia=0
      // this.Valecaja.numerocierre= this.CierresCajas.cierrescajasPK.secuencia;
      // this.Valecaja.cajero = this.OtrasConfigPv.cajero;
      // this.Valecaja.caja= this.caja
      if (this.$refs.formCrearValeCaja.validate()) {
        this.loading(true)
        
         if (this.ejecucion == true) {
          this.ejecucionValecaja = false
          this.loading(true)
         
          var _this = this
            setTimeout(function() {
              _this.conTSalvarValecaja()
            }, 300)
        }
      
      } else {
        this.alerta("Los campos en rojo son requeridos", "error")
      }

      //  this.$axios.get(this.$hostname + this.$hName + "/valecaja/findall",
      //           {headers:this.$store.getters.GetheadersAxios})
      //         .then(res => {console.log('respuesta'), console.log(res.data)});
    },

conTSalvarValecaja(){

  this.$axios.get(this.$hostname + this.$hName +
            "/cierrecaja/ultimocierre/" + this.caja.codigo +  "/",
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            this.CierresCajas.cierrescajasPK.secuencia = res.data
            var Obj = {
              secuencia: 0,
              autorizadoPor: this.Valecaja.autorizadoPor,
              beneficiario: this.Valecaja.beneficiario,
              borrado: false,
              caja: this.caja,
              cajero: this.$store.getters.GetdatosInfUsu.usuario.codigo,
              //cajero:this.OtrasConfigPv.cajero,
              descripcion: this.Valecaja.descripcion,
              fecha: getFechaZone(this.Valecaja.fecha),
              numerocierre: this.CierresCajas.cierrescajasPK.secuencia,
              valor: this.Valecaja.valor,
              hora: getHoraActual(),
              nomCaj: this.$store.getters.GetOtrasConfigPv.cajero,
            }
            this.loading(true)
            this.$axios
              .post(
                this.$hostname + this.$hName + "/valecaja/save",
                JSON.parse(JSON.stringify(Obj)),
                { headers: this.$store.getters.GetheadersAxios },
              )
              .then((res) => {
                if (localStorage.printerSelect != null) {
                }
                var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
                var impresora = null
                if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
                  impresora = JSON.parse(localStorage.printerSelect).nombre
                }

                var msg = {
                  accion: "print",
                  formato: this.caja.formatoimpresioncontado.trim(),
                  impresora: impresora,
                  data: this.configuraciones,
                  vale: res.data,
                  caja: this.caja,
                  cajero: this.$store.getters.GetOtrasConfigPv.cajero,
                }
                this.imprimir(msg, "vale")

                this.alerta("Vale de caja salvado correctamente!", "bien")
                this.cancelarValecaja()
              })
              .catch((error) => {
                this.alerta("Vale de caja no se salvo", "error")
              })


          })
           .catch(error => {
             this.ejecucionValecaja = true
             this.loading(false)
             this.alerta("DATO NO GUARDADO", "error") 
          })
},


    // Cerrar el cuadro de diálogo y restablecer el formulario.
    cancelarValecaja() {
      this.dialogValecaja = false
      this.newnewValecaja()
    },


    getUltimocierreCaja() {
      this.$axios
        .get(this.$hostname + this.$hName + "/cierrecaja/ultimocierre/" +
          this.caja.codigo + "/", { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.CierresCajas.cierrescajasPK.secuencia = res.data
          var _this = this
          setTimeout(function() {
            _this.UpdateConfigPv(_this.caja)
          }, 300)

        })
    },


    // Creando un nuevo objeto y asignándolo a la variable CierresCajas.
    newnewCierreCaja() {
      this.ListDenomMoneda = [];
      (this.Rmoneda = []),
        (this.RLisMon = []),
        (this.CierresCajas = {
          cierrescajasPK: { caja: 0, secuencia: 0 },
          cantidadtarjeta: 0,
          tarjeta: 0,
          cantidadcheques: 0,
          cheques: 0,
          cantidadrecibo: 0,
          recibos: 0,
          efectivo: 0,
          cierrecajaMonedaList: [],
          DenominacionCierrecajaList: [],
          datoTarjeta: null,
          cantidadtranferencia: 0,
          transferencia: 0,
        }),
        (this.Totales.CierresCajas = {
          totalTotal: 0,
          totalDenomiacionvalor: 0,
        })
      this.loading(false)

      this.getUltimocierreCaja()

    },


    // Comprobando si el valor de veryFoms es verdadero. Si es verdadero, llamará a la función
    // validarCierreCarnet(). Si es falso llamará a la función PostSalvarCierreCaja(falso).
    SalvarCierreCaja() {
      var lccaja = JSON.parse(localStorage.caja)
      if (lccaja.veryFoms == true) {
        //if(this.tipoTarjeta.azul==true){return 0;}
        //if(this.tipoTarjeta.cardnet==true){this.validarCierreCarnet();return 0;}
        this.loading(true)
        this.validarCierreCarnet()
        return 0
      } else {
        this.PostSalvarCierreCaja(false)
      }
    },

    // Envío de una solicitud POST al servidor para guardar el cierre caja.
    async PostSalvarCierreCaja(verifone) {
      this.CierresCajas.cierrecajaMonedaList = this.RLisMon
     // this.CierresCajas.denominacionCierrecajaList = this.ListDenomMoneda
      this.CierresCajas.cierrescajasPK.caja = this.caja.codigo
      this.CierresCajas.sucursal = this.caja.sucursal
      this.CierresCajas.cajero = this.$store.getters.GetOtrasConfigPv.cajero
      var MONEDABASE = this.$store.getters.GetConfiguracionGeneral.config.monedabase
      this.CierresCajas.moneda = MONEDABASE.codigo

      this.CierresCajas.denominacionCierrecajaList= await Promise.all( this.ListDenomMoneda.map(async item => {
          let nuevoItem = { ...item };
          if (item.cantidad == null) { nuevoItem.cantidad=0; }
          return nuevoItem;
        })
      );

      // this.CierresCajas.moneda = this.Monedafactura.codigo
      // var msg ={
      //           accion:"print",
      //           formato:this.caja.formatoimpresioncontado.trim(),
      //           impresora:JSON.parse(localStorage.printerSelect).nombre,
      //           data:this.configuraciones,
      //           cierre:JSON.parse(ooop),
      //           caja:this.caja,
      //           verifone:verifone,
      //           cajero:this.$store.getters.GetOtrasConfigPv.cajero
      //        //   fac:this.ReimprecionFacturaSeleccionada
      //         }
      //        this.imprimir(msg,"cierrescaja/imprimir")

      // var bool=true
      // if(bool==true){
      //   return 0;
      // }
      this.loading(true)
      this.$axios
        .post(
          this.$hostname + this.$hName + "/cierrecaja/saveOrUpdate/",
          this.CierresCajas,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.CierresCajas = res.data.Cierre
          // if (res.data.cierrescajasPK.secuencia>0) {}
          this.alerta("Cierre de caja salvado correctamente!!!", "bien")
          this.dialogCierreCaja = false
          if (localStorage.printerSelect != null) {
          }

          var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
          var impresora = null
          if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
            impresora = JSON.parse(localStorage.printerSelect).nombre
          }
          var msg = {
            accion: "print",
            formato: this.caja.formatoimpresioncontado.trim(),
            impresora: impresora,
            data: this.configuraciones,
            cierre: res.data.Cierre,
            caja: this.caja,
            verifone: verifone,
            cajero: this.$store.getters.GetOtrasConfigPv.cajero,
            ListFaccierre: res.data.ListFaccierre,
          }
          this.imprimir(msg, "cierre")

          this.alerta("Datos salvado correctamente !!!", "bien")
          this.newnewCierreCaja()
        })
        .catch((erro) => {
          this.loading(false)
          this.alerta("El cierre de caja no se salvo correctamente", "error")
        })
    },

    // Cerrar el cuadro de diálogo y restablecer el formulario.
    cancelarCierreCaja() {
      this.dialogCierreCaja = false
      this.newnewCierreCaja()
    },

    verificarPermitirDomicilio() {
      // var LIST_MENS =  res.data.filter((ee) => ee.mensajero.nombre=== this.nuevoMensajeroSelect.nombre);
      /*/findall/mensajeroverificarcaja/{caja}"*/

      if (this.caja == null || !this.caja.hasOwnProperty("codigo")) {
        this.alerta("No ha seleccionado una caja para hacer el cierre", "error")
        return
      }


      this.$axios.get(this.$hostname + this.$hName + "/Mesajeros/findall/mensajeroverificarcaja/" + this.caja.codigo,
        { headers: this.$store.getters.GetheadersAxios }).then((res) => {
        if (res.data == false) {
          this.OpenCierreCaja()
        } else {
          this.alerta("No puede hacer cierre de caja porque tiene domicilio pendiente", "error")
        }

        /* if(res.data.length==0){
            // this.OpenCierreCaja()
          }else{this.alerta("No puede hacer cierre de caja porque tiene domicilio pendiente", "error");} */
      })

    },

    // Llamar a una API para obtener los datos y luego asignar esos valores a variable.

    OpenCierreCaja() {

      if (this.$store.getters.GetConfiguracionGeneral.configPv.noCerrarPendiente === true) {

        var _this = this
        this.$axios
          .get(this.$hostname + this.$hName + "/temporales/todas/" + this.RestaurarFacturaBusqueda.sucursal.codigo, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            setTimeout(function() {
              if (res.data.length > 0) {
                _this.alerta("Nota: no esta permitido hacer cierre de caja con facturas temporales  pendiente.", "error")
              } else {
                _this.contOpenCierreCaja()
              }

            }, 600)
          })
          .catch((error) => {
            this.loading(false)
          })

      } else {
        this.contOpenCierreCaja()
      }


    },


    contOpenCierreCaja() {

      var _this = this
      this.dialogCierreCaja = true
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/cierrecaja/ultimocierre/" +
          this.caja.codigo +
          "/",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.CierresCajas.cierrescajasPK.secuencia = res.data
        })

      this.$axios
        .get(
          this.$hostname + this.$hName + "/denominacionmoneda/findallActivos/",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          (this.ListDenomMoneda = res.data),
            setTimeout(function() {
              _this.CalcularDenominacion()
            }, 500)
        })
    },


    // Llamar a una API REST y obtener el último número de secuencia de la caja registradora.
    findCierreActual() {
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/cierrecaja/ultimocierre/" +
          this.caja.codigo +
          "/",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.CierresCajas.cierrescajasPK.secuencia = res.data
          this.updateConfiguracion()
        })
    },


    SelctCbMonedaCierre(e) {
      setTimeout(function() {

      }, 300)

      /*var _this = this;
            setTimeout(function () {
              if (e.moneda == null) {
                e.moneda = "";
              }

              if (e.moneda.hasOwnProperty('codigo')) {
                e.moneda = "";
                e.moneda = null;
                return;
              }
            }, 300);*/
    },

    // Llamar a una API y obtener los datos de la API y almacenarlos en la variable Rmoneda.
    cargarMoneda() {
      this.$axios
        .get(this.$hostname + this.$hName + "/monedas/findallActivos/", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.Rmoneda = res.data))
    },
    AddMonedaCierrecaja() {
      var jsn = {
        codigo: 0,
        valor: 0,
        moneda: null,
      }
      this.RLisMon.push(jsn)
    },
    // Eliminar el elemento de la Tabla.
    deleMondaCierre(item) {
      const index = this.RLisMon.indexOf(item)
      confirm("¿ Desea eliminar este Moneda ?") &&
      this.RLisMon.splice(index, 1)
    },
    // Cálculo del total de las denominaciones y el total del efectivo.
    CalcularDenominacion() {
      var _this = this
      var Lisdnm = JSON.parse(JSON.stringify(this.ListDenomMoneda))
      this.Totales.CierresCajas.totalDenomiacionvalor = 0
      Lisdnm.forEach((element) => {
        element.Vtotal = element.cantidad * element.valor
        if (element.denominacion === undefined) {
          element.denominacion = { codigo: element.codigo, descripcion: element.descripcion }
        }
        this.Totales.CierresCajas.totalDenomiacionvalor += element.Vtotal
      })
      setTimeout(function() {
        _this.ListDenomMoneda = JSON.parse(JSON.stringify(Lisdnm))
      }, 500)
      this.CierresCajas.efectivo =
        this.Totales.CierresCajas.totalDenomiacionvalor
      /*this.Totales.CierresCajas.totalTotal =
        this.Totales.CierresCajas.totalDenomiacionvalor +
        this.CierresCajas.cheques * this.CierresCajas.cantidadcheques +
        this.CierresCajas.recibos * this.CierresCajas.cantidadrecibo +
        this.CierresCajas.tarjeta * this.CierresCajas.cantidadtarjeta;*/
      this.Totales.CierresCajas.totalTotal =
        this.Totales.CierresCajas.totalDenomiacionvalor +
        this.CierresCajas.cheques + this.CierresCajas.recibos + this.CierresCajas.transferencia + this.CierresCajas.tarjeta
    },
    OpenCoberturaSeguro() {
      if (this.clienteFactura == null) {
        // this.filtroTipoCliente = 2
        this.filtroTipoCliente = 3
        this.OpenEjecCoberturaSeguro = true
        this.OpenDialogCrearEditarCliente()
      }
      if (this.clienteFactura != null) {
        if (this.clienteFactura.ars != null && this.clienteFactura.ars.hasOwnProperty("codigo")) {
          this.dialogCoberturaSeguro = true
          this.OpenEjecCoberturaSeguro = false
          this.objTemp = JSON.parse(JSON.stringify(this.CoberturaSeguro))
          // if (this.clienteFactura.ars != null) { }
          this.CoberturaSeguro.ars = JSON.parse(
            JSON.stringify(this.clienteFactura.ars),
          )

        } else {
          this.OpenEjecCoberturaSeguro = false
          this.alerta("El cliente seleccionado no contiene ars asignado", "error")
          return
        }


      }
    },
    // Un método que se llama cuando el usuario hace clic en el botón cancelar de un modal.
    cancelarCoberturaSeguro() {
      this.dialogCoberturaSeguro = false
      this.CoberturaSeguro = JSON.parse(JSON.stringify(this.objTemp))
      this.objTemp = null
      this.CalcularTotalesProductosCompra()
    },

    // Creando un nuevo objeto llamado CoberturaSeguro.
    newnewCoberturaSeguro() {
      this.CoberturaSeguro = {
        ars: null,
        cobertura: 0,
        autorizacion: 0,
        medico: "",
        exequartur: "",
        especialidad: "",
        diagnostico: "",
      }
    },
    // Guardando los datos en el formulario y luego actualizando los datos en la tabla de los productos con la cobertura.
    async SalvarCoberturaSeguro() {
      if (this.$refs.formCrearCobertura.validate()) {


        if (this.CoberturaSeguro.ars.hasOwnProperty("letra") && this.CoberturaSeguro.ars.letra != null
          && this.CoberturaSeguro.ars.letra.length > 0) {
          if (this.CoberturaSeguro.ars.letra != this.CoberturaSeguro.autorizacion.substr(0, 1)) {
            this.alerta("La autorización de la ars no coincide con la autorización colocada", "error")
            return
          }
        }

        this.CoberturaSeguro.autorizacion
        this.CoberturaSeguro.ars.letra


        this.objTemp = null
        this.dialogCoberturaSeguro = false;
        (async () => {

          if (this.Totales.totalGeneral.descuento > 0 && this.CoberturaSeguro.cobertura > 0) {
            this.Descuentofactura.descuento = 0
            this.Descuentofactura.ValorPorc = false
            await this.SalvarDescuentoFactura()
          }

          this.RProductoCompraTemp.forEach(element => {
            element.cobertura = 0
          })

          this.RProductoCompra = JSON.parse(JSON.stringify(this.RProductoCompraTemp))
          var _this = this
          setTimeout(function() {
            _this.CalcularTotalesProductosCompra()
          }, 500)
        })()


      } else {
        this.alerta("Debe completar los datos de la cobertura", "error")
      }

    },


    coberturaSeguroKeyCtrl(e) {

      if (e.keyCode == 17) {
        this.SalvarCoberturaSeguro()
      }


    },

    getDocumentoOtrosIngresos() {
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/documentocxc/find/" +
          this.caja.sucursal.otrosIngresos,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.OtrosIngreso.documento = res.data
        })
    },
    // Creando un nuevo objeto llamado OtrosIngreso.
    newnewOtrosIngreso() {
      this.OtrosIngreso = {
        //secuencia2: 12
        //secuencia: 20
        activo: true,
        caja: 1,
        concepto: "",
        documento: null,
        fecha: new Date(),
        identificacion: "",
        nombre: "",
        referencia: "",
        telefono: "",
        tipoRecibo: null,
        valor: 0,
        contabilidad: null,
      }
    },
    // Un método que se llama cuando el usuario hace clic en el botón cancelar del cuadro de diálogo.
    cancelarOtrosIngreso() {
      this.dialogOtrosIngreso = false
    },
    contabilidadOtrosIngreso() {
      if (this.OtrosIngreso.valor == 0) {
        return
      }
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/contabilidad/crear-contabilidad-cxc/" +
          this.caja.sucursal.otrosIngresos +
          "/" +
          this.OtrosIngreso.valor +
          "/0/0/0/0/0/0",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.OtrosIngreso.contabilidad = res.data
        })
    },
    openCashDrawer() {
      if (localStorage.printerSelect != null) {
      }
      var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
      var impresora = null
      if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
        impresora = JSON.parse(localStorage.printerSelect).nombre
      }
      var msg = {
        accion: "print",
        formato: this.caja.formatoimpresioncontado.trim(),
        impresora: impresora,
        caja: this.caja,
        cajero: this.$store.getters.GetOtrasConfigPv.cajero,
      }
      this.imprimir(msg, "open")

    },

  SalvarOtrosIngreso(){

    if(this.caja==null || this.caja!=null && !this.caja.hasOwnProperty("codigo")){
      this.alerta("NOTA: seleccione una caja", "error")
      return
    }

    this.$axios
        .get(this.$hostname + this.$hName + "/cierrecaja/ultimocierre/" +
          this.caja.codigo + "/", { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.OtrosIngreso.caja=this.caja 
         this.OtrosIngreso.numerocierre=res.data

          var _this = this
          setTimeout(function() {
            _this.contSalvarOtrosIngreso()
          }, 300)

        })

      
    },


    // Guardando los datos en la base de datos de otros ingreso.
    contSalvarOtrosIngreso() {
      if (this.$refs.formOtrosIngresos.validate()) {
        this.OtrosIngreso.tiporecibo = this.OtrosIngreso.tipoRecibo.codigo
        this.OtrosIngreso.usuario = this.$store.getters.GetOtrasConfigPv.cajero
        this.loading(true)
        this.$axios
          .post(
            this.$hostname + this.$hName + "/otrosingresos/salvar",
            this.OtrosIngreso,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            this.alerta("Dato guardado correctamente", "bien2")
            this.newnewOtrosIngreso()
            this.dialogOtrosIngreso = false
            if (localStorage.printerSelect != null) {
            }
            var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
            var impresora = null
            if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
              impresora = JSON.parse(localStorage.printerSelect).nombre
            }
            var msg = {
              accion: "print",
              formato: this.caja.formatoimpresioncontado.trim(),
              impresora: impresora,
              data: this.configuraciones,
              recibo: res.data,
              caja: this.caja,
              cajero: this.$store.getters.GetOtrasConfigPv.cajero,
            }
            this.imprimir(msg, "otros-ingreso")

          })
          .catch((error) =>
            this.alerta("Datos no guardado correctamente", "error"),
          )
      } else {
        this.alerta("Debe completar los datos de la cobertura", "error")
      }
    },


  
    // Creando un nuevo objeto con dos propiedades, fechaInicio y fechaFinal.
    newnewImpresoraFiscal() {
      this.CierreRangoFecha = {
        fechaInicio: fechaNueva(),
        fechaFinal: fechaNueva(),
      }
      this.CierreRangoNumero = {
        inicio: 0,
        final: 0,
      }
    },
    // Cerrar el cuadro de diálogo y restablecer el formulario.
    cancelarImpresoraFiscal() {
      this.dialogImpFiscal = false
      this.newnewImpresoraFiscal()
    },

    OpenDialogCambioDivisa() {
      this.dialogCambioDivisa = true
      this.NewNewCambioDivisa()
      this.CargarBusquedaCambioDivisa()
    },
    // Creando un nuevo objeto y asignándolo a la variable CambioDivisa.
    NewNewCambioDivisa() {
      this.CambioDivisa = {
        id: 0,
        nombreCliente: "",
        telefonoClietne: "",
        cedulaCliente: "",
        operacion: true,
        tasaCompra: 0,
        tasaVenta: 0,
        cantidadRecivida: 0,
        devuelta: 0,
        cuadre: 0,
        caja: 0,
        usuario: null,
        fecha: new Date(),
        usuarioAnulado: null,
        fechaAnulada: null,
        cantidadEntregada: 0,
        cantidadComprada: 0,
        activada: true,
        direccionCliente: null,
        cajero: null,
        borrado: false,
        moneda: null,
      }
      this.CambioDivisaBusqueda = {
        secuencia: 0,
        cliente: "0",
        fechaInicial: fechaNueva(),
        fechaFinal: fechaNueva(),
      }
      this.loading(false)

    },
    // Envío de una solicitud al servidor y guarda la divisa.
    SalvarCambioDivisa() {

      if (this.CambioDivisa.devuelta < 0) {
        this.alerta("La cantidad Cantidad recibida es menor a la Cantidad a entregar", "error")
        return
      }

      if (this.$refs.formCambioDivisa.validate()) {
        this.CambioDivisa.caja = this.caja.codigo
        this.CambioDivisa.usuario = this.$store.getters.GetdatosInfUsu.usuario.usuario
        var User = ""
        if (this.$store.getters.GetdatosInfUsu.usuario.nombre == null) {
          User = this.$store.getters.GetdatosInfUsu.usuario.username
        } else {
          User = this.$store.getters.GetdatosInfUsu.usuario.nombre
        }
        this.CambioDivisa.cajero = User
        this.CambioDivisa.tasaCompra = this.CambioDivisa.moneda.tasaCompra
        this.CambioDivisa.tasaVenta = this.CambioDivisa.moneda.tasaVenta
        this.loading(true)
        this.$axios
          .post(
            this.$hostname + this.$hName + "/divisa/save/",
            this.CambioDivisa,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
            var impresora = null
            if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
              impresora = JSON.parse(localStorage.printerSelect).nombre
            }

            var fecha = new Date().toISOString().replaceAll("T", " ").trim()
            //console.log(fecha.split(".")[0])
            var obj = res.data
            obj.nuevaFecha = fecha
            var msg = {
              accion: "print",
              formato: this.caja.formatoimpresioncontado.trim(),
              impresora: impresora,
              data: this.configuraciones,
              divisa: obj,
              caja: this.caja,
              cajero: this.$store.getters.GetOtrasConfigPv.cajero,
            }
            this.imprimir(msg, "divisa")

            var _this = this
            setTimeout(function() {
              _this.alerta("Divisa guardada Correctamente !!!", "bien")
              _this.dialogCambioDivisa = false
              _this.NewNewCambioDivisa()

            }, 300)

          })
      }
    },
    // Llamar a una api  servidor y borra la divisa
    anularCambioDivisa() {

      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv("AccAnularCambioDivisa")
        return
      }

      if (this.$refs.formCambioDivisa.validate()) {
        this.CambioDivisa.caja = this.caja.codigo
        this.$axios
          .post(
            this.$hostname + this.$hName + "/divisa/Borrar/",
            this.CambioDivisa,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => (this.RVendedor = res.data))
      }
    },
    // Impresión de un recibo de cambio divisa.
    imprimirCambioDivisa() {
      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv("AccImprimirCambioDivisa")
        return
      }
      var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
      var impresora = null
      if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
        impresora = JSON.parse(localStorage.printerSelect).nombre
      }

      var msg = {
        accion: "print",
        formato: this.caja.formatoimpresioncontado.trim(),
        impresora: impresora,
        data: this.configuraciones,
        divisa: this.CambioDivisa,
        caja: this.caja,
        cajero: this.$store.getters.GetOtrasConfigPv.cajero,
      }
      this.imprimir(msg, "divisa")
    },
    // Llamar a una API REST y obtener una lista de objetos.
    CargarBusquedaCambioDivisa() {
      //CargarBusquedaRecetas:OpenDialogCrearEditarCliente:CambioDivisalist,CambioDivisaDatostabla,
      //CambioDivisaBusqueda:secuencia,cliente,fechaInicial,fechaFinal
      //http://10.0.0.95:8080/micromarket/services/divisas/filtroDivisa/jc/0/2021-01-01/2021-10-15

      if (this.CambioDivisaBusqueda.fechaInicial.toString().length == 0) {
        this.CambioDivisaBusqueda.fechaInicial = this.fechaNueva()
      }
      if (this.CambioDivisaBusqueda.fechaFinal.toString().length == 0) {
        this.CambioDivisaBusqueda.fechaFinal = this.fechaNueva()
      }

      this.CambioDivisalist = []

      if (this.CambioDivisaBusqueda.cliente.toString().length == 0) {
        this.CambioDivisaBusqueda.cliente = "0"
      }
      if (this.CambioDivisaBusqueda.secuencia.toString().length == 0) {
        this.CambioDivisaBusqueda.secuencia = "0"
      }

      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/divisa/filtroDivisa/" +
          this.CambioDivisaBusqueda.cliente +
          "/" +
          this.CambioDivisaBusqueda.secuencia +
          "/" +
          this.CambioDivisaBusqueda.fechaInicial +
          "/" +
          this.CambioDivisaBusqueda.fechaFinal +
          "",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.CambioDivisalist = res.data
        })

      //this.dialogRecetas=true
    },

    // Convertir la fecha en una cadena y setea los valores a un formulario.
    CambioDivisaDatostabla(e) {
      var cm = JSON.parse(JSON.stringify(e))
      cm.fe = new Date(e.fecha).toISOString().substr(0, 10)
      this.CambioDivisa = JSON.parse(JSON.stringify(cm))
    },
    OpenVendedores() {
      if (this.Facturasventa.vendedor != null) {
        this.objTemp = JSON.parse(JSON.stringify(this.Facturasventa.vendedor))
      }
      this.PanelMenuOpcionBotones = false
      this.PanelMenuOpcionVendedor = true
    },

    // Guardar el valor seleccionado del menú desplegable en el objeto.
    SalvarVendedores() {
      if (this.Facturasventa.vendedor != null) {
        this.objTemp = null
        this.PanelMenuOpcionBotones = true
        this.PanelMenuOpcionVendedor = false
      }
    },
    // Tomando el objeto de la matriz y asignándolo al objeto en el formulario.
    cancelarVendedores() {
      this.Facturasventa.vendedor = JSON.parse(JSON.stringify(this.objTemp))
      this.PanelMenuOpcionBotones = true
      this.PanelMenuOpcionVendedor = false

      var _this = this
      setTimeout(function() {
        if (_this.Facturasventa.vendedor == null) {
          _this.verificarVendedor()
        }

      }, 300)
      //this.NewNewVendedores()
    },
    // Un método que se llama cuando se hace clic en un botón y resetea un objeto.
    NewNewVendedores() {
      this.Facturasventa.vendedor = null
      //cancelarVendedores,NewNewVendedores (dialogCrearEditarCliente=false, NewclienteSeleccionado())clienteSeleccionado
    },
    // Comprobando si el valor seleccionado es nulo o indefinido.
    SelctCbVendedorFactura() {

      var _this = this
      setTimeout(function() {
        if (_this.Facturasventa.vendedor == null) {
          _this.Facturasventa.vendedor = ""
        }

        if (!_this.Facturasventa.vendedor.hasOwnProperty("codigo")) {
          _this.Facturasventa.vendedor = ""
          _this.Facturasventa.vendedor = null
          return
        }
      }, 300)


      /*   if (this.Facturasventa.vendedor == null) {
           this.Facturasventa.vendedor = "";
         }
         if (this.Facturasventa.vendedor.codigo == undefined) {
           this.Facturasventa.vendedor = "";
           this.alerta("Seleccione un Vendedor", "error");
           return;
         }*/
    },

    // Llamar a una API y obtener los datos de la API y almacenarlos en la variable RVendedor.
    async cargarVendedorFactura() {
      if (this.pvOnline == false || (typeof navigator !== "undefined" && navigator.onLine == false)) {
        await this.cargarVendedoresOffline("")
        return
      }
      this.$axios
        .get(this.$hostname + this.$hName + "/vendedores/findallactiv", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then(async (res) => {
            this.RVendedor = res.data.filter((ee) => ee.sucursal == null || ee.sucursal != null && ee.sucursal.codigo == this.caja.sucursal.codigo)
            await this.guardarVendedoresOffline(res.data || [])
            // this.RVendedor = res.data
          },
        )
        .catch(async (error) => {
          if (this.esErrorConexionPv(error)) {
            this.activarModoOfflinePorErrorConexion(error)
            await this.cargarVendedoresOffline("")
          }
        })
    },

    OpenMedico() {
      if (this.SelectMedicoFactura != null) {
        this.objTemp = JSON.parse(JSON.stringify(this.SelectMedicoFactura))
      }
      this.PanelMenuOpcionBotones = false
      this.PanelMenuOpcionMedico = true
    },
    NewNewMedico() {
      this.SelectMedicoFactura = null
    },
    SalvarMedico() {
      if (this.SelectMedicoFactura != null) {
        this.objTemp = null
        this.PanelMenuOpcionBotones = true
        this.PanelMenuOpcionMedico = false
      }
    },
    // Tomando el objeto que se creó en la sección de datos y copiándolo al objeto SelectMedicoFactura.
    cancelarMedico() {
      this.SelectMedicoFactura = JSON.parse(JSON.stringify(this.objTemp))
      this.PanelMenuOpcionBotones = true
      this.PanelMenuOpcionMedico = false
      //this.NewNewVendedores()
    },
    // Hacer una solicitud GET al servidor y devolver los datos del medico.
    cargarMedico() {
      this.$axios
        .get(this.$hostname + this.$hName + "/medicoafiliados/findall/", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RMedico = res.data))
    },
    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbMedicoFactura() {
      if (this.SelectMedicoFactura == null) {
        this.SelectMedicoFactura = ""
      }
      if (this.SelectMedicoFactura.codigo == undefined) {
        this.SelectMedicoFactura = ""
        this.alerta("Seleccione un Vendedor", "error")
        return
      }
    },
    OpenDescuentoFactura() {
      this.objTempaplicarDescuentoGlobalFacturaXencimaMaximo = null
      this.objTemp = JSON.parse(JSON.stringify(this.Descuentofactura))
      this.PanelMenuOpcionBotones = false
      this.PanelMenuOpcionDescuentoFactura = true
      var _this = this
      setTimeout(function() {
        _this.Descuentofactura.descuento = 0
      }, 600)

      // .select()
      var _this = this
      setTimeout(function() {
        _this.$refs.RefTextFieldDescuentoFactura.focus()
      }, 1000)
    },
    // Creando un nuevo objeto y asignándolo a la variable Descuentofactura.
    NewNewDescuentoFactura() {

      this.Descuentofactura.ValorPorc = true
      this.Descuentofactura.descuento = 0
      /*this.Descuentofactura = {
         ValorPorc: true,
         descuento: 0,
         DescuentoFacturaGlobal: false
       };*/
      //PanelMenuOpcionDescuentoFactura,Panel Descuentofactura,cancelarDescuentoFactura,NewNewDescuentoFactura,OpenDescuentoFactura
    },
    // Cálculo del descuento de los productos en el carrito de compras.
    async SalvarDescuentoFactura() {
      if (this.$refs.formDescuentoFactura.validate()) {
        this.objTemp = null
        this.PanelMenuOpcionBotones = true
        this.PanelMenuOpcionDescuentoFactura = false
        this.Descuentofactura.DescuentoFacturaGlobal = true

        //this.RProductoCompra

        var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
        var MONEDAFACTURATASA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)

        /* if (this.Descuentofactura.ValorPorc == true) {
          this.Descuentofactura.descuento =(((this.Descuentofactura.descuento*MONEDAFACTURATASA))   )
            }*/

        var EXEC_VALIDAR_DESC = false
        this.objTempaplicarDescuentoGlobalFacturaXencimaMaximo = JSON.parse(JSON.stringify(this.Descuentofactura))


        var bar = new Promise((resolve, reject) => {
          // (async () => {
          // this.RProductoCompraTemp.forEach(element => {
          //await
          Promise.all(this.RProductoCompraTemp.map(async (element) => {
            var Cant = element.cantidad

            var desc = (this.Descuentofactura.descuento)
            element.descuento = JSON.parse(JSON.stringify(this.Descuentofactura.descuento))
            element.ValorPorc = JSON.parse(JSON.stringify(this.Descuentofactura.ValorPorc))
            var PrecioVal = 0

            if (this.ConfImpfiscal == true) {
              PrecioVal = element.precio
            } else {

              if (element.productos.incluirimpuestoenprecio == true) {
                if (element.productos.impuesto != null) {
                  PrecioVal = (element.precio) / (1 + (element.productos.impuesto.tasa / 100))
                } else {
                  PrecioVal = element.precio
                }
              } else {

                PrecioVal = element.precio
              }

            }

            var DescPorencima = false
            var SuperAdmin = this.$store.getters.GetdatosInfUsu.usuario.sudo
            if (this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList.length > 0) {
              var ObjPerm = this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList.filter((ee) => ee.fn == 3 && ee.op == 14)
              if (ObjPerm.length > 0) {
                DescPorencima = ObjPerm[0].permiso
              } else {
                DescPorencima = false
              }
            }

            if (this.Descuentofactura.ValorPorc == true) {
              /*var valorDesc = ((element.descuentoKeys * 100) / (PrecioVal * Cant));
            var DescOdeMax = ((element.descuentoKeys * 100) / (PrecioVal * Cant)); */
              var valorDesc = (((desc * MONEDAFACTURATASA) * 100) / (PrecioVal * Cant))
              var DescOdeMax = (((desc * MONEDAFACTURATASA) * 100) / (PrecioVal * Cant))

              // console.log(`SuperAdmin=>${SuperAdmin};;DescPorencima=>${DescPorencima}`)
              if (SuperAdmin == false && DescPorencima == false) {
                if (valorDesc > element.productos.descuentomaximo) {
                  var valorrr = ((element.productos.descuentomaximo * (PrecioVal * Cant)) / 100)
                  element.descuento = valorrr
                  DescOdeMax = element.productos.descuentomaximo
                  EXEC_VALIDAR_DESC = true
                }
              }

              element.DescValor = (element.descuento * MONEDAFACTURATASA)
              element.valordescuento = element.descuento
              element.descuento = DescOdeMax

            } else {
              if (SuperAdmin == false && DescPorencima == false) {
                if (desc > element.productos.descuentomaximo) {
                  element.descuento = element.productos.descuentomaximo
                  EXEC_VALIDAR_DESC = true
                }
              }
              element.DescValor = ((element.descuento * (PrecioVal * Cant)) / 100)
              element.valordescuento = ((element.descuento * (PrecioVal * Cant)) / 100)

            }
            // Calculo de itbis en producto
          }))
          // })()
          // });
          resolve()
        })


        bar.then(() => {
          console.log("SalvarDescuentoFactura:All done!")
          this.RProductoCompra = JSON.parse(JSON.stringify(this.RProductoCompraTemp))
          var _this = this
          setTimeout(function() {
            _this.CalcularTotalesProductosCompra()

            if (EXEC_VALIDAR_DESC == true) {
              _this.funcionValidaPermisoPv("AccDescuentoGlobalFactura")
            }

          }, 500)
        })


      } else {
        this.alerta("Debe digitar un descuento", "error")
      }

    },

    //Aplicando Descuento Global Factura
    async aplicarDescuentoGlobalFacturaXencimaMaximo() {

      var DESCUENTO_FACTURA = JSON.parse(JSON.stringify(this.objTempaplicarDescuentoGlobalFacturaXencimaMaximo))

      //  this.RProductoCompraTemp.forEach(element => {});

      await Promise.all(this.RProductoCompraTemp.map(async (element) => {
        var Cant = element.cantidad
        var desc = DESCUENTO_FACTURA.descuento
        element.descuento = JSON.parse(JSON.stringify(DESCUENTO_FACTURA.descuento))
        element.ValorPorc = JSON.parse(JSON.stringify(DESCUENTO_FACTURA.ValorPorc))

        var PrecioVal = 0


        if (this.ConfImpfiscal == true) {
          PrecioVal = element.precio
        } else {

          if (element.productos.incluirimpuestoenprecio == true) {
            if (element.productos.impuesto != null) {
              PrecioVal = (element.precio) / (1 + (element.productos.impuesto.tasa / 100))
            } else {
              PrecioVal = element.precio
            }
          } else {

            PrecioVal = element.precio
          }

        }

        if (DESCUENTO_FACTURA.ValorPorc == true) {

          var valorDesc = ((desc * 100) / (PrecioVal * Cant))
          var DescOdeMax = ((desc * 100) / (PrecioVal * Cant))

          element.DescValor = element.descuento
          element.valordescuento = element.descuento
          element.descuento = DescOdeMax

        } else {

          element.DescValor = ((element.descuento * (PrecioVal * Cant)) / 100)
          element.valordescuento = ((element.descuento * (PrecioVal * Cant)) / 100)

        }
        // Calculo de itbis en producto
      }))


      this.RProductoCompra = JSON.parse(JSON.stringify(this.RProductoCompraTemp))

      var _this = this
      setTimeout(function() {
        _this.CalcularTotalesProductosCompra()
        _this.objTempaplicarDescuentoGlobalFacturaXencimaMaximo
      }, 500)

    },


    // Un método que se llama cuando el usuario hace clic en un botón cancelar la operacion.
    cancelarDescuentoFactura() {
      this.Descuentofactura = JSON.parse(JSON.stringify(this.objTemp))
      this.PanelMenuOpcionBotones = true
      this.PanelMenuOpcionDescuentoFactura = false
      //this.NewNewVendedores()
      this.CalcularTotalesProductosCompra()
    },
    OpenRetencionFactura() {
      this.objTemp = JSON.parse(JSON.stringify(this.Retencionfactura))
      this.PanelMenuOpcionBotones = false
      this.PanelMenuOpcionRetencionFactura = true
      var _this = this
      setTimeout(function() {
        _this.$refs.RefTextFieldRetencionFactura.focus()
      }, 500)
    },
    // Creando un nuevo objeto llamado Retencionfactura y asignándolo a la propiedad de datos
    NewNewRetencionFactura() {
      this.Retencionfactura = {
        ValorPorc: true,
        Retencion: 0,
      }
    },
    // Activa las variables necesarios para la retenciones de los productos
    SalvarRetencionFactura() {
      this.objTemp = null
      this.PanelMenuOpcionBotones = true
      this.PanelMenuOpcionRetencionFactura = false
      this.CalcularTotalesProductosCompra()
    },
    // Tomando el objeto que se está editando y copiándolo a un objeto temporal.
    cancelarRetencionFactura() {
      this.Retencionfactura = JSON.parse(JSON.stringify(this.objTemp))
      this.PanelMenuOpcionBotones = true
      this.PanelMenuOpcionRetencionFactura = false
      //this.NewNewVendedores()
      this.CalcularTotalesProductosCompra()
    },
    OpenRecargoFactura() {
      this.objTemp = JSON.parse(JSON.stringify(this.Recargofactura))
      this.PanelMenuOpcionBotones = false
      this.PanelMenuOpcionRecargoFactura = true
      var _this = this
      setTimeout(function() {
        _this.$refs.RefTextFieldRecargoFactura.focus()
      }, 500)
    },
    // Creando un nuevo objeto con las propiedades ValorPorc y Retención.
    NewNewRecargoFactura() {
      this.Retencionfactura = {
        ValorPorc: true,
        Retencion: 0,
      }
    },
    // Agregar una nueva propiedad al objeto de de la lista de productos a comprar.
    async SalvarRecargoFactura() {
      this.objTemp = null
      this.PanelMenuOpcionBotones = true
      this.PanelMenuOpcionRecargoFactura = false


      //this.RProductoCompraTemp.forEach(element => {});

      await Promise.all(this.RProductoCompraTemp.map(async (element) => {
        var Cant = element.cantidad
        element.recargo = JSON.parse(JSON.stringify(this.Recargofactura.recargo))
        var ValorPorcRecarg = JSON.parse(JSON.stringify(this.Recargofactura.ValorPorc))

        if (ValorPorcRecarg == true) {
          element.RecarValor = element.recargo
        } else {
          element.RecarValor = ((element.recargo * (element.precio * Cant)) / 100)
        }
        element.ValorPorcRecarg = JSON.parse(JSON.stringify(this.Recargofactura.ValorPorc))
        
      }))


      this.RProductoCompra = JSON.parse(JSON.stringify(this.RProductoCompraTemp))

      var _this = this
      setTimeout(function() {
        _this.CalcularTotalesProductosCompra()
      }, 500)


    },
    // Tomando el objeto que se creó en la sección temporal y copiándolo al objeto que se está
    // utilizando en el formulario y activa el panel necesario.
    cancelarRecargoFactura() {
      this.Recargofactura = JSON.parse(JSON.stringify(this.objTemp))
      this.PanelMenuOpcionBotones = true
      this.PanelMenuOpcionRecargoFactura = false
      this.CalcularTotalesProductosCompra()
    },
    OpenMonedaFactura() {
      this.objTemp = JSON.parse(JSON.stringify(this.Monedafactura))
      this.PanelMenuOpcionBotones = false
      this.PanelMenuOpcionMonedaFactura = true
    },
    // Creando una nueva objeto de la variable MonedaFactura.
    NewNewMonedaFactura() {
      this.Monedafactura = null
    },
    // Guardar la moneda de la factura.


    SalvarMonedaFactura() {
      this.UpdateConfigMoneda()

      this.objTemp = null
      /*this.PanelMenuOpcionBotones = true;
      this.PanelMenuOpcionMonedaFactura = false;*/
      this.actualizarDecimal = false
      EventBus.$emit("loading", true)
      var _this = this
      setTimeout(function() {
        _this.PanelMenuOpcionBotones = true
        _this.PanelMenuOpcionMonedaFactura = false
        _this.actualizarDecimal = true
        _this.calculostotales()
        EventBus.$emit("loading", false)
      }, 500)

      //cambio por cambio de moneda(01-03-2024):this.CalcularTotalesProductosCompra();
    },
    // Un método que se llama cuando el usuario hace clic en el botón
    //cancelar y activa o inavilita el panel de monea.
    cancelarMonedaFactura() {
      this.Monedafactura = JSON.parse(JSON.stringify(this.objTemp))
      this.PanelMenuOpcionBotones = true
      this.PanelMenuOpcionMonedaFactura = false
      //cambio por cambio de moneda(01-03-2024): this.CalcularTotalesProductosCompra();


      //this.NewNewMonedaFactura()
      //  Moneda Factura, PanelMenuOpcionMonedaFactura, cancelarMonedaFactura,NewNewMonedaFactura,SalvarMonedaFactura
      // Monedafactura:,OpenMonedaFactura
    },

    // Convertir los valores de las entradas a la nueva moneda.
    UpdateConfigMoneda() {
      var OtrasConfPv = this.$store.getters.GetOtrasConfigPv
      OtrasConfPv.moneda = this.Monedafactura.descripcion
      var TasaMmon = this.Monedafactura.tasa

      if (this.Facturasventa.efectivo > 0) {
        this.Facturasventa.efectivo = JSON.parse(
          JSON.stringify(this.Facturasventa.efectivo / TasaMmon),
        )
      }

      if (this.Facturasventa.tarjeta > 0) {
        this.Facturasventa.tarjeta = JSON.parse(
          JSON.stringify(this.Facturasventa.tarjeta / TasaMmon),
        )
      }

      if (this.Facturasventa.cheques > 0) {
        this.Facturasventa.cheques = JSON.parse(
          JSON.stringify(this.Facturasventa.cheques / TasaMmon),
        )
      }

      if (this.Facturasventa.transferencia > 0) {
        this.Facturasventa.transferencia = JSON.parse(
          JSON.stringify(this.Facturasventa.transferencia / TasaMmon),
        )
      }

      if (this.Facturasventa.cxc > 0) {
        this.Facturasventa.cxc = JSON.parse(
          JSON.stringify(this.Facturasventa.cxc / TasaMmon),
        )
      }

      if (this.Facturasventa.cupones > 0) {
        this.Facturasventa.cupones = JSON.parse(
          JSON.stringify(this.Facturasventa.cupones / TasaMmon),
        )
      }

      if (this.Facturasventa.puntos > 0) {
        this.Facturasventa.puntos = JSON.parse(
          JSON.stringify(this.Facturasventa.puntos / TasaMmon),
        )
      }

      if (this.Facturasventa.valorNc > 0) {
        this.Facturasventa.valorNc = JSON.parse(
          JSON.stringify(this.Facturasventa.valorNc / TasaMmon),
        )
      }

 if (this.Facturasventa.valorbonogas > 0) {
        this.Facturasventa.valorbonogas = JSON.parse(
          JSON.stringify(this.Facturasventa.valorbonogas / TasaMmon),
        )
      }

 if (this.Facturasventa.valorasignacion > 0) {
        this.Facturasventa.valorasignacion = JSON.parse(
          JSON.stringify(this.Facturasventa.valorasignacion / TasaMmon),
        )
      }
      
      if (this.Facturasventa.valorPruebaMetro > 0) {
        this.Facturasventa.valorPruebaMetro = JSON.parse(
          JSON.stringify(this.Facturasventa.valorPruebaMetro / TasaMmon),
        )
      }

        if (this.Facturasventa.valorTraspaso > 0) {
        this.Facturasventa.valorTraspaso = JSON.parse(
          JSON.stringify(this.Facturasventa.valorTraspaso / TasaMmon),
        )
      }

     if (this.Facturasventa.valordonacion > 0) {
        this.Facturasventa.valorTraspaso = JSON.parse(
          JSON.stringify(this.Facturasventa.valordonacion / TasaMmon),
        )
      }

      
    },

    OpenComentarioFactura() {
      this.objTemp = JSON.parse(JSON.stringify(this.Otros))
      this.PanelMenuOpcionBotones = false
      this.PanelMenuOpcionComentarioFactura = true
    },
    // Creando un nuevo objeto llamado Otros y asignándolo al objeto a la factura.
    NewNewComentarioFactura() {
      this.Otros = {
        comentario: "",
        numeroOrden: "",
        ShipTo: "",
        incoterms: "",
      }
    },
    // Poniendo el valor de la variable PanelMenuOpcionBotones a verdadero y
    // PanelMenuOpcionComentarioFactura a falso.
    SalvarComentarioFactura() {
      this.PanelMenuOpcionBotones = true
      this.PanelMenuOpcionComentarioFactura = false
    },
    // Establecer el valor de la entrada en una cadena vacía.
    cancelarComentarioFactura() {
      this.Facturasventa.comentario = ""
      this.Facturasventa.numeroOrden = ""
      this.Facturasventa.ShipTo = ""
      this.Facturasventa.incoterms = ""
      this.PanelMenuOpcionBotones = true
      this.PanelMenuOpcionComentarioFactura = false
    },
    // Una función que se llama cuando se hace clic en un botón y coloca los datos necesario
    //para que la factora sea adomicilio.
    AceptarFacturaDomicilio() {
      this.PanelMenuOpcionFacturaDomicilio = false
      this.PanelMenuOpcionBotones = true
      this.PanelMenuOpcionFacturaDomicilio = false
       var _this = this
      setTimeout(function() {
        _this.CalcularTotalesGeneral()
      }, 500)
    },

    // Establecer el valor de la variable en nulo.
    cancelarFacturaDomicilio() {
      this.domiciliofactura = null
      this.RDireccionDomicilio = []
      this.PanelMenuOpcionBotones = true
      this.PanelMenuOpcionFacturaDomicilio = false
       var _this = this
      setTimeout(function() {
        _this.CalcularTotalesGeneral()
      }, 500)
    },

    CargarRSucursal() {

      this.$axios.get(this.$hostname + this.$hName + "/sucursal/findallActivos/", { headers: this.$store.getters.GetheadersAxios }).then(res => {
        this.RSucursal = JSON.parse(JSON.stringify(res.data))
      })

    },
    SelctCbSucursal() {
      var _this = this
      setTimeout(function() {
        if (_this.sucursalFactTemporal == null) {
          _this.sucursalFactTemporal = ""
        }

        if (!_this.sucursalFactTemporal.hasOwnProperty("codigo")) {
          _this.sucursalFactTemporal = ""
          _this.sucursalFactTemporal = null
          _this.sucursalFactTemporal = _this.caja.sucursal
          return
        }
      }, 300)
    },

    SelctCbSucursalFactTempSeach() {
      var _this = this
      setTimeout(function() {
        if (_this.RestaurarFacturaBusqueda.sucursal == null) {
          _this.RestaurarFacturaBusqueda.sucursal = ""
        }

        if (!_this.RestaurarFacturaBusqueda.sucursal.hasOwnProperty("codigo")) {
          _this.RestaurarFacturaBusqueda.sucursal = ""
          _this.RestaurarFacturaBusqueda.sucursal = null
          return
        }
      }, 300)
    },

    OpenDialogGuardartemporal() {
      if (this.RProductoCompra.length == 0) {
        this.alerta("Debe seleccionar al menos un producto", "error")
        return
      }

      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv("AccGuardartemporal")
        return
      }

      var vend = this.$store.getters.GetConfiguracionGeneral.configPv.vendedorobligatorio

      if (vend == true && this.Facturasventa.vendedor == null) {
        this.alerta("Debe seleccionar un vendedor", "error")
        return
      }


      if (this.clienteFactura != null) {
        this.nombreFactTem = this.clienteFactura.nombre
        if (this.cambiarDestinoSucursal == true && this.sucursalFactTemporal == null) {
          this.dialogGuardartemporal = true
          this.sucursalFactTemporal = this.caja.sucursal
          this.focusRefTextFieldNombreFactTem()
          return
        }

        var _this = this
        setTimeout(function() {
          _this.loading(true)
          _this.guardartemporal()
        }, 500)


      } else {
        this.focusRefTextFieldNombreFactTem()
        if (this.Facturasventa.hasOwnProperty("nombreFactTem")) {
          this.nombreFactTem = JSON.parse(JSON.stringify(this.Facturasventa.nombreFactTem))
        }
        this.dialogGuardartemporal = true
      }
    },

    focusRefTextFieldNombreFactTem() {
      var _this = this
      setTimeout(function() {
        _this.$refs.RefTextFieldNombreFactTem.focus()
      }, 500)
    },

    finalizarGuardartemporalKeyCtrl(e) {

      if (e.keyCode == 17) {
        this.ValidarFomsguardartemporal()
      }


    },

    ValidarFomsguardartemporal() {
      this.Facturasventa.facturastemporalesDetalle = []
      if (this.RProductoCompra.length == 0) {
        this.alerta("Debe seleccionar al menos un producto", "error")
        return
      }

      if (!this.$refs.formNombreFactTem.validate()) {
        this.alerta("Los compos en rojos son requerido", "error")
        return
      }

      this.guardartemporal()

    },

    async CalcularTotalesProductosSaveTemp() {

      var totalGeneral = {
        subtotal: 0,
        itbis: 0,
        total: 0,
        descuento: 0,
        Retencion: 0,
        recargo: 0,
        cobertura: 0,
      }


      return new Promise((resolve, reject) => {
        if (this.RProductoCompra.length > 0) {


          var RObjProductoCompra = JSON.parse(
            JSON.stringify(this.RProductoCompraTemp),
          )
          var tasaMoneda = JSON.parse(JSON.stringify(this.configuraciones.config.monedabase.tasa))
          var Ccobertura = 0
          // RObjProductoCompra.forEach((element) => {});
          // (async () => {
          Promise.all(RObjProductoCompra.map(async (element) => {

            if (!element.hasOwnProperty("paramOfert") || element.paramOfert == false) {
              element.precio = this.RedondeoValor(element.precio / tasaMoneda)
              element.valor = this.RedondeoValor(element.precio * element.cantidad)
              if (this.ConfImpfiscal == false) {
                if (element.productos.incluirimpuestoenprecio == true) {
                  if (element.productos.impuesto != null) {
                    var precioVar = this.RemoveTax(element.productos, element.precio)
                    totalGeneral.subtotal += (element.cantidad * precioVar)
                    var VALOR_IMPUESTO = this.CalculateTax(element)
                    element.valorimpuesto = VALOR_IMPUESTO
                    totalGeneral.itbis += VALOR_IMPUESTO
                  }

                  if (element.productos.incluirimpuestoenprecio == false) {
                    if (element.productos.impuesto != null) {
                      var VALOR_IMPUESTO = this.CalculateTax(element)
                      element.valorimpuesto = VALOR_IMPUESTO
                      totalGeneral.itbis += VALOR_IMPUESTO
                    }
                  }
                  totalGeneral.descuento += this.RedondeoBasico(element.DescValor)
                  totalGeneral.recargo += element.RecarValor
                  Ccobertura += element.cobertura
                } else {

                  totalGeneral.subtotal += this.RedondeoBasico(element.valor)
                  if (element.productos.incluirimpuestoenprecio == true) {
                    if (element.productos.impuesto != null) {
                      var VALOR_IMPUESTO = this.CalculateTax(element)
                      element.valorimpuesto = VALOR_IMPUESTO
                      totalGeneral.itbis += VALOR_IMPUESTO
                    }
                  }
                  if (element.productos.incluirimpuestoenprecio == false) {
                    if (element.productos.impuesto != null) {
                      var VALOR_IMPUESTO = this.CalculateTax(element)
                      element.valorimpuesto = VALOR_IMPUESTO
                      totalGeneral.itbis += VALOR_IMPUESTO
                    }
                  }

                  totalGeneral.descuento += this.RedondeoBasico(element.DescValor)
                  totalGeneral.recargo += this.RedondeoBasico(element.RecarValor)
                }
              } else {


                if (element.productos.incluirimpuestoenprecio == true) {
                  if (element.productos.impuesto != null) {
                    var precioVar = element.precio
                    totalGeneral.subtotal += (element.cantidad * precioVar)
                    var VALOR_IMPUESTO = this.CalculateTax(element)
                    element.valorimpuesto = VALOR_IMPUESTO
                    totalGeneral.itbis += VALOR_IMPUESTO
                  }

                  if (element.productos.incluirimpuestoenprecio == false) {
                    if (element.productos.impuesto != null) {
                      var VALOR_IMPUESTO = this.CalculateTax(element)
                      element.valorimpuesto = VALOR_IMPUESTO
                      totalGeneral.itbis += VALOR_IMPUESTO
                    }
                  }
                  totalGeneral.descuento += this.RedondeoBasico(element.DescValor)
                  totalGeneral.recargo += this.RedondeoBasico(element.RecarValor)
                  Ccobertura += element.cobertura
                } else {

                  totalGeneral.subtotal += element.valor
                  if (element.productos.incluirimpuestoenprecio == true) {
                    if (element.productos.impuesto != null) {
                      var VALOR_IMPUESTO = this.CalculateTax(element)
                      element.valorimpuesto = VALOR_IMPUESTO
                      totalGeneral.itbis += VALOR_IMPUESTO
                    }
                  }
                  if (element.productos.incluirimpuestoenprecio == false) {
                    if (element.productos.impuesto != null) {
                      var VALOR_IMPUESTO = this.CalculateTax(element)
                      element.valorimpuesto = VALOR_IMPUESTO
                      totalGeneral.itbis += VALOR_IMPUESTO
                    }
                  }

                  totalGeneral.descuento += this.RedondeoBasico(element.DescValor)
                  totalGeneral.recargo += this.RedondeoBasico(element.RecarValor)
                }


              }
            }

          }))
          // })()


          if (Ccobertura > 0) {
            totalGeneral.cobertura = this.RedondeoBasico(Ccobertura)
          }
        }

        /* this.Descuentofactura.descuento = JSON.parse(JSON.stringify(this.Totales.totalGeneral.descuento))
       this.Descuentofactura.ValorPorc = true

       this.Recargofactura.recargo = JSON.parse(JSON.stringify(this.Totales.totalGeneral.recargo))
       this.Recargofactura.ValorPorc = true*/

        var todo = {
          Descuentofactura: {
            descuento: JSON.parse(JSON.stringify(totalGeneral.descuento)),
            ValorPorc: true,
          },

          Recargofactura: {
            recargo: JSON.parse(JSON.stringify(totalGeneral.recargo)),
            ValorPorc: true,
          },
          Retencionfactura: this.Retencionfactura,
          CoberturaSeguro: this.CoberturaSeguro,
          totalGeneral: totalGeneral,
          RObjProductoCompra: RObjProductoCompra,

        }

        resolve(todo)
      })


      /* this.Descuentofactura.descuento = JSON.parse(JSON.stringify(this.Totales.totalGeneral.descuento))
       this.Descuentofactura.ValorPorc = true

       this.Recargofactura.recargo = JSON.parse(JSON.stringify(this.Totales.totalGeneral.recargo))
       this.Recargofactura.ValorPorc = true*/

    },

    // Convertir la moneda de una moneda a otra.
    async ConvertirMonedaRd() {

      const result = await this.CalcularTotalesProductosSaveTemp()
      var MonedaTasa = this.configuraciones.config.monedabase.tasa
      var totalGeneral = JSON.parse(JSON.stringify(result.totalGeneral))
      var Descuentofactura = JSON.parse(JSON.stringify(result.totalGeneral))
      var Recargofactura = JSON.parse(JSON.stringify(result.Recargofactura))
      var Retencionfactura = JSON.parse(JSON.stringify(result.Retencionfactura))
      var CoberturaSeguro = JSON.parse(JSON.stringify(result.CoberturaSeguro))

      return new Promise((resolve, reject) => {
        //Nota: La variable:RObjProductoCompra trae el impuesto
        // var RObjProductoCompra = JSON.parse(JSON.stringify(this.RProductoCompraTemp));
        var RObjProductoCompra = JSON.parse(JSON.stringify(result.RObjProductoCompra))

        if (Descuentofactura.descuento > 0) {
          if (Descuentofactura.ValorPorc == true) {
            totalGeneral.descuento = Descuentofactura.descuento / MonedaTasa
          }
          if (Descuentofactura.ValorPorc == false) {
            totalGeneral.descuento =
              (Descuentofactura.descuento * totalGeneral.subtotal) / 100 / MonedaTasa
          }
        } else {
          totalGeneral.descuento = 0
        }

        if (Retencionfactura.Retencion > 0) {
          if (Retencionfactura.ValorPorc == true) {
            totalGeneral.Retencion = Retencionfactura.Retencion / MonedaTasa
          }
          if (Retencionfactura.ValorPorc == false) {
            totalGeneral.Retencion =
              (Retencionfactura.Retencion * this.Totales.totalGeneral.subtotal) / 100 / MonedaTasa
          }
        } else {
          totalGeneral.Retencion = 0
        }

        if (Recargofactura.recargo > 0) {
          if (Recargofactura.ValorPorc == true) {
            totalGeneral.recargo = Recargofactura.recargo / MonedaTasa
          }
          if (Recargofactura.ValorPorc == false) {
            totalGeneral.recargo = (Recargofactura.recargo * this.Totales.totalGeneral.subtotal) / 100 / MonedaTasa
          }
        } else {
          totalGeneral.recargo = 0
        }

        if (CoberturaSeguro.cobertura > 0) {
          totalGeneral.cobertura = CoberturaSeguro.cobertura / MonedaTasa
        } else {
          totalGeneral.cobertura = 0
        }

        if (this.ConfImpfiscal == true) {

          if (this.IncluirItbisGeneral == false) {
            totalGeneral.total = this.RedondeoBasico(
              totalGeneral.subtotal +
              totalGeneral.itbis +
              totalGeneral.recargo -
              (totalGeneral.descuento +
                totalGeneral.Retencion +
                totalGeneral.cobertura))
            //this.Totales.totalGeneral.total= this.Totales.totalGeneral.subtotal + this.Totales.totalGeneral.itbis
          }

          if (this.IncluirItbisGeneral == true) {
            totalGeneral.total = this.RedondeoBasico(
              totalGeneral.subtotal +
              totalGeneral.recargo -
              (totalGeneral.descuento +
                totalGeneral.Retencion +
                totalGeneral.cobertura))
            //this.Totales.totalGeneral.total= this.Totales.totalGeneral.subtotal
          }

        } else {

          totalGeneral.total = this.RedondeoBasico(
            totalGeneral.subtotal +
            totalGeneral.itbis +
            totalGeneral.recargo -
            (totalGeneral.descuento +
              totalGeneral.Retencion +
              totalGeneral.cobertura))

        }

      console.log('ver-detall->',RObjProductoCompra)
        var ListDet = []
        // this.RProductoCompraTemp.forEach((dato) => {
        //precioDig
        RObjProductoCompra.forEach((dato) => {
          var detalle = {
            facturastemporalesDetallePK: {
              secuencia: 0,
              producto: dato.productos.codigo,
              unidad: dato.unidades.codigo,
              // id: this.RProductoCompraTemp.indexOf(dato),
              id: RObjProductoCompra.indexOf(dato),
            },
            almacen: this.caja.almacen.codigo,
            cantidad: dato.cantidad,
            valordescuento: dato.valordescuento,
            valorimpuesto: dato.valorimpuesto,
            precio: dato.precio,
            precioDig: dato.precioDig,
            descuento: dato.descuento,
            codigocupon: null,
            valorcupon: 0.0,
            cantidadPendiente: dato.cantdad,
            oferta: null,
            valorRecargo: dato.hasOwnProperty("RecarValor") && dato.RecarValor!=null?dato.RecarValor:0.0,
            recargo: 0.0,
            descripcion: dato.descripcion,
            costounidad: dato.costo,
            cantidadDespachada: dato.cantidadDespachada,
            borrado: false,
            cobertura: 0,
            impuesto: dato.impuesto,
            productos: dato.productos,
            unidades: dato.unidades,
            vendedor: dato.vendedor,
          }
          if (!dato.hasOwnProperty("valordescuento") && dato.DescValor > 0) {
            detalle.valordescuento = dato.DescValor
          }
          if (!dato.hasOwnProperty("impuesto") && dato.hasOwnProperty("valorimpuesto") && dato.valorimpuesto > 0) {
            detalle.impuesto = dato.valorimpuesto
          }
          if (this.UsarLote == true) {
              detalle.lote = dato.lote
              detalle.facturastemporalesDetallePK.lote = dato.lote
              detalle.fechaLoteInicial = dato.hasOwnProperty("fechaLoteInicial") ? dato.fechaLoteInicial : null
            }

          ListDet.push(detalle)

        })


        var todo = {
          totalGeneral: totalGeneral,
          ListDet: ListDet,
        }


        resolve(todo)
      })


    },

    // Guardando los datos en la base de datos de factura temporal.
    async guardartemporal() {


      this.Facturasventa.facturastemporalesDetalle = []
      if (this.RProductoCompra.length == 0) {
        this.alerta("Debe seleccionar al menos un producto", "error")
        return
      }

      const result = await this.ConvertirMonedaRd()
      //var totalGeneral = JSON.parse(JSON.stringify(result.totalGeneral))
      var totalGeneral = JSON.parse(JSON.stringify(this.Totales.totalGeneral))
      var ListDet = JSON.parse(JSON.stringify(result.ListDet))
      if (this.ejecucion == true) {
        this.ejecucion = false

        if (this.clienteFactura != null) {
          this.Facturasventa.cliente = this.clienteFactura
          this.Facturasventa.numeroOrden = this.clienteFactura.numeroOrden
        }

        this.Facturasventa.moneda = this.Monedafactura
        this.Facturasventa.tasa = this.Monedafactura.tasa
        this.Facturasventa.caja = this.caja
        this.Facturasventa.sucursal = this.caja.sucursal
        if (this.domiciliofactura != null) {
          this.ConstruirDomicilio(this.Facturasventa, this.devuelta)
        }


        //this.Facturasventa.valordescuento=this.Descuentofactura.descuento
        var objfact = JSON.parse(JSON.stringify(this.Facturasventa))

        var PORCIENTO_LEY = this.$store.getters.GetConfiguracionGeneral.configPv.porcientoLey
        if (PORCIENTO_LEY != null && PORCIENTO_LEY > 0) {
          objfact.porcientoLey = PORCIENTO_LEY
          objfact.valorLey = this.RedondeoValor(((this.Totales.totalGeneral.subtotal * PORCIENTO_LEY) / 100))
        } else {
          objfact.porcientoLey = 0
          objfact.valorLey = 0
        }
        objfact.caja = this.caja
        objfact.descripcion = this.nombreFactTem

        objfact.sucursal = this.caja.sucursal
        //this.Totales.totalGeneral.total;
        objfact.valor = this.RedondeoValor(totalGeneral.total)
        objfact.valorimpuesto = this.RedondeoValor(totalGeneral.itbis)
        objfact.valordescuento = this.RedondeoValor(totalGeneral.descuento)
        objfact.retencion = this.RedondeoValor(totalGeneral.Retencion)
        objfact.valorRecargo = this.RedondeoValor(totalGeneral.recargo)
        objfact.recgGlobal=true
        objfact.cobertura = this.RedondeoValor(totalGeneral.cobertura)
        objfact.coberturaPendiente = this.RedondeoValor(totalGeneral.cobertura)
        //objfact.facturastemporalesDetalleList =this.Facturasventa.facturastemporalesDetalle;
        objfact.facturastemporalesDetalleList = ListDet
        objfact.nombreDgii = this.Facturasventa.nombreDgii
        objfact.cedulaDgii = this.Facturasventa.cedularncncf
        objfact.telefonoDgii = this.Facturasventa.telefononcf
        objfact.moneda = this.Monedafactura
        objfact.tasa = this.Monedafactura.tasa

        if (this.tipoTarjeta != null && this.tipoTarjeta.hasOwnProperty("codigo")) {
          objfact.tipotar = this.tipoTarjeta.codigo
        }

        if (this.Facturasventa.tipocomprobante == null) {
          objfact.tipocomprobante = this.configuraciones.configPv.comprobantefacturacion
        } else {
          objfact.tipoComprobante = this.Facturasventa.tipocomprobante.codigo
        }

        objfact.direccionDgii = this.Facturasventa.direccionncf
        //objfact.hora = new Date()
          objfact.hora = new Date(this.getParamFecha(this.fechaNueva()))
        
        if (this.domiciliofactura != null) {
          objfact.telefonoDomicilio = this.domiciliofactura.telefonoPrincipal
          objfact.codDir = this.domiciliofactura.selctDireccion.codigo
        }


        if (this.CoberturaSeguro.cobertura > 0) {
          objfact.ars = this.CoberturaSeguro.ars
          objfact.autorizacion = this.CoberturaSeguro.autorizacion
          objfact.medico = this.CoberturaSeguro.medico
          objfact.execuantum = this.CoberturaSeguro.exequartur
          objfact.especialidaMedico = this.CoberturaSeguro.especialidad
          objfact.diagnostico = this.CoberturaSeguro.diagnostico

        }

        if (this.SelectMedicoFactura != null) {
          objfact.medicoCodigo = this.SelectMedicoFactura
        }
        if (this.cambiarDestinoSucursal == true) {
          objfact.sucursal = this.sucursalFactTemporal.codigo
        }

        if (this.Facturasventa.vendedor != null && this.Facturasventa.vendedor.hasOwnProperty("codigo")) {
          objfact.vendedor = this.Facturasventa.vendedor
        }

        if (this.RecetaProdControlado.numero != null && this.RecetaProdControlado.detalleList.length > 0) {
          objfact.receta = JSON.stringify(this.RecetaProdControlado)
        }
        if (this.deleteFacturaTemporal != null) {
          this.deleRestaurarFact(this.deleteFacturaTemporal)
        }
        objfact.enUso = false
        objfact.cheque = this.Facturasventa.cheques
        objfact.bancoCheque = this.bancoCheque
        objfact.numeroCheque = this.Facturasventa.numeroCheque
        objfact.transferencia = this.Facturasventa.transferencia

        // this.Facturasventa.numeroCheque

        /* console.log('--guardartemporal--')
        console.log(objfact)
        console.log('PraPra es la señal')*/
        // console.log(JSON.stringify(objfact.facturastemporalesDetalleList))
        //  objfact.facturastemporalesDetalleList=[]
        // console.log(JSON.stringify(objfact))
        /* return */
        //objfact.usuario=this.$store.getters.GetdatosInfUsu.usuario.nombre
        objfact.usuario = this.$store.getters.GetdatosInfUsu.usuario.usuario
        this.$axios.post(this.$hostname + this.$hName + "/temporales/save", objfact, {
          headers: this.$store.getters.GetheadersAxios,
        })
          .then((res) => {
            this.alerta("Guardado corretamente...", "bien")
          })
          .catch((error) => this.alerta(error, "error"))
      }
    },
    llenarDetalleTemp(dato) {
      var detalle = {
        facturastemporalesDetallePK: {
          secuencia: 0,
          producto: dato.productos.codigo,
          unidad: dato.unidades.codigo,
          id: 0,
        },
        almacen: this.caja.almacen.codigo,
        cantidad: dato.cantidad,
        valordescuento: dato.valordescuento,
        valorimpuesto: dato.valorimpuesto,
        precio: dato.precio,
        descuento: dato.descuento,
        codigocupon: null,
        valorcupon: 0.0,
        cantidadPendiente: dato.cantdad,
        oferta: null,
        valorRecargo: 0.0,
        recargo: 0.0,
        descripcion: dato.descripcion,
        costounidad: dato.costo,
        cantidadDespachada: dato.cantidadDespachada,
        borrado: false,
        cobertura: 0,
        impuesto: dato.impuesto,
        productos: dato.productos,
        unidades: dato.unidades,
        vendedor: dato.vendedor,
      }
      if (this.UsarLote == true) {
        detalle.lote = dato.lote
        detalle.facturasventaDetallePK.lote = dato.lote
        detalle.fechaLoteInicial = dato.hasOwnProperty("fechaLoteInicial") ? dato.fechaLoteInicial : null
      }
      this.Facturasventa.facturastemporalesDetalle.push(detalle)
    },
    // Abriendo una ventana modal .
    OpenFacturaDomicilio() {
      if (this.clienteFactura == null) {
        this.OpenEjecFacturaDomicilio = true
        this.OpenDialogCrearEditarCliente()
      }
      if (this.clienteFactura != null) {

        if (this.domiciliofactura == null) {
          this.domiciliofactura = JSON.parse(JSON.stringify(this.clienteFactura))
          this.domiciliofactura.telefonoPrincipal = this.selectTelefonoCliente(this.clienteFactura)
          this.PanelMenuOpcionBotones = false
          this.PanelMenuOpcionFacturaDomicilio = true
          var jsn = [
            {
              codigo: 1,
              descripcion: "Dirección 1",
              direccion: this.clienteFactura.direccion,
            },
            {
              codigo: 2,
              descripcion: "Dirección 2",
              direccion: this.clienteFactura.direccion2,
            },
            { codigo: 3, descripcion: "Otra dirección ", direccion: " " },
          ]
          this.RDireccionDomicilio = JSON.parse(JSON.stringify(jsn))
          this.domiciliofactura.selctDireccion = jsn[0]
        } else {
          this.PanelMenuOpcionBotones = false
          this.PanelMenuOpcionFacturaDomicilio = true
        }


      }
    },
    ChangeDireccionDomicilio(e) {

      this.domiciliofactura.direccion = JSON.parse(JSON.stringify(e.direccion))
    },
    SelctCbDireccionDomicilio() {
      if (this.domiciliofactura.selctDireccion == null) {
        this.domiciliofactura.selctDireccion = ""
      }
      if (this.domiciliofactura.selctDireccion.codigo == undefined) {
        this.domiciliofactura.selctDireccion = ""
        this.alerta("Seleccione una direccion", "error")
        return
      }
    },
    OpenDialogAsignarMensajeros() {
      this.buscarMensajero = null
      this.NewMensagero()
      this.dialogAsignarMensajeros = true
      this.dialogRecibirMensajeros = false
      this.dialogFacturasRutasMensajeros = false
      this.dialogCambiarMensajeros = false
      this.dialogMensajero = true
    },
    OpenDialogRecibirMensajeros() {
      this.getUltimocierreCaja()
      this.buscarMensajero = null
      this.NewMensagero()
      this.dialogAsignarMensajeros = false
      this.dialogRecibirMensajeros = true
      this.dialogFacturasRutasMensajeros = false
      this.dialogCambiarMensajeros = false
      this.dialogMensajero = true
    },

    OpenDialogFacturasRutasMensajeros() {
      this.buscarMensajero = null
      this.NewMensagero()
      this.dialogAsignarMensajeros = false
      this.dialogRecibirMensajeros = false
      this.dialogFacturasRutasMensajeros = true
      this.dialogCambiarMensajeros = false
      this.dialogMensajero = true
      this.CargarFacturasRutasMensajeros()
    },

    OpenDialogCambiarMensajeros() {
      this.buscarMensajero = null
      this.NewMensagero()
      this.dialogAsignarMensajeros = false
      this.dialogRecibirMensajeros = false
      this.dialogFacturasRutasMensajeros = false
      this.dialogCambiarMensajeros = true
      this.dialogMensajero = true
    },


    // Creando un nuevo objeto y asignándolo a la variable MensageroSeleccionado.
    NewMensagero() {
      this.MensageroSeleccionado = {
        codigo: 0,
        nombre: "",
        telefono: "",
        cedula: "",
        metadeenvios: 0,
        sucursal: { descripcion: "" },
      }
      this.RFacturasDomicilio = []
      this.RRecibirMensajeros = []
      this.selectedRecibirMensajeros = []
      this.selectedAsignarMensajero = []
      this.selectedCambiarMensajeros = []
      this.FacturaDomicilioMensajero = null
      this.nuevoMensajeroSelect = null
      this.filtroAsigMensajero = {
        fact: "",
        sector: "",
        caja: null,
      }
    },

    // Una función que se llama cuando el usuario hace clic en el botón cancelar.
    CancelarVerAsignarMensajero() {
      this.VerFacturaDomicilioMensajero = false
      this.FacturaDomicilioMensajero = null
      this.dialogMensajero = false
      this.dialogRecibirMensajeros = false
      this.dialogAsignarMensajeros = false,
        this.dialogFacturasRutasMensajeros = false
      this.NewMensagero()
    },


    // Llama a una api para asirnarle al mensajero seleccionado la factura seleccionada
    async SalvarAsignarMensagero() {
      if (this.$refs.formAsignarMensagero.validate()) {

        if (this.selectedAsignarMensajero.length == 0) {
          this.alerta("Seleccione al menos una factura", "error")
          return
        }
        if (this.$store.getters.GetConfiguracionGeneral.configPv.activarLimiteAsignadoDomicilioMensajero != null && this.$store.getters.GetConfiguracionGeneral.configPv.activarLimiteAsignadoDomicilioMensajero == true){
          var LIMITE_ASIG_DOM_MEN =this.$store.getters.GetConfiguracionGeneral.configPv.limiteAsignadoDomicilioMensajero

          if((this.selectedAsignarMensajero.length+this.buscarMensajero.cantFactAsignada)>LIMITE_ASIG_DOM_MEN){
           // this.alerta(`NOTA: ESTA INTENTANTO ASIGNAR AL MENSAJERO MAS FACTURA DE LO PERMITIDO. \n \n 
           //Limite: ${LIMITE_ASIG_DOM_MEN} , Fact.Asignada: ${this.buscarMensajero.cantFactAsignada} , Fact.Seleccionada: ${this.selectedAsignarMensajero.length}`, "warning")

          this.notifConfAdicional= {
              estado: true,
              nombre: `NOTA: ESTA INTENTANTO ASIGNAR AL MENSAJERO MÁS FACTURA DE LO PERMITIDO.Limite: ${LIMITE_ASIG_DOM_MEN} , Fact.Asignada: ${this.buscarMensajero.cantFactAsignada} , Fact.Seleccionada: ${this.selectedAsignarMensajero.length} \n ¿Desea Asignar de todas forma?`,
              Exec: "contAsignarMensajero",
              objTemp: null,
            }

            return
          }

          this.contSalvarAsignarMensagero()

        }else{
          this.contSalvarAsignarMensagero()
        }

      } else {
        this.alerta("los campos en rojo son requeridos", "error")
      }
    },

      contSalvarAsignarMensagero(){

         if (this.ejecucion == true) {
          this.ejecucion = false
          this.loading(true)

          var OBJ = {
            listaDomicilio: this.selectedAsignarMensajero,
            codigoMensajero: this.MensageroSeleccionado.codigo,
          }

          this.$axios
            .post(
              this.$hostname + this.$hName + "/Mesajeros/asignarDomicilioMensajero",
              OBJ,
              { headers: this.$store.getters.GetheadersAxios },
            )
            .then((res) => {


              var _this = this
              setTimeout(function() {
                _this.CancelarVerAsignarMensajero()
                _this.loading(false)
                _this.ejecucion = true
              }, 900)


              var LIST_MENS = this.selectedAsignarMensajero
              if (localStorage.printerSelect != null) {
              }
              var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
              var impresora = null
              if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
                impresora = JSON.parse(localStorage.printerSelect).nombre
              }

              var msg = {
                accion: "print",
                formato: this.caja.formatoimpresioncontado.trim(),
                impresora: impresora,
                data: this.configuraciones,
                list: LIST_MENS,
                caja: this.caja,
                cajero: this.$store.getters.GetOtrasConfigPv.cajero,
                mensajero: this.buscarMensajero,
              }
              this.imprimir(msg, "list-delivery")

            })
            .catch((error) => {
                this.loading(false)
                this.alerta("Dato no guardado correctamente", "error")
              },
            )


          /* await Promise.all(this./asignarDomicilioMensajero.map(async (d) => {
          this.$axios
              .get(
                this.$hostname +
                this.$hName +
                "/Mesajeros/asignar/" +
                d.codigo +
                "/" +
                this.MensageroSeleccionado.codigo,
                { headers: this.$store.getters.GetheadersAxios }
              )
              .then((res) => {
                this.CancelarVerAsignarMensajero();
                this.loading(false)
                this.ejecucion = true;
              });

       }));*/

          /*this.selectedAsignarMensajero.forEach((d) => {
            this.$axios
              .get(
                this.$hostname +
                this.$hName +
                "/Mesajeros/asignar/" +
                d.codigo +
                "/" +
                this.MensageroSeleccionado.codigo,
                { headers: this.$store.getters.GetheadersAxios }
              )
              .then((res) => {
                this.CancelarVerAsignarMensajero();
                this.loading(false)
                this.ejecucion = true;
              });
          });*/
        }

      },


    imprmirFacturaRutaMensagero() {
      var LIST_MENS = this.RFacturasRutasMensajeros.filter((ee) => ee.mensajero.nombre === this.buscarMensajero.nombre)
      if (localStorage.printerSelect != null) {
      }
      var selectImpre = impresora = JSON.parse(localStorage.printerSelect)
      var impresora = null
      if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
        impresora = JSON.parse(localStorage.printerSelect).nombre
      }
      var msg = {
        accion: "print",
        formato: this.caja.formatoimpresioncontado.trim(),
        impresora: impresora,
        data: this.configuraciones,
        list: LIST_MENS,
        caja: this.caja,
        cajero: this.$store.getters.GetOtrasConfigPv.cajero,
        mensajero: this.buscarMensajero,
      }
      this.imprimir(msg, "list-delivery")


    },


    // Validando el formulario y si es válido está poniendo a false la variable ejecución.
    SalvarAsignadoMensagero() {
      if (this.$refs.formAsignarMensagero.validate()) {
        if (this.ejecucion == true) {
          this.ejecucion = false
        }
      } else {
        this.alerta("los campos en rojo son requeridos", "error")
      }
    },
    // Una función que se llama cuando el usuario selecciona un mensejero de un menú desplegable.
    getChangeBuscarMensajero(e) {
      if (e != null) {
        this.FacturaDomicilioMensajero = null
        this.RFacturasDomicilio = []
        this.RRecibirMensajeros = []
        this.selectedRecibirMensajeros = []
        this.selectedAsignarMensajero = []
        this.MensageroSeleccionado = JSON.parse(JSON.stringify(e))
        if (this.dialogAsignarMensajeros == true) {
          this.CargarFacturasDomicilio()
        }
        if (this.dialogRecibirMensajeros == true) {
          this.VerFacturaDomicilioMensajero = false
          this.FacturaDomicilioMensajero = null
          this.CargarRecibirMensajeros()
        }

        if (this.dialogFacturasRutasMensajeros == true) {
          this.CargarFacturasRutasMensajeros()
        }

        if (this.dialogCambiarMensajeros == true) {
          this.CargarRecibirMensajeros()
        }

       // console.log('codigoMensajero-->',e.codigo)
       // console.log('buscarMensajero-->',this.buscarMensajero)
        this.getCantFactAsignarMensajero(this.buscarMensajero)
          //this.buscarMensajero

      } else {
        this.MensageroSeleccionado = {
          codigo: 0,
          nombre: "",
          telefono: "",
          cedula: "",
          metadeenvios: 0,
          sucursal: { descripcion: "" },
        }

        this.FacturaDomicilioMensajero = null
      }

      // buscarMensajero:null,
      // Rmensajero:[],
      // RFacturasDomicilio:[],
      // MensageroSeleccionado:{
      //   codigo:0,
      //   nombre:'',
      //   telefono:'',
      //   cedula:'',
      //   metadeenvios: 0,
      //   sucursal:{descripcion:""}
      //   },
      // getChangeBuscarMensajero,SelctCbBuscarMensajero,cargarBuscarMensajero,CbFilBuscarMensajero(){headers:this.$store.getters.GetheadersAxios}
    },
    // Realización de una solicitud al servidor para actualizar el estado del pedido.
    slvarEntregado() {
      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv("AccMensajeroEntregado")
        return
      }

       
      if(this.cambioPagoDomicilio!=null && this.cambioPagoDomicilio.hasOwnProperty('codigo') && this.cambioPagoDomicilio.codigo==2 && this.cambioTipoTarjetaDomicilio==null){
       this.alerta("Seleccione el tipo de tarjeta", "error")
        return
      }
      
// codicion de cambio: tarjeta a efectivo:1
//efectivo atarjeta 2
      var dom = this.selectedRecibirMensajeros[0]
      var cambioPago = null
      var CAMBIO_a_EFE_TARJ_CHE_TRANS = 0
     var codtipotarjeta=0

     if(this.cambioPagoDomicilio!=null && this.cambioPagoDomicilio.hasOwnProperty('codigo') && this.cambioPagoDomicilio.codigo==2 && this.cambioTipoTarjetaDomicilio!=null){
        codtipotarjeta=this.cambioTipoTarjetaDomicilio.codigo
      }


      if (this.cambioPagoDomicilio != null && this.verificarCambioPagoDomicilio(this.FacturaDomicilioMensajero) == true) {
        cambioPago = this.cambioPagoDomicilio.descripcion
        CAMBIO_a_EFE_TARJ_CHE_TRANS = this.cambioPagoDomicilio.codigo
      }

      this.loading(true)


      var _this = this
      this.$axios
        .get(this.$hostname + this.$hName + "/cierrecaja/ultimocierre/" +
          this.caja.codigo + "/", { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.CierresCajas.cierrescajasPK.secuencia = res.data
          if (this.caja.codigo == this.FacturaDomicilioMensajero.caja.codigo && res.data == this.FacturaDomicilioMensajero.numerocierre) {

          } else {

            var OBJ = {
              facturasventaPK: this.FacturaDomicilioMensajero.facturasventaPK,
              numerocierre: res.data,
              caja: this.caja,
            }

            var configPv = this.$store.getters.GetConfiguracionGeneral.configPv

            if (!configPv.hasOwnProperty("actualizarFacturaDomicilioCajaRecibe") || configPv.hasOwnProperty("actualizarFacturaDomicilioCajaRecibe") && configPv.actualizarFacturaDomicilioCajaRecibe == true) {
              this.actualizaFacturaCierreCaja(OBJ, true)
            }


          }

          this.$axios.get(this.$hostname + this.$hName +
            "/Mesajeros/" + dom.codigo + "/" + true + "/actualizar/" + CAMBIO_a_EFE_TARJ_CHE_TRANS + "/" + res.data+"/"+codtipotarjeta,
            { headers: this.$store.getters.GetheadersAxios },
          )
            .then((res) => {
              this.VerFacturaDomicilioMensajero = false
              this.selectedRecibirMensajeros = []
              this.alerta("Factura Entregada Correctamente !!!", "bien")
              this.CargarRecibirMensajeros()
              this.loading(false)
            })

        })

    },


    salvarNoEntregado() {
      if (this.EjecutarPermisoPv == false) {
        this.funcionValidaPermisoPv("AccMensajeroNoEntregado")
        return
      }

      var doc = this.caja.sucursal.documentoNotaCredito
      //var doc=this.caja.sucursal.documentofacturacredito
      this.$axios.get(this.$hostname + this.$hName + "/documentocxc/find/" + doc,
        { headers: this.$store.getters.GetheadersAxios },
      ).then(resdoc => {

        if (resdoc.data.comprobante == true) {
          // ---->/secuenciaComprobantes/existesecuencia/
          // var link = resdoc.data.codigo +"/" + "CXC"

          var link = resdoc.data.codigo + "/" + "CXC/" + this.caja.sucursal.rnc.trim()
          this.$axios.get(this.$hostname + this.$hName + "/secuenciaComprobantes/existesecuenciaRnc/" + link,
            { headers: this.$store.getters.GetheadersAxios })
            .then(res => {
              if (res.data == true) {

                var _this = this
                setTimeout(function() {
                  _this.continuarsalvarNoEntregado()
                }, 600)

              } else {
                this.alerta("No posee secuencia para la Notas de Crédito que está intentado realizar", "error")
              }
            })
            .catch(error => {
              this.alerta(error, "error")
              this.loading(false)

            })

        } else {
          this.continuarsalvarNoEntregado()
        }


      })

    },


    continuarsalvarNoEntregado() {

      if (this.FacturaDomicilioMensajero.signatureValue != null) {
        // var BOOL_FACELEC=this.DevolucionFacturaSeleccionada.signatureValue!=null && this.caja.facturacionEletronica !=true && this.caja.sucursal.facturacionEletronica!=true
        var BOOL_FACELEC = this.caja.facturacionEletronica === true && this.caja.sucursal.facturacionEletronica === true
        if (BOOL_FACELEC == false) {
          this.alerta("NOTA: Esta factura fue generada con comprobante eletronico y la caja/sucursal no esta asignada con facturación electronica", "error")
          return
        }
      }

      var dom = this.selectedRecibirMensajeros[0]
      this.loading(true)
      this.$axios
        .get(this.$hostname + this.$hName + "/cierrecaja/ultimocierre/" +
          this.caja.codigo + "/", { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.CierresCajas.cierrescajasPK.secuencia = res.data
          if (this.caja.codigo == this.FacturaDomicilioMensajero.caja.codigo && res.data == this.FacturaDomicilioMensajero.numerocierre) {

            var _this = this
            setTimeout(function() {
              _this.contProcSalvarNoEntregado()
            }, 300)

          } else {


            var configPv = this.$store.getters.GetConfiguracionGeneral.configPv

            var OBJ = {
              facturasventaPK: this.FacturaDomicilioMensajero.facturasventaPK,
              numerocierre: res.data,
              caja: this.caja,
            }
            if (!configPv.hasOwnProperty("actualizarFacturaDomicilioCajaRecibe") || configPv.hasOwnProperty("actualizarFacturaDomicilioCajaRecibe") && configPv.actualizarFacturaDomicilioCajaRecibe == true) {
              this.actualizaFacturaCierreCaja(OBJ, false)
            } else {
              this.contProcSalvarNoEntregado()
            }

          }

        })

    },


    contProcSalvarNoEntregado() {
      var dom = this.selectedRecibirMensajeros[0]
      this.$axios.get(this.$hostname + this.$hName + "/Mesajeros/" +
        dom.codigo + "/" + false + "/" + this.CierresCajas.cierrescajasPK.secuencia + "/actualizar",
        { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          var df = JSON.parse(JSON.stringify(this.FacturaDomicilioMensajero))
          var BOOL_ELET = this.caja.sucursal.facturacionEletronica == true && this.caja.facturacionEletronica == true && df.hasOwnProperty("signatureValue") && df.signatureValue != null
          if (BOOL_ELET == true && df.hasOwnProperty("cobertura") && df.cobertura != null && df.cobertura > 0) {
            this.AnulacionFacturaSalvarNoEntregado(df)
          } else {
            this.DevolucionAdomicilioNoentregado()
          }


          var _this = this
          setTimeout(function() {
            _this.VerFacturaDomicilioMensajero = false
            _this.selectedRecibirMensajeros = []
            //   _this.alerta("Factura No Entregada Correctamente !!!", "bien");
            _this.CargarRecibirMensajeros()
            _this.loading(false)
          }, 800)
        })

    },

    AnulacionFacturaSalvarNoEntregado(FACT) {

      var link = `${FACT.facturasventaPK.secuencia}/${FACT.facturasventaPK.documento}`
      this.$axios
        .get(
          this.$hostname + this.$hName + "/devolucion/devolucionFactura/" + link,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {

          if (res.data == true) {
            this.alerta("Esta factura no puede ser anulada, porque tiene devoluciones de venta aplicada", "error")
            return
          } else {

            // if (this.AnulacionFacturaSeleccionada.cxc > 0 && this.AnulacionFacturaSeleccionada.valor != this.AnulacionFacturaSeleccionada.pendiente)
            if (FACT.cxc > 0 && FACT.cxc != FACT.pendiente) {
              this.alerta("Esta factura no se puede anular ya que posee algún movimiento.", "error")
              return
            }
            if (this.ejecucion == true) {
              this.ejecucion = false
              var BOOL_ELET = FACT.hasOwnProperty("signatureValue") && FACT.signatureValue != null

              if (BOOL_ELET == true) {
                var OBJ = {
                  documento: FACT.documentoFactura,
                  factura: FACT.facturasventaPK.secuencia,
                  ncf: FACT.ncf.trim(),
                  tipoAnulacion: this.RTipoAnulacion[6],
                  movimiento: false,
                  facturasventa: FACT,
                  numerocierre: this.CierresCajas.cierrescajasPK.secuencia,
                  caja: this.caja,
                  sucursal: this.caja.sucursal,
                }
                this.$refs.RefComponentsAnularFacturas.continuandoFinalizarDevolucionFactura(OBJ)
              } else {
                this.hacerAnulacion(FACT)
              }
            }

          }

        })
        .catch((error) => {
          console.error(error)
        })

    },

    // Este metodo actualiza la factura con el cierre y la caja actual
    //BOOL: si es (true) metodo domicilio entregado de lo contrario es no entregado
    actualizaFacturaCierreCaja(OBJ, BOOL) {
      this.$axios.post(this.$hostname + this.$hName + "/pv/updateFacturaCierreCaja",
        OBJ, { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          if (BOOL == true) {

          } else {
            this.contProcSalvarNoEntregado()
          }
          // this.alerta("Dato guardado correctamente!", "bien2");

        })
        .catch((error) => {
            console.log(error)
            this.loading(false)
            this.alerta("Proceso no realizado correctamente", "error")
          },
        )
    },


    // Creando un nuevo objeto y asignándolo a la variable DevolucionFacturaSeleccionada.
    DevolucionAdomicilioNoentregado() {

      this.DevolucionSelected = []
      //var df= this.selectedRecibirMensajeros[0]
      var df = JSON.parse(JSON.stringify(this.FacturaDomicilioMensajero))
      this.DevolucionSelected.push(df)
      var obj = {
        secuencia: df.facturasventaPK.secuencia,
        fecha: new Date(),
        ncf: df.ncf,
        cliente: df.cliente.nombre,
        cedula: df.cliente.cedrnc != null ? df.cliente.cedrnc : "",
        comentario: "domicilio No entregado",
        turno: null,
        formapago: "",
        DetalleList: df.facturasventaDetalleList,
        SeletDetalleList: df.facturasventaDetalleList,
        efectivo: true,
        quitaritbis: false,
        cheques: df.cheques,
        cupones: df.cupones,
        cxc: df.cxc,
        Pagoefec: df.efectivo,
        puntos: df.puntos,
        tarjeta: df.tarjeta,
        valorNc: df.valorNc,
        transferencia: df.transferencia,
        domicilionoentregado: true,
        devtarjeta: false,
        qrdgii: null,
        signatureValue: null,
        trackId: null,
        fechafirmadgii: null,
        //qrdgii:df.hasOwnProperty("qrdgii") && df.qrdgii != null ? df.qrdgii : null,
        //signatureValue:df.hasOwnProperty("signatureValue") && df.signatureValue != null ? df.signatureValue : null,
        //  trackId:df.hasOwnProperty("trackId") && df.trackId != null ? df.trackId : null,
        //fechafirmadgii:df.hasOwnProperty("fechafirmadgii") && df.fechafirmadgii != null ? df.fechafirmadgii : null

      }
      obj.valordevolucion= df.facturasventaDetalleList.reduce((total, item) => total + item.valor, 0);

      this.AceptarDevolucion = {
        nombre: df.cliente.nombre,
        cedula: df.cliente.cedrnc != null ? df.cliente.cedrnc : "",
      }
      this.DevolucionFacturaSeleccionada = JSON.parse(JSON.stringify(obj))
      var _this = this
      setTimeout(function() {
        _this.FinalizarDevolucionFactura()
      }, 500)


    },


    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbBuscarMensajero() {
      if (this.buscarMensajero == null) {
        this.buscarMensajero = ""
      }
      if (this.buscarMensajero.codigo == undefined) {
        this.buscarMensajero = ""
        this.alerta("Seleccione un mensajero", "error")
        return
      }
    },
    // Hacer una solicitud al servidor y devolver los datos de la factura no asignada.
    CargarFacturasDomicilio() {
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/Mesajeros/sin-agignar/" +
          this.caja.sucursal.codigo +
          "",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.RFacturasDomicilio = res.data
        })
    },
    // Hacer una llamada axios al servidor y devolver los datos del mensajero adomicilio.
    CargarRecibirMensajeros() {
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/Mesajeros/asignados/" +
          this.caja.sucursal.codigo +
          "/" +
          this.MensageroSeleccionado.codigo,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.RRecibirMensajeros = res.data
          this.totalDomicilio.valor = 0
          res.data.forEach(element => {
            this.totalDomicilio.valor += element.valor + element.devuelta
          })
        })
    },


    CargarFacturasRutasMensajeros() {

      this.$axios.get(this.$hostname + this.$hName +
        "/Mesajeros/asignados/" +
        this.caja.sucursal.codigo,
        { headers: this.$store.getters.GetheadersAxios },
      )
        .then((res) => {
          this.RFacturasRutasMensajeros = res.data
        })


      /* this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/Mesajeros/asignados/" +
          this.caja.sucursal.codigo +
          "/" +
          this.MensageroSeleccionado.codigo,
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => {
          this.RFacturasRutasMensajeros = res.data;
        });*/
    },

    // Hacer una solicitud al servidor y devolver los datos al Vue HTML.
    cargarBuscarMensajero() {

      this.Rmensajero = []
      if (this.caja == null) {
        this.alerta("Seleccione una caja", "error")
        return 0
      }

      var filtrarMensajerosSucursal = (lista) => {
        return (lista || []).filter((ee) => ee.sucursal == null || ee.sucursal != null && ee.sucursal.hasOwnProperty("codigo") && ee.sucursal.codigo == this.caja.sucursal.codigo)
      }
      var cargarActivos = () => {
        this.$axios.get(this.$hostname + this.$hName + "/Mesajeros/findall/activos", {
          headers: this.$store.getters.GetheadersAxios,
        }).then((res) => {
          this.guardarMensajerosOffline(res.data)
          this.Rmensajero = filtrarMensajerosSucursal(res.data)
        }).catch(() => this.cargarMensajerosOffline())
      }

      if (this.dialogAsignarMensajeros == true) {
        cargarActivos()
      }

      if (this.dialogRecibirMensajeros == true) {
        this.$axios.get(this.$hostname + this.$hName + "/Mesajeros/findall/recibir", {
          headers: this.$store.getters.GetheadersAxios,
        }).then((res) => {
          this.Rmensajero = res.data
          this.guardarMensajerosOffline(res.data)
        }).catch(() => this.cargarMensajerosOffline())
      }

      if (this.dialogFacturasRutasMensajeros == true) {
        cargarActivos()
      }

      if (this.dialogCambiarMensajeros == true) {
        cargarActivos()
      }

    },

    // Hacer una solicitud al servidor y devolver los datos de la factura no asignada.
    getCantFactAsignarMensajero(OBJ) {

      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/Mesajeros/cantFactAsignarMensajero/" +OBJ.codigo +"",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          OBJ.cantFactAsignada=res.data.cantFactAsignada
         // this.RFacturasDomicilio = res.data.cantFactAsignada
        })
    },

    async filterDataTableAsigMensajeroCaja(item) {

      if (this.filtroAsigMensajero.caja != null) {
        // this.CargarFacturasDomicilioCajaFilSelect(this.filtroAsigMensajero.caja.sucursal)
        /*var ObjProRow = item.filter((ee) => ee.caja == this.filtroAsigMensajero.caja.codigo);
      return ObjProRow*/
        const result = await this.CargarFacturasDomicilioCajaFilSelect(this.filtroAsigMensajero.caja.sucursal)
        this.RFacturasDomicilio = result.filter((ee) => ee.caja == this.filtroAsigMensajero.caja.codigo)
        //return result;

      } else {

        const result = await this.CargarFacturasDomicilioCajaFilSelect(this.caja.sucursal)
        this.RFacturasDomicilio = result
        // return result;
        // return item
      }


    },


    async CargarFacturasDomicilioCajaFilSelect(SUCURSAL) {
      return new Promise((resolve, reject) => {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/Mesajeros/sin-agignar/" +
            SUCURSAL.codigo +
            "",
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            resolve(res.data)
            // return res.data;
          })
          .catch(error => {
            resolve([])
          })

      })

    },


    filterDataTableAsigMensajeroSecto(item) {
      var tex = ""
      if (this.filtroAsigMensajero.sector.length > 0) {
        tex = this.filtroAsigMensajero.sector
      }
      var textOne = ""
      // typeof val === 'string'
      if (item != null && typeof item === "string") {
        textOne = item.toLowerCase()
      }

      const searchText = tex.toLowerCase()
      return textOne.indexOf(searchText) > -1

    },


    filterDataTableAsigMensajeroFact(item) {
      var tex = ""
      if (this.filtroAsigMensajero.fact.length > 0) {
        tex = this.filtroAsigMensajero.fact
      }
      const textOne = item.toLowerCase()
      const searchText = tex.toLowerCase()
      return textOne.indexOf(searchText) > -1

    },

    filterDataTableFacturaRutaCliente(item) {
      var tex = ""
      if (this.filtroFacturaRutaCliente.length > 0) {
        tex = this.filtroFacturaRutaCliente
      }
      const textOne = item.toLowerCase()
      // if(item!=null){ }
      const searchText = tex.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },


    filterDataTableFacturaRutaMensajero(item) {
      var tex = ""
      if (this.buscarMensajero != null && this.buscarMensajero.hasOwnProperty("nombre")) {
        tex = this.buscarMensajero.nombre

      }
      const textOne = item.toLowerCase()
      // if(item!=null){ }
      const searchText = tex.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },


    obtenerDatoSelectCambioMensajeroClickRow(e) {
      this.selectedCambiarMensajeros = []
      this.selectedCambiarMensajeros.push(e)
    },

    SelctCbNuevoMensajero() {

      var _this = this
      setTimeout(function() {
        if (_this.nuevoMensajeroSelect == null) {
          _this.nuevoMensajeroSelect = ""
        }

        if (!_this.nuevoMensajeroSelect.hasOwnProperty("codigo")) {
          _this.nuevoMensajeroSelect = ""
          _this.nuevoMensajeroSelect = null
          return
        }
      }, 300)

    },

    cambiarMensajeroSelecionado() {

      if (this.nuevoMensajeroSelect != null && this.nuevoMensajeroSelect.hasOwnProperty("nombre")) {

        var MENS_SELEC = JSON.parse(JSON.stringify(this.selectedCambiarMensajeros[0]))
        MENS_SELEC.mensajero = JSON.parse(JSON.stringify(this.nuevoMensajeroSelect))

        //Mesajeros/asignar/{domicilio}/{mensajero}

        this.loading(true)

        var CODIGO_NEW_MEN = this.nuevoMensajeroSelect.codigo


        var bar = new Promise((resolve, reject) => {
          this.selectedCambiarMensajeros.forEach(elem => {
            var CODIGO_DOM = elem.codigo
            this.$axios.get(this.$hostname + this.$hName +
              "/Mesajeros/asignar/" + CODIGO_DOM + "/" + CODIGO_NEW_MEN,
              { headers: this.$store.getters.GetheadersAxios },
            )
              .then((res) => {
                resolve()
              })

          })

        })

        bar.then(() => {
          console.log("All done cambio mensajero!")

          this.$axios.get(this.$hostname + this.$hName +
            "/Mesajeros/asignados/" +
            this.caja.sucursal.codigo,
            { headers: this.$store.getters.GetheadersAxios },
          )
            .then((res) => {
              var LIST_MENS = res.data.filter((ee) => ee.mensajero.nombre === this.nuevoMensajeroSelect.nombre)
              if (localStorage.printerSelect != null) {
              }
              var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
              var impresora = null
              if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
                impresora = JSON.parse(localStorage.printerSelect).nombre
              }

              var msg = {
                accion: "print",
                formato: this.caja.formatoimpresioncontado.trim(),
                impresora: JSON.parse(localStorage.printerSelect).nombre,
                data: this.configuraciones,
                list: LIST_MENS,
                caja: this.caja,
                cajero: this.$store.getters.GetOtrasConfigPv.cajero,
                mensajero: this.nuevoMensajeroSelect,
              }
              this.imprimir(msg, "list-delivery")


              this.alerta(" Domicilio asignado correctamente !!!", "bien2")
              this.selectedCambiarMensajeros = []
              this.nuevoMensajeroSelect = null
              this.buscarMensajero = null
              this.RRecibirMensajeros = []

            })

        })


      } else {
        this.alerta("Seleccione un mensajero nuevo", "error")
      }

    },


    obtenerDatoSelectFactDomicilioClickRow(e) {
      var ObjProRow = this.selectedAsignarMensajero.filter((ee) => ee.codigo == e.codigo)
      if (ObjProRow.length == 0) {
        this.selectedAsignarMensajero.push(e)
      }
    },


// Obtener los datos del servidor y luego configurar los datos en la variable
// FacturaDomicilioMensajero.

    obtenerDatoSelectRecibirMensajerosClickRow(e) {


      this.FacturaDomicilioMensajero = null
      this.selectedRecibirMensajeros = []

      this.selectedRecibirMensajeros.push(e)
      this.cambioPagoDomicilio = null
      this.cambioTipoTarjetaDomicilio=null
      // if(e.value==true){}
      this.$axios
        .get(
          this.$hostname + this.$hName + "/Mesajeros/asignar/" + e.codigo + "",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          if (res.data.toString().length != 0) {
            var obj = res.data
            obj.devuelta = e.devuelta
            obj.ComentarioLeido = false
            // this.FacturaDomicilioMensajero=res.data,
            this.FacturaDomicilioMensajero = obj
            this.VerFacturaDomicilioMensajero = true
            console.log("VerFactura-->Mej-->", res.data)

            if (this.verificarCambioPagoDomicilio(obj) == true) {
              if (obj.efectivo > 0) {
                this.cambioPagoDomicilio = JSON.parse(JSON.stringify(this.RCambioPagoDomicilio[0]))
              }

              if (obj.tarjeta > 0) {
                this.cambioPagoDomicilio = JSON.parse(JSON.stringify(this.RCambioPagoDomicilio[1]))
              }

              if (obj.cheques > 0) {
                this.cambioPagoDomicilio = JSON.parse(JSON.stringify(this.RCambioPagoDomicilio[2]))
              }

              if (obj.transferencia > 0) {
                this.cambioPagoDomicilio = JSON.parse(JSON.stringify(this.RCambioPagoDomicilio[3]))
              }

            }

          }
        })

    },
    // Obteniendo los datos del servidor y asignándolos a la variable FacturaDomicilioMensajero.
    obtenerDatoSelectRecibirMensajeros(e) {
      this.FacturaDomicilioMensajero = null
      if (e.value == true) {
        this.obtenerDatoSelectRecibirMensajerosClickRow(e.item)
      } else {

        this.obtenerDatoSelectRecibirMensajerosClickRow(e.item)
        /* var _this = this;
        setTimeout(function () {
          _this.VerFacturaDomicilioMensajero = false;
          _this.FacturaDomicilioMensajero = null;
          _this.CargarRecibirMensajeros();
        }, 500);*/
        // this.buscarMensajero=null
      }

      return
      /* if (e.value == true) {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/Mesajeros/asignar/" +
            e.item.codigo +
            "",
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then((res) => {
            if (res.data.toString().length != 0) {
              var obj = res.data;
              obj.ComentarioLeido = false;
              // this.FacturaDomicilioMensajero=res.data,
              this.FacturaDomicilioMensajero = obj;
              this.VerFacturaDomicilioMensajero = true;
              if(obj.efectivo>0){
           this.cambioPagoDomicilio=JSON.parse(JSON.stringify(this.RCambioPagoDomicilio[0]))
          }

          if(obj.tarjeta>0){
           this.cambioPagoDomicilio=JSON.parse(JSON.stringify(this.RCambioPagoDomicilio[1]))
          }
            }
          });
      }*/
    },


    calcularTotalRecibirMensajero() {

      this.selectedRecibirMensajeros = []


    },

    obtenerDatoAsignarMensajero() {
      if (e.value == true) {
        this.RDetFactura = []
        setTimeout(this.allobtener, 200)
      }
      if (e.value == false) {
        this.RDetFactura = []
        setTimeout(this.allobtener, 200)
      }
    },

    async keyupEnterAsigMensajFact(item) {
    //  console.log('2-',typeof item.target.value )
          var TG_VALUE=""
          if(item.target.value.trim().length > 0) {
          TG_VALUE = item.target.value.trim()
          }else{
            return
          }


      // var listFt= JSON.parse(JSON.stringify(this.RFacturasDomicilio.filter((ee) => ee.numeroFactura=TG_VALUE )))
       
   //var TG_VALUE="2707"
   var listFt= this.RFacturasDomicilio.filter((ee) => ee.numeroFactura!=null && ee.numeroFactura.trim().length > 0 && ee.numeroFactura.trim().includes(TG_VALUE)) 

const nuevosArrays = listFt.filter(item =>
  !this.selectedAsignarMensajero.some(sel => sel.numeroFactura === item.numeroFactura)
);


if(nuevosArrays.length>0){
  this.selectedAsignarMensajero.push(...nuevosArrays)
}


// RFactSELECT.push(...nuevos);


      var _this = this
      setTimeout(function() { 
        _this.filtroAsigMensajero.fact=""
        _this.$refs.RefFilAsigMenFactTextField.focus()
      }, 1500)



     // if(e.target.value.trim().length > 0) {}
     //typeof _this.CotizacionBusqueda.cliente ==="string"
    },





    OpenDialogCotizacion() {
      if (this.RProductoCompra.length == 0) {
        this.alerta("Debe de Agregar al menos un producto a la lista", "error")
        return
      }
      this.dialogCotizacion = true
      this.newnewCotizacion()


      if (this.cotizacionAfacturaSelect != null) {
        if (this.cotizacionAfacturaSelect.cliente != null) {
          this.CotizacionFact.cliente = this.cotizacionAfacturaSelect.cliente
        }
        this.CotizacionFact.nombrecliente = this.cotizacionAfacturaSelect.nombrecliente
        if (this.cotizacionAfacturaSelect.provedorEstado != null) {
          this.CotizacionFact.provedorEstado = this.cotizacionAfacturaSelect.provedorEstado
        } else {
          this.CotizacionFact.provedorEstado = false
        }

        this.CotizacionFact.telefono = this.cotizacionAfacturaSelect.telefono
        this.CotizacionFact.conceptoPago = this.cotizacionAfacturaSelect.conceptoPago
        this.CotizacionFact.concepto = this.cotizacionAfacturaSelect.concepto
        this.CotizacionFact.valido = this.cotizacionAfacturaSelect.valido
        this.CotizacionFact.correo = this.cotizacionAfacturaSelect.correo
        this.CotizacionFact.direccion = this.cotizacionAfacturaSelect.direccion

      } else {
        if (this.clienteFactura != null) {
          this.CotizacionFact.cliente = this.clienteFactura
          this.CotizacionFact.nombrecliente = this.clienteFactura.nombre
          this.CotizacionFact.correo = this.clienteFactura.email
          if (this.clienteFactura.telefonosClientesList.length > 0) {
            this.CotizacionFact.telefono =
              this.clienteFactura.telefonosClientesList[0].telefonosClientesPK.telefono
          }
          this.CotizacionFact.direccion = this.clienteFactura.direccion
        } else {
          this.CotizacionFact.cliente = null
        }
      }

      // this.CotizacionFact.valor = this.Totales.totalGeneral.subtotal;
      this.CotizacionFact.subtotal = this.Totales.totalGeneral.subtotal
      this.CotizacionFact.valor = this.Totales.totalGeneral.subtotal + this.Totales.totalGeneral.itbis - (this.Totales.totalGeneral.descuento)
      this.CotizacionFact.valordescuento = this.Totales.totalGeneral.descuento
      this.CotizacionFact.valorimpuesto = this.Totales.totalGeneral.itbis
      this.CotizacionFact.total = this.Totales.totalGeneral.total

      if (this.ConfImpfiscal == true) {
        this.CotizacionFact.valor = (this.CotizacionFact.valor - this.Totales.totalGeneral.itbis)
      }

      this.CotizacionFact.moneda = JSON.parse(
        JSON.stringify(this.Monedafactura),
      )
    },


    quitarItbisCotizacion() {
      var OBJTO = JSON.parse(JSON.stringify(this.CotizacionFact))

      if (this.CotizacionFact.quitaritbis == true) {
        this.CotizacionFact.subtotal = this.Totales.totalGeneral.subtotal
        this.CotizacionFact.valor = this.Totales.totalGeneral.subtotal - (this.Totales.totalGeneral.descuento)
        this.CotizacionFact.valordescuento = this.Totales.totalGeneral.descuento
        this.CotizacionFact.valorimpuesto = 0

      } else {
        this.CotizacionFact.subtotal = this.Totales.totalGeneral.subtotal
        this.CotizacionFact.valor = this.Totales.totalGeneral.subtotal + this.Totales.totalGeneral.itbis - (this.Totales.totalGeneral.descuento)
        this.CotizacionFact.valordescuento = this.Totales.totalGeneral.descuento
        this.CotizacionFact.valorimpuesto = this.Totales.totalGeneral.itbis

        if (this.ConfImpfiscal == true) {
          this.CotizacionFact.valor = (this.CotizacionFact.valor - this.Totales.totalGeneral.itbis)
        }
      }

    },


    verificarCambioPagoDomicilio(e) {
      var bool = false
// FacturaDomicilioMensajero.efectivo>0 || FacturaDomicilioMensajero.tarjeta>0
      /*if(e.cxc==0 && e.valorNc==0 && e.cheques==0 && e.transferencia==0){
  if(e.tarjeta==0 && e.efectivo>0 ){
    bool=true
  }

  if(e.efectivo==0 && e.tarjeta>0 ){
    bool=true
  }
} */

      if (e.efectivo > 0 && e.tarjeta == 0 && e.valorNc == 0 && e.cheques == 0 && e.transferencia == 0) {
        bool = true
      }
      if (e.tarjeta > 0 && e.efectivo == 0 && e.valorNc == 0 && e.cheques == 0 && e.transferencia == 0) {
        bool = true
      }
      if (e.cheques > 0 && e.efectivo == 0 && e.tarjeta == 0 && e.valorNc == 0 && e.transferencia == 0) {
        bool = true
      }
      if (e.transferencia > 0 && e.efectivo == 0 && e.tarjeta == 0 && e.valorNc == 0 && e.cheques == 0) {
        bool = true
      }

      return bool

    },

    SelctCbCambioPagoDomicilio() {
      var _this = this
      setTimeout(function() {
        if (_this.cambioPagoDomicilio == null) {
          _this.cambioPagoDomicilio = ""
        }
        if (!_this.cambioPagoDomicilio.hasOwnProperty("codigo")) {
          _this.cambioPagoDomicilio = ""
          _this.cambioPagoDomicilio = null
          if (_this.FacturaDomicilioMensajero.efectivo > 0) {
            _this.cambioPagoDomicilio = JSON.parse(JSON.stringify(_this.RCambioPagoDomicilio[0]))
          }

          if (_this.FacturaDomicilioMensajero.tarjeta > 0) {
            _this.cambioPagoDomicilio = JSON.parse(JSON.stringify(_this.RCambioPagoDomicilio[1]))
          }
          return
        }
      }, 300)
    },

    SelctCbCambioTipoTarjetaDomicilio() {
      var _this = this
      setTimeout(function() {
        if (_this.cambioTipoTarjetaDomicilio == null) {
          _this.cambioTipoTarjetaDomicilio = ""
        }
        if (!_this.cambioTipoTarjetaDomicilio.hasOwnProperty("codigo")) {
          _this.cambioTipoTarjetaDomicilio = ""
          _this.cambioTipoTarjetaDomicilio = null
          return
        }
      }, 300)
    },

    TipoFacturaDomicilio(e) {
      var data = ""

      if (this.verificarCambioPagoDomicilio(e) == true) {
        if (e.efectivo > 0) {
          data = "Efetivo"
        }
        if (e.tarjeta > 0) {
          data = "Tarjeta"
        }
        if (e.cheques > 0) {
          data = "Cheques"
        }
        if (e.transferencia > 0) {
          data = "Transferencia"
        }
        if (e.cxc > 0) {
          data = "Cuenta por cobrar"
        }
      } else {
        data = "Multiple: "
        var sting = ""

        if (e.efectivo > 0) {
          sting = "Efetivo"
        }
        if (e.tarjeta > 0) {
          if (sting.length > 0) {
            sting += ", "
          }
          sting += "Tarjeta"
        }

        if (e.cheques > 0) {
          if (sting.length > 0) {
            sting += ", "
          }
          sting += "Cheques"
        }

        if (e.transferencia > 0) {
          if (sting.length > 0) {
            sting += ", "
          }
          sting += "Transferencia"
        }

        if (e.cxc > 0) {
          if (sting.length > 0) {
            sting += ", "
          }
          sting += "Cuenta por cobrar"
        }

        data += `(${sting})`

      }


      /*  if (e.ars != null) {
        return data = " Sequro "
      }

      if (e.telefonoDomicilio != null) {
        return data = " Domicilio "
      }

      if (e.cxc != null && e.cxc > 0) {
        return data = " Cuenta por cobrar "
      }

      if (e.tarjeta != null && e.tarjeta > 0) {
        return data = " Tarjeta ";
      }

      if (e.efectivo != null && e.efectivo > 0) {
        return data = " Efectivo ";
      }*/


      return data
    },


    RecibirDomicilioValor(e) {
      //DevolucionFacturaSeleccionada.DetalleList
      //this.RedondeoBasico(this.Facturasventa.tarjeta)
      //this.DevolucionFacturaSeleccionada.quitaritbis
      var itbisTasa = 0.00
      var itbis = 0.00
      var descuento = 0.00
      var descuentoValor = 0.00
      var precioSinItbis = 0.00
      var valor = 0.00
      if (e.productos.impuesto != null) {
        itbisTasa = e.productos.impuesto.tasa
      }
      if (e.valordescuento > 0) {
        var DESCUENTOVALOR = this.RecibirDomicilioDescuento(e)
        descuentoValor = this.RedondeoValor(DESCUENTOVALOR / e.cantidad)
      }
      if (e.descuento > 0) {
        if (itbisTasa > 0) {
          if (e.productos.incluirimpuestoenprecio) {
            descuento = e.cantidad * this.RedondeoValor(((e.precio / (1 + (itbisTasa / 100))) * (e.descuento / 100)))
            precioSinItbis = e.cantidad * this.RedondeoValor((e.precio / (1 + (itbisTasa / 100))))
            itbis = this.RedondeoValor((precioSinItbis - descuento) * (itbisTasa / 100))
            valor = (precioSinItbis - descuento) + itbis
          } else {
            descuento = e.cantidad * this.RedondeoValor((e.precio * (e.descuento / 100)))
            precioSinItbis = e.cantidad * this.RedondeoValor(e.precio)
            itbis = this.RedondeoValor((precioSinItbis - descuento) * (itbisTasa / 100))
            valor = (precioSinItbis - descuento) + itbis
          }
        } else {
          if (descuentoValor > 0) {
            valor = (e.cantidad * e.precio) - (e.cantidad * descuentoValor)
          } else {
            valor = e.cantidad * (e.precio) * (e.descuento / 100)
          }
        }
      } else {
        if (e.valorimpuesto > 0) {
          valor = e.cantidad * (e.precio - e.valorimpuesto)
        } else {
          valor = e.cantidad * (e.precio)
        }
      }
      e.valor = valor
      return e.valor
    },

    RecibirDomicilioDescuento(ee) {

      var Cant = ee.cantidad
      var PrecioVal = 0


      if (this.ConfImpfiscal == true) {
        PrecioVal = ee.precio
      } else {

        if (ee.productos.incluirimpuestoenprecio == true) {
          if (ee.productos.impuesto != null) {
            PrecioVal = (ee.precio) / (1 + (ee.productos.impuesto.tasa / 100))
          } else {
            PrecioVal = ee.precio
          }
        } else {

          PrecioVal = ee.precio
        }

      }

// ee.DescValor = ((ee.descuento * (PrecioVal * Cant)) / 100)
      var valordescuento = ((ee.descuento * (PrecioVal * Cant)) / 100)

      return valordescuento

    },


    // Creando un nuevo objeto y asignándolo a la variable CotizacionFact.
    newnewCotizacion() {
      this.CotizacionFact = {
        secuencia: 0,
        activo: false,
        caja: null,
        concepto: "",
        conceptoPago: "",
        correo: "",
        direccion: "",
        facturada: false,
        fecha: new Date(),
        moneda: null,
        nombrecliente: "",
        sucursal: null,
        tasa: 1,
        telefono: "",
        valido: "",
        valor: 0,
        valordescuento: 0,
        valorimpuesto: 0,
        cotizacionDetalleList: [],
        subtotal: 0,
        quitaritbis: false,
        provedorEstado: false,
      }
      this.CotizacionImp = { CotImg: false, ProForma: false }
    },
    // Cerrar el cuadro de diálogo y restablecer el formulario.
    cancelarCotizacion() {
      this.dialogCotizacion = false
      this.newnewCotizacion()
    },
    // Guardando los datos en la base de datos de la cotizacion.
    SalvarCotizacion() {
      this.CotizacionFact.caja = this.caja.codigo
      // this.CotizacionFact.cajero=this.OtrasConfigPv.cajero
      this.CotizacionFact.sucursal = this.caja.sucursal
      this.CotizacionFact.cotizacionDetalleList = []
      if (this.CotizacionFact.correo == null) {
        this.CotizacionFact.correo = " "
      }
      var bar = new Promise((resolve, reject) => {
        this.RProductoCompra.forEach(async (d) => {
          d.valorimpuesto = 0
          d.impuestoIncluido = d.productos.incluirimpuestoenprecio
          if (d.productos.incluirimpuestoenprecio == true) {
            if (d.productos.impuesto != null) {
              d.valorimpuesto = d.precio - d.precio / (1 + d.productos.impuesto.tasa / 100)

              if (this.CotizacionFact.quitaritbis == true) {
                d.precio = d.precio - d.valorimpuesto
              }
            }
          }
          if (d.productos.incluirimpuestoenprecio == false) {
            if (d.productos.impuesto != null) {
              d.valorimpuesto = d.precio * (d.productos.impuesto.tasa / 100)
            }
          }
          if (this.CotizacionFact.quitaritbis == true) {
            d.valorimpuesto = 0
          }
          this.llenarDetalleCotizacion(d)
          resolve()
        })

      })

      bar.then(() => {
        console.log("All done SalvarCotizacion!")
        this.CotizacionFact.moneda = this.Monedafactura.codigo
        this.CotizacionFact.pv = true
        this.loading(true)

        var COTIZACIONFACT = JSON.parse(JSON.stringify(this.CotizacionFact))
        if (this.cotizacionAfacturaSelect != null) {
          COTIZACIONFACT.secuencia = this.cotizacionAfacturaSelect.secuencia
        }
        COTIZACIONFACT.borrado = false

        if (this.Facturasventa.vendedor != null && this.Facturasventa.vendedor.hasOwnProperty("codigo")) {
          COTIZACIONFACT.vendedor = this.Facturasventa.vendedor
        } else {
          COTIZACIONFACT.vendedor = null
        }
        COTIZACIONFACT.subTotal= parseFloat(this.currencyFormatter2(COTIZACIONFACT.subtotal).replaceAll(',', ''))

        COTIZACIONFACT.retencion = this.Totales.totalGeneral.Retencion > 0 ? this.Totales.totalGeneral.Retencion : 0

        this.$axios
          .post(
            this.$hostname + this.$hName + "/cotizacion/save",
            COTIZACIONFACT,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            var obj = JSON.parse(JSON.stringify(res.data))
            obj.CotImg = this.CotizacionImp.CotImg
            obj.ProForma = this.CotizacionImp.ProForma
            if (localStorage.printerSelect != null) {
            }
            var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
            var impresora = null
            if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
              impresora = JSON.parse(localStorage.printerSelect).nombre
            }
            var msg = {
              accion: "print",
              formato: this.caja.formatoimpresioncontado.trim(),
              impresora: impresora,
              data: this.configuraciones,
              fac: obj,
              caja: this.caja,
              cajero: this.$store.getters.GetOtrasConfigPv.cajero,
            }
            this.imprimir(msg, "cotizacion")


            this.alerta("Cotizacion Realizada Correctamente !!!", "bien")
            this.dialogCotizacion = false
          })
      })


    },
    // Agregar un nuevo objeto a una cotizacion.
    llenarDetalleCotizacion(dato) {
      var detalle = {
        cotizacionDetallePK: { secuencia: 0, producto: 0, unidad: 0, id: 0 },
        cantidad: dato.cantidad,
        valordescuento: dato.valordescuento,
        valorimpuesto: dato.valorimpuesto,
        tasaImpuesto: null,
        precio: dato.precio,
        descuento: dato.descuento,
        descripcion: dato.descripcion,
        cantidadDespachada: dato.cantidadDespachada,
        borrado: false,
        productos: dato.productos,
        unidades: dato.unidades,
        impuestoIncluido: dato.impuestoIncluido,
      }
      if (dato.productos.impuesto != null) {
        detalle.tasaImpuesto = dato.productos.impuesto.tasa
      }
      this.CotizacionFact.cotizacionDetalleList.push(detalle)
    },
    // Un método que  cambia la mascara del campo  y adacta su caracteristica
    // de pendiendo de su forma.
    MakaraCelCambio() {
      if (this.CambioDivisa.cedulaCliente.toString().length == 9) {
        this.MakCelRncCambDiv = "###-#####-#"
      }

      if (this.CambioDivisa.cedulaCliente.toString().length >= 11) {
        this.MakCelRncCambDiv = "###-#######-#"
      }
    },
    // Un método que se llama cuando el usuario cambia el valor de la entrada.
    cambioMonedas() {

      if (this.CambioDivisa.moneda == null || !this.CambioDivisa.moneda.hasOwnProperty("codigo")) {
        return
      }

      if (!this.CambioDivisa.operacion) {
        this.CambioDivisa.cantidadEntregada =
          this.CambioDivisa.cantidadComprada *
          this.CambioDivisa.moneda.tasaCompra
        this.CambioDivisa.devuelta =
          this.CambioDivisa.cantidadRecivida -
          this.CambioDivisa.cantidadComprada
      } else {
        this.CambioDivisa.cantidadEntregada =
          this.CambioDivisa.cantidadComprada *
          this.CambioDivisa.moneda.tasaVenta
        this.CambioDivisa.devuelta =
          this.CambioDivisa.cantidadRecivida -
          this.CambioDivisa.cantidadEntregada
      }
    },

    MakaraCelOtroIngreso() {
      if (this.OtrosIngreso.identificacion.toString().length == 9) {
        this.MakCelRnc = "###-#####-#"
      }

      if (this.OtrosIngreso.identificacion.toString().length >= 11) {
        this.MakCelRnc = "###-#######-#"
      }
    },

    MakaraCel() {
      if (this.clienteSeleccionado.cedrnc.toString().length == 9) {
        this.MakCelRnc = "###-#####-#"
      }
      if (this.clienteSeleccionado.cedrnc.toString().length >= 11) {
        this.MakCelRnc = "###-#######-#"
      }
    },
    // Comprobando si el valor es nulo o vacío y si lo es, lo establece en 0.
    blurCantNotnull(e) {
      var _this = this
      setTimeout(function() {
        if (e.cantidad == null) {
          e.cantidad = 0
          return
        }
        if (e.cantidad.length == 0) {
          e.cantidad = 0
          return
        }
      }, 300)


      /*if(e==null){
        e=0
        return
      }
      console.log(e.length)
      if(e.length==0){
        e=0
        return
      }*/

    },

    blurCantidadtarjeta() {

      var _this = this
      setTimeout(function() {

        if (_this.CierresCajas.cantidadtarjeta == null) {
          _this.CierresCajas.cantidadtarjeta = 0
        }

        if (_this.CierresCajas.cantidadtarjeta.length == 0) {
          _this.CierresCajas.cantidadtarjeta = 0
        }

      }, 300)

    },

    blurCantidadcheques() {

      var _this = this
      setTimeout(function() {

        if (_this.CierresCajas.cantidadcheques == null) {
          _this.CierresCajas.cantidadcheques = 0
        }

        if (_this.CierresCajas.cantidadcheques.length == 0) {
          _this.CierresCajas.cantidadcheques = 0
        }

      }, 300)

    },


    blurCantidadtranferencia() {

      var _this = this
      setTimeout(function() {

        if (_this.CierresCajas.cantidadtranferencia == null) {
          _this.CierresCajas.cantidadtranferencia = 0
        }

        if (_this.CierresCajas.cantidadtranferencia.length == 0) {
          _this.CierresCajas.cantidadtranferencia = 0
        }

      }, 300)

    },


    blurCantidadrecibo() {

      var _this = this
      setTimeout(function() {

        if (_this.CierresCajas.cantidadrecibo == null) {
          _this.CierresCajas.CierresCajas.cantidadrecibo = 0
        }

        if (_this.CierresCajas.cantidadrecibo.length == 0) {
          _this.CierresCajas.cantidadrecibo = 0
        }

      }, 300)

    },

    KeyUpCantidad(e) {
      if (e.target.value.length == 0) {
        e.target.value = 0
      }
      if (e.key) {
        var mynumeral = require("numeral")
        e.target.value = mynumeral(e.target.value).value()
        if (e.target.value == null) {
          e.target.value = 0
        }
      } else {
        e.key = ""
      }
      if (e.target.value.length == 0) {
        e.target.value = 0
        e.key = 0
      }
    },
    getColor(e) {
      if (e <= 0) {
        return "red"
      } else {
        return "green"
      }
    },

    // Establecer el foco en el campo de texto.
    InfomCaja() {
      if (this.$store.getters.GetOtrasConfigPv != null) {
        this.OtrasConfigPv = this.$store.getters.GetOtrasConfigPv
      }

      var _this = this
      setTimeout(function() {
        _this.$refs.RefTextFieldProducto.focus()
      }, 500)


      //  this.OtrasConfigPv={
      // caja:null,
      // terminal:null,
      // impresora:null,
      // turno:null,
      // cajero:this.$store.getters.GetdatosInfUsu.usuario.nombre,
      // moneda: this.$store.getters.GetConfiguracionGeneral.config.monedabase.descripcion,
      //  },
    },
    // Hacer una solicitud GET al servidor y devolver los datos.
    findAllTerminal() {
      this.getImpresoraLocal("/impresora/inicial/listaImpresora")
        .then((res) => {
          this.listTerminal = res.data

          if (res.data.length > 0) {
            this.terminal = res.data[0]
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // Guardando el valor de la selección en localStorage.
    updateImpresoraLocal(e) {
      localStorage.setItem(
        "printerSelect",
        JSON.stringify(this.OtrasConfigPv.impresora),
      )
    },
    // Estableciendo el valor de la variable OtrasConfigPv al valor de la variable
    UpdateConfigPv(e) {
      if (e != null) {
        var User = ""
        if (this.$store.getters.GetdatosInfUsu.usuario.nombre == null) {
          User = this.$store.getters.GetdatosInfUsu.usuario.username
        } else {
          User = this.$store.getters.GetdatosInfUsu.usuario.nombre
        }
        this.OtrasConfigPv.moneda = this.configuraciones.config.monedabase.descripcion
        this.OtrasConfigPv.cajero = User
        this.OtrasConfigPv.caja =e.descripcion.trim() + "-" + this.CierresCajas.cierrescajasPK.secuencia
        this.$store.commit("MutationDataOtrasConfigPv", this.OtrasConfigPv)
        sessionStorage.setItem("OtrasConfigPv", JSON.stringify(this.OtrasConfigPv),)
        localStorage.setItem("caja", JSON.stringify(e))
        this.loadPv()
      }
    },

    UpdateConfigPvTurno(e) {
    var _this = this
    setTimeout(function() {
      _this.UpdateConfigPv(_this.caja)
      }, 300)
    } ,

    // Actualización de los datos en la configuracion.
    updateConfiguracion() {
      if (this.OtrasConfigPv != null) {
        var cond = this.configuraciones.configPv.conduce
        var mar = this.caja.marca
        this.OtrasConfigPv.caja =
          (cond && mar ? "*" : "") +
          this.caja.descripcion.trim() +
          "-" +
          this.CierresCajas.cierrescajasPK.secuencia

        if (this.$store.getters.GetdatosInfUsu.usuario.nombre == null) {
          this.OtrasConfigPv.cajero = this.$store.getters.GetdatosInfUsu.usuario.username
        } else {
          this.OtrasConfigPv.cajero = this.$store.getters.GetdatosInfUsu.usuario.nombre
        }

        this.$store.commit("MutationDataOtrasConfigPv", this.OtrasConfigPv)
        sessionStorage.setItem(
          "OtrasConfigPv",
          JSON.stringify(this.OtrasConfigPv),
        )
      }
    },


    // Llamar a una API y obtener los datos de la API y almacenarlos en la variable RCaja.
    cargarCaja() {
      this.$axios
        .get(this.$hostname + this.$hName + "/cajas/findAllActivos", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RCaja = res.data))
    },

// Llamar a una API y obtener los datos de la API y almacenarlos en la variable RCaja.
    cargarTurnoTrabajo() {
      this.$axios.get(this.$hostname + this.$hName + "/turnos-trabajo/findallBorrado", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RTurnoTrabajo = res.data))
    },

 SelctCbTurnoTrabajoConfigPv() {

      var _this = this
      setTimeout(function() {
        if (_this.OtrasConfigPv.turno == null) {
          _this.OtrasConfigPv.turno = ""
        }

        if (!_this.OtrasConfigPv.turno.hasOwnProperty("codigo")) {
          _this.OtrasConfigPv.turno = ""
          _this.OtrasConfigPv.turno = null
          return
        }
      }, 300)

    },


    

    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbCajaConfigPv() {
      if (this.caja == null) {
        this.caja = ""
      }
      if (this.caja.codigo == undefined) {
        this.alerta("Seleccione una caja", "error")
        this.caja = ""
        return
      }
    },
    SelctCbCajaFiltAsigMensajero() {

      var _this = this
      setTimeout(function() {
        if (_this.filtroAsigMensajero.caja == null) {
          _this.filtroAsigMensajero.caja = ""
        }

        if (!_this.filtroAsigMensajero.caja.hasOwnProperty("codigo")) {
          _this.filtroAsigMensajero.caja = ""
          _this.filtroAsigMensajero.caja = null
          return
        }
      }, 300)

    },

    // Creando un nuevo objeto y asignándolo a la variable CotizacionBusqueda.
    NewBucarCotizacion() {
      this.CotizacionBusqueda = {
        secuencia: 0,
        fechaInicial: fechaNueva(),
        fechaFinal: fechaNueva(),
        cliente: null,
      }
    },

    // Establecer el valor predeterminado del paginador en 15.
    CotizacionCargarPaginacion(e) {
      this.CotizacionPaginator = e
      if (this.CotizacionPaginator.itemsPerPage == 1) {
        this.CotizacionPaginator.itemsPerPage = 15
      }
      this.getCotizacionlistFactCliente()
    },

    // Hacer una llamada API al servidor y devolver los datos de la cotizacion.
    getCotizacionlistFactCliente() {
      /*console.log('Viendo Informacion klk ')
      console.log(this.$refs.RefCombClienteCosFac.internalSearch)*/
      //  this.RegistroActividades.descripcion= JSON.parse(JSON.stringify(this.$refs.RefCombAct.internalSearch))

      var _this = this
      setTimeout(function() {
        _this.VerCotizacionlistFactCliente = []
        var sec,
          fecini,
          fecfin,
          cliente = null
        if (_this.CotizacionBusqueda.secuencia != null) {
          sec = _this.CotizacionBusqueda.secuencia
        }
        if (_this.CotizacionBusqueda.fechaInicial != null) {
          fecini = _this.CotizacionBusqueda.fechaInicial
        }
        if (_this.CotizacionBusqueda.fechaFinal != null) {
          fecfin = _this.CotizacionBusqueda.fechaFinal
        }
        

        if(_this.CotizacionBusqueda.cliente != null && typeof _this.CotizacionBusqueda.cliente ==="string"){
          cliente = _this.CotizacionBusqueda.cliente.trim()
          }

          if(_this.CotizacionBusqueda.cliente != null && typeof _this.CotizacionBusqueda.cliente ==="object" && _this.CotizacionBusqueda.cliente.hasOwnProperty('nombre')){
           cliente = _this.CotizacionBusqueda.cliente.nombre.trim()
          }

        var param = ""
        if (_this.$store.getters.GetConfiguracionGeneral.configPv.modalidadRutaVendedor == true && _this.Facturasventa.vendedor != null && _this.Facturasventa.vendedor.hasOwnProperty("codigo")) {
          var param = "/" + _this.Facturasventa.vendedor.codigo
        }

        _this.$axios
          .get(
            _this.$hostname +
            _this.$hName +
            "/reimpresion/cotizacion/" +
            sec +
            "/" +
            fecini +
            "/" +
            fecfin +
            "/" +
            cliente +
            "/" +
            _this.CotizacionPaginator.itemsPerPage +
            "/" +
            (_this.CotizacionPaginator.pageStart) + param,
            { headers: _this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            //*this.TotalRegistros = res.data.cantidad,
            _this.VerCotizacionlistFactCliente = res.data.listas
            _this.TotalRegistros = res.data.cantidad
          })

      }, 500)

    },

    async VerCotizacionDatostabla(e) {
      if (this.cargandoCotizacionFactura == true) {
        return
      }
      this.cargandoCotizacionFactura = true
      var Limpiar = new Promise((resolve, reject) => {
        this.limpiarPuntoVentaCompleto()

        setTimeout(() => {
          this.loading(true)
          resolve("resolved")
        }, 200)
      })

      Limpiar.then(() => {
        var _this = this
        setTimeout(function() {
          _this.contVerCotizacionDatostabla(e)
        }, 300)

      })


    },

    // Obtener los datos del servidor y agregarlos a la tabla.
    async contVerCotizacionDatostabla(e) {
      this.cotizacionAfacturaSelect = JSON.parse(JSON.stringify(e))
      this.dialogBucarCotizacion = false

      this.clienteFactura = null
      this.RProductoCompraTemp = []
      this.RProductoCompra = []
      this.RProductoCompraOfercta = []
      this.Facturasventa.vendedor = null
      this.Facturasventa.tipocomprobante = null
      this.Facturasventa.telefononcf = ""
      this.Facturasventa.cedularncncf = ""
      this.Facturasventa.nombreDgii = ""
      this.Facturasventa.direccionncf = ""
      this.Facturasventa.caja = this.caja
      this.Facturasventa.sucursal = this.caja.sucursal
      this.Facturasventa.comentario = ""
      if(e.hasOwnProperty('concepto') && e.concepto!=null && e.concepto.trim().length>0){
        this.Facturasventa.comentario = e.concepto.trim()
      }

      this.configuraciones.config.monedabase.tasa
      /*this.Monedafactura=JSON.parse(JSON.stringify(this.configuraciones.config.monedabase))
      this.Facturasventa.moneda=JSON.parse(JSON.stringify(this.configuraciones.config.monedabase))*/
      if (e.objmoneda != null) {
        var monedaa = e.objmoneda
        monedaa.tasa = e.tasa
        this.Monedafactura = monedaa
        this.Facturasventa.moneda = monedaa
        this.Facturasventa.tasa = monedaa.tasa
      }
      this.SalvarMonedaFactura()

      var _this = this
      /*this.Descuentofactura = {
        descuento: e.valordescuento,
        ValorPorc: true,
        DescuentoFacturaGlobal: true
      }*/

      //Verifica si de la lista de producto la existencia no alcansa
      var BOOL_existencia = false
      var OBJrestrList = []
      var bar = new Promise((resolve, reject) => {
        (async () => {

          if (e.cotizacionDetalleList.length > 0) {

            //var listFtempDetalle = JSON.parse(JSON.stringify(e.facturastemporalesDetalleList.filter((ee) => ee.precio>0)))
            var listFtempDetalle = JSON.parse(JSON.stringify(e.cotizacionDetalleList.filter((ee) => ee.precio >= 0)))
            listFtempDetalle.sort(function(a, b) {
              if (a.cotizacionDetallePK.id < b.cotizacionDetallePK.id) {
                return 1
              }
              if (a.cotizacionDetallePK.id > b.cotizacionDetallePK.id) {
                return -1
              }
              // a must be equal to b
              return 0
            })
            setTimeout(() => {
              (async () => {

                var TIPOCOM = e.cliente != null && e.cliente.hasOwnProperty("tipocomprobante") ? e.cliente.tipocomprobante : e.tipocomprobante

                // console.log(listFtempDetalle)
                // const restrList =  await this.detalleRestaurarFactTem(listFtempDetalle,e.tipocomprobante);

                Promise.all(listFtempDetalle.map(async (element) => {
                  element.precioDig = JSON.parse(JSON.stringify(element.precio))
                }))

                const restrList = await this.detalleRestaurarFactTem(listFtempDetalle, TIPOCOM)
                OBJrestrList = JSON.parse(JSON.stringify(restrList.ListTem))
                /* console.log('--OBJrestrList---')
          console.log(OBJrestrList)

         BOOL_existencia=restrList.BOOL_existencia
          console.log('--DFBOOL_existencia--')
          console.log(BOOL_existencia)*/
                if (restrList.BOOL_existencia == true) {
                  _this.alerta("hay producto que intenta vender, que la cantiada es mayor a la existencia", "error")
                }
                if (OBJrestrList.length > 0) {
                  // console.log('--restrList--')
                  // console.log(OBJrestrList)
                  this.RProductoCompraOfercta = JSON.parse(JSON.stringify(restrList.ListTem.filter((ee) => ee.paramOfert == true)))

                  await Promise.all(OBJrestrList.map(async (element) => {
                    // this.BuscPropiedadProductoSelct(element, 'add')
                    // this.productoSeleccionado=JSON.parse(JSON.stringify(element))
                    // this.SalvarInfProducto()
                    element.RecarValor = (element.hasOwnProperty("RecarValor") && element.RecarValor != null ? element.RecarValor : 0)
                    element.valorRecargo = (element.hasOwnProperty("valorRecargo") && element.valorRecargo != null ? element.valorRecargo : 0)
                    this.RProductoCompra.unshift(JSON.parse(JSON.stringify(element)))
                    this.RProductoCompraTemp.unshift(JSON.parse(JSON.stringify(element)))
                    /* //this.BuscPropiedadProductoSelct(element, 'add')*/

                  }))
                  this.loading(false)
                  this.$refs.RefScroll.scrollTop = 0
                  this.$refs.RefScrollProductoCompra.scrollTop = 0

                  var DATO = {
                    cliente: e.cliente,
                    vendedor: e.vendedor,
                    tipoComp: e.cliente != null && e.cliente.hasOwnProperty("tipocomprobante") ? e.cliente.tipocomprobante : e.tipocomprobante,
                    OBJ: JSON.parse(JSON.stringify(e)),
                  }


                  setTimeout(function() {

                    // _this.LimpiaInfProducto()

                    _this.LimpiaInfProducto_DatoClienteSelectRestFact(DATO)
                    if (e.cliente != null) {
                      _this.Facturasventa.nombreDgii = JSON.parse(JSON.stringify(e.cliente != null && e.cliente.nombre != null ? e.cliente.nombre : ""))
                      // _this.Facturasventa.telefononcf = JSON.parse(JSON.stringify(this.ComprobanteFisc.telefono))
                      _this.Facturasventa.direccionncf = JSON.parse(JSON.stringify(e.cliente.direccion))
                      _this.Facturasventa.cedularncncf = JSON.parse(JSON.stringify(e.cliente.cedrnc))
                    }
                  }, 400)
                  /*OBJrestrList.forEach(async(element) => {
            this.BuscPropiedadProductoSelct(element, 'add')
          });*/
                }


                setTimeout(() => {
                  resolve()
                }, 500)


              })()
            }, 500)
          } else {
            resolve()
          }

          /* setTimeout(() => {
          resolve()
        }, 500); */


        })()

      })


      bar.then(() => {
        this.ObjEjecPermisoPv = null
        try {
          this.Facturasventa.vendedor = e.vendedor
          this.Facturasventa.nombreDgii = JSON.parse(JSON.stringify(e.cliente != null && e.cliente.nombre != null ? e.cliente.nombre : ""))
          this.Facturasventa.nombreFactTem = e.nombrecliente
        } finally {
          this.cargandoCotizacionFactura = false
          this.loading(false)
        }
      })
    },


    //Organizar Y preparar detalle cotizacion

    async detalleContizacionFact(listFtempDetalle) {

      /*if (e.cotizacionDetalleList.length > 0) {
        e.cotizacionDetalleList.forEach(element => {

          var Link = `${element.productos.codigo}/${element.unidades.codigo}`
          this.$axios
            .get(
              this.$hostname + this.$hName + "/unidades-productos/find/" + Link,
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => {
              var Obj = res.data
              Obj.cantidad = element.cantidad
              Obj.omitirRegla = true
              Obj.DescValor = element.valordescuento
                Obj.descuentoKeys = element.valordescuento
                Obj.descuento = element.descuento
                Obj.ValorPorc = true
              this.BuscPropiedadProductoSelct(Obj, 'add')
            });
        });
      }*/

      //-------------------------
      var OBJ = {
        ListTem: [],
        BOOL_existencia: false,
      }
      return new Promise((rresolve, reject) => {
        var bar = new Promise((resolve, reject) => {
          listFtempDetalle.forEach(async (element, index, array) => {
            //findUnidadProductoConExistenciaAlmacen
            (async () => {
              var Link = `${element.productos.codigo}/${element.unidades.codigo}/${this.caja.sucursal.codigo}`
              this.$axios
                .get(
                  this.$hostname + this.$hName + "/unidades-productos/findUnidadProductoConExistenciaAlmacen/" + Link,
                  { headers: this.$store.getters.GetheadersAxios },
                )
                .then((res) => {
                  var Obj = res.data
                  Obj.cantidad = element.cantidad
                  Obj.omitirRegla = true
                  Obj.DescValor = element.valordescuento
                  Obj.descuentoKeys = element.valordescuento
                  Obj.descuento = element.descuento
                  Obj.ValorPorc = true
                  Obj.precio = element.precio
                  Obj.precioOrig = res.data.precio
                  Obj.precioDig = res.data.precio

                  if (this.configuraciones.configInv.permitirNegativos == false) {
                    if (res.data.productos.servicio == false && element.cantidad > res.data.existencias) {
                      OBJ.BOOL_existencia = true
                    } else {
                      OBJ.ListTem.push(Obj)
                      // this.BuscPropiedadProductoSelct(Obj, 'add')
                    }

                  } else {
                    OBJ.ListTem.push(Obj)
                  }

                })

            })()

          })
          resolve()
        })

        bar.then(() => {
          // OBJ.ListTem=ListDetalleTemp
          var _this = this
          setTimeout(function() {
            rresolve(OBJ)
          }, 300)

        })

      })
    },


    SelctCbCotizacionBuscar() {
      if (this.CotizacionBusqueda.cliente == null) {
        this.CotizacionBusqueda.cliente = ""
      }
      if (this.CotizacionBusqueda.cliente.codigo == undefined) {
        this.CotizacionBusqueda.cliente = ""
        this.alerta("Seleccione un cliente", "error")
        return
      }
    },
    NewDatosVuelo() {
      this.Facturasventa.lineaAerea = null
      this.Facturasventa.numeroVuelo = null
      this.Facturasventa.rutaSalidaE = null
      this.Facturasventa.rutaSalidaD = null
      this.Facturasventa.rutaRetornoE = null
      this.Facturasventa.rutaRetornoD = null
    },


    OpenDialogModalPagare() {

      this.dialogModalPagare = true

    },

    openPagoPagares() {
      this.dialogModalPagoPagare = true

      var _this = this
      setTimeout(function() {
        _this.$refs.RefComponentsPagoPagare.PagoPagares.caja = _this.caja
        _this.$refs.RefComponentsPagoPagare.isComponente = true

        if (_this.clienteFactura != null && _this.clienteFactura.hasOwnProperty("codigo")) {
          _this.$refs.RefComponentsPagoPagare.PagoPagares.cliente = _this.clienteFactura
          _this.$refs.RefComponentsPagoPagare.buscarPagare()
        }
        //  _this.$refs.RefComponentsPvModalConsultaBalancePunto.dialogClienteBalancePunto=true
        //  _this.$refs.RefComponentsPagoPagare.focusRefTextFieldCodigoBarra()
      }, 500)


    },


    async OpenDialogDatosPagareFactura() {

      if (this.clienteFactura == null) {
        this.OpenEjecDatosPagareFactura = true
        this.OpenDialogCrearEditarCliente()
      }
      if (this.clienteFactura != null) {
        if (this.RProductoCompra.length > 0) {

          this.dialogPagare = true
          this.OpenEjecDatosPagareFactura = false
          var _this = this
          setTimeout(function() {
            // _this.$refs.RefComponentsPvModalPagare.getPedidoAfacturalistFactCliente()

            

            if (_this.DatosPagareFactura != null) {
              _this.$refs.RefComponentsPvModalPagare.ObjTemPagare = JSON.parse(JSON.stringify(_this.DatosPagareFactura))
              _this.$refs.RefComponentsPvModalPagare.DatosPagareFactura = JSON.parse(JSON.stringify(_this.DatosPagareFactura))
            }

            _this.$refs.RefComponentsPvModalPagare.RProductoCompra = JSON.parse(JSON.stringify(_this.RProductoCompra))
            _this.$refs.RefComponentsPvModalPagare.fechaFactura = JSON.parse(JSON.stringify(_this.Facturasventa.fecha))
            _this.$refs.RefComponentsPvModalPagare.totalGeneral_total = JSON.parse(JSON.stringify(_this.Totales.totalGeneral.total))
            _this.$refs.RefComponentsPvModalPagare.Monedafactura = JSON.parse(JSON.stringify(_this.Monedafactura))
            _this.$refs.RefComponentsPvModalPagare.TasaMoneda = JSON.parse(JSON.stringify(_this.TasaMoneda))
            _this.$refs.RefComponentsPvModalPagare.DatosPagareFactura.contrato.valorPrestamo = JSON.parse(JSON.stringify(_this.Totales.totalGeneral.total))

          }, 300)


        } else {
          this.alerta(
            "Debe de agregar al menos 1 producto para ver la opción de pagaré",
            "error",
          )
        }
      }
      // this.DatosPagareFactura.contrato.valorPrestamo =this.Totales.totalGeneral.total;
    },


    // Creando un nuevo objeto llamado ConduceBusqueda y asignándolo a la propiedad de datos
    // ConduceBusqueda.
    NewBucarConduce() {
      this.ConduceBusqueda = {
        secuencia: 0,
        fechaInicial: fechaNueva(),
        fechaFinal: fechaNueva(),
        cliente: null,
      }
    },

     NewBucarConduceMultiple() {

      this.VerConducelistFactCliente=[]
        this.selectedListConduceMultiple=[]

      this.ConduceBusquedaMultiple = {
        secuencia: 0,
        fechaInicial: fechaNueva(),
        fechaFinal: fechaNueva(),
        cliente: null,
      }
    },

    // Hacer una llamada al servidor para obtener los datos.
    getConducelistFactCliente() {
      this.VerCotizacionlistFactCliente = []
      var sec,
        fecini,
        fecfin,
        cliente = null
      if (this.ConduceBusqueda.secuencia != null) {
        sec = this.ConduceBusqueda.secuencia
      }
      if (this.ConduceBusqueda.fechaInicial != null) {
        fecini = this.ConduceBusqueda.fechaInicial
      }
      if (this.ConduceBusqueda.fechaFinal != null) {
        fecfin = this.ConduceBusqueda.fechaFinal
      }
      // if (this.ConduceBusqueda.cliente != null) {
      //   cliente = this.ConduceBusqueda.cliente
      // }

       if(this.ConduceBusqueda.cliente != null && typeof this.ConduceBusqueda.cliente ==="string"){
          cliente = this.ConduceBusqueda.cliente.trim()
          }

          if(this.ConduceBusqueda.cliente != null && typeof this.ConduceBusqueda.cliente ==="object" && this.ConduceBusqueda.cliente.hasOwnProperty('nombre')){
           cliente = this.ConduceBusqueda.cliente.nombre.trim()
          }


      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/reimpresion/conduce/" +
          sec +
          "/" +
          fecini +
          "/" +
          fecfin +
          "/" +
          cliente +
          "/" +
          this.ReimprecionPaginator.itemsPerPage +
          "/" +
          this.ReimprecionPaginator.pageStart,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          //*this.TotalRegistros = res.data.cantidad,
          this.VerConducelistFactCliente = res.data.listas
        })
    },


    VerConduceDatostabla(e) {

      if (this.cargandoConduceFactura == true) {
        return
      }
      this.cargandoConduceFactura = true

      var LISTA_CONDUCE_MULTIPLE=JSON.parse(JSON.stringify(this.ListConduceMultiple)) 
    
      var Limpiar = new Promise((resolve, reject) => {
        this.limpiarPuntoVentaCompleto()

        setTimeout(() => {
          this.loading(true)
          resolve("resolved")
        }, 200)
      })

      Limpiar.then(() => {
        var _this = this
        setTimeout(function() {
          _this.ListConduceMultiple=JSON.parse(JSON.stringify(LISTA_CONDUCE_MULTIPLE)) 
          _this.contVerConduceDatostabla(e)
        }, 300)

      })

    },

    // Obtener los datos del servidor y luego agregarlos a la tabla los datos del producto.
    async contVerConduceDatostabla(e) {
      this.dialogBucarConduce = false
      this.conduceSelect = e.conduceInventarioPK
      // detalleConduceFact

      this.clienteFactura = null
      this.RProductoCompraTemp = []
      this.RProductoCompra = []
      this.RProductoCompraOfercta = []
      this.Facturasventa.vendedor = null
      this.Facturasventa.tipocomprobante = null
      this.Facturasventa.telefononcf = ""
      this.Facturasventa.cedularncncf = ""
      this.Facturasventa.nombreDgii = ""
      this.Facturasventa.direccionncf = ""
      this.Facturasventa.caja = this.caja
      this.Facturasventa.sucursal = this.caja.sucursal
      //this.Facturasventa.comentario = ""
      this.Facturasventa.comentario = e.hasOwnProperty('comentarioConducemultiple')&& e.comentarioConducemultiple!=null?e.comentarioConducemultiple:e.comentario


      this.configuraciones.config.monedabase.tasa

      if (e.objmoneda != null) {
        var monedaa = e.objmoneda
        monedaa.tasa = e.tasa
        this.Monedafactura = monedaa
        this.Facturasventa.moneda = monedaa
        this.Facturasventa.tasa = monedaa.tasa
      }
      this.SalvarMonedaFactura()

      var _this = this

      //Verifica si de la lista de producto la existencia no alcansa
      var BOOL_existencia = false
      var OBJrestrList = []
      var bar = new Promise((resolve, reject) => {
        (async () => {

          if (e.conduceInventarioDetalleList.length > 0) {

            //var listFtempDetalle = JSON.parse(JSON.stringify(e.facturastemporalesDetalleList.filter((ee) => ee.precio>0)))
            var listFtempDetalle = JSON.parse(JSON.stringify(e.conduceInventarioDetalleList.filter((ee) => ee.precio >= 0)))

            Promise.all(listFtempDetalle.map(async (element) => {
              element.productos = JSON.parse(JSON.stringify(element.producto))
              element.unidades = JSON.parse(JSON.stringify(element.unidad))
            }))


            listFtempDetalle.sort(function(a, b) {
              if (a.id < b.id) {
                return 1
              }
              if (a.id > b.id) {
                return -1
              }
              // a must be equal to b
              return 0
            })
            setTimeout(() => {
              (async () => {

                // console.log(listFtempDetalle)
                var TIPOCOM = e.cliente != null && e.cliente.hasOwnProperty("tipocomprobante") ? e.cliente.tipocomprobante : e.tipocomprobante
                //var TIPOCOM=e.tipocomprobante
                /**/
                Promise.all(listFtempDetalle.map(async (element) => {
                  element.precioDig = JSON.parse(JSON.stringify(element.precio))
                }))
                const restrList = await this.detalleRestaurarFactTem(listFtempDetalle, TIPOCOM)
                // const restrList =  await this.detalleRestaurarFactTem(listFtempDetalle,e.tipoComprobante);
                OBJrestrList = JSON.parse(JSON.stringify(restrList.ListTem))
                /* console.log('--OBJrestrList---')
          console.log(OBJrestrList)

         BOOL_existencia=restrList.BOOL_existencia
          console.log('--DFBOOL_existencia--')
          console.log(BOOL_existencia)*/
                if (restrList.BOOL_existencia == true) {
                  _this.alerta("hay producto que intenta vender, que la cantiada es mayor a la existencia", "error")
                }
                if (OBJrestrList.length > 0) {
                  // console.log('--restrList--')
                  // console.log(OBJrestrList)
                  this.RProductoCompraOfercta = JSON.parse(JSON.stringify(restrList.ListTem.filter((ee) => ee.paramOfert == true)))

                  await Promise.all(OBJrestrList.map(async (element) => {
                    // this.BuscPropiedadProductoSelct(element, 'add')
                    // this.productoSeleccionado=JSON.parse(JSON.stringify(element))
                    // this.SalvarInfProducto()
                    element.RecarValor = (element.hasOwnProperty("RecarValor") && element.RecarValor != null ? element.RecarValor : 0)
                    element.valorRecargo = (element.hasOwnProperty("valorRecargo") && element.valorRecargo != null ? element.valorRecargo : 0)
                    this.RProductoCompra.unshift(JSON.parse(JSON.stringify(element)))
                    this.RProductoCompraTemp.unshift(JSON.parse(JSON.stringify(element)))
                    /* //this.BuscPropiedadProductoSelct(element, 'add')*/

                  }))
                  this.loading(false)
                  this.$refs.RefScroll.scrollTop = 0
                  this.$refs.RefScrollProductoCompra.scrollTop = 0
                  var DATO = {
                    cliente: e.cliente,
                    vendedor: e.vendedor,
                    //tipoComp:e.tipocomprobante,
                    tipoComp: e.cliente != null && e.cliente.hasOwnProperty("tipocomprobante") ? e.cliente.tipocomprobante : e.tipocomprobante,
                    OBJ: JSON.parse(JSON.stringify(e)),
                  }


                  setTimeout(function() {

                    // _this.LimpiaInfProducto()

                    _this.LimpiaInfProducto_DatoClienteSelectRestFact(DATO)
                    if (e.cliente != null) {
                      console.log(e.cliente.nombre)
                      // _this.Facturasventa.telefononcf = JSON.parse(JSON.stringify(this.ComprobanteFisc.telefono))
                      _this.Facturasventa.nombreDgii = JSON.parse(JSON.stringify(e.cliente != null && e.cliente.nombre != null ? e.cliente.nombre.trim() : ""))
                      _this.Facturasventa.direccionncf = JSON.parse(JSON.stringify(e.cliente.direccion != null ? e.cliente.direccion.trim() : ""))
                      _this.Facturasventa.cedularncncf = JSON.parse(JSON.stringify(e.cliente.cedrnc != null ? e.cliente.cedrnc.trim() : ""))
                    }
                  }, 400)
                  /*OBJrestrList.forEach(async(element) => {
            this.BuscPropiedadProductoSelct(element, 'add')
          });*/
                }


                setTimeout(() => {
                  resolve()
                }, 500)


              })()
            }, 500)
          } else {
            resolve()
          }

          /* setTimeout(() => {
          resolve()
        }, 500); */


        })()

      })


      bar.then(() => {
        this.ObjEjecPermisoPv = null
        try {
          this.Facturasventa.vendedor = e.vendedor
          this.Facturasventa.nombreDgii = JSON.parse(JSON.stringify(e.cliente != null && e.cliente.nombre != null ? e.cliente.nombre.trim() : ""))
          this.Facturasventa.nombreFactTem = e.nombrecliente
        } finally {
          this.cargandoConduceFactura = false
          this.loading(false)
        }
      })


    },

//Organizar Y preparar detalle cotizacion
    async detalleConduceFact(listFtempDetalle) {
      var OBJ = {
        ListTem: [],
        BOOL_existencia: false,
      }
      return new Promise((rresolve, reject) => {
        var bar = new Promise((resolve, reject) => {
          listFtempDetalle.forEach(async (element, index, array) => {
            //findUnidadProductoConExistenciaAlmacen
            (async () => {
              var Link = `${element.producto.codigo}/${element.unidad.codigo}/${this.caja.sucursal.codigo}`
              this.$axios
                .get(
                  this.$hostname + this.$hName + "/unidades-productos/findUnidadProductoConExistenciaAlmacen/" + Link,
                  { headers: this.$store.getters.GetheadersAxios },
                )
                .then((res) => {
                  var Obj = res.data
                  Obj.cantidad = element.cantidad
                  Obj.omitirRegla = true
                  Obj.DescValor = element.valordescuento
                  Obj.descuentoKeys = element.valordescuento
                  Obj.descuento = element.descuento
                  Obj.ValorPorc = true
                  Obj.precio = element.precio
                  Obj.precioOrig = res.data.precio
                  Obj.precioDig = res.data.precio

                  if (this.configuraciones.configInv.permitirNegativos == false) {
                    if (res.data.productos.servicio == false && element.cantidad > res.data.existencias) {
                      OBJ.BOOL_existencia = true
                    } else {
                      OBJ.ListTem.push(Obj)
                      // this.BuscPropiedadProductoSelct(Obj, 'add')
                    }

                  } else {
                    OBJ.ListTem.push(Obj)
                  }

                })

            })()

          })
          resolve()
        })

        bar.then(() => {
          // OBJ.ListTem=ListDetalleTemp
          var _this = this
          setTimeout(function() {
            rresolve(OBJ)
          }, 300)

        })

      })
    },


    SelctCbConduceBuscar() {
      if (this.ConduceBusqueda.cliente == null) {
        this.ConduceBusqueda.cliente = ""
      }
      if (this.ConduceBusqueda.cliente.codigo == undefined) {
        this.ConduceBusqueda.cliente = ""
        this.alerta("Seleccione un cliente", "error")
        return
      }
    },

    // Llamar a una API y obtener los datos de la API y almacenarlos en la variable RTipoTarjeta.
    async cargarTipoTarjeta() {
      if (this.pvFacturacionOfflineActiva()) {
        var cargoOffline = await this.cargarTiposTarjetaOffline()
        if (cargoOffline == true && this.debeGuardarFacturaOffline()) {
          return true
        }
        if (typeof navigator !== "undefined" && navigator.onLine == false) {
          return cargoOffline
        }
      }
      try {
        var res = await this.$axios.get(this.$hostname + this.$hName + "/tarjeta/findall/", {
          headers: this.$store.getters.GetheadersAxios,
          timeout: 8000,
        })
        if (this.pvFacturasOfflinePendientes == 0) {
          this.desactivarModoOfflineForzado()
        }
        this.RTipoTarjeta = res.data || []
        await this.guardarTiposTarjetaOffline(this.RTipoTarjeta)
        return this.RTipoTarjeta.length > 0
      } catch (error) {
        if (this.esErrorConexionPv(error)) {
          this.activarModoOfflinePorErrorConexion(error)
        }
        return await this.cargarTiposTarjetaOffline()
      }
    },

    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbTipoTarjeta(mostrarAlerta) {
      if (this.tipoTarjeta == null) {
        this.tipoTarjeta = ""
      }

      if (this.tipoTarjeta.codigo == undefined) {
        if (mostrarAlerta == true) {
          this.alerta("Seleccione un Tipo de tarjeta", "error")
        }
        this.tipoTarjeta = ""
        return false
      }
      return true
    },

    // Llamar a una API y obtener los datos de la API y almacenarlos en la variable RBanco.
    cargarBanco() {
      this.$axios
        .get(this.$hostname + this.$hName + "/bancos/findall", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RBanco = res.data))
    },

    // Comprobando si el valor de la selección no está definido.
    SelctCbBanco() {

      var _this = this
      setTimeout(function() {
        if (_this.bancoCheque == null) {
          _this.bancoCheque = ""
        }

        if (!_this.bancoCheque.hasOwnProperty("codigo")) {
          _this.bancoCheque = ""
          _this.bancoCheque = null
          return
        }
      }, 300)

    },

    // Establecer el valor de las variables en verdadero o falso.
    defoulFormaPagoPanel() {
      this.PanelFormaPagoColmna1 = true
      this.PanelFormaPagoColmna2 = true
      this.PanelFormaPagoTarjeta = false
      this.PanelFormaPagoCheque = false
      this.PanelMenuOpcionBotones = true
      this.PanelFormaPagoNotaCredito = false
    },

    // Poniendo el valor de la variable PanelFormaPagoTarjeta verdadero si los datos de la tarjeta no es correcto.
    async OpenPanelFormaPagoTarjeta() {
      this.defoulFormaPagoPanel()
      this.PanelFormaPagoColmna2 = false
      this.PanelFormaPagoTarjeta = true
      await this.cargarTipoTarjeta()
      this.$nextTick(() => {
        if (this.$refs.formTarjetaFormPago != null) {
          this.$refs.formTarjetaFormPago.resetValidation()
        }
      })
    },

    // Abriendo un panel en un formulario cheque.
    OpenPanelFormaPagoCheque(e) {
      this.defoulFormaPagoPanel()
      this.NombreFormaPagoCheqTras = e
      this.PanelFormaPagoColmna2 = false
      this.PanelFormaPagoCheque = true
    },

    OpenPanelFormaPagoNotacredito() {
      this.CargarNotacreditocontado()
      this.defoulFormaPagoPanel()
      this.PanelMenuOpcionBotones = false
      this.PanelFormaPagoNotaCredito = true

    },


    BlurNotaCreditoPago() {
      if (this.selectedListFPagoNC.length > 0) {

        if (this.Facturasventa.valorNc > this.selectedListFPagoNC[0].pendiente) {
          this.alerta("no puede digitar un valor más alto del valor pendiente de la nota de crédito", "error")
          this.Facturasventa.valorNc = JSON.parse(JSON.stringify(this.selectedListFPagoNC[0].pendiente))
        }

      }
      this.calculostotales()

    },
    CargarNotacreditocontado() {

      if (this.PanelFormaPagoNotaCredito == false) {
        var fe = this.fechaNueva()
        this.$axios.get(this.$hostname + this.$hName +
          `/devolucion/notacreditocontado/${fe}/null`,
          { headers: this.$store.getters.GetheadersAxios },
        )
          .then((res) => {
            this.ListFormaPagoNC = res.data.ListNotacreditoContado
          })
      }

    },
    CbFilNotacreditocontado(e) {

      if (e.target.value.length == 0) {
        this.CargarNotacreditocontado()
      } else {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/devolucion/notacreditocontado/null/" + e.target.value,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            this.ListFormaPagoNC = res.data.ListNotacreditoContado
          })

      }

    },

    obtenerDatoSelectFormaPagoNC(e) {
      if (e.value == true) {
        this.obtenerDatoSelectFormaPagoNCClickRow(e.item)
      }
    },
    obtenerDatoSelectFormaPagoNCClickRow(e) {
      this.selectedListFPagoNC = []
      this.selectedListFPagoNC.push(e)
      if (this.Facturasventa.valorNc == 0) {
        this.Facturasventa.valorNc = JSON.parse(JSON.stringify(e.pendiente))
      }

      /* if (this.Facturasventa.valorNc > e.valor) {
         this.Facturasventa.valorNc = JSON.parse(JSON.stringify(e.pendiente))
       }*/

      if (this.Totales.totalGeneral.total > e.valor) {
        this.Facturasventa.valorNc = JSON.parse(JSON.stringify(e.pendiente))
      } else {
        this.Facturasventa.valorNc = JSON.parse(JSON.stringify(this.Totales.totalGeneral.total))
      }


      this.calculostotales()
      //this.Facturasventa.
    },

    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbTipoRecibo() {
      if (this.OtrosIngreso.tipoRecibo == null) {
        this.OtrosIngreso.tipoRecibo = ""
      }

      if (this.OtrosIngreso.tipoRecibo.codigo == undefined) {
        this.alerta("Seleccione un Tipo de Otros ingreso", "error")
        this.OtrosIngreso.tipoRecibo = ""
        return
      }
    },

    // El comprobante seleccionado está guardando los datos del formulario en el objeto Facturasventa.
    async SalvarComprobante() {
      if (this.fiscalPosGuardando) return
      this.fiscalPosGuardando = true
      try {
      await this.esperarClienteFiscalPos()
      if (this.$refs.formComprobante.validate()) {

        if (this.ComprobanteFisc.cedrnc != null && this.ComprobanteFisc.cedrnc.length > 0) {
          var CEDULA = this.ComprobanteFisc.cedrnc.replace("-", "")
          CEDULA = CEDULA.replace(/-/g, "")
          if (this.validaCedRnc(CEDULA) == false) {
            var NOM = CEDULA.length > 10 ? "CEDULA" : "RNC"
            this.alerta(`${NOM} Invalida `, "error")
            return
          }
        }

        if (!await this.guardarClienteFiscalPos()) return
        this.Facturasventa.tipocomprobante = JSON.parse(JSON.stringify(this.ComprobanteFisc.comprobante))
        this.Facturasventa.nombreDgii = JSON.parse(JSON.stringify(this.ComprobanteFisc.nombre))
        this.Facturasventa.telefononcf = JSON.parse(JSON.stringify(this.ComprobanteFisc.telefono))
        this.Facturasventa.direccionncf = JSON.parse(JSON.stringify(this.ComprobanteFisc.direccion))
        this.Facturasventa.cedularncncf = JSON.parse(JSON.stringify(this.ComprobanteFisc.cedrnc))
        this.dialogComprobante = false
        var _this = this
        setTimeout(function() {
          _this.CalcularTotalesProductosCompra()
        }, 500)

      } else {
        this.alerta("los campos en rojo son requeridos", "error")
      }
      } finally {
        this.fiscalPosGuardando = false
      }

    },

    // Establecer el valor del objeto
    cancelarComprobante() {
      this.ComprobanteFisc = {
        comprobante: null,
        nombre: null,
        telefono: "",
        direccion: "",
        cedrnc: "",
      },
        this.dialogComprobante = false
    },


    // Comprobando si el objeto en nulo o indefinido.
    SelctCbTipoCompComprobant() {
      var _this = this
      setTimeout(function() {
        if (_this.ComprobanteFisc.comprobante == null) {
          _this.ComprobanteFisc.comprobante = ""
        }

        if (!_this.ComprobanteFisc.comprobante.hasOwnProperty("codigo")) {
          _this.ComprobanteFisc.comprobante = ""
          _this.ComprobanteFisc.comprobante = null
          return
        }
      }, 300)
    },


    // Un método que se llama cuando se cambia la entrada.
    MakaraCelComprobante() {
      if (this.ComprobanteFisc.cedrnc.toString().length == 9) {
        this.MakCelRnc = "###-#####-#"
      }
      if (this.ComprobanteFisc.cedrnc.toString().length >= 11) {
        this.MakCelRnc = "###-#######-#"
      }
    },

    // Comprobando si el valor de la selección es nulo o no.
    SelctCbMotivoAnulacion() {
      var _this = this
      setTimeout(function() {
        if (_this.TipoAnulacion == null) {
          _this.TipoAnulacion = ""
        }

        if (!_this.TipoAnulacion.hasOwnProperty("codigo")) {
          _this.TipoAnulacion = ""
          _this.TipoAnulacion = null
          return
        }
      }, 300)
    },


    calcularToTalRecIng() {
      var tot =
        this.ReciboIngresoFactura.efectivo +
        this.ReciboIngresoFactura.cheque +
        this.ReciboIngresoFactura.transferencia +
        this.ReciboIngresoFactura.tarjeta

      this.devueltaRecIngreso =
        Math.round((tot - this.ReciboIngreso.abono) * 100) / 100
    },
    async AllSelcDevObtenerDatoSelect(e) {

      if (e.value == true) {

        var _this = this
        setTimeout(function() {

          _this.DevolucionFacturaSeleccionada.SeletDetalleList.forEach(element => {

            if (element.cantidadPendiente == 0) {
              const index = _this.DevolucionFacturaSeleccionada.SeletDetalleList.indexOf(element)
              _this.DevolucionFacturaSeleccionada.SeletDetalleList.splice(index, 1)
              _this.alerta("no puede hacer una devolución a un producto con la cantidad en 0", "error")
            }

          })
        }, 200)

      }

      var _this = this
      setTimeout(function() {
        _this.DevolucionValorTotal()
      }, 400)

    },


    SelcDevObtenerDatoSelect(e) {
      // @item-selected="DevolucionObtenerDatoSelect"
      if (e.value == true) {
        if (e.item.cantidadPendiente == 0) {
          var _this = this
          setTimeout(function() {
            const index = _this.DevolucionFacturaSeleccionada.SeletDetalleList.indexOf(e.item)
            _this.DevolucionFacturaSeleccionada.SeletDetalleList.splice(index, 1)
          }, 200)
          this.alerta("no puede hacer una devolución a un producto con la cantidad en 0", "error")

        }


      }

      var _this = this
      setTimeout(function() {
        _this.DevolucionValorTotal()
      }, 400)
    },


    // Creando un nuevo objeto llamado TbPaginatorHisCli para historial de cliente.
    NewHistorialClientRecIng() {
      this.ReciboIngresoFactPendHist = true
      this.listHiscliente = []
      this.TbTotalItemHisCli = 0
      this.TbPaginatorHisCli = {
        page: 1,
        itemsPerPage: 10,
        pageStart: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      }

    },

    openFarmacoVigilancia() {

      /*if (this.RProductoCompra.length == 0) {
        this.alerta("Debe de Agregar al menos un producto a la lista", "error")
        return
      }*/


      if (this.clienteFactura == null) {
        this.OpenEjecFarmacoVigilancia = true
        this.OpenDialogCrearEditarCliente()
        return
      }

      this.nuevoFarmacoVigilancia()
      this.dataFarmacoVigilancia()

      this.dialogFarmacoVigilancia = true
      this.RedireccionFocus("RefTextFieldFarViMedico")


    },

    async dataFarmacoVigilancia() {
      if (this.clienteFactura != null) {
        this.OpenEjecFarmacoVigilancia = false
        this.farmacoVigilancia.cliente = this.clienteFactura
        this.farmacoVigilancia.telefono = this.selectTelefonoCliente(this.clienteFactura)
        this.farmacoVigilancia.direccion = this.clienteFactura.direccion
        if (this.clienteFactura.ars != null) {
          this.farmacoVigilancia.ars = this.clienteFactura.ars
        }

        this.farmacoVigilancia.nss = this.clienteFactura.hasOwnProperty("nss") ? this.clienteFactura.nss : ""
        //this.farmacoVigilancia.nss

      }

      if (this.SelectMedicoFactura != null) {
        this.farmacoVigilancia.medico = this.SelectMedicoFactura.nombre
      }
      this.farmacoVigilancia.monto = this.Totales.totalGeneral.total

      if (this.RProductoCompra.length > 0) {
        // this.RProductoCompra.forEach(element => {});
        await Promise.all(this.RProductoCompra.map(async (element) => {
          var obj = {
            codigo: 0,
            unidadProducto: element,
            cantfac: element.cantidad,
            cantrec: 0,
            cantind: 0,
            indic: "",
            desprod: `${element.productos.descripcion} (${element.unidades.descripcion.trim()})`,
            codpro: element.unidadesProductosPK.producto,
            coduni: element.unidadesProductosPK.unidad,
            estatus: false,

          }
          this.farmacoVigilancia.farmacoVigilanciaDetalleList.push(obj)
        }))
      }

      //  console.log(this.HoraFormatter(new Date()))
      this.HoraFarmacoVigilancia()
      //setInterval(this.HoraFarmacoVigilancia,60000);

    },

    HoraFarmacoVigilancia() {

      this.farmacoVigilancia.hora = this.HoraFormatter2(new Date())
      //setInterval(this.HoraFarmacoVigilancia,10000);

      /*  var cont = 0;
var rango = document.getElementById('cont');

    var id = setInterval(function(){
        rango.innerHTML = cont;
        cont++;
        if(cont == 10)
        {
            clearInterval(id);
        }
    }, 1000);*/


    },

    cancelarFarmacoVigilancia() {
      this.nuevoFarmacoVigilancia()
      this.dialogFarmacoVigilancia = false
    },


    async SalvarFarmacoVigilancia() {

      // debe asignar al menos un producto
      var ObjProRow = JSON.parse(JSON.stringify(this.farmacoVigilancia.farmacoVigilanciaDetalleList.filter((ee) => ee.cantrec > 0)))
      await Promise.all(ObjProRow.map(async (element) => {
        if (element.fechaReposicion != null) {
          element.fechaReposicion = element.fechaReposicion.trim().substr(0, 10) + "T04:00"
          if (element.cantfac >= element.cantrec) {
            element.estatus = true
          }
        }
      }))

      if (ObjProRow.length == 0) {
        this.alerta("debe asignar al menos un producto colocando la cantidad resetada", "error")
        return
      }

      // farmacoVigilancia.farmacoVigilanciaDetalleList

      if (this.$refs.formfarmacoVigilancia.validate()) {
        this.farmacoVigilancia.hora = this.HoraFormatter2(new Date())
        var obj = JSON.parse(JSON.stringify(this.farmacoVigilancia))
        obj.farmacoVigilanciaDetalleList = JSON.parse(JSON.stringify(ObjProRow))
        obj.sucursal=this.caja.sucursal
        this.loading(true)
        this.$axios
          .post(
            this.$hostname + this.$hName + "/FarmacoVigilancia/save",
            obj,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            // this.alerta("Dato guardado correctamente!", "bien2");
            var vari = res.data.estado
            if (res.data.estado === "bien") {
              vari = "bien2"


              if (localStorage.printerSelect != null) {
              }
              var selectImpre = (localStorage.printerSelect != undefined ? JSON.parse(localStorage.printerSelect) : null)
              var impresora = null
              if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
                impresora = JSON.parse(localStorage.printerSelect).nombre
              }

              var msg = {
                accion: "print",
                formato: this.caja.formatoimpresioncontado.trim(),
                impresora: impresora,
                data: this.configuraciones,
                fac: res.data.datos,
                caja: this.caja,
                cajero: this.$store.getters.GetOtrasConfigPv.cajero,
              }
              this.imprimirVigilancia(msg, "vigilancia")


            }
            this.alerta(res.data.mensage, vari)
            this.cancelarFarmacoVigilancia()
          })
          .catch((error) => {
              this.loading(false)
              this.alerta("Dato no guardado correctamente", "error")
            },
          )


      } else {
        this.alerta("los campos en rojo son requeridos", "error")
      }


    },


    eliminarFarmacoVigilancia() {

      if (this.farmacoVigilancia.codigo == 0) {
        this.alerta("seleccione una receta  para eliminar", "error")
        return 0
      }


      if (this.$refs.formfarmacoVigilancia.validate()) {
        var obj = JSON.parse(JSON.stringify(this.farmacoVigilancia))
        this.loading(true)
        this.$axios
          .post(
            this.$hostname + this.$hName + "/FarmacoVigilancia/borrado",
            obj,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            this.alerta(res.data.mensage, res.data.estado)
            this.cancelarFarmacoVigilancia()
          })
          .catch((error) => {
              this.loading(false)
              this.alerta("Dato no borrado correctamente", "error")
            },
          )


      } else {
        this.alerta("los campos en rojo son requeridos", "error")
      }
    },


    async buscarRecetaVigilancia() {
      this.consultaRecetaCreadaList = []
      //buscarFarmVigBoolFactReceta=(false:receta / true:factura)
      if (this.buscarFarmVigBoolFactReceta == false) {
        if (this.buscarFarmVigilancia == 0) {
          this.loading(true)
          this.$axios
            .get(this.$hostname + this.$hName + "/FarmacoVigilancia/FarmaByClienteList/" + this.farmacoVigilancia.cliente.codigo, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              this.loading(false)

              this.dialogConsultaRecetaCreada = true
              if (res.data.length > 0) {
                this.consultaRecetaCreadaList = JSON.parse(JSON.stringify(res.data))
              } else {
                this.alerta("este cliente no tiene receta", "error")
              }
              /*  if(res.data.hasOwnProperty('codigo')){
            this.farmacoVigilancia=JSON.parse(JSON.stringify(res.data))
            this.farmacoVigilancia.fecha=new Date(res.data.fecha).toISOString().substr(0, 10)
            this.farmacoVigilancia.fechavencimiento=new Date(res.data.fechavencimiento).toISOString().substr(0, 10)
            console.log(res.data)
          }else{
            this.alerta("No hay receta con este codigo", "error");
          }  */
            })


        } else {
          this.$axios
            .get(this.$hostname + this.$hName + "/FarmacoVigilancia/FarmaBycodigo/" + this.buscarFarmVigilancia, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              if (res.data.hasOwnProperty("codigo")) {
                this.editConsultaRecetas(res.data)
                /*this.farmacoVigilancia=JSON.parse(JSON.stringify(res.data))
            this.farmacoVigilancia.fecha=new Date(res.data.fecha).toISOString().substr(0, 10)
            this.farmacoVigilancia.fechavencimiento=new Date(res.data.fechavencimiento).toISOString().substr(0, 10)*/
              } else {
                this.alerta("No hay receta con este codigo", "error")
              }
            })
        }
      } else {
        this.buscarFacturaRecetaFarmVig()

      }

    },


    buscarFacturaRecetaFarmVig() {

      if (this.buscarFarmVigilancia == 0) {
        this.LimpiarFarmacoVigilancia()
        return
      }

      this.$axios
        .get(this.$hostname + this.$hName + `/FarmacoVigilancia/getrecetafarmacovigilancia/${this.farmacoVigilancia.cliente.codigo}/${this.buscarFarmVigilancia}`, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          if (res.data.hasOwnProperty("codigo")) {
            this.buscarFarmVigBoolFactReceta = false
            this.editConsultaRecetas(res.data)
          } else {
            this.buscarFacturaTbRecetaFarmVig()
          }

        })
        .catch((error) => {
          this.alerta("factura no encontrada", "error")
        })
    },


    buscarFacturaTbRecetaFarmVig() {
      this.selectedFactura = []
      this.listFactCliente = []
      var cliente = this.farmacoVigilancia.cliente.codigo,
        fecini = "null",
        fecfin = "null",
        caja = "null",
        sec = this.buscarFarmVigilancia
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/reimpresion/facturasCajaCodcli/" + sec +
          "/" + fecini + "/" + fecfin + "/" +
          cliente + "/" + 30 + "/" + 0 + "/" + caja,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          if (res.data.listas.length == 0) {
            this.alerta("No existe factura con este numero.", "error")
          } else {
            //this.LimpiarFarmacoVigilancia()
            this.farmacoVigilancia.farmacoVigilanciaDetalleList = []
            var _this = this
            setTimeout(function() {
              _this.databuscarFacFarmacoVigilancia(res.data.listas[0])
            }, 500)

          }

          //this.listFactCliente = res.data.listas;
        })
        .catch((error) => {
          this.alerta("Factura no encontrada ", "error")
        })
    },

    async databuscarFacFarmacoVigilancia(FACTURA) {
      this.buscarFarmVigilancia = FACTURA.facturasventaPK.secuencia
      if (FACTURA.cliente != null) {
        this.OpenEjecFarmacoVigilancia = false
        this.farmacoVigilancia.cliente = FACTURA.cliente
        this.farmacoVigilancia.telefono = this.selectTelefonoCliente(FACTURA.cliente)
        this.farmacoVigilancia.direccion = FACTURA.cliente.direccion
        if (FACTURA.cliente.ars != null) {
          this.farmacoVigilancia.ars = FACTURA.cliente.ars
        }

        this.farmacoVigilancia.nss = FACTURA.cliente.hasOwnProperty("nss") ? FACTURA.cliente.nss : ""
        //this.farmacoVigilancia.nss

      }


      this.farmacoVigilancia.monto = FACTURA.valor
      this.farmacoVigilancia.facturasventa = FACTURA

      if (FACTURA.facturasventaDetalleList.length > 0) {
        // this.RProductoCompra.forEach(element => {});
        await Promise.all(FACTURA.facturasventaDetalleList.map(async (element) => {
          var obj = {
            codigo: 0,
            unidadProducto: element,
            cantfac: element.cantidad,
            cantrec: 0,
            cantind: 0,
            indic: "",
            desprod: `${element.productos.descripcion} (${element.unidades.descripcion.trim()})`,
            codpro: element.productos.codigo,
            coduni: element.unidades.codigo,
            // codpro:element.unidadesProductosPK.producto,
            // coduni:element.unidadesProductosPK.unidad,
            estatus: false,

          }
          this.farmacoVigilancia.farmacoVigilanciaDetalleList.push(obj)
        }))
      }

      //  console.log(this.HoraFormatter(new Date()))
      this.HoraFarmacoVigilancia()
      //setInterval(this.HoraFarmacoVigilancia,60000);

    },


    async editConsultaRecetas(e) {
//this.farmacoVigilanciaDetalleList
      var OBJ = JSON.parse(JSON.stringify(e))
      Promise.all(OBJ.farmacoVigilanciaDetalleList.map(async (element) => {
        element.fechaReposicion = element.nuevaFechaReposicion
        if (!element.hasOwnProperty("estatus")) {
          element.estatus = false
        }
        if (element.hasOwnProperty("estatus") && element.estatus == null) {
          element.estatus = false
        }

        //unidadesProductosPK:{producto:229,unidad:15}
        var ObjProRow = this.RProductoCompra.filter((ee) => ee.unidadesProductosPK.producto == element.codpro && ee.unidadesProductosPK.unidad == element.coduni)
        if (ObjProRow.length > 0) {
          element.cantfac = element.cantfac + ObjProRow[0].cantidad
        }

      }))

      OBJ.fecha = new Date(e.fecha).toISOString().substr(0, 10)
      OBJ.fechavencimiento = new Date(e.fechavencimiento).toISOString().substr(0, 10)
      this.farmacoVigilancia = JSON.parse(JSON.stringify(OBJ))
      this.buscarFarmVigilancia = JSON.parse(JSON.stringify(e.codigo))

      /*this.buscarFarmVigilancia=JSON.parse(JSON.stringify(e.codigo))
this.farmacoVigilancia.fecha=new Date(e.fecha).toISOString().substr(0, 10)
this.farmacoVigilancia.fechavencimiento=new Date(e.fechavencimiento).toISOString().substr(0, 10)
this.farmacoVigilancia.hora=JSON.parse(JSON.stringify(e.hora))
this.farmacoVigilancia.medico=JSON.parse(JSON.stringify(e.medico))
this.farmacoVigilancia.monto=e.monto
this.farmacoVigilancia.padecimiento=JSON.parse(JSON.stringify(e.padecimiento))
this.farmacoVigilancia.farmacoVigilanciaDetalleList= JSON.parse(JSON.stringify(e.farmacoVigilanciaDetalleList))*/
// .substr(0,7)
      /*fecha: "2023-04-04T00:00:00-04:00"
fechavencimiento: "2023-04-29T00:00:00-04:00"
hora: (...)
medico: ""
monto: 100
nss: (...)
padecimiento: ""
telefono: (...)*/

      this.dialogConsultaRecetaCreada = false
    },

    LimpiarFarmacoVigilancia() {

      this.buscarFarmVigilancia = 0
      this.farmacoVigilancia.medico = ""
      this.farmacoVigilancia.codigo = 0
      this.farmacoVigilancia.hora = null
      this.farmacoVigilancia.fechavencimiento = null
      this.farmacoVigilancia.padecimiento = ""
      this.farmacoVigilancia.farmacoVigilanciaDetalleList = []

      this.dataFarmacoVigilancia()

    },
    nuevoFarmacoVigilancia() {
      this.buscarFarmVigilancia = 0
      this.farmacoVigilancia = {
        codigo: 0,
        autorizacion: "",
        direccion: "",
        fecha: fechaNueva(),
        fechavencimiento: null,
        hora: null,
        medico: "",
        padecimiento: "",
        monto: 0,
        nss: "",
        telefono: "",
        borrado: false,
        ars: null,
        cliente: null,
        farmacoVigilanciaDetalleList: [],
        facturasventa: null,

      }
      this.farmacoVigilanciaSoloReceta = false

      this.consultaRecetaFarmVig = {
        desde: null,
        hasta: null,
      }

    },

    changeCombertirSoloReceta(e) {

      var _this = this
      setTimeout(function() {
        if (e == true) {
          Promise.all(_this.farmacoVigilancia.farmacoVigilanciaDetalleList.map(async (element) => {
            element.cantfac = 0
          }))
        }
        if (e == false) {
          _this.farmacoVigilanciaSoloReceta = true
        }


      }, 300)

    },


    // Establecer la fecha a la fecha de hoy si el usuario no ha ingresado una fecha.
    BlurDesdeFarmVig() {

      if (this.consultaRecetaFarmVig.desde != null && this.consultaRecetaFarmVig.desde.toString().length == 0) {
        this.consultaRecetaFarmVig.desde = null
      }

      if (this.consultaRecetaFarmVig.desde == null) {
        this.consultaRecetaFarmVig.desde = this.fechaNueva()
        var _this = this
        setTimeout(function() {
          _this.consultaRecetaFarmVig.desde = null
        }, 500)
      }

    },
    // Establecer la fecha a la fecha de hoy si el usuario no ha ingresado una fecha.
    BlurHastaFarmVig() {
      if (this.consultaRecetaFarmVig.hasta != null && this.consultaRecetaFarmVig.hasta.toString().length == 0) {
        this.consultaRecetaFarmVig.hasta = null
      }

      if (this.consultaRecetaFarmVig.hasta == null) {
        this.consultaRecetaFarmVig.hasta = this.fechaNueva()
        var _this = this
        setTimeout(function() {
          _this.consultaRecetaFarmVig.hasta = null
        }, 500)
      }

    },

    getConsultaRecetaCreadaList(LIST) {

      /*if (this.datosImprecionAll.desde.toString().length == 0) {
        this.datosImprecionAll.desde = this.fechaNueva();
      }*/

      var BOOLREQ = this.consultaRecetaFarmVig.desde != null && this.consultaRecetaFarmVig.desde.toString().length > 9 && this.consultaRecetaFarmVig.hasta != null && this.consultaRecetaFarmVig.hasta.toString().length > 9
      if (BOOLREQ == true) {
        return LIST.filter((ee) => ee.nuevaFecha >= this.consultaRecetaFarmVig.desde && ee.nuevaFecha <= this.consultaRecetaFarmVig.hasta)
      } else {
        return LIST
      }

      /*if(this.dialogConsultaRecetaCreada==true){
  }*/

    },

    async SeachTextFilVendedorCodigo(e) {
      var codigo = e.target.value.trim()
      if (codigo.length == 0) {
        this.blurTextFilVendedorCodigo()
        return
      }
      var vendedores = []
      if (this.pvOnline == false || (typeof navigator !== "undefined" && navigator.onLine == false)) {
        await this.cargarVendedoresOffline(codigo)
        vendedores = this.RVendedor || []
      } else {
        try {
          var res = await this.$axios.get(this.$hostname + this.$hName + "/vendedores/findallactiv", {
            headers: this.$store.getters.GetheadersAxios,
          })
          vendedores = res.data || []
          await this.guardarVendedoresOffline(vendedores)
        } catch (error) {
          if (this.esErrorConexionPv(error)) {
            this.activarModoOfflinePorErrorConexion(error)
            await this.cargarVendedoresOffline(codigo)
            vendedores = this.RVendedor || []
          } else {
            this.alerta("No existe vendedor con ese código", "error")
            this.blurTextFilVendedorCodigo()
            return
          }
        }
      }
      var ObjProRowSUC = vendedores.filter((ee) => ee.sucursal == null || ee.sucursal != null && ee.sucursal.codigo == this.caja.sucursal.codigo)
      var ObjProRow = ObjProRowSUC.filter((ee) => ee.codigo2 != null && ee.codigo2.trim() == codigo)
      if (ObjProRow.length > 0) {
        this.Facturasventa.vendedor = ObjProRow[0]
        this.SalvarVendedores()
        this.blurTextFilVendedorCodigo()
      } else {
        this.alerta("No existe vendedor con ese código", "error")
        this.blurTextFilVendedorCodigo()
      }
    },
    blurTextFilVendedorCodigo() {
      this.searchVendedorCodigo = ""
      this.activoF7 = false
      var _this = this
      setTimeout(function() {
        _this.$refs.RefTextFieldProducto.focus()
      }, 500)

    },


    // Busqueda de codigo_barra_preferencial del cliente .
    SeachTextFilBarraPreferencial(e) {
      if (e.trim().length > 0) {
        this.$axios
          .get(this.$hostname + this.$hName + "/clientes/getclientebarrapreferencial/" + e, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            if (res.data.hasOwnProperty("codigo")) {
              this.clienteFactura = res.data
              this.clienteFactura.codnom = `${res.data.codigo} - ${res.data.nombre.trim()} `
              this.alerta("Cliente Seleccionado", "bien2")

              var _this = this
              setTimeout(function() {
                _this.CompletaDatoClienteSelectFactura()
                _this.searchProducto = ""
                _this.$refs.RefTextFieldProducto.focus()

              }, 300)


            } else {
              this.alerta("No existe cliente preferencial con ese código", "error")
            }

          })
          .catch(error => {
            this.alerta("dato no encontrado", "error")
          })


      } else {

      }


    },

    // Comprobando si el valor de la entrada es nulo o indefinido.
    SelctCbClienteBuscarCredito() {
      var _this = this
      setTimeout(function() {
        if (_this.clienteTempCredito == null) {
          _this.clienteTempCredito = ""
        }

        if (!_this.clienteTempCredito.hasOwnProperty("codigo")) {
          _this.clienteTempCredito = ""
          _this.clienteTempCredito = null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
      }, 300)
    },

//cancela la seleccion de cliente a credito con cobertura
    cancelarSeleccionClienteCredito() {
      this.dialogSelectClienteTempCredito = false
      this.clienteTempCredito = null
    },

    SalvarSeleccionClienteCredito() {


      if (this.$refs.formSeleccionClienteCreditoCobertura.validate()) {
        this.dialogSelectClienteTempCredito = false

        if (this.clienteTempCredito.tipocomprobante != null) {
          this.Facturasventa.tipocomprobante = this.clienteTempCredito.tipocomprobante
          this.ComprobanteFisc.comprobante = this.clienteTempCredito.tipocomprobante
        } else {
          this.Facturasventa.tipocomprobante = this.$store.getters.GetConfiguracionGeneral.configPv.comprobantefacturacion
          this.ComprobanteFisc.comprobante = this.$store.getters.GetConfiguracionGeneral.configPv.comprobantefacturacion
        }

        if (this.clienteTempCredito.telefonosClientesList.length > 0) {
          this.Facturasventa.telefononcf = this.clienteTempCredito.telefonosClientesList[0].telefonosClientesPK.telefono
          this.ComprobanteFisc.telefono = this.clienteTempCredito.telefonosClientesList[0].telefonosClientesPK.telefono
        }

        if (this.clienteTempCredito.cedrnc != null && this.clienteTempCredito.cedrnc.length > 0) {
          this.Facturasventa.cedularncncf = this.clienteTempCredito.cedrnc.trim()
          this.ComprobanteFisc.cedrnc = this.clienteTempCredito.cedrnc.trim()
        }

        this.Facturasventa.nombreDgii = this.clienteTempCredito.nombre
        this.ComprobanteFisc.nombre = this.clienteTempCredito.nombre
        this.Facturasventa.direccionncf = this.clienteTempCredito.direccion
        this.ComprobanteFisc.direccion = this.clienteTempCredito.direccion
        //this.SalvarComprobante()
        this.CalcularTotalesProductosCompra()
        var _this = this
        setTimeout(function() {
          _this.ContrealizarCobro()
        }, 900)

      } else {
        this.alerta("los campos en rojo son requeridos", "error")
      }

    },


    MakaraCelAuto(e) {

      var MakCelRnc = "#############"
      if (e == null || e.cedrnc == null) {
        return MakCelRnc
      }


      if (e.cedrnc.toString().length == 9) {
        MakCelRnc = "###-#####-#"
      }
      if (e.cedrnc.toString().length >= 11) {
        MakCelRnc = "###-#######-#"
      }

      this.MakCelRnc = MakCelRnc
      return MakCelRnc
    },

    finalizarReimprimirKeyEsc(e) {
      if (e.keyCode == 27) {
        this.ListReimprecion = []
        this.NewReimprecionFacturaSeleccionada()
        this.BtnReimprecionvalue = 0
        this.dialogReimprecion = false
      }


    },


    // Una función que quita  el descuento a  cliente a credito .
    async QuitarDescuentoClienteCredito() {
      var QUITAR_DESC = this.$store.getters.GetConfiguracionGeneral.configPv.quitarDescuentoClienteCredito
      this.dialogNotifQuitarDescuentoCliente = false
      if (QUITAR_DESC != null && QUITAR_DESC == true) {
        this.Descuentofactura.descuento = 0
        this.Descuentofactura.ValorPorc = false
        await this.SalvarDescuentoFactura()
        //this.SalvarDescuentoFactura()

        /* var _this = this;
      setTimeout(function () {
        _this.SalvarDescuentoFactura()
      }, 600);*/

      }


    },

    getTasaMonedaSelect(valor) {
      var BVALOR = 0
      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)
      BVALOR = ((MONEDA.tasa / MONEDAFACTURA) * valor)
      return BVALOR
    },

    getTasaMonedaInfo(valor, moneda) {
      var BVALOR = 0
      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURA = (moneda != null ? moneda.tasa : MONEDA.tasa)
      BVALOR = ((MONEDA.tasa / MONEDAFACTURA) * valor)
      return BVALOR
    },

    getTasaInfo(valor, tasaSelect) {
      var BVALOR = 0
      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURA = (tasaSelect != null ? tasaSelect : MONEDA.tasa)
      BVALOR = ((MONEDA.tasa / MONEDAFACTURA) * valor)
      return BVALOR
    },


 getDecimalPlacesCantProd() {
  var cantidadDecimales =this.$store.getters.GetConfiguracionGeneral.configPv.cantidadDecimales

  var estacionGas= this.$store.getters.GetConfiguracionGeneral.config.estacion
  var estacionCombustible= this.$store.getters.GetConfiguracionGeneral.config.estacionCombustible
  var CANTREDONDEO= estacionGas==true || estacionCombustible==true?cantidadDecimales:2
  return CANTREDONDEO
 },

    getDecimalPlaces() {

    var cantidadDecimales =this.$store.getters.GetConfiguracionGeneral.configPv.cantidadDecimales
    var cantDec =  cantidadDecimales!=null && cantidadDecimales>0?cantidadDecimales:2

      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)
      var CANTREDONDEO = (MONEDAFACTURA != MONEDA.tasa ? 4 : cantDec)
      //var CANTREDONDEO = (MONEDAFACTURA != MONEDA.tasa ? 4 : 2)
      return CANTREDONDEO
    },

    ActualizarCotizacionFActurada(COTZ) {

      this.$axios
        .get(this.$hostname + this.$hName + "/cotizacion/ActualizarCotizacionFActurada/" + COTZ.secuencia, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RCaja = res.data))

    },


    filterCotizacionAfactura(List) {
      //RtipoComprobante
      return List.filter((ee) => ee.facturada == false)
      //return List.filter((ee) => ee.pv==true && ee.itbis==true );
    },

    //modalidad ruta/vendedor
    verificarVendedor() {
      if (this.$store.getters.GetConfiguracionGeneral.configPv.modalidadRutaVendedor == true && this.caja != null) {
        if (this.caja.hasOwnProperty("vendedor") && this.caja.vendedor != null && this.caja.vendedor.hasOwnProperty("codigo")) {
          this.Facturasventa.vendedor = this.caja.vendedor
          this.objTemp = JSON.parse(JSON.stringify(this.caja.vendedor))
          var _this = this
          setTimeout(function() {
            _this.cancelarVendedores()
          }, 300)

        }
        /* else{
     this.Facturasventa.vendedor=null
     this.objTemp=null
    this.OpenVendedores()
     this.alerta("El modo ruta/vendedor esta activo, debe asignar un vendedor.","error")
    }*/

      }

    },


    openPendientesEntrega() {
      this.dialogMedicamentosPendientes = true
    },

    openConsultaBalancePunto() {
      this.dialogConsultaBalancePunto = true


      var _this = this
      setTimeout(function() {
        //  _this.$refs.RefComponentsPvModalConsultaBalancePunto.dialogClienteBalancePunto=true
        _this.$refs.RefComponentsPvModalConsultaBalancePunto.focusRefTextFieldCodigoBarra()
      }, 500)


    },


    openConsultaConsumoCliente() {
      this.dialogConsultaConsumoCliente = true


      var _this = this
      setTimeout(function() {
        _this.$refs.RefComponentsPvModalConsultaConsumoCliente.dialogConsultaConsumoCliente = true
        _this.$refs.RefComponentsPvModalConsultaConsumoCliente.focusRefTextFieldCodigoBarra()
      }, 500)


    },
    openCrearModificarCliente() {
      this.dialogCrearModificarCliente = true


      var _this = this
      setTimeout(function() {
        _this.$refs.RefComponentsPvModalCrearModificarCliente.dialogCrearModificarCliente = true
        _this.$refs.RefComponentsPvModalCrearModificarCliente.dataClienteSeleccionado(_this.clienteFactura)
        _this.$refs.RefComponentsPvModalCrearModificarCliente.focusRefTextFieldBuscar()

      }, 500)


    },


    finalizarPanelInformaciónProductoEsc(e) {
      if (e.keyCode == 27) {
        this.cancelarInfProducto()
      }
    },


    promesaConTimeout(promesa, tiempoMs, mensaje) {
      var timeout = null
      var promesaTimeout = new Promise((resolve, reject) => {
        timeout = setTimeout(() => {
          reject(new Error(mensaje))
        }, tiempoMs)
      })

      return Promise.race([promesa, promesaTimeout]).finally(() => {
        if (timeout != null) {
          clearTimeout(timeout)
        }
      })
    },

    finalizarFacturaElectronicaPendiente(FACT, error) {
      console.log("FACTURA ELECTRONICA PENDIENTE", error)
      this.alerta("Factura guardada. DGII no respondio en el tiempo esperado. Queda pendiente de envio electronico.", "error")
      this.enviarImprimirFactura(FACT)
    },

    async facturacionEletronicaGet(FACT) {
      var tiempoMaximoDGII = 10000

      try {
        var TipoeCF = FACT.tipocomprobante.hasOwnProperty("tipoEcf") && FACT.tipocomprobante.tipoEcf != null ? FACT.tipocomprobante.tipoEcf : ""
        var promesaFacturaElectronica = null

        if (TipoeCF == 32 && FACT.valor < 250000) {
          promesaFacturaElectronica = this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_RFCE(FACT)
        } else {
          promesaFacturaElectronica = this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF(FACT)
        }

        var resObjCompleto = await this.promesaConTimeout(promesaFacturaElectronica, tiempoMaximoDGII, "Tiempo de espera DGII agotado")

        if (resObjCompleto == null || resObjCompleto.objtrackId == null) {
          throw new Error("DGII no retorno datos validos")
        }

        if (typeof resObjCompleto.objtrackId === "object" && resObjCompleto.objtrackId.hasOwnProperty('estado')) {
          if (resObjCompleto.objtrackId.estado === "Rechazado") {
            var msj_Error = ""

            if (resObjCompleto.objtrackId.mensajes != null) {
              resObjCompleto.objtrackId.mensajes.forEach((element) => {
                msj_Error += ` *- COD:${element.codigo} :${element.valor} \n`
              })
            }

            this.alerta(msj_Error, "error")
          }
        }

        await this.actualizarFAC_ELETRONICA(FACT, resObjCompleto)
      } catch (error) {
        this.finalizarFacturaElectronicaPendiente(FACT, error)
      } finally {
        this.loading(false)
      }
    },

    async actualizarFAC_ELETRONICA(FACT, objCompTrackId) {
      try {
        var TRACK = objCompTrackId.objtrackId

        var objTrack = {
          documento: FACT.facturasventaPK.documento,
          secuencia: FACT.facturasventaPK.secuencia,
          fechafirmadgii: objCompTrackId.fechafirmadgii,
          qrdgii: objCompTrackId.qrdgii,
          signatureValue: objCompTrackId.signatureValue,
          trackId: JSON.stringify(TRACK),
        }

        var res = await this.$axios.post(this.$hostname + this.$hName + "/pv/actualizarFactEletronica",
          objTrack, { headers: this.$store.getters.GetheadersAxios })

        this.enviarImprimirFactura(res.data)

        if (!objTrack.trackId.includes("Aceptado") && !objTrack.trackId.includes("Rechazado")) {
          var _this = this
          setTimeout(function() {
            _this.alerta("FACTURA salvado correctamente !!!...", "bien")
          }, 200)
        }
      } catch (error) {
        console.log("actualizartoken no guardado correctamente-->", error)
        throw error
      }
    },
    async DevolucionEletronicaGet(FACT) {

     console.log('ver-EletronicaGet-->',FACT)

      var CodigoModificacion = 3
      var resObjCompleto = await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF_DEV(FACT, CodigoModificacion)
      console.log("DevolucionEletronicaGet--->",CodigoModificacion)
      if (resObjCompleto.objtrackId.estado === "Rechazado") {
        var msj_Error = ""

        Promise.all(resObjCompleto.objtrackId.mensajes.map(async (element) => {
          msj_Error += ` *- COD:${element.codigo} :${element.valor} \n`
        }))

        this.alerta(msj_Error, "error")
        this.actualizarDEV_ELETRONICA(FACT, resObjCompleto)
        return
      }
//this.enviarImprimirFactura(FACT)
      this.actualizarDEV_ELETRONICA(FACT, resObjCompleto)

    },

    actualizarDEV_ELETRONICA(FACT, objCompTrackId) {
      var TRACK = objCompTrackId.objtrackId
      //delete TRACK["mensajes"]

      var objTrack = {
        documento: FACT.devoclucionPK.documento,
        secuencia: FACT.devoclucionPK.secuencia,
        fechafirmadgii: objCompTrackId.fechafirmadgii,
        qrdgii: objCompTrackId.qrdgii,
        signatureValue: objCompTrackId.signatureValue,
        trackId: JSON.stringify(TRACK),
      }

    if(FACT.hasOwnProperty('notacreditoclientes')&& FACT.notacreditoclientes!=null){
      this.actualizarNOTA_CreditoCxC_ELETRONICA(FACT.notacreditoclientes, objCompTrackId)
    }
      this.$axios.post(this.$hostname + this.$hName + "/devolucion/actualizarDevolicionEletronica",
        objTrack, { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          if (objCompTrackId.objtrackId.estado === "Aceptado") {
            this.devolucion = res.data
            this.cancelarAceptarDevolucion()
            this.enviarImprimirDevolucion(res.data)
          }

          if (objCompTrackId.objtrackId.estado === "Aceptado Condicional") {
            this.devolucion = res.data
            this.cancelarAceptarDevolucion()
            this.enviarImprimirDevolucion(res.data)
          }

           if (objCompTrackId.objtrackId.estado === "Rechazado") {
            //this.devolucion = res.data
            this.anulacionDevolucion(res.data)

          }

        })
        .catch((error) => {
          console.log("actualizartoken no guardado correctamente-->", error)
        })

    },


actualizarNOTA_CreditoCxC_ELETRONICA(FACT, objCompTrackId) {
      var TRACK = objCompTrackId.objtrackId
      //delete TRACK["mensajes"]

      var objTrack = {
        documento: FACT.notacreditoclientesPK.documento,
        secuencia: FACT.notacreditoclientesPK.secuencia,
        fechafirmadgii: objCompTrackId.fechafirmadgii,
        qrdgii: objCompTrackId.qrdgii,
        signatureValue: objCompTrackId.signatureValue,
        trackId: JSON.stringify(TRACK),
      }


      this.$axios.post(this.$hostname + this.$hName + "/notacreditocliente/actualizarFactEletronica",
        objTrack, { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          console.log('.ACT')
        })
        .catch((error) => {
          console.log("actualizartoken no guardado correctamente-->", error)
        })

    },
 


anulacionDevolucion(DEV_DATA){

 var link=`${DEV_DATA.devoclucionPK.secuencia}/${DEV_DATA.devoclucionPK.documento}`

this.$axios.get(
            this.$hostname + this.$hName + "/anularDevolucion/notaCreditoContadoDevolucion/" + link,
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then((res) => {
            if(res.data==true){
                    this.alerta("Esta Devolucion no puede ser anulada, porque tiene Nota de credito aplicada", "error");
                    return
                  }
                  
          this.$axios
            .post(
              this.$hostname + this.$hName + "/anularDevolucion/anular/",
              DEV_DATA,
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => 
            console.log("Dato Anulado correctamente", "bien")
          )
            .catch((error) => this.alerta(error, "error"));
        

          })
          .catch((error) => {
            console.error(error);
          });



},



    updateFactTemEnUso(e) {

      // verifOrUpdate:true: verifica , verifOrUpdate:false: resetea a uso false

      var permitirAbrirFacTEM = this.$store.getters.GetConfiguracionGeneral.configPv.permitirAbrirFacTempLugaresDiferente
      if (permitirAbrirFacTEM == true) {
        console.log("permitirAbrirFacTEM==true")
      } else {
        var objFacTem = {
          secuencia: e.secuencia,
          verifOrUpdate: false,
        }

        this.$axios
          .post(this.$hostname + this.$hName + "/temporales/verifOrUpdateusofacturatemporal/", objFacTem, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            console.log("--vIENDO iNFOMACION")
          })
          .catch((error) =>
            console.log("Dato no conectado.", "error"),
          )
      }

    },

    boolModoEstacion(){
      var boolEstacion=this.$store.getters.GetConfiguracionGeneral.config.hasOwnProperty('estacion')&& this.$store.getters.GetConfiguracionGeneral.config.estacion!=null &&this.$store.getters.GetConfiguracionGeneral.config.estacion==true;
      var boolEstacion_Combustible=this.$store.getters.GetConfiguracionGeneral.config.hasOwnProperty('estacionCombustible')&& this.$store.getters.GetConfiguracionGeneral.config.estacionCombustible!=null &&this.$store.getters.GetConfiguracionGeneral.config.estacionCombustible==true;
      return (boolEstacion==true || boolEstacion_Combustible==true)
    },

    turnoEstacionInterval() {
      var _this=this;
      //this.setIntervalturnoEstacion=setInterval(function(){ _this.ejecutarTurnoEstacionInterval() }, 10000);

this.$axios.get(this.$hostname + this.$hName + "/turnos-trabajo/findallBorrado", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          
          this.RTurnoTrabajo = res.data

            setTimeout(function(){ 
            _this.ejecutarTurnoEstacionInterval()
            }, 900);

        })
    },

   
    ejecutarTurnoEstacionIntervalghjghj() {


const ahora = new Date();
const hora = String(ahora.getHours()).padStart(2, "0");
const minuto = String(ahora.getMinutes()).padStart(2, "0");
const segundo = String(ahora.getSeconds()).padStart(2, "0");
const horaActual=(`${hora}:${minuto}:${segundo}`)
var ObjProRow = this.RTurnoTrabajo.filter((ee) => ee.horaEntrada>=horaActual && ee.horaSalida< horaActual)
console.log('ObjProRow-->',ObjProRow)
    },


ejecutarTurnoEstacionInterval() {

  if(this.RTurnoTrabajo.length == 0){

this.alerta(`NOTA: No existen turnos guardado para seleccionar el turno automatico.`, "warning")
    return
  }
  // 1. Función para convertir "HH:MM:SS" a segundos desde medianoche
  const timeToSeconds = (timeStr) => {
    const [h, m, s] = timeStr.split(":").map(Number);
    return h * 3600 + m * 60 + s;
  };

  // 2. Hora actual en segundos
  const ahora = new Date();
  const currentSeconds =
    ahora.getHours() * 3600 +
    ahora.getMinutes() * 60 +
    ahora.getSeconds();

  // 3. Buscar el turno que aplica ahora mismo
  const turnoActual = this.RTurnoTrabajo.find((t) => {
    const start = timeToSeconds(t.horaEntrada);
    const end   = timeToSeconds(t.horaSalida);

    if (start <= end) {
      // Turno NORMAL (no cruza medianoche), ej: 02:00:00 → 12:00:00
      return currentSeconds >= start && currentSeconds < end;
    } else {
      // Turno que CRUZA medianoche, ej: 20:00:00 → 02:00:00
      return currentSeconds >= start || currentSeconds < end;
    }
  });

if(turnoActual == null){
this.alerta("No hay un turno configurado para la hora actual", "error")
return
}

if(this.OtrasConfigPv.turno!=null &&this.OtrasConfigPv.turno.hasOwnProperty("codigo") && this.OtrasConfigPv.turno.codigo==turnoActual.codigo){
//El TUNO ESTA SELECCIONADo
  //UpdateConfigPvTurno()
}else{
this.OtrasConfigPv.turno=turnoActual
this.UpdateConfigPvTurno(this.OtrasConfigPv)
}



},


     canselarTurnoEstacionInterval() {
      /*clearInterval(this.setIntervalturnoEstacion)
      this.setIntervalturnoEstacion = null*/
    },


    getInfFactEletronica(data){

      var BOOL=false
      if(this.caja.facturacionEletronica==true && data.hasOwnProperty('trackId') &&  data.trackId!=null){
        BOOL=true
      }
      return BOOL

    },


 // Hacer una llamada al servidor para obtener los datos.
    getConduceMultiplelistFactCliente() {

      if(this.ConduceBusquedaMultiple.cliente == null || this.ConduceBusquedaMultiple.cliente!=null && typeof this.ConduceBusquedaMultiple.cliente ==="string" && this.ConduceBusquedaMultiple.cliente.trim().length==0){
          this.alerta("NOTA: EN EL CAMPO CLIENTE, DEBE COLOCAL UN NOMBRE O SELECCIONAR UN CLIENTE ", "error")
          return
       }

    
      this.VerCotizacionlistFactCliente = []
      this.selectedListConduceMultiple =[]
      var sec,
        fecini,
        fecfin,
        cliente = null
      if (this.ConduceBusquedaMultiple.secuencia != null) {
        sec = this.ConduceBusquedaMultiple.secuencia
      }
      if (this.ConduceBusquedaMultiple.fechaInicial != null) {
        fecini = this.ConduceBusquedaMultiple.fechaInicial
      }
      if (this.ConduceBusquedaMultiple.fechaFinal != null) {
        fecfin = this.ConduceBusquedaMultiple.fechaFinal
      }
      // if (this.ConduceBusqueda.cliente != null) {
      //   cliente = this.ConduceBusqueda.cliente
      // }

       if(this.ConduceBusquedaMultiple.cliente != null && typeof this.ConduceBusquedaMultiple.cliente ==="string"){
          cliente = this.ConduceBusquedaMultiple.cliente.trim()
          }

          if(this.ConduceBusquedaMultiple.cliente != null && typeof this.ConduceBusquedaMultiple.cliente ==="object" && this.ConduceBusquedaMultiple.cliente.hasOwnProperty('nombre')){
           cliente = this.ConduceBusquedaMultiple.cliente.nombre.trim()
          }


      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/reimpresion/conduce/" +
          sec +
          "/" +
          fecini +
          "/" +
          fecfin +
          "/" +
          cliente +
          "/" +
          this.ReimprecionPaginator.itemsPerPage +
          "/" +
          this.ReimprecionPaginator.pageStart,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          //*this.TotalRegistros = res.data.cantidad,
          this.VerConducelistFactCliente = res.data.listas
        })
    },




      async obtenerDatoSelectConduceMultiple(e) {
      this.obtenerDatoSelectConduceMultipleClickRow(e.item)
      },

      async obtenerDatoSelectConduceMultipleClickRow(e) {
      this.loaderTablaCargar()

      if(this.selectedListConduceMultiple.length>0 && this.selectedListConduceMultiple.filter((ee) => ee.indx === e.indx).length>0){
      const index =  this.selectedListConduceMultiple.indexOf(e)
      this.selectedListConduceMultiple.splice(index, 1)
      return
      }

      this.selectedListConduceMultiple.push(JSON.parse(JSON.stringify(e)))
      },

     async aplicarConduceMultiple(){

      console.log('ver obje-->',OBJ_CONDUCE)
         if(this.selectedListConduceMultiple.length==0){
          this.alerta("NOTA: DEBE SELECCIONAR AL MENOS UN CONDUCE ", "error")
          return
          }
          this.ListConduceMultiple=JSON.parse(JSON.stringify(this.selectedListConduceMultiple)) 

        // AGREGA TODOS LOS DETALLE DE LOS ARRAYS a UNA VARIABLE
         const OBJ_CONDUCE = {
            ...this.selectedListConduceMultiple[0],
            conduceInventarioDetalleList: this.selectedListConduceMultiple.flatMap( element => element.conduceInventarioDetalleList )
          };
        
          console.log('-->',this.selectedListConduceMultiple)
        // Extraemos todos los códigos en un array
const codigos = this.selectedListConduceMultiple.map(item => item.conduceInventarioPK.secuencia);
// Obtenemos el código menor y mayor
const codigoMenor = Math.min(...codigos);
const codigoMayor = Math.max(...codigos); 

OBJ_CONDUCE.comentarioConducemultiple=`No.AUTORIZACION:  
PER.FACTURA: ${this.FormatoFecha(this.fechaNueva())}
CANT.CONDUCE: ${this.selectedListConduceMultiple.length}   DEL No.${codigoMenor} AL ${codigoMayor}
BLOQUE:    `

const resultado = Object.values(
 OBJ_CONDUCE.conduceInventarioDetalleList.reduce((acc, item) => {
    const key = `${item.producto.codigo}-${item.unidad.codigo}-${item.oferta!=null?item.oferta:false}`;
    if (!acc[key]) {
      // clonamos el objeto completo
        acc[key] = { ...item };
        acc[key].valorimpuesto!=null?item.valorimpuesto:0;
        acc[key].valordescuento!=null?item.valordescuento:0;
        acc[key].oferta!=null?item.oferta:false;
    } else {
        acc[key].cantidad += item.cantidad;
        acc[key].valordescuento += item.valordescuento ?item.valordescuento: 0;
    }

    return acc;

  }, {})
);
OBJ_CONDUCE.conduceInventarioDetalleList=resultado

          this.objTemp=JSON.parse(JSON.stringify(OBJ_CONDUCE)) 

          var _this = this
      setTimeout(function() {
        _this.dialogSelectClienteTempConduceMultiple = true
      }, 500)
         
      },


      // Comprobando si el valor de la entrada es nulo o indefinido.
    SelctCbClienteTempConduceMultiple() {
      var _this = this
      setTimeout(function() {
        if (_this.clienteTempConduceMultiple == null) {
          _this.clienteTempConduceMultiple = ""
        }

        if (!_this.clienteTempConduceMultiple.hasOwnProperty("codigo")) {
          _this.clienteTempConduceMultiple = ""
          _this.clienteTempConduceMultiple = null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
      }, 300)
    },

    SalvarSeleccionClienteTempConduceMultiple(){
if (this.$refs.formSeleccionClienteConduceMultiple.validate()) {
  this.objTemp.cliente =this.clienteTempConduceMultiple
  this.VerConduceDatostabla(this.objTemp) 

      var _this = this
      setTimeout(function() {
        _this.objTemp=null
        _this.conduceSelect=null
        _this.dialogBucarConduceMultiple = false
        _this.dialogSelectClienteTempConduceMultiple = false
        _this.NewBucarConduceMultiple()
      }, 800)

   }else {
        this.alerta("los campos en rojo son requeridos", "error")
      }
      


    },

    deleteConduceMultiple(e) {
      this.$axios
        .post(this.$hostname + this.$hName + "/conduce/deleteConduceMultiple/", e, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          // this.BuscarRestaurarFacturas();
        })
        .catch((error) =>
          this.alerta("Dato no eliminado correctamente.", "error"),
        )

    },

    async validacionConducePorHora(){
      //VALIDACION ANTERIOR
     // var condFAct = (this.conduceSelect != null)
      /*  if ( condFAct == false && this.caja.marca &&  this.configuraciones.configPv.conduce && this.Facturasventa.cobertura==0 &&
              (this.Facturasventa.efectivo * MONEDAFACTURATASA) < 250000 && //el monto maximo que tieene la dgi para consumidor final B02
              this.Facturasventa.tipocomprobante.codigo === 1 && (this.Facturasventa.efectivo * MONEDAFACTURATASA) > 0 &&
              (this.Facturasventa.efectivo * MONEDAFACTURATASA) >= this.Facturasventa.valor &&
              (this.Facturasventa.tarjeta * MONEDAFACTURATASA) == 0 && (this.Facturasventa.cxc * MONEDAFACTURATASA) == 0 &&
              this.selectedListFPagoNC.length <= 0 && this.conduceSelect == null && this.domiciliofactura==null
            )*/
           var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
           var MONEDAFACTURATASA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)
           var BOOl_CALIFICAR_COND=(this.Facturasventa.cobertura==0 &&
              (this.Facturasventa.efectivo * MONEDAFACTURATASA) < 250000 && //el monto maximo que tieene la dgi para consumidor final B02
              this.Facturasventa.tipocomprobante.codigo === 1 && (this.Facturasventa.efectivo * MONEDAFACTURATASA) > 0 &&
              (this.Facturasventa.efectivo * MONEDAFACTURATASA) >= this.Facturasventa.valor &&
              (this.Facturasventa.tarjeta * MONEDAFACTURATASA) == 0 && (this.Facturasventa.cxc * MONEDAFACTURATASA) == 0 &&
              this.selectedListFPagoNC.length <= 0 && this.conduceSelect == null && this.domiciliofactura==null
            )

      var BOOL_COND_HORA=this.$store.getters.GetConfiguracionGeneral.configPv.conducePorHora
      var BOOl_IS_HORA_CONDUCE = false
    if(BOOL_COND_HORA==true && this.caja.activarConduceHora==true){  
       // 1. Función para convertir "HH:MM:SS" a segundos desde medianoche
       const timeToSeconds = (timeStr) => { const [h, m, s] = timeStr.split(":").map(Number); return h * 3600 + m * 60 + s; };
       const start = timeToSeconds(this.caja.conduceHoraInicio);
       const end  = timeToSeconds(this.caja.conduceHoraFin);
      // 2. Hora actual en segundos
       const ahora = new Date();
       const currentSeconds = ahora.getHours() * 3600 + ahora.getMinutes() * 60 + ahora.getSeconds(); 
       if(currentSeconds >= start && currentSeconds < end){ BOOl_IS_HORA_CONDUCE=true}
    }

   if(BOOl_CALIFICAR_COND==true && BOOl_IS_HORA_CONDUCE==true){
    return true;
   }else{
    return false;
   }

    },

combExtranjero(OBJ){
  //if(OBJ!=null)
   var BOOL46= OBJ!=null && OBJ.hasOwnProperty('tipocomprobante') && OBJ.tipocomprobante!=null && OBJ.tipocomprobante.hasOwnProperty('tipoEcf') && OBJ.tipocomprobante.tipoEcf!=null && OBJ.tipocomprobante.tipoEcf==46 
    return BOOL46
  //  if(BOOL46==true){ 	}
},

contNotifAdicAsignarMensajero(){
this.funcionValidaPermisoPv("AccNotifAdicAsignarMensajero")
},

cerrarNotificacionAdic(){
this.notifConfAdicional= {
      estado: false,
      nombre: "",
      Exec: "",
      objTemp:null
    }
},


// Comprobando si el valor de la entrada es nulo o indefinido.
    SelctCbDiagnostico() {
      var _this = this
      setTimeout(function() {
        if (_this.comboDiagnostico == null) {
          _this.comboDiagnostico = ""
          _this.CoberturaSeguro.diagnostico=""
        }

        if (!_this.comboDiagnostico.hasOwnProperty("codigoCIE10")) {
          _this.comboDiagnostico = ""
          _this.comboDiagnostico = null
          _this.CoberturaSeguro.diagnostico=""
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
        //_this.CoberturaSeguro.diagnostico=`${_this.comboDiagnostico.codigoCIE10}-${_this.comboDiagnostico.Diagnostico}`
        _this.CoberturaSeguro.diagnostico= _this.comboDiagnostico.codnom
      }, 300)
    },

    changeDiagnostico(e){

    if(e != null && typeof e === "object" && e.hasOwnProperty('codigoCIE10') ) {
       
      }else{
        this.CoberturaSeguro.diagnostico= ""
      }

    },


      // Creando un nuevo objeto llamado Internamientos
    newnewInternamientos() {
       this.internamiento={
        codigo: 0,
        activo: true,
        fechaIngreso: fechaNueva(),
        fechaSalida:null,
        cliente:null,
        ars:null,
        tipoasistencia:'',
        nohabitacion:'',
        documentoFactura: null,
        secuenciaFactura: null,
        borrado: false
      }
      this.dialogInternamientos=false
      this.OpenEjecInternamientos=false
    },


 // Un método que se llama cuando el usuario hace clic en el botón cancelar de un modal.
    cancelarInternamientos() {
      this.dialogInternamientos = false
      this.OpenEjecInternamientos=false

      if(this.internamiento.cliente!=null && this.internamiento.ars!=null){
        this.internamiento = JSON.parse(JSON.stringify(this.objTemp))
      }else{
      this.Facturasventa.registroInternamiento=null
      }
      
    
      this.objTemp = null
    },

    OpenInternamientos() {
      if (this.clienteFactura == null) {
        // this.filtroTipoCliente = 2
        this.filtroTipoCliente = 3
        this.OpenEjecInternamientos = true
        this.OpenDialogCrearEditarCliente()
      }
      if (this.clienteFactura != null) {
        if (this.clienteFactura.ars != null && this.clienteFactura.ars.hasOwnProperty("codigo")) {
          this.dialogInternamientos = true
          this.OpenEjecInternamientos = false
          this.objTemp = JSON.parse(JSON.stringify(this.internamiento))
          // if (this.clienteFactura.ars != null) { }
        this.internamiento.ars = JSON.parse(JSON.stringify(this.clienteFactura.ars))
        this.internamiento.cliente = JSON.parse(JSON.stringify(this.clienteFactura))

        } else {
          this.OpenEjecInternamientos = false
          this.alerta("El cliente seleccionado no contiene ars asignado", "error")
          return
        }
      }
    },

    BlurfechaIngreso() {
          if (this.internamiento.fechaIngreso.toString().length == 0) {
            this.internamiento.fechaIngreso = this.fechaNueva();
          }
        },

        // Guardando los datos en el formulario y luego actualizando los datos en la tabla de internamiento.
    async SalvarInternamiento() {
      if (this.$refs.formCrearInternamiento.validate()) {
         this.dialogInternamientos = false
         this.OpenEjecInternamientos=false
         this.Facturasventa.registroInternamiento= JSON.parse(JSON.stringify(this.internamiento))
      } else {
        this.alerta("Debe completar los datos de la cobertura", "error")
      }

    },

    getCajaCliente_por_defecto(){
        if(this.caja!=null && this.caja.hasOwnProperty('activarClientePorDefecto') && this.caja.activarClientePorDefecto==true && this.clienteFactura == null){
          if(this.caja.clientePorDefecto!=null && this.caja.clientePorDefecto.hasOwnProperty('codigo')){
             var CLIENTE_SELECT = JSON.parse(JSON.stringify(this.caja.clientePorDefecto))
              CLIENTE_SELECT.codnom = `${CLIENTE_SELECT.codigo} - ${CLIENTE_SELECT.nombre.trim()}`
              this.clienteFactura=JSON.parse(JSON.stringify(CLIENTE_SELECT))
          }
        }
    } ,
    

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e)
        this.aalert.right = true
        this.aalert.top = false
        this.aalert.timeout = 3000
        this.limpiarPuntoVentaCompleto()
        this.NewCrearProducto()
        this.NewclienteSeleccionado()
        this.newnewAceptarDevolucion()
        this.newnewValecaja()
        this.NewHistorialClientRecIng()
      }
      if (l == "bien2") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e)
        this.aalert.right = true
        this.aalert.top = false
        this.aalert.timeout = 3000
        this.ejecucion = true
        this.ejecucionValecaja=true
        this.loading(false)

      }
      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e)
        this.aalert.right = false
        this.aalert.top = true
        this.aalert.timeout = 120000
        this.ejecucion = true
        this.ejecucionValecaja=true
        this.loading(false)
      }

      if (l == "warning") {
        (this.aalert.estado = true),
          (this.aalert.color = "warning"),
          (this.aalert.nombre = e)
        this.aalert.right = false
        this.aalert.top = true
        this.aalert.timeout = 8000
        this.ejecucion = true
        this.ejecucionValecaja=true
        this.loading(false)
      }


    },


    RedireccionFocus(e) {
      var _this = this
      setTimeout(function() {
        _this.$refs[e].focus()
      }, 300)
    },

    loading(e) {
      EventBus.$emit("loading", e)
    },
    loaderTablaCargar() {
      this.loaderTabla = true
      var _this = this
      setTimeout(function() {
        _this.loaderTabla = false
      }, 900)
    },

    getImgUrl() {
      var images = require("@/assets/img/Nofoto.png")
      return images
    },
    // Redondear el número a 2 decimales.
    RedondeoBasico,
    // RedondeoBasico(x) {
    //   return Math.round((x + Number.EPSILON) * 100) / 100;
    // },
    // Redondear el valor de x al número de lugares decimales especificado por n.
    RedondeoValor,
    // RedondeoValor(x) {
    //   var n = JSON.parse(JSON.stringify(this.CantRedondeo));
    //   return parseFloat(Math.round(x * Math.pow(10, n)) / Math.pow(10, n));
    // },
    // Tomando un valor y dividiéndolo por una tasa.
    currencyFormatter2(value) {

      /* return (
        "" +
        //parseFloat(this.RedondeoValor(value / this.TasaMoneda)).toLocaleString("en",{ minimumFractionDigits: this.CantRedondeo })
      );*/
      var cantidadDecimales =this.$store.getters.GetConfiguracionGeneral.configPv.cantidadDecimales
      var cantDec =  cantidadDecimales!=null && cantidadDecimales>0?cantidadDecimales:2
      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURA = (this.Monedafactura != null ? this.Monedafactura.tasa : MONEDA.tasa)
      var CANTREDONDEO = (MONEDAFACTURA != MONEDA.tasa ? 4 : cantDec)
      //var CANTREDONDEO = (MONEDAFACTURA != MONEDA.tasa ? 4 : 2)

      return (
        "" +
        parseFloat(this.RedondeoValorCantRed(value / this.TasaMoneda, CANTREDONDEO)).toLocaleString("en", { minimumFractionDigits: CANTREDONDEO })
      )


    },

    currencyFormatter2MonedaInf(value, moneda) {

      /* return (
 "" +
 //parseFloat(this.RedondeoValor(value / this.TasaMoneda)).toLocaleString("en",{ minimumFractionDigits: this.CantRedondeo })
);*/

      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURA = (moneda != null ? moneda.tasa : MONEDA.tasa)
      var CANTREDONDEO = (MONEDAFACTURA != MONEDA.tasa ? 4 : 2)

      return (
        "" +
        parseFloat(this.RedondeoValorCantRed(value / this.TasaMoneda, CANTREDONDEO)).toLocaleString("en", { minimumFractionDigits: CANTREDONDEO })
      )


    },

    currencyFormatter2TasaInf(value, tasaSelec) {
      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      var MONEDAFACTURA = (tasaSelec != null ? tasaSelec : MONEDA.tasa)
      var CANTREDONDEO = (MONEDAFACTURA != MONEDA.tasa ? 4 : 2)

      return (
        "" +
        parseFloat(this.RedondeoValorCantRed(value / this.TasaMoneda, CANTREDONDEO)).toLocaleString("en", { minimumFractionDigits: CANTREDONDEO })
      )


    },

    verInfo(e) {
      console.log("verinf-->", e)

    },



    newDtosPagareFactura() {
      this.DatosPagareFactura = null
    },

    DataRetornfacturaPagare(e) {
      this.DatosPagareFactura = JSON.parse(JSON.stringify(e))
      this.Facturasventa.efectivo = JSON.parse(JSON.stringify(e.contrato.inicio))
      this.Facturasventa.cxc = JSON.parse(JSON.stringify(e.contrato.Capitalpagar))
      var _this = this
      setTimeout(function() {
        _this.calcularDevuelta()
        _this.dialogPagare = false
      }, 300)
    },


blurCantidadRecetada(items,disable){

  if(disable==true){

        this.funcionValidaPermisoPv("AccModificarRecProdControlado")
        this.objTempRecPro = JSON.parse(JSON.stringify(items))
      //   if (this.EjecutarPermisoPv == false) {
      //     return
      // }
        
      // var _this = this
      //   setTimeout(function() {
      //     _this.objTempRecPro = JSON.parse(JSON.stringify(items))
      //     //_this.EjecutarPermisoPv = false
      //   }, 999)
        
      //this.dialogRecProCantidadControlada=true
  }
  
},


saveCantidadRecetada () {
this.RecetaProdControlado.detalleList[this.objTempRecPro.indx].cantidadDespachada=this.objTempRecPro.cantidadDespachada
this.RecetaProdControlado.detalleList[this.objTempRecPro.indx].cantidadRecetada=this.objTempRecPro.cantidadRecetada
this.RecetaProdControlado.detalleList[this.objTempRecPro.indx].fechaModificacion=this.fechaNueva().trim().substr(0, 10) + "T04:00"
this.RecetaProdControlado.detalleList[this.objTempRecPro.indx].usuarioModificacion=JSON.parse(sessionStorage.getItem("usuarioAutorizacion"))
this.dialogRecProCantidadControlada=false



var _this = this
        setTimeout(function() {
          _this.objTempRecPro=null
        }, 500)

      },

    // Convertir una fecha del formato aaaa-mm-dd a dd-mm-aaaa.
    FormatoFecha(params0) {
      var params = null
      if (params0 == null) {
        params = this.fechaNueva()
      } else {
        params = new Date(params0).toISOString().substr(0, 10)
      }
      if (params != null) {
        if (params.length > 0) {
          return (
            params.substring(8, 10) +
            "-" +
            params.substring(5, 7) +
            "-" +
            params.substring(0, 4)
          )
        }
      }
    },

  },
  computed: {
    GetEjecucion() {
        if(this.caja!=null && this.caja.hasOwnProperty('activarClientePorDefecto') && this.caja.activarClientePorDefecto==true){
          this.getCajaCliente_por_defecto()
        }

      if(this.terminal!=null && this.terminal.impresoras.length==0){
       // var obj={codigo: 4,nombre: "Microsoft Print to PDF"}
        this.terminal.impresoras.push({codigo: 4,nombre: "Microsoft Print to PDF"})
      }
      if (this.clienteFactura == null) {
        this.newnewCoberturaSeguro()
        this.cancelarFacturaDomicilio()
      }
      if (this.CambioDivisa.operacion) {
        this.tituloCompra = "Cantidad a vender"
      } else {
        this.tituloCompra = "Cantidad a Comprar"
      }

      //-------Modale reimprecion--------

      if(this.BtnReimprecionvalue!=null){
        this.ReimpresionBusqueda.opcion=0
      }

      if (this.BtnReimprecionvalue == 0) {
        this.LabelReimprecion = "SELECCIONAR UN TIPO DE IMPRESIÓN"
      }

      if (this.BtnReimprecionvalue == 1) {
        this.LabelReimprecion = "REIMPRIMIR RECIBO"
      }
      if (this.BtnReimprecionvalue == 2) {
        this.LabelReimprecion = "REIMPRIMIR OTROS INGRESOS"
      }
      if (this.BtnReimprecionvalue == 3) {
        this.LabelReimprecion = "REIMPRIMIR FACTURA"
      }
      if (this.BtnReimprecionvalue == 4) {
        this.LabelReimprecion = "REIMPRIMIR DEVOLUCIÓN"
      }
      if (this.BtnReimprecionvalue == 5) {
        this.LabelReimprecion = "REIMPRIMIR VALE DE CAJA"
      }
      if (this.BtnReimprecionvalue == 6) {
        this.LabelReimprecion = "REIMPRIMIR COTIZACIÓN"
      }
      if (this.BtnReimprecionvalue == 7) {
        this.LabelReimprecion = "REIMPRIMIR CONDUCE"
      }

      if (this.searchProducto == null || this.searchProducto != null && this.searchProducto.length == 0) {
        this.ProdCompOrSelecProd = true
      } else {
        this.ProdCompOrSelecProd = false
      }
      this.windowSizeCaja = JSON.parse(JSON.stringify(this.windowSize))
      this.windowSizeCaja.height = this.windowSizeCaja.height - 273
      if (this.windowSize.width >= 382 && this.windowSize.width <= 606) {
        this.windowSizeCaja.height = this.windowSizeCaja.height - 70
      }

      // this.windowSizeCaja.height= this.windowSizeCaja.height-315
      // if(this.windowSize.width<957){this.windowSizeCaja.height= this.windowSize.height-338}
      // if(this.windowSize.width<605){this.windowSizeCaja.height= this.windowSize.height-415}
      // if(this.windowSize.width<425){this.windowSizeCaja.height= this.windowSize.height-440}
      // if(this.windowSize.width<375){this.windowSizeCaja.height= this.windowSize.height-370}

      if (this.OtrosIngreso.tipoRecibo == null) {
        this.OtrosIngreso.tipoRecibo = this.RtipoOtroIngreso[0]
      }


    },
  },
}
</script>

<style lang="scss">

.pmargin1 {
  margin-bottom: 3px;
}


@media screen and (min-width: 1058px) {
  #bottomteclado {
    min-width: 160px;
  }
}

@media screen and (max-width: 1058px) {
  #bottomteclado {
    min-width: 100px;
  }
}

@media screen and (max-width: 910px) {
  #miniTotal {
    font-size: 28px;
  }
}

@media screen and (max-width: 805px) {
  #miniTotal {
    font-size: 23px;
  }
}

@media screen and (max-width: 680px) {
  #miniTotal {
    font-size: 20px;
  }
}

@media screen and (min-width: 360px) and (max-width: 600px) {
  #miniTotal {
    font-size: 35px;
  }
}

@media screen and (max-width: 360px) {
  #miniTotal {
    font-size: 20px;
  }
}
</style>


